const oneearth = [
  {
    name: 'OneEarth',
    _id: 'OneEarth',
    children: [
      {
        name: 'Afrotropics',
        children: [
          {
            _id: '7c987658-8990-42a9-bd27-f98d5289ccd2',
            name: 'Southern Afrotropics',
            children: [
              {
                name: 'Southwest African Coastal Drylands (AT10)',
                children: [],
                _id: 'cacbadd2-04a8-425d-a35c-127dcb7859a2',
                value: 1000,
                parentId: '7c987658-8990-42a9-bd27-f98d5289ccd2',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f1d49057-7cdf-455e-af05-a0bba123ad5b/98 Kaokoveld Desert African bush elephant Joachim Huber.jpg',
                    _id: 'f1d49057-7cdf-455e-af05-a0bba123ad5b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9ccd394f-eb45-447d-8577-4b63bbb8ca2b/102 Namaqualand-Richtersveld steppe - Winfried Bruenken.jpg',
                    _id: '9ccd394f-eb45-447d-8577-4b63bbb8ca2b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/00fd563f-a713-419c-98cc-892fe1902f20/103 Namib Desert - Gregroire Dubois.jpg',
                    _id: '00fd563f-a713-419c-98cc-892fe1902f20'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/08efc5ec-4139-42a3-b7c5-9a9d10f01b3a/104 Namibian savanna woodlands - Uwe G\u00fcnther 1.jpg',
                    _id: '08efc5ec-4139-42a3-b7c5-9a9d10f01b3a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1ba94501-347a-48d3-ad21-2f1ee8934409/98 Kaokoveld Desert Courtesy of Alchemist-hp.jpg',
                    _id: '1ba94501-347a-48d3-ad21-2f1ee8934409'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/52f1db67-4b97-4a99-8db5-912fe07db1c0/Bioregion-map-AT10.jpg',
                content:
                  '<p>The Southwest African bioregion, located in the Afrotropical realm, runs the length of Namibia\u2019s Atlantic Coast through the southern half of Angola. It is an extremely arid region consisting of sandy coastal deserts, steppe, and dry savanna woodlands with four ecoregions altogether\u2014Kaokoveld Desert (98), Namaqualand-Richtersveld Steppe (102), Namib Desert (103), Namibian Savanna Woodlands (104)\u2014totaling approximately 27 million hectares of land area. The bioregion is well known for the sand seas with vast dunes up to 300 meters in height, and the foggy Skeleton Coast, which provides a vital source of moisture to sustain life in the harsh conditions of the desert. A number of unusual plant and animal species are found here, including the succulent quiver tree.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/52f1db67-4b97-4a99-8db5-912fe07db1c0/Bioregion-map-AT10.jpg"/><figcaption><span class="caption"><p>The Southwest African Coastal Drylands bioregion is part of the Southern Afrotropics&nbsp;subrealm and is made up of four ecoregions: Namibian Savanna Woodlands [1], Kaokoveld Desert [2], Namib Desert [3], Namaqualand-Richtersveld Steppe [4].</p></span> </figcaption></figure>\n<p>Learn more about each of the \u200bSouthwest African Coastal Drylands ecoregions below.</p>',
                ecoregions: [
                  { _id: '4a5a252f-9f06-4280-af6e-b8ad4be377da' },
                  { title: 'Namib Desert' },
                  { regionId: '103' },
                  {
                    dek:
                      'This ecoregion extends along the coastal plain of western Namibia, from the Uniab River in the north to the town of L\u00fcderitz in the south.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/039b7b60-a30c-4b4e-9bc8-fc081467bead/103-Namib_desert_-CC-2015.JPG',
                      _id: '039b7b60-a30c-4b4e-9bc8-fc081467bead'
                    }
                  },
                  { _id: 'fab3649f-46ee-4b20-92c9-984ffa7b720e' },
                  { title: 'Namibian Savanna Woodlands' },
                  { regionId: '104' },
                  {
                    dek:
                      'This ecoregion covers the narrow escarpment inland of the Namib Desert and broadens gradually towards the south, where it comprises extensive areas of the Nama Karoo plateau south of the town of Mariental.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9c1d702d-a8ef-4dee-aff0-41ae23a811b0/104-Nambia-CC-Hansueli Krapf-2008.JPG',
                      _id: '9c1d702d-a8ef-4dee-aff0-41ae23a811b0'
                    }
                  },
                  { _id: '90e53d3d-3127-466e-9935-8348c4df4e80' },
                  { title: 'Namaqualand-Richtersveld Steppe ' },
                  { regionId: '102' },
                  {
                    dek:
                      'This ecoregion extends down the western coast of Namibia from the town of L\u00fcderitz and into South Africa. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9ccd394f-eb45-447d-8577-4b63bbb8ca2b/102 Namaqualand-Richtersveld steppe - Winfried Bruenken.jpg',
                      _id: '9ccd394f-eb45-447d-8577-4b63bbb8ca2b'
                    }
                  },
                  { _id: '6e113404-fe82-4ce4-9258-c9f63257513f' },
                  { title: 'Kaokoveld Desert' },
                  { regionId: '98' },
                  {
                    dek:
                      'This ecoregion stretches along the west coast of southern Africa from the Uniab and Koigab Rivers in Namibia northwards into the Mo\u00e7\u00e2medes Desert of southern Angola.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2fede043-72c8-4bc5-8dc9-66d8818886a2/98 Kaokoveld desert - Hans Stieglitz.jpg',
                      _id: '2fede043-72c8-4bc5-8dc9-66d8818886a2'
                    }
                  }
                ],
                stats: [
                  { number: '26,930', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '71%', item: 'Protection Target' },
                  { number: '9', item: 'Protection Level' }
                ]
              },
              {
                name: 'Greater Karoo & Kalahari Drylands (AT9)',
                children: [],
                _id: '5689b4d8-47b8-479c-9e77-7cb7c859a9b0',
                value: 1000,
                parentId: '7c987658-8990-42a9-bd27-f98d5289ccd2',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3bdbb6e5-8bb2-477a-a8b0-2ceb32215499/47 Kalahari Acacia woodland - Harald S\u00fcpfle.JPG',
                    _id: '3bdbb6e5-8bb2-477a-a8b0-2ceb32215499'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5ce589f6-04ac-49b8-8a5f-52ea46669acd/97 Kalahari xeric savanna - Pieter Zeeman.jpg',
                    _id: '5ce589f6-04ac-49b8-8a5f-52ea46669acd'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/24a6ffcf-bafa-482a-9f72-3cfd80ee5f66/101 Nama Karoo shrublands - Tjeerd Wiersma.jpg',
                    _id: '24a6ffcf-bafa-482a-9f72-3cfd80ee5f66'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/96040bb2-fa21-44de-bdda-0d0af3d96042/Bioregion%20map-AT9.jpg',
                content:
                  '<p>The Greater Karoo &amp; Kalahari bioregion, located in the Afrotropical realm, encompasses the large expanse of dry savannas and woodlands between the Highveld in South Africa and the coastal deserts of Namibia. It contains four ecoregions \u2013 Kalahari Acacia Woodlands [1], Kalahari Xeric Savanna [2], Gariep Karoo [3], Nama Karoo Shrublands [4] \u2013 totaling approximately 121 million hectares of land area. Despite its dry climate, the bioregion is home to an extraordinary range of mammals including meerkat, the brown hyena, bat-eared and cape foxes, and all three of Africa\u2019s big cats \u2013 cheetah, leopard and the famous black-maned Kalahari lions.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/96040bb2-fa21-44de-bdda-0d0af3d96042/Bioregion%20map-AT9.jpg"/><figcaption><span class="caption"><p>The Greater Karoo &amp; Kalahari Drylands bioregion is part of the Southern Afrotropics&nbsp;subrealm and is made up of four ecoregions: Kalahari Acacia Woodlands [1], Kalahari Xeric Savanna [2], Gariep Karoo [3], Nama Karoo Shrublands [4].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace\u200b</strong></a> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bGreater Karoo &amp; Kalahari Drylands ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: '4c23e836-31f4-4761-a386-c1917eae8dc2' },
                  { title: 'Nama Karoo Shrublands' },
                  { regionId: '101' },
                  {
                    dek:
                      'This ecoregion is a vast, open, arid region dominated by low-shrub vegetation, punctuated by rugged relief.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/94fed150-fec8-46e6-9d4f-c1db6e74dcd2/101-Nama Karoo shrublands-CC-2015.jpg',
                      _id: '94fed150-fec8-46e6-9d4f-c1db6e74dcd2'
                    }
                  },
                  { _id: '09ace290-309c-40cc-8615-6435764b05e4' },
                  { title: 'Gariep Karoo' },
                  { regionId: '94' },
                  {
                    dek:
                      'This ecoregion is an extensive, open, arid region dominated by low-shrub vegetation, punctuated by rugged relief.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4d3cbbf9-e9a6-4adc-b1c3-42b82079abf2/94 Gariep Karoo - Pieter Zeeman.jpg',
                      _id: '4d3cbbf9-e9a6-4adc-b1c3-42b82079abf2'
                    }
                  },
                  { _id: '540098c0-ba64-4c9a-aa50-87a9d816e88a' },
                  { title: 'Kalahari Xeric Savanna' },
                  { regionId: '97' },
                  {
                    dek:
                      'This ecoregion stretches across northwestern South Africa, southern Botswana and central-southeastern Namibia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5ce589f6-04ac-49b8-8a5f-52ea46669acd/97 Kalahari xeric savanna - Pieter Zeeman.jpg',
                      _id: '5ce589f6-04ac-49b8-8a5f-52ea46669acd'
                    }
                  },
                  { _id: '0226879d-5025-4407-9cae-c977f52f05f5' },
                  { title: 'Kalahari Acacia Woodlands' },
                  { regionId: '47' },
                  {
                    dek:
                      'This ecoregion occupies a broad band of land that runs from northern Namibia and extends across to Botswana, just east of the Okavango Delta.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3bdbb6e5-8bb2-477a-a8b0-2ceb32215499/47 Kalahari Acacia woodland - Harald S\u00fcpfle.JPG',
                      _id: '3bdbb6e5-8bb2-477a-a8b0-2ceb32215499'
                    }
                  }
                ],
                stats: [
                  { number: '121,046', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '47%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Southeast African Subtropical Grasslands (AT8)',
                children: [],
                _id: '8249ec5c-e0c1-4271-97bb-55279d6c94c0',
                value: 1000,
                parentId: '7c987658-8990-42a9-bd27-f98d5289ccd2',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/78c3eec0-10f6-4303-bcf9-83a4bff8e349/Bushveld-CC-Anton Raath-2007.jpg',
                    _id: '78c3eec0-10f6-4303-bcf9-83a4bff8e349'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2c918434-7875-4638-9329-42e70aefb2e4/40-Tugela Falls-Drakensberg-CC-2012.jpg',
                    _id: '2c918434-7875-4638-9329-42e70aefb2e4'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f03cfc48-228f-4930-a7b8-455900219ec6/81 Highveld grassland - Steve Buissinne.jpg',
                    _id: 'f03cfc48-228f-4930-a7b8-455900219ec6'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/be141754-bada-4114-8ff8-81ff8869b8d8/Bioregion%20map-AT8.jpg',
                content:
                  '<p>The Southeast African bioregion, located in the Afrotropical realm, is centered around the inland Highveld, a plateau formed by the Great Escarpment ridge in South Africa dominated by mountain grasslands, which transition to subtropical grasslands in the east and mid-altitude bushlands in the north. The bioregion contains five ecoregions \u2013 Central Bushveld [1], Limpopo Lowveld [2], Highveld Grasslands [3], Drakensberg Grasslands [4], Drakensberg Escarpment Savanna and Thicket [5] \u2013 with a total area of more than 63 million hectares. Although fragmented, it contains the greatest expanse of remaining grassland in southern Africa and provides habitat for numerous birds and mammal species, including pangolins, honey badgers, and mountain zebras.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/be141754-bada-4114-8ff8-81ff8869b8d8/Bioregion%20map-AT8.jpg"/><figcaption><span class="caption"><p>The Southeast African Subtropical Grasslands bioregion is part of the Southern Afrotropics&nbsp;subrealm and is made up of five ecoregions: Central Bushveld [1], Limpopo Lowveld [2], Highveld Grasslands [3], Drakensberg Grasslands [4], Drakensberg Escarpment Savanna and Thicket [5].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bSoutheast African Subtropical Grasslands ecoregions below.</p>',
                ecoregions: [
                  { _id: '1be0f488-11c2-4167-ad62-9dc9e5ae6247' },
                  { title: 'Highveld Grasslands' },
                  { regionId: '81' },
                  {
                    dek:
                      'The Highland grasslands draw their name from the high interior plateau of South Africa, known as the Highveld.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f03cfc48-228f-4930-a7b8-455900219ec6/81 Highveld grassland - Steve Buissinne.jpg',
                      _id: 'f03cfc48-228f-4930-a7b8-455900219ec6'
                    }
                  },
                  { _id: 'a7bb2bf0-6c68-483f-874c-aabd46d9a472' },
                  { title: 'Limpopo Lowveld' },
                  { regionId: '48' },
                  {
                    dek:
                      'This ecoregion is one of the world\u2019s key strongholds for southern white and south-central black rhinos.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/50b4589d-6079-4c95-ac22-8311734ae294/48 Limpopo lowveld - hbieser.jpg',
                      _id: '50b4589d-6079-4c95-ac22-8311734ae294'
                    }
                  },
                  { _id: 'f700171d-6a7f-469e-bddd-3ae19e4a0552' },
                  { title: 'Drakensberg Grasslands' },
                  { regionId: '41' },
                  {
                    dek:
                      'This ecoregion is found in southeastern South Africa, primarily within the Kwazulu-Natal province. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c9042bfa-baf6-462e-92dc-e7518226ad85/41 Drakensberg grasslands - GeoffS 1_resized.jpg',
                      _id: 'c9042bfa-baf6-462e-92dc-e7518226ad85'
                    }
                  },
                  { _id: 'b34960bf-a20e-4680-9127-2ba9ab55174e' },
                  { title: 'Drakensberg Escarpment Savanna and Thicket' },
                  { regionId: '40' },
                  {
                    dek:
                      'This ecoregion is found alongside the numerous rivers of the Eastern Cape and KwaZulu-Natal Provinces of South Africa.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2c918434-7875-4638-9329-42e70aefb2e4/40-Tugela Falls-Drakensberg-CC-2012.jpg',
                      _id: '2c918434-7875-4638-9329-42e70aefb2e4'
                    }
                  },
                  { _id: '45d7f910-c816-4365-812c-6c1792608514' },
                  { title: 'Central Bushveld' },
                  { regionId: '38' },
                  {
                    dek:
                      'This ecoregion covers the southeast corner of Botswana and northern South Africa. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/78c3eec0-10f6-4303-bcf9-83a4bff8e349/Bushveld-CC-Anton Raath-2007.jpg',
                      _id: '78c3eec0-10f6-4303-bcf9-83a4bff8e349'
                    }
                  }
                ],
                stats: [
                  { number: '63,156', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '15%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'South African Cape Shrublands & Mountain Forests (AT2)',
                children: [],
                _id: '5a0cd87a-b9a9-4223-84ac-61c0896f92f2',
                value: 1000,
                parentId: '7c987658-8990-42a9-bd27-f98d5289ccd2',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/acb7c1ee-970e-4ce6-99ce-f209416a4ae8/15 Knysna-Amatole montane forests - Paul Venter.jpg',
                    _id: 'acb7c1ee-970e-4ce6-99ce-f209416a4ae8'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/163777bf-c875-4db9-ba99-a42567c7a426/89 Fynbos shrubland - Gregoire Dubois.jpg',
                    _id: '163777bf-c875-4db9-ba99-a42567c7a426'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c4fb3149-0b2a-4f15-a9d1-4bebb7b7504a/110 Succulent Karoo xeric shrublands - Winfried Bruenken.JPG',
                    _id: 'c4fb3149-0b2a-4f15-a9d1-4bebb7b7504a'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4a098d3c-f112-4f48-ba90-66e10c041e51/Bioregion-map-AT2.jpg',
                content:
                  '<p>The South African Cape is the only Mediterranean bioregion in the Afrotropical realm. It is confined to the small southern coastline of the continent and incorporates the succulent Karoo ecoregion, which is tightly interlinked with the dominant shrublands. The bioregion contains five ecoregions \u2013 Renosterveld Shrubland [1], Fynbos Shrubland [2], Succulent Karoo Xeric Shrublands [3], Knysna-Amatole Montane Forests [4], Albany Thickets [5] \u2013 and adjacent marine areas. It is an area of extraordinarily high plant diversity and endemism that includes the Cape Floristic Region, one of only 7 floral kingdoms in the world, with over 9000 plant species, two-thirds of which are endemic. The total land area of this bioregion is nearly 18 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4a098d3c-f112-4f48-ba90-66e10c041e51/Bioregion-map-AT2.jpg"/><figcaption><span class="caption"><p>The South African Cape Shrublands &amp; Mountain Forests bioregion is part of the Southern Afrotropics&nbsp;subrealm and is made up of five ecoregions: Renosterveld Shrubland [1], Fynbos Shrubland [2], Succulent Karoo Xeric Shrublands [3], Knysna-Amatole Montane Forests [4], Albany Thickets [5].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><ins><strong>Project Marketplace</strong></ins></a> to explore projects in this realm that need your support. Learn more about each of the Central South African Cape Shrublands &amp; Mountain Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '39fe8b88-84fd-4149-a1b1-eac5ede7b929' },
                  { title: 'Succulent Karoo Xeric Shrublands' },
                  { regionId: '110' },
                  {
                    dek:
                      'The ecoregion comprises the major biogeographical domain of Southern Karoo.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c4fb3149-0b2a-4f15-a9d1-4bebb7b7504a/110 Succulent Karoo xeric shrublands - Winfried Bruenken.JPG',
                      _id: 'c4fb3149-0b2a-4f15-a9d1-4bebb7b7504a'
                    }
                  },
                  { _id: 'ec00d788-1f9d-439d-97a5-aacf31578bf5' },
                  { title: 'Renosterveld Shrubland' },
                  { regionId: '90' },
                  {
                    dek:
                      'This ecoregion comprises the upland and lowland Renosterveld Shrubland portion of the world-renowned Cape Floristic Region (CFR) located in southwestern South Africa.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7bd414fc-0a68-490c-99d9-a7dee8e56aa8/Shale_Renosterveld_CC-Abu Shawka-2010.jpg',
                      _id: '7bd414fc-0a68-490c-99d9-a7dee8e56aa8'
                    }
                  },
                  { _id: 'f6278d85-3d2e-4744-b746-06dbd37461b2' },
                  { title: 'Fynbos Shrubland' },
                  { regionId: '89' },
                  {
                    dek:
                      'The Fynbos Shrubland ecoregion is located at the southwestern tip of the African continent where it forms part of the Cape Floristic Region (CFR), one of the most biologically diverse regions on earth.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/163777bf-c875-4db9-ba99-a42567c7a426/89 Fynbos shrubland - Gregoire Dubois.jpg',
                      _id: '163777bf-c875-4db9-ba99-a42567c7a426'
                    }
                  },
                  { _id: 'd4f4363c-11b3-4a59-a044-b58082881334' },
                  { title: 'Albany Thickets' },
                  { regionId: '88' },
                  {
                    dek:
                      'The Albany thicket is a dense, spiny shrubland with a canopy up to 2.5 m in height and usually abundant succulents.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/19378c74-0a99-4b10-841e-7a3353c089d4/88 Albany thickets - Ole J Brustad.jpg',
                      _id: '19378c74-0a99-4b10-841e-7a3353c089d4'
                    }
                  },
                  { _id: '4edcee12-527b-4fd1-a087-c01da56c7e88' },
                  { title: 'Knysna-Amatole Montane Forests' },
                  { regionId: '15' },
                  {
                    dek:
                      'This ecoregion is divided into two distinct portions, the Knysna forest along the coast and the Amatole forests further inland. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/042baac0-a605-4cb8-a326-10622a3ad0dc/15-Knysna_Forest-CC-2010jpg.jpg',
                      _id: '042baac0-a605-4cb8-a326-10622a3ad0dc'
                    }
                  }
                ],
                stats: [
                  { number: '17,833', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '31%', item: 'Protection Target' },
                  { number: '5', item: 'Protection Level' }
                ]
              },
              {
                name: 'Tristan Volcanic Islands (AT1)',
                children: [],
                _id: '3e35b0da-fd3c-43ee-959a-5b89274e405e',
                value: 1000,
                parentId: '7c987658-8990-42a9-bd27-f98d5289ccd2',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b6dfb849-b7de-4eed-920b-cac900969699/TristanDaCunhaGoughIslands ShrubandGrasslands-WikiCommons_resized.jpg',
                    _id: 'b6dfb849-b7de-4eed-920b-cac900969699'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6ef192ca-a8a2-4fd2-a912-50e1bc9a09c8/Bioregion-map-AT1.jpg',
                content:
                  '<p>The Tristan Volcanic Islands bioregion, located on the western edge of the Afrotropical realm, is a remote group of small islands in the far south of the Atlantic Ocean. The islands contain predominantly temperate grasslands with one single ecoregion \u2013 Tristan Da Cunha-Gough Islands Shrub and Grasslands [1] \u2013 but it has numerous endemic plant species including the tree fern. Whales and dolphins are often sighted in the waters surrounding the islands, and the area is of particular important for bird species. Total land area of the island is approximately 17,000 hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6ef192ca-a8a2-4fd2-a912-50e1bc9a09c8/Bioregion-map-AT1.jpg"/><figcaption><span class="caption"><p>The Tristan Volcanic Islands bioregion is part of the Southern Afrotropics&nbsp;subrealm and is made up of one ecoregion: Tristan Da Cunha-Gough Islands Shrub and Grasslands [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><ins><strong>Project Marketplace</strong></ins></a> to explore projects in this realm that need your support. Learn more about the Central Tristan Volcanic Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: 'f1952c4e-d6eb-499e-b429-f57b06d5e42a' },
                  { title: 'Tristan Da Cunha-Gough Islands Shrub and Grasslands' },
                  { regionId: '68' },
                  {
                    dek:
                      'The Tristan da Cunha Island Group is an archipelago of five volcanic islands resting on the east slope of the mid-Atlantic ridge, midway between Africa and South America. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b6dfb849-b7de-4eed-920b-cac900969699/TristanDaCunhaGoughIslands ShrubandGrasslands-WikiCommons_resized.jpg',
                      _id: 'b6dfb849-b7de-4eed-920b-cac900969699'
                    }
                  }
                ],
                stats: [
                  { number: '17', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '48%', item: 'Protection Target' },
                  { number: '10', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Afrotropics',
            value: 714
          },
          {
            _id: '8e74ab84-0832-4a13-b15b-1898e7bb4911',
            name: 'Equatorial Afrotropics',
            children: [
              {
                name: 'West African Coastal Forests & Savanna (AT19)',
                children: [],
                _id: '604466ba-a207-455c-b8bb-6ce793fc7154',
                value: 1000,
                parentId: '8e74ab84-0832-4a13-b15b-1898e7bb4911',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fef73b53-a438-491c-ba36-ae8f1056558f/14 Guinean montane forests - Yakoo1986.jpg',
                    _id: 'fef73b53-a438-491c-ba36-ae8f1056558f'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/db064ec3-0f8a-40d2-9ade-aa9514a28fae/30-Western_Guinean_lowland_forests-yakovlev alexey-cc.jpg',
                    _id: 'db064ec3-0f8a-40d2-9ade-aa9514a28fae'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3d94a133-2bfa-4204-b927-96b48c7c1dd5/11-EasternGuineanForests-WikiCommons5.jpg',
                    _id: '3d94a133-2bfa-4204-b927-96b48c7c1dd5'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ae63eb1e-0b83-406e-a160-badc9935dde2/11-EasternGuineanForests-WikiCommons4.jpg',
                    _id: 'ae63eb1e-0b83-406e-a160-badc9935dde2'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/89e1faf2-1e7c-4c8d-83ec-0b825fbba1a6/Bioregion%20map-AT19-rev.jpg',
                content:
                  '<p>The West African Coastal Forests &amp; Savanna bioregion, located in the Equatorial Afrotropics, consists of tropical coastal forests and mangroves as well as Guinean mountain forests and forest-savanna. With seven ecoregions -- Guinean Forest-Savanna [1], Guinean Montane Forests [2], Western Guinean Lowland Forests [3], Eastern Guinean Forests [4], Jos Plateau Forest-Grassland [5], Guinean Mangroves [6], Central African Mangrove [7], it has a land area more than 113 million hectares, not including mangroves or adjacent marine areas. The Guinean forests are considered to be a biodiversity hotspot with over 9,000 species, 20% of which are endemic to the region.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/89e1faf2-1e7c-4c8d-83ec-0b825fbba1a6/Bioregion%20map-AT19-rev.jpg"/><figcaption><span class="caption"><p>The West African Coastal Forests &amp; Savanna bioregion is part of the Equatorial Afrotropics&nbsp;subrealm and is made up of seven ecoregions: Guinean Forest-Savanna [1], Guinean Montane Forests [2], Western Guinean Lowland Forests [3], Eastern Guinean Forests [4], Jos Plateau Forest-Grassland [5], Guinean Mangroves [6], Central African Mangrove [7].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace\u200b</strong></a> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bWest African Coastal Forests &amp; Savanna ecoregions below.</p>',
                ecoregions: [
                  { _id: '208b6c98-f8d6-41b7-9371-238ef9a9f6c1' },
                  { title: 'Western Guinean Lowland Forests' },
                  { regionId: '30' },
                  {
                    dek:
                      'This ecoregion stretches from eastern Guinea, across Sierra Leone and Liberia, to the Sassandra River in south western C\u00f4te d\u2019Ivoire.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/db064ec3-0f8a-40d2-9ade-aa9514a28fae/30-Western_Guinean_lowland_forests-yakovlev alexey-cc.jpg',
                      _id: 'db064ec3-0f8a-40d2-9ade-aa9514a28fae'
                    }
                  },
                  { _id: '487bab44-2204-4457-a69f-b1dc415a089d' },
                  { title: 'Guinean Montane Forests' },
                  { regionId: '14' },
                  {
                    dek:
                      'This ecoregion consists of an array of peaks and plateaus at high elevations that are distinguishable against a backdrop of surrounding lowland forests and savannas.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fef73b53-a438-491c-ba36-ae8f1056558f/14 Guinean montane forests - Yakoo1986.jpg',
                      _id: 'fef73b53-a438-491c-ba36-ae8f1056558f'
                    }
                  },
                  { _id: 'afeda1a4-f7fc-4ae9-ba3b-ef1c0ac168d6' },
                  { title: 'Eastern Guinean Forests' },
                  { regionId: '11' },
                  {
                    dek:
                      'This ecoregion extends from the east banks of the Sassandra River in western C\u00f4te d\u2019Ivoire to the edge of Lake Volta in Ghana.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4d83f257-92a3-4be9-b512-604efe19f813/11-EasternGuineanForests-WikiCommons2.jpg',
                      _id: '4d83f257-92a3-4be9-b512-604efe19f813'
                    }
                  },
                  { _id: '9430c1f8-d80b-4b79-a0e1-933d60c3f8e1' },
                  { title: 'Guinean Mangroves' },
                  { regionId: '113' },
                  {
                    dek:
                      'The Guinean Mangroves are located in western Africa, and encompass mangrove stands along the coastlines of Senegal, Gambia, Guinea-Bissau, Guinea, Sierra Leone, Liberia, and C\u00f4te d\u2019Ivoire. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/63e4255d-28e6-499f-b5e9-f02f8688f6f2/Gambia Mangroves. Aerial view of mangrove forest in Gambia. Photo made by drone from above. iStock.jpeg',
                      _id: '63e4255d-28e6-499f-b5e9-f02f8688f6f2'
                    }
                  },
                  { _id: '3a23d277-8afa-44df-9cb0-45f9adfda9f5' },
                  { title: 'Jos Plateau Forest-Grassland' },
                  { regionId: '82' },
                  {
                    dek:
                      'This ecoregion rises above the surrounding forest-grassland and savanna ecoregions of northern Nigeria. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/497f5f58-4078-43b2-ac1e-80cb2e6bdaee/82 Jos Plateau forest-grassland - TripAdvisor Chief Thomas.jpg',
                      _id: '497f5f58-4078-43b2-ac1e-80cb2e6bdaee'
                    }
                  },
                  { _id: 'ddfb44a8-18d7-47a4-ad43-b3ac016be47b' },
                  { title: 'Guinean Forest-Savanna' },
                  { regionId: '44' },
                  {
                    dek:
                      'This ecoregion runs east to west across West Africa, reaching the coast at the Dahomey Gap, a narrow strip of semi-arid habitats in eastern Ghana and Benin.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b5368203-f301-4020-9c4c-8eaac6b89e37/44 Leasmhar cc.jpg',
                      _id: 'b5368203-f301-4020-9c4c-8eaac6b89e37'
                    }
                  },
                  { _id: 'f9cefe2a-af9a-4088-9739-ad4dd3c1dab6' },
                  { title: 'Central African Mangroves' },
                  { regionId: '111' },
                  {
                    dek:
                      'This ecoregion is located in western Africa, and the structure of the mangrove areas varies considerably, from the lagoon systems to systems modified by complex patterns of sediment deposition. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4648d0eb-4ee8-4879-9684-8760a4f2b311/111 Central African mangroves - Santiago Oremeno Garcia ZSL.jpg',
                      _id: '4648d0eb-4ee8-4879-9684-8760a4f2b311'
                    }
                  }
                ],
                stats: [
                  { number: '115,433 ', item: 'Total Land Area (1000 ha)' },
                  { number: '7', item: 'Number of Ecoregions' },
                  { number: '22%', item: 'Protection Target' },
                  { number: '8', item: 'Protection Level' }
                ]
              },
              {
                name: 'Gulf of Guinea Coastal Forests & Mangroves (AT17)',
                children: [],
                _id: 'a11ee780-598c-4763-bb00-02a0542a3663',
                value: 1000,
                parentId: '8e74ab84-0832-4a13-b15b-1898e7bb4911',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3a9da1a7-c214-40ad-b4b8-dabe92cd8a40/6 Cross-Sanaga-Bioko Coastal Forests Ndijose cc2.jpg',
                    _id: '3a9da1a7-c214-40ad-b4b8-dabe92cd8a40'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6642d902-3042-475a-a6fe-42b4357e6ad9/27-Sao_Tome_Ponta_Figo_Hike-CC-Chuck Moravec-2014.jpg',
                    _id: '6642d902-3042-475a-a6fe-42b4357e6ad9'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4648d0eb-4ee8-4879-9684-8760a4f2b311/111 Central African mangroves - Santiago Oremeno Garcia ZSL.jpg',
                    _id: '4648d0eb-4ee8-4879-9684-8760a4f2b311'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3488a843-4caf-4a43-8547-3de572b8f781/Bioregion%20map-AT17.jpg',
                content:
                  '<p>The Gulf of Guinea bioregion<strong>, </strong>located in the Equatorial Afrotropics subrealm, consists of lush tropical forests and mangroves lining the coastline of Gabon, Equatorial Guinea, Cameroon, and Nigeria, and includes Bioko, S\u00e3o Tom\u00e9, Pr\u00edncipe, and Annob\u00f3n islands. With seven terrestrial ecoregions\u2014Nigerian Lowland Forests [1], Niger Delta Swamp Forests [2], Cross-Niger Transition Forests [3], Cross-Sanaga-Bioko Coastal Forests [4], Congolian Coastal Forests [5], Mount Cameroon and Bioko Montane Forests [6], S\u00e3o Tom\u00e9, Pr\u00edncipe, and Annob\u00f3n Forests [7]\u2014as well as the Central African Mangroves [8] and adjacent marine areas. These Coastal Forests have been an ancient cradle for Congo\u2019s globally important populations of large forest mammals, including western lowland gorilla, chimpanzee, African forest elephant, and several endemic monkey species.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3488a843-4caf-4a43-8547-3de572b8f781/Bioregion%20map-AT17.jpg"/><figcaption><span class="caption"><p>The Gulf of Guinea Coastal Forests &amp; Mangroves bioregion is part of the Equatorial Afrotropics&nbsp;subrealm and is made up of eight ecoregions: Nigerian Lowland Forests [1], Niger Delta Swamp Forests [2], Cross-Niger Transition Forests [3], Cross-Sanaga-Bioko Coastal Forests [4], Congolian Coastal Forests [5], Mount Cameroon and Bioko Montane Forests [6], S\u00e3o Tom\u00e9, Pr\u00edncipe, and Annob\u00f3n Forests [7], Central African Mangroves [8].</p></span> </figcaption></figure>\n<p>Learn more about each of the eight ecoregions located in the \u200bGulf of Guinea Coastal Forests &amp; Mangroves Bioregion below.</p>',
                ecoregions: [
                  { _id: '7eccb414-4511-4806-a2b0-7bfe506747ec' },
                  { title: 'Mount Cameroon and Bioko Montane Forests' },
                  { regionId: '21' },
                  {
                    dek:
                      'This ecoregion occupies the higher elevations of Mount Cameroon on the African mainland and Bioko Island just offshore.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ce635038-ea48-4ca0-9e3c-874514320415/MountCameroon ndBiokoMontaneForests-Credit-John and Melanie (Illingworth) Kotsopoulos-Flickr-2.jpg',
                      _id: 'ce635038-ea48-4ca0-9e3c-874514320415'
                    }
                  },
                  { _id: '227c8abe-6fc1-4b52-8906-50c15f45aceb' },
                  { title: 'Cross-Sanaga-Bioko Coastal Forests' },
                  { regionId: '7' },
                  {
                    dek:
                      'This ecoregion extends from the Cross River in southeastern Nigeria, follows the coast as far south as the Sanaga River in Cameroon, and extends inland up to 300 km'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/78b239b5-090f-4126-a2e2-9a1723f2a773/7 Cross-Sanaga-Bioko coastal forests - Shiraz Chakara.jpg',
                      _id: '78b239b5-090f-4126-a2e2-9a1723f2a773'
                    }
                  },
                  { _id: '4c381966-e228-40c7-9f1f-1c6327f8e413' },
                  { title: 'S\u00e3o Tom\u00e9, Pr\u00edncipe, and Annob\u00f3n Forests' },
                  { regionId: '27' },
                  {
                    dek:
                      'This ecoregion covers the three volcanic islands of Pr\u00edncipe, S\u00e3o Tom\u00e9, and Annobon in the Gulf of Guinea, off the west coast of central Africa.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6642d902-3042-475a-a6fe-42b4357e6ad9/27-Sao_Tome_Ponta_Figo_Hike-CC-Chuck Moravec-2014.jpg',
                      _id: '6642d902-3042-475a-a6fe-42b4357e6ad9'
                    }
                  },
                  { _id: '931d7b7c-4521-4df3-97a7-9b7e8b85b13c' },
                  { title: 'Nigerian Lowland Forests' },
                  { regionId: '23' },
                  {
                    dek:
                      'This ecoregion is confined to a narrow, gently undulating coastal plain of 150 m altitude, along the coast in the southwest of Nigeria.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0a6385d5-1fb6-4412-98ae-7a2e525b3c90/23 Nigerian lowland forests - bidsingraceland.com.jpg',
                      _id: '0a6385d5-1fb6-4412-98ae-7a2e525b3c90'
                    }
                  },
                  { _id: 'c13a5ac2-ac2f-4f3f-ab2d-5b932cd64ef1' },
                  { title: 'Niger Delta Swamp Forests' },
                  { regionId: '22' },
                  {
                    dek:
                      'This ecoregion forms a triangle bordered by the town of Aboh at the northernmost tip, the Benin River along the western boundary, and the Imo River along the eastern boundary.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9ba3ccbe-c23d-4617-ac81-2298c9debcdd/Flottage_du_bois_dans_le_delta_du_Niger.jpg',
                      _id: '9ba3ccbe-c23d-4617-ac81-2298c9debcdd'
                    }
                  },
                  { _id: '26976929-246a-45c3-ad2f-1f28369062a7' },
                  { title: 'Cross-Niger Transition Forests' },
                  { regionId: '6' },
                  {
                    dek:
                      'This ecoregion is found in southern Nigeria and most of its relief is low and undulating with few notable topographic features. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/35d42ab7-a359-4a44-b4bc-632292bab449/6 Cross-Niger transition forests -Ukpuru.jpg',
                      _id: '35d42ab7-a359-4a44-b4bc-632292bab449'
                    }
                  },
                  { _id: '8b89f8c9-7d1b-401c-addb-7473a2981887' },
                  { title: 'Congolian Coastal Forests' },
                  { regionId: '5' },
                  {
                    dek:
                      'This ecoregion extends from the Sanaga River in west central Cameroon, south through Equatorial Guinea into the coastal and inland areas of Gabon, the Republic of Congo, and the Cabinda Province of Angola.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/17ae897c-29d9-4440-9bcd-433522060143/Ogooue\u0301 river, Gabon. Courtesy of Gregoire Dubois.jpg',
                      _id: '17ae897c-29d9-4440-9bcd-433522060143'
                    }
                  },
                  { _id: 'f9cefe2a-af9a-4088-9739-ad4dd3c1dab6' },
                  { title: 'Central African Mangroves' },
                  { regionId: '111' },
                  {
                    dek:
                      'This ecoregion is located in western Africa, and the structure of the mangrove areas varies considerably, from the lagoon systems to systems modified by complex patterns of sediment deposition. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4648d0eb-4ee8-4879-9684-8760a4f2b311/111 Central African mangroves - Santiago Oremeno Garcia ZSL.jpg',
                      _id: '4648d0eb-4ee8-4879-9684-8760a4f2b311'
                    }
                  }
                ],
                stats: [
                  { number: '36,264 ', item: 'Total Land Area (1000 ha)' },
                  { number: '8', item: 'Number of Ecoregions' },
                  { number: '60%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'Mandara Mountain & North Congolian Forest-Savannas (AT16)',
                children: [],
                _id: '1a3d9a52-7ec1-4b00-a6e1-78816d3b66d0',
                value: 1000,
                parentId: '8e74ab84-0832-4a13-b15b-1898e7bb4911',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/14d78e88-26ff-49c3-b486-f42ba3f7870d/Flickr-33111742634_0e8425c7cc_o_resized.jpg',
                    _id: '14d78e88-26ff-49c3-b486-f42ba3f7870d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/87891b28-7cdc-4205-b0e5-7a126f8c956c/52 Northern Congolian Forest-Savanna - Nuria Ortega.jpg',
                    _id: '87891b28-7cdc-4205-b0e5-7a126f8c956c'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d1abe8e8-6725-4c7f-84bc-9f5a6314fe38/Bioregion%20map-AT16.jpg',
                content:
                  '<p>North Congolian Forest-Savannas bioregion, located in the Equatorial Afrotropics, includes the Cameroon Highlands to the west and extends above the Congolian lowland forests to the Sudd in the east. It contains two ecoregions -- Cameroon Highlands Forests [1], Northern Congolian Forest-Savanna [2] -- totaling approximately 74.5 million hectares. This region is home to both forest and savanna elephant species, hippopotamus, duiker, giraffe, lions and several endemic amphibians. The volcanic mountain forests in the Cameroon highlands are particularly rich with endemic bird species.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d1abe8e8-6725-4c7f-84bc-9f5a6314fe38/Bioregion%20map-AT16.jpg"/><figcaption><span class="caption"><p>The Mandara Mountain &amp; North Congolian Forest-Savannas bioregion is part of the Equatorial Afrotropics&nbsp;subrealm and is made up of two ecoregions: Cameroon Highlands Forests [1], Northern Congolian Forest-Savanna [2].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace\u200b</strong></a> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bMandara Mountain &amp; North Congolian Forest-Savannas ecoregions below.</p>',
                ecoregions: [
                  { _id: 'e268417c-a251-458d-9ee6-5abf28f56957' },
                  { title: 'Northern Congolian Forest-Savanna' },
                  { regionId: '52' },
                  {
                    dek:
                      'This ecoregion extends from the Cameroon Highlands east through the Central African Republic, northeastern Democratic Republic of Congo (DRC), South Sudan, and into a sliver of northwestern Uganda.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/87891b28-7cdc-4205-b0e5-7a126f8c956c/52 Northern Congolian Forest-Savanna - Nuria Ortega.jpg',
                      _id: '87891b28-7cdc-4205-b0e5-7a126f8c956c'
                    }
                  },
                  { _id: 'a2cecb3d-45a5-4955-b121-9108042ed09a' },
                  { title: 'Cameroon Highlands Forests' },
                  { regionId: '2' },
                  {
                    dek:
                      'These highland forests cover the mountains of the border region between Nigeria and Cameroon, excluding Mount Cameroon. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/866e6ab6-04b0-4d15-b1db-06e4fdca8a38/Cameroon Highlands Forests CC.jpg',
                      _id: '866e6ab6-04b0-4d15-b1db-06e4fdca8a38'
                    }
                  }
                ],
                stats: [
                  { number: '74,579', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '18%', item: 'Protection Target' },
                  { number: '8', item: 'Protection Level' }
                ]
              },
              {
                name: 'North Congolian Lowland Forests (AT15)',
                children: [],
                _id: 'f4fe2f56-4d80-4cef-ba98-f2ba5d101ae5',
                value: 1000,
                parentId: '8e74ab84-0832-4a13-b15b-1898e7bb4911',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/675ab20c-d8fd-48d2-a207-df7ae55bf02f/24 Dzanga-CC-Damiano Luchetti-1994.jpg',
                    _id: '675ab20c-d8fd-48d2-a207-df7ae55bf02f'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a0bf7c14-d9b2-4796-bc7c-bb6e08f97742/26 Northwest Congolian lowland forests - ZSL MINFOF.JPG',
                    _id: 'a0bf7c14-d9b2-4796-bc7c-bb6e08f97742'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bff68194-dbe3-4709-bdf0-bb470088078d/Bioregion%20map-AT15.jpg',
                content:
                  '<p>The North Congolian Lowland bioregion in the Equatorial Afrotropics includes the densely forested lowland areas above the Congo River, bounded to the east by the Albertine Rift. It is divided into western and eastern halves and comprises two major ecoregions -- Northwest Congolian Lowland Forests [1], and Northeast Congolian lowland forests [2] -- totaling 95 million hectares.&nbsp;</p>\n<p>The bioregion contains vast expanses of intact rainforest and forms a part of one of the world\u2019s last remaining tropical forest wildernesses, storing an estimated 22 billion tonnes of carbon. These forests are amongst the richest in Africa for primates, harboring the largest population of lowland gorillas, and possibly chimpanzees, in the world.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bff68194-dbe3-4709-bdf0-bb470088078d/Bioregion%20map-AT15.jpg"/><figcaption><span class="caption"><p>The North Congolian Lowland Forests bioregion is part of the Equatorial Afrotropics&nbsp;subrealm and is made up of two ecoregions: Northwest Congolian Lowland Forests [1], Northeast Congolian lowland forests [2].</p></span> </figcaption></figure>\n<p>Explore the ecoregions and the climate solution projects located in this bioregion below.&nbsp;</p>',
                ecoregions: [
                  { _id: '211d3685-9aff-4a17-897c-c0a08fa52e3c' },
                  { title: 'Northwest Congolian Lowland Forests' },
                  { regionId: '26' },
                  {
                    dek:
                      'This ecoregion stretches across four countries\u2014Cameroon, Gabon, Republic of Congo, and the Central African Republic (CAR).'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/67880067-0d8d-472e-822c-d4809cbd4425/Gregoire DuboisFollowing Forest of Lobe\u0301ke\u0301 National Park, Cameroon.jpg',
                      _id: '67880067-0d8d-472e-822c-d4809cbd4425'
                    }
                  },
                  { _id: '353c15e1-65d8-4142-ad00-38eed5491f7d' },
                  { title: 'Northeast Congolian Lowland Forests' },
                  { regionId: '24' },
                  {
                    dek:
                      'These lowland forests, nestled between the Albertine Rift Mountains in the east, the transitional savannah to the north, and the Congo River and its tributaries in the south and west, are teeming with life.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c3cbc53e-cf5d-4187-9493-8bd1982d7947/24 Waterfall_ivindo_gabon-CC-Jefe Le Gran-CC-2007.jpg',
                      _id: 'c3cbc53e-cf5d-4187-9493-8bd1982d7947'
                    }
                  }
                ],
                stats: [
                  { number: '95,083', item: 'Total Land Area (1000 ha) ' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '83%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Central Congolian Tropical Forests (AT14)',
                children: [],
                _id: '37e7831a-89f7-4f85-885b-68c18d55264c',
                value: 1000,
                parentId: '8e74ab84-0832-4a13-b15b-1898e7bb4911',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4c58309d-7200-44b5-a53a-4c57e784a629/WesternCongolianWwampForests .jpg',
                    _id: '4c58309d-7200-44b5-a53a-4c57e784a629'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b73db264-8f5d-4d75-9bdf-15394ae18557/Tumba Lediima Natural Reserve.png',
                    _id: 'b73db264-8f5d-4d75-9bdf-15394ae18557'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eee7386b-d434-4eba-afcc-d48c5a5b2dee/Salonga National Park South_resized.jpg',
                    _id: 'eee7386b-d434-4eba-afcc-d48c5a5b2dee'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1ed905c9-14fe-437a-b575-c1bec9899a14/bioregion-map-congo-AT14.jpg',
                content:
                  '<p>The Central Congolian Tropical Forests bioregion, located in the Equatorial Afrotropics, is in the Cuvette Centrale region of the Congo Basin, south of the Congo River. It consists of dense wet forests and swamps, storing enormous amounts of carbon and harboring diverse wildlife, including lowland gorillas and the endemic peafowl. It is made up of three ecoregions -- Western Congolian Swamp Forests [1], Eastern Congolian Swamp Forests [2], Central Congolian Lowland Forests [3] -- totaling nearly 64 million hectares. It contains the Salonga National Park, one of the largest protected areas in the world.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1ed905c9-14fe-437a-b575-c1bec9899a14/bioregion-map-congo-AT14.jpg"/><figcaption><span class="caption"><p>The Central Congolian Tropical Forests bioregion is part of the Equatorial Afrotropics&nbsp;subrealm and is made up of three ecoregions: Western Congolian Swamp Forests [1], Eastern Congolian Swamp Forests [2], Central Congolian Lowland Forests [3].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Central Congolian Tropical Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'de73f480-b197-471f-9313-382a48d752cb' },
                  { title: 'Central Congolian Lowland Forests' },
                  { regionId: '3' },
                  {
                    dek:
                      'This ecoregion lies in the central part of the Congo Basin, south of the wide arc formed by the Congo River.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eee7386b-d434-4eba-afcc-d48c5a5b2dee/Salonga National Park South_resized.jpg',
                      _id: 'eee7386b-d434-4eba-afcc-d48c5a5b2dee'
                    }
                  },
                  { _id: '7767433f-3a74-4b8c-819d-5c5e7fa39041' },
                  { title: 'Western Congolian Swamp Forests' },
                  { regionId: '29' },
                  {
                    dek:
                      'This ecoregion consists of dense swamp forests growing extensively along the meandering tributaries of the Congo River.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4c58309d-7200-44b5-a53a-4c57e784a629/WesternCongolianWwampForests .jpg',
                      _id: '4c58309d-7200-44b5-a53a-4c57e784a629'
                    }
                  },
                  { _id: '2de2daff-40d3-445e-9dab-cd8dc66704c0' },
                  { title: 'Eastern Congolian Swamp Forests' },
                  { regionId: '10' },
                  {
                    dek:
                      'This ecoregion, combined with the neighbouring Western Congolian Swamp Forests, comprises one of the largest swamp forests in the world.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b73db264-8f5d-4d75-9bdf-15394ae18557/Tumba Lediima Natural Reserve.png',
                      _id: 'b73db264-8f5d-4d75-9bdf-15394ae18557'
                    }
                  }
                ],
                stats: [
                  { number: '63,752', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '92%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'South Congolian Forest-Savannas & Coastal Scarp (AT13)',
                children: [],
                _id: '389597c4-b872-4aaa-8452-c2b5c29d31ce',
                value: 1000,
                parentId: '8e74ab84-0832-4a13-b15b-1898e7bb4911',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2fb458b4-6261-4c17-8a09-3a23d4347ca7/WesternCongoliaForestSavannah-WikiCommons.JPG',
                    _id: '2fb458b4-6261-4c17-8a09-3a23d4347ca7'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/06ead837-b2be-4253-bd6b-41d40f2995d7/SouthernCongoliaForestSavannah-2_resized.jpg',
                    _id: '06ead837-b2be-4253-bd6b-41d40f2995d7'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4d06cce4-280d-47ac-b9dc-c2436eee8d9b/Bioregion%20map-AT13.jpg',
                content:
                  '<p>The South Congolian bioregion, located in the Equatorial Afrotropics, covers the area between the northern coast of Angola and mountains in the east of DRC, running along the Albertine Rift. It consists of tropical forest-savannas and woodlands running below the Equatorial forest zone with two ecoregions -- Western Congolian Forest-Savanna [1], Southern Congolian Forest-Savanna [2] -- and adjacent marine areas. It includes the southern portion of the Congo River and many of its tributaries. The area of bioregion is more than 94 million hectares.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4d06cce4-280d-47ac-b9dc-c2436eee8d9b/Bioregion%20map-AT13.jpg"/><figcaption><span class="caption"><p>The South Congolian Forest-Savannas &amp; Coastal Scarp bioregion is part of the Equatorial Afrotropics&nbsp;subrealm and is made up of two ecoregions: Western Congolian Forest-Savanna [1], Southern Congolian Forest-Savanna [2].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bSouth Congolian Forest-Savannas &amp; Coastal Scarp ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: 'fe306a1b-630e-4a8b-83ff-1fff0786034d' },
                  { title: 'Western Congolian Forest-Savanna' },
                  { regionId: '63' },
                  {
                    dek:
                      'This ecoregion covers the dissected plateaus bordering the lower Congo River, as it flows through the Democratic Republic of Congo (DRC), Republic of Congo, and northern Angola.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2fb458b4-6261-4c17-8a09-3a23d4347ca7/WesternCongoliaForestSavannah-WikiCommons.JPG',
                      _id: '2fb458b4-6261-4c17-8a09-3a23d4347ca7'
                    }
                  },
                  { _id: '0146c65b-7335-42ef-9051-86b948f4b1f7' },
                  { title: 'Southern Congolian Forest-Savanna' },
                  { regionId: '58' },
                  {
                    dek:
                      'The ecoregion covers much of south central Democratic Republic of Congo (DRC) and the northeast corner of Angola.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/06ead837-b2be-4253-bd6b-41d40f2995d7/SouthernCongoliaForestSavannah-2_resized.jpg',
                      _id: '06ead837-b2be-4253-bd6b-41d40f2995d7'
                    }
                  }
                ],
                stats: [
                  { number: '94,593', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '17%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'Victoria Basin & Albertine Rift Forests (AT12)',
                children: [],
                _id: 'd0e7c84d-9475-4600-8197-8a3d11ecddc5',
                value: 1000,
                parentId: '8e74ab84-0832-4a13-b15b-1898e7bb4911',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/132e325a-4352-47b1-a32d-cb9e3074047d/1 Albertine Rift Montane Forest - D Olsonc.jpg',
                    _id: '132e325a-4352-47b1-a32d-cb9e3074047d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fc944984-cb52-4bfb-a3e2-5991b17169ec/61 Victoria Basin forest-savanna - D Olson.jpg',
                    _id: 'fc944984-cb52-4bfb-a3e2-5991b17169ec'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c4c72023-7eb8-41a4-a254-aff34fbab8ba/86 Rwenzori-Virunga montane moorlands - Manuel Werner.jpg',
                    _id: 'c4c72023-7eb8-41a4-a254-aff34fbab8ba'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b68e5510-3aba-47fb-99e8-a800a2da641a/Bioregion%20map-AT12.jpg',
                content:
                  '<p>The Victoria Basin bioregion, located in the Equatorial Afrotropics, is centered on Lake Victoria at the border between Kenya, Tanzania, and Uganda, and the surrounding forest-savanna. It also includes the mountain forests along the Albertine Rift just to the west, with which it is tightly interconnected. The bioregion has three ecoregions -- Albertine Rift Montane Forests [1], Victoria Basin Forest-Savanna [2], Rwenzori-Virunga Montane Moorlands [3] -- and includes the famous Virunga National Park near Lake Edward at the eastern border of DRC. This is an especially important area of biodiversity with more than 2000 plant and tree species, 230 of which are endemic, and the last refuge of many endangered animals including the mountain gorilla, golden monkey, blue monkey, olive baboon, bush elephants, hippopotamus. It\u2019s also a refuge for millions of birds, which winter here from as far as Siberia. The area of this bioregion is nearly 32 million hectares.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b68e5510-3aba-47fb-99e8-a800a2da641a/Bioregion%20map-AT12.jpg"/><figcaption><span class="caption"><p>The Victoria Basin &amp; Albertine Rift Forests bioregion is part of the Equatorial Afrotropics&nbsp;subrealm and is made up of three ecoregions: Albertine Rift Montane Forests [1], Victoria Basin Forest-Savanna [2], Rwenzori-Virunga Montane Moorlands [3].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bVictoria Basin &amp; Albertine Rift Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'e2b98d5d-62b9-4491-9a92-2f4631f0766d' },
                  { title: 'Rwenzori-Virunga Montane Moorlands' },
                  { regionId: '86' },
                  {
                    dek:
                      'The \u2018Mountains of the Moon\u2019, otherwise known as the Rwenzori mountain range, extends up to 5,108 m at the Margherita summit, Africa\u2019s third tallest peak after Mount Kilimanjaro and Mount Kenya.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c4c72023-7eb8-41a4-a254-aff34fbab8ba/86 Rwenzori-Virunga montane moorlands - Manuel Werner.jpg',
                      _id: 'c4c72023-7eb8-41a4-a254-aff34fbab8ba'
                    }
                  },
                  { _id: 'e4ebf31b-22c0-4b4e-a9a3-d03368de66f1' },
                  { title: 'Victoria Basin Forest-Savanna' },
                  { regionId: '61' },
                  {
                    dek:
                      'Centered on Lake Victoria, the ecoregion encompasses most of south-central Uganda, the eastern half of Rwanda and extends marginally into Tanzania, Burundi, Democratic Republic of Congo (DRC), and Kenya.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fc944984-cb52-4bfb-a3e2-5991b17169ec/61 Victoria Basin forest-savanna - D Olson.jpg',
                      _id: 'fc944984-cb52-4bfb-a3e2-5991b17169ec'
                    }
                  },
                  { _id: 'f35758ff-9c97-42b5-b9b0-b805ad88d7f7' },
                  { title: 'Albertine Rift Montane Forests' },
                  { regionId: '1' },
                  {
                    dek:
                      'The Albertine Rift Montane Forests contain the highest levels of faunal endemism in Africa and harbors the mountain gorilla, one of the rarest animals in Africa.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/132e325a-4352-47b1-a32d-cb9e3074047d/1 Albertine Rift Montane Forest - D Olsonc.jpg',
                      _id: '132e325a-4352-47b1-a32d-cb9e3074047d'
                    }
                  }
                ],
                stats: [
                  { number: '31,906', item: 'Total Land Area (1000 ha) ' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '29%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Afrotropics',
            value: 1000
          },
          {
            _id: 'cad75fe6-009d-4680-9cc6-81ab9c170805',
            name: 'Sub-Equatorial Afrotropics',
            children: [
              {
                name: 'St. Helena & Ascension Islands (AT18)',
                children: [],
                _id: 'cce4b233-c2bd-48ba-820d-0c8c7e40c182',
                value: 1000,
                parentId: 'cad75fe6-009d-4680-9cc6-81ab9c170805',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/063768ac-db75-4021-84c7-231753871cb7/37 Ascension scrub and grasslands - Jerrrye _ Roy Klotz.jpg',
                    _id: '063768ac-db75-4021-84c7-231753871cb7'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/885789ae-a79f-4698-bb0c-2697dc45c8a4/60 St. Helena scrub and woodlands - Andrew Neaum.jpg',
                    _id: '885789ae-a79f-4698-bb0c-2697dc45c8a4'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e0e6f194-1419-44d0-bae5-5a95a367ee78/Bioregion%20map-AT18.jpg',
                content:
                  '<p>The St. Helena &amp; Ascension bioregion, located in the Equatorial Afrotropics, comprises a grouping of small volcanic islands in the middle of the Atlantic Ocean more than 800 nautical miles from the Gulf of Guinea. With two ecoregions -- St. Helena Scrub and Woodlands [1], Ascension Scrub and Grasslands [2] -- it has a land area of approximately 22,000 hectares. The surrounding waters are rich with biodiversity and serve as a critical stopping place for migratory species, and it has one of the largest nesting populations of green sea turtles.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e0e6f194-1419-44d0-bae5-5a95a367ee78/Bioregion%20map-AT18.jpg"/><figcaption><span class="caption"><p>The St. Helena &amp; Ascension Islands bioregion is part of the Sub-Equatorial Afrotropics subrealm and is made up of two ecoregions: St. Helena Scrub and Woodlands [1], Ascension Scrub and Grasslands [2].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bSt. Helena &amp; Ascension Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: '88bc2a03-25cf-4c84-a76c-3275e9a03a38' },
                  { title: 'St. Helena Scrub and Woodlands' },
                  { regionId: '60' },
                  {
                    dek:
                      'St. Helena Island is in the South Atlantic Ocean, 1,950 km west of the African Coast.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/885789ae-a79f-4698-bb0c-2697dc45c8a4/60 St. Helena scrub and woodlands - Andrew Neaum.jpg',
                      _id: '885789ae-a79f-4698-bb0c-2697dc45c8a4'
                    }
                  },
                  { _id: 'a026e191-9cbd-4ece-8c4a-f230e025b595' },
                  { title: 'Ascension Scrub and Grasslands' },
                  { regionId: '37' },
                  {
                    dek:
                      'Ascension Island lies in the equatorial Atlantic Ocean, 1,200 km northwest of the Island of St. Helena and 1,700 km from the nearest mainland in Africa. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/063768ac-db75-4021-84c7-231753871cb7/37 Ascension scrub and grasslands - Jerrrye _ Roy Klotz.jpg',
                      _id: '063768ac-db75-4021-84c7-231753871cb7'
                    }
                  }
                ],
                stats: [
                  { number: '22', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '100%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Greater African Subequatorial Savannas & Mixed Woodlands (AT11)',
                children: [],
                _id: '2c974f37-ad68-46be-a5b9-4ddf4546636f',
                value: 1000,
                parentId: 'cad75fe6-009d-4680-9cc6-81ab9c170805',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1f3ddc20-dc48-4f7e-a9bf-1609ff3ab586/Aerial landscape in Okavango delta, Botswana. Lakes and rivers, view from airplane, UNESCO World Heritage site in South Africa dreamstime_xxl_118858120 Large.jpeg',
                    _id: '1f3ddc20-dc48-4f7e-a9bf-1609ff3ab586'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b39bb2c9-e822-4e79-b901-374d2960afef/33 Zambezian Evergreen Forest - Geoff Gallice.jpg',
                    _id: 'b39bb2c9-e822-4e79-b901-374d2960afef'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9bcf5fbe-91b6-495e-8cb4-bd7856f66260/73 Makgadikgadi halophytics - Ralph Ellerich.jpg',
                    _id: '9bcf5fbe-91b6-495e-8cb4-bd7856f66260'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8e003d87-e48b-4926-b124-b9904d386b08/35 Angolan scarp savanna and woodlands - Marcos 1.jpg',
                    _id: '8e003d87-e48b-4926-b124-b9904d386b08'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1efb0353-aaa8-4115-ad98-d0de62d18794/85 Nyanga-Chimanimani Montane forest-grassland - Senorhorst Jahnsen.jpg',
                    _id: '1efb0353-aaa8-4115-ad98-d0de62d18794'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/02abedf5-bff3-43ef-a058-2cd21bb0b822/76 Zambezian flooded grasslands - Gregoire Dubois.jpg',
                    _id: '02abedf5-bff3-43ef-a058-2cd21bb0b822'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dab1086c-b7cd-4673-9d27-6d69616f365f/Aerial landscape in Okavango delta, Botswana. Lakes and rivers, view from airplane. Green vegetation in South Africa dreamstime_xxl_118858121 Large.jpeg',
                    _id: 'dab1086c-b7cd-4673-9d27-6d69616f365f'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2ce8e386-c37d-483f-b981-40eca913c4b5/Bioregion%20map-AT11.jpg',
                content:
                  '<p>The Greater African bioregion is the largest in the Afrotropical realm, covering the entire width of the continent from the drylands and grasslands of southern Africa north to the beginning of the Equatorial forest zone, extending to the southern shore of Lake Victoria. The bioregion consists mostly of savannas and woodlands, but it also includes pockets of dry forest and flooded grasslands, incorporating the lakes along the Albertine Rift. The bioregion contains 20 distinct ecoregions \u2013 Angolan Mopane Woodlands [1], Etosha Pan Halophytics [2], Zambezian Baikiaea Woodlands [3], Angolan Montane Forest-Grassland [4], Angolan Wet Miombo Woodlands [5], Dry Miombo Woodlands [6], Zambezian Flooded Grasslands [7], Zambezian Evergreen Dry Forests [8], Central Zambezian Wet Miombo Woodlands [9], Zambezian-Limpopo Mixed Woodlands [10], Makgadikgadi Halophytics [11], Zambezian Mopane Woodlands [12], Nyanga-Chimanimani Montane Forest-Grassland [13], Itigi-Sumbu Thicket [14], Southern Rift Montane Forest-Grassland [15], Eastern Arc Forests [16], Southern Acacia-Commiphora Bushlands and Thickets [17], East African Halophytics [18], Mulanje Montane Forest-Grassland [19], Angolan Scarp Savanna and Woodlands [20] \u2013 totaling more than 436 million hectares of land area. It covers most of the Zambezian region and is divided into three major zones by the Zambezi River to the west and the Albertine Rift to the east. The bioregion is incredibly rich in flora with 8500 species of plants, more than half of which are endemic.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2ce8e386-c37d-483f-b981-40eca913c4b5/Bioregion%20map-AT11.jpg"/><figcaption><span class="caption"><p>The Greater African Subequatorial Savannas &amp; Mixed Woodlands bioregion is part of the Subequatorial Afrotropics&nbsp;subrealm and is made up of twenty ecoregions: Angolan Mopane Woodlands [1], Etosha Pan Halophytics [2], Zambezian Baikiaea Woodlands [3], Angolan Montane Forest-Grassland [4], Angolan Wet Miombo Woodlands [5], Dry Miombo Woodlands [6], Zambezian Flooded Grasslands [7], Zambezian Evergreen Dry Forests [8], Central Zambezian Wet Miombo Woodlands [9], Zambezian-Limpopo Mixed Woodlands [10], Makgadikgadi Halophytics [11], Zambezian Mopane Woodlands [12], Nyanga-Chimanimani Montane Forest-Grassland [13], Itigi-Sumbu Thicket [14], Southern Rift Montane Forest-Grassland [15], Eastern Arc Forests [16], Southern Acacia-Commiphora Bushlands and Thickets [17], East African Halophytics [18], Mulanje Montane Forest-Grassland [19], Angolan Scarp Savanna and Woodlands [20].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace\u200b</strong></a> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bGreater African Sub-Equatorial Savannas &amp; Mixed Woodlands ecoregions below.</p>',
                ecoregions: [
                  { _id: '977c5556-b98c-423e-a3c5-bdc7efe8f689' },
                  { title: 'Southern Rift Montane Forest-Grassland' },
                  { regionId: '87' },
                  {
                    dek:
                      'This ecoregion consists of mountain chains around the western and northern shores of Lake Malawi/Nyasa, and extends to the eastern ranges of Lake Tanganyika. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fe08aeb7-a730-4c23-a5b0-2ec2932bee63/87 Southern Rift Montane forest-grassland - Felefuchs.JPG',
                      _id: 'fe08aeb7-a730-4c23-a5b0-2ec2932bee63'
                    }
                  },
                  { _id: 'c14dd4d4-aad8-4042-9993-8b8542347151' },
                  { title: 'Nyanga-Chimanimani Montane Forest-Grassland' },
                  { regionId: '85' },
                  {
                    dek:
                      'This ecoregion covers the mountains that extend along the border between Zimbabwe and Mozambique.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/42f2f8eb-afb8-4178-8d0f-ae9d2c20b5ef/85 Nyanga-Chimanimani Montane Forest-Grassland Axel Bohnstedt cc.jpeg',
                      _id: '42f2f8eb-afb8-4178-8d0f-ae9d2c20b5ef'
                    }
                  },
                  { _id: '9281dff9-2edf-4e39-ac3c-bf0310b3d165' },
                  { title: 'Mulanje Montane Forest-Grassland' },
                  { regionId: '84' },
                  {
                    dek:
                      'This ecoregion is situated at the southern end of Malawi about 100 km south of Lake Malawi. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bea145d6-a97b-4ed7-a7fd-e70111a5c8fb/84 Mulanje Montane forest-grassland - fffriendlyl.jpg',
                      _id: 'bea145d6-a97b-4ed7-a7fd-e70111a5c8fb'
                    }
                  },
                  { _id: 'f24ff453-620a-422a-9d58-1e4dfe673bd7' },
                  { title: 'Angolan Montane Forest-Grassland' },
                  { regionId: '77' },
                  {
                    dek:
                      'This ecoregion comprises a number of small montane forest patches surrounded by grasslands and Protea savanna in the west-central highlands of Angola.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d47a38e3-0742-470a-b99e-d779917ffc1f/77 Angolan montane forest-grassland - Benjamin Stauch.JPG',
                      _id: 'd47a38e3-0742-470a-b99e-d779917ffc1f'
                    }
                  },
                  { _id: '49c2dc64-5b92-480c-ab56-378d3d87f203' },
                  { title: 'Zambezian Flooded Grasslands' },
                  { regionId: '76' },
                  {
                    dek:
                      'Embedded predominantly within miombo and mopane woodlands, the ecoregion occurs as isolated patches from northern Botswana in the south, to Tanzania in the north.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/02abedf5-bff3-43ef-a058-2cd21bb0b822/76 Zambezian flooded grasslands - Gregoire Dubois.jpg',
                      _id: '02abedf5-bff3-43ef-a058-2cd21bb0b822'
                    }
                  },
                  { _id: 'fa7e0fbf-b5e0-43b4-82a4-6a5e2658804d' },
                  { title: 'Makgadikgadi Halophytics' },
                  { regionId: '73' },
                  {
                    dek:
                      'This ecoregion covers the Makgadikgadi Pan complex in northeastern Botswana which contains two major pans, Ntwetwe Pan and Sua Pan, surrounded by a number of smaller pans.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9bcf5fbe-91b6-495e-8cb4-bd7856f66260/73 Makgadikgadi halophytics - Ralph Ellerich.jpg',
                      _id: '9bcf5fbe-91b6-495e-8cb4-bd7856f66260'
                    }
                  },
                  { _id: '28940aff-a6f8-485e-8ee1-3dce6f2eaefd' },
                  { title: 'Etosha Pan Halophytics' },
                  { regionId: '70' },
                  {
                    dek:
                      'Situated within Etosha National Park, Namibia, the large saline depression is the remnant of a large, inland Pliocene lake and is the largest pan system in Namibia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0d3ba87a-08a2-4258-9c18-ccb9d18b021e/70 Etosha Pan halophytics - Gregoire Dubois.jpg',
                      _id: '0d3ba87a-08a2-4258-9c18-ccb9d18b021e'
                    }
                  },
                  { _id: '33677778-aca3-49a4-88bd-55cdff097822' },
                  { title: 'East African Halophytics' },
                  { regionId: '69' },
                  {
                    dek:
                      'This ecoregion encompass saline (soda) lakes, including Lake Natron, Lake Eyasi, and Lake Manyara, situated in the eastern arm of the Rift Valley in Tanzania as well as Lake Magadi in Kenya.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1e15c4ed-a66c-4619-9872-94b8832a575c/69 East African halophytics - clem23.jpg',
                      _id: '1e15c4ed-a66c-4619-9872-94b8832a575c'
                    }
                  },
                  { _id: '71e4fd25-cbaf-409a-9345-acdb7635a147' },
                  { title: 'Zambezian-Limpopo Mixed Woodlands' },
                  { regionId: '66' },
                  {
                    dek:
                      'The Zambezian-Limpopo mixed woodlands are widespread in the lower-lying areas of eastern southern Africa.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f671a205-c8ad-4d9d-9aa7-8bdafd480fc6/66 Zambezian-Limpopo mixed woodlands - Brian Dell.JPG',
                      _id: 'f671a205-c8ad-4d9d-9aa7-8bdafd480fc6'
                    }
                  },
                  { _id: '22712ad7-6a36-4d1e-9789-4c6f57f5fe9a' },
                  { title: 'Zambezian Mopane Woodlands' },
                  { regionId: '65' },
                  {
                    dek:
                      'This ecoregion is one of the most important areas for large mammal diversity and biomass in southern Africa, including some of the most significant remaining populations of black rhinoceros and elephants.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6b39f3ec-12b5-4fff-a38a-aff96f58116b/65 Zambezian Mopane Woodlands Courtesy of Hans Hillewaert.jpg',
                      _id: '6b39f3ec-12b5-4fff-a38a-aff96f58116b'
                    }
                  },
                  { _id: '61c60880-e8d2-4472-a90f-5145186fc528' },
                  { title: 'Zambezian Baikiaea Woodlands' },
                  { regionId: '64' },
                  {
                    dek:
                      'This ecoregion is a mosaic of Zambesi Redwood dominated forest, woodland, thicket, and secondary grasslands, which lies on deep Kalahari sands in a wide belt along the Angolan-Namibian border across to Zimbabwe. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/22d13f3c-d071-4df2-8e3f-3ebbcd13b8a3/64 Zambezian Baikiaea woodlands - Gregoire Dubois.jpg',
                      _id: '22d13f3c-d071-4df2-8e3f-3ebbcd13b8a3'
                    }
                  },
                  { _id: '44a50048-8b80-43f2-912b-bbd3145fba50' },
                  { title: 'Southern Acacia-Commiphora Bushlands and Thickets' },
                  { regionId: '57' },
                  {
                    dek:
                      'This ecoregion is located in north central Tanzania, and extends into southwestern Kenya on the eastern margins of Lake Victoria. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9dd5a4de-07a3-4cfa-9656-0140d024f363/51 Wildebeest herding and following a few leading zebra in the Masai Mara, Kenya. T R Shankar Raman cc.jpg',
                      _id: '9dd5a4de-07a3-4cfa-9656-0140d024f363'
                    }
                  },
                  { _id: '02e1a5f3-f6a9-4a6a-a5db-8c2d31674ced' },
                  { title: 'Itigi-Sumbu Thicket' },
                  { regionId: '46' },
                  {
                    dek:
                      'Stands of thicket occur in Tanzania close to its namesake town of Itigi near Dodoma, and also in Zambia between Lakes Mweru Wantipa and Tanganyika.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/76ee5d47-3067-4013-95ab-bfeac5adf647/46 Itigi-Sumbu thicket - Paul Smith.JPG',
                      _id: '76ee5d47-3067-4013-95ab-bfeac5adf647'
                    }
                  },
                  { _id: '6b52b005-65b3-4114-aba6-10193b6ad477' },
                  { title: 'Dry Miombo Woodlands' },
                  { regionId: '42' },
                  {
                    dek:
                      'This ecoregion includes parts of Tanzania, Mozambique,  Malawi, as well as extending across the Central African Plateau over central Zimbabwe and southern Zambia, and a large area of southwestern Angola.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d5c60f3e-82d8-426b-b835-ac6a0689e496/42 Dry miombo woodlands - D Olson.jpg',
                      _id: 'd5c60f3e-82d8-426b-b835-ac6a0689e496'
                    }
                  },
                  { _id: '746f151a-b302-459d-943e-f3ddd893be58' },
                  { title: 'Central Zambezian Wet Miombo Woodlands' },
                  { regionId: '39' },
                  {
                    dek:
                      'This ecoregion covers about central and northern Zambia, the southeastern DRC, western Malawi, western Tanzania, and parts of Burundi and northeastern Angola. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/208ec690-ef7d-48c1-a818-e398cd914f4c/39 Central Zambezian wet miombo woodlands - Thomas Wagner.jpg',
                      _id: '208ec690-ef7d-48c1-a818-e398cd914f4c'
                    }
                  },
                  { _id: 'bbf1f9db-16c8-411a-960a-ac5155c29707' },
                  { title: 'Angolan Wet Miombo Woodlands' },
                  { regionId: '36' },
                  {
                    dek:
                      'This ecoregion covers all of central Angola and extends into the Democratic Republic of Congo (DRC) and is mostly found at elevations between 1,000 and 1,500 m above sea level, including the highlands of Hu\u00edla, Huambo, and Bi\u00e9. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/438005a7-1f04-41c6-9cd4-f854017ed1e7/36 Angolan wet miombo woodlands - Paulo C\u00e9sar Santos.jpg',
                      _id: '438005a7-1f04-41c6-9cd4-f854017ed1e7'
                    }
                  },
                  { _id: '385a5403-3eae-41a4-ba1c-3dd4d20a7ebf' },
                  { title: 'Angolan Mopane Woodlands' },
                  { regionId: '34' },
                  {
                    dek:
                      'This ecoregion lies on the western edge of the Central African Plateau, at around 1,000 m in elevation along the Owambo Basin.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/75bc82b3-b333-4f79-aea0-0ac8d5397ac3/34-Grassland_at_etosha-CC-2007.jpg',
                      _id: '75bc82b3-b333-4f79-aea0-0ac8d5397ac3'
                    }
                  },
                  { _id: '1d13bf9f-5619-4f34-9f5e-18ab64953bfe' },
                  { title: 'Zambezian Evergreen Dry Forests' },
                  { regionId: '33' },
                  {
                    dek:
                      'The ecoregion\u2019s forests are found at 1,100 to 1,200 m elevation in the higher rainfall areas of the Kalahari sands of northern Barotseland in western Zambia, and extend into Angola. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b39bb2c9-e822-4e79-b901-374d2960afef/33 Zambezian Evergreen Forest - Geoff Gallice.jpg',
                      _id: 'b39bb2c9-e822-4e79-b901-374d2960afef'
                    }
                  },
                  { _id: '1fddf818-ec38-4f1a-9f27-14d5a5bb9d84' },
                  { title: 'Eastern Arc Forests' },
                  { regionId: '9' },
                  {
                    dek:
                      'This ecoregion is comprised of thirteen mountain blocks including the Taita Hills, the North and South Pare, the East and West Usambara, the North and South Nguru, the Ukaguru, the Uluguru, the Rubeho, and the Udzungwa. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/19469012-cf40-443e-a59f-f23954396c14/9 Eastern Arc forests - D Olson_resized.jpg',
                      _id: '19469012-cf40-443e-a59f-f23954396c14'
                    }
                  },
                  { _id: '07a920c4-3518-4c68-a4c0-5e00c59f39f7' },
                  { title: 'Angolan Scarp Savanna and Woodlands' },
                  { regionId: '35' },
                  {
                    dek:
                      'This ecoregion comprises a long narrow strip of land between the Atlantic Ocean, the southwest arid biome of Angola and the top of the scarp face of the Central African Plateau.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8e003d87-e48b-4926-b124-b9904d386b08/35 Angolan scarp savanna and woodlands - Marcos 1.jpg',
                      _id: '8e003d87-e48b-4926-b124-b9904d386b08'
                    }
                  }
                ],
                stats: [
                  { number: '450,016', item: 'Total Land Area (1000 ha)' },
                  { number: '20', item: 'Number of Ecoregions' },
                  { number: '35%', item: 'Protection Target' },
                  { number: '7', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Afrotropics',
            value: 285
          },
          {
            _id: '4a1dcf68-0d86-4f76-bf0c-577505fbe48d',
            name: 'Madagascar & East African Coast',
            children: [
              {
                name: 'Mascarene Tropical Forest Islands (AT4)',
                children: [],
                _id: 'b858a6dd-9628-482e-bcfb-f56ddd29b41c',
                value: 1000,
                parentId: '4a1dcf68-0d86-4f76-bf0c-577505fbe48d',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/546056e7-8a03-4d6e-8d41-94e4aa092b60/20 Mascarene forests - S Molteno.jpg',
                    _id: '546056e7-8a03-4d6e-8d41-94e4aa092b60'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/927992c0-6158-4356-89c8-a7f7cec46e92/Bioregion%20map-AT4.jpg',
                content:
                  '<p>The Mascarene bioregion, located in the Afrotropical realm, is an archipelago of islands in the Indian Ocean just east of Madagascar, which includes Mauritius, R\u00e9union, and Rodrigues, plus a variety of reefs, atolls, and small islands. Due to its unique soil and climate, it has an incredibly diverse flora with over 1000 native species, hundreds of which are endemic. The bioregion is dominated by one ecoregion \u2013 Mascarene Forests [1] \u2013 which include a diverse range of rainforests, cloud forests, swamp forest, and lowland dry forests. Mauritius was the former habitat of the now extinct dodo bird, and many other exotic birds. The islands are surrounded by approximately 750 square km of coral reefs. Total area of the islands is approximately 500,000 hectares, not including reefs and adjacent marine areas.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/927992c0-6158-4356-89c8-a7f7cec46e92/Bioregion%20map-AT4.jpg"/><figcaption><span class="caption"><p>The Mascarene Tropical Forest Islands bioregion is part of the Madagascar &amp; Eastern Afrotropics&nbsp;subrealm and is made up of one ecoregion: Mascarene Forests [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about the Mascarene Tropical Forest Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: 'dbfd23ea-afe9-4cfa-9515-3887da78a118' },
                  { title: 'Mascarene Forests' },
                  { regionId: '20' },
                  {
                    dek:
                      'The Mascarene Islands are located 640 to 1,450 km east of Madagascar in the western Indian Ocean. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/546056e7-8a03-4d6e-8d41-94e4aa092b60/20 Mascarene forests - S Molteno.jpg',
                      _id: '546056e7-8a03-4d6e-8d41-94e4aa092b60'
                    }
                  }
                ],
                stats: [
                  { number: '496', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '52%', item: 'Protection Target' },
                  { number: '7', item: 'Protection Level' }
                ]
              },
              {
                name: 'Amsterdam-Saint Paul Islands (AT3)',
                children: [],
                _id: '4b7eabee-ee71-48e7-b3a9-c62e3ee9a272',
                value: 1000,
                parentId: '4a1dcf68-0d86-4f76-bf0c-577505fbe48d',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e66e9267-4d33-4027-a020-f24fe0a9b7ce/AmsterdamSaintPaulIslandsTemperateGrasslands-NoCopyright2.JPG',
                    _id: 'e66e9267-4d33-4027-a020-f24fe0a9b7ce'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d81b5174-e7b2-4677-9c57-3b810a37eacb/Bioregion%20map-AT3.jpg',
                content:
                  '<p>The Amsterdam-Saint Paul bioregion, located in the far south of the Indian Ocean, is at the furthest edge of the Afroptropical realm, at the transition between the Indomalayan and Antarctic realms. Its two islands are dominated by temperate grasslands with one single ecoregion \u2013 Amsterdam-Saint Paul Islands Temperate Grasslands [1] \u2013 and adjacent marine areas. It is an especially important breeding area for an array of birds as well as fur seals, elephant seals, and rockhopper penguins.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d81b5174-e7b2-4677-9c57-3b810a37eacb/Bioregion%20map-AT3.jpg"/><figcaption><span class="caption"><p>The Amsterdam-Saint Paul bioregion is part of the Madagascar &amp; Eastern Afrotropics&nbsp;subrealm and is made up of one ecoregion: Amsterdam-Saint Paul Islands Temperate Grasslands [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about the Amsterdam-Saint Paul Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: '3cb3403c-099f-426a-8f71-71adb08d4faa' },
                  { title: 'Amsterdam-Saint Paul Islands Temperate Grasslands' },
                  { regionId: '67' },
                  {
                    dek:
                      'Amsterdam and Saint-Paul are Subantarctic volcanic islands in the southern Indian Ocean, located approximately 80 km from each other.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1ddaec34-2759-4e52-9db7-fc61bdae4da0/AmsterdamSaintPaulIslandsTemperateGrasslands-NoCopyright.jpg',
                      _id: '1ddaec34-2759-4e52-9db7-fc61bdae4da0'
                    }
                  }
                ],
                stats: [
                  { number: '7', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '99%', item: 'Protection Target' },
                  { number: '10', item: 'Protection Level' }
                ]
              },
              {
                name: 'East African Coastal Forests (AT7)',
                children: [],
                _id: '48c61817-7581-46cf-af98-0c99bb18138f',
                value: 1000,
                parentId: '4a1dcf68-0d86-4f76-bf0c-577505fbe48d',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/09d9858a-ffe5-4bef-8f04-5bbbeed5f489/16 Kwazulu Natal-Cape coastal forests -Aleph500Adam.jpg',
                    _id: '09d9858a-ffe5-4bef-8f04-5bbbeed5f489'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f2b0747c-1576-4afe-8504-4673780859dc/25 Northern Swahili coastal forests - \u00a9 Adrian Arbib www.arbib.org.jpg',
                    _id: 'f2b0747c-1576-4afe-8504-4673780859dc'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8e9a509e-e701-4a3a-9075-975c19627ec2/28 Southern Swahili coastal forests and woodlands - Axel Bohnstedt.JPG',
                    _id: '8e9a509e-e701-4a3a-9075-975c19627ec2'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/33bb8117-c64c-4b17-87c3-9c37f0abca8e/112 East Africa mangroves - Fanny Schertzer.jpg',
                    _id: '33bb8117-c64c-4b17-87c3-9c37f0abca8e'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3dab8722-5882-43b9-8de4-558b16bf15cd/Bioregion%20map-AT7.jpg',
                content:
                  '<p>The East African Coastal bioregion, located in the Afrotropical realm, extends in a narrow band nearly the entire length of Africa\u2019s eastern coast. It consists of tropical and subtropical moist forests including seven ecoregions \u2013 Northern Swahili Coastal Forests [1], East African Mangroves [2], Southern Swahili Coastal Forests and Woodlands [3], Zambezian Coastal Flooded Savanna [4], Maputaland Coastal Forests and Woodlands [5], Southern Africa Mangroves [6], Kwazulu Natal-Cape Coastal Forests [7]. The coastline is considered a biodiversity hotspot with 11,000 species of plants and animals, including 1000 species of seaweed, 3000 species of mollusks, and 1500 species of fish. The total land area of the bioregion is nearly 36 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3dab8722-5882-43b9-8de4-558b16bf15cd/Bioregion%20map-AT7.jpg"/><figcaption><span class="caption"><p>The East African Coastal Forests bioregion is part of the Madagascar &amp; Eastern Afrotropics subrealm and is made up of seven ecoregions: Northern Swahili Coastal Forests [1], East African Mangroves [2], Southern Swahili Coastal Forests and Woodlands [3], Zambezian Coastal Flooded Savanna [4], Maputaland Coastal Forests and Woodlands [5], Southern Africa Mangroves [6], Kwazulu Natal-Cape Coastal Forests [7].</p></span> </figcaption></figure>\n<p>Learn more about each of the \u200bEast African Coastal Forests ecoregions and explore the climate solution projects located in this bioregion below.</p>',
                ecoregions: [
                  { _id: 'c394d870-eb71-400f-9376-c2b6a5ecbb85' },
                  { title: 'Southern Africa Mangroves' },
                  { regionId: '116' },
                  {
                    dek:
                      'The Southern Africa Mangroves line parts of the eastern South African and southernmost Mozambique coastline along the Indian Ocean.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/771ed31f-9a2d-4e52-96e5-df89bcbe17a6/SouthernAfricanMangroves-Pixabay.jpg',
                      _id: '771ed31f-9a2d-4e52-96e5-df89bcbe17a6'
                    }
                  },
                  { _id: '0e2e0acb-a6e8-4c2f-aa59-384e5de4afb2' },
                  { title: 'East African Mangroves' },
                  { regionId: '112' },
                  {
                    dek:
                      'East African mangroves are found in Mozambique, Tanzania, Kenya, and southern Somalia. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/33bb8117-c64c-4b17-87c3-9c37f0abca8e/112 East Africa mangroves - Fanny Schertzer.jpg',
                      _id: '33bb8117-c64c-4b17-87c3-9c37f0abca8e'
                    }
                  },
                  { _id: '87f345c5-4607-4a23-a244-056f415ffdff' },
                  { title: 'Zambezian Coastal Flooded Savanna' },
                  { regionId: '75' },
                  {
                    dek:
                      'This ecoregion is restricted to the coastal regions of Mozambique, and essentially comprises the floodplain deltas of the Zambezi, Pungwe, Buzi, and Save Rivers.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6d4e9f1c-ce94-4a3c-9906-76a74b231a5a/75-ZambezianCoastalFloodedSavanna-WikiCommons.jpg',
                      _id: '6d4e9f1c-ce94-4a3c-9906-76a74b231a5a'
                    }
                  },
                  { _id: '5be42a2f-9e86-48c6-bb21-7c57cc14c347' },
                  { title: 'Southern Swahili Coastal Forests and Woodlands' },
                  { regionId: '28' },
                  {
                    dek:
                      'This ecoregion runs approximately 2,200 km along the eastern coast of Africa, from the Lukuledi River in southern Tanzania to the Changane River just south of Xai-Xai.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8e9a509e-e701-4a3a-9075-975c19627ec2/28 Southern Swahili coastal forests and woodlands - Axel Bohnstedt.JPG',
                      _id: '8e9a509e-e701-4a3a-9075-975c19627ec2'
                    }
                  },
                  { _id: '3cf45f70-b8bd-4d37-b9bd-af9675c252dc' },
                  { title: 'Northern Swahili Coastal Forests' },
                  { regionId: '25' },
                  {
                    dek:
                      'This ecoregion ranges from coastal Somalia to southern Tanzania. Outliers are found at the base of the Uluguru, Nguru, and Udzungwa Eastern Arc Mountains, and on the islands of Pemba, Unguja (Zanzibar), and Mafia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f2b0747c-1576-4afe-8504-4673780859dc/25 Northern Swahili coastal forests - \u00a9 Adrian Arbib www.arbib.org.jpg',
                      _id: 'f2b0747c-1576-4afe-8504-4673780859dc'
                    }
                  },
                  { _id: '4ff8bbe1-a35d-4aae-abd7-172c9a3d3f6e' },
                  { title: 'Maputaland Coastal Forests and Woodlands' },
                  { regionId: '19' },
                  {
                    dek:
                      'This ecoregion extends from the Changane River in southern Mozambique to the Umfolosi River just north of Cape Saint Lucia in South Africa. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ce21a99a-2d4c-4b48-b7d0-252b30835e1a/19 Maputaland coastal forests and woodlands - M Purves.JPG',
                      _id: 'ce21a99a-2d4c-4b48-b7d0-252b30835e1a'
                    }
                  },
                  { _id: 'de6ec961-94cf-42b1-8e8a-43bb22adea75' },
                  { title: 'Kwazulu Natal-Cape Coastal Forests' },
                  { regionId: '16' },
                  {
                    dek:
                      'This ecoregion extends south along the eastern South African coastline from Cape St Lucia to Cape St Francis.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/59d9fc8e-9356-4776-a299-00f87e8d5d75/Dense_forest_in_doline-CC-Ton Rulkens-2013.jpg',
                      _id: '59d9fc8e-9356-4776-a299-00f87e8d5d75'
                    }
                  }
                ],
                stats: [
                  { number: '35,825', item: 'Total Land Area (1000 ha) ' },
                  { number: '7', item: 'Number of Ecoregions' },
                  { number: '23%', item: 'Protection Target' },
                  { number: '7', item: 'Protection Level' }
                ]
              },
              {
                name: 'Madagascar Island (AT6)',
                children: [],
                _id: '79347e9f-5492-4a10-96b2-1e63b4937ded',
                value: 1000,
                parentId: '4a1dcf68-0d86-4f76-bf0c-577505fbe48d',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a5661f5f-0de7-4c98-a2d9-af5c39a5d2df/17 Madagascar humid forests - Frank Vassen.jpg',
                    _id: 'a5661f5f-0de7-4c98-a2d9-af5c39a5d2df'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f26a1a22-e3af-463c-8772-d12909d65e21/83 Madagascar ericoid thickets - Chris.jpg',
                    _id: 'f26a1a22-e3af-463c-8772-d12909d65e21'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ec069f46-af40-4190-a0ef-9a828d849a92/99 Madagascar spiny thickets - JialiangGao www.peace-on-earth.org.jpg',
                    _id: 'ec069f46-af40-4190-a0ef-9a828d849a92'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ee1ec2eb-7373-4d7f-874e-aeda489f8f91/114 Madagascar mangrove - C Michael Hogan.jpg',
                    _id: 'ee1ec2eb-7373-4d7f-874e-aeda489f8f91'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b4b9ddf6-8abb-4361-b004-71a4a77ef589/Bioregion%20map-AT6.jpg',
                content:
                  '<p>The Madagascar bioregion, located in the Afrotropical realm, is separated from the African continent by the Mozambique Channel dominated by humid tropical forests in the east, drylands in the south, and dry forests in the north. The bioregion contains eight terrestrial ecoregions \u2013 Madagascar Dry Deciduous Forests [1], Madagascar Subhumid Forests [2], &nbsp;Madagascar Humid Forests [3], Madagascar Succulent Woodlands [4], Madagascar Spiny Thickets [5], Madagascar Mangroves [6], Madagascar Ericoid Thickets [7], Ile Europa and Bassas Da India Xeric Scrub [8] \u2014 with a total land area of more than 59 million hectares, making it the fourth largest island in the world. Due to the island\u2019s physical isolation, it shelters extraordinary biodiversity with nearly 15,000 plant species, four-fifths of which are found nowhere else on Earth. It also has 300 bird and 260 reptile species, the majority of which are endemic. The lemur is the keystone mammal of the island, with over 100 species recorded.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b4b9ddf6-8abb-4361-b004-71a4a77ef589/Bioregion%20map-AT6.jpg"/><figcaption><span class="caption"><p>The Madagascar bioregion is part of the Madagascar &amp; Eastern Afrotropics subrealm and is made up of eight ecoregions: Madagascar Dry Deciduous Forests [1], Madagascar Subhumid Forests [2], &nbsp;Madagascar Humid Forests [3], Madagascar Succulent Woodlands [4], Madagascar Spiny Thickets [5], Madagascar Mangroves [6], Madagascar Ericoid Thickets [7], Ile Europa and Bassas Da India Xeric Scrub [8].&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the Madagascar Island ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: 'f0978691-8e52-417c-976c-a1b324338129' },
                  { title: 'Madagascar Mangroves' },
                  { regionId: '114' },
                  {
                    dek:
                      'This ecoregion contains mangrove forests found primarily along the western coast.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ee1ec2eb-7373-4d7f-874e-aeda489f8f91/114 Madagascar mangrove - C Michael Hogan.jpg',
                      _id: 'ee1ec2eb-7373-4d7f-874e-aeda489f8f91'
                    }
                  },
                  { _id: '09a9d2f4-55f6-4196-ac00-bc290b288154' },
                  { title: 'Madagascar Succulent Woodlands' },
                  { regionId: '100' },
                  {
                    dek:
                      'This ecoregion is located in southwestern and central western Madagascar, sandwiched between the Madagascar Spiny Thickets and the Madagascar Dry Deciduous Forests.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2e5e7c9e-3129-4edb-9ac5-57124c18359f/100 Madagascar succulent woodlands - Rhett Butler.jpg',
                      _id: '2e5e7c9e-3129-4edb-9ac5-57124c18359f'
                    }
                  },
                  { _id: 'afd86e59-04da-4c0b-b4c3-1debfab6830c' },
                  { title: 'Madagascar Spiny Thickets' },
                  { regionId: '99' },
                  {
                    dek:
                      'This ecoregion extends across southern and southwestern Madagascar from the Mangoky River on the west coast to the western slopes of the Anosyennes Mountain chain in the southeast. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ec069f46-af40-4190-a0ef-9a828d849a92/99 Madagascar spiny thickets - JialiangGao www.peace-on-earth.org.jpg',
                      _id: 'ec069f46-af40-4190-a0ef-9a828d849a92'
                    }
                  },
                  { _id: 'e7bc95b7-623b-462c-ab1c-7b3cbe851fd4' },
                  { title: 'Ile Europa and Bassas Da India Xeric Scrub' },
                  { regionId: '96' },
                  {
                    dek:
                      'The islands of Europa and Bassas da India lie in the Mozambique Channel near the southern end of Madagascar.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5524b6a5-2cd9-41a2-a129-0b8976e1e7eb/96 Ile Europa and Bassas da India xeric scrub - B Navez.jpg',
                      _id: '5524b6a5-2cd9-41a2-a129-0b8976e1e7eb'
                    }
                  },
                  { _id: '906555e2-a3fc-4b0e-8a27-6eef3a2119b1' },
                  { title: 'Madagascar Ericoid Thickets' },
                  { regionId: '83' },
                  {
                    dek:
                      'This ecoregion includes the ericoid thicket habitats found above approximately 1,800 m on the upper slopes of Madagascar\u2019s four major massifs: Tsaratanana, Marojejy, Ankaratra, and Andringitra.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f26a1a22-e3af-463c-8772-d12909d65e21/83 Madagascar ericoid thickets - Chris.jpg',
                      _id: 'f26a1a22-e3af-463c-8772-d12909d65e21'
                    }
                  },
                  { _id: '85fe496b-ab79-4685-8af8-db8e47d6aa3b' },
                  { title: 'Madagascar Dry Deciduous Forests' },
                  { regionId: '32' },
                  {
                    dek:
                      'This ecoregion occurs in two separate geographic regions. The first is on the western side of Madagascar from the Ampasindava Peninsula in the north to Belo-sur-Tsiribihina and Maromandia in the south.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2f4d40f8-fad0-4638-8bee-6e237030a955/32 Madagascar dry deciduous forests cc.jpg',
                      _id: '2f4d40f8-fad0-4638-8bee-6e237030a955'
                    }
                  },
                  { _id: '6928bd4a-c43c-49a5-a4aa-5ca483a61ab7' },
                  { title: 'Madagascar Subhumid Forests' },
                  { regionId: '18' },
                  {
                    dek:
                      'This ecoregion is located in the highlands of Madagascar in between the humid forests at the crest of the eastern escarpment and the dry deciduous forests on the western boundary.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ccb2b78f-b520-4126-b785-d44a4741f0aa/18-Tapia_Uapaca_bojeri_Itremo_CC-2016.jpg',
                      _id: 'ccb2b78f-b520-4126-b785-d44a4741f0aa'
                    }
                  },
                  { _id: '08d4589e-b142-414e-a85e-81928b1f6a44' },
                  { title: 'Madagascar Humid Forests' },
                  { regionId: '17' },
                  {
                    dek:
                      'This ecoregion occupies the eastern side of Madagascar, including the littoral forests of the narrow coastal plain and up to the crest of the eastern escarpment around 1,200 \u2013 1,600 m.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a5661f5f-0de7-4c98-a2d9-af5c39a5d2df/17 Madagascar humid forests - Frank Vassen.jpg',
                      _id: 'a5661f5f-0de7-4c98-a2d9-af5c39a5d2df'
                    }
                  }
                ],
                stats: [
                  { number: '59,466', item: 'Total Land Area (1000 ha) ' },
                  { number: '8', item: 'Number of Ecoregions' },
                  { number: '24%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Seychelles & Comoros Tropical Islands (AT5)',
                children: [],
                _id: 'dc90219e-2657-4216-8b50-6bbe58b8dabb',
                value: 1000,
                parentId: '4a1dcf68-0d86-4f76-bf0c-577505fbe48d',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6b664cb5-1652-405d-af60-0c837ca9a8d4/4 Comoros forests - Oliver Hawlitschek.JPG',
                    _id: '6b664cb5-1652-405d-af60-0c837ca9a8d4'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/027e0cac-5f3c-449c-97e4-93d6ad770117/13 Granitic Seychelles Forest - Peggy and Marco Lachmann-Anke.jpg',
                    _id: '027e0cac-5f3c-449c-97e4-93d6ad770117'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/596d2e8c-d009-4447-a6ee-09a8198ac290/91 Aldabra Island xeric scrub - B Navez.JPG',
                    _id: '596d2e8c-d009-4447-a6ee-09a8198ac290'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c17557e3-d19a-466d-aa53-6a9f0b174f86/4-Comoros Forests-Rados\u0142aw Botev-cc.jpg',
                    _id: 'c17557e3-d19a-466d-aa53-6a9f0b174f86'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f841afbf-92d8-483b-b6f0-b62bb440efca/Bioregion%20map-AT5%20rev.jpg',
                content:
                  '<p>The Seychelles &amp; Comoros bioregion, located in the Afrotropical realm, consists of two archipelagos of islands in the Indian Ocean north of Madagascar. The Seychelles group in the east is dominated by granitic tropical broadleaf forest with over 75 endemic plant species, including the rare jellyfish tree. The Comoros group in the west, just off the coast of Mozambique, is dominated by dense tropical forests. Altogether, the bioregion contains three ecoregions\u2014Comoros Forests [4], Aldabra Island Xeric Scrub [91], Granitic Seychelles Forests [13]\u2014covering an area of approximately 250,000 hectares, not including reefs and adjacent marine areas.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f841afbf-92d8-483b-b6f0-b62bb440efca/Bioregion%20map-AT5%20rev.jpg"/><figcaption><span class="caption"><p>The Seychelles &amp; Comoros Tropical Islands bioregion is part of the Madagascar &amp; Eastern Afrotropics subrealm and is made up of three ecoregions: Comoros Forests [1], Aldabra Island Xeric Scrub [2], Granitic Seychelles Forests [3].</p></span> </figcaption></figure>\n<p>Learn more about each of the Seychelles &amp; Comoros Tropical Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: '42e78755-b687-4b17-8f96-ec9b241cfece' },
                  { title: 'Granitic Seychelles Forests' },
                  { regionId: '13' },
                  {
                    dek:
                      'The 115 islands making up the Seychelles are located in the Indian Ocean, about 930 km northeast of Madagascar. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/027e0cac-5f3c-449c-97e4-93d6ad770117/13 Granitic Seychelles Forest - Peggy and Marco Lachmann-Anke.jpg',
                      _id: '027e0cac-5f3c-449c-97e4-93d6ad770117'
                    }
                  },
                  { _id: '2623fb8a-ee21-4094-8903-84f70514a1b1' },
                  { title: 'Comoros Forests' },
                  { regionId: '4' },
                  {
                    dek:
                      'This ecoregion covers the Comoros Islands which are found approximately 300 km from northern Madagascar and about 300 km from the mainland of East Africa. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6b664cb5-1652-405d-af60-0c837ca9a8d4/4 Comoros forests - Oliver Hawlitschek.JPG',
                      _id: '6b664cb5-1652-405d-af60-0c837ca9a8d4'
                    }
                  },
                  { _id: '8174b57c-e355-480b-8adc-6a8fdff9e61d' },
                  { title: 'Aldabra Island Xeric Scrub' },
                  { regionId: '91' },
                  {
                    dek:
                      'This ecoregion occupies the island of Aldabra, one of the largest atolls in the world. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/596d2e8c-d009-4447-a6ee-09a8198ac290/91 Aldabra Island xeric scrub - B Navez.JPG',
                      _id: '596d2e8c-d009-4447-a6ee-09a8198ac290'
                    }
                  }
                ],
                stats: [
                  { number: '254', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '94%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Afrotropics',
            value: 714
          },
          {
            _id: '3e06b7bc-ff9e-4c1e-a439-da0ab8274bce',
            name: 'Sub-Saharan Afrotropics',
            children: [
              {
                name: 'Sahel Acacia Savannas (AT23)',
                children: [],
                _id: '060b6223-9d18-456b-aa98-921f7508185c',
                value: 1000,
                parentId: '3e06b7bc-ff9e-4c1e-a439-da0ab8274bce',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dd800420-ba10-4647-8719-664e28b8e0d7/53 Sahelian Acacia savanna - JC Brito.jpg',
                    _id: 'dd800420-ba10-4647-8719-664e28b8e0d7'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d39bc05d-0e80-4cf8-9190-f90bd6b0b293/71 Inner Niger Delta flooded savanna - Upyernoz.jpg',
                    _id: 'd39bc05d-0e80-4cf8-9190-f90bd6b0b293'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aae86d3d-47e5-4432-a366-0fb9edc7273b/LakeChad-NoCopyright.jpg',
                    _id: 'aae86d3d-47e5-4432-a366-0fb9edc7273b'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d58551a3-2738-40e0-b339-4c7e2840984d/Bioregion%20map-AT23.jpg',
                content:
                  '<p>The Sahel Acacia Savannas bioregion, located in the Sub-Saharan Afrotropics, consists almost entirely of one ecoregion \u2014 Sahelian Acacia Savanna [2] \u2014 that spans across the width of the continent from northern Senegal and Mauritania on the Atlantic coast to Sudan and Eritrea on the Red Sea. Commonly referred to as the \u2018Sahel\u2019\u2014this ecoregion comprises a grassland-dominated transition zone between savanna woodlands to the south and the Sahara Desert to the north. The Sahelian climate is tropical, hot, and strongly seasonal. It also includes two very unique flooded savanna ecoregions \u2014 Inner Niger Delta Flooded Savanna [1], Lake Chad Flooded Savanna [3] \u2014 and altogether the bioregion as a land area of nearly 377 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d58551a3-2738-40e0-b339-4c7e2840984d/Bioregion%20map-AT23.jpg"/><figcaption><span class="caption"><p>The Sahel Acacia Savannas bioregion is part of the Sub-Saharan Afrotropics&nbsp;subrealm and is made up of three ecoregions: Inner Niger Delta Flooded Savanna [1], Sahelian Acacia Savanna [2], Lake Chad Flooded Savanna [3].</p></span> </figcaption></figure>\n<p><br>\n</p>',
                ecoregions: [
                  { _id: '5d79a984-7261-4dc7-8282-eaad27eb19e8' },
                  { title: 'Lake Chad Flooded Savanna' },
                  { regionId: '72' },
                  {
                    dek:
                      'This ecoregion includes Lake Chad and the nearby Hadejia-Nguru wetlands. Lake Chad straddles the borders between four African countries: Cameroon, Chad, Niger, and Nigeria. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0e1aab15-61df-45ee-9400-a1db1c3fa74f/73 Lake Chad Flooded Savanna Ryszard Vorbrich cc.jpg',
                      _id: '0e1aab15-61df-45ee-9400-a1db1c3fa74f'
                    }
                  },
                  { _id: '72ae0c42-ad28-44bf-96fb-fec3473845e1' },
                  { title: 'Sahelian Acacia Savanna' },
                  { regionId: '53' },
                  {
                    dek:
                      'This ecoregion stretches across Africa from northern Senegal and Mauritania on the Atlantic coast to Sudan and Eritrea on the Red Sea. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dd800420-ba10-4647-8719-664e28b8e0d7/53 Sahelian Acacia savanna - JC Brito.jpg',
                      _id: 'dd800420-ba10-4647-8719-664e28b8e0d7'
                    }
                  },
                  { _id: '7f606505-51c8-4b1b-acef-faf1cbb28e52' },
                  { title: 'Inner Niger Delta Flooded Savanna' },
                  { regionId: '71' },
                  {
                    dek:
                      'This ecoregion contains the inland delta of the Niger River in central Mali between Djenn\u00e9 in the south and Tombouctou in the north. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d39bc05d-0e80-4cf8-9190-f90bd6b0b293/71 Inner Niger Delta flooded savanna - Upyernoz.jpg',
                      _id: 'd39bc05d-0e80-4cf8-9190-f90bd6b0b293'
                    }
                  }
                ],
                stats: [
                  { number: '376,823 ', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '28%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'South Red Sea & Gulf of Aden Coastal Drylands (AT22)',
                children: [],
                _id: '4eddab09-3964-40d3-98ad-42714f8df59e',
                value: 1000,
                parentId: '3e06b7bc-ff9e-4c1e-a439-da0ab8274bce',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d998427e-06ba-4255-884c-f985dfd498a3/92 Djibouti xeric shrublands - Gregoire Dubois.jpg',
                    _id: 'd998427e-06ba-4255-884c-f985dfd498a3'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/757c03b9-3a47-4f63-a3fc-cfcc7cd70178/108 Southwest Arabian Escarpment shrublands and woodlands - KKWRC T Butynski.jpg',
                    _id: '757c03b9-3a47-4f63-a3fc-cfcc7cd70178'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bed222d8-0c6b-4227-b657-50a79c6d62e6/115 Red Sea mangroves - KKWRC T Butynski.jpg',
                    _id: 'bed222d8-0c6b-4227-b657-50a79c6d62e6'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/723f1733-9def-4f46-b013-20dafba14d03/Bioregion%20map-AT22%20rev.jpg',
                content:
                  '<p>The South Red Sea &amp; Gulf of Aden Coastal Drylands bioregion, located in the Sub-Saharan Afrotropics, consists of 12 ecoregions \u2014 Red Sea Mangroves [1], Djibouti Xeric Shrublands [2], &nbsp;Eritrean Coastal Desert [3], Horn of Africa Xeric Bushlands [4], Somali Montane Xeric Woodlands [5], Hobyo Grasslands and Shrublands [6], Socotra Island Xeric Shrublands [7], South Arabian Fog Woodlands, Shrublands, and Dune [8], Southwest Arabian Escarpment Shrublands and Woodlands [9], Southwest Arabian Coastal Xeric Shrublands [10], Southwest Arabian Montane Woodlands and Grasslands [11], Southwest Arabian Highland Xeric Scrub [12], encompassing the Horn of Africa, the southern Red Sea and Alden Sea, and the southernmost tip of the Arabian Peninsula. The bioregion is mostly desert with some drylands and scrublands and covers an area of approximately 78 million hectares, not including mangroves and adjacent marine areas in the Red Sea. The Horn of Africa is home to both the frankincense and myrrh trees and contains many endemic and rare animals adapted to the region\u2019s dry and hot climate.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/723f1733-9def-4f46-b013-20dafba14d03/Bioregion%20map-AT22%20rev.jpg"/><figcaption><span class="caption"><p>The South Red Sea &amp; Gulf of Aden Coastal Drylands bioregion is part of the Sub-Saharan Afrotropics&nbsp;subrealm and is made up of 12 ecoregions: Red Sea Mangroves [1], Djibouti Xeric Shrublands [2], &nbsp;Eritrean Coastal Desert [3], Horn of Africa Xeric Bushlands [4], Somali Montane Xeric Woodlands [5], Hobyo Grasslands and Shrublands [6], Socotra Island Xeric Shrublands [7], South Arabian Fog Woodlands, Shrublands, and Dune [8], Southwest Arabian Escarpment Shrublands and Woodlands [9], Southwest Arabian Coastal Xeric Shrublands [10], Southwest Arabian Montane Woodlands and Grasslands [11], Southwest Arabian Highland Xeric Scrub [12].</p></span> </figcaption></figure>\n<p>Learn more about each of the \u200bSouth Red Sea &amp; Gulf of Aden Coastal Drylands ecoregions below.</p>',
                ecoregions: [
                  { _id: '75206a5e-7a66-40d1-b78b-77435d850a0d' },
                  { title: 'Southwest Arabian Highland Xeric Scrub' },
                  { regionId: '109' },
                  {
                    dek:
                      'This ecoregion is situated in the high altitude plains of the southwestern Arabian highlands including part of Saudi Arabia and the western highlands of Yemen. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/198cd419-64a9-4e42-8a19-dd7e389a81a3/109 Southwest Arabian highland xeric scrub -Jialiang Gao.jpg',
                      _id: '198cd419-64a9-4e42-8a19-dd7e389a81a3'
                    }
                  },
                  { _id: '7b9f807c-c40b-4f2b-abff-8e2ce672ebab' },
                  { title: 'Southwest Arabian Escarpment Shrublands and Woodlands' },
                  { regionId: '108' },
                  {
                    dek:
                      'This ecoregion is situated in the southwestern Arabian highlands and includes part of the Asir Mountains of Saudi Arabia and most of the western highlands of Yemen.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/757c03b9-3a47-4f63-a3fc-cfcc7cd70178/108 Southwest Arabian Escarpment shrublands and woodlands - KKWRC T Butynski.jpg',
                      _id: '757c03b9-3a47-4f63-a3fc-cfcc7cd70178'
                    }
                  },
                  { _id: 'd271d642-5985-4756-8d99-e58ff195fe8b' },
                  { title: 'Southwest Arabian Coastal Xeric Shrublands' },
                  { regionId: '107' },
                  {
                    dek:
                      'The western side of the Asir Mountains and Yemen highlands drop sharply to a low, flat coastal plain, the Tihamah, where this ecoregion is found.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/28e2862f-8bfc-4f2f-9bf4-b2777ac8cca0/107 Southwest Arabian coastal xeric shrublands - ZSL KKWRC.jpg',
                      _id: '28e2862f-8bfc-4f2f-9bf4-b2777ac8cca0'
                    }
                  },
                  { _id: '3f94ef27-5515-427a-9fc9-97742866a476' },
                  { title: 'Socotra Island Xeric Shrublands' },
                  { regionId: '105' },
                  {
                    dek:
                      'The ecoregion covers a small archipelago of islands east of the Horn of Africa and south of the Arabian Coast. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ff4a5130-13f1-4691-a08d-0e9171f74020/105 Socotra Island xeric shrublands - Boris Khvostichenko.JPG',
                      _id: 'ff4a5130-13f1-4691-a08d-0e9171f74020'
                    }
                  },
                  { _id: 'f2d95893-272a-4dc3-8448-304cc3d341b8' },
                  { title: 'Eritrean Coastal Desert' },
                  { regionId: '93' },
                  {
                    dek:
                      'The Eritrean Coastal Desert runs along the southern coast of the Red Sea from Balfair Assoli in Eritrea to Ras Bir near Obock in Djibouti.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d6347668-1408-4f15-bbfc-97a8a0ae7208/93-Gazelle_de_Soemmerring_(2)-CC-2014.jpg',
                      _id: 'd6347668-1408-4f15-bbfc-97a8a0ae7208'
                    }
                  },
                  { _id: '04beee74-d029-46bf-8c10-d7b29c6e55ed' },
                  { title: 'Djibouti Xeric Shrublands' },
                  { regionId: '92' },
                  {
                    dek:
                      'This ecoregion extends from the Sudanese-Eritrean border, south through Ethiopia to Djibouti, and eastwards into Somalia\u2014in the Somaliland region of the country, as well as extending into the center of Ethiopia. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d998427e-06ba-4255-884c-f985dfd498a3/92 Djibouti xeric shrublands - Gregoire Dubois.jpg',
                      _id: 'd998427e-06ba-4255-884c-f985dfd498a3'
                    }
                  },
                  { _id: 'ea6a1904-2e5c-45f0-a5a3-3f63246e7606' },
                  { title: 'Southwest Arabian Montane Woodlands and Grasslands' },
                  { regionId: '59' },
                  {
                    dek:
                      'This ecoregion is situated in the southwestern Arabian highlands above 2,000 m.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4983ea5d-b1d0-4964-8ae1-58613b4209fa/59 Southwest Arabian montane woodlands and grasslands - ZSL KKWRC.jpg',
                      _id: '4983ea5d-b1d0-4964-8ae1-58613b4209fa'
                    }
                  },
                  { _id: 'e3f8f930-a408-4e40-9822-ef6e1f136ee6' },
                  { title: 'South Arabian Fog Woodlands, Shrublands, and Dune' },
                  { regionId: '56' },
                  {
                    dek:
                      'This ecoregion covers much of the south eastern coasts of the Arabian Peninsula.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dfe94217-35db-408a-9a0f-b88e72e42e11/56 South Arabian fog woodlands, shrublands, and dune - Mary Palouse.jpg',
                      _id: 'dfe94217-35db-408a-9a0f-b88e72e42e11'
                    }
                  },
                  { _id: '8059d60a-8553-4a74-94af-19089dcd2edc' },
                  { title: 'Red Sea Mangroves' },
                  { regionId: '115' },
                  {
                    dek:
                      'This ecoregion consists of small scattered patches of mangrove stands along the Red Sea coast in Djibouti, Northern Somalia, Sudan, Egypt, Yemen, Saudi Arabia, and Eritrea.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bed222d8-0c6b-4227-b657-50a79c6d62e6/115 Red Sea mangroves - KKWRC T Butynski.jpg',
                      _id: 'bed222d8-0c6b-4227-b657-50a79c6d62e6'
                    }
                  },
                  { _id: '81a6db67-cb33-4962-add7-18d309270ce5' },
                  { title: 'Somali Montane Xeric Woodlands' },
                  { regionId: '106' },
                  {
                    dek:
                      'The ecoregion stretches along the coast of Somalia through the regions of Somaliland and Puntland.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9cda8d5f-d4aa-45e8-9028-eb8bd170535b/106 Somali montane xeric woodlands - Abdirisak 1.JPG',
                      _id: '9cda8d5f-d4aa-45e8-9028-eb8bd170535b'
                    }
                  },
                  { _id: 'eb98e1b8-c58e-489c-a533-1a129b37c974' },
                  { title: 'Hobyo Grasslands and Shrublands' },
                  { regionId: '95' },
                  {
                    dek:
                      'This ecoregion covers a long, narrow coastal strip in Somalia, extending from just south of Mogadishu near the town of Merka northwards to 250 km north of Hobyo.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/57cade1c-753d-4856-a983-2e451a3a9073/95 Hobyo grasslands and shrublands - Somali Net.jpg',
                      _id: '57cade1c-753d-4856-a983-2e451a3a9073'
                    }
                  },
                  { _id: 'bb6c319f-47de-46f0-a2df-0a6758a02fbf' },
                  { title: 'Horn of Africa Xeric Bushlands' },
                  { regionId: '45' },
                  { dek: 'This ecoregion occupies the majority of the Horn of Africa.' },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b350cb19-dcd1-422a-a656-70b181690c4e/45 Horn of Africa xeric bushlands - nomadPS.jpg',
                      _id: 'b350cb19-dcd1-422a-a656-70b181690c4e'
                    }
                  }
                ],
                stats: [
                  { number: '78,041 ', item: 'Total Land Area (1000 ha)' },
                  { number: '12', item: 'Number of Ecoregions' },
                  { number: '26%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Lake Turkana-Sudd Grasslands, Bushlands & Forests (AT21)',
                children: [],
                _id: '90b1a824-cee2-4207-8492-218c7aa05d88',
                value: 1000,
                parentId: '3e06b7bc-ff9e-4c1e-a439-da0ab8274bce',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eba32aba-0c21-4f79-a922-dee167191703/8 East African montane forests - D Olson_resized.jpg',
                    _id: 'eba32aba-0c21-4f79-a922-dee167191703'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/613d5310-532c-468c-974b-f76d6d0bbf47/12 Ethiopian montane forests - Sabine_s sunbird.jpg',
                    _id: '613d5310-532c-468c-974b-f76d6d0bbf47'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ef32d689-409c-4af1-9aa5-7116648dbaa0/49 Mandara Plateau woodlands - Amcaja.jpg',
                    _id: 'ef32d689-409c-4af1-9aa5-7116648dbaa0'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/47e3410f-a71d-449f-9110-7cab8319d434/51 Northern Acacia-Commiphora bushlands and thickets - D Olson.jpg',
                    _id: '47e3410f-a71d-449f-9110-7cab8319d434'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/16519da9-8264-46ce-9e62-efa225a07f45/Bioregion%20map-AT21-rev.jpg',
                content:
                  '<p>The Lake Turkana-Sudd Grasslands, Bushlands &amp; Forests bioregion is located in the Sub-Saharan Afrotropics. It is a very complex assemblage of 11 ecoregions -- Mandara Plateau Woodlands [1], East Sudanian Savanna [2], Sudd Flooded Grasslands [3], East African Montane Forests [4], Ethiopian Montane Grasslands and Woodlands [5], Ethiopian Montane Moorlands [6], Ethiopian Montane Forests [7], Northern Acacia-Commiphora Bushlands and Thickets [8], Masai Xeric Grasslands and Shrublands [9], Somali Acacia-Commiphora Bushlands and Thickets [10], and East African Montane Moorlands [11] -- stretching from northern Cameroon to Ethiopia. Fed by the White Nile in Sudan, the Sudd swamps overflow in the raining season, providing nutrients and water to one of the world\u2019s largest floodplains. This makes it particularly important for migrations of birds and large mammals. The land area of this bioregion, covering over 284 million hectares, mostly consists of subtropical grasslands and savanna but it also includes the Ethiopian mountain forests, grasslands, and shrublands.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/16519da9-8264-46ce-9e62-efa225a07f45/Bioregion%20map-AT21-rev.jpg"/><figcaption><span class="caption"><p>The Lake Turkana-Sudd Grasslands, Bushlands &amp; Forests bioregion is part of the Sub Saharan Afrotropics&nbsp;subrealm and is made up of 11 ecoregions: Mandara Plateau Woodlands [1], East Sudanian Savanna [2], Sudd Flooded Grasslands [3], East African Montane Forests [4], Ethiopian Montane Grasslands and Woodlands [5], Ethiopian Montane Moorlands [6], Ethiopian Montane Forests [7], Northern Acacia-Commiphora Bushlands and Thickets [8], Masai Xeric Grasslands and Shrublands [9], Somali Acacia-Commiphora Bushlands and Thickets [10], East African Montane Moorlands [11].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><ins><strong>Project Marketplace</strong></ins></a> to explore projects in this realm that need your support. Learn more about each of the \u200bSouth Red Sea &amp; Gulf of Alden Coastal Drylands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'd05e2eef-934d-4d5d-9943-3acdaabe25ba' },
                  { title: 'East African Montane Moorlands' },
                  { regionId: '78' },
                  {
                    dek:
                      'This ecoregion occupies the peaks of large mountains close to the equator in Kenya, northernmost Tanzania, and the border area between Kenya and Uganda.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/49ea837a-33ff-4b62-9245-07300a900394/EastAfricanMontaneMoorlands-WikiCommons3.jpg',
                      _id: '49ea837a-33ff-4b62-9245-07300a900394'
                    }
                  },
                  { _id: 'd2eff680-c868-437b-a3ac-7e1c99544fc1' },
                  { title: 'Somali Acacia-Commiphora Bushlands and Thickets' },
                  { regionId: '55' },
                  {
                    dek:
                      'This ecoregion occupies the majority of the Horn of Africa to the east of the Ethiopian Highlands, including the Ogaden Desert and northeast Kenyan semi-deserts.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/64311e86-daa6-4043-ac34-f92151da48d8/55 Somali Acacia-Commiphora bushlands and thickets - GD Robinson.jpg',
                      _id: '64311e86-daa6-4043-ac34-f92151da48d8'
                    }
                  },
                  { _id: '554d4a80-f69b-4e3d-89cd-5cb3c99ba0de' },
                  { title: 'East African Montane Forests' },
                  { regionId: '8' },
                  {
                    dek:
                      'This ecoregion encompasses moderate to high altitude habitats along a chain of isolated mountains flanking the Rift Valley.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eba32aba-0c21-4f79-a922-dee167191703/8 East African montane forests - D Olson_resized.jpg',
                      _id: 'eba32aba-0c21-4f79-a922-dee167191703'
                    }
                  },
                  { _id: '3a23d277-8afa-44df-9cb0-45f9adfda9f5' },
                  { title: 'Jos Plateau Forest-Grassland' },
                  { regionId: '82' },
                  {
                    dek:
                      'This ecoregion rises above the surrounding forest-grassland and savanna ecoregions of northern Nigeria. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/497f5f58-4078-43b2-ac1e-80cb2e6bdaee/82 Jos Plateau forest-grassland - TripAdvisor Chief Thomas.jpg',
                      _id: '497f5f58-4078-43b2-ac1e-80cb2e6bdaee'
                    }
                  },
                  { _id: '283ece76-c0f8-4c22-989b-b1772122a89a' },
                  { title: 'Ethiopian Montane Moorlands' },
                  { regionId: '80' },
                  {
                    dek:
                      'This ecoregion covers the higher parts of the Ethiopian Highlands Massif, from 3,000 m to over 4,500 m. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f281ed99-fa39-4ba8-bf37-258f1168b55a/80 Ethiopian montane moorlands - Gregoire Dubois.jpg',
                      _id: 'f281ed99-fa39-4ba8-bf37-258f1168b55a'
                    }
                  },
                  { _id: '62488c8d-709d-41ee-80fc-789a11d3b37e' },
                  { title: 'Ethiopian Montane Grasslands and Woodlands' },
                  { regionId: '79' },
                  {
                    dek:
                      'This ecoregion covers the majority of two Ethiopian Mountain massifs ranging from 1,800 to 3,000 m in elevation.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eff9ae26-30c5-4540-b38f-1de6b312a270/79 Ethiopian montane grasslands and woodlands - Gregoire Dubois.jpg',
                      _id: 'eff9ae26-30c5-4540-b38f-1de6b312a270'
                    }
                  },
                  { _id: 'df314ca6-893f-4629-ba33-8ab8b8e93c41' },
                  { title: 'Sudd Flooded Grasslands' },
                  { regionId: '74' },
                  {
                    dek:
                      'This ecoregion is located in South Sudan and comprises one of the largest swamps in Africa and is also one of the largest floodplain wetlands in the world\u2014about 600 km long and a similar distance wide. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/568d4c00-de43-44f8-8ced-b1983bef22c3/74 Sudd Flooded Grasslands - Yann Anthus-Bertrand.jpg',
                      _id: '568d4c00-de43-44f8-8ced-b1983bef22c3'
                    }
                  },
                  { _id: '31709373-1562-47b9-910c-675ad20dd87d' },
                  { title: 'Masai Xeric Grasslands and Shrublands' },
                  { regionId: '50' },
                  {
                    dek:
                      'This ecoregion is located in the northern part of Kenya and extreme southwestern Ethiopia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1a0c5c22-3f4c-4f84-97ef-fd4040f9fce0/50 Masai xeric grasslands and shrublands - Filiberto Strazzari.jpg',
                      _id: '1a0c5c22-3f4c-4f84-97ef-fd4040f9fce0'
                    }
                  },
                  { _id: '74f4aa29-1375-4b92-a28a-6292b3b2dd99' },
                  { title: 'Mandara Plateau Woodlands' },
                  { regionId: '49' },
                  {
                    dek:
                      'This ecoregion is located along the border between northeastern Nigeria and northwestern Cameroon.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ef32d689-409c-4af1-9aa5-7116648dbaa0/49 Mandara Plateau woodlands - Amcaja.jpg',
                      _id: 'ef32d689-409c-4af1-9aa5-7116648dbaa0'
                    }
                  },
                  { _id: '333598e2-daec-47b0-a14a-7bee13879172' },
                  { title: 'East Sudanian Savanna' },
                  { regionId: '43' },
                  {
                    dek:
                      'This ecoregion lies south of the Sahel in central and eastern Africa, and is divided into a western block and an eastern block by the Sudd Flooded Grasslands ecoregion.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1809b7d9-0e13-4355-92e5-02dc50fee775/43 East Sudanian savanna - monikap.jpg',
                      _id: '1809b7d9-0e13-4355-92e5-02dc50fee775'
                    }
                  },
                  { _id: '2a1f40ed-bca2-43f4-8d9d-b7d1ed0ed68c' },
                  { title: 'Ethiopian Montane Forests' },
                  { regionId: '12' },
                  {
                    dek:
                      'The forests that remain on the rugged highlands of Ethiopia support high species richness and endemism.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/613d5310-532c-468c-974b-f76d6d0bbf47/12 Ethiopian montane forests - Sabine_s sunbird.jpg',
                      _id: '613d5310-532c-468c-974b-f76d6d0bbf47'
                    }
                  },
                  { _id: '906d9321-9fc9-43ac-981f-a45ac7222975' },
                  { title: 'Northern Acacia-Commiphora Bushlands and Thickets' },
                  { regionId: '51' },
                  {
                    dek:
                      'This ecoregion extends from the southeast corner of Sudan and northeast Uganda, through much of lowland Kenya.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/47e3410f-a71d-449f-9110-7cab8319d434/51 Northern Acacia-Commiphora bushlands and thickets - D Olson.jpg',
                      _id: '47e3410f-a71d-449f-9110-7cab8319d434'
                    }
                  }
                ],
                stats: [
                  { number: '282,916 ', item: 'Total Land Area (1000 ha)' },
                  { number: '11', item: 'Number of Ecoregions' },
                  { number: '24%', item: 'Protection Target' },
                  { number: '7', item: 'Protection Level' }
                ]
              },
              {
                name: 'West Sudanian Savanna (AT20)',
                children: [],
                _id: 'decc43ec-8195-41b1-8853-f691ee058518',
                value: 1000,
                parentId: '3e06b7bc-ff9e-4c1e-a439-da0ab8274bce',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7c0d3563-2464-4395-ae9e-1814388646d3/62 West Sudanian savanna - JC Brito_resized.jpg',
                    _id: '7c0d3563-2464-4395-ae9e-1814388646d3'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3f27bc3a-dd11-4379-b58d-fcfa76dfec01/Bioregion%20map-AT20.jpg',
                content:
                  '<p>The West Sudanian Savanna bioregion, located in the Sub-Saharan Afrotropics, is made up of one large ecoregion \u2014 West Sudanian Savanna [1] \u2014 stretching from the coast of Senegal to the eastern border of Nigeria. It is an area of particular importance for large mammal migrations and includes a network of important national parks along the border between Benin and Burkina Faso. The land area of this bioregion is approximately 164 million hectares.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3f27bc3a-dd11-4379-b58d-fcfa76dfec01/Bioregion%20map-AT20.jpg"/><figcaption><span class="caption"><p>The West Sudanian Savanna bioregion is part of the Sub Saharan Afrotropics&nbsp;subrealm and is made up of a single ecoregion: West Sudanian Savanna [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about the \u200bWest Sudanian Savanna ecoregion below.</p>',
                ecoregions: [
                  { _id: '427f23ff-40e9-431a-b0fd-67b4977f7187' },
                  { title: 'West Sudanian Savanna' },
                  { regionId: '62' },
                  {
                    dek:
                      'This ecoregion stretches across West Africa from Senegal and The Gambia to the eastern border of Nigeria. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/60de5a76-533a-4a38-bc9c-501327a941d4/62-Sudanian savanna-CC-Marco Schmidt-2001.jpg',
                      _id: '60de5a76-533a-4a38-bc9c-501327a941d4'
                    }
                  }
                ],
                stats: [
                  { number: '164,303', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '16%', item: 'Protection Target' },
                  { number: '10', item: 'Protection Level' }
                ]
              },
              {
                name: 'Cape Verde Islands (AT24)',
                children: [],
                _id: '22fcd8ea-5f80-430d-b16b-fb7f34836c59',
                value: 1000,
                parentId: '3e06b7bc-ff9e-4c1e-a439-da0ab8274bce',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/93a0ff8d-e13c-4274-b533-619496b5803f/31 Cape Verde Islands dry forests - Ji Elle.jpg',
                    _id: '93a0ff8d-e13c-4274-b533-619496b5803f'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2abf47dd-4ed7-4859-84d1-3a8a888dd80d/Bioregion%20map-AT24.jpg',
                content:
                  '<p>The Cape Verde Islands bioregion, located in the Afrotropical realm, contains the group of ten volcanic islands off the coast of Senegal, is defined by one dry forest ecoregion \u2014 Cape Verde Islands Dry Forests (31) \u2014 with a total land area of approximately 450,000 hectares. Cape Verde\'s isolation has resulted in the islands having a number of endemic species, particularly birds and reptiles, many of which are endangered. The islands are also an important breeding area for seabirds.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2abf47dd-4ed7-4859-84d1-3a8a888dd80d/Bioregion%20map-AT24.jpg"/><figcaption><span class="caption"><p>The Cape Verde Islands bioregion is part of the Sub Saharan Afrotropics&nbsp;subrealm and is made up of a single ecoregion: (1) Cape Verde Islands Dry Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of the Afrotropics. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about the \u200bCape Verde Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: 'c6a484d7-fe55-4766-831f-a987a5c93b90' },
                  { title: 'Cape Verde Islands Dry Forests' },
                  { regionId: '31' },
                  {
                    dek:
                      'The Cape Verde Islands consist of ten islands and five islets and are located in the eastern Atlantic Ocean approximately 500 km from the coast of Senegal, West Africa.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9d393876-7c79-4090-90db-c26bc7dd9129/31 Cape Verde Islands dry forests - Ji Elle.jpg',
                      _id: '9d393876-7c79-4090-90db-c26bc7dd9129'
                    }
                  }
                ],
                stats: [
                  { number: '457', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '11%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Afrotropics',
            value: 714
          }
        ],
        parentId: 'top',
        _id: 'Afrotropics',
        value: 833
      },
      {
        name: 'Antarctica',
        children: [
          {
            _id: '1b676594-d7c1-4d6c-b73f-fe0fbc47ff8c',
            name: 'Antarctic Continent & Islands',
            children: [
              {
                name: 'Subantarctic Antipodes Islands (AN4)',
                children: [],
                _id: 'f25e4b2e-6217-4b52-b73e-709234b15a16',
                value: 1000,
                parentId: '1b676594-d7c1-4d6c-b73f-fe0fbc47ff8c',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f2ae3217-b60f-4311-aa2b-ed99f8f44053/196-Royal Penguins rookery-CC-M. Murphy-2006.JPG',
                    _id: 'f2ae3217-b60f-4311-aa2b-ed99f8f44053'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/03015cbf-9262-4001-9fed-8017960e15b8/AN4-Antarctica-antipodes.jpg',
                content:
                  '<p>The Antipodes bioregion lies just below New Zealand. A group of rocky, volcanic islands dominated by one tundra ecoregion \u2013 Antipodes Subantarctic Islands Tundra (196) \u2013 this bioregion is an important breeding site for an array of birds. The islands are surrounded by the Moutere Mahue marine reserve.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/03015cbf-9262-4001-9fed-8017960e15b8/AN4-Antarctica-antipodes.jpg"/><figcaption><span class="caption"><p>The Subantarctic Antipodes Islands bioregion is part of the Antarctic Continent &amp; Islands subrealm and is made up of one ecoregion: Antipodes Subantarctic Islands Tundra [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Antarctica. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Subantarctic Antipodes Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: 'cfad33b3-9338-471c-8120-8c542a92a203' },
                  { title: 'Antipodes Subantarctic Islands Tundra' },
                  { regionId: '196' },
                  {
                    dek:
                      'This ecoregion consist of five island groups scattered across the cold, wet, and windy Southern Ocean south of New Zealand and Australia\u2015Bounty Islands, Auckland Islands, Antipodes Islands, Campbell Island, and Macquarie Island.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0e4df9d2-e31c-43d8-95e1-de5e69786648/196 Antipodes Subantarctic Islands tundra - M Murphy.JPG',
                      _id: '0e4df9d2-e31c-43d8-95e1-de5e69786648'
                    }
                  }
                ],
                stats: [
                  { number: '88', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '100%', item: 'Protection Target' },
                  { number: '10', item: 'Protection Level' }
                ]
              },
              {
                name: 'Subantarctic Indian Ocean Islands (AN3)',
                children: [],
                _id: '0e6b5e9f-c862-450a-8e11-05ae66e3dd0d',
                value: 1000,
                parentId: '1b676594-d7c1-4d6c-b73f-fe0fbc47ff8c',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/17aa34be-5671-4300-b089-8d52e84deb37/Glacier-Kerguelen-Islands B Navez.jpg',
                    _id: '17aa34be-5671-4300-b089-8d52e84deb37'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4e55f8ea-731f-43e1-a1fd-e5d99c6e9cdb/133 Heard Island cc.jpg',
                    _id: '4e55f8ea-731f-43e1-a1fd-e5d99c6e9cdb'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e02cad04-15df-407a-a31b-c9e381573f35/AN3-Antarctica-s%20islands.jpg',
                content:
                  '<p>The Subantarctic Indian Ocean bioregion consists of four island groupings in the South Indian Ocean, about halfway between the Cape of Good Hope in South Africa and the Antarctic mainland. The islands are unified by one tundra ecoregion \u2013 Southern Indian Ocean Islands Tundra [133] \u2013 and surrounding marine areas.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e02cad04-15df-407a-a31b-c9e381573f35/AN3-Antarctica-s%20islands.jpg"/><figcaption><span class="caption"><p>The Subantarctic Indian Ocean Islands bioregion is part of the Antarctic Continent &amp; Islands subrealm and is made up of one ecoregion: Southern Indian Ocean Islands Tundra [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Antarctica. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Subantarctic Indian Ocean Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: 'fbfaf90a-805c-45d0-80e7-043ddc067ddb' },
                  { title: 'Southern Indian Ocean Islands Tundra' },
                  { regionId: '133' },
                  {
                    dek:
                      'This ecoregion encompasses five island groups in the southern Indian Ocean (or Southern Ocean): Prince Edward (South Africa), Crozet, Kerguelen (France), and Heard and McDonald Islands (Australia).'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/21fdcdac-8628-4098-bdb2-2b3d45ab52c5/antarctic.jpg',
                      _id: '21fdcdac-8628-4098-bdb2-2b3d45ab52c5'
                    }
                  }
                ],
                stats: [
                  { number: 'N/A', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: 'N/A', item: 'Protection Target' },
                  { number: 'N/A', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Antarctic Peninsula & Scotia Sea (AN2)',
                children: [],
                _id: '58be31bb-f423-475f-b5c6-83fb6ec9f1a1',
                value: 1000,
                parentId: '1b676594-d7c1-4d6c-b73f-fe0fbc47ff8c',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d1018086-af38-4033-8b6c-2511402d84e5/CentralSouthAntarcticPeninsulaTundra-DreamstimeCC2.jpg',
                    _id: 'd1018086-af38-4033-8b6c-2511402d84e5'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/57933fc4-dc62-4246-b144-20f8d0f3585d/ScotiaSeaIslandsTundra-WikiCommons_resized.jpg',
                    _id: '57933fc4-dc62-4246-b144-20f8d0f3585d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ca3cb4a7-64f0-443c-bc98-3af01fa1665c/SouthOrkneyIslandsTundra-TripAdvisorCC.jpg',
                    _id: 'ca3cb4a7-64f0-443c-bc98-3af01fa1665c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6311f468-d8f8-4b5a-9cb4-33f259391690/CentralSouthAntarcticPeninsulaTundra-DreamstimeCC.jpg',
                    _id: '6311f468-d8f8-4b5a-9cb4-33f259391690'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5c500385-86de-48ed-a2d7-6b0eb3f2a89a/AN2-Antarctica-scotia.jpg',
                content:
                  '<p>The Antarctic Peninsula bioregion protrudes 1,300 km from West Antarctica towards the Tierra del Fuego, the southernmost tip of South America. The rocky coasts of the peninsula have the mildest climate in Antarctica and are free of snow in the summer months, supporting an abundance of land and marine biodiversity. The bioregion contains two tundra ecoregions \u2013 &nbsp;Scotia Sea Islands Tundra [1], South Orkney Islands Tundra [2] \u2013 including the Scotia Sea, Orkney Islands, South Georgia and South Sandwich Islands.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5c500385-86de-48ed-a2d7-6b0eb3f2a89a/AN2-Antarctica-scotia.jpg"/><figcaption><span class="caption"><p>The Antarctic Peninsula &amp; Scotia Sea bioregion is part of the Antarctic Continent &amp; Islands subrealm and is made up of two ecoregions: &nbsp;Scotia Sea Islands Tundra [1], South Orkney Islands Tundra [2].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Antarctica. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Antarctic Peninsula &amp; Scotia Sea ecoregions below.</p>',
                ecoregions: [
                  { _id: 'afe7ff77-6c4c-433b-9647-4cac062a5a75' },
                  { title: 'South Orkney Islands Tundra' },
                  { regionId: '131' },
                  {
                    dek:
                      'This is the most northerly of all the Antarctic ecoregions, separated from the closest ecoregion by 600 km of water and with a distinctive climate and rich biodiversity. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ca3cb4a7-64f0-443c-bc98-3af01fa1665c/SouthOrkneyIslandsTundra-TripAdvisorCC.jpg',
                      _id: 'ca3cb4a7-64f0-443c-bc98-3af01fa1665c'
                    }
                  },
                  { _id: 'c156d44e-a609-4421-a97a-12334039aae1' },
                  { title: 'Scotia Sea Islands Tundra' },
                  { regionId: '129' },
                  {
                    dek:
                      'This ecoregion is made up of several islands across three main groups. These are some of the wildest and most inhospitable islands on Earth.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/57933fc4-dc62-4246-b144-20f8d0f3585d/ScotiaSeaIslandsTundra-WikiCommons_resized.jpg',
                      _id: '57933fc4-dc62-4246-b144-20f8d0f3585d'
                    }
                  }
                ],
                stats: [
                  { number: 'N/A', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: 'N/A', item: 'Protection Target' },
                  { number: 'N/A', item: 'Protection Level' }
                ]
              },
              {
                name: 'Continental Antarctica (AN1)',
                children: [],
                _id: '463863d5-d9ff-4f48-b582-4f443c0f28e3',
                value: 1000,
                parentId: '1b676594-d7c1-4d6c-b73f-fe0fbc47ff8c',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/11bf189b-f935-4920-abce-9e090d4e72b1/130 South Antarctic Peninsula tundra - euphro.jpg',
                    _id: '11bf189b-f935-4920-abce-9e090d4e72b1'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/22471a47-2d58-4e6b-8e6f-1779c4dd3e50/132 South Victoria Land tundra - Aleks Terauds.jpg',
                    _id: '22471a47-2d58-4e6b-8e6f-1779c4dd3e50'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/29239251-2c73-44c4-8814-e76364829549/134 Transantarctic Mountains tundra - Hannes Grobe.jpg',
                    _id: '29239251-2c73-44c4-8814-e76364829549'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d7cb5e50-eed8-45a2-9572-41a7fb9122fa/AN1-Antarctica%20main.jpg',
                content:
                  '<p>The main Antarctica bioregion includes the entirety of the Antarctic continent, with the exception of the Antarctic Peninsula. It consists of ice-covered land, glaciers, and coastal ice sheets but also includes a variety of coastal tundra habitats important for biodiversity. The bioregion includes 15 tundra ecoregions altogether \u2013 Ellsworth Mountain Tundra [1], Marie Byrd Land Tundra [2]. Transantarctic Mountains Tundra, [3] South Victoria Land Tundra [4], North Victoria Land Tundra [5], Adelie Land Tundra [6], East Antarctic Tundra [7], Prince Charles Mountains Tundra [8], Enderby Land Tundra [9], Dronning Maud Land Tundra [10], South Antarctic Peninsula Tundra [11], Central South Antarctic Peninsula Tundra [12], Northeast Antarctic Peninsula Tundra [13], Northwest Antarctic Peninsula Tundra [14], Ellsworth Land Tundra [15] \u2013 and adjacent marine areas in the Southern Ocean, which shelter an abundance of wildlife, including penguins, blue whales, orcas, colossal squids, fur seals, many endemic fish species, and the nesting ground for over 100 million birds.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d7cb5e50-eed8-45a2-9572-41a7fb9122fa/AN1-Antarctica%20main.jpg"/><figcaption><span class="caption"><p>The Continental Antarctica Bioregion is part of the Antarctic Continent &amp; Islands subrealm and comprises 15 ecoregions: Ellsworth Mountain Tundra [1], Marie Byrd Land Tundra [2]. Transantarctic Mountains Tundra, [3] South Victoria Land Tundra [4], North Victoria Land Tundra [5], Adelie Land Tundra [6], East Antarctic Tundra [7], Prince Charles Mountains Tundra [8], Enderby Land Tundra [9], Dronning Maud Land Tundra [10], South Antarctic Peninsula Tundra [11], Central South Antarctic Peninsula Tundra [12], Northeast Antarctic Peninsula Tundra [13], Northwest Antarctic Peninsula Tundra [14], Ellsworth Land Tundra [15].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Antarctica. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Continental Antarctica ecoregions below.</p>',
                ecoregions: [
                  { _id: 'd6ba4848-c3fb-4266-b76d-7de203d330c0' },
                  { title: 'Northwest Antarctic Peninsula Tundra' },
                  { regionId: '127' },
                  {
                    dek:
                      'This ecoregion is one of the most biologically diverse of all the Antarctic ecoregions. It includes all of the ice-free land on the northern tip and western side of the Antarctic Peninsula. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8d1d4b13-aa54-4df7-aa5c-5ca87744cb8a/127 Northwest Antarctic Peninsula tundra - Liam Quinn.jpg',
                      _id: '8d1d4b13-aa54-4df7-aa5c-5ca87744cb8a'
                    }
                  },
                  { _id: '664343e5-9687-4b70-a1e7-2ba9189da518' },
                  { title: 'Northeast Antarctic Peninsula Tundra' },
                  { regionId: '126' },
                  {
                    dek:
                      'This ecoregion is situated on the north-eastern tip of the Antarctic Peninsula and includes parts of Deception Island, parts of Joinville Island, and parts of the mainland Antarctic Peninsula.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8fccda71-4bef-4239-ad50-413e8f2f5e14/126 Northeast Antarctic Peninsula tundra - franap69.jpg',
                      _id: '8fccda71-4bef-4239-ad50-413e8f2f5e14'
                    }
                  },
                  { _id: '7a744af2-8853-4f7d-996b-75df676b3b84' },
                  { title: 'North Victoria Land Tundra' },
                  { regionId: '125' },
                  {
                    dek:
                      'This ecoregion is the third largest ecoregion in Antarctica consisting of large areas of connected permanently ice-free land, much of it forming deep valleys and high ridges.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1d61542a-72bf-4940-8ff3-46a4a0488a1f/125 North Victoria Land tundra - Aleks Terauds.jpg',
                      _id: '1d61542a-72bf-4940-8ff3-46a4a0488a1f'
                    }
                  },
                  { _id: '5e03b033-138a-43c9-a77b-448710581758' },
                  { title: 'Central South Antarctic Peninsula Tundra' },
                  { regionId: '118' },
                  {
                    dek:
                      'This ecoregion sits in the middle of the Antarctic Peninsula, between the Northwest Antarctic Peninsula Tundra and South Antarctic Peninsula Tundra ecoregions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6311f468-d8f8-4b5a-9cb4-33f259391690/CentralSouthAntarcticPeninsulaTundra-DreamstimeCC.jpg',
                      _id: '6311f468-d8f8-4b5a-9cb4-33f259391690'
                    }
                  },
                  { _id: 'e6b71678-2193-479c-8943-960671d6d5a9' },
                  { title: 'Transantarctic Mountains Tundra ' },
                  { regionId: '134' },
                  {
                    dek:
                      'This ecoregion is by the far the largest of all the Antarctic ecoregions, at almost 20,000 km. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dc11a400-41ad-4d55-8dbc-fc544bcf91b9/134-Transantarctic_mountain_CC-Hannes Grobe-1998.jpg',
                      _id: 'dc11a400-41ad-4d55-8dbc-fc544bcf91b9'
                    }
                  },
                  { _id: '73f97dbc-378f-4281-9b21-4030b9320d23' },
                  { title: 'South Victoria Land Tundra' },
                  { regionId: '132' },
                  {
                    dek:
                      'This ecoregion has large areas of connected ice-free land, including the Dry Valleys, which are known as one of the most extreme environments on the planet.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/22471a47-2d58-4e6b-8e6f-1779c4dd3e50/132 South Victoria Land tundra - Aleks Terauds.jpg',
                      _id: '22471a47-2d58-4e6b-8e6f-1779c4dd3e50'
                    }
                  },
                  { _id: '160f4b0a-f5a6-4240-9057-c58adbcffc3d' },
                  { title: 'South Antarctic Peninsula Tundra' },
                  { regionId: '130' },
                  {
                    dek:
                      'This ecoregion is made up of the southerly most ice-area area of the Antarctic Peninsula.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/11bf189b-f935-4920-abce-9e090d4e72b1/130 South Antarctic Peninsula tundra - euphro.jpg',
                      _id: '11bf189b-f935-4920-abce-9e090d4e72b1'
                    }
                  },
                  { _id: 'f64a464a-3c79-4f2c-aa6b-b9d9c93e5972' },
                  { title: 'Prince Charles Mountains Tundra' },
                  { regionId: '128' },
                  {
                    dek:
                      'This ecoregion contains the ice-free area between the Enderby Land Tundra ecoregion and the western extent of the East Antarctica tundra ecoregion. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9c4022b1-b232-4994-8dae-1cc96d47dbbf/128 Prince Charles Mountains tundra - Claurabert.jpg',
                      _id: '9c4022b1-b232-4994-8dae-1cc96d47dbbf'
                    }
                  },
                  { _id: 'bcd1c761-b41d-4761-8dc0-1eb29367543c' },
                  { title: 'Marie Byrd Land Tundra' },
                  { regionId: '124' },
                  {
                    dek:
                      'This ecoregion is one of the most remote and isolated ecoregions on the continent consisting of patchily distributed ice-free land across a relatively broad area.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2461fc5f-2321-484f-bf86-501541f4896d/124 Marie Byrd Land tundra - Jasmine Lee.jpg',
                      _id: '2461fc5f-2321-484f-bf86-501541f4896d'
                    }
                  },
                  { _id: 'e82bd083-7066-469b-a0d3-40d9ffc1b5db' },
                  { title: 'Enderby Land Tundra' },
                  { regionId: '123' },
                  {
                    dek:
                      'This ecoregion is one of the more coastal ecoregions in Antarctica, consisting of rather patchily distributed permanently ice-free land, particularly along the coastal margins.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b33f381a-fa98-4567-9d3d-488a106e49b1/123 Enderby lLnd tundra - Wikiwand.jpg',
                      _id: 'b33f381a-fa98-4567-9d3d-488a106e49b1'
                    }
                  },
                  { _id: '33f9e71b-cc81-4d12-82f7-d55982fcbe25' },
                  { title: 'Ellsworth Mountains Tundra' },
                  { regionId: '122' },
                  {
                    dek:
                      'This ecoregion are made up of the permanently ice-free land in the mountainous and inhospitable region to the south of the Antarctic Peninsula.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8c11cb02-5726-4afc-8d1d-0d6dcdb0844d/122-Sentinel_Range,_Ellsworth_Mountains,_Antarctica-CC-NASA:Michael Studinger-2012.jpg',
                      _id: '8c11cb02-5726-4afc-8d1d-0d6dcdb0844d'
                    }
                  },
                  { _id: '673de9ad-4ee9-4fd5-98e3-9e021e84309e' },
                  { title: 'Ellsworth Land Tundra' },
                  { regionId: '121' },
                  {
                    dek:
                      'This ecoregion lies between the Bellingshausen and Amundsen Seas and includes the area traditionally known as Ellsworth Land, Thurston Island, and a number of small offshore islands in the Amundsen Sea.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/edacc5f8-1af5-4fdb-a6f1-e19352963f79/121 Ellsworth Land trundra - NASA.jpg',
                      _id: 'edacc5f8-1af5-4fdb-a6f1-e19352963f79'
                    }
                  },
                  { _id: '86876290-4354-42ae-b862-f5de27d4415f' },
                  { title: 'East Antarctic Tundra' },
                  { regionId: '120 ' },
                  {
                    dek:
                      'This ecoregion is composed of ice-free patches of land distributed along of the east Antarctic coastline, stretching for over 2,500 km.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c662446c-645e-4d0e-a4c9-da4efffeb37a/120 East Antarctic tundra - Aleks Terauds.jpg',
                      _id: 'c662446c-645e-4d0e-a4c9-da4efffeb37a'
                    }
                  },
                  { _id: '8a8028fa-6714-43f9-9e88-6bdcf61b54cf' },
                  { title: 'Dronning Maud Land Tundra' },
                  { regionId: '119' },
                  {
                    dek:
                      'This ecoregion is a largely inland system of ice-free areas that are patchily distributed at the western end and tend to be clumped and more connected, with larger ice-free areas, at the eastern end. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/893e6661-b709-419f-8f15-58bf5bcce250/119 Dronning Maud Land tundra - \u0421\u043e\u043b\u043e\u0432\u044c\u044f\u043d\u043e\u0432\u0430 \u0418\u0440\u0438\u043d\u0430.jpg',
                      _id: '893e6661-b709-419f-8f15-58bf5bcce250'
                    }
                  },
                  { _id: '04211bd5-1a9f-412c-87e2-12d3637ddbcf' },
                  { title: 'Adelie Land Tundra' },
                  { regionId: '117' },
                  {
                    dek:
                      'This is the smallest ecoregion in the Antarctic continental bioregion, comprised of small patches of permanently ice-free land, largely distributed along the coast.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a588b81f-2229-4300-b972-f611dd95811a/117 Adelie Land tundra - Samuel Blanc.jpg',
                      _id: 'a588b81f-2229-4300-b972-f611dd95811a'
                    }
                  }
                ],
                stats: [
                  { number: 'N/A', item: 'Total Land Area (1000 ha)' },
                  { number: '15', item: 'Number of Ecoregions' },
                  { number: 'N/A', item: 'Protection Target' },
                  { number: 'N/A', item: 'Protection level' }
                ]
              }
            ],
            parentId: 'Antarctica',
            value: 1000
          }
        ],
        parentId: 'top',
        _id: 'Antarctica',
        value: 166
      },
      {
        name: 'Australasia',
        children: [
          {
            _id: '959d8017-366d-4b0d-96b4-8947a556cfd4',
            name: 'New Zealand',
            children: [
              {
                name: 'Lord Howe & Norfolk Islands (AU2)',
                children: [],
                _id: 'eee451d0-25a4-4480-810f-dca9a7f51e66',
                value: 1000,
                parentId: '959d8017-366d-4b0d-96b4-8947a556cfd4',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1798c2b8-487f-4119-a99e-3582abb93f00/142 Lord Howe Island subtropical forests - Kahuroha Black Diamond Images.jpg',
                    _id: '1798c2b8-487f-4119-a99e-3582abb93f00'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/707e61d9-1a12-4345-9a95-f8ce31c083f6/147-Norfolk-Island-Pines-CC-2006.jpg',
                    _id: '707e61d9-1a12-4345-9a95-f8ce31c083f6'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0d95d06e-4d88-4ef9-962f-3893552a4cda/Bioregion%20map-AU2.jpg',
                content:
                  '<p>The Lord Howe &amp; Norfolk bioregion, located in the Australasia realm, is situated between Australia and New Zealand in the Tasman Sea. This small group of islands is dominated by subtropical forests and is designated as its own marine province. The bioregion contains two ecoregions \u2013 Lord Howe Island Subtropical Forests [1], Norfolk Island Subtropical Forests [2].&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0d95d06e-4d88-4ef9-962f-3893552a4cda/Bioregion%20map-AU2.jpg"/><figcaption><span class="caption"><p>The Lord Howe &amp; Norfolk Islands bioregion is part of the New Zealand subrealm and is made up of two ecoregions: Lord Howe Island Subtropical Forests [1], Norfolk Island Subtropical Forests [2].&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bLord Howe &amp; Norfolk Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'eef7f791-b638-44c6-a2ed-330120907e8d' },
                  { title: 'Norfolk Island Subtropical Forests' },
                  { regionId: '147' },
                  {
                    dek:
                      'The Norfolk Island group is situated on a submarine ridge that runs between New Caledonia and the North Island of New Zealand.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/16f32f33-fb7f-4ec3-b9c5-185b0330e583/147 Norfolk Island subtropical forests - Peter James McNally.jpg',
                      _id: '16f32f33-fb7f-4ec3-b9c5-185b0330e583'
                    }
                  },
                  { _id: '5b59c467-c84a-46f1-b6b6-a2e51b91188b' },
                  { title: 'Lord Howe Island Subtropical Forests' },
                  { regionId: '142' },
                  {
                    dek:
                      'The Lord Howe Island Group are the remnants of ancient volcanoes, and the main island, Lord Howe Island, is small.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1798c2b8-487f-4119-a99e-3582abb93f00/142 Lord Howe Island subtropical forests - Kahuroha Black Diamond Images.jpg',
                      _id: '1798c2b8-487f-4119-a99e-3582abb93f00'
                    }
                  }
                ],
                stats: [
                  { number: '6', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '99%', item: 'Protection Target' },
                  { number: '5', item: 'Protection Level' }
                ]
              },
              {
                name: 'New Zealand (AU1)',
                children: [],
                _id: '1ed1af63-e856-46ac-ad86-88a0fb282552',
                value: 1000,
                parentId: '959d8017-366d-4b0d-96b4-8947a556cfd4',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6307ffe8-1e18-4fed-a2ad-0b6ba41d9076/Autumn landscape, lake Wanaka, New Zealand dreamstime_xxl_40624193 Large.jpeg',
                    _id: '6307ffe8-1e18-4fed-a2ad-0b6ba41d9076'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/24719239-68ee-4e39-bb0d-d5cfad340be5/RakiuraIIslandTemperateForests-Dreamstime.jpg',
                    _id: '24719239-68ee-4e39-bb0d-d5cfad340be5'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7ca1ebad-ec18-490a-83ea-dce6c7f80692/194-Southern_Alps_-CC-Lasse Holst Hansen-2013.jpg',
                    _id: '7ca1ebad-ec18-490a-83ea-dce6c7f80692'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aba6d624-b78d-4dbd-810b-4b1dbab6c1bf/171 New Zealand North Island temperate forests - Alistair McLellan.jpg',
                    _id: 'aba6d624-b78d-4dbd-810b-4b1dbab6c1bf'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e42dd173-55cd-4a8a-a917-0913f7f0434b/175 Richmond temperate forests - Simon Steinberger.jpg',
                    _id: 'e42dd173-55cd-4a8a-a917-0913f7f0434b'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5c2e08eb-1b15-4fd5-ab77-6918fc8d1994/Bioregion%20map-AU1.jpg',
                content:
                  '<p>The New Zealand bioregion, located in the Australasia realm, incorporates the country\u2019s two main islands and several hundred small surrounding islands. It does not include territorial claims in Polynesia or Antarctica. The North Island and the west coast of the South Island are dominated by temperate broadleaf forests. A large mountain range divides the South Island, with mountain grasslands at higher elevations and tussock grasslands at lower elevations on the east side of the island. The bioregion contains 12 ecoregions \u2013 Kermadec Islands Subtropical Moist Forests [1], Northland Temperate Kauri Forests [2], New Zealand North Island Temperate Forests [3], Richmond Temperate Forests [4], Nelson Coast Temperate Forests [5], Westland Temperate Forests [6], Fiordland Temperate Forests [7], New Zealand South Island Montane Grasslands [8], Canterbury-Otago Tussock Grasslands [9], New Zealand South Island Temperate Forests [10], Rakiura Island Temperate Forests [11], Chatham Island Temperate Forests [12] \u2013 and several large alpine lakes. The total area of this bioregion is nearly 27 million hectares, not including adjacent marine areas.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5c2e08eb-1b15-4fd5-ab77-6918fc8d1994/Bioregion%20map-AU1.jpg"/><figcaption><span class="caption"><p>The New Zealand bioregion is part of the New Zealand subrealm and is made up of 12 ecoregions: Kermadec Islands Subtropical Moist Forests [1], Northland Temperate Kauri Forests [2], New Zealand North Island Temperate Forests [3], Richmond Temperate Forests [4], Nelson Coast Temperate Forests [5], Westland Temperate Forests [6], Fiordland Temperate Forests [7], New Zealand South Island Montane Grasslands [8], Canterbury-Otago Tussock Grasslands [9], New Zealand South Island Temperate Forests [10], Rakiura Island Temperate Forests [11], Chatham Island Temperate Forests [12].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bNew Zealand ecoregions below.</p>',
                ecoregions: [
                  { _id: '186def48-c437-4819-bb64-065f7eb6e316' },
                  { title: 'Chatham Island Temperate Forests' },
                  { regionId: '167' },
                  {
                    dek:
                      'The remote Chatham Islands are 800 km east of the South Island of New Zealand. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0543f88b-0e18-468d-b727-f428be972e61/167-Schist_formations,_Kaingaroa,_Chatham_Islands-CC-M Newman-2018.jpg',
                      _id: '0543f88b-0e18-468d-b727-f428be972e61'
                    }
                  },
                  { _id: 'b63479e6-d466-44b3-90ab-c2a7344fd9d1' },
                  { title: 'Kermadec Islands Subtropical Moist  Forests' },
                  { regionId: '624' },
                  {
                    dek:
                      'The remote Kermadec archipelago occurs in an island chain of 13 small islands 1,000 km northeast of North Cape, New Zealand. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/33625ffe-a3e3-4817-ac98-3fd5409e6d0a/624 Kermadec Islands subtropical moist forests Lawrie Mead.jpg',
                      _id: '33625ffe-a3e3-4817-ac98-3fd5409e6d0a'
                    }
                  },
                  { _id: '7a836e35-e7ab-4764-a012-f7916905f0df' },
                  { title: 'New Zealand South Island Montane Grasslands' },
                  { regionId: '194' },
                  {
                    dek:
                      'This ecoregion encompasses the Southern Alps, the highest alpine region in New Zealand, with snow and ice fields, as well as a variety of alpine habitats. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cc30c85e-622a-4f71-906f-8643fc53e6b3/194 New Zealand South Island montane grasslands - Bernd Hildebrandt.jpg',
                      _id: 'cc30c85e-622a-4f71-906f-8643fc53e6b3'
                    }
                  },
                  { _id: '440afb08-2981-4f5d-abf1-4f1ea62e997b' },
                  { title: 'Canterbury-Otago Tussock Grasslands' },
                  { regionId: '190' },
                  { dek: 'This ecoregion lies in the rain shadow of the Southern Alps.' },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/16c65d65-cc78-476f-8ead-4078e084261c/CanterburOtagoGussockGrasslands-WikiCommons.jpg',
                      _id: '16c65d65-cc78-476f-8ead-4078e084261c'
                    }
                  },
                  { _id: 'dcda7901-c0db-41d1-96d5-576f55246e78' },
                  { title: 'Westland Temperate Forests' },
                  { regionId: '180' },
                  {
                    dek:
                      'This high rainfall ecoregion covers the narrow lower-elevation forests of New Zealand\u2019s South Island central coast. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/574d42b1-1023-47fb-ad71-36033564405f/180 Westland temperate forests - Bettina Damgaard.jpg',
                      _id: '574d42b1-1023-47fb-ad71-36033564405f'
                    }
                  },
                  { _id: '11ebaee3-2ed9-4570-a8f3-b1c9a96fb31c' },
                  { title: 'Richmond Temperate Forests' },
                  { regionId: '175' },
                  {
                    dek:
                      'The imposing, hand-sized Kaikoura giant weta conotes the great age and isolation of the plants and animals of New Zealand and the Richmond forests. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e42dd173-55cd-4a8a-a917-0913f7f0434b/175 Richmond temperate forests - Simon Steinberger.jpg',
                      _id: 'e42dd173-55cd-4a8a-a917-0913f7f0434b'
                    }
                  },
                  { _id: '30b09207-b5c7-4033-8058-2c20fa555e13' },
                  { title: 'Rakiura Island Temperate Forests' },
                  { regionId: '174' },
                  {
                    dek:
                      'Rakiura Island (Stewart) just south of the South Island of New Zealand supports one of the most southern temperate rainforests in the world.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/85f47975-8aa1-47c4-b6f4-fe54baebc9b1/RakiuraIslandTemperateForests-WikiCommons.jpg',
                      _id: '85f47975-8aa1-47c4-b6f4-fe54baebc9b1'
                    }
                  },
                  { _id: '766ce1c2-c5a0-4377-bb9f-6bd0fc56f9a8' },
                  { title: 'Northland Temperate Kauri Forests' },
                  { regionId: '173' },
                  {
                    dek:
                      'Many rare, endemic, and threatened species occur on offshore islands, such as the Three Kings Islands and the Poor Knights Islands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2ac42b90-a3e6-4bf5-a1dd-0418f3018a52/173 Northland temperate kauri forests - Simon Steinberger.jpg',
                      _id: '2ac42b90-a3e6-4bf5-a1dd-0418f3018a52'
                    }
                  },
                  { _id: '5b910efa-129b-43c7-9f9b-25ab01826ca0' },
                  { title: 'New Zealand South Island temperate forests' },
                  { regionId: '172' },
                  {
                    dek:
                      'This remains the largest native forest on the east coast of South Island, New Zealand.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/da0c4f9d-51e2-40c6-8dec-dd183f4b1d56/172 New Zealand South Island temperate forests - Martyn Cook.jpg',
                      _id: 'da0c4f9d-51e2-40c6-8dec-dd183f4b1d56'
                    }
                  },
                  { _id: 'd5c5e001-a0b7-4d39-995f-e5ac40f0aff4' },
                  { title: 'New Zealand North Island temperate forests' },
                  { regionId: '171' },
                  {
                    dek:
                      'In the temperate forests of the North Island, dense podocarp and mixed beech/podocarp forests covered lower elevation landscapes. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aba6d624-b78d-4dbd-810b-4b1dbab6c1bf/171 New Zealand North Island temperate forests - Alistair McLellan.jpg',
                      _id: 'aba6d624-b78d-4dbd-810b-4b1dbab6c1bf'
                    }
                  },
                  { _id: 'c2c245f8-371e-4a29-919a-2d42124a4ff4' },
                  { title: 'Nelson Coast temperate forests' },
                  { regionId: '170' },
                  {
                    dek:
                      'The temperate rainforests of the Nelson coast are a globally rare habitat type.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/21227cb7-6457-4a7f-b886-52ea5731c242/170 Nelson Coast temperate forests - Bowhaz.jpg',
                      _id: '21227cb7-6457-4a7f-b886-52ea5731c242'
                    }
                  },
                  { _id: 'cfbc588d-97ae-4f7e-8204-44a3c9604976' },
                  { title: 'Fiordland temperate forests' },
                  { regionId: '169' },
                  {
                    dek:
                      'Fiordland at the southwest corner of New Zealand\u2019s South Island is notable for some of the highest levels of endemism of any temperate or alpine area in the world. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f157a3f7-540c-4332-900e-24eb1e5c9d58/169 Fiordland temperate forests - Michael Seebeck.jpg',
                      _id: 'f157a3f7-540c-4332-900e-24eb1e5c9d58'
                    }
                  }
                ],
                stats: [
                  { number: '26,665', item: 'Total Land Area (1000 ha)' },
                  { number: '12', item: 'Number of Ecoregions' },
                  { number: '49%', item: 'Protection Target' },
                  { number: '6', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Australasia',
            value: 285
          },
          {
            _id: 'd4209d05-9714-4a42-8bec-a3c18ca3d4dc',
            name: 'Australasian Islands & Eastern Indonesia',
            children: [
              {
                name: 'Southeast Indonesian Dry Forest Islands (AU15)',
                children: [],
                _id: 'd34612ac-02a8-4ffb-ae87-9baeee98efe0',
                value: 1000,
                parentId: 'd4209d05-9714-4a42-8bec-a3c18ca3d4dc',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fc13d5ea-9a8a-43d5-9bef-ff085b1de7bc/163-Komodo_Islands-CC-Amelia Samulo-2011.jpg',
                    _id: 'fc13d5ea-9a8a-43d5-9bef-ff085b1de7bc'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/64239cbb-c867-4dae-8bbf-6ee43e7e3e97/165-Air_Terjun_Tanggedu,_Sumba_Timur-CC-2017_resized.jpg',
                    _id: '64239cbb-c867-4dae-8bbf-6ee43e7e3e97'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/390af658-1b01-499b-b92f-6272ef6a556a/166-View_over_tropical_dry_forest_to_coastal_strand_vegetation_on_Jaco_Island,_Tutuala,_Lautem,_Timor-Leste-CC-Colin Trainor-.jpg',
                    _id: '390af658-1b01-499b-b92f-6272ef6a556a'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c5a17045-4429-4aba-807e-e06c6595f358/Bioregion%20map-AU15.jpg',
                content:
                  '<p>The Southeast Indonesian bioregion, located in the Australasia realm, includes most of the Lesser Sunda Islands, of long chain of volcanic islands running along the Flores and Savu Seas, from Timor-Leste to the Lombok Strait that divides the Australasian and Indomalayan realms. This bioregion is dominated by tropical dry forests with three ecoregions \u2013 Sumba Deciduous Forests [1], Lesser Sundas Deciduous Forests [2], Timor and Wetar Deciduous Forests [3] \u2013 totaling more than 8 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c5a17045-4429-4aba-807e-e06c6595f358/Bioregion%20map-AU15.jpg"/><figcaption><span class="caption"><p>The Southeast Indonesian Dry Forest Islands bioregion is part of the Australasian Islands &amp; Eastern Indonesia subrealm and is made up of three ecoregions: Sumba Deciduous Forests [1], Lesser Sundas Deciduous Forests [2], Timor and Wetar Deciduous Forests [3].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bSoutheast Indonesian Dry Forest Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: '6a3808ce-230a-45bc-9647-20f71f105c4a' },
                  { title: 'Timor and Wetar Deciduous Forests' },
                  { regionId: '166' },
                  {
                    dek:
                      'This ecoregion represents the semi-evergreen dry forests of Timor, Wetar, and some smaller islands in the provinces of Nusa Tenggara and Maluku in the eastern Indonesian Archipelago.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/35818a46-d68a-4f99-bc53-9c0f96f64fee/166 Timor and Wetar deciduous forests - Roger King.jpg',
                      _id: '35818a46-d68a-4f99-bc53-9c0f96f64fee'
                    }
                  },
                  { _id: '10982a87-adbb-4423-b8b6-d6a8defdda32' },
                  { title: 'Sumba Deciduous Forests' },
                  { regionId: '165' },
                  {
                    dek:
                      'This ecoregion represents the semi-evergreen forests on the island of Sumba, in the eastern Indonesian Archipelago. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/93d45224-e9b6-4239-abeb-fc992dfcaec3/165 Sumba deciduous forests - Zarasrtn.jpg',
                      _id: '93d45224-e9b6-4239-abeb-fc992dfcaec3'
                    }
                  },
                  { _id: '8b45fee6-6351-4475-b152-62d7a6e04d76' },
                  { title: 'Lesser Sundas Deciduous Forests' },
                  { regionId: '163' },
                  {
                    dek:
                      'This ecoregion represents the semi-evergreen dry forests in the Lesser Sunda Islands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/78fa2813-3dcf-4c17-b5c6-78ac770c228f/163 Lesser Sundas deciduous forests - Eric Wikramanayake.jpg',
                      _id: '78fa2813-3dcf-4c17-b5c6-78ac770c228f'
                    }
                  }
                ],
                stats: [
                  { number: '8,392', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '44%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Sulawesi & Maluku Islands (AU14)',
                children: [],
                _id: '2df67e45-4aa7-4706-b6be-ebb98ec6d77a',
                value: 1000,
                parentId: 'd4209d05-9714-4a42-8bec-a3c18ca3d4dc',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/062fe2dd-407c-4f85-b3a6-17825ea5c322/138 Buru rain forests - Craig Robson Birdquest.jpg',
                    _id: '062fe2dd-407c-4f85-b3a6-17825ea5c322'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/57aa8bfd-f678-43e4-a1b0-d305340e0a0c/136 Banda Sea Islands moist deciduous forests - Mark Richards.JPG',
                    _id: '57aa8bfd-f678-43e4-a1b0-d305340e0a0c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b2ac9cc8-f8f9-4255-a5de-c833f1c6ccab/157 Sulawesi montane rain forests - Rhett Butler.jpg',
                    _id: 'b2ac9cc8-f8f9-4255-a5de-c833f1c6ccab'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8dc85635-5b0e-49dc-b2a5-1d6b32daace6/Bioregion%20map-AU14.jpg',
                content:
                  '<p>The Sulawesi &amp; Maluku bioregion, located in the Australasia realm, consist of a large group of Indonesian islands surrounding the Molucca and Banda Seas. Sulawesi, to the west, is the largest island of the group with two major gulfs. The Maluku, to the east, are an archipelago of islands separated from New Guinea by the Halmahera and Seram Seas. The islands are dominated by rainforests with moist deciduous forest in the south, and the bioregion consists of six ecoregions \u2013 Sulawesi Montane Rainforests [1], Sulawesi Lowland Rainforests [2], Buru Rainforests [3], Halmahera Rainforests [4], Seram Rainforests [5], Banda Sea Islands Moist Deciduous Forests [6] \u2013 totaling approximately 25.5 million hectares of land area.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8dc85635-5b0e-49dc-b2a5-1d6b32daace6/Bioregion%20map-AU14.jpg"/><figcaption><span class="caption"><p>The Sulawesi &amp; Maluku Islands bioregion is part of the Australasian Islands &amp; Eastern Indonesia subrealm and is made up of six ecoregions: Sulawesi Montane Rainforests [1], Sulawesi Lowland Rainforests [2], Buru Rainforests [3], Halmahera Rainforests [4], Seram Rainforests [5], Banda Sea Islands Moist Deciduous Forests [6].&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bSulawesi &amp; Maluku Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'b2147503-3931-467c-b294-27d884421cbb' },
                  { title: 'Sulawesi Montane Rainforests' },
                  { regionId: '157' },
                  {
                    dek:
                      'Sulawesi is at the crossroads of Southeast Asia, New Guinea, and Australia, yet its deep water isolation has driven the evolution of numerous unique species. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b2ac9cc8-f8f9-4255-a5de-c833f1c6ccab/157 Sulawesi montane rain forests - Rhett Butler.jpg',
                      _id: 'b2ac9cc8-f8f9-4255-a5de-c833f1c6ccab'
                    }
                  },
                  { _id: '206bf796-6965-4a13-ac7e-707669d42002' },
                  { title: 'Sulawesi Lowland Rainforests' },
                  { regionId: '156' },
                  {
                    dek:
                      'The islands are located in the region known as Wallacea, which contains a distinctive fauna representing a mix of Asian and Australasian species. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e8686756-772d-4878-98d7-960beecefc1d/156 Sulawesi lowland rain forests - Rhett Butler.jpg',
                      _id: 'e8686756-772d-4878-98d7-960beecefc1d'
                    }
                  },
                  { _id: '1b66b382-997a-4e5c-9905-b0876503b14f' },
                  { title: 'Seram Rainforests' },
                  { regionId: '151' },
                  {
                    dek:
                      'Located between New Guinea and Southeast Asia, this island supports lineages from both biotas.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9ef5fb3f-d596-4c24-95b7-2a3e0c724c78/151 Seram Rain Forests Dani Albakia cc.jpg',
                      _id: '9ef5fb3f-d596-4c24-95b7-2a3e0c724c78'
                    }
                  },
                  { _id: '7e37e682-af53-4ba7-9e77-2282cea309be' },
                  { title: 'Halmahera Rainforests' },
                  { regionId: '140' },
                  {
                    dek:
                      'This ecoregion represents the moist forests on Halmahera, Morotai, Obi, Bacan, and the other nearby Maluku Islands in the northeastern Indonesian Archipelago.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fe34cc0a-26cc-4b33-8f18-2114aaa6f133/140 Halmahera rain forests - Explore Plants.jpg',
                      _id: 'fe34cc0a-26cc-4b33-8f18-2114aaa6f133'
                    }
                  },
                  { _id: '3edef82e-9e18-4896-81cc-f6a605688c0f' },
                  { title: 'Buru Rainforests' },
                  { regionId: '138' },
                  {
                    dek:
                      'Buru Island is a long-isolated stepping stone for plants and animals between Southeast Asia and New Guinea. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/062fe2dd-407c-4f85-b3a6-17825ea5c322/138 Buru rain forests - Craig Robson Birdquest.jpg',
                      _id: '062fe2dd-407c-4f85-b3a6-17825ea5c322'
                    }
                  },
                  { _id: '6f80154d-34ff-4cf6-93e2-69f34c76f0dc' },
                  { title: 'Banda Sea Islands Moist Deciduous Forests' },
                  { regionId: '136' },
                  {
                    dek:
                      'This ecoregion is comprised of several islands scattered along an arc between the large islands of Timor-Leste and Papua New Guinea in the Pacific Ocean.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/57aa8bfd-f678-43e4-a1b0-d305340e0a0c/136 Banda Sea Islands moist deciduous forests - Mark Richards.JPG',
                      _id: '57aa8bfd-f678-43e4-a1b0-d305340e0a0c'
                    }
                  }
                ],
                stats: [
                  { number: '25,508', item: 'Total Land Area (1000 ha)' },
                  { number: '6', item: 'Number of Ecoregions' },
                  { number: '75%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              },
              {
                name: 'New Guinea & Surrounding Islands (AU13)',
                children: [],
                _id: 'ad429ade-3b70-405b-b65f-82299179b810',
                value: 1000,
                parentId: 'd4209d05-9714-4a42-8bec-a3c18ca3d4dc',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/117a0266-f9d4-4235-9c08-66fd5175566d/188-Trans_Fly_landscape-PNG-CC-Iain Taylor-2007.jpg',
                    _id: '117a0266-f9d4-4235-9c08-66fd5175566d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/70700364-35c7-40ca-b0cc-ac802cf5d408/137 Biak-Numfoor rain forests - John Morrison.jpg',
                    _id: '70700364-35c7-40ca-b0cc-ac802cf5d408'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e576479b-93bf-45d3-9418-478be4672bb2/139-Mount_Bosavi_-rim_of_crater-CC-2008.jpg',
                    _id: 'e576479b-93bf-45d3-9418-478be4672bb2'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/90edf25e-197e-4fae-b7ae-3513e8292f33/145 New Britain-New Ireland montane rain forests - Ethan B Linck.jpeg',
                    _id: '90edf25e-197e-4fae-b7ae-3513e8292f33'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fad88685-ba16-4fe1-af7e-f6a291986058/Bioregion%20map-AU13.jpg',
                content:
                  '<p>The New Guinea bioregion, located in the Australasia realm, is the world\u2019s second largest island (after Greenland) separated from Australia by the Torres Strait. New Guinea and its surrounding islands make up the northernmost grouping of islands in Melanesia. This bioregion is dominated by rainforests and swamp forests with extensive mangroves. Along the island\u2019s central mountain ridge high-altitude grasslands are found, with tropical grasslands in the south of the island, just opposite Cape York in Australia. Altogether, the bioregion has 19 ecoregions \u2013 Vogelkop-Aru Lowland Rainforests [1], Vogelkop Montane Rainforests [2], Southern New Guinea Freshwater Swamp Forests [3], Biak-Numfor Rainforests [4], Yapen Rainforests [5], Northern New Guinea Lowland Rain and Freshwater Swamp Forests [6], Northern New Guinea Montane Rainforests [7], Papuan Central Range Sub-Alpine Grasslands [8], Central Range Papuan Montane Rainforests [9], Southern New Guinea Lowland Rain Forests [10], Trans Fly Savanna and Grasslands [11], Huon Peninsula Montane Rainforests [12], Southeastern Papuan Rainforests [13], Admiralty Islands Lowland Rainforests [14], New Britain-New Ireland Lowland Rainforests [15], New Britain-New Ireland Montane Rainforests [16], Trobriand Islands Rainforests [17], Louisiade Archipelago Rainforests [18], New Guinea Mangroves [19]. This bioregion is one of the most biodiverse places on the planet, harboring 5-10% of all known species. Its total land area is nearly 88 million hectares, and it is home to over a thousand tribal groups, 44 of which are uncontacted.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fad88685-ba16-4fe1-af7e-f6a291986058/Bioregion%20map-AU13.jpg"/><figcaption><span class="caption"><p>The New Guinea &amp; Surrounding Islands bioregion is part of the Australasian Islands &amp; Eastern Indonesia subrealm and is made up of 19 ecoregions: Vogelkop-Aru Lowland Rainforests [1], Vogelkop Montane Rainforests [2], Southern New Guinea Freshwater Swamp Forests [3], Biak-Numfor Rainforests [4], Yapen Rainforests [5], Northern New Guinea Lowland Rain and Freshwater Swamp Forests [6], Northern New Guinea Montane Rainforests [7], Papuan Central Range Sub-Alpine Grasslands [8], Central Range Papuan Montane Rainforests [9], Southern New Guinea Lowland Rain Forests [10], Trans Fly Savanna and Grasslands [11], Huon Peninsula Montane Rainforests [12], Southeastern Papuan Rainforests [13], Admiralty Islands Lowland Rainforests [14], New Britain-New Ireland Lowland Rainforests [15], New Britain-New Ireland Montane Rainforests [16], Trobriand Islands Rainforests [17], Louisiade Archipelago Rainforests [18], New Guinea Mangroves [19].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bNew Guinea &amp; Surrounding Islands ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: '31c7b18a-f57b-49cc-9053-bb6d49af67b5' },
                  { title: 'New Guinea Mangroves' },
                  { regionId: '217' },
                  {
                    dek:
                      "New Guinea's mangroves are among the world\u2019s largest and most intact wetlands, and are found along extensive lengths of its coastline."
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/611fe032-3cfc-4925-94bb-c85526d384ed/217 New Guinea mangroves - Natalie Ragan.jpg',
                      _id: '611fe032-3cfc-4925-94bb-c85526d384ed'
                    }
                  },
                  { _id: '87cbd474-95b4-4369-9b3e-eb9fcd5720b7' },
                  { title: 'Papuan Central Range Sub-Alpine Grasslands' },
                  { regionId: '195' },
                  {
                    dek:
                      'Tall, wet, tropical, and isolated define New Guinea\u2019s Central Range alpine habitats. Puncak Jaya stands as the highest peak in Australasia and the tallest island mountain in the world, capped by Equatorial glaciers. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a876d412-9c46-4f89-b322-4a7b11114197/195 Papuan Central Range sub-alpine grasslands - Ethan B Linck.jpg',
                      _id: 'a876d412-9c46-4f89-b322-4a7b11114197'
                    }
                  },
                  { _id: '4f0af8f5-0155-42bb-a549-ce1e7fb0c987' },
                  { title: 'Trans Fly Savanna and Grasslands' },
                  { regionId: '188' },
                  {
                    dek:
                      'The Trans Fly Savanna and Grasslands ecoregion is one of the most extensive lowlands on the island of New Guinea. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eca78a9e-803d-432d-ba6f-9f3ea66110bf/188 Trans Fly savanna and grasslands - John Morrison.jpg',
                      _id: 'eca78a9e-803d-432d-ba6f-9f3ea66110bf'
                    }
                  },
                  { _id: '4efd6c63-9279-4c7d-bbd9-00534b2be5c9' },
                  { title: 'Yapen Rainforests' },
                  { regionId: '162' },
                  {
                    dek:
                      'Yapen lies across Cenderawasih Bay and was once connected to Papua New Guinea.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8e86481c-7533-4c9c-8c84-9030abd690a7/162 Yapen rain forests - Pvanvelzen.JPG',
                      _id: '8e86481c-7533-4c9c-8c84-9030abd690a7'
                    }
                  },
                  { _id: '5b57e073-d390-40c4-9534-459319489c4b' },
                  { title: 'Vogelkop-Aru Lowland Rainforests' },
                  { regionId: '161' },
                  {
                    dek:
                      'This ecoregion covers the lowland and sub-montane forests, less than 1,000 m in elevation, along the middle of the Bird\u2019s Head (Vogelkop) peninsula, and in Bomberai peninsula, south of the main Bird\u2019s Head peninsula.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/99793854-feb9-4788-b625-0165e5b96992/161 Vogelkop-Aru lowland rain forests - Rhett Butler.jpg',
                      _id: '99793854-feb9-4788-b625-0165e5b96992'
                    }
                  },
                  { _id: '084be7a9-fc59-4aa8-9876-e63ae6dd5e67' },
                  { title: 'Vogelkop Montane Rainforests' },
                  { regionId: '160' },
                  {
                    dek:
                      'The northwestern part of Papua New Guinea is known variously as Vogelkop, Bird\u2019s Head Peninsula, or Burung Kepala in Indonesian, for its bird head shape.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9aa6dac2-edb3-4897-bca4-bea86b379f19/160 Vogelkop montane rain forests - Rhett Butler.jpg',
                      _id: '9aa6dac2-edb3-4897-bca4-bea86b379f19'
                    }
                  },
                  { _id: '5d23170a-ea6b-4188-90ed-85f06b1a186b' },
                  { title: 'Trobriand Islands Rainforests' },
                  { regionId: '158' },
                  {
                    dek:
                      "This ecoregion lies just off the southeastern tip of Papua New Guinea in the southwest Pacific and includes Woodlark Island and two island groups: the D'Entrecasteaux and the Trobriand."
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/db83aeb8-c294-4ff5-b2e3-b6b0f2d99bfd/158 Trobriand Islands rain forests - Mark Van Beirs Birdquest.jpg',
                      _id: 'db83aeb8-c294-4ff5-b2e3-b6b0f2d99bfd'
                    }
                  },
                  { _id: 'd10b1709-32f5-4531-a603-48acf6048424' },
                  { title: 'Southern New Guinea Lowland Rainforests' },
                  { regionId: '155' },
                  {
                    dek:
                      'This ecoregion stretches across the lowland forests south of the Central Cordillera of Indonesian Irian Jaya and Papua New Guinea.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5d6b81ba-a3cb-45ac-920e-90a3b174fd09/155 Southern New Guinea lowland rain forests - 710928003 Flickr.jpg',
                      _id: '5d6b81ba-a3cb-45ac-920e-90a3b174fd09'
                    }
                  },
                  { _id: '04482daf-e3a2-4be2-ac7a-464937137d20' },
                  { title: 'Southern New Guinea Freshwater Swamp Forests' },
                  { regionId: '154' },
                  {
                    dek:
                      'This ecoregion consists of a large extent in south-central New Guinea and a smaller, disjunct patch along the southern coast of the Vogelkop Peninsula in West Papua.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fc6f82df-a0ab-41d1-b757-74d8be7d987a/154 Southern New Guinea freshwater swamp forests - John Morrison.jpg',
                      _id: 'fc6f82df-a0ab-41d1-b757-74d8be7d987a'
                    }
                  },
                  { _id: '2aa88d04-a2cb-49dc-824d-fc9c26c70a9d' },
                  { title: 'Southeastern Papuan Rainforests' },
                  { regionId: '153' },
                  {
                    dek:
                      'This lowland and montane ecoregion is made up of the Owen Stanley Range and surrounding lowland and coastal areas.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cf9f45b8-bf78-4e61-9e5b-8edac815b685/153 Southeast Papuan rain forests - Arthur Chapman.jpg',
                      _id: 'cf9f45b8-bf78-4e61-9e5b-8edac815b685'
                    }
                  },
                  { _id: 'e5227471-c4d7-4389-a88d-34433c8b562a' },
                  { title: 'Northern New Guinea Montane Rainforests' },
                  { regionId: '149' },
                  {
                    dek:
                      'This ecoregion is comprised of the Van Rees, Gauttier, Cyclops, Denake, Bewani, Torricelli, Prince Alexander, and Adelbert Ranges. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ede1cf4d-dd17-48dc-a1d0-a8b403a89da3/149 Northern New Guinea montane rain forests - Rhett Butler.jpg',
                      _id: 'ede1cf4d-dd17-48dc-a1d0-a8b403a89da3'
                    }
                  },
                  { _id: 'd2a4fb4e-8fb2-439f-b336-ea78421c35e1' },
                  { title: 'Northern New Guinea Lowland Rain and Freshwater Swamp Forests' },
                  { regionId: '148' },
                  {
                    dek:
                      'The lowlands of northern New Guinea are a maze of freshwater and peat swamps that interlace tall lowland forests and tall-grass savannas.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5e09b1f0-e789-4315-968a-1cac7916c4c3/148 Northern New Guinea lowland rain and freshwater swamp forests - Rocky Roe.JPG',
                      _id: '5e09b1f0-e789-4315-968a-1cac7916c4c3'
                    }
                  },
                  { _id: 'b48c80f4-b0e7-44cd-b905-1b20f56f1b43' },
                  { title: 'New Britain-New Ireland Montane Rainforests' },
                  { regionId: '145' },
                  {
                    dek:
                      'Mossy cloud forests covered in epiphytes top the high mountains of New Britain and New Ireland.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/90edf25e-197e-4fae-b7ae-3513e8292f33/145 New Britain-New Ireland montane rain forests - Ethan B Linck.jpeg',
                      _id: '90edf25e-197e-4fae-b7ae-3513e8292f33'
                    }
                  },
                  { _id: '11310db7-0c11-439b-9042-55009e31845e' },
                  { title: 'New Britain-New Ireland Lowland Rainforests' },
                  { regionId: '144' },
                  {
                    dek:
                      'The Bismarck Archipelago is dominated by New Britain and New Ireland, though St. Matthias Islands, New Hanover, and many associated islands are also part of the archipelago.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b7814ddf-6abe-4492-a0c9-f9982aaaf32a/144 New Britain-New Ireland lowland rain forests - Ethan B Linck.jpeg',
                      _id: 'b7814ddf-6abe-4492-a0c9-f9982aaaf32a'
                    }
                  },
                  { _id: '79e6a35f-1055-4d44-a01b-adae4469ec0b' },
                  { title: 'Louisiade Archipelago Rainforests' },
                  { regionId: '143' },
                  {
                    dek:
                      'Located far to the east of the island of New Guinea, the idyllic Louisiade Archipelago supports rain forests with many endemic plants and animals.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dcc56cd1-53a4-4a79-ac2e-a914da8de79b/143 Louisiade Archipelago rain forests - John Leslie Dowe Australian Tropical Herbarium Cairns Qld Australia.jpg',
                      _id: 'dcc56cd1-53a4-4a79-ac2e-a914da8de79b'
                    }
                  },
                  { _id: '82ff89a5-a6e4-4af5-af89-3b47b515347d' },
                  { title: 'Huon Peninsula Montane Rainforests' },
                  { regionId: '141' },
                  {
                    dek:
                      'The climate of this ecoregion is tropical wet, which is characteristic of this part of Melanesia, located in the western Pacific Ocean north of Australia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/422bd4b8-86e7-4478-9d9e-1b387df07b35/141 Huon Peninsula montane rain forests - Ryan Hawk ryanhawk.com.jpg',
                      _id: '422bd4b8-86e7-4478-9d9e-1b387df07b35'
                    }
                  },
                  { _id: '0aac8c8b-677b-40a0-abbc-c9693b215f82' },
                  { title: 'Central Range Papuan Montane Rainforests' },
                  { regionId: '139 ' },
                  { dek: 'This ecoregion covers the mountain spine of the island of New Guinea.' },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9fcb9494-8b72-4505-9f31-9587ce7bc1be/139 Central Range Papuan montane rain forests - John Morrison.jpg',
                      _id: '9fcb9494-8b72-4505-9f31-9587ce7bc1be'
                    }
                  },
                  { _id: '01d48dd7-5368-4c5a-81e1-26538367f8ca' },
                  { title: 'Biak-Numfoor Rainforests' },
                  { regionId: '137' },
                  {
                    dek:
                      'This ecoregion covers Biak and Numfoor islands that stand guard at the entrance of Cenderawasih Bay constricting the western part of Papua New Guinea to form Bird\u2019s Head Peninsula.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/70700364-35c7-40ca-b0cc-ac802cf5d408/137 Biak-Numfoor rain forests - John Morrison.jpg',
                      _id: '70700364-35c7-40ca-b0cc-ac802cf5d408'
                    }
                  },
                  { _id: '03988589-a2e0-4d5c-a383-c0f6d1046a5a' },
                  { title: 'Admiralty Islands Lowland Rainforests' },
                  { regionId: '135' },
                  {
                    dek:
                      'This group of remote oceanic islands that comprise the ecoregion are volcanic in origin, dating back to the late Miocene 8 to 10 million years ago. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/92244d0b-6418-4bf8-b5e1-91e86c9606b6/135 Admiralty Islands lowland rain forests - Valter Weijola.jpg',
                      _id: '92244d0b-6418-4bf8-b5e1-91e86c9606b6'
                    }
                  }
                ],
                stats: [
                  { number: '87,795', item: 'Total Land Area (1000 ha)' },
                  { number: '19', item: 'Number of Ecoregions' },
                  { number: '85%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              },
              {
                name: 'Vanuatu Islands (AU11)',
                children: [],
                _id: '529a56a8-79e5-4ca5-8904-68a48abf850a',
                value: 1000,
                parentId: 'd4209d05-9714-4a42-8bec-a3c18ca3d4dc',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2c5f9f2b-1772-4f08-a6cd-bbe1f98504cc/159 Vanuatu_rain_forests Phillip Capper cc.jpg',
                    _id: '2c5f9f2b-1772-4f08-a6cd-bbe1f98504cc'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0478a6ad-37b0-4a72-ab60-d689097f46a8/159-Vanuatu_Tanna_Yasur-CC-.JPG',
                    _id: '0478a6ad-37b0-4a72-ab60-d689097f46a8'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c82c29ce-99b8-468a-a64c-bbb40fbd6a66/Bioregion%20map-AU11.jpg',
                content:
                  '<p>The Vanuatu Islands bioregion, located in the Australasia realm, is an archipelago of over 80 islands just to the east of New Caledonia and the Coral Sea, marking the beginning of the South Pacific Ocean and the southern grouping of islands in Melanesia. These islands, totaling more than 1 million hectares of land, are dominated by one ecoregion \u2013 Vanuatu Rainforests [1] \u2013 which are the product of one of the world\u2019s most prolific seed dispersers, the flying fox. The area is rich with marine life, including 4000 species of marine mollusks.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c82c29ce-99b8-468a-a64c-bbb40fbd6a66/Bioregion%20map-AU11.jpg"/><figcaption><span class="caption"><p>The Vanuatu Islands bioregion is part of the Australasian Islands &amp; Eastern Indonesia subrealm and is made up of one ecoregion: Vanuatu Rainforests [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace\u200b</strong></a> \u200bto explore projects in this realm that need your support. Learn more about the \u200bVanuatu Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: '3f0ac6d9-3763-4823-99a7-9d039cdf5b05' },
                  { title: 'Vanuatu Rainforests' },
                  { regionId: '159' },
                  {
                    dek:
                      'This ecoregion consists of tropical lowland and montane forests in the island nation of Vanuatu (formerly New Hebrides), with the addition of the Santa Cruz Group, or Temotu Province of the Solomon Islands. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/16b52b88-0522-4d62-9620-9091f7aee25c/159 Vanuatu rain forests - John Morrison.jpg',
                      _id: '16b52b88-0522-4d62-9620-9091f7aee25c'
                    }
                  }
                ],
                stats: [
                  { number: '1,323', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '77%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              },
              {
                name: 'Coral Sea & New Caledonia Islands (AU10)',
                children: [],
                _id: '7fb46ba0-ce86-4c48-b7af-829feec77288',
                value: 1000,
                parentId: 'd4209d05-9714-4a42-8bec-a3c18ca3d4dc',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c360a453-22c6-43a0-8e26-a3cacdfd312c/164 Savane_niaoulis_nouvelle_caledonie-CC-2008.jpg',
                    _id: 'c360a453-22c6-43a0-8e26-a3cacdfd312c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2b4f0beb-c376-4498-8bb3-fbe6782f2bcb/146 New Caledonia Rain Forests cc.jpeg',
                    _id: '2b4f0beb-c376-4498-8bb3-fbe6782f2bcb'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/76fb7658-41dd-4f30-a77e-9052801444d1/Bioregion%20map-AU10.jpg',
                content:
                  '<p>The Coral Sea bioregion, located in the Australasia realm, extends from the Great Barrier Reef to the New Caledonia Islands, encompassing most of the Coral Sea and sharing much of the reef\u2019s rich biodiversity. The New Caledonia islands are mostly covered in tropical rainforest, with dry forests along the main island\u2019s west coast. The bioregion has two ecoregions \u2013 New Caledonia Dry Forests [1], New Caledonia Rain Forests [2] \u2013 with a total land area of nearly 2 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/76fb7658-41dd-4f30-a77e-9052801444d1/Bioregion%20map-AU10.jpg"/><figcaption><span class="caption"><p>The Coral Sea &amp; New Caledonia Islands bioregion is part of the Australasian Islands &amp; Eastern Indonesia subrealm and is made up of two ecoregions: New Caledonia Dry Forests [1], New Caledonia Rain Forests [2].&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace\u200b</strong></a> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bCoral Sea &amp; New Caledonia Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'f6a2087c-df74-45f0-89b2-c4a17f6db419' },
                  { title: 'New Caledonia Dry Forests' },
                  { regionId: '164' },
                  {
                    dek:
                      'The dry forests of New Caledonia contain a unique assemblage of plants with 59 endemic species.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c360a453-22c6-43a0-8e26-a3cacdfd312c/164 Savane_niaoulis_nouvelle_caledonie-CC-2008.jpg',
                      _id: 'c360a453-22c6-43a0-8e26-a3cacdfd312c'
                    }
                  },
                  { _id: 'e118e739-5b44-435a-8fd2-2648759c6ef5' },
                  { title: 'New Caledonia Rainforests' },
                  { regionId: '146' },
                  {
                    dek:
                      'The long isolation of this group of South Pacific islands\u2015an errant chunk of ancient Gondwanaland consisting of New Caledonia and Loyalty Islands\u2015has driven the evolution of a biota that is globally distinctive.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/86fa59da-cb81-484a-8333-45f4be4c8f2b/146 New Caledonia rain forests - David Mark.jpg',
                      _id: '86fa59da-cb81-484a-8333-45f4be4c8f2b'
                    }
                  }
                ],
                stats: [
                  { number: '1,902', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '76%', item: 'Protection Target' },
                  { number: '7', item: 'Protection Level' }
                ]
              },
              {
                name: 'Solomon Islands (AU12)',
                children: [],
                _id: '087c80a0-ee01-4d5e-ba96-c084df6c089a',
                value: 1000,
                parentId: 'd4209d05-9714-4a42-8bec-a3c18ca3d4dc',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/45022217-1a02-476e-beb0-f314742766bc/152 Solomon Islands Rain Forests RH D 22.jpeg',
                    _id: '45022217-1a02-476e-beb0-f314742766bc'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7772387e-9eb5-4d95-a14a-196b7e7db6e0/Bioregion%20map-AU12.psd',
                content:
                  '<p>The Solomon Islands bioregion, located in the Australasia realm, is an archipelago of six major islands and hundreds of minor islands and islets in the Solomon Sea, just above the Coral Sea. It is the central grouping of islands in Melanesia. These islands, totaling approximately 3.5 million hectares of land, are dominated by one ecoregion \u2013 Solomon Islands Rain Forests [1] \u2013 and are known for a diversity of plant life, including more than 230 species of orchid. This bioregion contains several active volcanoes.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7772387e-9eb5-4d95-a14a-196b7e7db6e0/Bioregion%20map-AU12.psd"/><figcaption><span class="caption"><p>The Solomon Islands bioregion is part of the Australasian Islands &amp; Eastern Indonesia subrealm and is made up of one ecoregion: Solomon Islands Rain Forests [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about the \u200bSolomon Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: '3422b72a-9d0f-4606-a8f7-a1830cdfaee6' },
                  { title: 'Solomon Islands Rainforests' },
                  { regionId: '152' },
                  {
                    dek:
                      'The Solomon Islands are an arc of high oceanic islands clothed in rain forests and surrounded by blue coral-filled seas.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/82e142d8-1cb4-4202-9330-a2f821417a76/152 Solomon Islands rain forests - Ethan B Linck.jpg',
                      _id: '82e142d8-1cb4-4202-9330-a2f821417a76'
                    }
                  }
                ],
                stats: [
                  { number: '3,593', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '89%', item: 'Protection Target' },
                  { number: '0', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Australasia',
            value: 857
          },
          {
            _id: '9e2e6a39-2aa3-4a09-8842-60c031fc6c17',
            name: 'Australia',
            children: [
              {
                name: 'Queensland Tropical Rainforests & Savannas (AU9)',
                children: [],
                _id: 'd74331dc-a208-4463-a224-0ae259de79b4',
                value: 1000,
                parentId: '9e2e6a39-2aa3-4a09-8842-60c031fc6c17',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/628a9b71-02dc-4862-a084-1a4702b31703/150-Girringun_National_Park-CC-Rob and Stephanie Levy-2007.jpg',
                    _id: '628a9b71-02dc-4862-a084-1a4702b31703'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cf79efda-9f0e-4dfe-a4f3-a0a9f20e5f7a/150-Daintree_Rainforest_CC-2011.jpg',
                    _id: 'cf79efda-9f0e-4dfe-a4f3-a0a9f20e5f7a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/35bec551-2857-42ff-97b3-29018656ace4/183 Cape York Peninsula Tropical Savanna Jim Bendon.jpg',
                    _id: '35bec551-2857-42ff-97b3-29018656ace4'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4abe3c82-8913-4578-a51e-348390952f40/182-Isla_Gorge_National_Park-CC-2014.jpg',
                    _id: '4abe3c82-8913-4578-a51e-348390952f40'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8ee518c8-44ea-4c57-821b-bc089b892710/Bioregion%20map-AU9.jpg',
                content:
                  '<p>The Queensland Tropical bioregion, located in the Australasia realm, covers the northeast coast of Australia, including Cape York in the north, running along the coastline of the Coral Sea. This bioregion includes the Great Barrier Reef just off the coast of Queensland, the world\u2019s largest reef system and one of the seven natural wonders of the world. These reefs support an extraordinary diversity of wildlife, including 400 corals, 30 cetacean species, and over 1500 species of fish, and 400 corals. On land, the bioregion consists mostly of tropical savannas with pockets of coastal rainforest. It contains three ecoregions \u2013 Cape York Peninsula Tropical Savanna [1], Queensland Tropical Rainforests [2], Brigalow Tropical Savanna [3] \u2013 with a total land area of nearly 57 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8ee518c8-44ea-4c57-821b-bc089b892710/Bioregion%20map-AU9.jpg"/><figcaption><span class="caption"><p>The Queensland Tropical Rainforests &amp; Savannas bioregion is part of the Australia subrealm and is made up of three ecoregions: Cape York Peninsula Tropical Savanna [1], Queensland Tropical Rainforests [2], Brigalow Tropical Savanna [3].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace\u200b</strong></a> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bQueensland Tropical Rainforests &amp; Savannas ecoregions below.</p>',
                ecoregions: [
                  { _id: 'cf2271ed-f7bc-4fc2-9f54-71b09322ee55' },
                  { title: 'Cape York Peninsula Tropical Savanna' },
                  { regionId: '183' },
                  {
                    dek:
                      "This ecoregion's location and diverse habitats make for a rich biota representing one quarter of Australia\u2019s frogs, one quarter of its reptiles, a third of all mammals, and half of its birds represented."
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5c0f5ef3-c3f9-4a19-97a4-9a0379e3e452/183 Cape York Peninsula tropical savanna - Roisterer.jpg',
                      _id: '5c0f5ef3-c3f9-4a19-97a4-9a0379e3e452'
                    }
                  },
                  { _id: 'ef6f2c86-0e9c-43cb-a60d-4db141e04647' },
                  { title: 'Queensland Tropical Rainforests' },
                  { regionId: '150' },
                  {
                    dek:
                      'Northeast Australia\u2019s relict tropical rainforests are notable for ancient lineages of plants and animals and strong affinities with the tropical forests of New Guinea to the north.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6bfd6818-9c48-4ea5-a2e8-ee2de524ea6e/150 Queensland tropical rain forests - Ivo Gut.jpg',
                      _id: '6bfd6818-9c48-4ea5-a2e8-ee2de524ea6e'
                    }
                  },
                  { _id: '34f9fd03-3f6f-49c4-a3dc-3d2ce54a0a04' },
                  { title: 'Brigalow Tropical Savanna' },
                  { regionId: '182' },
                  {
                    dek:
                      'This ecoregion is a transition from wetter coastal forests of eastern Australia to the drier semi-arid and arid zones of the continent\u2019s center.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b1935988-6bc1-41c5-8508-6b7573484633/182-Blackdown_Tableland_National_Park_View_CC-2007.jpg',
                      _id: 'b1935988-6bc1-41c5-8508-6b7573484633'
                    }
                  }
                ],
                stats: [
                  { number: '56,869', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '78%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'North Australian Tropical Savannas (AU8)',
                children: [],
                _id: '9280dd8e-46eb-48b8-9e37-ac81d077c101',
                value: 1000,
                parentId: '9e2e6a39-2aa3-4a09-8842-60c031fc6c17',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3be6e738-3cb7-4f02-bbee-253af9313ecf/181 Arnhem Land Tropical Savanna Dietmar Rabich cc.jpg',
                    _id: '3be6e738-3cb7-4f02-bbee-253af9313ecf'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dbd52f13-0f2c-4b91-b9e8-fc4518aab00b/187 Mitchell Grass Downs John Robert McPherson cc.jpg',
                    _id: 'dbd52f13-0f2c-4b91-b9e8-fc4518aab00b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/70213c9b-b59f-4b6e-98ca-a1d82af88159/184 Carpentaria Tropical Savanna James Fitzgerald cc.jpg',
                    _id: '70213c9b-b59f-4b6e-98ca-a1d82af88159'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0b86e695-b38f-425f-9cbf-9705f5d3162f/Bioregion%20map-AU8.jpg',
                content:
                  '<p>The North Australian Tropical bioregion, located in the Australasia realm, consists entirely of tropical savannas covering the north of the continent, excluding Cape York in the north of Queensland. The bioregion contains six ecoregions \u2013 Kimberly Tropical Savanna [1], Victoria Plains Tropical Savanna [2], Arnhem Land Tropical Savanna [3], Carpentaria Tropical Savanna [4], Mitchell Grass Downs [5], Einasleigh Upland Savanna [6] \u2013 and adjacent marine areas in the Timor Sea and Gulf of Carpentaria. It has a total land area of more than 168 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0b86e695-b38f-425f-9cbf-9705f5d3162f/Bioregion%20map-AU8.jpg"/><figcaption><span class="caption"><p>The North Australian Tropical Savannas bioregion is part of the Australia subrealm and is made up of six ecoregions: Kimberly Tropical Savanna [1], Victoria Plains Tropical Savanna [2], Arnhem Land Tropical Savanna [3], Carpentaria Tropical Savanna [4], Mitchell Grass Downs [5], Einasleigh Upland Savanna [6].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bNorth Australian Tropical Savannas ecoregions below.</p>',
                ecoregions: [
                  { _id: '44e19e35-06db-4d11-adad-72dc70336159' },
                  { title: 'Victoria Plains Tropical Savanna' },
                  { regionId: '189' },
                  {
                    dek:
                      'The Victoria Plains are a transition zone between the monsoonal rain environments of northern Australia and the dry arid interior of the continent.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cffd98ad-abd3-4107-81ec-d9c53c3ea664/189 Victoria Plains tropical savanna - Nichollos Harrison.jpg',
                      _id: 'cffd98ad-abd3-4107-81ec-d9c53c3ea664'
                    }
                  },
                  { _id: '08f137d6-9c46-43e0-93e7-6a22e56d1f7c' },
                  { title: 'Mitchell Grass Downs' },
                  { regionId: '187' },
                  {
                    dek:
                      'Mitchell grasses dominate vast treeless, rolling plains that stretch from central west Queensland into the Barkly Tableland on the northeast fringe of Australia\u2019s central deserts.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/834297bc-78b4-4a6e-8ab1-7e76ba311d82/187 Mitchell Grass Downs - C Goodwin.jpg',
                      _id: '834297bc-78b4-4a6e-8ab1-7e76ba311d82'
                    }
                  },
                  { _id: 'e683765e-f2ab-4797-8aff-023c2546742d' },
                  { title: 'Kimberly Tropical Savanna' },
                  { regionId: '186' },
                  {
                    dek:
                      'The deep gorges and steep cliffs of the rugged central ranges of the Kimberly have long functioned as climate microrefugia for many moisture-loving species.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3b5ac9cf-9aa5-4650-b714-187c1e02129e/186 Kimberly tropical savanna - Baras.jpg',
                      _id: '3b5ac9cf-9aa5-4650-b714-187c1e02129e'
                    }
                  },
                  { _id: '420eba68-7098-415d-8992-ff15030c02a3' },
                  { title: 'Einasleigh Upland Savanna' },
                  { regionId: '185' },
                  {
                    dek:
                      'Moving inland and upwards from the coastal Queensland rainforests, the drier Einasleigh Upland Savanna supports ironbark woodlands, wetlands, and drier rainforests.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/690fe6de-793b-4957-81dd-210b8d47e1e9/185 Einasleigh upland savanna - www.cape-york-australia.com.JPG',
                      _id: '690fe6de-793b-4957-81dd-210b8d47e1e9'
                    }
                  },
                  { _id: 'c7ec9dab-4872-4609-b54a-09ca6d07da2e' },
                  { title: 'Carpentaria Tropical Savanna' },
                  { regionId: '184' },
                  {
                    dek:
                      'This ecoregion encompasses a long arc of depositional plains along the southern Gulf of Carpentaria.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2b129182-6e8c-44bd-92a8-1774b4a96b9a/184 Carpentaria tropical savanna - DavidB601.JPG',
                      _id: '2b129182-6e8c-44bd-92a8-1774b4a96b9a'
                    }
                  },
                  { _id: 'ff3d101d-1cf4-4bea-86ed-e1bf34a22166' },
                  { title: 'Arnhem Land Tropical Savanna' },
                  { regionId: '181' },
                  {
                    dek:
                      'Arnhem Land is notable for its vast relatively natural landscapes, mosaics of floodplains, woodlands, wetlands, sedgelands, mangroves, and pockets of vine-filled monsoonal rainforest.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b75f8f14-c137-4a40-8fb3-3fec05586792/181 Arnhem Land tropical savanna - pen_ash.jpg',
                      _id: 'b75f8f14-c137-4a40-8fb3-3fec05586792'
                    }
                  }
                ],
                stats: [
                  { number: '168,381', item: 'Total Land Area (1000 ha)' },
                  { number: '6', item: 'Number of Ecoregions' },
                  { number: '84%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Greater Australian Interior Desert & Shrublands (AU7)',
                children: [],
                _id: '475f74b6-0172-4f5d-b09f-6eefaef5a6c3',
                value: 1000,
                parentId: '9e2e6a39-2aa3-4a09-8842-60c031fc6c17',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/23140eb3-90d5-4330-83d4-d458b4767570/208-Ayers rock:Uluru-CC.jpg',
                    _id: '23140eb3-90d5-4330-83d4-d458b4767570'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c0ab5e26-46e1-4ddd-b523-838f4b73335e/210-Great_Sandy_Desert,_Australia-CC-2013.jpg',
                    _id: 'c0ab5e26-46e1-4ddd-b523-838f4b73335e'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a51d1249-b3b7-4a94-a99d-69965d35bd7b/1086px-SimpsonsDesert.jpeg',
                    _id: 'a51d1249-b3b7-4a94-a99d-69965d35bd7b'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d9da93de-a0e1-439d-ad99-d7511f54957f/Bioregion%20map-AU7.jpg',
                content:
                  '<p>The Greater Australian Interior bioregion, located in the Australasia realm, represents a huge expanse of desert and dry shrublands with the famous Uluru, or Ayers Rock, in the center of the continent, a site that is sacred to its Indigenous people. The bioregion contains eight distinct ecoregions \u2013 Western Australian Mulga Shrublands [1], Great Sandy-Tanami Desert [2], Gibson Desert [3], Great Victoria Desert [4], Nullarbor Plains Xeric Shrublands [5], Central Ranges Xeric Scrub [6], Tirari-Stuart Stony Desert [7], Simpson Desert [8] \u2013 with a total area of more than 325 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d9da93de-a0e1-439d-ad99-d7511f54957f/Bioregion%20map-AU7.jpg"/><figcaption><span class="caption"><p>The Greater Australian Interior Desert &amp; Shrublands bioregion is part of the Australia subrealm and is made up of eight ecoregions: Western Australian Mulga Shrublands [1], Great Sandy-Tanami Desert [2], Gibson Desert [3], Great Victoria Desert [4], Nullarbor Plains Xeric Shrublands [5], Central Ranges Xeric Scrub [6], Tirari-Stuart Stony Desert [7], Simpson Desert [8].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bGreater Australian Interior Desert &amp; Shrublands ecoregions below.</p>',
                ecoregions: [
                  { _id: '1371ab47-4933-44f9-ac0e-025721783ea4' },
                  { title: 'Western Australian Mulga Shrublands' },
                  { regionId: '216' },
                  {
                    dek:
                      'This ecoregion is mostly covered by mulga trees, a type of acacia adapted to hot and arid climate through long tap roots that access water. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/be758f58-2580-45b0-aadc-064370cc46f1/216 Acacia_aneura_habit-CC-Mark Marathon-2013.jpg',
                      _id: 'be758f58-2580-45b0-aadc-064370cc46f1'
                    }
                  },
                  { _id: 'e704a829-e321-41ab-bead-3ddefb4b57f1' },
                  { title: 'Tirari-Stuart Stony Desert' },
                  { regionId: '215' },
                  {
                    dek:
                      'Ancient gibber pebble plains, sand dunes, ephemeral gilgal lakes, salt lakes, and xeric grasslands cover the Tirari-Sturt stony desert, one of the driest areas of Australia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7b43ce0f-bb64-4589-84ed-fadc0c9f9473/215 Tirari-Sturt stony desert - pen-ash.jpg',
                      _id: '7b43ce0f-bb64-4589-84ed-fadc0c9f9473'
                    }
                  },
                  { _id: 'acc3fa3c-6e04-4e8f-9373-d13e5aaff98d' },
                  { title: 'Simpson Desert' },
                  { regionId: '214' },
                  {
                    dek:
                      'This ecoregion has low relief characterized by flood and alluvial plains, ephemeral lakes and claypans.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6331be47-a0f7-4dc9-90ef-3b05dc13f845/214 Simpson Desert - Christopher_Watson.jpg',
                      _id: '6331be47-a0f7-4dc9-90ef-3b05dc13f845'
                    }
                  },
                  { _id: '0aebe4bc-3a51-48a7-8c50-7b65e48fb38f' },
                  { title: 'Nullarbor Plains Xeric Shrublands' },
                  { regionId: '212' },
                  {
                    dek:
                      'The Nullarbor Plain is flat, featureless, and treeless, riddled with caves and sinkholes in this uplifted ancient seabed\u2014the world\u2019s largest limestone plain.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dce7b70c-9ad3-4c63-ab98-a704495ef158/212 Nullarbor Plains xeric shrublands - Wikiwand.jpg',
                      _id: 'dce7b70c-9ad3-4c63-ab98-a704495ef158'
                    }
                  },
                  { _id: 'a9a8db81-d148-42c0-976a-cc1660b14828' },
                  { title: 'Great Victoria Desert' },
                  { regionId: '211' },
                  {
                    dek:
                      'The Great Victoria Desert is a global hotspot for reptile diversity, with the colourful thorny devil being one of the most spectacular.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0fa7d6b5-f6ff-4d76-8b4b-6f3ab9706be8/211 Great Victoria desert - Marian Deschain.JPG',
                      _id: '0fa7d6b5-f6ff-4d76-8b4b-6f3ab9706be8'
                    }
                  },
                  { _id: '1a844b6d-4445-46dd-9316-cd37a4bb578c' },
                  { title: 'Great Sandy-Tanami Desert' },
                  { regionId: '210' },
                  {
                    dek:
                      'This expansive ecoregion encompasses the Little Sandy Desert, Great Sandy Desert, and Tanami Desert Interim Biogeographic Regionalization for Australia (IBRA) regions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2842b95e-72a7-4c25-a67f-26ba548405ca/210 Great Sandy-Tanami desert - Peter WH.jpg',
                      _id: '2842b95e-72a7-4c25-a67f-26ba548405ca'
                    }
                  },
                  { _id: 'fccca648-6f52-4e7a-9696-8de79b68911c' },
                  { title: 'Gibson Desert' },
                  { regionId: '209' },
                  {
                    dek:
                      'The broad gravel and red sand plains and dunes of the Gibson Desert are home to one to the world\u2019s most diverse communities of reptiles.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/64dedbc3-e727-43d0-abd9-7ac8d4d7b103/209-Gibson_Desert-CC-2007.jpg',
                      _id: '64dedbc3-e727-43d0-abd9-7ac8d4d7b103'
                    }
                  },
                  { _id: '5114ef88-4c70-4ad9-b8cb-3607a6977b26' },
                  { title: 'Central Ranges Xeric Scrub' },
                  { regionId: '208' },
                  {
                    dek:
                      'This ecoregion includes red-soils of mulga (Acacia aneura) shrubland and grasslands of the Central Ranges at the heart of Australia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c4016746-8243-4a75-911d-85b123bf9961/208 Central Ranges xeric scrub - releasetheweb.jpg',
                      _id: 'c4016746-8243-4a75-911d-85b123bf9961'
                    }
                  }
                ],
                stats: [
                  { number: '325,462', item: 'Total Land Area (1000 ha)' },
                  { number: '8', item: 'Number of Ecoregions' },
                  { number: '84%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'West Australian Dry Coastal Shrublands (AU6)',
                children: [],
                _id: '8d6de58c-d3be-435f-82c3-e9636410e907',
                value: 1000,
                parentId: '9e2e6a39-2aa3-4a09-8842-60c031fc6c17',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5b2fdb00-4f89-4c0e-922d-a0cce7239e50/207-Carnarvon Xeric Shrublands-TerrtT2-cc.jpg',
                    _id: '5b2fdb00-4f89-4c0e-922d-a0cce7239e50'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8a8680a5-043f-4a1a-90ac-160e9091d430/213-Paraburdoo Iron ore_mine_CC-2011.jpg',
                    _id: '8a8680a5-043f-4a1a-90ac-160e9091d430'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aadcf09d-248b-44cf-b200-a4a42846300c/213-Hamersley_Range,_Pilbara_Region,_Western_Australia-CC-Barry T Coles-2007.JPG',
                    _id: 'aadcf09d-248b-44cf-b200-a4a42846300c'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d7f817b9-ac5e-4dbb-adfe-1ad8fb8d7c46/Bioregion%20map-AU6.jpg',
                content:
                  '<p>The West Australian bioregion, located in the Australasia realm, includes the dry shrublands on the continent\u2019s west coast, from Shark Bay to the beginning of Eighty Mile Beach in the northwest. It contains two ecoregions \u2013 Carnarvon Xeric Shrublands [1], Pilbara Shrublands [2] \u2013 and adjacent marine areas in the Indian Ocean. The total land area of this bioregion is more than 26 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d7f817b9-ac5e-4dbb-adfe-1ad8fb8d7c46/Bioregion%20map-AU6.jpg"/><figcaption><span class="caption"><p>The West Australian Dry Coastal Shrublands bioregion is part of the Australia subrealm and is made up of two ecoregions: Carnarvon Xeric Shrublands [1], Pilbara Shrublands [2].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bWest Australian Dry Coastal Shrublands ecoregions below.</p>',
                ecoregions: [
                  { _id: '442b8dda-7eca-4575-b9bb-095750e720ef' },
                  { title: 'Pilbara Shrublands' },
                  { regionId: '213' },
                  {
                    dek:
                      'This ecoregion displays unusually high levels of endemism derived, in part, from its ancient landscapes, complex habitats, and relative isolation.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ff1d9b45-b331-434d-8ac2-d87f5d025323/213 Pilbara shrublands - RuRu_SG.jpg',
                      _id: 'ff1d9b45-b331-434d-8ac2-d87f5d025323'
                    }
                  },
                  { _id: '1bc1156d-5a92-400c-80b0-e08abea7c96c' },
                  { title: 'Carnarvon Xeric Shrublands' },
                  { regionId: '207' },
                  {
                    dek:
                      'This ecoregion includes the dry shrublands of this remote region in western Australia. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a9eb53de-cb0d-420e-9a68-7534c0d9b64b/207 Carnarvon xeric shrublands - Laurent Marsol.jpg',
                      _id: 'a9eb53de-cb0d-420e-9a68-7534c0d9b64b'
                    }
                  }
                ],
                stats: [
                  { number: '26,377', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '91%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              },
              {
                name: 'South Australian Mediterranean Forests, Woodlands & Scrub (AU5)',
                children: [],
                _id: '23d3bcf7-bee1-424c-9367-c2e700022ebf',
                value: 1000,
                parentId: '9e2e6a39-2aa3-4a09-8842-60c031fc6c17',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8ee29a0f-26c7-4ca7-ac47-2173418103ea/197 Coolgardie Woodlands Keren Gila cc.jpg',
                    _id: '8ee29a0f-26c7-4ca7-ac47-2173418103ea'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d41fd4d1-89ab-44be-add4-5a0c9ff5ab9c/Jarrah-Karri Forest and Shrublands Orderinchaos cc2.jpg',
                    _id: 'd41fd4d1-89ab-44be-add4-5a0c9ff5ab9c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/470de3b2-914e-43d8-8be6-5dbf1f5f26d6/205-Southwest Australia Savanna-Bryn Pinzgauer-cc.jpg',
                    _id: '470de3b2-914e-43d8-8be6-5dbf1f5f26d6'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/af801363-8727-42a3-8b2b-60e65cc158c3/205-Kalbarri_Park_CC-Mike Bruss-2005.jpg',
                    _id: 'af801363-8727-42a3-8b2b-60e65cc158c3'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/602dd09a-e95c-4952-9ed1-946a03c28cc0/Bioregion%20map-AU5.jpg',
                content:
                  '<p>The South Australian Mediterranean bioregion, located in the Australasia realm, consists mostly of woodlands and shrublands covering much of the length of Australia\u2019s southern and western coastline, from St. Vincent Gulf to Shark Bay. The bioregion contains eight ecoregions \u2013 Southwest Australia Savanna [1], Southwest Australia Woodlands [2], Jarrah-Karri Forest and Shrublands [3], Esperance Mallee [4], Coolgardie Woodlands [5], Hampton Mallee and Woodlands [6], Eyre and Yorke Mallee [7], Flinders-Lofty Montane Woodlands [8] \u2013 and adjacent marine areas in the Great Australian Bight and Indian Ocean.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/602dd09a-e95c-4952-9ed1-946a03c28cc0/Bioregion%20map-AU5.jpg"/><figcaption><span class="caption"><p>The South Australian Mediterranean Forests, Woodlands &amp; Scrub bioregion is part of the Australia subrealm and is made up of eight ecoregions: Southwest Australia Savanna [1], Southwest Australia Woodlands [2], Jarrah-Karri Forest and Shrublands [3], Esperance Mallee [4], Coolgardie Woodlands [5], Hampton Mallee and Woodlands [6], Eyre and Yorke Mallee [7], Flinders-Lofty Montane Woodlands [8].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bSouth Australian Mediterranean Forests, Woodlands &amp; Scrub ecoregions below.</p>',
                ecoregions: [
                  { _id: '955e8690-4428-4ca1-a0c0-3136a2821af9' },
                  { title: 'Southwest Australia Woodlands' },
                  { regionId: '206' },
                  {
                    dek:
                      'This ecoregion occurs in the Southwest Australia global biodiversity hotspot, one of the five Mediterranean-type ecosystems around the world that are known for exceptionally high endemism and richness of plant species. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/88fef045-bd89-4faf-ad80-7fd4b3d0200c/206 Southwest Australia woodlands - Jasmine Milton.jpg',
                      _id: '88fef045-bd89-4faf-ad80-7fd4b3d0200c'
                    }
                  },
                  { _id: '933460a6-4952-4283-901c-8f609e61de78' },
                  { title: 'Southwest Australia Savanna' },
                  { regionId: '205' },
                  {
                    dek:
                      'The southwest savannas are a transition zone between the arid center of Australia and the long-isolated biodiversity hotspot of southwest Australia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a3d78355-838f-4251-bece-433ebdb8ba42/205 Southwest Australia savanna - Robertpaulyoung.jpg',
                      _id: 'a3d78355-838f-4251-bece-433ebdb8ba42'
                    }
                  },
                  { _id: 'a5957258-e69c-4f3d-ad80-e5f6526614aa' },
                  { title: 'Jarrah-Karri Forest and Shrublands' },
                  { regionId: '202' },
                  {
                    dek:
                      'The tall, wet forests of the southwestern tip of Australia are an isolated refuge for wet forest species separated from Australia\u2019s eastern moist forests by the arid center of the continent.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e993a232-c339-4a65-b1d9-712793898d13/202-Pemberton_Karri_haze-CC-2005.jpg',
                      _id: 'e993a232-c339-4a65-b1d9-712793898d13'
                    }
                  },
                  { _id: 'cce36dc6-674b-4ca2-99b9-174e7d44870b' },
                  { title: 'Hampton Mallee and Woodlands' },
                  { regionId: '201' },
                  {
                    dek:
                      'This ecoregion occurs on ancient marine dunes and sediments uplifted along the southern coast of Australia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ebe07373-e25c-4a48-969e-ccf7d728e7bb/201 Eucla_coast-CC-2008.jpg',
                      _id: 'ebe07373-e25c-4a48-969e-ccf7d728e7bb'
                    }
                  },
                  { _id: 'b604846f-39f5-47a7-a6a5-451a968f5168' },
                  { title: 'Flinders-Lofty Montane Woodlands' },
                  { regionId: '200' },
                  {
                    dek:
                      'North-south ranges and hills dominate this small ecoregion, situated in southern east-central Australia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/902468ce-3af3-41e6-ad7c-8cc5224c411e/200 Flinders-Lofty montane woodlands - Peripitus.jpg',
                      _id: '902468ce-3af3-41e6-ad7c-8cc5224c411e'
                    }
                  },
                  { _id: 'e12cc36e-fe4a-47f8-b281-6d90c076c051' },
                  { title: 'Eyre and Yorke Mallee' },
                  { regionId: '199' },
                  {
                    dek:
                      'The mallee woodlands and shrublands of southern Australia are hotspots for plant biodiversity, an outstanding feature of the five Mediterranean-climate regions in the world.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/567afcb6-9f04-4f0c-99bb-9a1c3c712556/Eyre Yorke.jpg',
                      _id: '567afcb6-9f04-4f0c-99bb-9a1c3c712556'
                    }
                  },
                  { _id: 'deb665ac-1d40-4951-aadc-292795ac1a15' },
                  { title: 'Esperance Mallee' },
                  { regionId: '198' },
                  {
                    dek:
                      'This ecoregion is one of the world\u2019s greatest concentrations of unique plants, being one of the richest ecoregions within the Southwest Australia (SWA) Mediterranean-climate global botanical hotspot.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ffa4e235-7255-416e-a5ba-f5f9e53403c7/198 Esperance mallee - Hughesdarren.jpg',
                      _id: 'ffa4e235-7255-416e-a5ba-f5f9e53403c7'
                    }
                  },
                  { _id: '24921623-102d-4888-9485-2b5cf436084c' },
                  { title: 'Coolgardie Woodlands' },
                  { regionId: '197' },
                  {
                    dek:
                      'This ecoregion includes a transition woodland between the Mediterranean-climate of Australia\u2019s south-west coast and the continent\u2019s arid interior.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2f25af3b-9d1f-4c07-8ed1-ef88fe14de3f/197 Coolgardie woodlands - Keren Gila 1.jpg',
                      _id: '2f25af3b-9d1f-4c07-8ed1-ef88fe14de3f'
                    }
                  }
                ],
                stats: [
                  { number: '61,867', item: 'Total Land Area (1000 ha)' },
                  { number: '8', item: 'Number of Ecoregions' },
                  { number: '54%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'East Australian Mediterranean Woodlands & Temperate Savannas (AU4)',
                children: [],
                _id: '3a464500-b752-417b-8f77-817678c56e31',
                value: 1000,
                parentId: '9e2e6a39-2aa3-4a09-8842-60c031fc6c17',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/10ae03ac-0a25-40f1-83d2-8a27f69bf721/192 Southeast_Australia_temperate_savanna Judy Christie CC.jpg',
                    _id: '10ae03ac-0a25-40f1-83d2-8a27f69bf721'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7e9f7a5d-7163-46d7-93d6-cd58bc211c79/193-Mount_Ginini_-_Namadgi_National_Park_-_CC-2006.jpg',
                    _id: '7e9f7a5d-7163-46d7-93d6-cd58bc211c79'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/66ab21f0-b461-4b92-8855-b16108684e1a/203-Ngarkat_Conservation_Park_Tyms_Lookout-CC-2006.jpg',
                    _id: '66ab21f0-b461-4b92-8855-b16108684e1a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/539be4bd-a9fb-4eec-88a3-4ca07d125c26/204 Blue_Lake,_Mount_Gambier-CC-2008.jpg',
                    _id: '539be4bd-a9fb-4eec-88a3-4ca07d125c26'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/180d138c-8b7a-4120-aa52-642fda915ece/Bioregion%20map-AU4.jpg',
                content:
                  '<p>The East Australian Mediterranean bioregion, located in the Australasia realm, is situated between the coastal forests to the east and the continent\u2019s great interior deserts to the west. It is a largely Mediterranean woodland biome but is tightly interconnected with the continent\u2019s southeastern temperate savanna. The bioregion contains four ecoregions \u2013 Australian Alps Montane Grasslands [1], Southeast Australia Temperate Savanna [2], Murray-Darling Woodlands and Mallee [3], Naracoorte Woodlands [4] \u2013 including Kangaroo Island and adjacent marine areas in Long Bay and below. Its total land area is more than 76 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/180d138c-8b7a-4120-aa52-642fda915ece/Bioregion%20map-AU4.jpg"/><figcaption><span class="caption"><p>The East Australian Mediterranean Woodlands &amp; Temperate Savannas bioregion is part of the Australia subrealm and is made up of four ecoregions: Australian Alps Montane Grasslands [1], Southeast Australia Temperate Savanna [2], Murray-Darling Woodlands and Mallee [3], Naracoorte Woodlands [4].&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace\u200b</strong></a> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bEast Australian Mediterranean Woodlands &amp; Temperate Savannas ecoregions below.</p>',
                ecoregions: [
                  { _id: 'a6c93623-6177-4c37-8ff3-78604e5ce49b' },
                  { title: 'Naracoorte Woodlands' },
                  { regionId: '204' },
                  {
                    dek:
                      'The Mediterranean-climate woodlands of the Naracoorte represent a globally-rare habitat type adapted to cool, wet winters and hot, dry summers.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b14d6250-d9b6-43e4-b562-196002055ae7/204 The_Coorong-CC-2012.JPG',
                      _id: 'b14d6250-d9b6-43e4-b562-196002055ae7'
                    }
                  },
                  { _id: '9ece7bba-57ec-49b1-a84f-50a4393c2577' },
                  { title: 'Murray-Darling Woodlands and Mallee' },
                  { regionId: '203' },
                  {
                    dek:
                      'This is one of the world\u2019s rare Mediterranean-climate ecoregions, all notable for rich concentrations of endemic plants. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8eb746f0-a1c0-449c-8be3-6742a77b11e5/203 Murray-Darling woodlands and mallee - Glen Fergus.jpg',
                      _id: '8eb746f0-a1c0-449c-8be3-6742a77b11e5'
                    }
                  },
                  { _id: '4ef103d8-66c4-4b24-b07f-bae487ef9c83' },
                  { title: 'Southeast Australia Temperate Savanna' },
                  { regionId: '192' },
                  {
                    dek:
                      'This ecoregion is a transition between the moist eastern coastal margin and the arid central interior Australia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/47076d00-0961-4201-944b-624162d6d61d/192 Southeast Australia temperate savanna - Shiftchange.jpg',
                      _id: '47076d00-0961-4201-944b-624162d6d61d'
                    }
                  },
                  { _id: 'bab61a19-d1e7-4a15-b3c5-894d6f7abd2c' },
                  { title: 'Eastern Australia Mulga Shrublands' },
                  { regionId: '191' },
                  {
                    dek:
                      'Low mulga woodlands and shrublands dominate the infertile soils of this ecoregion.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4a8217eb-581b-4bd2-8a2c-b519d868ee20/191 Eastern Australia mulga shrublands - Huygens.jpg',
                      _id: '4a8217eb-581b-4bd2-8a2c-b519d868ee20'
                    }
                  }
                ],
                stats: [
                  { number: '76,438', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '67%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              },
              {
                name: 'East Australian Temperate Forests & Mountain Shrublands (AU3)',
                children: [],
                _id: '2ed51c1f-bb8b-4c07-9293-cd0594257323',
                value: 1000,
                parentId: '9e2e6a39-2aa3-4a09-8842-60c031fc6c17',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b88de9cd-de6d-4658-8c46-da9cae6998f0/193 Australian Alps montane grasslands - Alex Cohen.jpg',
                    _id: 'b88de9cd-de6d-4658-8c46-da9cae6998f0'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/56ec5cf4-0530-4e8b-abcb-50bb8bd218b4/177 Tasmanian Central Highland forests - Einszweifrei.jpg',
                    _id: '56ec5cf4-0530-4e8b-abcb-50bb8bd218b4'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/db113bca-eb97-464c-8f2b-132cf00d7743/168 Eastern Australian temperate forests- Michael Barnett.jpg',
                    _id: 'db113bca-eb97-464c-8f2b-132cf00d7743'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c0a53f86-1b11-417e-948a-ceb1f046c3f5/Bioregion%20map-AU3%20edited%202.jpg',
                content:
                  '<p>The East Australian Temperate bioregion, located in the Australasia realm, stretches the length of the continent\u2019s east coast and includes Tasmania. It is dominated almost entirely by temperate broadleaf forests with a pocket of alpine grasslands at the top of the Australian Alps. The bioregion contains six ecoregions \u2013 Eastern Australian Temperate Forests [1], Southeast Australia Temperate Forests [2], Australian Alps Montane Grasslands [3], Tasmanian Temperate Rainforests [4], Tasmanian Central Highland Forests [5], Tasmanian Temperate Forests [6] \u2013 and adjacent marine areas in the Tasman Sea. Its total land area is more than 56 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c0a53f86-1b11-417e-948a-ceb1f046c3f5/Bioregion%20map-AU3%20edited%202.jpg"/><figcaption><span class="caption"><p>The East Australian Temperate Forests &amp; Mountain Shrublands bioregion is part of the Australia subrealm and is made up of six ecoregions: Eastern Australian Temperate Forests [1], Southeast Australia Temperate Forests [2], Australian Alps Montane Grasslands [3], Tasmanian Temperate Rainforests [4], Tasmanian Central Highland Forests [5], Tasmanian Temperate Forests [6].&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Australasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bEast Australian Temperate Forests &amp; Mountain Shrublands ecoregions below.</p>',
                ecoregions: [
                  { _id: '48c4c703-8e62-4f2c-a3ed-391005ea7747' },
                  { title: 'Australian Alps Montane Grasslands' },
                  { regionId: '193' },
                  {
                    dek:
                      'The southern portion of the Great Dividing Range in southeast Australia has peaks reaching 2,228 m, making it the highest massif on the continent and the only ecoregion with alpine ecosystems.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b88de9cd-de6d-4658-8c46-da9cae6998f0/193 Australian Alps montane grasslands - Alex Cohen.jpg',
                      _id: 'b88de9cd-de6d-4658-8c46-da9cae6998f0'
                    }
                  },
                  { _id: '63a99754-1d32-4657-ad2c-0671753fa1e9' },
                  { title: 'Tasmanian Temperate Rainforests' },
                  { regionId: '179' },
                  {
                    dek:
                      'This ecoregion includes rainforests of western Tasmania which are among the world\u2019s oldest forests.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b6434020-ef6d-468f-9b47-620b111bbd41/179 Tasmanian temperate rain forests - JJ Harrison.jpg',
                      _id: 'b6434020-ef6d-468f-9b47-620b111bbd41'
                    }
                  },
                  { _id: '92cf91e1-4c27-44b4-bca7-6708f4d5c83b' },
                  { title: 'Tasmanian Temperate Forests' },
                  { regionId: '178' },
                  {
                    dek:
                      'This ecoregion houses Eucalypt woodlands, wombats, wallaby, kangaroo, echidnas, platypus, and tasmanian devils.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d40d4fbe-9e7d-4bf0-9634-9484606b2938/178 Tasmanian temperate forests - Arvid Olson.jpg',
                      _id: 'd40d4fbe-9e7d-4bf0-9634-9484606b2938'
                    }
                  },
                  { _id: '0515ae72-17d7-44b1-9348-c59c1ef31502' },
                  { title: 'Tasmanian Central Highland Forests' },
                  { regionId: '177' },
                  {
                    dek:
                      'This ecoregion features a series of mountain peaks covered in unusual plant communities.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/56ec5cf4-0530-4e8b-abcb-50bb8bd218b4/177 Tasmanian Central Highland forests - Einszweifrei.jpg',
                      _id: '56ec5cf4-0530-4e8b-abcb-50bb8bd218b4'
                    }
                  },
                  { _id: 'cd19c207-4ea4-4c75-8592-56c3eb739100' },
                  { title: 'Southeast Australia Temperate Forests' },
                  { regionId: '176' },
                  {
                    dek:
                      'This ecoregion covers the coastal lowlands and inland tablelands that lie inland of the Great Dividing Range and Australian Alps. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/01240db7-c4ed-4b1a-bd49-ae1a769202c5/176 Southeast Australia temperate forests - Andreas Schau.jpg',
                      _id: '01240db7-c4ed-4b1a-bd49-ae1a769202c5'
                    }
                  },
                  { _id: '43d146f4-3b6b-4334-99c9-b06155517dd6' },
                  { title: 'Eastern Australian Temperate Forests' },
                  { regionId: '168' },
                  {
                    dek:
                      'This wetter coastal ecoregion has acted as refuge for wet forest species for millions of years and many endemic and relictual species occur here.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/db113bca-eb97-464c-8f2b-132cf00d7743/168 Eastern Australian temperate forests- Michael Barnett.jpg',
                      _id: 'db113bca-eb97-464c-8f2b-132cf00d7743'
                    }
                  }
                ],
                stats: [
                  { number: '56,635', item: 'Total Land Area (1000 ha)' },
                  { number: '6', item: 'Number of Ecoregions' },
                  { number: '36%', item: 'Protection Target ' },
                  { number: '6', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Australasia',
            value: 1000
          }
        ],
        parentId: 'top',
        _id: 'Australasia',
        value: 500
      },
      {
        name: 'Central America',
        children: [
          {
            _id: 'de9b02db-f71a-422a-b195-6a7bbe0640a8',
            name: 'Central America',
            children: [
              {
                name: 'Central American Isthmian & Colombian Coastal Forests (NT24)',
                children: [],
                _id: 'f1a60e1a-543e-4a09-92aa-90ac01b2f6ec',
                value: 1000,
                parentId: 'de9b02db-f71a-422a-b195-6a7bbe0640a8',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a03104b9-09ec-441c-8fe7-840a776bac76/506-Volcan_Turrialba-Eco506-CC-Jorge Antonio Leoni de Leon-2013.JPG',
                    _id: 'a03104b9-09ec-441c-8fe7-840a776bac76'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a06c6d06-5084-4ffa-a4a6-2a248b0a89cc/615 South American Pacific mangroves - Rhett Butler.jpg',
                    _id: 'a06c6d06-5084-4ffa-a4a6-2a248b0a89cc'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/31b464fd-a1ed-493c-8557-4dcaeaccfa25/506 Talamancan montane forests - Adam Timpf.jpg',
                    _id: '31b464fd-a1ed-493c-8557-4dcaeaccfa25'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/20042d59-ee7f-4400-9ad3-c20b8000230e/461-Panama Tree-eco461-CC-Ariel Rodriguez-Vargas-2014.JPG',
                    _id: '20042d59-ee7f-4400-9ad3-c20b8000230e'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/07325c0f-cc89-409d-afdf-e84163dcfc97/615-Ensenada_de_Utr\u00eda_-_Mangroven-Eco615-CC-Philipp Weigell.jpg',
                    _id: '07325c0f-cc89-409d-afdf-e84163dcfc97'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ae536a44-b5c1-4b70-86c0-42511319ffff/Bioregion%20map-NT24rev.jpg',
                content:
                  '<p>The Isthmian &amp; Colombian Coastal bioregion, located in the Central America (Neotropical) realm, consists almost entirely of dense tropical forests with dry coastal forests surrounding Panama Bay and the Gulf of Parita on the southern side of the Isthmus of Panama. From a biogeographical perspective, Central America locks into the South American continent, extending down the full extent of Colombia\u2019s Pacific coast and incorporating the humid forests of the Magdalena River valley that lies between two branches of the Northern Andes. The bioregion has nine terrestrial ecoregions \u2013 Choc\u00f3-Dari\u00e9n Moist Forests (454), Cocos Island Moist Forests (455), Eastern Panamanian Montane Forests (461), Isthmian-Atlantic Moist Forests (470), Isthmian-Pacific Moist Forests (471), Magdalena-Urab\u00e1 Moist Forests (478), Talamancan Montane Forests (506), Panamanian Dry Forests (541), Malpelo Island Xeric Scrub (604) \u2013 and includes the large marine areas and extensive mangroves of the South American Pacific Mangroves (615) and Southern Mesoamerican Pacific Mangroves (617) on either side of the Isthmus. The total area of this bioregion is more than 27 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ae536a44-b5c1-4b70-86c0-42511319ffff/Bioregion%20map-NT24rev.jpg"/><figcaption><span class="caption"><p>The Central American Isthmian &amp; Colombian Coastal Forests bioregion is part of the Central America subrealm and is made up of 11 ecoregions: (1) Isthmian-Atlantic Moist Forests (2) Southern Mesoamerican Pacific Mangroves (3) Talamancan Montane Forests (4) Isthmian-Pacific Moist Forests (5) Panamanian Dry Forests (6) Malpelo Island Xeric Scrub (7) Magdalena-Urab\u00e1 Moist Forests (8) Choc\u00f3-Dari\u00e9n Moist Forests (9) South American Pacific Mangroves (10) Eastern Panamanian Montane Forests (11) Cocos Island Moist Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Central American Isthmian &amp; Colombian Coastal Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'eee027c2-a7ca-4cd5-b4e0-c60053fef6ad' },
                  { title: 'Southern Mesoamerican Pacific Mangroves' },
                  { regionId: '617' },
                  {
                    dek:
                      'The Southern Mesoamerican Pacific Mangrove ecoregion comprises five subecoregions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/55637996-400a-46c5-a772-7483c31150c5/617 Southern Mesoamerican Pacific mangroves - Frank Hummel Birdquest.jpg',
                      _id: '55637996-400a-46c5-a772-7483c31150c5'
                    }
                  },
                  { _id: '1221ae73-2e9e-404b-9b27-c6529e8e05d7' },
                  { title: 'Mesoamerican Gulf-Caribbean Mangroves' },
                  { regionId: '613' },
                  {
                    dek:
                      'The Mesoamerican Gulf-Caribbean Mangroves ecoregion holds eleven subecoregions. The mangrove fragments remaining across this ecoregion are important refuges for many breeding and migratory species. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/36ff8596-6fab-4820-892f-bd2ff7500c9c/613 Mesoamerican Gulf-Caribbean mangroves - organizatuempressa.jpg',
                      _id: '36ff8596-6fab-4820-892f-bd2ff7500c9c'
                    }
                  },
                  { _id: '7719c919-48bd-4c40-8265-ac6962608755' },
                  { title: 'Malpelo Island Xeric Scrub' },
                  { regionId: '604' },
                  {
                    dek:
                      'Malpelo Island is a small, isolated Pacific island 435 km to the west of Colombia and south of Panama.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8b171162-9078-4030-8af1-f8d6783613c7/604 Malpelo Island xeric scrub - NOAA.jpg',
                      _id: '8b171162-9078-4030-8af1-f8d6783613c7'
                    }
                  },
                  { _id: '0cb37671-ba47-46d9-b5c0-6c736f806900' },
                  { title: 'Panamanian Dry Forests' },
                  { regionId: '541' },
                  {
                    dek:
                      'This ecoregion is distributed in distinct areas, such as small residual deciduous and semi-deciduous forests and gallery forests along the rivers.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a90f0ba2-7c92-4138-8cbd-b7590488b50d/541 Panamanian dry forests - Dirk van der Made.jpg',
                      _id: 'a90f0ba2-7c92-4138-8cbd-b7590488b50d'
                    }
                  },
                  { _id: '8d30d124-d608-4309-b23c-d0ba8d471adc' },
                  { title: 'Talamancan Montane Forests' },
                  { regionId: '506' },
                  {
                    dek:
                      'Located in the highlands of Costa Rica and western Panama, the Talamanca Montane Forests ecoregion occurs above 750 m and above 1,500 m in some places on the Pacific slope, up to approximately 3,000 m.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/31b464fd-a1ed-493c-8557-4dcaeaccfa25/506 Talamancan montane forests - Adam Timpf.jpg',
                      _id: '31b464fd-a1ed-493c-8557-4dcaeaccfa25'
                    }
                  },
                  { _id: '17bb920f-12c4-46b3-a9b5-c165f77f1d3c' },
                  { title: 'Magdalena-Urab\u00e1 Moist Forests' },
                  { regionId: '478' },
                  {
                    dek:
                      'Located in northern Colombia, the moist forests of the Magdalena-Urab\u00e1 ecoregion link the northern ecoregions of Mesoamerica and the Choc\u00f3 with the Andean and Amazonian ecoregions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/54119334-e982-4b5c-a11a-020c0f0a02c9/478 Magdalena-Urab\u00e1 moist forests - Parque Nacionales Naturales de Colombia.jpg',
                      _id: '54119334-e982-4b5c-a11a-020c0f0a02c9'
                    }
                  },
                  { _id: '107d71de-92dc-4691-b39b-b2785c41f9e4' },
                  { title: 'Isthmian-Pacific Moist Forests' },
                  { regionId: '471' },
                  {
                    dek:
                      'This ecoregion extends along the Pacific lowlands and foothills of southern Costa Rica and Panama. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ac24a184-507a-4dae-8994-13a50a7dfc0c/471 Isthmian-Pacific moist forests - Rhett Butler.jpg',
                      _id: 'ac24a184-507a-4dae-8994-13a50a7dfc0c'
                    }
                  },
                  { _id: '77473f0e-34d0-45bc-b8b8-6d522a345750' },
                  { title: 'Isthmian-Atlantic Moist Forests' },
                  { regionId: '470' },
                  {
                    dek:
                      'This ecoregion covers the lowland Atlantic slopes mainly below 500 m elevation in southern Nicaragua, northern Costa Rica, and most of Panama. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/94975d4c-6d5b-42ed-a398-78ae64e46105/Isthmian-Atlantic_moist_forests_cc.png',
                      _id: '94975d4c-6d5b-42ed-a398-78ae64e46105'
                    }
                  },
                  { _id: 'bba00760-2774-415e-bed6-fea7a11f8dc5' },
                  { title: 'Eastern Panamanian Montane Forests' },
                  { regionId: '461' },
                  {
                    dek:
                      'The eastern Panamanian Montane Forests are located in the southeastern portion of Panama, in the Dari\u00e9n Province.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/679cb01d-f93c-42c3-beff-f59f178d578d/461 Eastern Panamanian montane forests - D Olson.jpg',
                      _id: '679cb01d-f93c-42c3-beff-f59f178d578d'
                    }
                  },
                  { _id: 'b462386d-036b-47d6-827f-2879043a25ae' },
                  { title: 'Choc\u00f3-Dari\u00e9n Moist Forests' },
                  { regionId: '454' },
                  {
                    dek:
                      'This ecoregion extends from eastern Panama, in the provinces of Dari\u00e9n and Kuna-Yala, along almost the entire Pacific Coast of Colombia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bbd8a911-ce8c-4d65-a14f-c36d4e56a3b1/454 Choc\u00f3-Dari\u00e9n moist forests - C Arango.JPG',
                      _id: 'bbd8a911-ce8c-4d65-a14f-c36d4e56a3b1'
                    }
                  },
                  { _id: '43d5e898-d23d-49de-89ae-8f5619cc2ea0' },
                  { title: 'South American Pacific Mangroves' },
                  { regionId: '615' },
                  {
                    dek:
                      'The South American Pacific Mangrove ecoregion is comprised of five subecoregions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/07325c0f-cc89-409d-afdf-e84163dcfc97/615-Ensenada_de_Utri\u0301a_-_Mangroven-Eco615-CC-Philipp Weigell.jpg',
                      _id: '07325c0f-cc89-409d-afdf-e84163dcfc97'
                    }
                  }
                ],
                stats: [
                  { number: ' 27,277 ', item: 'Total Land Area (1000 ha)' },
                  { number: '11', item: 'Number of Ecoregions' },
                  { number: '64%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Yucatan & Veracruz Mixed Forests (NT27)',
                children: [],
                _id: '6b091607-18d6-4ed1-b325-eed9bddef170',
                value: 1000,
                parentId: 'de9b02db-f71a-422a-b195-6a7bbe0640a8',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4e009580-ab9d-4eae-9abc-d27ec19ddd2c/494- Usumacinta River from Yaxchilan, Chiapas, Mexico-Ec0494-CC-Thelma Datter-2011_resized.jpg',
                    _id: '4e009580-ab9d-4eae-9abc-d27ec19ddd2c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/19b6a126-fcb1-4a09-9cf2-a1b154c0464d/494-Forest_in_Tikal_Guatemala-Eco494-CC-R Harrison-2007.jpg',
                    _id: '19b6a126-fcb1-4a09-9cf2-a1b154c0464d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7564d975-9c8e-416e-8fd9-199234380672/514 Veracruz Moist Forests panza.rayada cc.jpg',
                    _id: '7564d975-9c8e-416e-8fd9-199234380672'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/968c7744-2ff2-485e-9983-17cdeeacac01/514 Veracruz Moist Forests William L. Farr cc2.jpg',
                    _id: '968c7744-2ff2-485e-9983-17cdeeacac01'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b1436264-81fc-4860-b841-c7763e9ee96a/514 Veracruz Moist Forests Carlos Adampol Galindo.jpg',
                    _id: 'b1436264-81fc-4860-b841-c7763e9ee96a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/99cc5b1e-bff3-41f0-9a53-67784393ab41/514 Veracruz Moist Forests William L. Farr cc.jpg',
                    _id: '99cc5b1e-bff3-41f0-9a53-67784393ab41'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f7de6eb2-1635-49b7-bde0-8a2b97ea16ba/Bioregion%20map-NT27.jpg',
                content:
                  '<p>The Yucatan bioregion, located in the Central America (Neotropical) realm, extends from the Pet\u00e9n Basin in central Guatemala to the beginning of the dry mesquite woodlands (mezquital) in northern Mexico, contained between the Eastern Sierra Madre mountain range and the Caribbean coast. It is dominated by the tropical moist forests of the Yucat\u00e1n Peninsula along with sections of dry forest and pine savanna. The bioregion contains nine terrestrial ecoregions \u2013 Pantanos De Centla (489), Pet\u00e9n-Veracruz Moist Forests (494), Sierra De Los Tuxtlas (501), Veracruz Moist Forests (514), Veracruz Montane Forests (515), Yucatan Moist Forests (519), Veracruz Dry Forests (550), Yucatan Dry Forests (551), Belizean Pine Savannas (564) \u2013 along with extensive Mesoamerican Gulf-Caribbean Mangroves (613). The total area of this bioregion is more than 37 million hectares, not including adjacent marine areas.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f7de6eb2-1635-49b7-bde0-8a2b97ea16ba/Bioregion%20map-NT27.jpg"/><figcaption><span class="caption"><p>The Yucatan &amp; Veracruz Mixed Forests bioregion is part of the Central America subrealm and is made up of 10 ecoregions: (1) Veracruz Moist Forests (2) Veracruz Montane Forests (3) Veracruz Dry Forests (4) Sierra De Los Tuxtlas (5) Pet\u00e9n-Veracruz Moist Forests (6) Pantanos De Centla (7) Yucatan Dry Forests (8) Yucatan Moist Forests (9) Belizean Pine Savannas (10) Mesoamerican Gulf-Caribbean Mangroves.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Yucatan &amp; Veracruz Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'db54ec96-22ee-497b-aee0-df3e2748631c' },
                  { title: 'Belizian Pine Savannas' },
                  { regionId: '564' },
                  {
                    dek:
                      'This ecoregion is found almost entirely in Belize along the northwestern coast of the Caribbean.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1543b5b3-50fc-47e7-a60d-54bbb13cb263/564 Belizian pine savannas - Reed Noss_resized.jpg',
                      _id: '1543b5b3-50fc-47e7-a60d-54bbb13cb263'
                    }
                  },
                  { _id: '5e75a7f0-d43d-4193-b76a-adf2f1816b94' },
                  { title: 'Yucatan Dry Forests' },
                  { regionId: '551' },
                  {
                    dek:
                      'This ecoregion is on the northwestern portion of the Yucat\u00e1n Peninsula in Mexico.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3f30e170-a5ab-4f64-99dc-28d9679972df/551-YucatanDryForests-Dreamstime.jpg',
                      _id: '3f30e170-a5ab-4f64-99dc-28d9679972df'
                    }
                  },
                  { _id: '65a4b750-d461-48d3-b223-b1029ef9569c' },
                  { title: 'Veracruz Dry Forests' },
                  { regionId: '550' },
                  {
                    dek:
                      'The region is in the coastal plain of central Veracruz, north of the Santa Martha and San Andr\u00e9s volcanoes.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a76c74bd-4231-4471-bc2a-1c1cfdbb1638/550 Veracruz dry forest - H\u00e9ctor David Jimeno.jpg',
                      _id: 'a76c74bd-4231-4471-bc2a-1c1cfdbb1638'
                    }
                  },
                  { _id: '7824227e-aff3-42e7-9c83-4756e24c5b6c' },
                  { title: 'Yucatan Moist Forests' },
                  { regionId: '519' },
                  {
                    dek:
                      'The Yucat\u00e1n Moist Forests are located at the junction between the physiographical provinces of Pet\u00e9n in the southeast and the Yucat\u00e1n in the northwest.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4e4517b1-2469-4862-b7d1-daa8117c94f3/519 Yucatan moist forests - Reed Noss_resized.jpg',
                      _id: '4e4517b1-2469-4862-b7d1-daa8117c94f3'
                    }
                  },
                  { _id: '7f9bcda3-8240-40d4-bfa1-e975d2fa5cff' },
                  { title: 'Veracruz Montane Forests' },
                  { regionId: '515' },
                  {
                    dek:
                      'The Veracruz Montane Forests are located in the Mexican State of Veracruz and are remnant of the Sierra Madre Oriental mountain range. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f56336cb-c7b5-4420-b9b9-e40c1832c6d5/515 Veracruz montane forests - Boligrafoazul.JPG',
                      _id: 'f56336cb-c7b5-4420-b9b9-e40c1832c6d5'
                    }
                  },
                  { _id: 'aeceff05-8e09-4701-add4-6eb91f67a0b9' },
                  { title: 'Veracruz Moist Forests' },
                  { regionId: '514' },
                  {
                    dek:
                      'This moist forest ecoregion is situated on the Gulf of Mexico\u2019s northeastern coastal plain of Mexico, in the north of Veracruz and the south of Tamaulipas states. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/11c43a56-0541-4d11-aa38-505126011df6/514 Veracruz moist forest - H\u00e9ctor David Jimeno.jpg',
                      _id: '11c43a56-0541-4d11-aa38-505126011df6'
                    }
                  },
                  { _id: '6320b8d0-4e6b-4768-a6a8-f098e2a44156' },
                  { title: 'Sierra De Los Tuxtlas' },
                  { regionId: '501' },
                  {
                    dek:
                      'Sierra de los Tuxtlas constitutes the largest and northernmost intact portion of moist forests in Mexico.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fc61fa41-5b69-4444-8fd9-6cdbb8c8ee94/501-San_martin-Eco501- CC-2006.jpg',
                      _id: 'fc61fa41-5b69-4444-8fd9-6cdbb8c8ee94'
                    }
                  },
                  { _id: '860cd843-61bf-4343-9126-e062a4ab2a6e' },
                  { title: 'Pet\u00e9n-Veracruz Moist Forests' },
                  { regionId: '494' },
                  {
                    dek:
                      'Spanning West to East along southeastern Mexico, the ecoregion narrows where the Mexican states of Veracruz, Oaxaca and Puebla meet, and continues as a wide strip of land towards the southeast.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/35507a4f-d721-4afb-9bcf-529d8f2e96c2/494 Pet\u00e9n-Veracruz moist forests - bere69.jpg',
                      _id: '35507a4f-d721-4afb-9bcf-529d8f2e96c2'
                    }
                  },
                  { _id: '455fc0bb-ee64-41d1-a3d1-7f0ac57e34b8' },
                  { title: 'Pantanos De Centla' },
                  { regionId: '489' },
                  {
                    dek: 'The Pantanos de Centla Moist Forests are in the state of Tabasco, Mexico.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9956f36b-46a5-4670-ad4d-7fe927249013/489-Pantanos_de_Centla-Eco489-CC-Alfonso Bouchot-2008.JPG',
                      _id: '9956f36b-46a5-4670-ad4d-7fe927249013'
                    }
                  },
                  { _id: '1221ae73-2e9e-404b-9b27-c6529e8e05d7' },
                  { title: 'Mesoamerican Gulf-Caribbean Mangroves' },
                  { regionId: '613' },
                  {
                    dek:
                      'The Mesoamerican Gulf-Caribbean Mangroves ecoregion holds eleven subecoregions. The mangrove fragments remaining across this ecoregion are important refuges for many breeding and migratory species. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/36ff8596-6fab-4820-892f-bd2ff7500c9c/613 Mesoamerican Gulf-Caribbean mangroves - organizatuempressa.jpg',
                      _id: '36ff8596-6fab-4820-892f-bd2ff7500c9c'
                    }
                  }
                ],
                stats: [
                  { number: '38,744', item: 'Ecoregion Size (1000 ha)' },
                  { number: '10', item: 'Number of Ecoregions' },
                  { number: '55%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'Mexican Subtropical Islands (NT29)',
                children: [],
                _id: 'f68b32b0-3ca4-4ca7-8187-6b09adffcc1d',
                value: 1000,
                parentId: 'de9b02db-f71a-422a-b195-6a7bbe0640a8',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4dcfb54b-177c-46ff-8dec-4f3e48e325ec/533 Islas Revillagigedo dry forests - Debora Barr NOAA.jpg',
                    _id: '4dcfb54b-177c-46ff-8dec-4f3e48e325ec'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9e4e65fc-1130-46fe-b317-328e9b7d7f01/568 Clipperton Island shrub and grasslands - Shannon Rankin NOAA.jpg',
                    _id: '9e4e65fc-1130-46fe-b317-328e9b7d7f01'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dc593efc-89ed-4002-9fad-e8050ff9a30b/NT29.jpg',
                content:
                  '<p>The Mexican Islands bioregion, located in the Pacific Ocean at the top of the Central America (Neotropical) realm, includes the Islas Revillagigedo just below the Baja California Peninsula as well as Clipperton Island farther south. These islands consist of tropical dry forest and shrublands with two ecoregions \u2013 Islas Revillagigedo Dry Forests (533), Clipperton Island Shrub and Grasslands (568) \u2013 as well as an important marine protected area proposed for the waters surrounding Clipperton Island. The total land area of this bioregion is approximately 24,000 hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dc593efc-89ed-4002-9fad-e8050ff9a30b/NT29.jpg"/><figcaption><span class="caption"><p>The Mexican Subtropical Islands bioregion is part of the Central America subrealm and is made up of two ecoregions: (1) Islas Revillagigedo Dry Forests (2) Clipperton Island Shrub and Grasslands.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Mexican Subtropical Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'bfa19641-3ce4-4fd3-9277-8c9ad2bcacb9' },
                  { title: 'Clipperton Island Shrub and Grasslands' },
                  { regionId: '568' },
                  {
                    dek:
                      'Clipperton Island, also referred to as \u201cIle de la Passion\u201d, falls under the jurisdiction of the Republic of French Polynesia. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9e4e65fc-1130-46fe-b317-328e9b7d7f01/568 Clipperton Island shrub and grasslands - Shannon Rankin NOAA.jpg',
                      _id: '9e4e65fc-1130-46fe-b317-328e9b7d7f01'
                    }
                  },
                  { _id: 'c635c565-0f1e-4f34-bd44-923d72209b07' },
                  { title: 'Islas Revillagigedo Dry Forests' },
                  { regionId: '533' },
                  {
                    dek:
                      'Volcanic activity from the Pleistocene gave rise to the four Revillagigedo Islands: Socorro, Clari\u00f3n, San Benedicto, and Roca Partida, located approximately 390 km southwest of Cabo San Lucas in Mexico.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4dcfb54b-177c-46ff-8dec-4f3e48e325ec/533 Islas Revillagigedo dry forests - Debora Barr NOAA.jpg',
                      _id: '4dcfb54b-177c-46ff-8dec-4f3e48e325ec'
                    }
                  }
                ],
                stats: [
                  { number: '24', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '88%', item: 'Protection Target' },
                  { number: '10', item: 'Protection Level' }
                ]
              },
              {
                name: 'Mexican Dry & Coniferous Forests (NT28)',
                children: [],
                _id: '649a89fd-2899-4ae0-8619-bd5491c05c94',
                value: 1000,
                parentId: 'de9b02db-f71a-422a-b195-6a7bbe0640a8',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4a31cb8a-6673-41db-bbc3-8608f5ec7a4e/521-Baj\u00edoDryForests-WikiCommons2.jpg',
                    _id: '4a31cb8a-6673-41db-bbc3-8608f5ec7a4e'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7c272c88-fb36-42c8-aef9-497282f2019d/557-The Cloud Forest of Santiago Comaltepec, Oaxaca, Mexico is some the best conserved in the world-Eco557-CC.JPG',
                    _id: '7c272c88-fb36-42c8-aef9-497282f2019d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/25e7c11b-f3b8-4aff-ba0c-f3e10d15147d/558-Mexican_White_Pine-Eco558-CC-2009.jpg',
                    _id: '25e7c11b-f3b8-4aff-ba0c-f3e10d15147d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4f6dd988-6be6-45bc-aef3-7979130c1f63/558-Arbutus_xalapensis-eco558-CC-Miguel Vieira-2012.jpg',
                    _id: '4f6dd988-6be6-45bc-aef3-7979130c1f63'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c7a71282-ee2b-47b7-8e3e-966b31292d00/559-Pinus_hartwegii_forest-Eco559-CC-Paco Olvera Monterd-2006.jpg',
                    _id: 'c7a71282-ee2b-47b7-8e3e-966b31292d00'
                  },
                  {
                    path:
                      "86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eb9e1d67-ea25-487f-9f75-e1f719ff1979/559-Pinus hartweggi-Hartweg's Pine-Eco559-CC-.jpg",
                    _id: 'eb9e1d67-ea25-487f-9f75-e1f719ff1979'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ff399398-4bc0-43bb-a580-157b2b5c7754/Bioregion%20map-NT28.jpg',
                content:
                  '<p>The Mexican Dry &amp; Coniferous bioregion, located in the Central America (Neotropical) realm, starts at the Isthmus of Tehuantepec and includes most of the western Sierra Madre mountain range, running the entire length of Mexico\u2019s Pacific coast. It consists entirely of tropical and subtropical dry forests and the pine-oak forests of the Sierra Madres. The bioregion contains 13 terrestrial ecoregions \u2013 Oaxacan Montane Forests (487), Baj\u00edo Dry Forests (521), Balsas Dry Forests (522), Jalisco Dry Forests (534), Sierra de la Laguna Dry Forests (544), Sinaloan Dry Forests (545), Southern Pacific Dry Forests (547), Sierra de la Laguna Pine-Oak Forests (556), Sierra Madre De Oaxaca Pine-Oak Forests (557), Sierra Madre Del Sur Pine-Oak Forests (558), Trans-Mexican Volcanic Belt Pine-Oak Forests (559), San Lucan Xeric Scrub (607), Tehuac\u00e1n Valley Matorral (610) \u2013 along with Northern Mesoamerican Pacific Mangroves (614). The total area of this bioregion is approximately 44 million hectares, not including adjacent marine areas.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ff399398-4bc0-43bb-a580-157b2b5c7754/Bioregion%20map-NT28.jpg"/><figcaption><span class="caption"><p>The Mexican Dry &amp; Coniferous Forests bioregion is part of the Central America subrealm and is made up of 14 ecoregions: (1) San Lucan Xeric Scrub (2) Sierra de la Laguna Pine-Oak Forests (3) Sierra de la Laguna Dry Forests (4) Sinaloan Dry Forests (5) Northern Mesoamerican Pacific Mangroves (6) Trans-Mexican Volcanic Belt Pine-Oak Forests (7) Jalisco Dry Forests (8) Baj\u00edo Dry Forests (9) Balsas Dry Forests (10) Sierra Madre Del Sur Pine-Oak Forests (11) Tehuac\u00e1n Valley Matorral (12) Oaxacan Montane Forests (13) Sierra Madre De Oaxaca Pine-Oak Forests (14) Southern Pacific Dry Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Mexican Dry &amp; Coniferous Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '2a6165a4-4be0-4ef4-9a6f-d9dd14407dc2' },
                  { title: 'Northern Mesoamerican Pacific Mangroves' },
                  { regionId: '614' },
                  {
                    dek:
                      'The Northwest Mexican Coast Mangroves are composed of two main mangrove areas located on the Pacific Coast and on the Gulf of California coast.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/79eb6f30-e1de-4d8d-bd5d-e5975719a3a1/614 Northern Mesoamerican Pacific mangroves -Tomas Castelazo.jpg',
                      _id: '79eb6f30-e1de-4d8d-bd5d-e5975719a3a1'
                    }
                  },
                  { _id: '5b3aa84b-cb2f-4107-8272-87a096763864' },
                  { title: 'Tehuac\u00e1n Valley Matorral' },
                  { regionId: '610' },
                  {
                    dek:
                      'The Tehuac\u00e1n Valley Matorral ecoregion is situated in southeast Puebla and northwestern Oaxaca states in Mexico.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3c08fe8d-d0f4-4d54-bb03-ffe88cf86250/610 Tehuac\u00e1n Valley matorral - Luistlatoani.JPG',
                      _id: '3c08fe8d-d0f4-4d54-bb03-ffe88cf86250'
                    }
                  },
                  { _id: '9365cfbd-f5dd-4500-bf26-87d8a1d81533' },
                  { title: 'San Lucan Xeric Scrub' },
                  { regionId: '607' },
                  {
                    dek:
                      'The San Lucan Xeric Scrub ecoregion includes the southernmost part of the Baja California peninsula. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5ebec7f9-4c35-4e49-94c2-b81ad8087401/607 San Lucan xeric scrub - D Olson_resized.jpg',
                      _id: '5ebec7f9-4c35-4e49-94c2-b81ad8087401'
                    }
                  },
                  { _id: '91ed6d86-e13a-4ad5-a62a-086207809c33' },
                  { title: 'Trans-Mexican Volcanic Belt Pine-Oak Forests' },
                  { regionId: '559' },
                  {
                    dek:
                      'The Trans-volcanic belt is a large mountain range running from west to east in the central portion of Mexico. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bb3b9498-841e-4598-b06c-2611068f2cf9/559 Trans-Mexican Volcanic Belt pine-oak forests - Julio C\u00e9sar Garc\u00eda.jpg',
                      _id: 'bb3b9498-841e-4598-b06c-2611068f2cf9'
                    }
                  },
                  { _id: 'af4248dd-1045-4d5d-9dc2-fa6958207ffc' },
                  { title: 'Sierra Madre Del Sur Pine-Oak Forests' },
                  { regionId: '558' },
                  { dek: 'Most of this ecoregion falls within the Guerrero and Oaxaca states.' },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0c268a82-dd9f-4b9d-851b-66a890906893/558  Sierra Madre del Sur pine-oak forests -James L Reveal.jpg',
                      _id: '0c268a82-dd9f-4b9d-851b-66a890906893'
                    }
                  },
                  { _id: '077ff6d2-8a68-4dae-8599-7b4f56aa5d4b' },
                  { title: 'Sierra Madre De Oaxaca Pine-Oak Forests' },
                  { regionId: '557' },
                  {
                    dek:
                      'This ecoregion is located in northern Oaxaca State, and is delineated by the Sierra Norte de Oaxaca Mountains, which have characteristically abrupt and rugged topography.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/be3af4d6-aba3-4156-8f70-36a82bb03ecb/557 Sierra Madre de Oaxaca pine-oak forests - Prisjl.JPG',
                      _id: 'be3af4d6-aba3-4156-8f70-36a82bb03ecb'
                    }
                  },
                  { _id: '2b843865-71f3-4dab-a856-bc4d7134a05f' },
                  { title: 'Sierra de la Laguna Pine-Oak Forests' },
                  { regionId: '556' },
                  {
                    dek:
                      'This ecoregion is contained in a larger area known as the Cape Region and constitutes the southernmost part of the Baja California Peninsula.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/308bcd15-a747-451b-8fab-49bf33072a62/556 Sierra de la Laguna pine-oak forests - German Ortiz Landa 7.jpg',
                      _id: '308bcd15-a747-451b-8fab-49bf33072a62'
                    }
                  },
                  { _id: '25f760dd-9226-4ada-8544-2facedfe4158' },
                  { title: 'Southern Pacific Dry Forests' },
                  { regionId: '547' },
                  {
                    dek:
                      'This ecoregion is located on the southeastern slopes of the Sierra Madre del Sur Mountains, which give way to a narrow fringe of coastal plains on which the dry forests of this ecoregion are found. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d065e79e-f467-4bc2-8ec7-b758461fddfb/547 Southern Pacific dry forests - Darvin Santos.jpg',
                      _id: 'd065e79e-f467-4bc2-8ec7-b758461fddfb'
                    }
                  },
                  { _id: 'b9aef0cc-fe43-4c8c-86c9-c510cf4563d4' },
                  { title: 'Sinaloan Dry Forests' },
                  { regionId: '545' },
                  {
                    dek:
                      'The Sinaloan Dry Forests ecoregion is situated in the northwestern Pacific coastal plain of Mexico.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ddd74e16-b2fa-437c-bd37-2be0103bee02/545 Sinaloan dry forests - D Olson.jpg',
                      _id: 'ddd74e16-b2fa-437c-bd37-2be0103bee02'
                    }
                  },
                  { _id: '2f4a1997-7062-4df5-9055-13adf14c62a2' },
                  { title: 'Sierra de la Laguna Dry Forests' },
                  { regionId: '544' },
                  {
                    dek:
                      'Located at the southern end of the Baja California peninsula, this region was once an isolated island before joining the mainland.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c58b294f-92b1-4197-85fa-4f2b83163d20/544 Sierra de la Laguna dry forests - D Olson.jpg',
                      _id: 'c58b294f-92b1-4197-85fa-4f2b83163d20'
                    }
                  },
                  { _id: '3a9b7188-c523-4748-8a9f-ceeadb9825db' },
                  { title: 'Jalisco Dry Forests' },
                  { regionId: '534' },
                  {
                    dek:
                      'The Jalisco Dry Forests are located along the Pacific coast of the Mexican states of Nayarit, Jalisco, and Colima.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a84ce5bc-238a-4292-9911-acdb25a0aaee/534 Jalisco dry forests - Aedrake09.JPG',
                      _id: 'a84ce5bc-238a-4292-9911-acdb25a0aaee'
                    }
                  },
                  { _id: 'e576b87b-44be-43c5-8b19-489c4016723f' },
                  { title: 'Balsas Dry Forests' },
                  { regionId: '522' },
                  {
                    dek:
                      'The Balsas Dry Forest ecoregion is in southern Mexico, south of the mountainous Trans-volcanic belt.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e5ab7576-8468-4487-9780-719905a74630/522 Balsas dry forests - Alvaro Gonz\u00e1lez.jpg',
                      _id: 'e5ab7576-8468-4487-9780-719905a74630'
                    }
                  },
                  { _id: 'bb4718ab-dfe5-4f93-8bed-f35804b825c8' },
                  { title: 'Baj\u00edo Dry Forests' },
                  { regionId: '521' },
                  {
                    dek:
                      'This ecoregion is situated in western central Mexico, and forms part of the central trans-volcanic belt.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e0cd3568-e661-41ef-994c-9632a426477c/521-Baji\u0301oDryForests-WikiCommons1.jpg',
                      _id: 'e0cd3568-e661-41ef-994c-9632a426477c'
                    }
                  },
                  { _id: '1b9d8419-971f-48ec-841d-d9debbcec076' },
                  { title: 'Oaxacan Montane Forests' },
                  { regionId: '487' },
                  {
                    dek:
                      'Among the largest intact montane forests of southern Mexico, this ecoregion houses the highest diversity of amphibians and reptiles in the country. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a1df048b-ee59-4053-b1d1-17ae7c86fe10/487 Oaxacan montane forest - H\u00e9ctor David Jimeno.jpg',
                      _id: 'a1df048b-ee59-4053-b1d1-17ae7c86fe10'
                    }
                  }
                ],
                stats: [
                  { number: '44,945', item: 'Total Land Area (1000 ha)' },
                  { number: '14', item: 'Number of Ecoregions' },
                  { number: '32%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Central American Mixed Forests (NT25)',
                children: [],
                _id: 'fee53c96-0c64-462d-be68-2864a804873c',
                value: 1000,
                parentId: 'de9b02db-f71a-422a-b195-6a7bbe0640a8',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/14a4ef5e-ea78-4b8f-91e8-030cd3667ca0/449 Cayos Miskitos-San Andr\u00e9s and Providencia moist forests - Luis Barreto.png',
                    _id: '14a4ef5e-ea78-4b8f-91e8-030cd3667ca0'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ea6c84e3-748a-4fc1-8f98-9c6048c6274b/Bioregion%20map-NT25rev.jpg',
                content:
                  '<p>The Mixed Forests bioregion, located in the Central America (Neotropical) realm, covers most of Nicaragua, Honduras, El Salvador, and the mountain highlands of southern Guatemala. It consists of a series of complex interlocking tropical biomes \u2013 from pine forest/grasslands and moist forests in the east to coniferous and dry forests in the west. The bioregion contains 12 terrestrial ecoregions altogether \u2013 Cayos Miskitos-San Andr\u00e9s and Providencia Moist Forests (449), Central American Atlantic Moist Forests (450), Central American Montane Forests (451), Chiapas Montane Forests (452), Chimalapas Montane Forests (453), Costa Rican Seasonal Moist Forests (458), Sierra Madre De Chiapas Moist Forests (502), Central American Dry Forests (527), Chiapas Depression Dry Forests (528), Central American Pine-Oak Forests (553), Miskito Pine Forests (573), Motagua Valley Thornscrub (605) \u2013 and includes extensive mangroves, Mesoamerican Gulf-Caribbean Mangroves (613) and Southern Mesoamerican Pacific Mangroves (617), along both the Caribbean and Pacific coastlines. The total area of this bioregion is over 36 million hectares, not including adjacent marine areas or the massive Lago Cocibolca in the south.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ea6c84e3-748a-4fc1-8f98-9c6048c6274b/Bioregion%20map-NT25rev.jpg"/><figcaption><span class="caption"><p>The Central American Mixed Forests bioregion is part of the Central America subrealm and is made up of 14 ecoregions: (1) Southern Mesoamerican Pacific Mangroves (2) Central American Dry Forests (3) Chimalapas Montane Forests (4) Sierra Madre De Chiapas Moist Forests (5) Chiapas Depression Dry Forests (6) Central American Pine-Oak Forests (7) Chiapas Montane Forests (8) Costa Rican Seasonal Moist Forests (9) Motagua Valley Thornscrub (10) Central American Atlantic Moist Forests (11) Central American Montane Forests (12) Miskito Pine Forests (13) Mesoamerican Gulf-Caribbean Mangroves (14) Cayos Miskitos-San Andr\u00e9s and Providencia Moist Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Central American Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'eee027c2-a7ca-4cd5-b4e0-c60053fef6ad' },
                  { title: 'Southern Mesoamerican Pacific Mangroves' },
                  { regionId: '617' },
                  {
                    dek:
                      'The Southern Mesoamerican Pacific Mangrove ecoregion comprises five subecoregions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/55637996-400a-46c5-a772-7483c31150c5/617 Southern Mesoamerican Pacific mangroves - Frank Hummel Birdquest.jpg',
                      _id: '55637996-400a-46c5-a772-7483c31150c5'
                    }
                  },
                  { _id: '08daa832-9e52-43c5-983a-83a24df9a888' },
                  { title: 'Miskito Pine Forests' },
                  { regionId: '573' },
                  {
                    dek:
                      'These coastal pine forests of the Caribbean coast and of the Honduras and Nicaragua lowlands contrast sharply with the surrounding tropical moist forest.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/85243e89-3477-458e-9ef4-290932ee74c0/573 Miskito pine forests - William M Ciesla Forest Health Management International.jpg',
                      _id: '85243e89-3477-458e-9ef4-290932ee74c0'
                    }
                  },
                  { _id: 'bcafd04b-3836-4aab-8fa6-dfd8112f5735' },
                  { title: 'Central American Pine-Oak Forests' },
                  { regionId: '553' },
                  {
                    dek:
                      'This ecoregion incorporates the central Mexican state of Chiapas, southern Guatemala, most of Honduras and El Salvador, and small areas of west central Nicaragua.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/59b9f201-6412-425b-a5dc-a145fa5510e2/553 Central American pine-oak forests - Gerson Rodriguez.jpg',
                      _id: '59b9f201-6412-425b-a5dc-a145fa5510e2'
                    }
                  },
                  { _id: 'dc43becc-662b-4b52-a6a5-e5d973a399bf' },
                  { title: 'Chiapas Depression Dry Forests' },
                  { regionId: '528' },
                  {
                    dek:
                      'The most extensive dry forests in the state of Chiapas, Mexico lies on a vast portion of flat lands called the Central Chiapas Depression. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6f30f615-91e6-4a6d-93b7-04d582f784ba/528 Chiapas Depression dry forests - Thelmadatter.jpg',
                      _id: '6f30f615-91e6-4a6d-93b7-04d582f784ba'
                    }
                  },
                  { _id: '23021591-17fe-47e6-b2d8-e3578a880c69' },
                  { title: 'Central American Dry Forests' },
                  { regionId: '527' },
                  {
                    dek:
                      'The Central American Dry forest ecoregion stretches along the Pacific Coast of southern Chiapas, Mexico to Guanacaste, Costa Rica.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7ef7e08e-c11d-4e47-be78-9adb3e03c483/527 Central American dry forests - Gregoire Dubois.jpg',
                      _id: '7ef7e08e-c11d-4e47-be78-9adb3e03c483'
                    }
                  },
                  { _id: '2c62093f-4c6f-4fcf-8dcc-3dc665be4695' },
                  { title: 'Sierra Madre De Chiapas Moist Forests' },
                  { regionId: '502' },
                  {
                    dek:
                      'The species rich and diverse moist forests of Chiapas lie on both sides of the Sierra Madre de Chiapas.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eee4fae4-6abb-4dad-9da1-d8bee8a5f1b8/502 El_Triunfo_Chiapas-CC-Medicen alo-2017_resized.jpg',
                      _id: 'eee4fae4-6abb-4dad-9da1-d8bee8a5f1b8'
                    }
                  },
                  { _id: '9965208b-b3ea-4648-800f-673197d3ee49' },
                  { title: 'Costa Rican Seasonal Moist Forests' },
                  { regionId: '458' },
                  {
                    dek:
                      'The Costa Rican Seasonal Moist Forests ecoregion is a transitional subtropical habitat between the surrounding wet and dry forest ecoregions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9865df8e-ef32-4067-9361-f6f3297527cd/458 Costa Rican Seasonal Moist Forest - Liz Roy.jpg',
                      _id: '9865df8e-ef32-4067-9361-f6f3297527cd'
                    }
                  },
                  { _id: '8296ac19-49eb-4841-bfae-7b1945a68511' },
                  { title: 'Cocos Island Moist Forests' },
                  { regionId: '455' },
                  {
                    dek:
                      'Cocos Island in the central eastern Pacific Ocean lies 523 km southwest of Cabo Blanco, in Costa Rica.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fc875f5d-1eb6-44fd-b74e-9cedb5b6535b/455 Cocos Island moist forests - J Rawl S.jpg',
                      _id: 'fc875f5d-1eb6-44fd-b74e-9cedb5b6535b'
                    }
                  },
                  { _id: '8bd569f7-067d-4a8a-b11a-59ceea73ac96' },
                  { title: 'Chimalapas Montane Forests' },
                  { regionId: '453' },
                  {
                    dek:
                      'The Chimalapas Montane Forests occur in mountains above approximately 1,000 m at the junction of the three most biodiverse states of Mexico: Veracruz, Oaxaca, and Chiapas.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/53f8bd34-ab92-48c6-b9a1-48679f4bbc3b/453 Chimalapas montane forests - Mario Jimenez Leyva.jpg',
                      _id: '53f8bd34-ab92-48c6-b9a1-48679f4bbc3b'
                    }
                  },
                  { _id: '408c9170-393d-4f08-b289-aebef80f0df9' },
                  { title: 'Chiapas Montane Forests' },
                  { regionId: '452' },
                  {
                    dek:
                      'This ecoregion is located in the state of Chiapas, Mexico, on the northeast mountain range, with elevations from 1,200-2,200 m.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bae50109-1a16-40ca-9e94-407ffe004dc7/452 Chiapas montane forests - Danj _ Ana.jpg',
                      _id: 'bae50109-1a16-40ca-9e94-407ffe004dc7'
                    }
                  },
                  { _id: '52b77bf5-6d68-4000-8a17-67be977028a1' },
                  { title: 'Central American Montane Forests' },
                  { regionId: '451' },
                  {
                    dek:
                      'The Central American Montane Forests ecoregion comprised of more than 40 relatively small islands extending from southern Mexico towards the southeast through Guatemala, El Salvador, Honduras, and Nicaragua. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/84e8b6b2-a4bc-4def-8f11-74619e249740/451 Central American montane forests - Gerson Rodriguez.jpg',
                      _id: '84e8b6b2-a4bc-4def-8f11-74619e249740'
                    }
                  },
                  { _id: '9e58b172-4a97-400f-b3ad-802581c565ab' },
                  { title: 'Central American Atlantic Moist Forests' },
                  { regionId: '450' },
                  {
                    dek:
                      'This ecoregion is located along the Caribbean lowlands of Central America through southeast Guatemala.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/032170a8-c8c0-47b0-9031-f0ada55405c3/450 Central American Atlantic moist forests - Rebecca Ore.jpg',
                      _id: '032170a8-c8c0-47b0-9031-f0ada55405c3'
                    }
                  },
                  { _id: 'eba8e092-9d37-4908-b83c-8777ad8543d0' },
                  { title: 'Cayos Miskitos-San Andr\u00e9s and Providencia Moist Forests' },
                  { regionId: '449' },
                  {
                    dek:
                      'This ecoregion is formed by the moist forests of the Cayos Miskitos, San Andr\u00e9s, and Providencia Islands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/14a4ef5e-ea78-4b8f-91e8-030cd3667ca0/449 Cayos Miskitos-San Andr\u00e9s and Providencia moist forests - Luis Barreto.png',
                      _id: '14a4ef5e-ea78-4b8f-91e8-030cd3667ca0'
                    }
                  },
                  { _id: '1221ae73-2e9e-404b-9b27-c6529e8e05d7' },
                  { title: 'Mesoamerican Gulf-Caribbean Mangroves' },
                  { regionId: '613' },
                  {
                    dek:
                      'The Mesoamerican Gulf-Caribbean Mangroves ecoregion holds eleven subecoregions. The mangrove fragments remaining across this ecoregion are important refuges for many breeding and migratory species. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/36ff8596-6fab-4820-892f-bd2ff7500c9c/613 Mesoamerican Gulf-Caribbean mangroves - organizatuempressa.jpg',
                      _id: '36ff8596-6fab-4820-892f-bd2ff7500c9c'
                    }
                  },
                  { _id: '5dfb2e7a-b715-4c49-9243-fee85d36c848' },
                  { title: 'Motagua Valley Thornscrub' },
                  { regionId: '605' },
                  {
                    dek:
                      'The Motagua Valley is situated in northeastern Guatemala along the border of Honduras.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9f137bc3-653b-4c07-afce-4affdc59f031/605 Motagua Valley thornscrub - Kymacpherson.jpg',
                      _id: '9f137bc3-653b-4c07-afce-4affdc59f031'
                    }
                  }
                ],
                stats: [
                  { number: '36,709', item: 'Total Land Area (1000 ha)' },
                  { number: '14', item: 'Number of Ecoregions' },
                  { number: '57%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Central America',
            value: 1000
          },
          {
            _id: '24b1806f-c397-44ec-b8a6-81b1d857f901',
            name: 'Caribbean',
            children: [
              {
                name: 'Caribbean Islands (NT26)',
                children: [],
                _id: 'e3dbd75d-cc02-4da4-8df6-a4c484b84e65',
                value: 1000,
                parentId: '24b1806f-c397-44ec-b8a6-81b1d857f901',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8a1245fb-ce66-4a09-91eb-86e0c35b744e/475 Leeward Islands Moist Forests Kouakou ph cc.jpg',
                    _id: '8a1245fb-ce66-4a09-91eb-86e0c35b744e'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f05255cf-882f-47a8-90cf-c34c739d489c/495-Rain_Forest_of_El_Yunque,_Puerto_Rico-CC-Alessandro Cali-2006.jpg',
                    _id: 'f05255cf-882f-47a8-90cf-c34c739d489c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c16c1eb4-df09-45a4-b039-5a605f651553/530-Mogote-Valle de Vinales-Cuba-CC-2007.jpg',
                    _id: 'c16c1eb4-df09-45a4-b039-5a605f651553'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7d57dc29-3c4b-4b66-ba0f-925a632972f8/530-Karst_Mountain_in_Pinar_del_Rio_Province_-_Cuba-Eco530-CC-Adam Jones-2009.JPG',
                    _id: '7d57dc29-3c4b-4b66-ba0f-925a632972f8'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1cf8755e-d127-4853-b6d4-6c1195e8fe2b/Bioregion%20map-NT26.jpg',
                content:
                  '<p>The Caribbean Islands bioregion, located in the Central America (Neotropical) realm, incorporates all 700 of the islands and islets of the Caribbean Sea, with the exception of Aruba, Cura\u00e7ao, and other small islands just off the coast of Venezuela. It also includes the Everglades in the southern tip of Florida, which demarcates the transition between the Nearctic and Neotropical realms. The islands contain a mixture of dry and moist forests, both broadleaf and conifer, surrounded by mangroves. The largest island, Cuba, is mostly dry broadleaf forest with extensive flooded grasslands and some cactus scrub. The bioregion contains 19 terrestrial ecoregions altogether \u2013 Cuban Moist Forests (459), Hispaniolan Moist Forests (468), Jamaican Moist Forests (472), Leeward Islands Moist Forests (475), Puerto Rican Moist Forests (495), Windward Islands Moist Forests (517), Cuban Dry Forests (530), Hispaniolan Dry Forests (532), Jamaican Dry Forests (535), Lesser Antillean Dry Forests (537), Puerto Rican Dry Forests (543), Bahamian Pineyards (552), Cuban Pine Forests (554), Hispaniolan Pine Forests (555), Cuban Wetlands (579), Enriquillo Wetlands (580), Everglades Flooded Grasslands (581), Caribbean Shrublands (599), Cuban Cactus Scrub (600) \u2013 with extensive mangroves, including the Bahamian-Antillean Mangroves (612), across all the islands. The total area of this bioregion is over 24 million hectares, not including adjacent marine areas.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1cf8755e-d127-4853-b6d4-6c1195e8fe2b/Bioregion%20map-NT26.jpg"/><figcaption><span class="caption"><p>The Caribbean Islands bioregion is part of the Caribbean subrealm and is made up of 20 ecoregions: (1) Everglades Flooded Grasslands (2) Bahamian-Antillean Mangroves (3) Bahamian Pineyards (4) Cuban Pine Forests (5) Cuban Moist Forests (6) Cuban Cactus Scrub (7) Cuban Dry Forests (8) Cuban Wetlands (9) Jamaican Moist Forests (10) Jamaican Dry Forests (11) Hispaniolan Dry Forests (12) Hispaniolan Moist Forests (13) Hispaniolan Pine Forests (14) Enriquillo Wetlands (15) Puerto Rican Moist Forests (16) Puerto Rican Dry Forests (17) Leeward Islands Moist Forests (18) Caribbean Shrublands (19) Lesser Antillean Dry Forests (20) Windward Islands Moist Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Caribbean Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'fdebc4ec-2c2d-4cc5-bb4b-3ff53bf57bf1' },
                  { title: 'Puerto Rican Moist Forests' },
                  { regionId: '495' },
                  {
                    dek:
                      'Montane forests cover the Sierra de Luquillo and the higher peaks of the Cordillera Central.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/962aee03-1b40-4fab-b8b5-4f39c288973f/495 Puerto Rican moist forests - Gregoire Dubois.jpg',
                      _id: '962aee03-1b40-4fab-b8b5-4f39c288973f'
                    }
                  },
                  { _id: '29bce74b-41b2-494d-9b45-9523062fcf13' },
                  { title: 'Bahamian-Antillean Mangroves' },
                  { regionId: '612' },
                  {
                    dek:
                      'The Bahamas islands ecoregion consist of over 3,000 low-lying islands with a maximum elevation of 60 m.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9411e29f-3553-4991-8dd9-f20c6260a91e/612 Bahamian-Antillean mangroves - Anton Bielousov.jpeg',
                      _id: '9411e29f-3553-4991-8dd9-f20c6260a91e'
                    }
                  },
                  { _id: '759410fa-7a40-4cce-8425-7de613608462' },
                  { title: 'Cuban Cactus Scrub' },
                  { regionId: '600' },
                  {
                    dek:
                      'This ecoregion is dispersed in strips or small patches along Cuba\u2019s shore, particularly in the southeastern part of the island. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a1bb9cc6-ce15-4112-be3c-5e1c88dab4ff/600 Cuban cactus scrub - Jeshua Nace.jpg',
                      _id: 'a1bb9cc6-ce15-4112-be3c-5e1c88dab4ff'
                    }
                  },
                  { _id: '669661e0-aa3c-4822-add8-a4f3d797a816' },
                  { title: 'Caribbean Shrublands' },
                  { regionId: '599' },
                  {
                    dek:
                      'This ecoregion includes the Leeward Islands, specifically most of Grande Terre and Marie-Galante of Guadeloupe, Antigua, Anguilla, St. Martin, St. Barthelemy, Saba, and the eastern portions of the US and British Virgin Islands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/164e7e0d-7bc1-46c0-8043-0f923c8bd759/599 Caribbean shrublands - Tria Denis.jpg',
                      _id: '164e7e0d-7bc1-46c0-8043-0f923c8bd759'
                    }
                  },
                  { _id: '4007d643-a5bd-4f81-8bd2-61f793796c63' },
                  { title: 'Everglades Flooded Grasslands' },
                  { regionId: '581' },
                  {
                    dek:
                      'The Everglades, located at the southern tip of peninsular Florida, is the most well-known wetland in the United States and one of the most distinct in the world.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6d5f507e-0711-4b6e-b1d8-3122b79fa8b5/581-Everglades_Sawgrass_Prairie-CC-2007.JPG',
                      _id: '6d5f507e-0711-4b6e-b1d8-3122b79fa8b5'
                    }
                  },
                  { _id: 'bbf73bec-0a09-4353-9e0f-61e5ba170eff' },
                  { title: 'Enriquillo Wetlands' },
                  { regionId: '580' },
                  {
                    dek:
                      'This ecoregion is primarily composed of lakes, lake islands, and surrounding habitats. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1d237a4f-e700-4745-bbd2-e2ca689a62c4/580 Enriquillo wetlands - Tim Ross.jpg',
                      _id: '1d237a4f-e700-4745-bbd2-e2ca689a62c4'
                    }
                  },
                  { _id: '71306fca-f5c7-4e9a-848b-3fd8c8006cd4' },
                  { title: 'Cuban Wetlands' },
                  { regionId: '579' },
                  {
                    dek:
                      'Most of Cuba\u2019s wetlands are located on floodplains and depressions influenced by the tides.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ae821101-0f40-4b2e-a199-857d1b786be1/579 Cuban wetlands - David _ Edel Tryse.jpg',
                      _id: 'ae821101-0f40-4b2e-a199-857d1b786be1'
                    }
                  },
                  { _id: '119a53f4-fb52-4a9f-bfef-a575c9f06a5d' },
                  { title: 'Hispaniolan Pine Forests' },
                  { regionId: '555' },
                  {
                    dek:
                      'The pine forests of this ecoregion are located on slopes with shallow soils and at higher elevations in the Hispaniolan mountain systems. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0ada3fec-5f86-4c8e-94b4-9698dafbbd0b/555 Hispaniolan pine forests Cuyaya.jpg',
                      _id: '0ada3fec-5f86-4c8e-94b4-9698dafbbd0b'
                    }
                  },
                  { _id: 'b097fcc2-fdbb-4e09-a865-f44f27c78524' },
                  { title: 'Cuban Pine Forests' },
                  { regionId: '554' },
                  {
                    dek:
                      'The Cuban Pine Forests are located on the eastern and western sides of the island in the province of Isla de la Juventud and Pinar del R\u00edo.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8d7ffa97-7da4-43a3-ae89-ac55593d3158/554 Cuban pine forests - Lagaly_de.jpg',
                      _id: '8d7ffa97-7da4-43a3-ae89-ac55593d3158'
                    }
                  },
                  { _id: '28143af0-8029-4207-bac6-6001ffb35ea5' },
                  { title: 'Bahamian Pineyards' },
                  { regionId: '552' },
                  {
                    dek:
                      'This ecoregion is found in varying proportions on the northern Bahamian islands of Grand Bahama, Abaco, Andros, New Providence in the Bahamas, and the Caicos Islands of North and Middle Caicos and Pine Cay.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/824d067f-2b4b-4d3d-ae51-f2a8f58616f2/552_Bahamas pine_2_jennie-wren (via iNaturalist).jpg',
                      _id: '824d067f-2b4b-4d3d-ae51-f2a8f58616f2'
                    }
                  },
                  { _id: '9a7cb121-4e64-4c04-b87e-c82888c5ed84' },
                  { title: 'Puerto Rican Dry Forests' },
                  { regionId: '543' },
                  {
                    dek:
                      'The Puerto Rican Dry Forests ecoregion is located along the south-central and southwestern coast of Puerto Rico and on the adjacent islands of Mona, Vieques, Culebra, Desecheo, and Caja de Muertos.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7f6dc517-6466-406d-a506-94d160b6591f/543 Puerto Rican dry forests - Gregoire Dubois.jpg',
                      _id: '7f6dc517-6466-406d-a506-94d160b6591f'
                    }
                  },
                  { _id: '6fbb3814-e4c2-4bdc-a5ad-a81ed3c61bc1' },
                  { title: 'Lesser Antillean Dry Forests' },
                  { regionId: '537' },
                  {
                    dek:
                      'This ecoregion covers small portions of the Caribbean\u2019s Leeward Islands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1a9fdc31-b004-4ae4-a873-2406b59fc455/537-LesserAntilleanDryForests-Dreamstime.jpg',
                      _id: '1a9fdc31-b004-4ae4-a873-2406b59fc455'
                    }
                  },
                  { _id: 'e70ceb37-99c1-4b68-9dc9-774dd4bd6800' },
                  { title: 'Jamaican Dry Forests' },
                  { regionId: '535' },
                  {
                    dek:
                      'This ecoregion comprises approximately 15% of the land area on the island and covers most of the dry forests near the coast.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5b977139-a2d8-446b-9861-0824e1b17759/534-JamaicanDryForests-Dreamstime.jpg',
                      _id: '5b977139-a2d8-446b-9861-0824e1b17759'
                    }
                  },
                  { _id: '3993a7a7-04ee-4390-86e4-a532084cd4c5' },
                  { title: 'Hispaniolan Dry Forests' },
                  { regionId: '532' },
                  {
                    dek:
                      'The areas occupied by this ecoregion are located throughout the western two thirds of the island of Hispaniola, making up about 20% of the vegetation. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d4959822-937f-44a3-ae11-fc15628f6f26/532 Hispaniolan dry forests - lassensurf.jpg',
                      _id: 'd4959822-937f-44a3-ae11-fc15628f6f26'
                    }
                  },
                  { _id: '90d52797-98ab-4459-940b-67586da7a31f' },
                  { title: 'Cuban Dry Forests' },
                  { regionId: '530' },
                  {
                    dek:
                      'This ecoregion contains 141 bird species, 11 of them endemic to the island, and some of which are endangered.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1ccf7887-ebf3-4775-b323-1ea51fe781e2/530 Cuban dry forests - Juan Campesino.jpg',
                      _id: '1ccf7887-ebf3-4775-b323-1ea51fe781e2'
                    }
                  },
                  { _id: '8871ceca-887a-4018-a162-3f4f903b095b' },
                  { title: 'Windward Islands Moist Forests' },
                  { regionId: '517' },
                  {
                    dek:
                      'The Windward Island Moist Forests ecoregion is found in much of the central portion of each of the Caribbean\u2019s Windward Islands and is characterized by rugged mountains, lush tropical vegetation, and high annual rainfall.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dcd18de1-73fd-4b32-a6d0-090d2f10384a/517 Windward Islands moist forests -frameme-commonswiki.JPG',
                      _id: 'dcd18de1-73fd-4b32-a6d0-090d2f10384a'
                    }
                  },
                  { _id: '68af9e8d-4a90-4d54-b6a8-e679dc199623' },
                  { title: 'Leeward Islands Moist Forests' },
                  { regionId: '475' },
                  {
                    dek:
                      'This ecoregion is found in various proportions on the Caribbean\u2019s Leeward Islands characterized by rugged volcanic mountains covered in moist tropical forest.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d2694c32-3330-4bdd-8477-47c750a854e7/475 Leeward Islands moist forests - Nicolas Vilars.jpg',
                      _id: 'd2694c32-3330-4bdd-8477-47c750a854e7'
                    }
                  },
                  { _id: 'a418c0c0-abfb-4ad4-b17e-d770e57bb14e' },
                  { title: 'Jamaican Moist Forests' },
                  { regionId: '472' },
                  {
                    dek:
                      'This ecoregion comprises approximately 85% of Jamaica\u2019s land area covering most of the island except coastal areas and lowland dry forests.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/818b16b7-ecf8-4a22-8782-6f1bfa275ba5/472 Jamaican moist forests - wolmadrian.jpg',
                      _id: '818b16b7-ecf8-4a22-8782-6f1bfa275ba5'
                    }
                  },
                  { _id: 'a914f8e4-0d2c-4e89-b5d4-20394542018d' },
                  { title: 'Hispaniolan Moist Forests' },
                  { regionId: '468' },
                  {
                    dek:
                      'The endangered Hispaniolan solenodon is endemic to its namesake island with much of its suitable habitat falling in this ecoregion.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3d6b35a8-ea54-4ce7-9dd1-eabe1d24f2a6/468 Los_Haitises_Park-CC-Anton Bielousov-2012.jpeg',
                      _id: '3d6b35a8-ea54-4ce7-9dd1-eabe1d24f2a6'
                    }
                  },
                  { _id: '5de8d5f6-32df-4ec7-8451-b281ccd14e6b' },
                  { title: 'Cuban Moist Forests' },
                  { regionId: '459' },
                  {
                    dek:
                      'This ecoregion is distributed in multiple patches of different sizes along the ranges and highlands of the island of Cuba.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6c212092-5189-4714-a917-a9619f03819d/459 Cuban moist forests - Anagoria.JPG',
                      _id: '6c212092-5189-4714-a917-a9619f03819d'
                    }
                  }
                ],
                stats: [
                  { number: '24,122', item: 'Total Land Area (1000 ha)' },
                  { number: '20', item: 'Number of Ecoregions' },
                  { number: '48%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Central America',
            value: 200
          }
        ],
        parentId: 'top',
        _id: 'Central America',
        value: 333
      },
      {
        name: 'Central Eurasia',
        children: [
          {
            _id: 'a74ab6eb-9b56-448a-8c1d-e76525fa9cb3',
            name: 'Persian Deserts & Forests',
            children: [
              {
                name: 'Afghan-Balochistan Drylands, Mountain Meadows & Conifer Forests (PA30)',
                children: [],
                _id: '2fd8739f-ae96-4caf-8185-863f8d31f74a',
                value: 1000,
                parentId: 'a74ab6eb-9b56-448a-8c1d-e76525fa9cb3',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/61ba501c-d835-4128-b427-0bf507038809/BaluchistanXericSoodlands-WikiCommons.JPG',
                    _id: '61ba501c-d835-4128-b427-0bf507038809'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1542843a-1326-466b-958d-25296e565d3c/694 East Afghan montane conifer forests - Brian Christiansen.jpg',
                    _id: '1542843a-1326-466b-958d-25296e565d3c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d220259a-f255-4062-bf6f-9134d9cb5f49/752 Ghorat-Hazarajat alpine meadow - USAID.jpg',
                    _id: 'd220259a-f255-4062-bf6f-9134d9cb5f49'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a89068df-5269-42ef-8cd3-423d205d14de/807 Afghan Mountains semi-desert - AlfredoGmx.jpg',
                    _id: 'a89068df-5269-42ef-8cd3-423d205d14de'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f4f40fa8-2ebf-415d-b6c9-ed965111e5dc/813 Badghyz and Karabil semi-desert - koldo hormaza.jpg',
                    _id: 'f4f40fa8-2ebf-415d-b6c9-ed965111e5dc'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bc7c8b14-3276-4d1d-b1cd-1032c5edf403/Bioregion%20map-PA30.jpg',
                content:
                  '<p>The Afghan-Balochistan Drylands, Mountain Meadows &amp; Conifer Forests bioregion is located in the Central Eurasia realm (central Palearctic) and contains eight ecoregions \u2013 East Afghan Montane Conifer Forests (694), Ghorat-Hazarajat Alpine Meadow (752), Sulaiman Range Alpine Meadows (766), Afghan Mountains Semi-Desert (807), Badghyz and Karabil Semi-Desert (813), Balochistan Xeric Woodlands (814), Central Afghan Mountains Xeric Woodlands (816), Paropamisus Xeric Woodlands (834) \u2013 totaling approximately 78 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bc7c8b14-3276-4d1d-b1cd-1032c5edf403/Bioregion%20map-PA30.jpg"/><figcaption><span class="caption"><p>The Afghan-Balochistan Drylands, Mountain Meadows &amp; Conifer Forests bioregion is part of the Persian Deserts &amp; Forests subrealm and is made up of eight ecoregions: (1) Badghyz and Karabil Semi-Desert (2) Paropamisus Xeric Woodlands (3) Afghan Mountains Semi-Desert (4) Ghorat-Hazarajat Alpine Meadow (5) Central Afghan Mountains Xeric Woodlands (6) East Afghan Montane Conifer Forests (7) Sulaiman Range Alpine Meadows (8) Balochistan Xeric Woodlands.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Afghan-Balochistan Drylands, Mountain Meadows &amp; Conifer Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'd4d59d85-59cf-4774-96eb-491284a8d235' },
                  { title: 'Paropamisus Xeric Woodlands' },
                  { regionId: '834' },
                  {
                    dek:
                      'This ecoregion is located mostly in Northern Afghanistan on the central mountains, where higher altitudes and more rainfall permit open xeric woodlands to thrive.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4cf2d51b-1751-462d-92da-09d3b6787c4e/834 Paropamisus xeric woodlands - Julian-G Albert.jpg',
                      _id: '4cf2d51b-1751-462d-92da-09d3b6787c4e'
                    }
                  },
                  { _id: '8cec15c4-fb83-46ee-8a34-a86e917e7822' },
                  { title: 'Central Afghan Mountains Xeric Woodlands' },
                  { regionId: '816' },
                  {
                    dek:
                      'This ecoregion forms a broad crescent shapes belt surrounding the eastern and southern sides of the Afghan central mountains. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/12976637-f64f-4401-b7b3-3d215dde0020/816 Central Afghan Mountains xeric woodlands - Uploader.jpg',
                      _id: '12976637-f64f-4401-b7b3-3d215dde0020'
                    }
                  },
                  { _id: '44a98582-d2bf-46a8-8496-889fbd285734' },
                  { title: 'Baluchistan Xeric Woodlands' },
                  { regionId: '814' },
                  {
                    dek:
                      'This ecoregion extends from the Las Bela Valley and high plateaus of Baluchistan Province in southwest Pakistan and southeastern Afghanistan north to the Trans-Indus Plains of the North-West Frontier Province.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4504c451-d7e2-4ce4-ba59-a05c5874f58d/BaluchistanXericSoodlands-WikiCommons2.jpg',
                      _id: '4504c451-d7e2-4ce4-ba59-a05c5874f58d'
                    }
                  },
                  { _id: '84745994-2e39-4492-9baf-137fe84ee90d' },
                  { title: 'Badghyz and Karabil Semi-Desert' },
                  { regionId: '813' },
                  {
                    dek:
                      'This ecoregion stretches through the hilly plateaus north of the Paropamiz mountain, part of the Hindu Kush range.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f4f40fa8-2ebf-415d-b6c9-ed965111e5dc/813 Badghyz and Karabil semi-desert - koldo hormaza.jpg',
                      _id: 'f4f40fa8-2ebf-415d-b6c9-ed965111e5dc'
                    }
                  },
                  { _id: '4d0fd1ff-e3df-4227-a173-91d0c432494c' },
                  { title: 'Afghan Mountains Semi-Desert' },
                  { regionId: '807' },
                  {
                    dek:
                      'This ecoregion is made up of three disjunct areas of small, dry valleys along the slopes of Hindu Kush mountain range in Afghanistan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a89068df-5269-42ef-8cd3-423d205d14de/807 Afghan Mountains semi-desert - AlfredoGmx.jpg',
                      _id: 'a89068df-5269-42ef-8cd3-423d205d14de'
                    }
                  },
                  { _id: '4573b2b2-4e3d-41e8-93bd-07dcae23ca54' },
                  { title: 'Sulaiman Range Alpine Meadows' },
                  { regionId: '766' },
                  {
                    dek:
                      'This disjunct ecoregion covers the alpine meadows of the high elevations, above 1,500 m of the Sulaiman Range.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/48fcb1e2-5d73-44c7-ba74-bfeee5c27eb3/766 Sulaiman Range alpine meadows - Hayatullah Khan Durrani.JPG',
                      _id: '48fcb1e2-5d73-44c7-ba74-bfeee5c27eb3'
                    }
                  },
                  { _id: '7e648af2-c85b-4cac-97b6-97d3c82d249f' },
                  { title: 'Ghorat-Hazarajat Alpine Meadow' },
                  { regionId: '752' },
                  {
                    dek:
                      'This ecoregion follows the western extension of the subalpine thickets and Cushion Shrubland floristic unit and is made up of several distinct parts.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d220259a-f255-4062-bf6f-9134d9cb5f49/752 Ghorat-Hazarajat alpine meadow - USAID.jpg',
                      _id: 'd220259a-f255-4062-bf6f-9134d9cb5f49'
                    }
                  },
                  { _id: '3989a8fb-6739-44bb-b516-51ce3cbc6751' },
                  { title: 'East Afghan Montane Conifer Forests' },
                  { regionId: '694' },
                  {
                    dek:
                      'This ecoregion spans from the Eastern Hindu Kush mountain range in Afghanistan to the Central North of Pakistan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1542843a-1326-466b-958d-25296e565d3c/694 East Afghan montane conifer forests - Brian Christiansen.jpg',
                      _id: '1542843a-1326-466b-958d-25296e565d3c'
                    }
                  }
                ],
                stats: [
                  { number: '78,022', item: 'Total Land Area (1000 ha)' },
                  { number: '8', item: 'Number of Ecoregions' },
                  { number: '8%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Persian Deserts & Mountain Woodlands (PA29)',
                children: [],
                _id: '09e3d004-8f50-4dfb-923a-73d6af2f9818',
                value: 1000,
                parentId: 'a74ab6eb-9b56-448a-8c1d-e76525fa9cb3',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/269dd324-5b1b-46f7-b5aa-7bd676b10187/820-Dasht-e_Kavir-Iran- CC-Klara Novakova-2014.JPG',
                    _id: '269dd324-5b1b-46f7-b5aa-7bd676b10187'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9e098d34-8fc2-4274-b02e-b96622d7b29f/841-Mount_of_Saint_Catherine-CC-2007.jpg',
                    _id: '9e098d34-8fc2-4274-b02e-b96622d7b29f'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3016e17a-1944-4faa-9864-931656e4f5c9/838 Registan-North Pakistan sandy desert- Mouliric.jpg',
                    _id: '3016e17a-1944-4faa-9864-931656e4f5c9'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dd3307a2-8c70-41c0-8bc8-323a90c68c60/Bioregion-map-PA29.webp',
                content:
                  '<p>The Persian Deserts &amp; Mountain Woodlands bioregion is located in the Central Eurasia realm (central Palearctic) and contains four ecoregions \u2013 Kuh Rud and Eastern Iran Montane Woodlands (757), Central Persian Desert Basins (820), Registan-North Pakistan Sandy Desert (838), South Iran Nubo-Sindian Desert and Semi-Desert (841) \u2013 totaling approximately 134 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dd3307a2-8c70-41c0-8bc8-323a90c68c60/Bioregion-map-PA29.webp"/><figcaption><span class="caption"><p>The Persian Deserts &amp; Mountain Woodlands bioregion is part of the Persian Deserts &amp; Forests subrealm and is made up of four ecoregions: (1) Central Persian Desert Basins (2) Kuh Rud and Eastern Iran Montane Woodlands (3) Registan-North Pakistan Sandy Desert (4) South Iran Nubo-Sindian Desert and Semi-Desert.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Persian Deserts &amp; Mountain Woodlands ecoregions below.</p>',
                ecoregions: [
                  { _id: '3c304a68-a111-4532-b330-8efe440e8b69' },
                  { title: 'Registan-North Pakistan Sandy Desert' },
                  { regionId: '838' },
                  {
                    dek:
                      'This ecoregion spans southern Afghanistan, extreme eastern Iran, and part of Northwest Pakistan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3016e17a-1944-4faa-9864-931656e4f5c9/838 Registan-North Pakistan sandy desert- Mouliric.jpg',
                      _id: '3016e17a-1944-4faa-9864-931656e4f5c9'
                    }
                  },
                  { _id: 'fde620cb-5385-4dd6-a960-4ea4660435b2' },
                  { title: 'Central Persian Desert Basins' },
                  { regionId: '820' },
                  {
                    dek:
                      'This ecoregion covers Iran\u2019s central plateau, reaching into a small part of Northwest Afghanistan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6c14ef5a-6cf2-446a-a773-b4b756305972/820 Central Persian desert basins - Naser Mizbani.jpg',
                      _id: '6c14ef5a-6cf2-446a-a773-b4b756305972'
                    }
                  },
                  { _id: 'dc657ba1-df9c-4868-a65c-174ad71cbc4a' },
                  { title: 'South Iran Nubo-Sindian Desert and Semi-Desert' },
                  { regionId: '841' },
                  {
                    dek:
                      'This ecoregion stretches across the Southern swathe of Iran, reaching into small areas of Iraq and Pakistan. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/85839e53-a45b-4cf1-a94d-f27c84de4c36/841 South Iran Nubo-Sindian desert and semi-desert - Bilal Mizra.jpg',
                      _id: '85839e53-a45b-4cf1-a94d-f27c84de4c36'
                    }
                  },
                  { _id: 'b147b6a0-3c69-4703-8dc3-6a6c480c5354' },
                  { title: 'Kuh Rud and Eastern Iran Montane Woodlands' },
                  { regionId: '757' },
                  {
                    dek:
                      'This ecoregion encompasses the highlands of central and Eastern Iran, reaching into a very small area of Pakistan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a443aab4-b19e-44a1-8340-1bfebcbee72d/747 Karkas Mountain-CC-Alireza Javaheri-2014.jpg',
                      _id: 'a443aab4-b19e-44a1-8340-1bfebcbee72d'
                    }
                  }
                ],
                stats: [
                  { number: '133,896', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '25%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'South Caspian Coastal & Mountain Mixed Forests (PA28)',
                children: [],
                _id: 'e9d00ea4-7c38-4914-b558-61242ac77420',
                value: 1000,
                parentId: 'a74ab6eb-9b56-448a-8c1d-e76525fa9cb3',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/18784990-0ba8-4d8a-8011-d6a97be91558/649 Caspian Hyrcanian Mixed Forests Courtesy of Alireza Javaheri.jpg',
                    _id: '18784990-0ba8-4d8a-8011-d6a97be91558'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5cfea9f9-1e26-47db-8e82-d6714706b17c/649 Caspian Hyrcanian Mixed Forests Argooya CC.jpg',
                    _id: '5cfea9f9-1e26-47db-8e82-d6714706b17c'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4e105815-a097-4658-8542-31098b8deb4c/Bioregion%20map-PA28.jpg',
                content:
                  '<p>The South Caspian Coastal &amp; Mountain Mixed Forests bioregion is located in the Central Eurasia realm (central Palearctic) and contains two ecoregions \u2013 Caspian Hyrcanian Mixed Forests (649), Elburz Range Forest Steppe (695) \u2013 totaling nearly 12 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4e105815-a097-4658-8542-31098b8deb4c/Bioregion%20map-PA28.jpg"/><figcaption><span class="caption"><p>The South Caspian Coastal &amp; Mountain Mixed Forests bioregion is part of the Persian Deserts &amp; Forests subrealm and is made up of two ecoregions: (1) Caspian Hyrcanian Mixed Forests (2) Elburz Range Forest Steppe.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the South Caspian Coastal &amp; Mountain Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '6f6e060b-0db7-4c3a-bd8c-4193c2df0e4c' },
                  { title: 'Elburz Range Forest Steppe' },
                  { regionId: '695' },
                  {
                    dek:
                      'The Elburz Range Forest Steppe is in Northern Iran, spanning the Southern and Eastern slopes of the Elburz Mountains. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/56980cf0-12cb-4b75-aab4-da8a666508b5/695 Elburz Range forest steppe - Nader.jpg',
                      _id: '56980cf0-12cb-4b75-aab4-da8a666508b5'
                    }
                  },
                  { _id: '0ec548c4-77f3-41c5-af65-f141403863b6' },
                  { title: 'Caspian Hyrcanian Mixed Forests' },
                  { regionId: '649' },
                  {
                    dek:
                      'The vast majority of the ecoregion lies in Northwest Iran, while part of it covers the Lenkoran lowlands and Talysh Mountains of Southeast Azerbaijan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/18784990-0ba8-4d8a-8011-d6a97be91558/649 Caspian Hyrcanian Mixed Forests Courtesy of Alireza Javaheri.jpg',
                      _id: '18784990-0ba8-4d8a-8011-d6a97be91558'
                    }
                  }
                ],
                stats: [
                  { number: '11,864', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '20%', item: 'Protection Target' },
                  { number: '6', item: 'Protection Level' }
                ]
              },
              {
                name: 'Zagros Mountain Forests & East Anatolian Steppe (PA27)',
                children: [],
                _id: '3eecaaae-b3db-424b-bc28-fbc3682ca9ff',
                value: 1000,
                parentId: 'a74ab6eb-9b56-448a-8c1d-e76525fa9cb3',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/68f11829-dad7-49d6-a773-abe4bbc59375/727 Eastern Anatolian montane steppe - Tuna Olger.jpg',
                    _id: '68f11829-dad7-49d6-a773-abe4bbc59375'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ec6a7fe9-df32-4af4-be23-717e10eda319/688-The_view_of_Dena_from_Semirom_road_-_panoramio-CC-Alireza Javaheri-2015_resized.jpg',
                    _id: 'ec6a7fe9-df32-4af4-be23-717e10eda319'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fcc67a1e-c24d-4a95-b940-27b8a1398fbc/Bioregion%20map-PA27.jpg',
                content:
                  '<p>The Zagros Mountain Forests &amp; East Anatolian Steppe bioregion is located in the Central Eurasia realm (central Palearctic) and contains two ecoregions \u2013 Zagros Mountains Forest Steppe (688), Eastern Anatolian Montane Steppe (727) \u2013 totaling nearly 57 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fcc67a1e-c24d-4a95-b940-27b8a1398fbc/Bioregion%20map-PA27.jpg"/><figcaption><span class="caption"><p>The Zagros Mountain Forests &amp; East Anatolian Steppe bioregion is part of the Persian Deserts &amp; Forests subrealm and is made up of two ecoregions: (1) Eastern Anatolian Montane Steppe (2) Zagros Mountains Forest Steppe.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Zagros Mountain Forests &amp; East Anatolian Steppe ecoregions below.</p>',
                ecoregions: [
                  { _id: 'b24b00fa-b6c9-4038-94f4-0de87efbdf48' },
                  { title: 'Eastern Anatolian Montane Steppe' },
                  { regionId: '727' },
                  {
                    dek:
                      'This ecoregion traverses East Turkey, Northwest Iran, the Nakhchyvan Autonomous Republic in Azerbaijan, Armenia, and South Georgia. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/68f11829-dad7-49d6-a773-abe4bbc59375/727 Eastern Anatolian montane steppe - Tuna Olger.jpg',
                      _id: '68f11829-dad7-49d6-a773-abe4bbc59375'
                    }
                  },
                  { _id: '63fca8a3-5882-44b2-b047-b943e216c98d' },
                  { title: 'Zagros Mountains Forest Steppe' },
                  { regionId: '688' },
                  { dek: 'This ecoregion spans the Zagros mountain arch.' },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8102ddfc-a7ed-443c-b61d-a7c9dad96a54/688 Zagros Mountains forest steppe - ninara.jpg',
                      _id: '8102ddfc-a7ed-443c-b61d-a7c9dad96a54'
                    }
                  }
                ],
                stats: [
                  { number: '56,727', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '10%', item: 'Protection Target' },
                  { number: '5', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Central Eurasia',
            value: 1000
          },
          {
            _id: '14338329-582b-4988-9239-087cfdf25571',
            name: 'Tien Shan Mountains',
            children: [
              {
                name: 'Tian Shan-Pamir Grasslands, Mountain Steppe & Conifer Forests (PA31)',
                children: [],
                _id: 'cf0186a9-53ff-4ad4-b50a-08171a24f1d7',
                value: 1000,
                parentId: '14338329-582b-4988-9239-087cfdf25571',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3e82d942-ac12-4f47-93b1-7ab3cdd18f73/767 Tian Shan montane steppe and meadows - Ruslan Kadyrov.jpg',
                    _id: '3e82d942-ac12-4f47-93b1-7ab3cdd18f73'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1facfa2d-1142-42c0-8b5a-cfeb6a1fb67f/721 Alai-Western Tian Shan steppe - \u0421\u0435\u0440\u0433\u0435\u0439 \u042e\u043c\u0430\u0433\u0443\u043b\u043e\u0432.jpg',
                    _id: '1facfa2d-1142-42c0-8b5a-cfeb6a1fb67f'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/831159fc-e1a0-4f95-8915-da8241be28a7/709 Tian Shan montane conifer forests (Kyrgyzstan) - John Morrison.jpg',
                    _id: '831159fc-e1a0-4f95-8915-da8241be28a7'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/86066db5-7020-400c-a661-bec5cca6f6c5/730-Gissaro-AlaiOpenWoodlands-CC-WikiCommons.jpg',
                    _id: '86066db5-7020-400c-a661-bec5cca6f6c5'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/123ab7ed-1c0b-4124-aab0-fe3ac1dfb48b/740 Tian Shan foothill arid steppe - AndreiGarm.jpg',
                    _id: '123ab7ed-1c0b-4124-aab0-fe3ac1dfb48b'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cccc7469-375c-4fa5-b5c1-7eb1db2f36c7/Bioregion%20map-PA31.jpg',
                content:
                  '<p>The Tian Shan-Pamir Grasslands, Mountain Steppe &amp; Conifer Forests bioregion is located in the Central Eurasia realm (central Palearctic) and contains five ecoregions \u2013 Tian Shan Montane Conifer Forests (709), Alai-Western Tian Shan Steppe (721), Gissaro-Alai Open Woodlands (730), Tian Shan Foothill Arid Steppe (740), Tian Shan Montane Steppe and Meadows (767) \u2013 totaling more than 73 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cccc7469-375c-4fa5-b5c1-7eb1db2f36c7/Bioregion%20map-PA31.jpg"/><figcaption><span class="caption"><p>The Tian Shan-Pamir Grasslands, Mountain Steppe &amp; Conifer Forests bioregion is part of the Tian Shan Mountains subrealm and is made up of five ecoregions: (1) Alai-Western Tian Shan Steppe (2) Gissaro-Alai Open Woodlands (3) Tian Shan Montane Conifer Forests (4) Tian Shan Montane Steppe and Meadows (5) Tian Shan Foothill Arid Steppe.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Tian Shan-Pamir Grasslands, Mountain Steppe &amp; Conifer Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '518501fd-29b3-4c1d-a346-1322ae80ca36' },
                  { title: 'Tian Shan Montane Conifer Forests' },
                  { regionId: '709' },
                  {
                    dek:
                      'Surrounded by the desert basins of northern China, this ecoregion is an isolated, east-west trending mountain range '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/831159fc-e1a0-4f95-8915-da8241be28a7/709 Tian Shan montane conifer forests (Kyrgyzstan) - John Morrison.jpg',
                      _id: '831159fc-e1a0-4f95-8915-da8241be28a7'
                    }
                  },
                  { _id: '85cabe27-a5c2-45f7-9245-b418754705ad' },
                  { title: 'Tian Shan Foothill Arid Steppe' },
                  { regionId: '740' },
                  {
                    dek:
                      'The Tian Shan (Celestial Mountains) rises from the deserts and steppe basins of Inner Asia to form the largest temperate-arid mountain system on Earth. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/123ab7ed-1c0b-4124-aab0-fe3ac1dfb48b/740 Tian Shan foothill arid steppe - AndreiGarm.jpg',
                      _id: '123ab7ed-1c0b-4124-aab0-fe3ac1dfb48b'
                    }
                  },
                  { _id: 'dbb64b01-ce92-4f18-9ab4-6f59869bc7f1' },
                  { title: 'Gissaro-Alai Open Woodlands' },
                  { regionId: '730' },
                  {
                    dek:
                      'This ecoregion intersects five countries: Afghanistan, Kazakhstan, Kyrgyzstan, Tajikistan, and Uzbekistan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/169aa46d-1005-4f96-9160-39d746a00e21/730 Gissaro-Alai open woodlands - Andy Bay.jpg',
                      _id: '169aa46d-1005-4f96-9160-39d746a00e21'
                    }
                  },
                  { _id: 'bdf80406-9aae-447a-810e-4a635ae5e0b3' },
                  { title: 'Alai-Western Tian Shan Steppe' },
                  { regionId: '721' },
                  {
                    dek:
                      'This ecoregion spreads over five countries along lowland and loess plains.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1facfa2d-1142-42c0-8b5a-cfeb6a1fb67f/721 Alai-Western Tian Shan steppe - \u0421\u0435\u0440\u0433\u0435\u0439 \u042e\u043c\u0430\u0433\u0443\u043b\u043e\u0432.jpg',
                      _id: '1facfa2d-1142-42c0-8b5a-cfeb6a1fb67f'
                    }
                  },
                  { _id: 'd593bf92-2213-43f5-bbed-81fa66a3a4a2' },
                  { title: 'Tian Shan Montane Steppe and Meadows' },
                  { regionId: '767' },
                  {
                    dek:
                      'The Tian Shan are separated from the Kunlun Mountains and the Tibetan Plateau by the broad, hyper-arid Tarim Basin and Taklimakan Desert. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8cc62abd-6850-491b-b031-7e6c3809a03d/767 Tian Shan Montane Steppe and Meadows Michael E cc.jpg',
                      _id: '8cc62abd-6850-491b-b031-7e6c3809a03d'
                    }
                  }
                ],
                stats: [
                  { number: '73,384', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '37%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Central Eurasia',
            value: 250
          },
          {
            _id: '1b20b2b5-43e7-4281-8729-750f501353a0',
            name: 'Caspian Sea & Central Asian Deserts',
            children: [
              {
                name: 'Caspian Sea, Coastal Deserts & Kopet Dagh Mountain Woodlands (PA33)',
                children: [],
                _id: 'ffa5ac86-3349-4c0c-a9a2-8805c49a36bd',
                value: 1000,
                parentId: '1b20b2b5-43e7-4281-8729-750f501353a0',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/47065a2a-71ab-402b-ab2c-40bbf0d739b5/815-Wetlands in Volga Estuary-CC-2016.jpg',
                    _id: '47065a2a-71ab-402b-ab2c-40bbf0d739b5'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bab941f6-952f-4305-8f23-8604bd61f8f8/812 Azerbaijan shrub desert and steppe - Kristian Ellis Wood.jpg',
                    _id: 'bab941f6-952f-4305-8f23-8604bd61f8f8'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5392ddc2-5c34-4721-ac9c-df18f32ba809/829 Kopet Dag semi-desert - Raimund Andree.jpg',
                    _id: '5392ddc2-5c34-4721-ac9c-df18f32ba809'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2507ad68-f041-4c2f-ab90-f0d7eae111b0/756 Kopet Dag woodlands and forest steppe - Reza Babaeian.JPG',
                    _id: '2507ad68-f041-4c2f-ab90-f0d7eae111b0'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9b3caca1-5ece-4fd7-b01d-21cc65d05be9/Bioregion%20map-PA33.jpg',
                content:
                  '<p>The Caspian Sea, Coastal Deserts &amp; Kopet Dagh Mountain Woodlands bioregion is located in the Central Eurasia realm (central Palearctic) and contains four ecoregions \u2013 Kopet Dag Woodlands and Forest Steppe (756), Azerbaijan Shrub Desert and Steppe (812), Caspian Lowland Desert (815), Kopet Dag Semi-Desert (829) \u2013 totaling approximately 41.5 million hectares of land area.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9b3caca1-5ece-4fd7-b01d-21cc65d05be9/Bioregion%20map-PA33.jpg"/><figcaption><span class="caption"><p>The Caspian Sea, Coastal Deserts &amp; Kopet Dagh Mountain Woodlands bioregion is part of the Caspian Sea &amp; Central Asian Deserts subrealm and is made up of four ecoregions: (1) Caspian Lowland Desert (2) Azerbaijan Shrub Desert and Steppe (3) Kopet Dag Semi-Desert (4) Kopet Dag Woodlands and Forest Steppe.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Caspian Sea, Coastal Deserts &amp; Kopet Dagh Mountain Woodlands ecoregions below.</p>',
                ecoregions: [
                  { _id: '33100484-1aa4-4dec-82fd-4a7683d23407' },
                  { title: 'Kopet Dag Semi-Desert' },
                  { regionId: '829' },
                  {
                    dek:
                      'This ecoregion lies largely within Turkmenistan, reaching into a small area of Northeastern Iran. Fringing the magnificent Kopet Dag Mountains, it spans the transition zone between foothills and vast lowland desert.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5392ddc2-5c34-4721-ac9c-df18f32ba809/829 Kopet Dag semi-desert - Raimund Andree.jpg',
                      _id: '5392ddc2-5c34-4721-ac9c-df18f32ba809'
                    }
                  },
                  { _id: '7b07641b-0161-4800-b26c-9d1a9f389b21' },
                  { title: 'Caspian Lowland Desert' },
                  { regionId: '815' },
                  {
                    dek:
                      'This ecoregion lies on the northern and eastern shores of the Caspian Sea following the coastlines of Russia, Kazakhstan, Turkmenistan, and Iran. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a2b2152f-1b85-4f13-a918-16673cb10016/815 Caspian lowland desert - \u0418\u0433\u043e\u0440\u044c \u0428\u043f\u0438\u043b\u0435\u043d\u043e\u043a.jpg',
                      _id: 'a2b2152f-1b85-4f13-a918-16673cb10016'
                    }
                  },
                  { _id: '22d23fc8-371d-4ed6-9142-eefbcb4b4fd5' },
                  { title: 'Azerbaijan Shrub Desert and Steppe' },
                  { regionId: '812' },
                  {
                    dek:
                      'Seventy percent of this ecoregion lies within Azerbaijan, with the rest reaching into Southeast Georgia and Northwest Iran. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bab941f6-952f-4305-8f23-8604bd61f8f8/812 Azerbaijan shrub desert and steppe - Kristian Ellis Wood.jpg',
                      _id: 'bab941f6-952f-4305-8f23-8604bd61f8f8'
                    }
                  },
                  { _id: '8ccd8bcf-9b3d-4dcd-9842-548835de3230' },
                  { title: 'Kopet Dag Woodlands and Forest Steppe' },
                  { regionId: '756' },
                  {
                    dek:
                      'This ecoregion encompasses the Kopet Dag\u2014a chain of mountains stretching along the border of Iran and Turkmenistan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2507ad68-f041-4c2f-ab90-f0d7eae111b0/756 Kopet Dag woodlands and forest steppe - Reza Babaeian.JPG',
                      _id: '2507ad68-f041-4c2f-ab90-f0d7eae111b0'
                    }
                  }
                ],
                stats: [
                  { number: '41,680', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '47%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Central Asian Deserts & Riparian Woodlands (PA32)',
                children: [],
                _id: 'e680f5cf-5c6b-4c8d-b522-a19fac1a972a',
                value: 1000,
                parentId: '1b20b2b5-43e7-4281-8729-750f501353a0',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5464d94b-8815-47ae-87ab-be62631ca6e0/817 Central Asian northern desert - Ashina.jpg',
                    _id: '5464d94b-8815-47ae-87ab-be62631ca6e0'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c201509d-a7ae-4962-8f2d-94b1a189074b/818 Central Asian riparian woodlands - \u042e \u0414\u0430\u043d\u0438\u043b\u0435\u0432\u0441\u043a\u0438\u0439.jpg',
                    _id: 'c201509d-a7ae-4962-8f2d-94b1a189074b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b5ca8ca3-5cc1-4a1e-9774-b4428bbeadd8/819 Central Asian southern desert - David Stanley.jpg',
                    _id: 'b5ca8ca3-5cc1-4a1e-9774-b4428bbeadd8'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/530eacc3-c9ff-452f-b543-8e0a24446d15/828 Kazakh semi-desert - Alex Pazhenkov.jpg',
                    _id: '530eacc3-c9ff-452f-b543-8e0a24446d15'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/89721a95-0fc8-472c-be8c-0e005bb32d30/Bioregion%20map-PA32.jpg',
                content:
                  '<p>The Central Asian Deserts &amp; Riparian Woodlands bioregion is located in the Central Eurasia realm (central Palearctic) and contains four ecoregions \u2013 Central Asian Northern Desert (817), Central Asian Riparian Woodlands (818), Central Asian Southern Desert (819), Kazakh Semi-Desert (828) \u2013 totaling approximately 200 million hectares of land area.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/89721a95-0fc8-472c-be8c-0e005bb32d30/Bioregion%20map-PA32.jpg"/><figcaption><span class="caption"><p>The Central Asian Deserts &amp; Riparian Woodlands bioregion is part of the Caspian Sea &amp; Central Asian Deserts subrealm and is made up of four ecoregions: (1) Kazakh Semi-Desert (2) Central Asian Riparian Woodlands (3) Central Asian Northern Desert (4) Central Asian Southern Desert.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Central Asian Deserts &amp; Riparian Woodlands ecoregions below.</p>',
                ecoregions: [
                  { _id: '896bf9a9-a787-4788-9620-f83069c9876d' },
                  { title: 'Kazakh Semi-Desert' },
                  { regionId: '828' },
                  {
                    dek:
                      'This ecoregion stretches from the Ural River to the west, encompassing the North Aral Sea in the southwest, to the Kazakh Uplands, a vast low-relief plain, in the central east, which has low mountain oases.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/530eacc3-c9ff-452f-b543-8e0a24446d15/828 Kazakh semi-desert - Alex Pazhenkov.jpg',
                      _id: '530eacc3-c9ff-452f-b543-8e0a24446d15'
                    }
                  },
                  { _id: 'bb896df2-b460-4d85-8e09-6c2ea4265449' },
                  { title: 'Central Asian Southern Desert' },
                  { regionId: '819' },
                  {
                    dek:
                      'This ecoregion covers two massive deserts, the Kyzylkum in Uzbekistan and Kazakhstan, and the Karakum in Turkmenistan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b5ca8ca3-5cc1-4a1e-9774-b4428bbeadd8/819 Central Asian southern desert - David Stanley.jpg',
                      _id: 'b5ca8ca3-5cc1-4a1e-9774-b4428bbeadd8'
                    }
                  },
                  { _id: '247fd360-50af-406e-b0e9-62cd32d64477' },
                  { title: 'Central Asian Riparian Woodlands' },
                  { regionId: '818' },
                  {
                    dek:
                      'This ecoregion covers four disjunct portions in Turkmenistan, Uzbekistan, and Kazakhstan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c201509d-a7ae-4962-8f2d-94b1a189074b/818 Central Asian riparian woodlands - \u042e \u0414\u0430\u043d\u0438\u043b\u0435\u0432\u0441\u043a\u0438\u0439.jpg',
                      _id: 'c201509d-a7ae-4962-8f2d-94b1a189074b'
                    }
                  },
                  { _id: '2a33de20-8846-44a2-b0af-4f936d5f5364' },
                  { title: 'Central Asian Northern Desert' },
                  { regionId: '817' },
                  {
                    dek:
                      'This ecoregion covers disjunct areas mainly in Kazakhstan and Uzbekistan, with small parts in Kyrgyzstan and Turkmenistan. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5464d94b-8815-47ae-87ab-be62631ca6e0/817 Central Asian northern desert - Ashina.jpg',
                      _id: '5464d94b-8815-47ae-87ab-be62631ca6e0'
                    }
                  }
                ],
                stats: [
                  { number: '200,064', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '54%', item: 'Protection Target' },
                  { number: '0', item: 'Protection Level ' }
                ]
              }
            ],
            parentId: 'Central Eurasia',
            value: 500
          },
          {
            _id: '29e0d88b-4f9a-4a65-8755-9a8bdc38f152',
            name: 'Kazakh Steppes & Hemiboreal Forests',
            children: [
              {
                name: 'Siberian Hemiboreal Forests & Steppe (PA35)',
                children: [],
                _id: 'ae32c14c-e41f-49c8-8a1e-4e5131ff5fc2',
                value: 1000,
                parentId: '29e0d88b-4f9a-4a65-8755-9a8bdc38f152',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/862f167d-14cd-4c61-849c-2f01d40c3d06/687-Bugotak Hills Protected Area, Novosibirsk Oblast-CC-\u0421\u0435\u0434\u044b\u0445 \u0414\u0435\u043d\u0438\u0441 \u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432\u0438\u0447-2015_resized.jpg',
                    _id: '862f167d-14cd-4c61-849c-2f01d40c3d06'
                  }
                ],
                map: null,
                content:
                  '<p>The Siberian Hemiboreal Forests &amp; Steppe bioregion is located in the Central Eurasia realm (central Palearctic) and contains one ecoregion \u2013 Western Siberian Hemiboreal Forests (687) \u2013 totaling approximately 38.5 million hectares of land area.&nbsp;</p>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Siberian Hemiboreal Forests &amp; Steppe ecoregions below.</p>',
                ecoregions: [
                  { _id: 'd6e1f2d0-8f31-4631-99dc-061a50449f34' },
                  { title: 'Western Siberian Hemiboreal Forests' },
                  { regionId: '687' },
                  {
                    dek:
                      'This ecoregion forms a latitudinal belt within the southern taiga zone of West Siberia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eec4c215-7eda-4cb7-a4e7-c86113674dde/687 Western Siberian hemiboreal forests - Elya.jpg',
                      _id: 'eec4c215-7eda-4cb7-a4e7-c86113674dde'
                    }
                  }
                ],
                stats: [
                  { number: '38,616', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '30%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Kazakh Forest Steppe & Grasslands (PA34)',
                children: [],
                _id: 'e6782a01-0519-4966-aa37-01942c78b1e2',
                value: 1000,
                parentId: '29e0d88b-4f9a-4a65-8755-9a8bdc38f152',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/86f377ad-1afe-4878-b86e-15490b84ad6e/733-Kent Mountains-Karkaraly_National_Park_-CC-S Reznichenko-2010jpg_resized.jpg',
                    _id: '86f377ad-1afe-4878-b86e-15490b84ad6e'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/76a6ffaf-b1a9-4f0b-9eb3-6cdc010a9bb5/732- The steppes of central Kazakshtan (Akmola Province)-Eco732-CC-2007.jpg',
                    _id: '76a6ffaf-b1a9-4f0b-9eb3-6cdc010a9bb5'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7298ece9-7fb3-4173-8850-c572123f0313/731- Imen Nature Reserve-in Eco731-CC-2006.JPG',
                    _id: '7298ece9-7fb3-4173-8850-c572123f0313'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/48a43e0c-0b24-4a73-ace2-81f37a20ad98/Bioregion%20map-PA34.jpg',
                content:
                  '<p>The Kazakh Forest Steppe &amp; Grasslands bioregion is located in the Central Eurasia realm (central Palearctic) and contains three ecoregions \u2013 Kazakh Forest Steppe (731), Kazakh Steppe (732), Kazakh Upland Steppe (733) \u2013 totaling approximately 130 million hectares of land area.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/48a43e0c-0b24-4a73-ace2-81f37a20ad98/Bioregion%20map-PA34.jpg"/><figcaption><span class="caption"><p>The Kazakh Forest Steppe &amp; Grasslands bioregion is part of the Kazakh Steppes &amp; Hemiboreal Forests subrealm and is made up of three ecoregions: (1) Kazakh Forest Steppe (2) Kazakh Upland Steppe (3) Kazakh Steppe.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Central Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Kazakh Forest Steppe &amp; Grasslands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'bb688701-533f-42af-af0c-cc4c9ad72b8d' },
                  { title: 'Kazakh Upland Steppe' },
                  { regionId: '733' },
                  {
                    dek:
                      'This ecoregion is composed of three separate areas: Kokchetau Uplands in northern Kazakhstan; Aktau, Ortau, and Karkaraly mountain area in central-eastern Kazakhstan; and Chingiztau mountain area to the east.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f5340bcd-c337-4cb7-9e13-081669d45c58/733 Kazakh upland steppe - Wassily.jpg',
                      _id: 'f5340bcd-c337-4cb7-9e13-081669d45c58'
                    }
                  },
                  { _id: 'a57012ff-78a3-483a-85d7-0a3d839708a8' },
                  { title: 'Kazakh Steppe' },
                  { regionId: '732' },
                  {
                    dek:
                      'This large ecoregion is bounded in the west by the Ural River, in the north and east by more humid forest steppe, and in the south by the Kazakh Semi-Desert ecoregion. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2ad15def-58c3-4e2f-b8d9-378187b76314/732 Kazakh steppe - Vmenkov.jpg',
                      _id: '2ad15def-58c3-4e2f-b8d9-378187b76314'
                    }
                  },
                  { _id: 'db938ee1-49a1-4fab-8315-a0aa0bd69864' },
                  { title: 'Kazakh Forest Steppe' },
                  { regionId: '731' },
                  {
                    dek:
                      'This ecoregion forms a long, 150\u2013250 km-wide band, stretching from the Ural Mountains to foothills of the Altai and Sayan Mountains. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7298ece9-7fb3-4173-8850-c572123f0313/731- Imen Nature Reserve-in Eco731-CC-2006.JPG',
                      _id: '7298ece9-7fb3-4173-8850-c572123f0313'
                    }
                  }
                ],
                stats: [
                  { number: '129,988', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '27%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level ' }
                ]
              }
            ],
            parentId: 'Central Eurasia',
            value: 500
          },
          {
            _id: '8a02b502-db04-454f-a578-cd75cfb037f0',
            name: 'Altai-Sayan Mountains',
            children: [
              {
                name: 'Altai Mountain Forests, Grasslands & Desert Steppe (PA37)',
                children: [],
                _id: '8a070b49-47cd-49e2-8453-fa70ba4d58ac',
                value: 1000,
                parentId: '8a02b502-db04-454f-a578-cd75cfb037f0',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/114f7588-5b90-4506-b9d5-021d0dbfb541/749 Altai alpine meadow and tundra - Jacqueline Macou.jpg',
                    _id: '114f7588-5b90-4506-b9d5-021d0dbfb541'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7083b99d-311f-43e5-8974-d22916ecabc7/826-Ubsunur Hollow landscape, Mongolia-CC-1999JPG.JPG',
                    _id: '7083b99d-311f-43e5-8974-d22916ecabc7'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a921590d-4f7f-486c-9696-3f987f3d7601/690-Katun Nature Reserve-CC-2015_resized.jpg',
                    _id: 'a921590d-4f7f-486c-9696-3f987f3d7601'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e2c4240d-2d62-40f6-8ae6-742cdc1711fa/690-Sunset_at_Kucherla_lake-CC-2009.jpg',
                    _id: 'e2c4240d-2d62-40f6-8ae6-742cdc1711fa'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/34133861-5696-4d59-8de7-45a36e9115c1/690-Katun_nature_reserve-CC-2011.jpg',
                    _id: '34133861-5696-4d59-8de7-45a36e9115c1'
                  }
                ],
                map: null,
                content:
                  '<p>The Altai Mountain Forests, Grasslands &amp; Desert Steppe bioregion is located in the Central Eurasia realm (central Palearctic) and contains four ecoregions \u2013 Altai Montane Forest and Forest Steppe (690), Altai Steppe and Semi-Desert (724), Emin Valley Steppe (729), Altai Alpine Meadow and Tundra (749) \u2013 totaling more than 47 million hectares of land area.</p>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Altai Mountain Forests, Grasslands &amp; Desert Steppe ecoregions below.</p>',
                ecoregions: [
                  { _id: '80135d09-ab1c-4b1d-b520-f947aae4e90e' },
                  { title: 'Emin Valley Steppe' },
                  { regionId: '728' },
                  {
                    dek:
                      'This ecoregion straddles the Kazakhstan-China border along the north slope of the Tian Shan mountain range.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8d47bfab-5a42-411f-88ce-8d7834af333e/728 Alakol lake-CC-Isabelle Kirsch-2018 crop_resized.jpg',
                      _id: '8d47bfab-5a42-411f-88ce-8d7834af333e'
                    }
                  },
                  { _id: 'd10762c2-16c5-4f4b-8af0-c28e4fa28760' },
                  { title: 'Altai Alpine Meadow and Tundra' },
                  { regionId: '749' },
                  {
                    dek:
                      'This ecoregion lies above conifer forest treeline, occupying the headwaters of two of Siberia\u2019s greatest rivers, the Ob and the Irtysh. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/06f500d9-471d-45e0-8c28-f015064306e4/749-Katun Nature Reserve-CC-2015_resized.jpg',
                      _id: '06f500d9-471d-45e0-8c28-f015064306e4'
                    }
                  },
                  { _id: 'b4b3a9d6-7b05-4880-9535-8d7a02ddf552' },
                  { title: 'Altai Steppe and Semi-Desert' },
                  { regionId: '724' },
                  {
                    dek:
                      'This ecoregion forms a transition between the forests of the Altai Mountain ecoregions to the north and east and the Kazakh desert plain to the west. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aec7f697-b695-46ce-b173-a38c5edc87da/724 Altai steppe and semi-desert - Dimitry A Mottl.jpg',
                      _id: 'aec7f697-b695-46ce-b173-a38c5edc87da'
                    }
                  },
                  { _id: '0c40fd67-3bb1-4793-aab2-34666ef31f48' },
                  { title: 'Altai Montane Forest and Forest Steppe' },
                  { regionId: '690' },
                  {
                    dek:
                      'This ecoregion traces the Altai Mountains southeastward, dividing arid basins of Inner Asia from Siberian river systems that drain to the Arctic. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2bffe339-f8fb-4d51-a544-43d4872f1dbf/690 Altai montane forest and forest steppe - svetlanavic.jpg',
                      _id: '2bffe339-f8fb-4d51-a544-43d4872f1dbf'
                    }
                  }
                ],
                stats: [
                  { number: '47,383', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '50%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Sayan Mountain Conifer Forests, Alpine Meadows & Steppe (PA36)',
                children: [],
                _id: '1bffb0d0-4fb4-4e19-9a89-97b5ec29401b',
                value: 1000,
                parentId: '8a02b502-db04-454f-a578-cd75cfb037f0',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/593c6d5e-7b44-4e3c-ad04-b3da066f979f/764-Sayan Mountians-CC-2012_resized.jpg',
                    _id: '593c6d5e-7b44-4e3c-ad04-b3da066f979f'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7c16af12-06b6-4701-b675-68777ec589f7/707-Khakasski_nature_reserve-CC-2011.jpg',
                    _id: '7c16af12-06b6-4701-b675-68777ec589f7'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f38bc8ac-6b24-4656-9fbf-0fd1a3f39aed/736-Confluence of the Kaa-Kem and Pii-Kem Rivers-CC-2015.jpg',
                    _id: 'f38bc8ac-6b24-4656-9fbf-0fd1a3f39aed'
                  }
                ],
                map: null,
                content:
                  '<p>The Sayan Mountain Conifer Forests, Alpine Meadows &amp; Steppe bioregion is located in the Central Eurasia realm (central Palearctic) and contains four ecoregions \u2013 Sayan Montane Conifer Forests (707), Sayan Intermontane Steppe (736), South Siberian Forest Steppe (738), Sayan Alpine Meadows and Tundra (764) \u2013 totaling more than 47 million hectares of land area.&nbsp;</p>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Sayan Mountain Conifer Forests, Alpine Meadows &amp; Steppe ecoregions below.</p>',
                ecoregions: [
                  { _id: '6f2f147a-f19f-474f-90ed-c6df24edf430' },
                  { title: 'Sayan Alpine Meadows and Tundra' },
                  { regionId: '764' },
                  {
                    dek:
                      'This ecoregion covers areas above the tree line between the Altai Mountains and Lake Baikal in Russia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f4706cf0-8c71-43be-b6f2-a65d48b6362f/764 Sayan alpine meadows and tundra - Kanenori.jpg',
                      _id: 'f4706cf0-8c71-43be-b6f2-a65d48b6362f'
                    }
                  },
                  { _id: '44106597-25f1-4c04-9715-78515056c5c9' },
                  { title: 'Sayan Intermontane Steppe' },
                  { regionId: '736' },
                  {
                    dek:
                      'This ecoregion is found between ridges of the Tannu-Ola mountains to the south and the Western Sayan mountains to the north, within the Central Tuva Depression. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/140409e5-0ac7-4165-844e-26fbe0d93897/736 Sayan Intermontane steppe - Oschtan.jpg',
                      _id: '140409e5-0ac7-4165-844e-26fbe0d93897'
                    }
                  },
                  { _id: '0c57b41a-385e-4dfd-bc67-bc32427f775f' },
                  { title: 'Sayan Montane Conifer Forests' },
                  { regionId: '707' },
                  {
                    dek:
                      'This ecoregion is situated on the boundary between Siberian taiga forest and Central Asian desert, comprising the mid-elevations of the highest mountains in Siberia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/992e023e-f1d4-4f91-b8f3-12524c348d21/707 Sayan montane conifer forests - Daniel Bellinson.jpg',
                      _id: '992e023e-f1d4-4f91-b8f3-12524c348d21'
                    }
                  },
                  { _id: '6dcc2ea2-8b2d-476d-96bc-57d93b31ec19' },
                  { title: 'South Siberian Forest Steppe' },
                  { regionId: '738' },
                  {
                    dek:
                      'This ecoregion is made up of four patches of a mix of grasslands and sparse forest in a thin band of lowland terrain. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7b90c147-0d85-4143-9983-920db76826a1/738 South Siberian forest steppe - Pascal Chauffeton.JPG',
                      _id: '7b90c147-0d85-4143-9983-920db76826a1'
                    }
                  }
                ],
                stats: [
                  { number: '47,330', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions ' },
                  { number: '57%', item: 'Protection Target ' },
                  { number: '3', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Central Eurasia',
            value: 500
          }
        ],
        parentId: 'top',
        _id: 'Central Eurasia',
        value: 833
      },
      {
        name: 'Eastern Eurasia',
        children: [
          {
            _id: '17ac0bf5-135f-42cd-ad1b-b90937cbbdc1',
            name: 'East Asian Deserts',
            children: [
              {
                name: 'Greater Gobi Desert (PA43)',
                children: [],
                _id: '35c046d3-95bd-4e88-8afc-6bdab804e02f',
                value: 1000,
                parentId: '17ac0bf5-135f-42cd-ad1b-b90937cbbdc1',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fb2ebbb9-453e-482f-87a0-034b9415c0a7/808 Alashan Plateau semi-desert - Doron.jpg',
                    _id: 'fb2ebbb9-453e-482f-87a0-034b9415c0a7'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/083aa25d-0a25-44cc-84a2-316b007751d5/825 Great Lakes Basin desert steppe - Jacqueline Macou.jpg',
                    _id: '083aa25d-0a25-44cc-84a2-316b007751d5'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8b4c0402-5c2f-46eb-8de0-a7fa2dd8d2da/824 Eastern Gobi desert steppe (Ikh Nart Natural Reserve Mongolia) - John Morrison.jpg',
                    _id: '8b4c0402-5c2f-46eb-8de0-a7fa2dd8d2da'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/18f5cdcc-89d6-42b1-80e7-dbb743f06a32/Bioregion%20map-PA43.jpg',
                content:
                  '<p>The Greater Gobi Desert bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains three ecoregions \u2013 Alashan Plateau Semi-Desert (808), Eastern Gobi Desert Steppe (824), Gobi Lakes Valley Desert Steppe (825) \u2013 totaling nearly 110 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/18f5cdcc-89d6-42b1-80e7-dbb743f06a32/Bioregion%20map-PA43.jpg"/><figcaption><span class="caption"><p>The Greater Gobi Desert bioregion is part of the East Asian Deserts subrealm and is made up of three ecoregions: (1) Alashan Plateau Semi-Desert (2) Gobi Lakes Valley Desert Steppe (3) Eastern Gobi Desert Steppe.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Greater Gobi Desert ecoregions below.</p>',
                ecoregions: [
                  { _id: '2b2c30d7-bf9c-44c6-8883-8b464d6052b8' },
                  { title: 'Junggar Basin Semi-Desert' },
                  { regionId: '827' },
                  {
                    dek:
                      'The Junggar Basin is one of the great intermontane basins of Central Asia. Situated between the Tian Shan and Altai mountain ranges, it supports a vast expanse of semi-desert habitat.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/228e8a62-3fcf-4ad4-a134-c37a40998049/ 827 Gurbantunggut Desert-CC-2007.jpg',
                      _id: '228e8a62-3fcf-4ad4-a134-c37a40998049'
                    }
                  },
                  { _id: '2213646f-c0e7-43b6-aa30-9ffd6eb3f0a1' },
                  { title: 'Alashan Plateau Semi-Desert' },
                  { regionId: '808' },
                  {
                    dek:
                      'This ecoregion encompasses the Helan Mountains to the East, Quilian Mountains the West, and the Tibetan Plateau to the south, both in China.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fb2ebbb9-453e-482f-87a0-034b9415c0a7/808 Alashan Plateau semi-desert - Doron.jpg',
                      _id: 'fb2ebbb9-453e-482f-87a0-034b9415c0a7'
                    }
                  }
                ],
                stats: [
                  { number: '109,707', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '69%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Taklimakan Desert & Lowland Deciduous Forests (PA39)',
                children: [],
                _id: 'cb87aab5-8f06-4898-9d1a-2f8a7c79b8dd',
                value: 1000,
                parentId: '17ac0bf5-135f-42cd-ad1b-b90937cbbdc1',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4283cc6d-86d6-423a-a85b-8bd3b411e581/843-Rawak_Temple_-CC_2009.jpg',
                    _id: '4283cc6d-86d6-423a-a85b-8bd3b411e581'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f3ef5d16-5a7e-4d7b-9eea-969fbcec95c2/684 Tarim Basin deciduous forests and steppe -Michael Manning.jpg',
                    _id: 'f3ef5d16-5a7e-4d7b-9eea-969fbcec95c2'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/15eb5a11-3748-43c3-b87e-d4f24a543e5d/Bioregion%20map-PA39.jpg',
                content:
                  '<p>The Taklimakan Desert &amp; Lowland Deciduous Forests bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains two ecoregions \u2013 Tarim Basin Deciduous Forests and Steppe (684), Taklimakan Desert (843) \u2013 totaling approximately 80 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/15eb5a11-3748-43c3-b87e-d4f24a543e5d/Bioregion%20map-PA39.jpg"/><figcaption><span class="caption"><p>The Taklimakan Desert &amp; Lowland Deciduous Forests bioregion is part of the East Asian Deserts subrealm and is made up of two ecoregions: (1) Tarim Basin Deciduous Forests and Steppe (2) Taklimakan Desert.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Taklimakan Desert &amp; Lowland Deciduous Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '965d8615-d30b-44a2-bfca-de2eb04a92a1' },
                  { title: 'Taklimakan Desert' },
                  { regionId: '843' },
                  {
                    dek:
                      'Encircled by tall mountains near the geographic center of Eurasia, the Taklamakan Desert is deprived of moisture from all sources\u2014monsoonal, westerly, and Arctic.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cf887f59-00b1-469d-b512-871a52dfc744/843 Taklimakan Desert - jiankangbidu.jpg',
                      _id: 'cf887f59-00b1-469d-b512-871a52dfc744'
                    }
                  },
                  { _id: '28f6edbc-33de-465b-a9c4-45623fae82b3' },
                  { title: 'Tarim Basin Deciduous Forests and Steppe' },
                  { regionId: '684' },
                  {
                    dek:
                      'Situated across Xinjiang, China, the Tarim Basin is further from the ocean than any other place in the world, with high mountains blocking both the Asian monsoon and westerly winter storms. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f3ef5d16-5a7e-4d7b-9eea-969fbcec95c2/684 Tarim Basin deciduous forests and steppe -Michael Manning.jpg',
                      _id: 'f3ef5d16-5a7e-4d7b-9eea-969fbcec95c2'
                    }
                  }
                ],
                stats: [
                  { number: '79,813', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '71%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Junggar Semi-Desert & Ermin Valley Steppe (PA38)',
                children: [],
                _id: '1574cc8f-290c-4380-8aed-fc9cfd469a7b',
                value: 1000,
                parentId: '17ac0bf5-135f-42cd-ad1b-b90937cbbdc1',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a0f35389-c454-46f1-809c-dda36dd8481b/728 Katya Gabelko cc.jpg',
                    _id: 'a0f35389-c454-46f1-809c-dda36dd8481b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/228e8a62-3fcf-4ad4-a134-c37a40998049/ 827 Gurbantunggut Desert-CC-2007.jpg',
                    _id: '228e8a62-3fcf-4ad4-a134-c37a40998049'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5ad20ca7-f648-41cc-bdf2-ddc9d14d2e5c/Bioregion%20map-PA38.jpg',
                content:
                  '<p>The Junggar Semi-Desert &amp; Ermin Valley Steppe bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains two ecoregions \u2013 Emin Valley Steppe (728), Junggar Basin Semi-Desert (827) \u2013 totaling approximately 37 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5ad20ca7-f648-41cc-bdf2-ddc9d14d2e5c/Bioregion%20map-PA38.jpg"/><figcaption><span class="caption"><p>The Junggar Semi-Desert &amp; Ermin Valley Steppe bioregion is part of the East Asian Deserts subrealm and is made up of two ecoregions: (1) Emin Valley Steppe (2) Junggar Basin Semi-Desert.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Junggar Semi-Desert &amp; Ermin Valley Steppe ecoregions below.</p>',
                ecoregions: [
                  { _id: '78189758-a4de-4e90-a84d-2110f413d548' },
                  { title: 'Great Lakes Basin Desert Steppe' },
                  { regionId: '826' },
                  {
                    dek:
                      'This huge depression is bounded by the Mongolian Altai mountains to the west, Gobi Altai mountains to the south, Tannu Ola mountains to the north, and the Sangilen and Khangai ranges to the west.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7af19e85-45ed-41fd-89de-8d5cfc21f4c9/826 Great Lakes Basin desert steppe - \u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440 \u041b\u0435\u0449\u0451\u043d\u043e\u043a.jpg',
                      _id: '7af19e85-45ed-41fd-89de-8d5cfc21f4c9'
                    }
                  },
                  { _id: '311ebcb0-0663-4914-8d46-c71fd3e68523' },
                  { title: 'Gobi Lakes Valley Desert Steppe' },
                  { regionId: '825' },
                  {
                    dek:
                      'This ecoregion sits between the Khangai Mountains and the eastern end of the Mongolian Altai mountain range, covering the eastern end of the Gobi Altai mountains, including their highest peak, Ikh Bogd, 3,957m tall. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/083aa25d-0a25-44cc-84a2-316b007751d5/825 Great Lakes Basin desert steppe - Jacqueline Macou.jpg',
                      _id: '083aa25d-0a25-44cc-84a2-316b007751d5'
                    }
                  },
                  { _id: '87b822fb-883f-41e2-84dd-bdf0d7e8e9eb' },
                  { title: 'Eastern Gobi Desert Steppe' },
                  { regionId: '824' },
                  {
                    dek:
                      'This ecoregion covers an area of 282,369 km2 and extends from the Inner Mongolian plateau in northern China and Mongolia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8b4c0402-5c2f-46eb-8de0-a7fa2dd8d2da/824 Eastern Gobi desert steppe (Ikh Nart Natural Reserve Mongolia) - John Morrison.jpg',
                      _id: '8b4c0402-5c2f-46eb-8de0-a7fa2dd8d2da'
                    }
                  }
                ],
                stats: [
                  { number: '37,002', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '62%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Eastern Eurasia',
            value: 600
          },
          {
            _id: '11281083-8e95-429b-a5cb-3d74ced24a6b',
            name: 'Tibetan Plateau',
            children: [
              {
                name: 'Tibetan-Pamir Alpine Steppes, Shrublands & Mountain Forests (PA41)',
                children: [],
                _id: '10048236-762c-489d-bbb1-29e9fe620af6',
                value: 1000,
                parentId: '11281083-8e95-429b-a5cb-3d74ced24a6b',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ac666990-db6f-4c41-a40f-1ef4f1efb2c6/770 Yarlung Zanbo arid steppe - hbieser.jpg',
                    _id: 'ac666990-db6f-4c41-a40f-1ef4f1efb2c6'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dbfe7948-0435-4e62-8d02-98ed07bce76f/Bioregion-map-PA41.jpg',
                content:
                  '<p>The Tibetan-Pamir Alpine Steppes, Shrublands &amp; Mountain Forests bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains eight ecoregions&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dbfe7948-0435-4e62-8d02-98ed07bce76f/Bioregion-map-PA41.jpg"/></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Tibetan-Pamir Alpine Steppes, Shrublands &amp; Mountain Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '99df9c86-618d-4c98-be84-e07d3622a640' },
                  { title: 'Karakoram-West Tibetan Plateau Alpine Steppe' },
                  { regionId: '754' },
                  {
                    dek:
                      'This ecoregion lies within the catchment of the upper Indus River where it is shadowed from rain by the Karakoram and the northwestern Himalayan mountain ranges.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e13f6b32-53cc-42da-92eb-ffea231c21d6/754-Karakoram-WestTibetanPlateauAlpineSteppe-CC-WikiCommons.jpg',
                      _id: 'e13f6b32-53cc-42da-92eb-ffea231c21d6'
                    }
                  },
                  { _id: '7c4e41fb-8f60-4cea-a109-266308c3d25e' },
                  { title: 'Yarlung Zanbo Arid Steppe' },
                  { regionId: '770' },
                  {
                    dek:
                      'The Yarlung Zanbo valley is situated at a lower elevation than other parts of the Tibetan Plateau and is further warmed during summer by f\u00f6hn winds that descend the north slope of the Himalaya.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4dc88a95-5e6c-44f9-b684-1549ae2c7814/770 Yarlung Zanbo Arid Steppe Gerd Eichmann cc.jpg',
                      _id: '4dc88a95-5e6c-44f9-b684-1549ae2c7814'
                    }
                  },
                  { _id: '1e6315ac-5e1b-479c-8401-31829a694c63' },
                  { title: 'Western Himalayan Alpine Shrub and Meadows' },
                  { regionId: '769' },
                  {
                    dek:
                      'This ecoregion represents the alpine meadows and shrublands between 3,000 and 5,000 m in the western Himalaya, from the Kali Gandaki River gorge in Nepal to the Indian State of Uttar Pradesh. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e31b395e-741f-4b21-96f9-7488d1e44333/769 Western Himalayan alpine shrub and meadows - Araghu.JPG',
                      _id: 'e31b395e-741f-4b21-96f9-7488d1e44333'
                    }
                  },
                  { _id: '47af3aaf-8084-4c34-8643-05e46924813c' },
                  { title: 'Pamir Alpine Desert and Tundra' },
                  { regionId: '762' },
                  {
                    dek:
                      'This ecoregion includes broad valleys and steeply rolling hills with an ecological and physiographic similarity to the Tibetan Plateau, that are instead situated at a mean elevation of about 4,200 m, substantially lower (and warmer) than the high basins of northwestern Tibet.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7585f8b0-f566-4cc9-8568-aa7e8c7c866a/762 Pamir alpine desert and tundra - Brian Harrington Spier.jpg',
                      _id: '7585f8b0-f566-4cc9-8568-aa7e8c7c866a'
                    }
                  },
                  { _id: '50d24a86-8e1e-450e-9252-e5c82cb0f891' },
                  { title: 'Northwestern Himalayan Alpine Shrub and Meadows' },
                  { regionId: '760' },
                  {
                    dek:
                      'This ecoregion represents a narrow band of alpine scrub and meadows between 3,300 and 3,600 m, especially in the Vale of Kashmir.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/251f59e9-81b4-4021-883f-a9037314f009/760 Northwestern Himalayan alpine shrub and meadows - Tahsin A Shah.jpg',
                      _id: '251f59e9-81b4-4021-883f-a9037314f009'
                    }
                  },
                  { _id: 'e555941e-3714-4555-9f00-d06c8b324092' },
                  { title: 'Hindu Kush Alpine Meadow' },
                  { regionId: '753' },
                  {
                    dek:
                      'This ecoregion forms part of the western Hindu Kush Himalayas in Afghanistan and is bordered by Pakistan in the east and Tajikistan in the north.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7f7a173f-9197-42cb-b61d-7b93c99a1025/753 Hindu Kush alpine meadow - Falk Oberdorf.png',
                      _id: '7f7a173f-9197-42cb-b61d-7b93c99a1025'
                    }
                  },
                  { _id: '70c9c4da-a825-4fc9-85de-805a6939fa52' },
                  { title: 'Eastern Himalayan Alpine Shrub and Meadows' },
                  { regionId: '751' },
                  {
                    dek:
                      'This ecoregion is atop the roof of the world, surrounding the highest mountain peaks on Earth; Everest\u2014locally known as Sagarmatha\u2014Makalu, Dhaulagiri, and Jomalhari. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e4942a05-3527-4be6-8ad3-86aa3504bc62/751 Eastern Himalayan alpine shrub and meadows - skeeze.jpg',
                      _id: 'e4942a05-3527-4be6-8ad3-86aa3504bc62'
                    }
                  },
                  { _id: '70430781-4bb7-4483-98a4-85cbae56d84c' },
                  { title: 'Northeastern Himalayan Subalpine Conifer Forests' },
                  { regionId: '702' },
                  {
                    dek:
                      'This ecoregion occupy slopes of the Zangbo Gorge, the deepest river valley on Earth.\u2060'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1c366642-db07-43f8-862b-91131e23cde8/702 Northeast Himalayan subalpine conifer forests - \u5143\u6c5f \u674e.jpg',
                      _id: '1c366642-db07-43f8-862b-91131e23cde8'
                    }
                  }
                ],
                stats: [
                  { number: ' 63,741 ', item: 'Total Land Area (1000 ha)' },
                  { number: '8', item: 'Number of Ecoregions' },
                  { number: '40%', item: 'Protection Target' },
                  { number: '5', item: 'Protection Level' }
                ]
              },
              {
                name: 'Greater Tibetan Plateau Alpine Meadows & Shrublands (PA40)',
                children: [],
                _id: 'fb4b4424-6f0b-4049-a7fe-857331fba1d8',
                value: 1000,
                parentId: '11281083-8e95-429b-a5cb-3d74ced24a6b',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/016ccab3-48d6-4b0a-95c8-407dec3d2561/750 Central Tibetan Plateau alpine steppe - yuxiu0702.jpg',
                    _id: '016ccab3-48d6-4b0a-95c8-407dec3d2561'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/893ce247-66c7-45fa-a6ce-7eb2d243e594/759 North Tibetan Plateau-Kunlun Mountains Alpine Desert Nick Kent-Basham cc.jpg',
                    _id: '893ce247-66c7-45fa-a6ce-7eb2d243e594'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a8e54b8f-1ac6-4085-b274-fbd0a7b2db3b/768 Tibetan Plateau Alpine Shrublands and Meadows Chen Zhi cc.jpg',
                    _id: 'a8e54b8f-1ac6-4085-b274-fbd0a7b2db3b'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0093ec42-8959-42e9-9c73-8ef8e081a19a/Bioregion%20map-PA40.jpg',
                content:
                  '<p>The Greater Tibetan Plateau Alpine Meadows &amp; Shrublands bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains seven ecoregions \u2013 Qilian Mountains Conifer Forests (705), &nbsp;Central Tibetan Plateau Alpine Steppe (750), North Tibetan Plateau-Kunlun Mountains Alpine Desert (759), Qilian Mountains Subalpine Meadows (763), Southeast Tibet Shrublands and Meadows (765), Tibetan Plateau Alpine Shrublands and Meadows (768), Qaidam Basin Semi-Desert (835) \u2014 totaling more than 202 million hectares of land area.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0093ec42-8959-42e9-9c73-8ef8e081a19a/Bioregion%20map-PA40.jpg"/><figcaption><span class="caption"><p>The Greater Tibetan Plateau Alpine Meadows &amp; Shrublands bioregion is part of the Himalayas &amp; Tibetan Plateau subrealm and is made up of seven ecoregions: (1) North Tibetan Plateau-Kunlun Mountains Alpine Desert (2) Central Tibetan Plateau Alpine Steppe (3) Qaidam Basin Semi-Desert (4) Qilian Mountains Subalpine Meadows (5) Qilian Mountains Conifer Forests (6) Tibetan Plateau Alpine Shrublands and Meadows (7) Southeast Tibet Shrublands and Meadows.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Greater Tibetan Plateau Alpine Meadows &amp; Shrublands ecoregions below.</p>',
                ecoregions: [
                  { _id: '50a096ae-abd5-4d01-b720-123b6c97ec8e' },
                  { title: 'Southeast Tibet Shrublands and Meadows' },
                  { regionId: '765' },
                  {
                    dek:
                      'Abutting the highest mountain range in the world, the southeastern Tibetan Plateau supports an exceptionally moist alpine habitats.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b0310c3d-6305-44d5-b02f-a829f885e64d/765-Southeast_Tibet_meadows-CC-2014.jpg',
                      _id: 'b0310c3d-6305-44d5-b02f-a829f885e64d'
                    }
                  },
                  { _id: 'aaab14fe-c9dc-4f5b-bdc3-245ccb286a34' },
                  { title: 'Qilian Mountains Subalpine Meadows' },
                  { regionId: '763' },
                  {
                    dek:
                      'The Qilian Mountains crest along the northeastern rim of the Tibet Plateau at elevations over 5,500 m.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3262dd42-3025-4e2a-9cd9-6e59d982da32/763 Colourful_Qilian-CC-Stefan Wagener-2016.jpg',
                      _id: '3262dd42-3025-4e2a-9cd9-6e59d982da32'
                    }
                  },
                  { _id: '3c6107df-51b3-4654-8414-254d4f2b7673' },
                  { title: 'Qilian Mountains Conifer Forests' },
                  { regionId: '705' },
                  {
                    dek:
                      'The Qilian Mountains rise to 5,500 m elevation along the northeastern margin of the Tibetan Plateau, providing snowmelt to desert oases at the foot of the range. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8753b48d-4182-476a-91bc-9adef66d950d/705 Qilian Mountains conifer forests - zj3177.jpg',
                      _id: '8753b48d-4182-476a-91bc-9adef66d950d'
                    }
                  },
                  { _id: '04f3d179-a920-4af4-a9ea-31d58a192466' },
                  { title: 'Qaidam Basin Semi-Desert' },
                  { regionId: '835' },
                  {
                    dek:
                      'This ecoregion occupies a tectonic depression, or graben, that slumps between the Tibet Plateau, the Altun mountain range, and the western part of the rapidly uplifting Qilian mountain range.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4ef45433-a204-4e6b-a7aa-c06b80d80fb3/835 Qaidam Basin-CC-2017_resized.jpg',
                      _id: '4ef45433-a204-4e6b-a7aa-c06b80d80fb3'
                    }
                  },
                  { _id: '43c9d307-9d26-4079-a4d0-cf025bfe75d4' },
                  { title: 'Tibetan Plateau Alpine Shrublands and Meadows' },
                  { regionId: '768' },
                  {
                    dek:
                      'Alpine shrublands and meadows extend 1,500 km across the central part of the Tibetan Plateau from the Tsangpo river valley near Lhasa to the Qilian Mountains in the far northeast.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/95ebbda6-221c-48cd-8637-af354bbd4aa8/768 Tibetan Plateau alpine shrublands and meadows - Luo Shaoyang.jpg',
                      _id: '95ebbda6-221c-48cd-8637-af354bbd4aa8'
                    }
                  },
                  { _id: '7f4c3315-cff0-4290-899d-cf7a2dff32de' },
                  { title: 'North Tibetan Plateau-Kunlun Mountains Alpine Desert' },
                  { regionId: '759' },
                  {
                    dek:
                      'The vast Tibetan Plateau supports a range of alpine habitats, of which the most extreme environments are located in the northwest where precipitation is scant, temperatures are frigid, and elevations exceed 4,800 m for hundreds of kilometers in all directions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/062172e0-37c4-4fc6-b9e5-c7b1d583de6d/759 North Tibetan Plateau-Kunlun Mountains alpine desert - Nick Kent-Basham.jpg',
                      _id: '062172e0-37c4-4fc6-b9e5-c7b1d583de6d'
                    }
                  },
                  { _id: '18b9eea4-c76c-4a18-af18-4913903c33c7' },
                  { title: 'Central Tibetan Plateau Alpine Steppe' },
                  { regionId: '750' },
                  {
                    dek:
                      'Between the monsoon-affected southeast and the frigid, desiccated northwest lies this ecoregion, hundreds of thousands of square kilometers of steppe meadow, where individual small plants are typically separated by bare earth. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1dccd1ee-ca00-4316-a708-344c8151e890/750 Central Tibetan Plateau Alpine Steppe Slyvannus cc.jpg',
                      _id: '1dccd1ee-ca00-4316-a708-344c8151e890'
                    }
                  }
                ],
                stats: [
                  { number: '202,328 ', item: 'Total Land Area (1000 ha)' },
                  { number: '7', item: 'Number of Ecoregions ' },
                  { number: '66%', item: 'Protection Target' },
                  { number: '6', item: 'Protection Level ' }
                ]
              }
            ],
            parentId: 'Eastern Eurasia',
            value: 400
          },
          {
            _id: 'e69f30a1-6799-4f7e-a317-a5c9591f45c9',
            name: 'Mongolian Grasslands',
            children: [
              {
                name: 'Mongolian Grasslands, Alpine Meadows & Forest Steppe (PA44)',
                children: [],
                _id: 'ba76e19b-0d02-4098-b21c-0c1ada2f8ae3',
                value: 1000,
                parentId: 'e69f30a1-6799-4f7e-a317-a5c9591f45c9',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6bec300f-55fd-4220-b418-4598bb5e08bf/734-Grasslands-CC-2006.JPG',
                    _id: '6bec300f-55fd-4220-b418-4598bb5e08bf'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9deb0c3e-dcf2-4d30-b837-370bd93a4501/700_Siberian larch_1_SriMesh via Wikimedia.jpg',
                    _id: '9deb0c3e-dcf2-4d30-b837-370bd93a4501'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b9b9f372-283c-41c4-99bd-84ad3535d01f/737-Selenga-CC-2005.jpg',
                    _id: 'b9b9f372-283c-41c4-99bd-84ad3535d01f'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e240688b-d9aa-4ec8-b81b-d5aab40bd2b5/Bioregion%20map-PA44.jpg',
                content:
                  '<p>The Mongolian Grasslands, Alpine Meadows &amp; Forest Steppe bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains six ecoregions \u2013 Khangai Mountains Conifer Forests (700), Daurian Forest Steppe (726), Mongolian-Manchurian Grassland (734), Selenge-Orkhon Forest Steppe (737), Nenjiang River Grassland (743), Khangai Mountains Alpine Meadow (755) \u2013 totaling approximately 139 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e240688b-d9aa-4ec8-b81b-d5aab40bd2b5/Bioregion%20map-PA44.jpg"/><figcaption><span class="caption"><p>The Mongolian Grasslands, Alpine Meadows &amp; Forest Steppe bioregion is part of the Mongolian Grasslands subrealm and is made up of six ecoregions: (1) Selenge-Orkhon Forest Steppe (2) Khangai Mountains Alpine Meadow (3) Khangai Mountains Conifer Forests (4) Mongolian-Manchurian Grassland (5) Daurian Forest Steppe (6) Nenjiang River Grassland.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Mongolian Grasslands, Alpine Meadows &amp; Forest Steppe ecoregions below.</p>',
                ecoregions: [
                  { _id: 'd122e0ad-f520-4153-a2e9-51fa6f58344e' },
                  { title: 'Khangai Mountains Alpine Meadow' },
                  { regionId: '755' },
                  {
                    dek:
                      'This ecoregion encompasses a mosaic of habitats at the highest altitudes of Mongolia\u2019s central Khangai mountain range.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cfa47378-a6b4-48fd-9728-b8744ca6cf8c/755 Khangai Mountains alpine meadow - Andre Felbrich.jpg',
                      _id: 'cfa47378-a6b4-48fd-9728-b8744ca6cf8c'
                    }
                  },
                  { _id: '675e976a-9e6e-46c0-b322-2c2d37de1a3c' },
                  { title: 'Nenjiang River Grassland' },
                  { regionId: '743' },
                  {
                    dek:
                      'The Nenjiang River originates in the Khingan mountain range, near the eastern end of the Mongolian Plateau, then flows to the lowlands of central Manchuria in northeastern China. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2a7c2cf4-a30c-45c8-8b69-62fe46b90335/743 Nenjiang River grassland - Refrain.jpg',
                      _id: '2a7c2cf4-a30c-45c8-8b69-62fe46b90335'
                    }
                  },
                  { _id: 'bea93d6f-d33e-4dbb-89fa-6cddc3ed8309' },
                  { title: 'Selenge-Orkhon Forest Steppe' },
                  { regionId: '737' },
                  {
                    dek:
                      'This ecoregion covers the basins of the Tesiin Gol River, which runs to the west; the Selenge River, which run north east to Lake Baikal; and its major tributary, the Orkhon River. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d0a3ce33-99d7-4881-a62b-2b6ae3c3a799/737 Selenge-Orkhon forest steppe - kanenori.jpg',
                      _id: 'd0a3ce33-99d7-4881-a62b-2b6ae3c3a799'
                    }
                  },
                  { _id: '731dd6ea-a9db-4492-9651-1f125a8ee7a4' },
                  { title: 'Mongolian-Manchurian Grassland' },
                  { regionId: '734' },
                  {
                    dek:
                      'This ecoregion is one of the largest, most intact grassland ecosystems on Earth, lying between Siberian conifer forests, Central Asian rocky deserts, and the Manchurian hills of Northeastern China.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dc0d88ba-4530-444e-8874-23b06b8219fa/734 Mongolian-Manchurian grassland - Kanenori.jpg',
                      _id: 'dc0d88ba-4530-444e-8874-23b06b8219fa'
                    }
                  },
                  { _id: '52bba255-3ccd-4d8c-8cdc-1ae3fdce9ee0' },
                  { title: 'Khangai Mountains Conifer Forests' },
                  { regionId: '700 ' },
                  {
                    dek:
                      'This ecoregion is restricted to a narrow northern strip of the Khangai Mountain range of Mongolia, where dense conifer forests grow on the northern aspect of mountain slopes. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6ea5df19-9c39-48f8-a22b-85522afdf3d1/700 Khangai Mountains conifer forests - B\u00e1thory P\u00e9ter.jpg',
                      _id: '6ea5df19-9c39-48f8-a22b-85522afdf3d1'
                    }
                  },
                  { _id: '3320ea69-bac6-468c-8965-bea9c489b07a' },
                  { title: 'Daurian Forest Steppe' },
                  { regionId: '726' },
                  {
                    dek:
                      'Mongolia\u2019s Daurian Forest Steppe ecoregion covers the northern part of the UNESCO-designated \u2018Landscapes of Dauria\u2019, a majestic reach of forest and steppe-grassland that extends across northeastern Mongolia into southern Siberia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3a8a6338-9001-41da-baa5-a7423533f16e/726 Daurian forest steppe (Mongolia) - John Morrison.jpg',
                      _id: '3a8a6338-9001-41da-baa5-a7423533f16e'
                    }
                  }
                ],
                stats: [
                  { number: '139,018', item: 'Total Land Area (1000 ha)' },
                  { number: '6', item: 'Number of Ecoregions' },
                  { number: '33%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Ordos Plateau Steppe & Mountain Conifer Forests (PA42)',
                children: [],
                _id: '62c278b8-2ea1-43ed-b18a-0e117500a009',
                value: 1000,
                parentId: 'e69f30a1-6799-4f7e-a317-a5c9591f45c9',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/21b74c40-5dc9-4c23-8a97-462275e40a22/696 Helanshan Montane Conifer Forests cc.jpeg',
                    _id: '21b74c40-5dc9-4c23-8a97-462275e40a22'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/94ce409d-48cd-4fe8-94b7-08de0f3c852c/761 Ordos Plateau steppe - sylvanus.jpg',
                    _id: '94ce409d-48cd-4fe8-94b7-08de0f3c852c'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c118b4ca-e869-49d1-a001-9dab03a73f76/Bioregion%20map-PA42.jpg',
                content:
                  '<p>The Ordos Plateau Steppe &amp; Mountain Conifer Forests bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains two ecoregions \u2013 Helanshan Montane Conifer Forests (696), Ordos Plateau Steppe (761) \u2013 totaling approximately 24 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c118b4ca-e869-49d1-a001-9dab03a73f76/Bioregion%20map-PA42.jpg"/><figcaption><span class="caption"><p>The Ordos Plateau Steppe &amp; Mountain Conifer Forests bioregion is part of the Mongolian Grasslands subrealm and is made up of two ecoregions: (1) Helanshan Montane Conifer Forests (2) Ordos Plateau Steppe.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Ordos Plateau Steppe &amp; Mountain Conifer Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '6f97006c-0cb8-4c66-847c-25d24b159cae' },
                  { title: 'Ordos Plateau Steppe' },
                  { regionId: '761' },
                  {
                    dek:
                      'The Ordos Plateau lies within the Great Bend of the Huang He (Yellow River) in China.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/94ce409d-48cd-4fe8-94b7-08de0f3c852c/761 Ordos Plateau steppe - sylvanus.jpg',
                      _id: '94ce409d-48cd-4fe8-94b7-08de0f3c852c'
                    }
                  },
                  { _id: 'b19bd9ea-3ff1-42d0-a826-95f2d8129ac1' },
                  { title: 'Helanshan Montane Conifer Forests' },
                  { regionId: '696' },
                  {
                    dek:
                      'The Helanshan mountain range projects northward for about 180 km from the Tibet-Qinghai Plateau in China.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ac66a2e2-5f58-498d-8429-19cb6b6953c0/696 Helanshan montane conifer forests - Yaan.jpg',
                      _id: 'ac66a2e2-5f58-498d-8429-19cb6b6953c0'
                    }
                  }
                ],
                stats: [
                  { number: '24,069', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '10%', item: 'Protection Target' },
                  { number: '8', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Eastern Eurasia',
            value: 400
          },
          {
            _id: 'dbb19f48-2df7-4058-baaa-9a50f5b3be88',
            name: 'Northeast Asian Forests',
            children: [
              {
                name: 'Korean Peninsula Mixed Forests (PA48)',
                children: [],
                _id: 'd7b29e9d-4f70-4c3f-af12-8216663f0936',
                value: 1000,
                parentId: 'dbb19f48-2df7-4058-baaa-9a50f5b3be88',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2578a67b-c8f1-4247-91b6-05cfebd75090/681-Wolchulsan_mountain_peak-CC-2006.jpg',
                    _id: '2578a67b-c8f1-4247-91b6-05cfebd75090'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/74bae07d-e911-42eb-a291-f1f66a40ef92/681-Hallasan-CC- Richard Fabi-2005.jpg',
                    _id: '74bae07d-e911-42eb-a291-f1f66a40ef92'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c0fc1927-c85c-4b13-be88-0dea65a8eed8/681-Korea-Geoje-CC-2006.JPG',
                    _id: 'c0fc1927-c85c-4b13-be88-0dea65a8eed8'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e5e54844-7201-4430-972d-648439c3c96d/Bioregion%20map-PA48.jpg',
                content:
                  '<p>The Korean Peninsula Mixed Forests bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains two ecoregions \u2013 Central Korean Deciduous Forests (655), Southern Korea Evergreen Forests (681) \u2013 totaling approximately 12 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e5e54844-7201-4430-972d-648439c3c96d/Bioregion%20map-PA48.jpg"/><figcaption><span class="caption"><p>The Korean Peninsula Mixed Forests bioregion is part of the Northeast Asian Forests subrealm and is made up of two ecoregions: (1) Central Korean Deciduous Forests (2) Southern Korea Evergreen Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Korean Peninsula Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'a7b04f09-51fe-4ffe-bf7a-09886b934998' },
                  { title: 'Central Korean Deciduous Forests' },
                  { regionId: '655' },
                  {
                    dek:
                      'This ecoregion occupies most of the Korean Peninsula, apart from the southern coastal margin and the hilly north.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/66efd96c-a0bb-4ed7-aa33-6cb983c68f92/655 Central Korean deciduous forests - chokyusang.jpg',
                      _id: '66efd96c-a0bb-4ed7-aa33-6cb983c68f92'
                    }
                  },
                  { _id: 'f2fa162a-3f1f-409e-ae5b-0096627b120d' },
                  { title: 'Southern Korea Evergreen Forests' },
                  { regionId: '681' },
                  {
                    dek:
                      'The climate and environmental conditions of the southern margin of the Korean Peninsula and Jeju Island support warm-temperate evergreen broadleaf forest.\u2060'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9968dad6-6a1a-4852-8df3-73888306cf33/681 Southern Korea evergreen forests - Yi Jo.jpg',
                      _id: '9968dad6-6a1a-4852-8df3-73888306cf33'
                    }
                  }
                ],
                stats: [
                  { number: '11,955', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '20%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'Manchuria-Ussuri Mixed Forests & Meadow Steppes (PA46)',
                children: [],
                _id: 'c2049f0d-f6f3-4884-901f-0d8ce17fe192',
                value: 1000,
                parentId: 'dbb19f48-2df7-4058-baaa-9a50f5b3be88',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/721e456b-5b57-4a9d-9bbf-6560e5a4566c/673 Qin Ling Mountains deciduous forests - Charlie439753.jpg',
                    _id: '721e456b-5b57-4a9d-9bbf-6560e5a4566c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d80790a2-a017-4ebd-af8d-950cfda46826/656-Mount_Paektu-CC-Mark Fahey-2011_resized.jpg',
                    _id: 'd80790a2-a017-4ebd-af8d-950cfda46826'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fffd66d2-fbf7-45ee-82c3-f6be7aff1fd7/746-Marsh leading into Lake Khanka-CC-Marinka Yar-2007.jpg',
                    _id: 'fffd66d2-fbf7-45ee-82c3-f6be7aff1fd7'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c0b535be-0315-4085-a364-3f05f50fc4cc/Bioregion%20map-PA46.jpg',
                content:
                  '<p>The Manchuria-Ussuri Mixed Forests &amp; Meadow Steppes bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains six ecoregions \u2013 Changbai Mountains Mixed Forests (656), Manchurian Mixed Forests (669), Northeast China Plain Deciduous Forests (673), Ussuri Broadleaf and Mixed Forests (685), Amur Meadow Steppe (741), Suiphun-Khanka Meadows and Forest Meadows (746) &nbsp;\u2013 totaling approximately 118.5 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c0b535be-0315-4085-a364-3f05f50fc4cc/Bioregion%20map-PA46.jpg"/><figcaption><span class="caption"><p>The Manchuria-Ussuri Mixed Forests &amp; Meadow Steppes bioregion is part of the Northeast Asian Forests subrealm and is made up of six ecoregions: (1) Northeast China Plain Deciduous Forests (2) Changbai Mountains Mixed Forests (3) Manchurian Mixed Forests (4) Suiphun-Khanka Meadows and Forest Meadows (5) Amur Meadow Steppe (6) Ussuri Broadleaf and Mixed Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Manchuria-Ussuri Mixed Forests &amp; Meadow Steppes ecoregions below.</p>',
                ecoregions: [
                  { _id: 'ec12e84e-fef6-4260-949f-b29f7c0e505c' },
                  { title: 'Suiphun-Khanka Meadows and Forest Meadows' },
                  { regionId: '746' },
                  {
                    dek:
                      'Lake Khanka sits astride the China-Russia border in the center of this ecoregion, which is composed of lowlands surrounding 25 rivers.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/35a2846b-d5c4-4aba-9aa5-c360f385c442/746 Suiphun-Khanka meadows and forest meadows - \u0411\u0435\u0440\u0435\u0433_\u0425\u0430\u043d\u043a\u0438.jpg',
                      _id: '35a2846b-d5c4-4aba-9aa5-c360f385c442'
                    }
                  },
                  { _id: '41fd85fd-91c6-477d-b046-ea661c9ac735' },
                  { title: 'Amur Meadow Steppe' },
                  { regionId: '741' },
                  {
                    dek:
                      'The expansive rivers, Amur and Songhua, wind through the vast, open plains of this ecoregion.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/68aef18f-f131-4e62-9035-760cb1ddc034/741 Amur meadow steppe - Andshel.JPG',
                      _id: '68aef18f-f131-4e62-9035-760cb1ddc034'
                    }
                  },
                  { _id: 'f5129efa-d968-4871-8a01-2a0257ea87e2' },
                  { title: 'Ussuri Broadleaf and Mixed Forests' },
                  { regionId: '685' },
                  {
                    dek:
                      'This ecoregion is found just north of the Amur River, which swings northwards through the ecoregion, east of the Ussuri River on the gentle western slopes of the Sikhote-Alin Mountains, and on the steep eastern slopes of the Sikhote-Alin to the coast of the Sea of Japan. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d923e93b-14f9-4953-813f-13fd9adb5e97/685-Bikin River Valley-Olga Ukhvatkina-2013.jpg',
                      _id: 'd923e93b-14f9-4953-813f-13fd9adb5e97'
                    }
                  },
                  { _id: '68ab421b-9343-4203-937d-a3dc00efefe3' },
                  { title: 'Changbai Mountains Mixed Forests' },
                  { regionId: '656' },
                  {
                    dek: 'This ecoregion spans across northern North Korea and north-eastern China.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7b76a6f1-f7c7-46f5-b63d-c86f2f797a69/656 Changbai Mountains mixed forests - Uwe Brodrecht CCO2.jpg',
                      _id: '7b76a6f1-f7c7-46f5-b63d-c86f2f797a69'
                    }
                  },
                  { _id: '6d9b8d8a-afb6-479e-879e-eb3d99c50d3d' },
                  { title: 'Northeast China Plain Deciduous Forests' },
                  { regionId: '673' },
                  {
                    dek:
                      'The Northeast China Plain deciduous forests ecoregion follows the Liao river upstream from the Bay of Bohai, crosses a low watershed divide into the Songhua river, and extends to the confluence of the Songhua with the Heilongjiang (Amur) River on the Russian frontier.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cf6392c3-3048-4023-a956-49044187a0d8/673 Flower_Sea_Scenic_Spot_in_Fanhe,_Tieling_CC-2014_resized.jpg',
                      _id: 'cf6392c3-3048-4023-a956-49044187a0d8'
                    }
                  },
                  { _id: '030c25b4-673c-4799-ab10-1e703f2899dd' },
                  { title: 'Manchurian Mixed Forests' },
                  { regionId: '669' },
                  {
                    dek:
                      'The Manchurian Mixed Forests ecoregion is affected by a cold continental airflow from interior Asia that brings dry, frigid conditions during winter.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d208cc34-7223-4917-88b7-23b9872a9e20/669 Manchurian mixed forests - Uwe Brodrecht CCO2.jpg',
                      _id: 'd208cc34-7223-4917-88b7-23b9872a9e20'
                    }
                  }
                ],
                stats: [
                  { number: '118,689', item: 'Total Land Area (1000 ha)' },
                  { number: '6', item: 'Number of Ecoregions' },
                  { number: '28%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'Dzhagdy Mountain Conifer Forests (PA45)',
                children: [],
                _id: '87830719-d781-456b-9893-c66f7503df3a',
                value: 1000,
                parentId: 'dbb19f48-2df7-4058-baaa-9a50f5b3be88',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d3fc3944-15fc-40ef-bad9-211c94314fe3/693 Da Hinggan-Dzhagdy Mountains Conifer Forests cc.jpg',
                    _id: 'd3fc3944-15fc-40ef-bad9-211c94314fe3'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9f63db33-7a31-4f38-946b-080ebb31355d/Bioregion%20map-PA45.jpg',
                content:
                  '<p>The Dzhagdy Mountain Conifer Forests bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains one single ecoregion \u2013 Da Hinggan-Dzhagdy Mountains Conifer Forests (693) &nbsp;\u2013 totaling nearly 25 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9f63db33-7a31-4f38-946b-080ebb31355d/Bioregion%20map-PA45.jpg"/><figcaption><span class="caption"><p>The Dzhagdy Mountain Conifer Forests bioregion is part of the Northeast Asian Forests subrealm and is made up of one ecoregions: (1) Da Hinggan-Dzhagdy Mountains Conifer Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Dzhagdy Mountain Conifer Forests ecoregion below.</p>',
                ecoregions: [
                  { _id: '93e28e9d-6494-43ef-9b74-2477650fe9c0' },
                  { title: 'Da Hinggan-Dzhagdy Mountains Conifer Forests' },
                  { regionId: '693' },
                  {
                    dek:
                      'Western interior reaches of the Da Hinggan (Khingan) mountain range of Chinese Inner Mongolia extend north to the Dzhagdy Mountains of Russia, an eastern extension of the great Altai mountain system.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/04894b1f-2170-4a46-aa24-589e627aedc8/693 Da Hinggan-Dzhagdy Mountains conifer forests - heteroscedascity.JPG',
                      _id: '04894b1f-2170-4a46-aa24-589e627aedc8'
                    }
                  }
                ],
                stats: [
                  { number: '24,888', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '23%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Eastern Eurasia',
            value: 600
          },
          {
            _id: '92d277c5-3cc4-4fc0-b7c3-3cbfd9d41422',
            name: 'Japanese Islands',
            children: [
              {
                name: 'Japan Forest Islands (PA47)',
                children: [],
                _id: 'c0200c6f-5cf2-43bd-bf3a-223256ae4111',
                value: 1000,
                parentId: '92d277c5-3cc4-4fc0-b7c3-3cbfd9d41422',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/da4baa90-9fde-474f-ab35-1c9204a7aaef/699-Mt.Tokusa-tozandou-CC-2007.jpg',
                    _id: 'da4baa90-9fde-474f-ab35-1c9204a7aaef'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1a695e23-f641-4d93-9852-25e58622e984/682 Taiheiyo evergreen forests - Kanenori.jpg',
                    _id: '1a695e23-f641-4d93-9852-25e58622e984'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/32567cbe-0f1b-4dae-a6ed-5cd8e256073c/683 Taiheiyo montane deciduous forests - sayama.jpg',
                    _id: '32567cbe-0f1b-4dae-a6ed-5cd8e256073c'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/21049f72-7fc6-45f5-90d2-3d323093d8ed/Bioregion%20map-PA47.jpg',
                content:
                  '<p>The Japan Forest Islands bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains seven ecoregions \u2013 Hokkaido Deciduous Forests (666), Nihonkai Evergreen Forests (670), Nihonkai Montane Deciduous Forests (671), Taiheiyo Evergreen Forests (682), Taiheiyo Montane Deciduous Forests (683), Hokkaido Montane Conifer Forests (698), Honshu Alpine Conifer Forests (699) &nbsp;\u2013 totaling approximately 38 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/21049f72-7fc6-45f5-90d2-3d323093d8ed/Bioregion%20map-PA47.jpg"/><figcaption><span class="caption"><p>The Japan Forest Islands bioregion is part of the Japanese Islands subrealm and is made up of seven ecoregions: (1) Taiheiyo Evergreen Forests (2) Nihonkai Montane Deciduous Forests (3) Nihonkai Evergreen Forests (4) Taiheiyo Montane Deciduous Forests (5) Honshu Alpine Conifer Forests (6) Hokkaido Deciduous Forests (7) Hokkaido Montane Conifer Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Japan Forest Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'b3f74e29-1c66-438f-a7ab-698dbb0e63de' },
                  { title: 'Honshu Alpine Conifer Forests' },
                  { regionId: '699' },
                  {
                    dek:
                      "This ecoregion covers several areas of alpine vegetation amidst montane deciduous forests areas in Northern Honshu (Japan's main island) and Southern Hokkaido islands."
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a895cb2d-7f66-4462-af50-a68ce811db45/699 Honshu alpine conifer forests - Kanenori.jpg',
                      _id: 'a895cb2d-7f66-4462-af50-a68ce811db45'
                    }
                  },
                  { _id: 'b62aa629-02cd-40e0-acda-984fc289dc5f' },
                  { title: 'Hokkaido Montane Conifer Forests' },
                  { regionId: '698' },
                  {
                    dek:
                      "The Hokkaido Montane Conifer Forests ecoregion is located on Japan's northernmost volcanic Island of Hokkaido, the country's second-largest island."
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/30fed13a-d80a-440b-bf8b-d877788be056/698 Hokkaido montane conifer forests - phutinu0.jpg',
                      _id: '30fed13a-d80a-440b-bf8b-d877788be056'
                    }
                  },
                  { _id: 'fbba4c9f-e683-4be4-a74d-233e4885cbef' },
                  { title: 'Taiheiyo Montane Deciduous Forests' },
                  { regionId: '683' },
                  {
                    dek:
                      'This mountainous ecoregion extends from Kyushu island in the south of Japan to the northeastern coast of Honshu, with a small section on Shikoku island. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/32567cbe-0f1b-4dae-a6ed-5cd8e256073c/683 Taiheiyo montane deciduous forests - sayama.jpg',
                      _id: '32567cbe-0f1b-4dae-a6ed-5cd8e256073c'
                    }
                  },
                  { _id: '30df0f2e-669b-46b7-a4f1-9401aea22c8c' },
                  { title: 'Taiheiyo Evergreen Forests' },
                  { regionId: '682' },
                  {
                    dek:
                      'This ecoregion encompasses areas across several of Japan\u2019s major islands, stretching from Kyushu and Shikoku in the south to the western coast of Honshu further north.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1a695e23-f641-4d93-9852-25e58622e984/682 Taiheiyo evergreen forests - Kanenori.jpg',
                      _id: '1a695e23-f641-4d93-9852-25e58622e984'
                    }
                  },
                  { _id: '74e7fa85-34a3-4881-b472-9fa902545f3e' },
                  { title: 'Nihonkai Montane Deciduous Forests' },
                  { regionId: '671 ' },
                  {
                    dek:
                      'This mountainous ecoregion lies predominantly within Japan\u2019s largest island\u2014Honshu\u2014with a small section in the southerly tip of Hokkaido beneath the Kuromatsunai line.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f6137bda-2cb0-4fb0-b3b5-164bc48ff882/671 Nihonkai montane deciduous forests - sayama.jpg',
                      _id: 'f6137bda-2cb0-4fb0-b3b5-164bc48ff882'
                    }
                  },
                  { _id: 'e726d031-6023-4f95-97ce-e0abbf8a95c9' },
                  { title: 'Nihonkai Evergreen Forests' },
                  { regionId: '670' },
                  {
                    dek:
                      'This ecoregion encompasses much of the west coast of Honshu\u2014Japan\u2019s largest island\u2014from the city of Hamada in the south to Yurihonjo in the north.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4d469985-d09c-44e2-964d-73fac2b8d682/670 Nihonkai evergreen forests - Bernard Gagnon.jpg',
                      _id: '4d469985-d09c-44e2-964d-73fac2b8d682'
                    }
                  },
                  { _id: '4998bfd2-f4e3-48ba-bb7b-14a1fa0044b7' },
                  { title: 'Hokkaido Deciduous Forests' },
                  { regionId: '666' },
                  {
                    dek:
                      "This ecoregion covers 36,301 km2 of lowland temperate deciduous forests mostly on Hokkaido, Japan's northernmost island."
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5cebccc7-2d80-4126-9989-57fc70436642/666 Mt_MEKUNNAI-CC-2011.JPG',
                      _id: '5cebccc7-2d80-4126-9989-57fc70436642'
                    }
                  }
                ],
                stats: [
                  { number: '38,032', item: 'Total Land Area (1000 ha) ' },
                  { number: '7', item: 'Number of Ecoregions' },
                  { number: '58%', item: 'Protection Target' },
                  { number: '5', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Eastern Eurasia',
            value: 200
          },
          {
            _id: '80af2445-45fb-487e-8d38-be3fb52b0b15',
            name: 'Central East Asian Forests',
            children: [
              {
                name: 'Hengduan Mountain Conifer Forests (PA53)',
                children: [],
                _id: '933fb0b4-f074-4d73-a940-e3162e8814f1',
                value: 1000,
                parentId: '80af2445-45fb-487e-8d38-be3fb52b0b15',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/73c6de83-2579-4d78-bfac-8b05634f693d/697 Hengduan Mountains subalpine conifer forests - littleP.jpg',
                    _id: '73c6de83-2579-4d78-bfac-8b05634f693d'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6808a2ec-102e-4eb3-82ce-42eefcefbfc3/Bioregion%20map-PA53.jpg',
                content:
                  '<p>The Hengduan Mountain Conifer Forests bioregion includes a group of parallel mountain ranges that connect the southeast portion of the Tibetan Plateau with the Yunnan-Guizhou Plateau in southwest China. These forested mountains are defined by three rivers -- the Yangtze, Mekong, and Salween -- and are recognized today as the Three Parallel Rivers UNESCO World Heritage Site, one of the most biologically diverse temperate region on Earth, home to 6,000 plant species, 173 mammal species, and 417 bird species, many of which are endemic to the region. This bioregion contains three ecoregions \u2014 Hengduan Mountains Subalpine Conifer Forests (697), Nujiang Lancang Gorge Subalpine Conifer and Mixed Forests (704), Qionglai-Minshan Conifer Forests (706) \u2014 totaling over 26 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6808a2ec-102e-4eb3-82ce-42eefcefbfc3/Bioregion%20map-PA53.jpg"/><figcaption><span class="caption"><p>The Hengduan Mountain Conifer Forests bioregion is part of the Central East Asian Forests subrealm and is made up of three ecoregions: (1) Nujiang Lancang Gorge Subalpine Conifer and Mixed Forests (2) Hengduan Mountains Subalpine Conifer Forests (3) Qionglai-Minshan Conifer Forests.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Hengduan Mountain Conifer Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'e899da2e-53d9-4428-bbb6-f9c46dad6bbb' },
                  { title: 'Qionglai-Minshan Conifer Forests' },
                  { regionId: '706' },
                  {
                    dek:
                      'As tectonic forces push Eastern Tibet against the rigid continental crust of the Sichuan Basin, steep mountain escarpments have cropped up to form the Qionglai-Minshan mountain system.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/adec0c49-dab4-4cf9-a49c-da8f65870b9e/706 Qionglai-Minshan conifer forests - btsold.jpg',
                      _id: 'adec0c49-dab4-4cf9-a49c-da8f65870b9e'
                    }
                  },
                  { _id: 'dca8059b-8612-42e8-a91a-e0351bf33fae' },
                  { title: 'Nujiang Lancang Gorge Subalpine Conifer and Mixed Forests' },
                  { regionId: '704' },
                  {
                    dek:
                      'Several parallel river gorges, separated by steep mountain ridges, divide the Yunnan Plateau of China from the eastern Himalaya.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/352d44bf-d7a1-45d6-8953-b257b049a54b/704 Nujiang Langcang Gorge alpine conifer and mixed forests - Rhett Butler.jpg',
                      _id: '352d44bf-d7a1-45d6-8953-b257b049a54b'
                    }
                  },
                  { _id: '55fbe635-3078-4dac-b35c-3030e97e4e60' },
                  { title: 'Hengduan Mountains Subalpine Conifer Forests' },
                  { regionId: '697' },
                  {
                    dek:
                      'The Hengduan mountain system, the most biologically diverse temperate region on Earth, forms a landscape of deep river gorges and tall dividing ranges at the southeastern margin of the Tibet Plateau.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/502f9253-83b5-454a-84b3-5fb1d407263a/697-Hengduan_conifer_forests-CC-2014.jpg',
                      _id: '502f9253-83b5-454a-84b3-5fb1d407263a'
                    }
                  }
                ],
                stats: [
                  { number: '26,303 ', item: 'Ecoregion Size (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '30%', item: 'Protection Target' },
                  { number: '7', item: 'Protection Level' }
                ]
              },
              {
                name: 'Guizhou & Yunnan Subtropical Forest Plateaus (PA52)',
                children: [],
                _id: '553a0a12-b6c4-4400-88f4-0195e12f1c61',
                value: 1000,
                parentId: '80af2445-45fb-487e-8d38-be3fb52b0b15',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/07fe0c55-ad79-497c-a022-546f3896160a/642-Wulingyuan_Hunan Province-CC-Filipe Fortes-2006.jpg',
                    _id: '07fe0c55-ad79-497c-a022-546f3896160a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1461f546-24b6-47ee-b071-e4d75716b9c4/642-Fanjingshan-CC-2019.jpg',
                    _id: '1461f546-24b6-47ee-b071-e4d75716b9c4'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ae86e488-2a08-4ba2-a7e2-df6173b0dab5/642-ZhangJiaJie_River_CC-2007.jpg',
                    _id: 'ae86e488-2a08-4ba2-a7e2-df6173b0dab5'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9da7540f-a6d9-4aff-a680-6b7a4a330236/643-Western Hills-CC-2010.jpg',
                    _id: '9da7540f-a6d9-4aff-a680-6b7a4a330236'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/32a698ab-2349-4e9d-bf4e-35eacd26cfb2/643-South_Jade_Cloud_Road-CC-Ishai Bar-2005.JPG',
                    _id: '32a698ab-2349-4e9d-bf4e-35eacd26cfb2'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b2dfc342-19ea-48ad-9a03-fd23afd3fe8e/Bioregion%20map-PA52.jpg',
                content:
                  '<p>The Guizhou &amp; Yunnan Subtropical Forest Plateaus bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains two ecoregions \u2013 Guizhou Plateau Broadleaf and Mixed Forests (642), Yunnan Plateau Subtropical Evergreen Forests (643) \u2013 totaling approximately 51 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b2dfc342-19ea-48ad-9a03-fd23afd3fe8e/Bioregion%20map-PA52.jpg"/><figcaption><span class="caption"><p>The Guizhou &amp; Yunnan Subtropical Forest Plateaus bioregion is part of the Central East Asian Forests subrealm and is made up of two ecoregions: (1) Yunnan Plateau Subtropical Evergreen Forests (2) Guizhou Plateau Broadleaf and Mixed Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Guizhou &amp; Yunnan Subtropical Forest Plateaus ecoregions below.</p>',
                ecoregions: [
                  { _id: '21c03fe7-ae04-4efc-8ba3-d52301ea9a71' },
                  { title: 'Yunnan Plateau Subtropical Evergreen Forests' },
                  { regionId: '643' },
                  {
                    dek:
                      'The Yunnan Plateau, literally \u201cSouth of the Clouds,\u201d is a transition from the monsoon tropics of Indochina to the eastern Himalayan region. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8c05d1e7-32fc-4fa2-ad2f-e79e30d39368/643 Yunnan Plateau subtropical evergreen forests - \u7b80\u4f53\u4e2d\u6587.jpg',
                      _id: '8c05d1e7-32fc-4fa2-ad2f-e79e30d39368'
                    }
                  },
                  { _id: '866cec38-84c4-49ee-ba65-de2de85919c2' },
                  { title: 'Guizhou Plateau Broadleaf and Mixed Forests' },
                  { regionId: '642' },
                  {
                    dek:
                      'The Guizhou Plateau lies at an elevation of 1,000 to 1,400 m and comprises a rugged landscape of block-shaped limestone hills separated by steep-walled basins; it is part of a geological realm called the South China Karst. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f2eaed04-aa1e-4d9e-a8ba-c8dece24f6b8/642 Guizhou Plateau broadleaf and mixed forests - Vined.jpg',
                      _id: 'f2eaed04-aa1e-4d9e-a8ba-c8dece24f6b8'
                    }
                  }
                ],
                stats: [
                  { number: '51,101', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '14%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'Sichuan Basin & Central Mountain Forests (PA51)',
                children: [],
                _id: '05ea2c55-ee23-4908-9b1a-7ab498e93866',
                value: 1000,
                parentId: '80af2445-45fb-487e-8d38-be3fb52b0b15',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0d32372d-2898-4847-aae1-9176cceb3249/680-China_-_Emei_Shan_1_-_lush_misty_forest_CC-McKay Savage-2006.jpg',
                    _id: '0d32372d-2898-4847-aae1-9176cceb3249'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/061970af-8b53-4b00-94a6-51d5cfacfc47/677-Part_of_Qinling_mountains-CC-2017.jpg',
                    _id: '061970af-8b53-4b00-94a6-51d5cfacfc47'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4438c084-63b0-4f03-8896-c554831081a0/659-Shennongjia_virgin_forest-CC-2012.jpg',
                    _id: '4438c084-63b0-4f03-8896-c554831081a0'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a31edb52-7260-4c0b-befc-37f83199acbb/Bioregion%20map-PA51.jpg',
                content:
                  '<p>The Sichuan Basin &amp; Central Mountain Forests bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains three ecoregions \u2013 Daba Mountains Evergreen Forests (659), Qin Ling Mountains Deciduous Forests (677), Sichuan Basin Evergreen Broadleaf Forests (680) &nbsp;\u2013 totaling approximately 39 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a31edb52-7260-4c0b-befc-37f83199acbb/Bioregion%20map-PA51.jpg"/><figcaption><span class="caption"><p>The Sichuan Basin &amp; Central Mountain Forests bioregion is part of the Central East Asian Forests subrealm and is made up of three ecoregions: (1) Sichuan Basin Evergreen Broadleaf Forests (2) Daba Mountains Evergreen Forests (3) Qin Ling Mountains Deciduous Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Sichuan Basin &amp; Central Mountain Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '21b20da8-6496-4fcc-a9fc-7eeee6e88abb' },
                  { title: 'Sichuan Basin Evergreen Broadleaf Forests' },
                  { regionId: '680' },
                  {
                    dek:
                      'The Sichuan Basin is a fertile expanse of low hills and plains almost entirely encircled by mountains: the Tibet Plateau to the west, karst limestone uplands to the south, row upon row of rugged hills to the north and east, cut through by the Chang Jiang.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e8f7720d-7e66-4462-a371-b859d1df41b3/680 Sichuan Basin evergreen broadleaf forests - fannyss 1.jpg',
                      _id: 'e8f7720d-7e66-4462-a371-b859d1df41b3'
                    }
                  },
                  { _id: '6d1f3a76-4bfb-42cb-a259-0789f7434961' },
                  { title: 'Daba Mountains Evergreen Forests' },
                  { regionId: '659' },
                  {
                    dek:
                      'The Daba Mountains have the most extensive primary forests remaining in central China.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/68f6f08b-2362-4ac1-9e4f-e1f33620000c/659 Daba Mountains evergreen forests - \u4e2d \u5f6d cq19690527.jpg',
                      _id: '68f6f08b-2362-4ac1-9e4f-e1f33620000c'
                    }
                  },
                  { _id: '9c1111f6-e3ac-43fb-8bae-625118d9f7a9' },
                  { title: 'Qin Ling Mountains Deciduous Forests' },
                  { regionId: '677' },
                  {
                    dek:
                      'The Qinling Mountains first formed more than 200 million years ago as a suture zone where the tectonic plate of Southern China, moving north, accreted to the Asian continent.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/261f7ce8-e70d-4f3f-9710-59771c942614/677 Qin Ling Mountains deciduous forests - Charlie Yan.jpg',
                      _id: '261f7ce8-e70d-4f3f-9710-59771c942614'
                    }
                  }
                ],
                stats: [
                  { number: '39,062', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '10%', item: 'Protection Target' },
                  { number: '7', item: 'Protection Level' }
                ]
              },
              {
                name: 'Chang Jiang Plain Evergreen Forests (PA50)',
                children: [],
                _id: 'a314aeb2-3336-4e70-8859-6cadacf942a1',
                value: 1000,
                parentId: '80af2445-45fb-487e-8d38-be3fb52b0b15',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2cc6b2d3-9e05-4953-97b1-7f9a99ff40c2/657-Summit_-_HuangShan-CC-Stephane Janel-2012.jpg',
                    _id: '2cc6b2d3-9e05-4953-97b1-7f9a99ff40c2'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bb0816d4-fcd6-4f03-aa17-5256e2e3e46b/657-Huangshan_CC-Chi King-2007.jpg',
                    _id: 'bb0816d4-fcd6-4f03-aa17-5256e2e3e46b'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/994281aa-8620-469b-ba8f-fae993e02cd0/Bioregion%20map-PA50.jpg',
                content:
                  '<p>The Chang Jiang Plain Evergreen Forests bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains two ecoregions \u2013 Changjiang Plain Evergreen Forests (657), Yellow Sea Saline Meadow (748) \u2013 totaling approximately 44.5 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/994281aa-8620-469b-ba8f-fae993e02cd0/Bioregion%20map-PA50.jpg"/><figcaption><span class="caption"><p>The Chang Jiang Plain Evergreen Forests bioregion is part of the Central East Asian Forests subrealm and is made up of two ecoregions: (1) Changjiang Plain Evergreen Forests (2) Yellow Sea Saline Meadow.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Chang Jiang Plain Evergreen Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '6d6d6dd8-1d76-412c-91fa-c338ddb2cae6' },
                  { title: ' Yellow Sea Saline Meadow' },
                  { regionId: '748' },
                  {
                    dek:
                      'One reach of coastal saline meadow, the Yancheng coastline, extends northward from the mouth of the Yangtze River towards the Shandong Peninsula, holding the Yellow Sea Saline Meadow ecoregion.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ff6f2460-d082-4b90-bc18-5bf60a89f4cb/748 Yellow Sea saline meadow - cmx.gov.cn.jpg',
                      _id: 'ff6f2460-d082-4b90-bc18-5bf60a89f4cb'
                    }
                  },
                  { _id: '91159c26-3f29-4d1b-b3aa-c4b20537e7e9' },
                  { title: 'Changjiang Plain Evergreen Forests' },
                  { regionId: '657' },
                  {
                    dek:
                      'This ecoregion is delineated to the south and west by the mountainous uplands of southern China; to the north, it is separated from the plains of the Huang He by a low watershed divide.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/02b4f6dc-7ca8-4b40-8725-4992897ea33c/657 Changjiang Plain evergreen forests - ChiefSun.jpg',
                      _id: '02b4f6dc-7ca8-4b40-8725-4992897ea33c'
                    }
                  }
                ],
                stats: [
                  { number: '44,433', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '17%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Loess Plateau & Huang He Plain Mixed Forests (PA49)',
                children: [],
                _id: 'f1273a02-caf1-4e96-a56c-c3fb8d5b8988',
                value: 1000,
                parentId: '80af2445-45fb-487e-8d38-be3fb52b0b15',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0c0ca624-a301-4ad6-aaff-7494ae02c676/653 Central China Loess Plateau Mixed Forests Rheins CC.jpg',
                    _id: '0c0ca624-a301-4ad6-aaff-7494ae02c676'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5a171d27-d954-404a-8b64-d77239f7bb2f/667 Huang He Plain mixed forests - Alex Ansley.jpg',
                    _id: '5a171d27-d954-404a-8b64-d77239f7bb2f'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3ed3699d-fd2a-4fc3-95cd-9d52c0a12f63/Bioregion%20map-PA49.jpg',
                content:
                  '<p>The Loess Plateau &amp; Huang He Plain Mixed Forests bioregion is located in the Eastern Eurasia realm (eastern Palearctic) and contains three ecoregions \u2013 Central China Loess Plateau Mixed Forests (653), Huang He Plain Mixed Forests (667), Bohai Sea Saline Meadow (742) \u2013 totaling nearly 81 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3ed3699d-fd2a-4fc3-95cd-9d52c0a12f63/Bioregion%20map-PA49.jpg"/><figcaption><span class="caption"><p>The Loess Plateau &amp; Huang He Plain Mixed Forests bioregion is part of the Central East Asian Forests subrealm and is made up of three ecoregions: (1) Central China Loess Plateau Mixed Forests (2) Huang He Plain Mixed Forests (3) Bohai Sea Saline Meadow.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Eastern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Loess Plateau &amp; Huang He Plain Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '2f2f9ba3-5cdf-4512-86fc-37d9b18bc076' },
                  { title: 'Bohai Sea Saline Meadow' },
                  { regionId: '742' },
                  {
                    dek:
                      'This ecoregion occupies a crescent of the Chinese coast that faces the northern part of the Yellow Sea, north of the Shandong Peninsula.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e18a0c52-d7c7-47e3-a2b0-586a6e0096d7/742 Yellow_River_-CC-2012.jpg',
                      _id: 'e18a0c52-d7c7-47e3-a2b0-586a6e0096d7'
                    }
                  },
                  { _id: '186f039f-f110-428d-ba63-9c20816e44e5' },
                  { title: 'Huang He Plain Mixed Forests' },
                  { regionId: '667' },
                  {
                    dek:
                      'Spreading across northeastern China, the Huang He Plain Mixed Forests ecoregion widens eastward as the floodplains that define it become broader towards the coast of the Yellow Sea.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5a171d27-d954-404a-8b64-d77239f7bb2f/667 Huang He Plain mixed forests - Alex Ansley.jpg',
                      _id: '5a171d27-d954-404a-8b64-d77239f7bb2f'
                    }
                  },
                  { _id: '0628636e-917c-4d8c-bc05-e83044f22d08' },
                  { title: 'Central China Loess Plateau Mixed Forests' },
                  { regionId: '653 ' },
                  {
                    dek:
                      'The Central China Loess Plateau, northwest of the Yellow River Basin, forms a transition zone between the maritime-influenced ecoregions of eastern China and the steppes and deserts of Mongolia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1c6087a6-d142-407e-bf75-e7f2947ed04f/653 Central China Loess Plateau mixed forests - panayota.jpg',
                      _id: '1c6087a6-d142-407e-bf75-e7f2947ed04f'
                    }
                  }
                ],
                stats: [
                  { number: '80,718', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '7%', item: 'Protection Target' },
                  { number: '7', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Eastern Eurasia',
            value: 1000
          }
        ],
        parentId: 'top',
        _id: 'Eastern Eurasia',
        value: 1000
      },
      {
        name: 'Indomalaya',
        children: [
          {
            _id: '75da71cb-9df4-4149-bc6a-22ffbd7e9db9',
            name: 'Malaysia & Western Indonesia',
            children: [
              {
                name: 'Borneo Tropical Forests & Sundaland Heath Forests (IM16)',
                children: [],
                _id: '9a996e95-b631-44d9-8e30-06b7a21f5ef2',
                value: 1000,
                parentId: '75da71cb-9df4-4149-bc6a-22ffbd7e9db9',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/01873293-74a7-4cfb-8a7a-dd883341ef83/Borneo peat swamp forest Ruanda Agung SugardimanAusAID CC.jpg',
                    _id: '01873293-74a7-4cfb-8a7a-dd883341ef83'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f3083028-8dd6-40af-b114-b8f12de86747/281 Sundaland heath forests - Bernard Dupont.jpg',
                    _id: 'f3083028-8dd6-40af-b114-b8f12de86747'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1aedb2af-8e1d-431b-89d9-f75c59cde2a0/313 Kinabalu montane alpine meadows - John Morrison.jpg',
                    _id: '1aedb2af-8e1d-431b-89d9-f75c59cde2a0'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fd933ab0-1305-4e2b-92ca-890b1f9e21a3/Bioregion%20map-IM16%20rev.jpg',
                content:
                  '<p>The Borneo Tropical Forests &amp; Sundaland Heath Forests bioregion is located in the Southeast Asian Forests subrealm of Indomalaya and contains six terrestrial ecoregions \u2013 Borneo Lowland Rainforests (219), Borneo Montane Rainforests (220), Borneo Peat Swamp Forests &nbsp;(221), Southwest Borneo Freshwater Swamp Forests (273), Sundaland Heath Forests (281), Kinabalu Montane Alpine Meadows (313) \u2013 along with the Sunda Shelf Mangroves (322) totaling approximately nearly 75 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fd933ab0-1305-4e2b-92ca-890b1f9e21a3/Bioregion%20map-IM16%20rev.jpg"/><figcaption><span class="caption"><p>The Borneo Tropical Forests &amp; Sundaland Heath Forests bioregion is part of the Malaysia and Western Indonesia subrealm and is made up of seven ecoregions: Southwest Borneo Freshwater Swamp Forests [1], Borneo Peat Swamp Forests [2], Sundaland Heath Forests [3], Borneo Lowland Rainforests [4], Borneo Montane Rainforests [5], Kinabalu Montane Alpine Meadows [6], Sunda Shelf Mangroves [7].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Borneo Tropical Forests &amp; Sundaland Heath Forests ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: '05cd7433-ad03-49a9-ab8c-05072e974dab' },
                  { title: 'Sunda Shelf Mangroves' },
                  { regionId: '322' },
                  {
                    dek:
                      'This ecoregion lines the coasts of the islands of Borneo and Sumatra, astride the geologically active fault known as the \u2018Ring of Fire\u2019 that arcs around the Pacific Ocean.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7d9be759-67e6-457e-9fd0-50e22d168097/322 Sunda Shelf mangroves - Zarqa Liaqat.jpg',
                      _id: '7d9be759-67e6-457e-9fd0-50e22d168097'
                    }
                  },
                  { _id: '8676a053-c5b0-40aa-ade3-7a566a03aff4' },
                  { title: 'Kinabalu Montane Alpine Meadows' },
                  { regionId: '313' },
                  {
                    dek:
                      'Straddling the 4,095 m peak of Mount Kinabalu that towers above the vast tropical rainforests of Borneo, this ecoregion represents the alpine and subalpine meadows and shrublands of the Kinabalu and Crocker ranges.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1aedb2af-8e1d-431b-89d9-f75c59cde2a0/313 Kinabalu montane alpine meadows - John Morrison.jpg',
                      _id: '1aedb2af-8e1d-431b-89d9-f75c59cde2a0'
                    }
                  },
                  { _id: 'a7751e78-4eff-448b-9620-64ee1e2e48ec' },
                  { title: 'Sundaland Heath Forests' },
                  { regionId: '281' },
                  {
                    dek:
                      'This ecoregion is made up of the forests growing on patches of white-sand soils on sandstone plateaus and ridges, and beaches raised from the seabed which have well-drained acidic soils that leach nutrients.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f3083028-8dd6-40af-b114-b8f12de86747/281 Sundaland heath forests - Bernard Dupont.jpg',
                      _id: 'f3083028-8dd6-40af-b114-b8f12de86747'
                    }
                  },
                  { _id: '5fc571fc-c367-4903-b978-5d90c04d3239' },
                  { title: 'Southwest Borneo Freshwater Swamp Forests' },
                  { regionId: '273' },
                  {
                    dek:
                      'This ecoregion represents the freshwater swamp forests that line the southern and western coast of Borneo in Indonesian Kalimantan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1f4cfecb-568a-40b2-9087-24f8fc4c42de/OtterCivet-Credit-SusanChyne-SabengauFelidProject.jpeg',
                      _id: '1f4cfecb-568a-40b2-9087-24f8fc4c42de'
                    }
                  },
                  { _id: 'af13ff3b-fb3b-4502-b333-b57543297c10' },
                  { title: 'Borneo Peat Swamp Forests' },
                  { regionId: '221' },
                  {
                    dek:
                      'This ecoregion represents the peat swamps along the coasts of Borneo and around the clusters of inland lakes associated with the Mahakam and Kapuas rivers.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/42f544c9-1101-4630-b467-a2077367e80e/Borneo peat swamp forest JeremiahsCPs CC.jpg',
                      _id: '42f544c9-1101-4630-b467-a2077367e80e'
                    }
                  },
                  { _id: '8f35ac6e-f3cb-42fa-8588-9eb10c72831b' },
                  { title: 'Borneo Montane Rainforests' },
                  { regionId: '220' },
                  {
                    dek:
                      'This ecoregion representing the montane forests along the central spine of Borneo has been described as a montane archipelago in an ocean of lowland dipterocarp forests.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/75b81322-6d11-4233-a560-f31801362811/220 Borneo montane rain forests - Paul White.jpg',
                      _id: '75b81322-6d11-4233-a560-f31801362811'
                    }
                  },
                  { _id: '2476b71b-754d-4297-8831-11bdd77d78f8' },
                  { title: 'Borneo Lowland Rainforests' },
                  { regionId: '219' },
                  {
                    dek:
                      'The biodiversity of Borneo\u2019s rainforests is among the richest in the world, rivalling forests of New Guinea and the Amazon.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/77a76706-9bcd-4902-a42f-edee81bf5b84/219 Borneo lowland forest - Rhett Butler.jpg',
                      _id: '77a76706-9bcd-4902-a42f-edee81bf5b84'
                    }
                  }
                ],
                stats: [
                  { number: '74,859 ', item: 'Total Land Area (1000 ha)' },
                  { number: '7', item: 'Number of Ecoregions' },
                  { number: '69%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Peninsular Malaysian & Sumatran Tropical Rainforests (IM18)',
                children: [],
                _id: 'd6f99311-bfc6-4e1b-a95c-0c1ef5efd3a1',
                value: 1000,
                parentId: '75da71cb-9df4-4149-bc6a-22ffbd7e9db9',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/77eba7c7-c586-4f6e-bf4e-4bb57c103b6b/278 Sumatran lowland rain forests - R Butler.jpg',
                    _id: '77eba7c7-c586-4f6e-bf4e-4bb57c103b6b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7d9be759-67e6-457e-9fd0-50e22d168097/322 Sunda Shelf mangroves - Zarqa Liaqat.jpg',
                    _id: '7d9be759-67e6-457e-9fd0-50e22d168097'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8c0d6d26-9011-416c-b95c-71023e9541a3/263 Peninsular Malaysian montane rain forests - John Morrison.jpg',
                    _id: '8c0d6d26-9011-416c-b95c-71023e9541a3'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/44ad0dd6-9f1a-4472-9c58-a20fd73a0c3b/Bioregion-map-IM18-rev.jpg',
                content:
                  '<p>The Peninsular Malaysian &amp; Sumatran Tropical Rainforests bioregion is located in the Southeast Asian Forests subrealm of Indomalaya and contains ten ecoregions \u2013 Mentawai Islands Rainforests (245), Sumatran Montane Rainforests (279), Sumatran Lowland Rainforests (278), Sumatran Tropical Pine Forests (305), Sumatran Freshwater Swamp Forests (277), Sumatran Peat Swamp Forests (280), Peninsular Malaysian Rainforests (265), Peninsular Malaysian Peat Swamp Forests (264), Peninsular Malaysian Montane Rainforests (263), Sunda Shelf Mangroves (322) \u2014 totaling nearly 62 million hectares of land area with extensive surrounding marine areas.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/44ad0dd6-9f1a-4472-9c58-a20fd73a0c3b/Bioregion-map-IM18-rev.jpg"/><figcaption><span class="caption"><p>The Peninsular Malaysian &amp; Sumatran Tropical Rainforests bioregion is part of the Indomalaya subrealm and is made up of 10 ecoregions: Mentawai Islands Rainforests [1], Sumatran Montane Rainforests [2], Sumatran Lowland Rainforests [3], Sumatran Tropical Pine Forests [4], Sumatran Freshwater Swamp Forests [5], Sumatran Peat Swamp Forests [6], Peninsular Malaysian Rainforests [7], Peninsular Malaysian Peat Swamp Forests [8], Peninsular Malaysian Montane Rainforests [9], Sunda Shelf Mangroves [10].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Peninsular Malaysian &amp; Sumatran Tropical Rainforests ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: '156bcf6e-c9db-4914-a39b-ca512acd1e96' },
                  { title: 'Sumatran Tropical Pine Forests' },
                  { regionId: '305' },
                  {
                    dek:
                      'This ecoregion consists of five discrete patches of tropical pine forests scattered across the mountain range and embedded within the montane broadleaf forests of Sumatra. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e27440f8-cdb7-4a7a-a273-c368f43b7a4e/305 Sumatran tropical pine forests - Mohd Fahmi.jpg',
                      _id: 'e27440f8-cdb7-4a7a-a273-c368f43b7a4e'
                    }
                  },
                  { _id: '06130162-7d4f-4d7f-9afa-41213350efd1' },
                  { title: 'Sumatran Peat Swamp Forests' },
                  { regionId: '280' },
                  {
                    dek:
                      'The Sumatran Peat Swamp Forests lie along the southeastern coast of Sumatra.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f48ba44a-2110-4154-8be2-40a28652e8c0/280 Sumatran peat swamp forests - James Maiden CIFOR.jpg',
                      _id: 'f48ba44a-2110-4154-8be2-40a28652e8c0'
                    }
                  },
                  { _id: 'da2f44c1-9938-4dd9-93ed-f75d43d2b26d' },
                  { title: 'Sumatran Montane Rainforests' },
                  { regionId: '279' },
                  {
                    dek:
                      'This ecoregion represents the forests above 1,000 m in elevation along the Barisan Mountain Range that runs the length of Sumatra.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/23932304-20aa-4f5d-bdad-fefe30277beb/279 Sumatran montane rain forests - Nomo Michael Hoefner.jpg',
                      _id: '23932304-20aa-4f5d-bdad-fefe30277beb'
                    }
                  },
                  { _id: '8232444f-0f51-442a-b791-989b05bd02f6' },
                  { title: 'Sumatran Lowland Rainforests' },
                  { regionId: '278' },
                  { dek: 'This ecoregion covers the lowland rainforests of Sumatra.' },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/77eba7c7-c586-4f6e-bf4e-4bb57c103b6b/278 Sumatran lowland rain forests - R Butler.jpg',
                      _id: '77eba7c7-c586-4f6e-bf4e-4bb57c103b6b'
                    }
                  },
                  { _id: '29e556e2-2970-4b25-ae7d-2144d98adcb2' },
                  { title: 'Sumatran Freshwater Swamp Forests' },
                  { regionId: '277' },
                  {
                    dek:
                      'This ecoregion represents the disjunct patches of freshwater swamp forests adjacent to the peat swamp forests in eastern Sumatra. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/54ef5c75-75b0-4710-b965-141d156d6994/277 Sumatran freshwater swamp forests - Rhett Butler.jpg',
                      _id: '54ef5c75-75b0-4710-b965-141d156d6994'
                    }
                  },
                  { _id: '15a37d43-1af7-4ff2-90a1-d12cb4671a37' },
                  { title: 'Peninsular Malaysian Rainforests' },
                  { regionId: '265' },
                  {
                    dek:
                      'This ecoregion represents the lowland moist forests of peninsular Malaysia, with small sections extending into southern Thailand. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/535a11ec-4995-4885-9d4a-6760541a9a01/265 Peninsular Malaysian rain forests - Gregorik.JPG',
                      _id: '535a11ec-4995-4885-9d4a-6760541a9a01'
                    }
                  },
                  { _id: '681ccf4e-150c-40c9-bacb-8fe4f97eb8e4' },
                  { title: 'Peninsular Malaysian Peat Swamp Forests' },
                  { regionId: '264' },
                  {
                    dek:
                      'This ecoregion is located along the coastal regions of Peninsular Malaysia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8cdb6116-4ef7-46b6-a128-e572a431f608/Peninsular Malaysian Peat Swamp Forests Frostpolar CC.jpg',
                      _id: '8cdb6116-4ef7-46b6-a128-e572a431f608'
                    }
                  },
                  { _id: '29c08b32-6799-45a1-8fb7-7957799fab33' },
                  { title: 'Peninsular Malaysian Montane Rainforests' },
                  { regionId: '263' },
                  {
                    dek:
                      'This ecoregion represents the montane forests in central peninsular Malaysia, barely extending to the southernmost areas of Thailand.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8c0d6d26-9011-416c-b95c-71023e9541a3/263 Peninsular Malaysian montane rain forests - John Morrison.jpg',
                      _id: '8c0d6d26-9011-416c-b95c-71023e9541a3'
                    }
                  },
                  { _id: '41299d6b-f25a-4174-af9b-a10d67e1e439' },
                  { title: 'Mentawai Islands Rainforests' },
                  { regionId: '245' },
                  {
                    dek:
                      'This ecoregion represents the islands 80 to 120 km off the western coast of Sumatra.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/870b5a7a-d929-451c-a3b6-0b0b804885e7/245 Mentawai Islands rain forests - Viajar24h.jpg',
                      _id: '870b5a7a-d929-451c-a3b6-0b0b804885e7'
                    }
                  },
                  { _id: '05cd7433-ad03-49a9-ab8c-05072e974dab' },
                  { title: 'Sunda Shelf Mangroves' },
                  { regionId: '322' },
                  {
                    dek:
                      'This ecoregion lines the coasts of the islands of Borneo and Sumatra, astride the geologically active fault known as the \u2018Ring of Fire\u2019 that arcs around the Pacific Ocean.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7d9be759-67e6-457e-9fd0-50e22d168097/322 Sunda Shelf mangroves - Zarqa Liaqat.jpg',
                      _id: '7d9be759-67e6-457e-9fd0-50e22d168097'
                    }
                  }
                ],
                stats: [
                  { number: ' 61,361 ', item: 'Total Land Area (1000 ha) ' },
                  { number: '10', item: 'Number of Ecoregions' },
                  { number: '54%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Javan-Bali Tropical Rainforests (IM17) ',
                children: [],
                _id: 'fe68c7a9-2c76-4800-8bd2-f395c35d7b1f',
                value: 1000,
                parentId: '75da71cb-9df4-4149-bc6a-22ffbd7e9db9',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d259e213-5467-4c47-a541-6bff3f770675/289 Western Java rain forests - Achmad Soerio Hutomo.jpg',
                    _id: 'd259e213-5467-4c47-a541-6bff3f770675'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fb100d16-4d48-490f-8ceb-dc47f2d7cf75/229 Eastern Java-Bali montane rain forests - Aknafi.jpg',
                    _id: 'fb100d16-4d48-490f-8ceb-dc47f2d7cf75'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1329bd96-a64b-4f7f-b52a-727dad51bdb5/288 Western Java montane rain forests (Mt Salak) - John Morrison.jpg',
                    _id: '1329bd96-a64b-4f7f-b52a-727dad51bdb5'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fc926a03-2bf9-479e-909d-c68a4c816f44/Bioregion%20map-IM17-Malaysia%20and%20Western%20Indonesia.jpg',
                content:
                  '<p>The Javan-Bali Tropical Rainforests bioregion is located in the Southeast Asian Forests subrealm of Indomalaya and contains five ecoregions \u2013 Christmas and Cocos Islands Tropical Forests (227), Eastern Java-Bali Montane Rainforests (229), Eastern Java-Bali Rainforests (230), Western Java Montane Rainforests (288), Western Java Rainforests (289) \u2013 totaling nearly 14 million hectares of land area with extensive surrounding marine areas.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fc926a03-2bf9-479e-909d-c68a4c816f44/Bioregion%20map-IM17-Malaysia%20and%20Western%20Indonesia.jpg"/><figcaption><span class="caption"><p>The Javan-Bali Tropical Rainforests bioregion is part of the Malaysia and Western Indonesia subrealm and is made up of five ecoregions: Western Java Rainforests [1], Western Java Montane Rainforests [2], Eastern Java-Bali Rainforests [3], Eastern Java-Bali Montane Rainforests [4], Christmas and Cocos Islands Tropical Forests [5].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Javan-Bali Tropical Rainforests ecoregions below.</p>',
                ecoregions: [
                  { _id: '0da637f6-8309-41f3-9df5-17693483c517' },
                  { title: 'Western Java Rainforests' },
                  { regionId: '289' },
                  {
                    dek:
                      'This ecoregion represents the lowland rainforests of western and central Java, an Indonesian island along the famous Ring of Fire that defines the seismically active border of the northward-drifting Pacific Plate. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d259e213-5467-4c47-a541-6bff3f770675/289 Western Java rain forests - Achmad Soerio Hutomo.jpg',
                      _id: 'd259e213-5467-4c47-a541-6bff3f770675'
                    }
                  },
                  { _id: 'd0f4db1c-d925-497c-be41-95d105d9b3ad' },
                  { title: 'Western Java Montane Rainforests' },
                  { regionId: '288' },
                  {
                    dek: 'This ecoregion represents the montane forests of West and Central Java. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1329bd96-a64b-4f7f-b52a-727dad51bdb5/288 Western Java montane rain forests (Mt Salak) - John Morrison.jpg',
                      _id: '1329bd96-a64b-4f7f-b52a-727dad51bdb5'
                    }
                  },
                  { _id: 'ca6f8fc4-f78f-409f-a65d-b6e29d1d8da5' },
                  { title: 'Eastern Java-Bali Rainforests' },
                  { regionId: '230' },
                  {
                    dek:
                      'This ecoregion represents the lowland moist forests of the eastern half of the island of Java and Bali, and the smaller islands off the northern coasts of both.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ca760740-9ca9-410c-9e15-7d930cad2c7e/230 Eastern Java-Bali rain forests - Rochmad Setyadi.jpg',
                      _id: 'ca760740-9ca9-410c-9e15-7d930cad2c7e'
                    }
                  },
                  { _id: '956e93d7-fd7e-4cf6-b72b-693a8200e773' },
                  { title: 'Eastern Java\u2013Bali Montane Rainforests' },
                  { regionId: '229' },
                  {
                    dek:
                      'This ecoregion represents forests along the central mountains of eastern Java and Bali, comprised of a row of about twenty active and dormant volcanos.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fb100d16-4d48-490f-8ceb-dc47f2d7cf75/229 Eastern Java-Bali montane rain forests - Aknafi.jpg',
                      _id: 'fb100d16-4d48-490f-8ceb-dc47f2d7cf75'
                    }
                  },
                  { _id: 'fc7fb64f-15b3-42a1-9dcf-079175b0c103' },
                  { title: 'Christmas and Cocos Islands Tropical Forests' },
                  { regionId: '227' },
                  {
                    dek:
                      'Christmas Island and the Cocos Islands are two peaks of ancient submarine volcanos that rise over 5,000 m from the Indian Ocean floor, now peeking out the ocean surface.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b08d589f-4401-47cc-9a37-146ef394e219/227 Christmas and Cocos Islands tropical forests - Michael Seebeck.jpg',
                      _id: 'b08d589f-4401-47cc-9a37-146ef394e219'
                    }
                  }
                ],
                stats: [
                  { number: '13,818 ', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '30%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Indomalaya',
            value: 375
          },
          {
            _id: 'bd861c5e-bc4e-4a23-b501-16e7d5d069c5',
            name: 'Indian Subcontinent',
            children: [
              {
                name: 'Greater Deccan-Sri Lankan Forests & Drylands (IM8)',
                children: [],
                _id: '011f3d73-cde6-4cbc-8cdf-5b0eb9fcb522',
                value: 1000,
                parentId: 'bd861c5e-bc4e-4a23-b501-16e7d5d069c5',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/736d73b4-0f52-4ee5-89af-efaf54fdc32a/315-Deccan_Scrub_Forests_at_Mastyagiri_CC-2012_resized.jpg',
                    _id: '736d73b4-0f52-4ee5-89af-efaf54fdc32a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a07cf933-bf4a-4779-b92a-8141152b45d1/297 North Deccan dry deciduous forests - Theasg sap.JPG',
                    _id: 'a07cf933-bf4a-4779-b92a-8141152b45d1'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fa3c047e-1ee6-4e74-b5b3-113068a8c8c5/293 East Deccan dry-evergreen forests - Shmilyshy.JPG',
                    _id: 'fa3c047e-1ee6-4e74-b5b3-113068a8c8c5'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/167ccc9b-7804-4d12-95eb-e360d4a7108b/Bioregion%20map-IM8%20Indian%20Subcontinent.jpg',
                content:
                  '<p>The Greater Deccan-Sri Lankan Forests &amp; Drylands bioregion is located within the Indian Subcontinent subrealm in Indomalaya and contains six ecoregions \u2013 Central Deccan Plateau Dry Deciduous Forests [1], Deccan Thorn Scrub Forests [2], South Deccan Plateau Dry Deciduous Forests [3], East Deccan Dry-Evergreen Forests [4], Sri Lanka Dry-Zone Dry Evergreen Forests [5], Godavari-Krishna Mangroves [6] \u2013 totaling approximately 73 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/167ccc9b-7804-4d12-95eb-e360d4a7108b/Bioregion%20map-IM8%20Indian%20Subcontinent.jpg"/><figcaption><span class="caption"><p>The Greater Deccan-Sri Lankan Forests &amp; Drylands bioregion is part of the Indian Subcontinent subrealm and is made up of six ecoregions: Central Deccan Plateau Dry Deciduous Forests [1], Deccan Thorn Scrub Forests [2], South Deccan Plateau Dry Deciduous Forests [3], East Deccan Dry-Evergreen Forests [4], Sri Lanka Dry-Zone Dry Evergreen Forests [5], Godavari-Krishna Mangroves [6].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Greater Deccan-Sri Lankan Forests &amp; Drylands ecoregions below.</p>',
                ecoregions: [
                  { _id: '56ecbaaa-c137-4073-a0fa-e1c697bc9990' },
                  { title: 'Godavari-Krishna Mangroves' },
                  { regionId: '316' },
                  {
                    dek:
                      'This ecoregion extends as a narrow band along the middle-region coast of the Indian subcontinent. It forms larger patches in the estuaries of the Godavari and Krishna rivers.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cbbe6275-7ae7-4d71-8532-9a998925fd9b/316 Godavari-Krishna mangroves - JM Garg.jpg',
                      _id: 'cbbe6275-7ae7-4d71-8532-9a998925fd9b'
                    }
                  },
                  { _id: 'e54a4910-e1e0-407a-b260-09f9f67088bf' },
                  { title: 'Deccan Thorn Scrub Forests' },
                  { regionId: '315' },
                  {
                    dek:
                      'This ecoregion represents the low, sparse thorn scrub vegetation in the arid parts of the Deccan Plateau.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/736d73b4-0f52-4ee5-89af-efaf54fdc32a/315-Deccan_Scrub_Forests_at_Mastyagiri_CC-2012_resized.jpg',
                      _id: '736d73b4-0f52-4ee5-89af-efaf54fdc32a'
                    }
                  },
                  { _id: '012b0272-432f-4e7b-8541-580ca81bd735' },
                  { title: 'Sri Lanka Dry-Zone Dry Evergreen Forests' },
                  { regionId: '301' },
                  {
                    dek:
                      'This ecoregion represents the tropical dry forests throughout most of Sri Lanka.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/18d9c759-8fed-444c-a033-02f591586ab7/301 Sri Lanka dry-zone dry evergreen forests - Eric Wikaramanayake.jpg',
                      _id: '18d9c759-8fed-444c-a033-02f591586ab7'
                    }
                  },
                  { _id: '076211af-51d1-4f0d-8484-05b3536e6f25' },
                  { title: 'South Deccan Plateau Dry Deciduous Forests' },
                  { regionId: '298' },
                  {
                    dek:
                      'The ecoregion represents the expanse of tropical dry forests in the southern parts of the Deccan Plateau, in the rain shadow cast by the Western Ghats Mountains.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/653f3c32-1315-44cc-8e4e-142d68426819/298 South Deccan Plateau dry deciduous forests - Eric Wikramanayake.jpg',
                      _id: '653f3c32-1315-44cc-8e4e-142d68426819'
                    }
                  },
                  { _id: '1b546a8a-41ab-42f0-84dd-be4872e1cb9f' },
                  { title: 'East Deccan Dry-Evergreen Forests' },
                  { regionId: '293' },
                  {
                    dek:
                      'This ecoregion is relatively small, and represents the narrow strip of dry evergreen forests along the coast of southeastern India.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0b30c566-19db-4d5c-9b6f-2d337f3a0af1/Ebony tree forest public domain.jpg',
                      _id: '0b30c566-19db-4d5c-9b6f-2d337f3a0af1'
                    }
                  },
                  { _id: 'e036b334-cc7f-4b1a-8e10-5a794597aa50' },
                  { title: 'Central Deccan Plateau Dry Deciduous Forests' },
                  { regionId: '290' },
                  {
                    dek:
                      'The ecoregion sits in the middle of the Deccan Plateau that makes up most of India.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ec258f4a-03b4-467e-872e-7ca7d6f35dff/290 Central Deccan Plateau dry deciduous forests - Eric Wikramanayake.jpg',
                      _id: 'ec258f4a-03b4-467e-872e-7ca7d6f35dff'
                    }
                  }
                ],
                stats: [
                  { number: '73,823 ', item: 'Total Land Area (1000 ha)' },
                  { number: '6', item: 'Number of Ecoregions' },
                  { number: '8%', item: 'Protection Target' },
                  { number: '8', item: 'Protection Level' }
                ]
              },
              {
                name: 'Northern Deccan & Odisha Tropical Forests (IM7)',
                children: [],
                _id: '6a4ec863-f7a2-40e6-8d94-6d81882dc897',
                value: 1000,
                parentId: 'bd861c5e-bc4e-4a23-b501-16e7d5d069c5',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ce9e1afd-a591-46a7-ac2a-d0b739a5b6f9/261 Orissa semi-evergreen forests - Punu150.jpg',
                    _id: 'ce9e1afd-a591-46a7-ac2a-d0b739a5b6f9'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c0f180eb-9e4d-420c-8b4e-7d001e1c829a/228-Kambhalakonda-CC-2011.jpg',
                    _id: 'c0f180eb-9e4d-420c-8b4e-7d001e1c829a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/393fce7d-09ac-41ec-a6ef-34383fca9b67/228-Woods-CC-2012.jpg',
                    _id: '393fce7d-09ac-41ec-a6ef-34383fca9b67'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b2ea8e81-6c87-4d90-9434-3067fc073147/Bioregion%20map-IM7%20Indian%20Subcontinent.jpg',
                content:
                  '<p>The Northern Deccan &amp; Odisha Tropical Forests bioregion is located within the Indian Subcontinent subrealm in Indomalaya and contains four &nbsp;ecoregions \u2013 East Deccan Moist Deciduous Forests [1], North Deccan Dry Deciduous Forests [2], Orissa Semi-Evergreen Forests [3], Godavari-Krishna Mangroves [4] \u2013 totaling approximately 42 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b2ea8e81-6c87-4d90-9434-3067fc073147/Bioregion%20map-IM7%20Indian%20Subcontinent.jpg"/><figcaption><span class="caption"><p>The Northern Deccan &amp; Odisha Tropical Forests bioregion is part of the Indian Subcontinent subrealm and is made up of four ecoregions: East Deccan Moist Deciduous Forests [1], North Deccan Dry Deciduous Forests [2], Orissa Semi-Evergreen Forests [3], Godavari-Krishna Mangroves [4].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Northern Deccan &amp; Odisha Tropical Forests ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: '56ecbaaa-c137-4073-a0fa-e1c697bc9990' },
                  { title: 'Godavari-Krishna Mangroves' },
                  { regionId: '316' },
                  {
                    dek:
                      'This ecoregion extends as a narrow band along the middle-region coast of the Indian subcontinent. It forms larger patches in the estuaries of the Godavari and Krishna rivers.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cbbe6275-7ae7-4d71-8532-9a998925fd9b/316 Godavari-Krishna mangroves - JM Garg.jpg',
                      _id: 'cbbe6275-7ae7-4d71-8532-9a998925fd9b'
                    }
                  },
                  { _id: 'e3ababb9-47e3-46b3-b735-10fc06ef4470' },
                  { title: 'North Deccan Dry Deciduous Forests' },
                  { regionId: '297' },
                  {
                    dek:
                      'This ecoregion extends across three Indian states of Bihar, Orissa, and Madhya Pradesh, and represents the northern extent of dry deciduous forests in India.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a07cf933-bf4a-4779-b92a-8141152b45d1/297 North Deccan dry deciduous forests - Theasg sap.JPG',
                      _id: 'a07cf933-bf4a-4779-b92a-8141152b45d1'
                    }
                  },
                  { _id: 'f1b76982-e3d0-4fc4-83bd-67bb657b9fb8' },
                  { title: 'Orissa Semi-Evergreen Forests' },
                  { regionId: '261' },
                  {
                    dek:
                      'The flora and fauna of this ecoregion has an ancient geological lineage with Gondwanaland origins, but now represents the forests along the low hills in the northeastern Indian State of Orissa.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ce9e1afd-a591-46a7-ac2a-d0b739a5b6f9/261 Orissa semi-evergreen forests - Punu150.jpg',
                      _id: 'ce9e1afd-a591-46a7-ac2a-d0b739a5b6f9'
                    }
                  },
                  { _id: 'cdef68a3-ae9c-415a-9325-75cc99574b09' },
                  { title: 'East Deccan Moist Deciduous Forests' },
                  { regionId: '228' },
                  {
                    dek:
                      'This ecoregion is a tropical moist deciduous forest ecoregion of east-central India.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cf358114-2741-4198-b7f2-bbb2219f473d/228 East Deccan moist deciduous forests - Adityamadhav83.JPG',
                      _id: 'cf358114-2741-4198-b7f2-bbb2219f473d'
                    }
                  }
                ],
                stats: [
                  { number: '42,971 ', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '6%', item: 'Protection Target' },
                  { number: '8', item: 'Protection Level' }
                ]
              },
              {
                name: 'North Indian Tropical Forests & Sundarbans (IM6)',
                children: [],
                _id: '93ebda6f-9a2d-4bfc-a730-e7a58a6b54b4',
                value: 1000,
                parentId: 'bd861c5e-bc4e-4a23-b501-16e7d5d069c5',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/37f5f477-9a5a-49d6-add9-8bb82f8614a2/282 Sunderban-CC-Santanu dey-2013_resized.jpg',
                    _id: '37f5f477-9a5a-49d6-add9-8bb82f8614a2'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6e40a004-1a21-4ed3-8980-66dbde3db08a/244 Meghalaya subtropical forests - chalonortheast.jpg',
                    _id: '6e40a004-1a21-4ed3-8980-66dbde3db08a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cdd7322b-f622-487c-b0bc-5107a4d6faf1/287 Upper Gangetic Plains moist deciduous forests - varsham 1.jpg',
                    _id: 'cdd7322b-f622-487c-b0bc-5107a4d6faf1'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7b212fb5-83c4-4a48-84d1-70a44238e898/Bioregion%20map-IM6%20Indian%20Subcontinent.jpg',
                content:
                  '<p>The North Indian Tropical Forests &amp; Sundarbans bioregion is the eastern section of the Indian Subcontinent subrealm in Indomalaya, containing seven terrestrial ecoregions \u2013 Upper Gangetic Plains Moist Deciduous Forests [1], Lower Gangetic Plains Moist Deciduous Forests [2], Meghalaya Subtropical Forests [3], Brahmaputra Valley Semi-Evergreen Forests [4], Sundarbans Freshwater Swamp Forests [5], Sundarbans Mangroves [6], Myanmar Coast Mangroves [7] \u2013 along with the Myanmar Coast Mangroves (321) and Sundarbans Mangroves (323) totaling approximately 66 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7b212fb5-83c4-4a48-84d1-70a44238e898/Bioregion%20map-IM6%20Indian%20Subcontinent.jpg"/><figcaption><span class="caption"><p>The North Indian Tropical Forests &amp; Sundarbans bioregion is part of the Indian Subcontinent subrealm and is made up of seven ecoregions: Upper Gangetic Plains Moist Deciduous Forests [1], Lower Gangetic Plains Moist Deciduous Forests [2], Meghalaya Subtropical Forests [3], Brahmaputra Valley Semi-Evergreen Forests [4], Sundarbans Freshwater Swamp Forests [5], Sundarbans Mangroves [6], Myanmar Coast Mangroves [7].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the North Indian Tropical Forests &amp; Sundarbans ecoregions below.</p>',
                ecoregions: [
                  { _id: 'cdc6c0ba-51e5-47c6-9485-3ab44b522efd' },
                  { title: 'Sundarbans Mangroves' },
                  { regionId: '323' },
                  {
                    dek:
                      'This ecoregion lies in a vast delta, an area over 10,000 km2 formed by the confluence of South Asia\u2019s largest rivers, the Ganges, Hooghly, Padma, Brahmaputra and Meghna.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2b57f90e-c616-4e59-8954-f94f170b685e/323_Heritiera fomes (mangrove tree species)_3_Wikimedia Commons.jpg',
                      _id: '2b57f90e-c616-4e59-8954-f94f170b685e'
                    }
                  },
                  { _id: '9ea6d147-bc7e-43dd-9974-349ebbf5253c' },
                  { title: 'Upper Gangetic Plains Moist Deciduous Forests' },
                  { regionId: '287' },
                  {
                    dek:
                      'This ecoregion lies along one of Asia\u2019s largest and most sacred rivers, the Ganges, or Ganga.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cdd7322b-f622-487c-b0bc-5107a4d6faf1/287 Upper Gangetic Plains moist deciduous forests - varsham 1.jpg',
                      _id: 'cdd7322b-f622-487c-b0bc-5107a4d6faf1'
                    }
                  },
                  { _id: '36aa6034-5af4-4250-94a7-50146de9633e' },
                  { title: 'Sundarbans Freshwater Swamp Forests' },
                  { regionId: '282' },
                  {
                    dek:
                      'This ecoregion represents the swamp forests surrounding the Sundarbans Mangroves, in the zone where the freshwater from the rivers push back the saline waters of the intruding ocean.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/37f5f477-9a5a-49d6-add9-8bb82f8614a2/282 Sunderban-CC-Santanu dey-2013_resized.jpg',
                      _id: '37f5f477-9a5a-49d6-add9-8bb82f8614a2'
                    }
                  },
                  { _id: 'fca5c9da-328a-42e8-b126-9b0a7f2f6c6a' },
                  { title: 'Meghalaya Subtropical Forests' },
                  { regionId: '244' },
                  {
                    dek:
                      'This ecoregion represents the subtropical forests of the Khasi and Garo hills of the Indian State, Meghalaya, which literally means \u2018abode of clouds\u2019. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6e40a004-1a21-4ed3-8980-66dbde3db08a/244 Meghalaya subtropical forests - chalonortheast.jpg',
                      _id: '6e40a004-1a21-4ed3-8980-66dbde3db08a'
                    }
                  },
                  { _id: '4e093f65-7301-43e0-8889-4260576a6dfd' },
                  { title: 'Lower Gangetic Plains Moist Deciduous Forests' },
                  { regionId: '238' },
                  {
                    dek:
                      'This ecoregion lies along the confluence of two of Asia\u2019s largest rivers, the Ganges and Brahmaputra Rivers.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/edb0256d-23ee-4514-bf96-fb2eb82418f4/238 Lower Gangetic Plains moist deciduous forests - JKDs.jpg',
                      _id: 'edb0256d-23ee-4514-bf96-fb2eb82418f4'
                    }
                  },
                  { _id: 'bac54437-8e33-4acf-aaf3-abd369be69f0' },
                  { title: 'Brahmaputra Valley Semi-Evergreen Forests' },
                  { regionId: '222' },
                  {
                    dek:
                      'This ecoregion represents the swath of semi-evergreen forests along the upper reaches of the sacred Brahmaputra River.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9e7e251b-54e6-4e33-bdca-24c682603127/222 Brahmaputra Valley semi-evergreen forests - Gregoire Dubois.jpg',
                      _id: '9e7e251b-54e6-4e33-bdca-24c682603127'
                    }
                  },
                  { _id: '82db88be-27eb-4968-9e4d-d0fb843b29ad' },
                  { title: 'Myanmar Coast Mangroves' },
                  { regionId: '321' },
                  {
                    dek:
                      'This ecoregion extends along the eastern rim of the Bay of Bengal through the coastal areas of India, Myanmar, Thailand, and Malaysia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9e488dbb-b36b-41b1-8558-17a7a133b487/MyanmarCoastMangroves-Dreamstime.jpg',
                      _id: '9e488dbb-b36b-41b1-8558-17a7a133b487'
                    }
                  }
                ],
                stats: [
                  { number: '66,270 ', item: 'Total Land Area (1000 ha)' },
                  { number: '7', item: 'Number of Ecoregions' },
                  { number: '9%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Himalayan Mixed Forests & Grasslands (IM5)',
                children: [],
                _id: '5f051f59-e3f9-4174-a8f9-9419a20a6dc2',
                value: 1000,
                parentId: 'bd861c5e-bc4e-4a23-b501-16e7d5d069c5',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fab2b772-a93a-418d-8415-cccb951f2a5f/309 Eastern Himalayan subalpine conifer forests - Eric Wikramanayake_resized.jpg',
                    _id: 'fab2b772-a93a-418d-8415-cccb951f2a5f'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e0da047f-72e7-45a3-806c-a5b7a6515ebd/302 Himalayan subtropical pine forests - Sanjoy Ghosh.jpg',
                    _id: 'e0da047f-72e7-45a3-806c-a5b7a6515ebd'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/329efe84-59b6-4bdd-942c-91d78cc2e093/310 Western Himalayan subalpine conifer forests - Paul Evans.jpg',
                    _id: '329efe84-59b6-4bdd-942c-91d78cc2e093'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9bf48b72-4a89-4805-bc13-4ea067e2d27d/Bioregion%20map-IM5%20Indian%20Subcontinent.jpg',
                content:
                  '<p>The Himalayan Mixed Forests &amp; Grasslands bioregion is located at the very top of the Indian Subcontinent subrealm in Indomalaya and contains seven ecoregions \u2013 Eastern Himalayan Subalpine Conifer Forests [1], Eastern Himalayan Broadleaf Forests [2], Himalayan Subtropical Pine Forests [3], Terai-Duar Savanna and Grasslands [4], Himalayan Subtropical Broadleaf Forests [5], Western Himalayan Subalpine Conifer Forests [6], Western Himalayan Broadleaf Forests [7] \u2013 totaling approximately 35.5 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9bf48b72-4a89-4805-bc13-4ea067e2d27d/Bioregion%20map-IM5%20Indian%20Subcontinent.jpg"/><figcaption><span class="caption"><p>The Himalayan Mixed Forests &amp; Grasslands bioregion is part of the Indian Subcontinent subrealm and is made up of seven ecoregions: Eastern Himalayan Subalpine Conifer Forests [1], Eastern Himalayan Broadleaf Forests [2], Himalayan Subtropical Pine Forests [3], Terai-Duar Savanna and Grasslands [4], Himalayan Subtropical Broadleaf Forests [5], Western Himalayan Subalpine Conifer Forests [6], Western Himalayan Broadleaf Forests [7].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Himalayan Mixed Forests &amp; Grasslands ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: '04f2654e-e43e-4d86-bb6e-307345e0a2d3' },
                  { title: 'Terai-Duar Savanna and Grasslands' },
                  { regionId: '311' },
                  {
                    dek:
                      'This ecoregion stretches from northwest India across and into the inner river valleys of southern Nepal and to southwest Bhutan. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2d34447e-64a8-47e6-af53-cd3db4bcedd0/311 Terai-Duar savanna and grasslands - Meg _ Rahul.jpg',
                      _id: '2d34447e-64a8-47e6-af53-cd3db4bcedd0'
                    }
                  },
                  { _id: '359261f6-f026-466d-b2ed-88fe06a9d273' },
                  { title: 'Western Himalayan Subalpine Conifer Forests' },
                  { regionId: '310' },
                  {
                    dek:
                      'This ecoregion extends west from the Kali Gandaki River in central Nepal through northwestern India into eastern Pakistan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/329efe84-59b6-4bdd-942c-91d78cc2e093/310 Western Himalayan subalpine conifer forests - Paul Evans.jpg',
                      _id: '329efe84-59b6-4bdd-942c-91d78cc2e093'
                    }
                  },
                  { _id: 'cc452e65-1f68-480c-ab2d-8dea26389a7c' },
                  { title: 'Eastern Himalayan Subalpine Conifer Forests' },
                  { regionId: '309' },
                  {
                    dek:
                      'This ecoregion represents the belt of conifer forest from the Kali Gandaki River in Nepal through Bhutan and into the Arunachal Pradesh State in India.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fab2b772-a93a-418d-8415-cccb951f2a5f/309 Eastern Himalayan subalpine conifer forests - Eric Wikramanayake_resized.jpg',
                      _id: 'fab2b772-a93a-418d-8415-cccb951f2a5f'
                    }
                  },
                  { _id: '44752266-e887-493d-a45c-ec55bb2d9234' },
                  { title: 'Western Himalayan Broadleaf Forests' },
                  { regionId: '308' },
                  {
                    dek:
                      'This ecoregion is a narrow band between 1,500 and 2,600 m in width, starting from the deep creeks of the Kali Gandaki River gorge in Central Nepal through northwestern India into Pakistan westward. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f0c60308-9dab-4838-a160-793886ddcb28/308 Western Himalayan broadleaf forests - asad_78.jpg',
                      _id: 'f0c60308-9dab-4838-a160-793886ddcb28'
                    }
                  },
                  { _id: '7f77fb70-c024-4b2c-aad1-52c8092412c0' },
                  { title: 'Eastern Himalayan Broadleaf Forests' },
                  { regionId: '306' },
                  {
                    dek:
                      'This ecoregion represents the narrow band of temperate broadleaf forest, between 2,000 and 3,000 m in width in the eastern Himalaya.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6235580a-cbec-43f6-8150-943b944d4b52/306 Eastern Himalayan broadleaf forests - Eric Wikramanayake.jpg',
                      _id: '6235580a-cbec-43f6-8150-943b944d4b52'
                    }
                  },
                  { _id: '78ef19da-69b2-4c77-b2d5-9eb296c2cf18' },
                  { title: 'Himalayan Subtropical Pine Forests' },
                  { regionId: '302' },
                  {
                    dek:
                      'This ecoregion stretches for over 3,000 km along the lower elevations of the Himalayan mountain range, from Pakistan to Bhutan, cutting through several Himalayan states of India and Nepal.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e0da047f-72e7-45a3-806c-a5b7a6515ebd/302 Himalayan subtropical pine forests - Sanjoy Ghosh.jpg',
                      _id: 'e0da047f-72e7-45a3-806c-a5b7a6515ebd'
                    }
                  },
                  { _id: '8c9b92f7-4ba4-4918-b79f-a81c15005bde' },
                  { title: 'Himalayan Subtropical Broadleaf Forests' },
                  { regionId: '233' },
                  {
                    dek:
                      'This ecoregion extends from the tiny Himalayan Kingdom of Bhutan in the east to Nepal in the west, as it traverses the Siwalik Hills.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e272a4c6-cbca-4622-b027-99301d58f899/233 Himalayan subtropical broadleaf forests - jessicablueelephants.jpg',
                      _id: 'e272a4c6-cbca-4622-b027-99301d58f899'
                    }
                  }
                ],
                stats: [
                  { number: '35,582', item: 'Total Land Area (1000 ha)' },
                  { number: '7', item: 'Number of Ecoregions' },
                  { number: '43%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Indian Dry Deciduous Forests (IM3)',
                children: [],
                _id: 'a40a5dfd-dde8-462e-9d2c-53a15929b77c',
                value: 1000,
                parentId: 'bd861c5e-bc4e-4a23-b501-16e7d5d069c5',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fd9fc94d-664c-4b83-b6c9-f2941bc9a5ed/292 Chhota-Nagpur dry deciduous forests - Sk Noor Islam.jpg',
                    _id: 'fd9fc94d-664c-4b83-b6c9-f2941bc9a5ed'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f39fd341-3092-4120-8dfa-ea642bad2c70/295 Khathiar-Gir dry deciduous forests -Bernard Gagnon.jpg',
                    _id: 'f39fd341-3092-4120-8dfa-ea642bad2c70'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/af19f26d-fbfe-410f-b560-da50fd108822/320 Indus River Delta-Arabian Sea mangroves - Bishnu Sarangi.jpg',
                    _id: 'af19f26d-fbfe-410f-b560-da50fd108822'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2fe7bbb7-e5a5-4899-aff8-ac4d799fd123/Bioregion%20map-IM3%20Indian%20Subcontinent.jpg',
                content:
                  '<p>The Indian Dry Deciduous Forests bioregion stretches across the Indian Subcontinent subrealm in Indomalaya. It contains four terrestrial ecoregions \u2013 Chhota-Nagpur Dry Deciduous Forests [1], Narmada Valley Dry Deciduous Forests [2], Khathiar-Gir Dry Deciduous Forests [3], Indus River Delta-Arabian Sea Mangroves [4] \u2013 totaling more than 56 million hectares of land area and includes the Gulf of Khambhat and adjoining Indus River Delta-Arabian Sea Mangroves (320). The bioregion, which includes the Narmada River and adjoining Vindhya and Chot Nagpur mountains, is defined by a very long dry season. While more than two-thirds of the region has been cleared, there are still large remaining tracts of original deciduous forests.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2fe7bbb7-e5a5-4899-aff8-ac4d799fd123/Bioregion%20map-IM3%20Indian%20Subcontinent.jpg"/><figcaption><span class="caption"><p>The Indian Dry Deciduous Forests bioregion is part of the Indian Subcontinent subrealm and is made up of four ecoregions: Chhota-Nagpur Dry Deciduous Forests [1], Narmada Valley Dry Deciduous Forests [2], Khathiar-Gir Dry Deciduous Forests [3], Indus River Delta-Arabian Sea Mangroves [4].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of \u200bIndomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace\u200b</strong></a> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bIndian Dry Deciduous Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '3f598e45-042a-45af-b0f5-40a138ddbfe0' },
                  { title: 'Narmada Valley Dry Deciduous Forests' },
                  { regionId: '296' },
                  {
                    dek:
                      'This ecoregion represents the dry forests along the Narmada River Valley, a rift valley situated in a fault zone marking the boundary of northern India and the Indian Peninsula. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/395a9688-3923-4a38-b1d7-5f23a0d33e59/DryForest-WikiWandCC.jpg',
                      _id: '395a9688-3923-4a38-b1d7-5f23a0d33e59'
                    }
                  },
                  { _id: '6bf4a2f2-3204-47ed-b4ec-a92ac7bd7e50' },
                  { title: 'Khathiar-Gir Dry Deciduous Forests' },
                  { regionId: '295' },
                  {
                    dek:
                      'This ecoregion covers the dry deciduous forests that are surrounded by the extensive thorn scrub forests that cover most of India\u2019s northwestern regions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f39fd341-3092-4120-8dfa-ea642bad2c70/295 Khathiar-Gir dry deciduous forests -Bernard Gagnon.jpg',
                      _id: 'f39fd341-3092-4120-8dfa-ea642bad2c70'
                    }
                  },
                  { _id: '62fc4731-36e8-4c99-b684-ff9c646311da' },
                  { title: 'Chhota-Nagpur Dry Deciduous Forests' },
                  { regionId: '292' },
                  {
                    dek:
                      'This ecoregion still harbors large populations of Asia\u2019s largest predator and herbivore, the tiger and Asian elephant, both of which are still able to roam the landscape with relative freedom, a rarity in this bioregion. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fd9fc94d-664c-4b83-b6c9-f2941bc9a5ed/292 Chhota-Nagpur dry deciduous forests - Sk Noor Islam.jpg',
                      _id: 'fd9fc94d-664c-4b83-b6c9-f2941bc9a5ed'
                    }
                  },
                  { _id: '5f1ee2ba-c333-49e3-be3b-de6780148e19' },
                  { title: 'Indus River Delta-Arabian Sea Mangroves' },
                  { regionId: '320' },
                  {
                    dek:
                      'This ecoregion is in several disjunct patches that line the shorelines of the Indus River Delta and the Gulfs of Kutch and Khambhat.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/af19f26d-fbfe-410f-b560-da50fd108822/320 Indus River Delta-Arabian Sea mangroves - Bishnu Sarangi.jpg',
                      _id: 'af19f26d-fbfe-410f-b560-da50fd108822'
                    }
                  }
                ],
                stats: [
                  { number: ' 56,352 ', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '6%', item: 'Protection Target' },
                  { number: '8', item: 'Protection Level' }
                ]
              },
              {
                name: 'Indian Tropical Coastal Forests (IM2)',
                children: [],
                _id: 'cce064e2-e4ca-4239-9234-f381765eda83',
                value: 1000,
                parentId: 'bd861c5e-bc4e-4a23-b501-16e7d5d069c5',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ad28c115-95d6-4367-865c-9160a9fc0f87/254 North Western Ghats montane rain forests - Bishnu Sarangi.jpg',
                    _id: 'ad28c115-95d6-4367-865c-9160a9fc0f87'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e0e0f274-4e5f-4945-8798-0a866ef5c8f9/242 Malabar Coast moist forests - Bishnu Sarangi.jpg',
                    _id: 'e0e0f274-4e5f-4945-8798-0a866ef5c8f9'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3f1e2474-2ae8-4e56-b5a3-b174081e1fa0/271 South Western Ghats montane rain forests - Rajib Ghosh.jpg',
                    _id: '3f1e2474-2ae8-4e56-b5a3-b174081e1fa0'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/673a3a73-303a-4cb8-bdf2-730473646b7f/Bioregion%20map-IM2.jpg',
                content:
                  '<p>The Indian Tropical Coastal Forests bioregion is located along the western coast of the Indian Subcontinent subrealm in Indomalaya. It contains seven ecoregions \u2013 Sri Lanka Lowland Rain Forests [1], Sri Lanka Montane Rain Forests [2], Malabar Coast Moist Forests [3], South Western Ghats Montane Rain Forests [4], South Western Ghats Moist Deciduous Forests [5], North Western Ghats Montane Rain Forests [6], North Western Ghats Moist Deciduous Forests [7] \u2013 totaling approximately 17 million hectares of land area and adjacent marine areas. Defined by the long Western Ghats mountain range and adjoining coastline, this bioregion was once dominated by rainforests that thrived in the annual monsoon cycle, which can bring as much as 8 feet of rainfall to the region. While nearly all of the natural forests have been cleared, some pockets remain as sacred groves preserved by local communities.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/673a3a73-303a-4cb8-bdf2-730473646b7f/Bioregion%20map-IM2.jpg"/><figcaption><span class="caption"><p>The Indian Tropical Coastal Forests bioregion is part of the Indian Subcontinent subrealm and is made up of seven ecoregions: Sri Lanka Lowland Rain Forests [1], Sri Lanka Montane Rain Forests [2], Malabar Coast Moist Forests [3], South Western Ghats Montane Rain Forests [4], South Western Ghats Moist Deciduous Forests [5], North Western Ghats Montane Rain Forests [6], North Western Ghats Moist Deciduous Forests [7].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of \u200bIndomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a><strong>\u200b</strong> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bIndian Tropical Coastal Forests ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: '2695b34c-45a7-4926-b4d4-6d6f77b955c3' },
                  { title: 'South Western Ghats Montane Rainforests' },
                  { regionId: '271' },
                  {
                    dek:
                      'This ecoregion represents the rainforests above 1,000 m elevation of the southern Western Ghats mountain range along the west coast of the Indian subcontinent.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3f1e2474-2ae8-4e56-b5a3-b174081e1fa0/271 South Western Ghats montane rain forests - Rajib Ghosh.jpg',
                      _id: '3f1e2474-2ae8-4e56-b5a3-b174081e1fa0'
                    }
                  },
                  { _id: 'fb765156-3ee3-4c5e-817a-c280dbe271e2' },
                  { title: 'South Western Ghats Moist Deciduous Forests' },
                  { regionId: '270' },
                  {
                    dek:
                      'This ecoregion surrounds the montane rain forests along the southern extent of the Western Ghats Mountain Range, and represents the drier, deciduous forest ecosystems.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/41edeb7c-1750-4f6b-9133-2160b2785519/270 South Western Ghats moist deciduous forests - Eric Wikramanayake.jpg',
                      _id: '41edeb7c-1750-4f6b-9133-2160b2785519'
                    }
                  },
                  { _id: 'f8157d10-93bf-43cc-8bf3-75d9d9d28b84' },
                  { title: 'North Western Ghats Montane Rainforests' },
                  { regionId: '254' },
                  {
                    dek:
                      'This ecoregion represents the upper montane forests along the Western Ghats mountain range, from north of Mumbai to the Wyanad evergreen forests in the south.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ad28c115-95d6-4367-865c-9160a9fc0f87/254 North Western Ghats montane rain forests - Bishnu Sarangi.jpg',
                      _id: 'ad28c115-95d6-4367-865c-9160a9fc0f87'
                    }
                  },
                  { _id: '518a8a41-849a-407a-a1d1-4b35f32e5027' },
                  { title: 'North Western Ghats Moist Deciduous Forests' },
                  { regionId: '253' },
                  {
                    dek:
                      'This ecoregion extends through the Indian states of Maharashtra and Karnataka, northwards from where the South Western Ghats Moist Deciduous Forests ends. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1137d0c2-c493-4ecb-a1e2-05053e0e66f8/253-Purna_River_view_from_Campsite-CC-2014.jpg',
                      _id: '1137d0c2-c493-4ecb-a1e2-05053e0e66f8'
                    }
                  },
                  { _id: 'ef871554-d4fc-41f8-8561-322fdf7d920d' },
                  { title: 'Malabar Coast Moist Forests' },
                  { regionId: '242' },
                  {
                    dek:
                      'This ecoregion extends from the coast to the 250 m elevation contour of the steep Western Ghats Mountains a few kilometers inland. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e0e0f274-4e5f-4945-8798-0a866ef5c8f9/242 Malabar Coast moist forests - Bishnu Sarangi.jpg',
                      _id: 'e0e0f274-4e5f-4945-8798-0a866ef5c8f9'
                    }
                  },
                  { _id: '1e455f64-f0eb-4132-aa42-46065caa4f89' },
                  { title: 'Sri Lanka Montane Rainforests' },
                  { regionId: '275' },
                  {
                    dek:
                      'This ecoregion represents the island\u2019s montane and sub-montane wet forests above 1,000 m. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8beba5d2-32e3-4184-84c7-fb506d683cc5/275 Sri Lanka montane rain forests - Eric Wikramanayake.jpg',
                      _id: '8beba5d2-32e3-4184-84c7-fb506d683cc5'
                    }
                  },
                  { _id: '60b87c21-05c1-44b1-8590-2e54ad92eb4a' },
                  { title: 'Sri Lanka Lowland Rainforests' },
                  { regionId: '274' },
                  {
                    dek:
                      'These rainforests have been separated from the nearest rainforests in the Western Ghats mountain range along the west coast of India since the late Miocene, over 7 million years ago, allowing species to evolve in isolation.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c8b34d41-f46e-4ace-9620-5a5d606b0e18/274 Sri Lanka lowland rain forests - N Chamal.JPG',
                      _id: 'c8b34d41-f46e-4ace-9620-5a5d606b0e18'
                    }
                  }
                ],
                stats: [
                  { number: ' 17,703 ', item: 'Total Land Area (1000 ha)' },
                  { number: '7', item: 'Number of Ecoregions' },
                  { number: '36%', item: 'Protection Target ' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'North Indomalayan Deserts & Scrub Forest (IM4)',
                children: [],
                _id: '0d13a6ae-50d0-4df4-9d32-484284eedc03',
                value: 1000,
                parentId: 'bd861c5e-bc4e-4a23-b501-16e7d5d069c5',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/af19f26d-fbfe-410f-b560-da50fd108822/320 Indus River Delta-Arabian Sea mangroves - Bishnu Sarangi.jpg',
                    _id: 'af19f26d-fbfe-410f-b560-da50fd108822'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/17bfbb4b-8720-44ee-a61d-f2ed389f9111/317 Indus Valley desert - GS Rawat.jpg',
                    _id: '17bfbb4b-8720-44ee-a61d-f2ed389f9111'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/70f7cf76-e139-4799-8218-f308b66243fa/312-Rann_of_Kutch_-_White_Desert_2-CC-2013.jpg',
                    _id: '70f7cf76-e139-4799-8218-f308b66243fa'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/74c7def6-1be0-4069-b80c-e211cb27af6c/Bioregion%20map-IM4%20Indian%20Subcontinent.jpg',
                content:
                  '<p>The North Indomalayan Desert &amp; Scrub Forest bioregion is located in the northwest of the Indian Subcontinent subrealm in Indomalaya and contains five terrestrial ecoregions \u2013 Indus Valley Desert [1], Aravalli West Thorn Scrub Forests [2], Thar Desert [3], Rann of Kutch Seasonal Salt Marsh [4], Indus River Delta-Arabian Sea Mangroves [5] \u2013 (320) totaling nearly 78 million hectares of land area, not including the Indus River Delta-Arabian Sea Mangroves and adjoining marine areas. The bioregion is dominated by the drylands and deserts of the Indus River and Luni River valleys. Though a harsh, desolate environment, the seasonal salt flats spanning surrounding &nbsp;the Gulf of Kutch provide refuge for the endangered Asiatic wild ass and support the one of the world\'s largest breeding colonies of flamingos.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/74c7def6-1be0-4069-b80c-e211cb27af6c/Bioregion%20map-IM4%20Indian%20Subcontinent.jpg"/><figcaption><span class="caption"><p>The North Indomalayan Deserts &amp; Scrub Forest bioregion is part of the Indian Subcontinent subrealm and is made up of five ecoregions: Indus Valley Desert [1], Aravalli West Thorn Scrub Forests [2], Thar Desert [3], Rann of Kutch Seasonal Salt Marsh [4], Indus River Delta-Arabian Sea Mangroves [5].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of \u200bIndomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace\u200b</strong></a> \u200bto explore projects in this realm that need your support. Learn more about each of the \u200bNorth Indomalayan Deserts &amp; Scrub Forest ecoregions below.</p>',
                ecoregions: [
                  { _id: '5f1ee2ba-c333-49e3-be3b-de6780148e19' },
                  { title: 'Indus River Delta-Arabian Sea Mangroves' },
                  { regionId: '320' },
                  {
                    dek:
                      'This ecoregion is in several disjunct patches that line the shorelines of the Indus River Delta and the Gulfs of Kutch and Khambhat.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/af19f26d-fbfe-410f-b560-da50fd108822/320 Indus River Delta-Arabian Sea mangroves - Bishnu Sarangi.jpg',
                      _id: 'af19f26d-fbfe-410f-b560-da50fd108822'
                    }
                  },
                  { _id: '3f5af0f0-78aa-4e82-a88a-5d81b957c22e' },
                  { title: 'Thar Desert' },
                  { regionId: '318' },
                  {
                    dek:
                      'This ecoregion lies to the west of the Aravalli Mountain Range in the northwestern Indian States of Gujarat, Rajasthan, extending across the border to the Punjab and Sind regions of Pakistan. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0ad2b5bc-ef90-486f-ab4b-2742d7d9aa23/318 Thar Desert - sushmita balasubramani.webp',
                      _id: '0ad2b5bc-ef90-486f-ab4b-2742d7d9aa23'
                    }
                  },
                  { _id: '66cc29a5-e85a-4a27-ab9c-cbf0147cd413' },
                  { title: 'Indus Valley Desert' },
                  { regionId: '317' },
                  {
                    dek:
                      'This hot, arid ecoregion sits in the middle of Pakistan\u2019s Indus Valley, flanked by the Glaiman Mountain Range to the west, and the Chenab River to the east. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/07b168ba-8a15-4c13-a4af-2ecda39dd08a/Indus Valley Desert.jpg',
                      _id: '07b168ba-8a15-4c13-a4af-2ecda39dd08a'
                    }
                  },
                  { _id: '20203a30-67d4-49ad-86b5-18ed8be4e21d' },
                  { title: 'Aravalli West Thorn Scrub Forests' },
                  { regionId: '314' },
                  {
                    dek:
                      'This ecoregion represents the thorn scrub forests in the northwestern parts of the Indian subcontinent, along the Aravalli Mountains, transcending the international border between India and Pakistan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6874ab22-7868-4dce-b618-5fecbc2637df/314 Aravalli west thorn scrub forests - Indranil Banerjie 1.jpg',
                      _id: '6874ab22-7868-4dce-b618-5fecbc2637df'
                    }
                  },
                  { _id: '14df4da4-3e8c-4ac1-97e9-7717d548e45b' },
                  { title: 'Rann of Kutch Seasonal Salt Marsh' },
                  { regionId: '312' },
                  {
                    dek:
                      'This ecoregion represents the saline wetlands and mudflats at the mouth of the Luni River that flows down from the Aravalli Hills in northwestern India. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1143a93a-5d5f-4b3c-96e7-ecde854d2412/312-Rann_of_Kutch_-_White_Desert-CC-2013.jpg',
                      _id: '1143a93a-5d5f-4b3c-96e7-ecde854d2412'
                    }
                  }
                ],
                stats: [
                  { number: '77,908', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '13%', item: 'Protection Target' },
                  { number: '10', item: 'Protection Level' }
                ]
              },
              {
                name: 'Central Indian Ocean Islands (IM1)',
                children: [],
                _id: 'fc2c9a8d-66c5-45f6-8ce5-a800d2e4a696',
                value: 1000,
                parentId: 'bd861c5e-bc4e-4a23-b501-16e7d5d069c5',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9b43cae7-91c7-4375-9863-d187298b1d4b/Maldives_Nizam Ibrahim_cc.jpg',
                    _id: '9b43cae7-91c7-4375-9863-d187298b1d4b'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/06747e26-7970-462c-802a-323a50e93ae4/Bioregion%20map-IM1%20Indian%20Subcontinent.jpg',
                content:
                  '<p>The Central Indian Ocean Islands bioregion is part of the Indian Subcontinent subrealm within Indomalaya. It contains one ecoregion \u2014 Maldives-Lakshadweep-Chagos Archipelago Tropical Moist Forests [1] \u2014totaling approximately 55 thousand hectares of land area and consisting primarily of the marine areas surrounding the Maldives, Lakshadweep, and Chagos -- three volcanic island groups in the Indian Ocean that together form a vast underwater mountain range, the Chagos-Laccadive Plateau. Known mostly for its biodiverse coral reef system, the islands themselves provide critical habitats for seabirds and turtles.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/06747e26-7970-462c-802a-323a50e93ae4/Bioregion%20map-IM1%20Indian%20Subcontinent.jpg"/><figcaption><span class="caption"><p>The Central Indian Ocean Islands bioregion is part of the Indian Subcontinent subrealm and is made up of one ecoregion: Maldives-Lakshadweep-Chagos Archipelago Tropical Moist Forests [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of \u200bIndomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace\u200b</strong></a> \u200bto explore projects in this realm that need your support. Learn more about the \u200bCentral Indian Ocean Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: 'ea6a0d21-af40-47a2-8a97-d274fa0cabd7' },
                  { title: 'Maldives-Lakshadweep-Chagos Archipelago Tropical Moist Forests' },
                  { regionId: '243' },
                  {
                    dek:
                      'This ecoregion represents three island groups along a submarine mountain range known as the Chagos-Laccadive Plateau in the western Indian Ocean. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/920d6687-9073-422e-a79e-8c7f197a1667/243 Maldives-Lakshadweep-Chagos Archipelago tropical moist forests - Andreas Schau.jpg',
                      _id: '920d6687-9073-422e-a79e-8c7f197a1667'
                    }
                  }
                ],
                stats: [
                  { number: '55', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '33%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level ' }
                ]
              }
            ],
            parentId: 'Indomalaya',
            value: 1000
          },
          {
            _id: '6c0e624b-7b1d-4071-9743-b35ff6652dde',
            name: 'Southeast Asian Forests',
            children: [
              {
                name: 'Philippines & Sulu Sea Tropical Forests (IM15)',
                children: [],
                _id: '872eba95-86b9-44ca-a3e5-3d4ea5d4239e',
                value: 1000,
                parentId: '6c0e624b-7b1d-4071-9743-b35ff6652dde',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cd43f9ce-a5c1-4f11-a0ae-ea12a8fc5f22/231-Mount_Canlaon-Negros-CC-2009.JPG',
                    _id: 'cd43f9ce-a5c1-4f11-a0ae-ea12a8fc5f22'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1210836a-9b3c-4043-8377-16537a01de1d/246 Mindanao montane rain forests - Bro Jeffrey Pioquinto SJ.jpg',
                    _id: '1210836a-9b3c-4043-8377-16537a01de1d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/14a0754a-faa9-44b6-8c3e-ea3c4a6bc916/276 Sulu Archipelago rain forests - Ervin Malicdem.jpg',
                    _id: '14a0754a-faa9-44b6-8c3e-ea3c4a6bc916'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/300468ea-621b-4034-bac6-9ea6b4f0e7ca/Bioregion-map-IM15-rev.jpg',
                content:
                  '<p>The Philippines &amp; Sulu Sea Tropical Forests bioregion is located in the Southeast Asian Forests subrealm of Indomalaya and contains nine ecoregions \u2013 Luzon Rainforests [1], Luzon Montane Rainforests [2], Luzon Tropical Pine Forests [3], Palawan Rainforests [4], Mindoro Rainforests [5], Greater Negros-Panay Rainforests [6], Mindanao-Eastern Visayas Rainforests [7], Mindanao Montane Rainforests [8], Sulu Archipelago Rainforests [9] \u2013 totaling approximately 30 million hectares of land area.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/300468ea-621b-4034-bac6-9ea6b4f0e7ca/Bioregion-map-IM15-rev.jpg"/><figcaption><span class="caption"><p>The Philippines &amp; Sulu Sea Tropical Forests bioregion is part of the Indomalaya subrealm and is made up of nine ecoregions: Luzon Rainforests [1], Luzon Montane Rainforests [2], Luzon Tropical Pine Forests [3], Palawan Rainforests [4], Mindoro Rainforests [5], Greater Negros-Panay Rainforests [6], Mindanao-Eastern Visayas Rainforests [7], Mindanao Montane Rainforests [8], Sulu Archipelago Rainforests [9].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Philippines &amp; Sulu Sea Tropical Forests ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: '53997a82-2dfa-4386-a9f4-4096abf4b437' },
                  { title: 'Luzon Tropical Pine Forests' },
                  { regionId: '303' },
                  {
                    dek:
                      'This ecoregion covers the tropical pine forest on the Central Cordillera Mountains on Luzon Island.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0ba12010-0b21-4e09-8aee-c972ba7f2995/303 Luzon tropical pine forests - Judgefloro.JPG',
                      _id: '0ba12010-0b21-4e09-8aee-c972ba7f2995'
                    }
                  },
                  { _id: '0c4e1814-2eb0-4f89-ad80-3634cf6dfeb4' },
                  { title: 'Sulu Archipelago Rainforests' },
                  { regionId: '276' },
                  {
                    dek:
                      'This ecoregion represents a chain of islands between the large islands of Borneo and Mindanao, Philippines.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/14a0754a-faa9-44b6-8c3e-ea3c4a6bc916/276 Sulu Archipelago rain forests - Ervin Malicdem.jpg',
                      _id: '14a0754a-faa9-44b6-8c3e-ea3c4a6bc916'
                    }
                  },
                  { _id: 'f9cec0fd-2140-4791-8567-536088a3878f' },
                  { title: 'Palawan Rainforests' },
                  { regionId: '262' },
                  { dek: 'This ecoregion covers Palawan and its peripheral islands. ' },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5adfd31d-ccd7-4e69-b5b4-10f0b769f53b/262-El_Nido_Palawan_Big_Lagoon-CC-2012.jpg',
                      _id: '5adfd31d-ccd7-4e69-b5b4-10f0b769f53b'
                    }
                  },
                  { _id: '06cacf4b-a93d-43e6-98c1-b594d7f0caa9' },
                  { title: 'Mindoro Rainforests' },
                  { regionId: '248' },
                  {
                    dek:
                      'This ecoregion represents Mindoro Island and the smaller satellite islands with a wet tropical climate.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6eb72e18-8ad2-4195-9afe-a79b40d6a988/248 Mindoro rain forests - Mil Del.jpg',
                      _id: '6eb72e18-8ad2-4195-9afe-a79b40d6a988'
                    }
                  },
                  { _id: '4d9eafb9-4d47-43fb-b655-8d2bfeffaeb8' },
                  { title: 'Mindanao-Eastern Visayas Rainforests' },
                  { regionId: '247' },
                  {
                    dek:
                      'This ecoregion covers the lowland forests below 1,000 m in elevation, on the Philippine islands of Mindanao, Samar, Leyte, Bohol, and several smaller satellite islands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/21411430-9ad3-4532-a556-3de4be272d86/247 Mindanao-Eastern Visayas rain forests - John Morrison.jpg',
                      _id: '21411430-9ad3-4532-a556-3de4be272d86'
                    }
                  },
                  { _id: 'd303381d-dad8-4afd-8e60-1e8b6f657204' },
                  { title: 'Mindanao Montane Rainforests' },
                  { regionId: '246' },
                  {
                    dek:
                      'This ecoregion covers the montane rainforests, above 1,000 m elevation, on Mindanao Island.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1210836a-9b3c-4043-8377-16537a01de1d/246 Mindanao montane rain forests - Bro Jeffrey Pioquinto SJ.jpg',
                      _id: '1210836a-9b3c-4043-8377-16537a01de1d'
                    }
                  },
                  { _id: '2dff440c-de1f-4147-bc60-ed92bdb98042' },
                  { title: 'Luzon Rainforests' },
                  { regionId: '241' },
                  {
                    dek:
                      'The Luzon Rainforests ecoregion covers the rainforests below 1,000 m on Luzon Island.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c1252d70-542c-46fc-a5f7-c7297fbd78ed/241 Luzon rain forests - John Morrison.jpg',
                      _id: 'c1252d70-542c-46fc-a5f7-c7297fbd78ed'
                    }
                  },
                  { _id: '7cbf51a3-6ef6-49ce-a816-ac1b4fe33fb8' },
                  { title: 'Luzon Montane Rainforests' },
                  { regionId: '240' },
                  {
                    dek:
                      'This ecoregion represents the forests above 1,000 m in elevation along the Sierra Madre Mountain range, the longest in the Philippines, and the Zambales Mountains in the west. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6f0ed7ff-4330-4d07-9b11-89269e8ea7b8/240 Luzon montane rain forests- R Brown.jpg',
                      _id: '6f0ed7ff-4330-4d07-9b11-89269e8ea7b8'
                    }
                  },
                  { _id: '85db722a-dc7c-4d60-8d6f-fde1bf84767e' },
                  { title: 'Greater Negros-Panay Rainforests' },
                  { regionId: '231' },
                  {
                    dek:
                      'This ecoregion consists of several islands; namely the larger Negros, Panay, Cebu, and several smaller islands. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/35e7d78a-2124-401b-bcf1-1d6d52e2948e/231 Greater Negros-Panay rain forests - John Morrison.jpg',
                      _id: '35e7d78a-2124-401b-bcf1-1d6d52e2948e'
                    }
                  }
                ],
                stats: [
                  { number: ' 30,044', item: 'Total Land Area (1000 ha)' },
                  { number: '9', item: 'Number of Ecoregions' },
                  { number: '54%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'South China Subtropical Evergreen & Monsoon Forests (IM13)',
                children: [],
                _id: 'df2acfda-985e-4f8c-bfe6-924dc7434dfc',
                value: 1000,
                parentId: '6c0e624b-7b1d-4071-9743-b35ff6652dde',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7ac8fd20-3b72-463f-895e-8c3168aaec9f/232 Hainan Island monsoon rain forests - Helen Nash.JPG',
                    _id: '7ac8fd20-3b72-463f-895e-8c3168aaec9f'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7e6ad2b2-bb5c-4e90-a83e-807a0767fce0/269 South Taiwan monsoon rain forests - Max Chang.jpg',
                    _id: '7e6ad2b2-bb5c-4e90-a83e-807a0767fce0'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/90a5bb05-5d96-45ae-996b-33e4d9c495ee/283 Taiwan subtropical evergreen forests - Gerralt van Soest.jpg',
                    _id: '90a5bb05-5d96-45ae-996b-33e4d9c495ee'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/570f4ac0-bac9-49ac-b386-e5d2d16eba4d/Bioregion%20map-IM13%20Southeast%20Asian%20Forests.jpg',
                content:
                  '<p>The South China Subtropical Evergreen &amp; Monsoon Forests bioregion is located in the Southeast Asian Forests subrealm of Indomalaya and contains five ecoregions \u2013 Hainan Island Monsoon Rain Forests [1], South China-Vietnam Subtropical Evergreen Forests [2], Jian Nan Subtropical Evergreen Forests [3], Taiwan Subtropical Evergreen Forests [4], South Taiwan Monsoon Rain Forests [5] \u2013 totaling approximately 94 million hectares of land area. This bioregion also includes adjoining coastal marine areas in the South China Sea.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/570f4ac0-bac9-49ac-b386-e5d2d16eba4d/Bioregion%20map-IM13%20Southeast%20Asian%20Forests.jpg"/><figcaption><span class="caption"><p>The South China Subtropical Evergreen &amp; Monsoon Forests bioregion is part of the Southeast Asian Forests subrealm and is made up of five ecoregions: Hainan Island Monsoon Rain Forests [1], South China-Vietnam Subtropical Evergreen Forests [2], Jian Nan Subtropical Evergreen Forests [3], Taiwan Subtropical Evergreen Forests [4], South Taiwan Monsoon Rain Forests [5].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the South China Subtropical Evergreen &amp; Monsoon Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'f84e8bea-7bb7-436d-aac6-0e047c03ad53' },
                  { title: 'Taiwan Subtropical Evergreen Forests' },
                  { regionId: '283' },
                  {
                    dek:
                      'This ecoregion represents most of the forests of the island of Taiwan, except for the southernmost section that lies to the south of the Tropic of Cancer.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/90a5bb05-5d96-45ae-996b-33e4d9c495ee/283 Taiwan subtropical evergreen forests - Gerralt van Soest.jpg',
                      _id: '90a5bb05-5d96-45ae-996b-33e4d9c495ee'
                    }
                  },
                  { _id: '6a859f6c-a101-46a7-8067-97141d69e05c' },
                  { title: 'South Taiwan Monsoon Rainforests' },
                  { regionId: '269' },
                  {
                    dek:
                      'This ecoregion covers the low elevation forests in the southern-most part of the island.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7e6ad2b2-bb5c-4e90-a83e-807a0767fce0/269 South Taiwan monsoon rain forests - Max Chang.jpg',
                      _id: '7e6ad2b2-bb5c-4e90-a83e-807a0767fce0'
                    }
                  },
                  { _id: '9218f5a1-54ce-46a5-a6f7-c38b2eba635a' },
                  { title: 'South China-Vietnam Subtropical Evergreen Forests' },
                  { regionId: '268' },
                  {
                    dek:
                      'This ecoregion extends from northern Vietnam into southeastern China, and includes Hainan Island. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b51a134f-a833-4e02-8421-416478798d67/268 South China-Vietnam subtropical evergreen forests - Craig Robson Birdquest.jpg',
                      _id: 'b51a134f-a833-4e02-8421-416478798d67'
                    }
                  },
                  { _id: '2e30ecff-bcab-4239-96a2-9da26606746f' },
                  { title: 'Jian Nan Subtropical Evergreen Forests' },
                  { regionId: '236' },
                  {
                    dek:
                      'This ecoregion covers the Nan Ling mountain range, a wide divide that separates the southern Zhujiang River basin from the northern Yangtze Valley. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f37b8329-17c8-406e-911f-7023f5d35133/236 Jian Nan subtropical evergreen forests - Rolf Muller.jpg',
                      _id: 'f37b8329-17c8-406e-911f-7023f5d35133'
                    }
                  },
                  { _id: 'da485c43-4bca-479f-bc63-60cb64be8bf4' },
                  { title: 'Hainan Island Monsoon Rainforests' },
                  { regionId: '232' },
                  {
                    dek:
                      'This ecoregion represents the montane forests in the central region of the island, which has a more seasonal climate.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7ac8fd20-3b72-463f-895e-8c3168aaec9f/232 Hainan Island monsoon rain forests - Helen Nash.JPG',
                      _id: '7ac8fd20-3b72-463f-895e-8c3168aaec9f'
                    }
                  }
                ],
                stats: [
                  { number: '94,146 ', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '29%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Indochina Mixed Forests & Peatlands (IM12)',
                children: [],
                _id: '0b485023-f5e5-43ca-8596-25041efe21e4',
                value: 1000,
                parentId: '6c0e624b-7b1d-4071-9743-b35ff6652dde',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a75dfbdb-a1d4-4f76-aae5-bc1117d10ff6/Thung Salaeng Luang nationalpark of Thailand, mountain view with sea of fog and forest dreamstime_158003599.jpg',
                    _id: 'a75dfbdb-a1d4-4f76-aae5-bc1117d10ff6'
                  },
                  {
                    path:
                      "86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fc66b20b-3dc7-4870-b778-ecbb171f412d/285-Cambodia's_rice_fields-Tonle Sap-CC-Dmitry A Mottl-2015_resized.jpg",
                    _id: 'fc66b20b-3dc7-4870-b778-ecbb171f412d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cfb2a390-c565-4815-a2f3-520cd6780ad6/CentralIndochinaDryForests-PixabayCC.jpg',
                    _id: 'cfb2a390-c565-4815-a2f3-520cd6780ad6'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/92e3cca9-6cfe-48f2-93db-4abce94a4ed5/223 Cardamom Mountains rain forests - Rhett Butler.jpg',
                    _id: '92e3cca9-6cfe-48f2-93db-4abce94a4ed5'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/68f2fb88-19b1-49f7-8689-1a5e5e20394d/239 Luang Prabang montane rain forests - kolibri5.jpg',
                    _id: '68f2fb88-19b1-49f7-8689-1a5e5e20394d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2ea2d7a1-480f-4253-b9d1-26805334232e/300 Southern Vietnam lowland dry forests - Rhett Butler.jpg',
                    _id: '2ea2d7a1-480f-4253-b9d1-26805334232e'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6d9bd5f9-917a-447c-884c-32f70da6654a/Bioregion%20map-IM12%20Southeast%20Asian%20Forests.jpg',
                content:
                  '<p>The Indochina Mixed Forests &amp; Peatlands bioregion is located in the Southeast Asian Forests subrealm of Indomalaya and contains 15 terrestrial ecoregions \u2013 Red River Freshwater Swamp Forests [1], Northern Vietnam Lowland Rainforests [2], Northern Annamites Rainforests [3], Southern Annamites Montane Rainforests [4], Southern Vietnam Lowland Dry Forests [5], Southeastern Indochina Dry Evergreen Forests [6], Central Indochina Dry Forests [7], Tonle Sap-Mekong Peat Swamp Forest [8], Tonle Sap Freshwater Swamp Forests [9], Cardamom Mountains Rainforests [10], Chao Phraya Lowland Moist Deciduous Forests [11], Chao Phraya Freshwater Swamp Forests [12], Northern Thailand-Laos Moist Deciduous Forests [13], Luang Prabang Montane Rainforests [14], Northern Khorat Plateau Moist Deciduous Forests [15], Indochina Mangroves [16], South China Sea Islands [17] \u2013 totaling approximately 90.5 million hectares of land area. This bioregion also includes the South China Sea Islands (267) and surrounding marine areas.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6d9bd5f9-917a-447c-884c-32f70da6654a/Bioregion%20map-IM12%20Southeast%20Asian%20Forests.jpg"/><figcaption><span class="caption"><p>The Indochina Mixed Forests &amp; Peatlands bioregion is part of the Southeast Asian Forests subrealm and is made up of 17 ecoregions: Red River Freshwater Swamp Forests [1], Northern Vietnam Lowland Rainforests [2], Northern Annamites Rainforests [3], Southern Annamites Montane Rainforests [4], Southern Vietnam Lowland Dry Forests [5], Southeastern Indochina Dry Evergreen Forests [6], Central Indochina Dry Forests [7], Tonle Sap-Mekong Peat Swamp Forest [8], Tonle Sap Freshwater Swamp Forests [9], Cardamom Mountains Rainforests [10], Chao Phraya Lowland Moist Deciduous Forests [11], Chao Phraya Freshwater Swamp Forests [12], Northern Thailand-Laos Moist Deciduous Forests [13], Luang Prabang Montane Rainforests [14], Northern Khorat Plateau Moist Deciduous Forests [15], Indochina Mangroves [16], South China Sea Islands [17].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Indochina Mixed Forests &amp; Peatlands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'bcb48573-79e6-43f5-a726-9838b4f26de0' },
                  { title: 'Southern Vietnam Lowland Dry Forests' },
                  { regionId: '300' },
                  {
                    dek:
                      'This ecoregion covers the dry forests along the semi-arid coastal areas of southern Vietnam, where the Annamite Mountains restrict the flow of humid air during the monsoon season, and casts a rain shadow. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2ea2d7a1-480f-4253-b9d1-26805334232e/300 Southern Vietnam lowland dry forests - Rhett Butler.jpg',
                      _id: '2ea2d7a1-480f-4253-b9d1-26805334232e'
                    }
                  },
                  { _id: 'dc25d367-d029-49ad-90b9-ce6c805f5f86' },
                  { title: 'Southeastern Indochina Dry Evergreen Forests' },
                  { regionId: '299' },
                  {
                    dek:
                      'This ecoregion sprawls across Cambodia and southern Vietnam, with parts extending into Thailand and Laos.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/81e2393e-832a-4477-8cd8-7f02a42e1213/299 Southeast Indochina dry evergreen forests - Roy Bateman.jpg',
                      _id: '81e2393e-832a-4477-8cd8-7f02a42e1213'
                    }
                  },
                  { _id: '22ac2a64-a25a-4a6b-a8a2-ad47c7188ab7' },
                  { title: 'Central Indochina Dry Forests' },
                  { regionId: '291' },
                  {
                    dek:
                      'This ecoregion extends across Thailand, from the dry lower slopes in the north and the foothills of the Tenasserim Range to the uplands around the Chao Phraya River Basin.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d086d7bf-f9e8-41f7-95bf-599a99b60b17/CentralIndochinaDryForests-WikiCommons.jpg',
                      _id: 'd086d7bf-f9e8-41f7-95bf-599a99b60b17'
                    }
                  },
                  { _id: 'f5f4ccdd-8a75-4435-b99f-0a156f6abb59' },
                  { title: 'Tonle Sap-Mekong Peat Swamp Forests' },
                  { regionId: '286' },
                  {
                    dek:
                      'This ecoregion represents the forests that are permanently inundated with shallow fresh- water around the Tonle Sap Lake and River, Southeast Asia\u2019s largest natural lake and its river, located in central Cambodia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/329d955b-d69e-451b-b8ff-558dd81e57bd/286 Tonle Sap-Mekong peat swamp forests - Quolip.jpg',
                      _id: '329d955b-d69e-451b-b8ff-558dd81e57bd'
                    }
                  },
                  { _id: '5cc5b8df-b76c-4ce3-8460-c9c5d9cce2c9' },
                  { title: 'Tonle Sap Freshwater Swamp Forests' },
                  { regionId: '285' },
                  {
                    dek:
                      'This ecoregion extends south from Tonle Sap Lake in central Cambodia, along the Tonle Sap River, and then along the lower reaches of the Mekong River into southern Vietnam.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2d5b98d5-f27e-4dc3-a09f-21fa4a1da09a/285 Tonle Sap freshwater swamp forests - Sharon Ang.jpg',
                      _id: '2d5b98d5-f27e-4dc3-a09f-21fa4a1da09a'
                    }
                  },
                  { _id: '82b85928-04ca-438f-b862-55f067161bc1' },
                  { title: 'Southern Annamites Montane Rainforests' },
                  { regionId: '272' },
                  {
                    dek:
                      'This ecoregion represents the remote montane forests from Kontuey Neak, or \u201cthe Dragon\u2019s Tail\u201d in the northwest corner of Cambodia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a2d78672-cf93-4f9b-ac72-dcf5c04bb443/272 Southern Annamites montane rain forests - Craig Robson Birdquest.jpg',
                      _id: 'a2d78672-cf93-4f9b-ac72-dcf5c04bb443'
                    }
                  },
                  { _id: '2e66a69f-12ee-4d2b-88cb-2e6fa63b27cf' },
                  { title: 'Northern Vietnam Lowland Rainforests' },
                  { regionId: '260' },
                  {
                    dek:
                      'This ecoregion extends south from the Red River, along the coast and lowlands, to Tam Ky in Central Vietnam. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1fb5c3d3-99fe-4c97-9f82-8f0e0c50b53e/260 Northern Vietnam lowland rain forests - Rhett Butler.jpg',
                      _id: '1fb5c3d3-99fe-4c97-9f82-8f0e0c50b53e'
                    }
                  },
                  { _id: 'ca6b1e1d-312b-4cc0-831a-a2f1cffa79d3' },
                  { title: 'Northern Thailand-Laos Moist Deciduous Forests' },
                  { regionId: '258' },
                  {
                    dek:
                      'This ecoregion includes the limestone karst mountains in northern Thailand and Laos.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/51b9ec61-10b3-4fba-8d06-9a562884be29/258 Northern Thailand-Laos moist deciduous forests - Takeaway.jpg',
                      _id: '51b9ec61-10b3-4fba-8d06-9a562884be29'
                    }
                  },
                  { _id: '9d6b1037-0ecc-465c-9cc1-715a2edd03f2' },
                  { title: 'Northern Khorat Plateau Moist Deciduous Forests' },
                  { regionId: '257' },
                  {
                    dek:
                      'This ecoregion is relatively small, and represents the moist deciduous forests in the northern part of the low, saucer-shaped plateau in western Thailand.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f68660bf-4796-4f25-86e7-5fdc4dd216e4/257 Northern Khorat Plateau moist deciduous forests - Erwannjacquin.JPG',
                      _id: 'f68660bf-4796-4f25-86e7-5fdc4dd216e4'
                    }
                  },
                  { _id: '0be101e2-2032-479b-8cea-5cf37fbcd867' },
                  { title: 'Northern Annamites Rainforests' },
                  { regionId: '255' },
                  {
                    dek:
                      'This ecoregion straddles the Annamite, or Troung Son, mountain range and the international boundary between Laos and Vietnam. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/90afe9eb-99ea-4386-8993-d1d94c3b6f6e/255 Northern Annamites rain forests - Rolf M\u00fcller.jpg',
                      _id: '90afe9eb-99ea-4386-8993-d1d94c3b6f6e'
                    }
                  },
                  { _id: '6f32b9cd-c454-4829-adea-d506ceaf67d6' },
                  { title: 'Luang Prabang Montane Rainforests' },
                  { regionId: '239' },
                  {
                    dek:
                      'This ecoregion represents the forests above 800 m in northern and central Laos and in small areas of northeastern Thailand, barely touching northern Vietnam.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1406adb7-a6fa-4cf6-990b-8c239123d2fa/239 Luang Prabang Montane Rain Forests Nopparat thanatawan cc.jpg',
                      _id: '1406adb7-a6fa-4cf6-990b-8c239123d2fa'
                    }
                  },
                  { _id: '60fc034e-47ae-45ca-873f-dc90c1f10725' },
                  { title: 'Chao Phraya Lowland Moist Deciduous Forests' },
                  { regionId: '225' },
                  {
                    dek:
                      'This ecoregion occurs as two disjunct areas on either side of the Chao Phraya river basin\u2019s lower reaches.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/42ea37de-8aa6-41ca-9005-c26b1a9c28bd/225 Chao Phraya lowland moist deciduous forests - Ahoerstemeier.jpg',
                      _id: '42ea37de-8aa6-41ca-9005-c26b1a9c28bd'
                    }
                  },
                  { _id: 'a80c77f4-29a4-44f8-8066-554b6e8f86e3' },
                  { title: 'Chao Phraya Freshwater Swamp Forests' },
                  { regionId: '224' },
                  {
                    dek:
                      'The sprawling capital of Thailand, Bangkok, which supports over 8 million people, sits in the lower reaches of this ecoregion. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1d74a57e-da4a-4ea8-922f-77520d27c4d6/224 Chao Phraya freshwater swamp forests - Heinrich Damm.jpg',
                      _id: '1d74a57e-da4a-4ea8-922f-77520d27c4d6'
                    }
                  },
                  { _id: '3e23d5b5-97aa-428e-9f3f-c788632fdb33' },
                  { title: 'Cardamom Mountains Rainforests' },
                  { regionId: '223' },
                  {
                    dek:
                      'This ecoregion represents the wet evergreen forests of the Cardamom and Elephant mountains in southwest Cambodia and southeast Thailand.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/92e3cca9-6cfe-48f2-93db-4abce94a4ed5/223 Cardamom Mountains rain forests - Rhett Butler.jpg',
                      _id: '92e3cca9-6cfe-48f2-93db-4abce94a4ed5'
                    }
                  },
                  { _id: '4ae3e91b-22ff-4282-a684-1b6a830938a0' },
                  { title: 'South China Sea Islands' },
                  { regionId: '267' },
                  {
                    dek:
                      'The South China Sea Islands ecoregion consists of over 250 islands, atolls, and shoals scattered throughout the South China Sea, and grouped into three archipelagos.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/599f0b4a-05ef-4d98-9be6-be6d0223bf17/267 South China Sea Islands - chauha.JPG',
                      _id: '599f0b4a-05ef-4d98-9be6-be6d0223bf17'
                    }
                  },
                  { _id: '2ba8b27d-e6cf-4568-b69b-f2268f611e72' },
                  { title: 'Indochina Mangroves' },
                  { regionId: '319' },
                  {
                    dek:
                      'The mangroves that comprise this ecoregion line the coastal areas of the Gulf of Thailand, where regular flooding by tidal or brackish water and saline gleysols provide conditions for mangroves.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/63e64747-2b79-48aa-9828-435232eb19b1/319-Nypa Fruticans-Vietnam River-CC-Luis Argerich-2005.jpg',
                      _id: '63e64747-2b79-48aa-9828-435232eb19b1'
                    }
                  },
                  { _id: 'c2acfa92-59cf-45be-bc65-b73b1e05c8ce' },
                  { title: 'Red River Freshwater Swamp Forests' },
                  { regionId: '266' },
                  {
                    dek:
                      'This ecoregion comprises the freshwater swamp forests of the Red River valley in northern Vietnam, immediately inland from the mangroves, and upriver along the wide shallow lower reaches of this 1,149 km long river. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b32a6046-f12c-40bb-8a6b-cad0ce2904d3/266 Red River freshwater swamp forests - Rungbachduoung.jpg',
                      _id: 'b32a6046-f12c-40bb-8a6b-cad0ce2904d3'
                    }
                  }
                ],
                stats: [
                  { number: '91,172 ', item: 'Total Land Area (1000 ha)' },
                  { number: '17', item: 'Number of Ecoregions' },
                  { number: '32%', item: 'Protection Target' },
                  { number: '5', item: 'Protection Level' }
                ]
              },
              {
                name: 'Irrawaddy & North Indochina Mixed Forests (IM11)',
                children: [],
                _id: '376add45-cf3d-4bc0-b469-6492ef23f69d',
                value: 1000,
                parentId: '6c0e624b-7b1d-4071-9743-b35ff6652dde',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/257a5581-f539-4342-857d-c9e865bae5ca/237 Kayah-Karen montane rain forests -.JPG',
                    _id: '257a5581-f539-4342-857d-c9e865bae5ca'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f58dffbc-0953-4353-b8cb-fa3d44359f36/294 Irrawaddy dry forests - Richard Todd.jpg',
                    _id: 'f58dffbc-0953-4353-b8cb-fa3d44359f36'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7ff9a870-115d-4f13-88f7-c3b53fb02355/319 Indochina mangroves - Thawathai Seangsai.jpg',
                    _id: '7ff9a870-115d-4f13-88f7-c3b53fb02355'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/88a18f64-47ac-47ad-861b-931206447fe4/Bioregion%20map-IM11%20Southeast%20Asian%20Forests.jpg',
                content:
                  '<p>The Irrawaddy &amp; North Indochina Mixed Forests bioregion is located in the Southeast Asian Forests subrealm of Indomalaya and contains four ecoregions \u2013 Irrawaddy Moist Deciduous Forests [1], Irrawaddy Dry Forests [2], Northern Indochina Subtropical Forests [3], Kayah-Karen Montane Rainforests [4] \u2013 totaling nearly 74 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/88a18f64-47ac-47ad-861b-931206447fe4/Bioregion%20map-IM11%20Southeast%20Asian%20Forests.jpg"/><figcaption><span class="caption"><p>The Irrawaddy &amp; North Indochina Mixed Forests bioregion is part of the Southeast Asian Forests subrealm and is made up of four ecoregions: Irrawaddy Moist Deciduous Forests [1], Irrawaddy Dry Forests [2], Northern Indochina Subtropical Forests [3], Kayah-Karen Montane Rainforests [4].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Irrawaddy &amp; North Indochina Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'a511d54d-e3fd-4c94-aa75-793774171f9f' },
                  { title: 'Irrawaddy Dry Forests' },
                  { regionId: '294' },
                  {
                    dek:
                      'This ecoregion is comprised of several patches of dry forests where the environment is harsh and dry, with only about 650 mm of annual rainfall.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f58dffbc-0953-4353-b8cb-fa3d44359f36/294 Irrawaddy dry forests - Richard Todd.jpg',
                      _id: 'f58dffbc-0953-4353-b8cb-fa3d44359f36'
                    }
                  },
                  { _id: '12ba3b26-c067-4ef2-b1e3-a64aebb6e1cd' },
                  { title: 'Northern Indochina Subtropical Forests' },
                  { regionId: '256' },
                  {
                    dek:
                      'This ecoregion straddles the intersection where the faunas of the northern Palearctic and the southern Indo-Malayan realms mix.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3e4e113c-e558-4f13-a831-884c26d68941/256 Fan_Si_Pan-path_to-CC-2010.jpg',
                      _id: '3e4e113c-e558-4f13-a831-884c26d68941'
                    }
                  },
                  { _id: '2057befb-d1c0-4d7d-b7b7-973c2235d00a' },
                  { title: 'Kayah-Karen Montane Rainforests' },
                  { regionId: '237' },
                  {
                    dek:
                      'This ecoregion lies along the northern part of the Tenasserim Mountain Range, which forms the border between Thailand and Myanmar. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/257a5581-f539-4342-857d-c9e865bae5ca/237 Kayah-Karen montane rain forests -.JPG',
                      _id: '257a5581-f539-4342-857d-c9e865bae5ca'
                    }
                  },
                  { _id: 'ea8b4420-7673-4b4b-986c-61e1f8126f8e' },
                  { title: 'Irrawaddy Moist Deciduous Forests' },
                  { regionId: '235' },
                  {
                    dek:
                      'This ecoregion covers the moist deciduous forests in the vast Irrawaddy River basin, including the catchments of the Bago Yoma mountains and the foothills of Rakhine Yoma. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a3488b5f-d2f1-47d6-97d0-b7532f8e87d5/235 Irrawaddy moist deciduous forests - Go-Myanmar.jpg',
                      _id: 'a3488b5f-d2f1-47d6-97d0-b7532f8e87d5'
                    }
                  }
                ],
                stats: [
                  { number: '73,153 ', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '38%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Arakan Mountains & Northern Triangle Forests (IM10)',
                children: [],
                _id: '5c755703-bfe6-45c3-b8d9-813d7cc428aa',
                value: 1000,
                parentId: '6c0e624b-7b1d-4071-9743-b35ff6652dde',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ba4b7b03-28ac-46fe-98c6-69328f6ee2ad/249 Mizoram-Manipur-Kachin rain forests - chalonortheast.com.jpg',
                    _id: 'ba4b7b03-28ac-46fe-98c6-69328f6ee2ad'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0436a9a5-d6f9-4af1-b06f-32e0f412882d/304 Northeast India-Myanmar pine forests - chalonortheast.com.jpg',
                    _id: '0436a9a5-d6f9-4af1-b06f-32e0f412882d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b82cdc1f-227a-47f0-a05b-1c35bd1c95ee/307 Northern Triangle temperate forests - Mark Fisher Fisher Creative.jpg',
                    _id: 'b82cdc1f-227a-47f0-a05b-1c35bd1c95ee'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a2d7367a-64ad-46a8-b41e-d24ada861401/Bioregion%20map-IM10%20Southeast%20Asian%20Forests.jpg',
                content:
                  '<p>The Arakan Mountains &amp; Northern Triangle Forests bioregion defines the upper western boundary of the Southeast Asian Forests subrealm in Indomalaya, containing five ecoregions \u2013 Northern Triangle Temperate Forests [1], Northern Triangle Subtropical Forests [2], Northeast India-Myanmar Pine Forests [3], Mizoram-Manipur-Kachin Rainforests [4], Chin Hills-Arakan Yoma Montane Forests [5] \u2013 totaling approximately 24 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a2d7367a-64ad-46a8-b41e-d24ada861401/Bioregion%20map-IM10%20Southeast%20Asian%20Forests.jpg"/><figcaption><span class="caption"><p>The Arakan Mountains &amp; Northern Triangle Forests bioregion is part of the Southeast Asian Forests subrealm and is made up of five ecoregions: Northern Triangle Temperate Forests [1], Northern Triangle Subtropical Forests [2], Northeast India-Myanmar Pine Forests [3], Mizoram-Manipur-Kachin Rainforests [4], Chin Hills-Arakan Yoma Montane Forests [5].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Arakan Mountains &amp; Northern Triangle Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '84c70739-fb06-4466-9ac1-025adbfd13a9' },
                  { title: 'Northeast India-Myanmar Pine Forests' },
                  { regionId: '304' },
                  {
                    dek:
                      'This ecoregion represents the pine forests distributed in three isolated patches in the Naga Hills, which form the international border between India and Myanmar. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0436a9a5-d6f9-4af1-b06f-32e0f412882d/304 Northeast India-Myanmar pine forests - chalonortheast.com.jpg',
                      _id: '0436a9a5-d6f9-4af1-b06f-32e0f412882d'
                    }
                  },
                  { _id: '2b3eca76-7294-41ea-8a66-a4112f907b77' },
                  { title: 'Northern Triangle Subtropical Forests' },
                  { regionId: '259' },
                  {
                    dek:
                      'The Northern Triangle Subtropical Forests ecoregion mountains were formed from the upheaval and uplift that followed the collision between the Deccan Plateau and the Laurasian mainland, which also created the Himalayas.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8ce891b5-4ce2-443f-af75-4e5f9a62be06/259 Northern Triangle subtropical forests - Eric Daft Fisher Creative.jpg',
                      _id: '8ce891b5-4ce2-443f-af75-4e5f9a62be06'
                    }
                  },
                  { _id: 'ea2df71a-e253-4341-9b61-6564be4c4161' },
                  { title: 'Mizoram-Manipur-Kachin Rainforests' },
                  { regionId: '249' },
                  {
                    dek:
                      'This ecoregion is vast, covering the remote sub-montane rainforests from the southern Arakan mountains and Chin Hills in western Myanmar into the northern mountains of Kachin State in Myanmar.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ba4b7b03-28ac-46fe-98c6-69328f6ee2ad/249 Mizoram-Manipur-Kachin rain forests - chalonortheast.com.jpg',
                      _id: 'ba4b7b03-28ac-46fe-98c6-69328f6ee2ad'
                    }
                  },
                  { _id: 'f07dbe64-9ad7-48d0-bbad-41dead44deea' },
                  { title: 'Chin Hills-Arakan Yoma Montane Forests' },
                  { regionId: '226' },
                  {
                    dek:
                      'This ecoregion represents the montane moist forests of the Chin Hills and Arakan (now known as Rakhine) Yoma along the west coast of Myanmar. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/71b771b5-882a-4a1a-9112-b708b5a49c50/226 Chin Hills-Arakan Yoma montane forests - Lionslayer.JPG',
                      _id: '71b771b5-882a-4a1a-9112-b708b5a49c50'
                    }
                  },
                  { _id: 'fbc43a7c-07fe-4b3d-a452-00cdf9913d7f' },
                  { title: 'Northern Triangle Temperate Forests' },
                  { regionId: '307' },
                  {
                    dek:
                      'This ecoregion represents a relatively narrow band of temperate forests in northern Myanmar\u2019s mountains.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b82cdc1f-227a-47f0-a05b-1c35bd1c95ee/307 Northern Triangle temperate forests - Mark Fisher Fisher Creative.jpg',
                      _id: 'b82cdc1f-227a-47f0-a05b-1c35bd1c95ee'
                    }
                  }
                ],
                stats: [
                  { number: '24,009', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '75%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Myanmar Coastal Rainforests & Andaman Sea Islands (IM9)',
                children: [],
                _id: '3d205c96-303e-4629-8e13-3b0e1c8b4c98',
                value: 1000,
                parentId: '6c0e624b-7b1d-4071-9743-b35ff6652dde',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7ff9a870-115d-4f13-88f7-c3b53fb02355/319 Indochina mangroves - Thawathai Seangsai.jpg',
                    _id: '7ff9a870-115d-4f13-88f7-c3b53fb02355'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a7a2440b-1cce-4de5-948d-117247158151/250 Myanmar coastal rain forests - Doron.jpg',
                    _id: 'a7a2440b-1cce-4de5-948d-117247158151'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/25573f06-281e-4d27-8b4a-e9015de5fc0e/NicobarIslandsRainForests-WikiCommons.jpg',
                    _id: '25573f06-281e-4d27-8b4a-e9015de5fc0e'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/461a4626-f4a1-4407-bc3f-358db3b96449/Bioregion%20map-IM9%20rev.jpg',
                content:
                  '<p>The Myanmar Coastal Rainforests &amp; Andaman Sea Islands bioregion is located in the west of the Southeast Asian Forests subrealm in Indomalaya, containing seven terrestrial ecoregions \u2013 Tenasserim-South Thailand Semi-Evergreen Rainforests [1], Myanmar Coastal Rainforests [2], Irrawaddy Freshwater Swamp Forests [3], Andaman Islands Rainforests [4], Nicobar Islands Rainforests [5] \u2013 along with Myanmar Coast Mangroves [6] and Indochina Mangroves [7], totaling approximately 21 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/461a4626-f4a1-4407-bc3f-358db3b96449/Bioregion%20map-IM9%20rev.jpg"/><figcaption><span class="caption"><p>The Myanmar Coastal Rainforests &amp; Andaman Sea Islands bioregion is part of the Southeast Asian Forests subrealm and is made up of seven ecoregions: Tenasserim-South Thailand Semi-Evergreen Rainforests [1], Myanmar Coastal Rainforests [2], Irrawaddy Freshwater Swamp Forests [3], Andaman Islands Rainforests [4], Nicobar Islands Rainforests [5], Myanmar Coast Mangroves [6], Indochina Mangroves [7].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Myanmar Coastal Rainforests &amp; Andaman Sea Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: '3b2d2835-856d-4fa2-9ba0-34c90e99f06e' },
                  { title: 'Tenasserim-South Thailand Semi-Evergreen Rainforests' },
                  { regionId: '284' },
                  {
                    dek:
                      'This ecoregion is a transition from the continental dry evergreen forests in central Thailand to the semi-evergreen rainforests along the neck of the Malayan peninsula.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ed8afc92-dec8-4aa2-beb3-df7c6a99f8f6/Morning fog in dense tropical rainforest, kaeng krachan, thailand. Dreamstime.jpg',
                      _id: 'ed8afc92-dec8-4aa2-beb3-df7c6a99f8f6'
                    }
                  },
                  { _id: '0075d4b0-2c58-4ce1-9c67-be1949048b84' },
                  { title: 'Nicobar Islands Rainforests' },
                  { regionId: '252' },
                  {
                    dek:
                      'This ecoregion represents the cluster of Nicobar Islands in the archipelago along the eastern Indian Ocean undersea mountain range.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/25573f06-281e-4d27-8b4a-e9015de5fc0e/NicobarIslandsRainForests-WikiCommons.jpg',
                      _id: '25573f06-281e-4d27-8b4a-e9015de5fc0e'
                    }
                  },
                  { _id: '19ec75cc-35c4-46fe-b8ae-af85b19c87d1' },
                  { title: 'Myanmar Coastal Rainforests' },
                  { regionId: '250' },
                  {
                    dek:
                      'This ecoregion represents the lowland evergreen and semi-evergreen rainforests along the western side of the Arakan Yoma and Tenasserim mountain ranges of Myanmar\u2019s west coast. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a7a2440b-1cce-4de5-948d-117247158151/250 Myanmar coastal rain forests - Doron.jpg',
                      _id: 'a7a2440b-1cce-4de5-948d-117247158151'
                    }
                  },
                  { _id: '93141baa-f22e-4111-bfc0-f607f5150419' },
                  { title: 'Irrawaddy Freshwater Swamp Forests' },
                  { regionId: '234' },
                  {
                    dek:
                      'This ecoregion represents the forests immediately behind the mangroves, in the zone where the fresh water from the Irrawaddy River pushes back the salt water.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0460b607-ed0b-43b2-abdc-ea3a62f6577b/234 Maubin,_Myanmar_(Burma)_-_panoramio-CC-2017.jpg',
                      _id: '0460b607-ed0b-43b2-abdc-ea3a62f6577b'
                    }
                  },
                  { _id: '02305e96-237c-490c-85f4-dfd0fa863688' },
                  { title: 'Andaman Islands Rainforests' },
                  { regionId: '218' },
                  {
                    dek:
                      'The Andaman Islands, covered by this ecoregion, is part of an archipelago that continues southward to the Nicobar Islands on the eastern side of the Bay of Bengal. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7821669f-8542-47a8-bb7c-cb25026da3f5/218 Andaman Islands rain forests - Aliven Sarkar.JPG',
                      _id: '7821669f-8542-47a8-bb7c-cb25026da3f5'
                    }
                  },
                  { _id: '82db88be-27eb-4968-9e4d-d0fb843b29ad' },
                  { title: 'Myanmar Coast Mangroves' },
                  { regionId: '321' },
                  {
                    dek:
                      'This ecoregion extends along the eastern rim of the Bay of Bengal through the coastal areas of India, Myanmar, Thailand, and Malaysia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9e488dbb-b36b-41b1-8558-17a7a133b487/MyanmarCoastMangroves-Dreamstime.jpg',
                      _id: '9e488dbb-b36b-41b1-8558-17a7a133b487'
                    }
                  },
                  { _id: '2ba8b27d-e6cf-4568-b69b-f2268f611e72' },
                  { title: 'Indochina Mangroves' },
                  { regionId: '319' },
                  {
                    dek:
                      'The mangroves that comprise this ecoregion line the coastal areas of the Gulf of Thailand, where regular flooding by tidal or brackish water and saline gleysols provide conditions for mangroves.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/63e64747-2b79-48aa-9828-435232eb19b1/319-Nypa Fruticans-Vietnam River-CC-Luis Argerich-2005.jpg',
                      _id: '63e64747-2b79-48aa-9828-435232eb19b1'
                    }
                  }
                ],
                stats: [
                  { number: '21,100 ', item: 'Total Land Area (1000 ha) ' },
                  { number: '7', item: 'Number of Ecoregions' },
                  { number: '46%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Nansei Islands Subtropical Evergreen Forests (IM14)',
                children: [],
                _id: 'ec8cd7c2-4679-4712-8e0e-5e10982f3ea6',
                value: 1000,
                parentId: '6c0e624b-7b1d-4071-9743-b35ff6652dde',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/81662cb3-7017-4d76-9649-90525ae02b35/Forest_at_Mount_Yae_Okinawa_201911_01.jpg',
                    _id: '81662cb3-7017-4d76-9649-90525ae02b35'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1b724137-2a55-47b1-addd-423340c9314e/Bioregion%20map-IM14%20Southeast%20Asian%20Forests.jpg',
                content:
                  '<p>The Nansei Islands Subtropical Evergreen Forests bioregion is located in the Southeast Asian Forests subrealm of Indomalaya and contains one ecoregion \u2013 Nansei Islands Subtropical Evergreen Forests [1] \u2013 located just south of Japan, totaling approximately 408 thousand hectares of land area and extensive marine areas surrounding this chain of forested islands.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1b724137-2a55-47b1-addd-423340c9314e/Bioregion%20map-IM14%20Southeast%20Asian%20Forests.jpg"/><figcaption><span class="caption"><p>The Nansei Islands Subtropical Evergreen Forests bioregion is part of the Southeast Asian Forests subrealm and is made up of 1 ecoregion: Nansei Islands Subtropical Evergreen Forests [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Indomalaya. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more the Nansei Islands Subtropical Evergreen Forests ecoregion below.</p>',
                ecoregions: [
                  { _id: '2e01fcf5-11ef-48c3-a381-303ac88bc828' },
                  { title: 'Nansei Islands Subtropical Evergreen Forests' },
                  { regionId: '251' },
                  {
                    dek:
                      'This ecoregion covers the 1,050 km-long chain of over 100 small islands that stretches from Kyushu Island of Japan to Taiwan.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a813dfcf-ac20-4fe4-b83a-62fbaa4cfca5/251 Nansei Islands subtropical evergreen forests - Kanenori.jpg',
                      _id: 'a813dfcf-ac20-4fe4-b83a-62fbaa4cfca5'
                    }
                  }
                ],
                stats: [
                  { number: '408', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '97%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level ' }
                ]
              }
            ],
            parentId: 'Indomalaya',
            value: 875
          }
        ],
        parentId: 'top',
        _id: 'Indomalaya',
        value: 500
      },
      {
        name: 'Northern America',
        children: [
          {
            _id: '50180bc9-29a2-4585-8e09-e9d5757d6eb0',
            name: 'Great Plains',
            children: [
              {
                name: 'Midwestern Tallgrass Prairie & Forest Transition (NA21)',
                children: [],
                _id: 'e92cead2-326e-43b6-998a-7a6bfae4f0ca',
                value: 1000,
                parentId: '50180bc9-29a2-4585-8e09-e9d5757d6eb0',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cb7257b8-cd9b-4ef0-a551-30d310585dbb/388 Central Tallgrass prairie - Shannon.jpg',
                    _id: 'cb7257b8-cd9b-4ef0-a551-30d310585dbb'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9fe29b38-cd11-451e-8c54-0be8f9a325d9/387 Central US forest-grasslands transition - Quadriflora77.jpg',
                    _id: '9fe29b38-cd11-451e-8c54-0be8f9a325d9'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ed2451c2-5990-4474-aeb7-664f9223e61f/392-Konza_Prairie_Trail_Fall_1-CC-2009.jpg',
                    _id: 'ed2451c2-5990-4474-aeb7-664f9223e61f'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2acbc532-f3b0-4cfb-96ed-9bcd4218d1b4/Bioregion%20map-NA21.jpg',
                content:
                  '<p>The Midwestern Tallgrass bioregion, located in the Northern America (Nearctic) realm, is the third major section of the continent\u2019s Great Plains subrealm, extending eastward from the Missouri River, where it transitions to open forests across Illinois, known as the central grassland-forest transition.&nbsp;</p>\n<p>It contains three ecoregions \u2013 Central US Forest-Grasslands Transition (387), Central Tallgrass Prairie (388), Flint Hills Tallgrass Prairie (392) \u2013 and incorporates the western half of Lake Michigan as well as a large section of the Missouri River.&nbsp;</p>\n<p>The total land area of this bioregion is nearly 60 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2acbc532-f3b0-4cfb-96ed-9bcd4218d1b4/Bioregion%20map-NA21.jpg"/><figcaption><span class="caption"><p>The Midwestern Tallgrass Prairie &amp; Forest Transition bioregion is part of the Great Plains subrealm and is made up of three ecoregions: (1) Flint Hills Tallgrass Prairie (2) Central Tallgrass Prairie (3) Central US Forest-Grasslands Transition.&nbsp;</p></span> </figcaption></figure>',
                ecoregions: [
                  { _id: 'b31dc4a1-97cf-4c8b-b69e-0582b0132732' },
                  { title: 'Central US Forest-Grasslands Transition' },
                  { regionId: '387' },
                  {
                    dek:
                      'This ecoregion occupies a large area between the deciduous forests of the eastern United States and the tallgrass prairies of the eastern Great Plains.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9fe29b38-cd11-451e-8c54-0be8f9a325d9/387 Central US forest-grasslands transition - Quadriflora77.jpg',
                      _id: '9fe29b38-cd11-451e-8c54-0be8f9a325d9'
                    }
                  },
                  { _id: '0e3a40be-c648-4c9b-85da-70114d1884d8' },
                  { title: 'Flint Hills Tallgrass Prairie' },
                  { regionId: '392' },
                  {
                    dek:
                      'This ecoregion is distinguished from the Central Tallgrass Prairie to the east and northeast by its thin, cherty, limestone-derived soils, which hindered plowing for crop agriculture.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/45a2f88c-3ed7-4451-80a0-bbae0b4b0ac3/392-Tall grass prairie-Flint Hills-CC-Edwin Olson-2005.jpg',
                      _id: '45a2f88c-3ed7-4451-80a0-bbae0b4b0ac3'
                    }
                  },
                  { _id: 'f63eb27b-4322-4f53-9e09-c200407bc8bc' },
                  { title: 'Central Tallgrass Prairie' },
                  { regionId: '388' },
                  {
                    dek:
                      'This ecoregion, the heart of the tallgrass prairie, is the iconic North American prairie, with grasses up to 3 m tall on the best soils, waving in the wind over root systems just as long or sometimes longer.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cb7257b8-cd9b-4ef0-a551-30d310585dbb/388 Central Tallgrass prairie - Shannon.jpg',
                      _id: 'cb7257b8-cd9b-4ef0-a551-30d310585dbb'
                    }
                  }
                ],
                stats: [
                  { number: '59,934', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '3%', item: 'Protection Target' },
                  { number: '7', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Northern Prairie & Aspen Forests (NA12)',
                children: [],
                _id: 'ea455a8f-fe29-4c4a-9835-ed183056aae8',
                value: 1000,
                parentId: '50180bc9-29a2-4585-8e09-e9d5757d6eb0',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dd141734-5a6c-461c-95df-16ad2fcc6ec4/396 Northern Shortgrass Prairie Brett Snyder cc.jpeg',
                    _id: 'dd141734-5a6c-461c-95df-16ad2fcc6ec4'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d93227b3-35e4-4ff1-9836-e0cd70e0a73b/386 Canadian Aspen Forests and Parklands Ken Lund, Flickr.jpg',
                    _id: 'd93227b3-35e4-4ff1-9836-e0cd70e0a73b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0f8be477-8b52-461e-a128-74bce140cf29/386 Canadian Aspen Forests and Parklands Just a Prarie Boy, Flickr.jpg',
                    _id: '0f8be477-8b52-461e-a128-74bce140cf29'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8961eb14-5d93-46fc-8cfc-791452771263/Bioregion%20map-NA12.jpg',
                content:
                  '<p>The Northern Prairie bioregion, located in the Great Plains subrealm of Northern America, is the upper section of the Great Plains, lying between the Great Lakes forests to the east and the Northern Rockies to the west. It is predominantly made up of shortgrass prairie mixed with aspen forests and tallgrass prairie in the east. The bioregion includes three ecoregions \u2013 Northern Shortgrass Prairie (396), Northern Tallgrass Prairie (397), Canadian Aspen Forests and Parklands (386) \u2013 and is defined largely by the expansive Missouri River watershed. The total area of this bioregion is approximately 113 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8961eb14-5d93-46fc-8cfc-791452771263/Bioregion%20map-NA12.jpg"/><figcaption><span class="caption"><p>The Northern Prairie &amp; Aspen Forests bioregion is part of the Great Plains subrealm and is made up of three ecoregions: (1) Northern Shortgrass Prairie (2) Canadian Aspen Forests and Parklands (3) Northern Tallgrass Prairie.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Northern Prairie &amp; Aspen Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'c3ccabf8-5d49-4b85-b01d-46178f10b5ae' },
                  { title: 'Northern Tallgrass Prairie' },
                  { regionId: '397' },
                  {
                    dek:
                      'This ecoregion represents the northernmost tallgrass prairie in North America, extending north into a true boreal climate. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/545e6bf4-b2d5-4942-b1a0-9c3b01e5c0c0/397 Delta_Marsh_Field_Station_Manitoba_Canada-CC-Shahnoor Habib Munmun.JPG',
                      _id: '545e6bf4-b2d5-4942-b1a0-9c3b01e5c0c0'
                    }
                  },
                  { _id: '234ab73b-2533-45f2-aba9-05d2074bb608' },
                  { title: 'Canadian Aspen Forests and Parklands' },
                  { regionId: '386' },
                  {
                    dek:
                      'This ecoregion is an immense region stretching from southwestern Minnesota and southeastern North Dakota.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b8390275-013d-4bb0-a72a-beba066488e2/386-Flying_over_a_branch_of_the_Saskatchewan_River_in_Alberta-CC_Paul Hami-2008.jpg',
                      _id: 'b8390275-013d-4bb0-a72a-beba066488e2'
                    }
                  },
                  { _id: '6016127e-bccb-4343-a3a9-45fc56af628c' },
                  { title: 'Northern Shortgrass Prairie' },
                  { regionId: '396' },
                  {
                    dek:
                      'This ecoregion, sprawling across five U.S. states and two Canadian provinces, is the largest grassland ecoregion in North America.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b5e60317-e959-49d0-969f-bde223d0e163/396 Northern Shortgrass prairie - Badlands National Park.jpg',
                      _id: 'b5e60317-e959-49d0-969f-bde223d0e163'
                    }
                  }
                ],
                stats: [
                  { number: '112,913', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '26%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              },
              {
                name: 'Southern Prairie Mixed Grasslands (NA20)',
                children: [],
                _id: '453c6a33-af4b-4079-b440-e58fc7cffbc9',
                value: 1000,
                parentId: '50180bc9-29a2-4585-8e09-e9d5757d6eb0',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f970fda1-38ea-4715-9c74-b28878d98815/389 Central-Southern US mixed grasslands - LoperGrad.JPG',
                    _id: 'f970fda1-38ea-4715-9c74-b28878d98815'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/94efe989-d375-4817-8929-d424323303a3/390 Cross-Timbers savanna-woodland - David Hepworth.jpg',
                    _id: '94efe989-d375-4817-8929-d424323303a3'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/16069900-4955-4e73-966d-5467ca9a7027/395 Nebraska Sand Hills mixed grasslands - Reed Noss.jpg',
                    _id: '16069900-4955-4e73-966d-5467ca9a7027'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a2bcf4ac-4a4a-447f-8fc3-23f0b336217d/Bioregion%20map-NA20.jpg',
                content:
                  '<p>The Southern Prairie bioregion, located in the Northern America (Nearctic) realm, is the lower section of the Great Plains subrealm and is composed entirely of grasslands stretching from the top of Nebraska to southern Texas, bounded by the Rockies to the west. It contains five ecoregions \u2013 (1) Western Shortgrass Prairie (2) Nebraska Sand Hills Mixed Grasslands (3) Central-Southern US Mixed Grasslands (4) Cross-Timbers Savanna-Woodland (5) Edwards Plateau Savanna \u2013 and has largely been converted to farmland. The total area of this bioregion is nearly 99 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a2bcf4ac-4a4a-447f-8fc3-23f0b336217d/Bioregion%20map-NA20.jpg"/><figcaption><span class="caption"><p>The Southern Prairie Mixed Grasslands bioregion is part of the Great Plains subrealm and is made up of five ecoregions: (1) Western Shortgrass Prairie (2) Nebraska Sand Hills Mixed Grasslands (3) Central-Southern US Mixed Grasslands (4) Cross-Timbers Savanna-Woodland (5) Edwards Plateau Savanna.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Southern Prairie Mixed Grasslands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'cee7d5dd-c8d5-4b7f-83e8-ee2920618723' },
                  { title: 'Western Shortgrass Prairie' },
                  { regionId: '402' },
                  {
                    dek:
                      'The Western Shortgrass Prairie is the second largest grassland ecoregion in North America, stretching from Texas and New Mexico in the south to Nebraska and Wyoming in the north.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e8c561df-7c7d-46d4-9aae-939b126ec2e0/402 Western shortgrass prairie - Leaflet.jpg',
                      _id: 'e8c561df-7c7d-46d4-9aae-939b126ec2e0'
                    }
                  },
                  { _id: '54f5a74f-f9ba-49d7-8280-33dcf098d838' },
                  { title: 'Edwards Plateau Savanna' },
                  { regionId: '391' },
                  {
                    dek:
                      'This ecoregion, the heart of the famed Texas Hill Country, lies to the west of the Texas Blackland Prairies ecoregion and is bordered on the south by the Tamaulipan Mezquital and on the southwest by the Chihauhuan Desert.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/000a0faa-f2aa-402d-947d-bd3e561a5ead/391 Limestone_bluff,_typical_of_the_Edwards_Plateau,_Highway_336,_Real_County,_Texas,-CC-William L Farr-2012.jpg',
                      _id: '000a0faa-f2aa-402d-947d-bd3e561a5ead'
                    }
                  },
                  { _id: '22c4c2b7-f4fd-461a-85dc-e125087df940' },
                  { title: ' Cross-Timbers Savanna-Woodland' },
                  { regionId: '390' },
                  {
                    dek:
                      'This ecoregion covers a long latitudinal extent from Texas north through eastern Oklahoma and a small portion of eastern Kansas.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/94efe989-d375-4817-8929-d424323303a3/390 Cross-Timbers savanna-woodland - David Hepworth.jpg',
                      _id: '94efe989-d375-4817-8929-d424323303a3'
                    }
                  },
                  { _id: '2b737739-d778-457d-ae09-28df5910c4a3' },
                  { title: 'Central-Southern US Mixed Grasslands' },
                  { regionId: '389' },
                  {
                    dek:
                      'This ecoregion forms an ecological transition from tallgrass to shortgrass prairie. From north to south, its eastern boundary abuts the Central Tallgrass, Flint Hills Tallgrass, and Cross-Timber Savanna-Woodland ecoregions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f970fda1-38ea-4715-9c74-b28878d98815/389 Central-Southern US mixed grasslands - LoperGrad.JPG',
                      _id: 'f970fda1-38ea-4715-9c74-b28878d98815'
                    }
                  },
                  { _id: '37138dd3-af78-44d5-9c43-bd5192184650' },
                  { title: 'Nebraska Sand Hills Mixed Grasslands' },
                  { regionId: '395' },
                  {
                    dek:
                      'This ecoregion is the smallest ecoregion in the Great Plains but stands out as the most intact of all Great Plains ecoregions and, most significantly, as the largest area of sand dunes in the entire Western Hemisphere. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/16069900-4955-4e73-966d-5467ca9a7027/395 Nebraska Sand Hills mixed grasslands - Reed Noss.jpg',
                      _id: '16069900-4955-4e73-966d-5467ca9a7027'
                    }
                  }
                ],
                stats: [
                  { number: '98,632', item: 'Total Land Area (1000 ha) ' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '38%', item: 'Protection Target' },
                  { number: '0', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Northern America',
            value: 600
          },
          {
            _id: 'b9cd9856-5810-4462-be43-96d60cdcce20',
            name: 'American West',
            children: [
              {
                name: 'Northwest Intermountain Conifer Forests (NA14)',
                children: [],
                _id: '2f9056b0-dfcb-4269-8406-56db21f496e5',
                value: 1000,
                parentId: 'b9cd9856-5810-4462-be43-96d60cdcce20',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3178d26e-8bae-477c-b18d-756a839cba88/362 Okanogan Dry Forests Marneejill, flickr.jpg',
                    _id: '3178d26e-8bae-477c-b18d-756a839cba88'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3b06861d-3c5f-4266-9daf-e5572c1747aa/355 Fraser Plateau and Basin conifer forests - Petra.jpg',
                    _id: '3b06861d-3c5f-4266-9daf-e5572c1747aa'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4f5c0395-2221-4c46-b9a4-3c908a983147/Bioregion%20map-NA14.jpg',
                content:
                  '<p>The Northwest Intermountain bioregion, located in the American West subrealm of Northern America, lies between the Rockies to the east and the Coast Mountains in the west and is dominated by conifer forests. This bioregion includes two ecoregions \u2013 Fraser Plateau and Basin Conifer Forests (355), Okanogan Dry Forests (362) \u2013 and encompasses the southern portion of the Lakes District in British Columbia, a network of hundreds of linear valley lakes. The total area of this bioregion is approximately 16 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4f5c0395-2221-4c46-b9a4-3c908a983147/Bioregion%20map-NA14.jpg"/><figcaption><span class="caption"><p>The Northwest Intermountain Conifer Forests bioregion is part of the American West subrealm and is made up of two ecoregions: (1) Fraser Plateau and Basin Conifer Forests (2) Okanogan Dry Forests.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Northwest Intermountain Conifer Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '490d2d48-c5be-43b5-9e54-540259be0baa' },
                  { title: 'Okanogan Dry Forests' },
                  { regionId: '362' },
                  {
                    dek:
                      'This ecoregion is a complex mix of forest, grassland, and desert shrubland, and in its western portion, subalpine and alpine vegetation.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c373f33e-4342-44c9-b99e-66cecbf0e062/362 Okanogan dry forests - Straitgate.JPG',
                      _id: 'c373f33e-4342-44c9-b99e-66cecbf0e062'
                    }
                  },
                  { _id: 'e8ecedfb-9318-4ab9-bc61-17d48200e7b7' },
                  { title: 'Fraser Plateau and Basin Conifer Forests' },
                  { regionId: '355' },
                  {
                    dek:
                      'This ecoregion occupies a transitional area of plateaus and plains covering much of the central interior of British Columbia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3b06861d-3c5f-4266-9daf-e5572c1747aa/355 Fraser Plateau and Basin conifer forests - Petra.jpg',
                      _id: '3b06861d-3c5f-4266-9daf-e5572c1747aa'
                    }
                  }
                ],
                stats: [
                  { number: '15,707', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '45%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Greater Rockies & Mountain Forests (NA13)',
                children: [],
                _id: 'bcace7fa-be48-441d-b039-8b70ff644572',
                value: 1000,
                parentId: 'b9cd9856-5810-4462-be43-96d60cdcce20',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3c2383f3-eb2d-4f03-9ebe-05527a67648c/367-Yellowstone Falls-Grand Canyon-CC-Scott Catron-2005.JPG',
                    _id: '3c2383f3-eb2d-4f03-9ebe-05527a67648c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9a5c85eb-87d3-47f5-8efe-f5d3b7ad2d09/394-Bison_at_National_Bison_Range-Montana-CC-USFWS-2008.jpg',
                    _id: '9a5c85eb-87d3-47f5-8efe-f5d3b7ad2d09'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/63f65df1-df06-4c9f-9d75-1dacbc4d2a7b/361 Northern Rockies conifer forests - Harvey Locke.jpg',
                    _id: '63f65df1-df06-4c9f-9d75-1dacbc4d2a7b'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eb9ff7f5-a07e-454d-bee0-fd9070bcceae/Bioregion%20map-NA13.jpg',
                content:
                  '<p>The Greater Rockies bioregion is the backbone of the American West subrealm within Northern America. It extends northward from Yellowstone National Park in Wyoming all the way to Lake Williston in British Columbia. It is covered predominately by temperate conifer forests but includes the foothill grasslands covering the floor of the many valleys that are intertwined with the adjacent mountains. The bioregion includes four ecoregions \u2013 Central British Columbia Mountain Forests (350), Northern Rockies Conifer Forests (361), South Central Rockies Forests (367), Montana Valley and Foothill Grasslands (394) \u2013 and encompasses the northern portion of the Lakes District in British Columbia as well as Glacier National Park of Canada. The total area of this bioregion is approximately 70 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eb9ff7f5-a07e-454d-bee0-fd9070bcceae/Bioregion%20map-NA13.jpg"/><figcaption><span class="caption"><p>The Greater Rockies &amp; Mountain Forests bioregion is part of the American West subrealm and is made up of four ecoregions: (1) Central British Columbia Mountain Forests (2) Northern Rockies Conifer Forests (3) South Central Rockies Forests (4) Montana Valley and Foothill Grasslands.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Greater Rockies &amp; Mountain Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '771b04d9-92b8-47cb-927b-672ec94a7a23' },
                  { title: 'Montana Valley and Foothill Grasslands' },
                  { regionId: '394' },
                  {
                    dek:
                      'This ecoregion forms the matrix of the northern Greater Yellowstone Ecosystem (GYE), westward into central Idaho.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/78aae34f-50ca-49c9-8350-6d5253047612/394 Montana Valley and Foothill grasslands - USFWS.jpg',
                      _id: '78aae34f-50ca-49c9-8350-6d5253047612'
                    }
                  },
                  { _id: '47d117ba-8332-484e-94be-4dc6785b03c3' },
                  { title: 'South Central Rockies Forests' },
                  { regionId: '367' },
                  {
                    dek:
                      'This ecoregion contains the world\u2019s first national park, Yellowstone, as well as Grand Teton National Park and many designated Wilderness areas.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/49db39e7-8793-43eb-a07b-65eb257e83fb/367-Pilot_and_Index_Peaks-WY-Eco367-CC-National Park Service.jpg',
                      _id: '49db39e7-8793-43eb-a07b-65eb257e83fb'
                    }
                  },
                  { _id: '4ca918fb-73d8-44e0-8246-848e86badc5e' },
                  { title: 'Central British Columbia Mountain Forests' },
                  { regionId: '350' },
                  {
                    dek:
                      'This ecoregion is oriented northwest-southeast and lies to the east of the Coast Mountains.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cdcc255f-3225-41cf-b6e6-a66e1dffb1e1/1076px-Nice_looking_day_at_the_South_end_of_Williston_Lake_(305293522).jpg',
                      _id: 'cdcc255f-3225-41cf-b6e6-a66e1dffb1e1'
                    }
                  },
                  { _id: '8791a51d-6ba6-45d5-9571-323864bc0318' },
                  { title: 'Northern Rockies Conifer Forests' },
                  { regionId: '361' },
                  {
                    dek:
                      'This ecoregion encompasses the well-known Rocky Mountain parks of Canada (Jasper, Banff, Yoho, Glacier, Kootenay, and Waterton Lakes National Parks, as well as several Provincial Parks) and the United States (Glacier National Park and several Wilderness Areas, including the Bob Marshall, Selway-Bitterroot, and Cabinet Mountains). '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/63f65df1-df06-4c9f-9d75-1dacbc4d2a7b/361 Northern Rockies conifer forests - Harvey Locke.jpg',
                      _id: '63f65df1-df06-4c9f-9d75-1dacbc4d2a7b'
                    }
                  }
                ],
                stats: [
                  { number: '70,046', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '59%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Colorado Plateau & Mountain Forests (NA19)',
                children: [],
                _id: '3f49c23b-2ee0-4158-82c0-697435b8ff11',
                value: 1000,
                parentId: 'b9cd9856-5810-4462-be43-96d60cdcce20',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cfe29e6e-6fc4-4336-afaf-54fcd1788850/353-Spruce forest in the CO Rockies-CC-Charles M Sauer-2007.jpg',
                    _id: 'cfe29e6e-6fc4-4336-afaf-54fcd1788850'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/db5a9763-8399-4ab1-ac0f-0f8fedd81927/429 Colorado Plateau shrublands - cormanx1.jpg',
                    _id: 'db5a9763-8399-4ab1-ac0f-0f8fedd81927'
                  },
                  {
                    path:
                      "86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/38e329c0-c73a-4768-b613-8f54f395b0bc/368-Kings_Peak_with_Henry's_Fork_Basin-eco368-CC-Matthias B-2004.jpg",
                    _id: '38e329c0-c73a-4768-b613-8f54f395b0bc'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5fe29dff-3eab-4e64-a8b2-b5bafc26f81f/Bioregion%20map-NA19.jpg',
                content:
                  '<p>The Colorado Plateau bioregion, located in the American West subrealm of Northern America, is encircled by mountains on all sides and consists primarily of desert shrublands and shrub steppe, spanning from the Arizona Mountains in the south to northern Wyoming, where it abuts the Central Rockies. It contains five ecoregions \u2013 Arizona Mountains Forests (346), Colorado Plateau Shrublands (429), Wasatch and Uinta Montane Forests (368), Colorado Rockies Forests (353), Wyoming Basin Shrub Steppe (438) \u2013 and for over a thousand years has been home to many different Native American tribes. The total area of this bioregion is approximately 72 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5fe29dff-3eab-4e64-a8b2-b5bafc26f81f/Bioregion%20map-NA19.jpg"/><figcaption><span class="caption"><p>The Colorado Plateau &amp; Mountain Forests bioregion is part of the American West subrealm and is made up of five ecoregions: (1) Wyoming Basin Shrub Steppe (2) Wasatch and Uinta Montane Forests (3) Colorado Plateau Shrublands (4) Colorado Rockies Forests (5) Arizona Mountains Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Colorado Plateau &amp; Mountain Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '1613a6c0-d759-4b91-99a6-a2f7d3f670c2' },
                  { title: 'Wyoming Basin Shrub Steppe' },
                  { regionId: '438' },
                  {
                    dek:
                      'The large Wyoming Basin Shrub Steppe ecoregion is largely confined to Wyoming, but overlaps into southern Montana, southeastern Idaho, northeastern Utah, and northwestern Colorado.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/58dcc90a-945d-44ad-b18b-784f921bebc1/438 Wyoming Basin shrub steppe - David Mark.jpg',
                      _id: '58dcc90a-945d-44ad-b18b-784f921bebc1'
                    }
                  },
                  { _id: '8c269773-2f16-47c3-bcd6-d59cf18bebaa' },
                  { title: 'Colorado Plateau Shrublands' },
                  { regionId: '429' },
                  {
                    dek:
                      'This ecoregion is bounded on the north by the Wyoming Basin Shrub Steppe and on the east by the Colorado Rockies Forests.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/db5a9763-8399-4ab1-ac0f-0f8fedd81927/429 Colorado Plateau shrublands - cormanx1.jpg',
                      _id: 'db5a9763-8399-4ab1-ac0f-0f8fedd81927'
                    }
                  },
                  { _id: '81738afc-a512-45cd-8a31-7002721f09ce' },
                  { title: 'Wasatch and Uinta Montane Forests' },
                  { regionId: '368' },
                  {
                    dek:
                      'This ecoregion constitutes the western edge of the greater Rocky Mountains and consists of two mountain ranges: the north-south oriented Wasatch Range and the east-west oriented Uinta Range.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5703f52f-c17e-4514-8f9f-01be459e9c3c/368 Wasatch and Uinta montane forests - Jared Pedroza.jpg',
                      _id: '5703f52f-c17e-4514-8f9f-01be459e9c3c'
                    }
                  },
                  { _id: '6a34a0b7-d495-43c0-a2ec-3ecb714fdf0e' },
                  { title: 'Colorado Rockies Forests' },
                  { regionId: '353' },
                  {
                    dek:
                      'The Colorado Rockies Forests ecoregion is massive and diverse in physical conditions and vegetation.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fba35865-7b7e-43ba-9d79-bc2ac188ef69/353 Colorado Rockies forests - lassensurf.jpg',
                      _id: 'fba35865-7b7e-43ba-9d79-bc2ac188ef69'
                    }
                  },
                  { _id: '47d5dc68-5526-4e28-abb6-f4289b11e090' },
                  { title: 'Arizona Mountains Forests' },
                  { regionId: '346' },
                  {
                    dek:
                      'This ecoregion lies to the north of southeastern Arizona\u2019s and southwestern New Mexico\u2019s isolated \u201csky islands,\u201d the northern outliers of the extensive Sierra Madre Occidental Pine-Oak Forests ecoregion.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a439f6fa-83d3-4ada-b3e4-57e4a1e249fa/346 Arizona Mountains forests - David Mark.jpg',
                      _id: 'a439f6fa-83d3-4ada-b3e4-57e4a1e249fa'
                    }
                  }
                ],
                stats: [
                  { number: '71,956', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '57%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Great Basin & Columbia Steppe (NA18)',
                children: [],
                _id: 'ee2ddc6e-1895-4719-bacc-37053466bcc4',
                value: 1000,
                parentId: 'b9cd9856-5810-4462-be43-96d60cdcce20',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/47e024e5-09b9-4650-b99b-d0e44d2adc04/434 Snake-Columbia shrub steppe - BLM.jpg',
                    _id: '47e024e5-09b9-4650-b99b-d0e44d2adc04'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/77608dad-5dce-45f7-b4ad-d0355878282d/Bioregion%20map-NA18.jpg',
                content:
                  '<p>The Great Basin &amp; Columbia Steppe bioregion, located in the American West subrealm of Northern America, is encircled by mountains on all sides, except for its southern boundary which marks the beginning of the Mojave Desert. It is made up predominantly of desert shrub-steppe dotted with small mountains, which are covered by conifer forest. It contains three ecoregions \u2013 Great Basin Montane Forests (356), Great Basin Shrub Steppe (430), and Snake-Columbia Shrub Steppe (434) \u2013 and incorporates the Great Salt Lake in central Utah. The total area of this bioregion is approximately 50 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/77608dad-5dce-45f7-b4ad-d0355878282d/Bioregion%20map-NA18.jpg"/><figcaption><span class="caption"><p>The Great Basin &amp; Columbia Steppe bioregion is part of the American West subrealm and is made up of three ecoregions: (1) Snake-Columbia Shrub Steppe (2) Great Basin Shrub Steppe (3) Great Basin Montane Forests.</p></span> </figcaption></figure>\n<p>Learn more about each of the Great Basin &amp; Columbia Steppe ecoregions below.</p>',
                ecoregions: [
                  { _id: 'bca4ce8e-3e67-4dfb-b9ff-b9909b2ec17f' },
                  { title: 'Snake-Columbia Shrub Steppe' },
                  { regionId: '434' },
                  {
                    dek:
                      'This vast ecoregion encompasses the sagebrush steppe of southeastern Oregon, northern Nevada, extreme northeastern California, southern Idaho, and a tiny slice of western Wyoming.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/47e024e5-09b9-4650-b99b-d0e44d2adc04/434 Snake-Columbia shrub steppe - BLM.jpg',
                      _id: '47e024e5-09b9-4650-b99b-d0e44d2adc04'
                    }
                  },
                  { _id: '344be436-b1f0-4c81-b297-a6e0ea05ec9d' },
                  { title: 'Great Basin Shrub Steppe' },
                  { regionId: '430' },
                  {
                    dek:
                      'This huge ecoregion encompasses most of Nevada, nearly half of Utah, and small adjoining areas of California and Idaho.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2bbf1870-6cc8-44f5-a8cd-7d58cc76390f/430 Great Basin shrub steppe - Tip Kilby.jpg',
                      _id: '2bbf1870-6cc8-44f5-a8cd-7d58cc76390f'
                    }
                  },
                  { _id: '66f5795c-1150-4b35-b974-47072f1b24d5' },
                  { title: 'Great Basin Montane Forests' },
                  { regionId: '356' },
                  {
                    dek:
                      'A conspicuous feature of the Great Basin of North America is an archipelago of uplifted fault block mountains jutting out of a vast sea of sagebrush.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/16c79413-72d4-4410-8868-c46e0061ae19/356 Great Basin montane forests - James Bouldin USGS.jpg',
                      _id: '16c79413-72d4-4410-8868-c46e0061ae19'
                    }
                  }
                ],
                stats: [
                  { number: '50,348', item: 'Total Land Area (1000 ha) ' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '82%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Columbia Plateau & Blue Mountains (NA17)',
                children: [],
                _id: 'b0f23360-378b-486a-acec-ae382b3df4cc',
                value: 1000,
                parentId: 'b9cd9856-5810-4462-be43-96d60cdcce20',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/80086064-c938-409c-9663-be2470e625fb/348 Blue Mountains Forests Miguel Vieira cc.jpg',
                    _id: '80086064-c938-409c-9663-be2470e625fb'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6bd18182-b6aa-4f91-ad98-fa59265ae668/398 Palouse Prairie - Walter Siegmund.JPG',
                    _id: '6bd18182-b6aa-4f91-ad98-fa59265ae668'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/03d626ec-d313-4964-b20e-6af5927d8ff3/398 Palouse Prairie Lynn Suckow US Forest Service cc.jpg',
                    _id: '03d626ec-d313-4964-b20e-6af5927d8ff3'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6417365c-914c-432e-9a7e-ec0a12022a11/398 Palouse Prairie Dsdugan cc.jpg',
                    _id: '6417365c-914c-432e-9a7e-ec0a12022a11'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/250e1650-80dd-4d58-bff3-005d564bef43/Bioregion%20map-NA17.jpg',
                content:
                  '<p>The Columbia Plateau, located in the American West subrealm of Northern America, is an intermontane bioregion contained by the Rockies to the east and the Cascades to the west. This bioregion consists largely of high-altitude prairie but incorporates the conifer forests that cover the range of the lower lying, volcanic mountains to the south. It contains two ecoregions \u2013 Palouse Prairie (398), Blue Mountains Forests (348) \u2013 and includes a large portion of the Snake River, which merges with the Columbia River in southern Washington. The total area of this bioregion is approximately 15.5 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/250e1650-80dd-4d58-bff3-005d564bef43/Bioregion%20map-NA17.jpg"/><figcaption><span class="caption"><p>The Columbia Plateau &amp; Blue Mountains bioregion is part of the American West subrealm and is made up of two ecoregions: (1) Palouse Prairie (2) Blue Mountains Forests.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Columbia Plateau &amp; Blue Mountains ecoregions below.</p>',
                ecoregions: [
                  { _id: 'b0888f2f-8f9e-42b4-8c5b-f1bec5651058' },
                  { title: 'Palouse Prairie' },
                  { regionId: '398' },
                  {
                    dek:
                      'This ecoregion occupies a large area of the Columbia Basin and Okanogan Highlands physiographic provinces of north-central Oregon, central and eastern Washington, and small areas of western Idaho and south-central British Columbia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bbd6b943-c56a-43ee-a905-24ef4c3a9e1c/398 Palouse Prairie Lynn Suckow.jpg',
                      _id: 'bbd6b943-c56a-43ee-a905-24ef4c3a9e1c'
                    }
                  },
                  { _id: '17571554-d5bf-46c1-b898-cd7e5202d3a2' },
                  { title: 'Blue Mountains Forests' },
                  { regionId: '348' },
                  {
                    dek:
                      'This ecoregion occupies a broad swath of central Oregon (east of the Eastern Cascades) and northeastern Oregon, as well as adjacent areas of southeastern Washington and western Idaho. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5dd26b54-e322-4325-950e-4830d72d1f9c/348 Blue Mountains forests - USFS.jpg',
                      _id: '5dd26b54-e322-4325-950e-4830d72d1f9c'
                    }
                  }
                ],
                stats: [
                  { number: '15,481', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '27%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level ' }
                ]
              }
            ],
            parentId: 'Northern America',
            value: 1000
          },
          {
            _id: '36f54067-20f4-4c6f-842f-597a468fa5a0',
            name: 'North Pacific Coast',
            children: [
              {
                name: 'Greater California (NA31)',
                children: [],
                _id: '723450bf-f05a-4604-bbb9-c1b7130187b3',
                value: 1000,
                parentId: '36f54067-20f4-4c6f-842f-597a468fa5a0',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ece92f3a-09ea-4b1d-bb53-8b9d144fe3ab/366-Mount_Alice_and_Temple_Crag_in_the_Sierra_Nevada_(U.S.)-Eco366-CC-Miguel V-2010.jpg',
                    _id: 'ece92f3a-09ea-4b1d-bb53-8b9d144fe3ab'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/001d5b02-efaa-4d44-94dd-989b42b1c7a2/422- CA_1_north_of_Jenner-Eco 422-Eco422-CC-2013.jpg',
                    _id: '001d5b02-efaa-4d44-94dd-989b42b1c7a2'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/73bde107-6c5f-41da-a9e4-3ca2e4f6ab47/424 California montane chaparral and woodlands - jsanchezd.jpg',
                    _id: '73bde107-6c5f-41da-a9e4-3ca2e4f6ab47'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/04916159-f173-49d8-8c5a-d9c743b6bcf1/366-Pinus_ponderosa_Yosemite_CC-Jodie Wilson-2009.jpg',
                    _id: '04916159-f173-49d8-8c5a-d9c743b6bcf1'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f9deae6b-45ef-43c4-92cc-d9cdbebd43c0/Bioregion%20map-NA31.jpg',
                content:
                  '<p>The Greater California bioregion, located in the North Pacific Coast subrealm of Northern America, is defined by the Mediterranean chaparral and woodlands that run between the Pacific Coast and the Lower California mountain range enclosing the Central Valley, which is one of the most productive agricultural regions in the world. This bioregion also incorporates the Sierra Nevada mountain range to the east, with its ancient sequoias, deep canyons, and high mountain lakes and waterfalls famous for inspiring the writings of John Muir, which led to the beginning of the US national parks system. The bioregion contains six ecoregions \u2013 Santa Lucia Montane Chaparral and Woodlands [1], California Interior Chaparral and Woodlands [2], California Central Valley Grasslands [3], Sierra Nevada Forests [4], California Montane Chaparral and Woodlands [5], California Coastal Sage and Chaparral [6] \u2013 and adjacent marine areas along the Pacific coast. The total land area of this bioregion is approximately 23 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f9deae6b-45ef-43c4-92cc-d9cdbebd43c0/Bioregion%20map-NA31.jpg"/><figcaption><span class="caption"><p>The Greater California bioregion is part of the North Pacific Coast subrealm and is made up of six ecoregions: Santa Lucia Montane Chaparral and Woodlands [1], California Interior Chaparral and Woodlands [2], California Central Valley Grasslands [3], Sierra Nevada Forests [4], California Montane Chaparral and Woodlands [5], California Coastal Sage and Chaparral [6].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Greater California ecoregions below.</p>',
                ecoregions: [
                  { _id: '8aa814af-b445-4c99-9551-347250258903' },
                  { title: 'Santa Lucia Montane Chaparral and Woodlands ' },
                  { regionId: '425' },
                  {
                    dek:
                      'This ecoregion is a small region bordering the Pacific Ocean in the Santa Lucia Mountains and vicinity, part of the Southern Coast Ranges of California.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5ddb3995-853e-4c51-a42e-f4279b59258f/425-San Gabriel Mountains-Eco425-CC-2005.jpg',
                      _id: '5ddb3995-853e-4c51-a42e-f4279b59258f'
                    }
                  },
                  { _id: 'b1ce2b69-7713-4e3f-838c-a77574a37251' },
                  { title: 'California Montane Chaparral and Woodlands ' },
                  { regionId: '424' },
                  {
                    dek:
                      'This ecoregion occupies the Transverse Ranges of southern California, from north of Santa Barbara to northeast of San Bernardino, and the Peninsular Ranges, from east of San Jacinto southward to east of San Diego, as well as several disjunct blocks in northern Baja California. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/73bde107-6c5f-41da-a9e4-3ca2e4f6ab47/424 California montane chaparral and woodlands - jsanchezd.jpg',
                      _id: '73bde107-6c5f-41da-a9e4-3ca2e4f6ab47'
                    }
                  },
                  { _id: '44deeab0-608e-44b6-a77e-3f1c1aefe7ce' },
                  { title: 'California Interior Chaparral and Woodlands' },
                  { regionId: '423' },
                  {
                    dek:
                      'This ecoregion wraps around California\u2019s Central Valley, extending from Shasta Lake in the north to the vicinity of Wheeler Ridge in the south.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b453db4f-d2f4-439c-9227-840d242635a1/423 California interior chaparral and woodlands - David Mark.jpg',
                      _id: 'b453db4f-d2f4-439c-9227-840d242635a1'
                    }
                  },
                  { _id: 'e83d058a-5ce9-40ba-ba13-2244f89e41af' },
                  { title: 'California Coastal Sage and Chaparral' },
                  { regionId: '422' },
                  {
                    dek:
                      'This ecoregion stretches from the vicinity of Santa Barbara, California, southward along the coastal plain, coastal terraces, and mountains south of the east-west Traverse Ranges to northeastern Baja California, Mexico.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/144210cf-b028-40d2-a07f-4cf980ae57ca/422 California coastal sage and chaparral - D Olson.jpg',
                      _id: '144210cf-b028-40d2-a07f-4cf980ae57ca'
                    }
                  },
                  { _id: '2975a8c7-bbe3-495e-8151-b25fb6ca716b' },
                  { title: 'California Central Valley Grasslands' },
                  { regionId: '385' },
                  {
                    dek:
                      'The California Central Valley ecoregion stretches from Red Bluff, California, southeastward 720 km to the vicinity of Wheeler Ridge.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eb5019ea-cee0-4661-aef9-86d7c5ab81ba/385 California Central Valley grasslands -Gary Kramer USDA.jpg',
                      _id: 'eb5019ea-cee0-4661-aef9-86d7c5ab81ba'
                    }
                  },
                  { _id: 'a03da044-51c2-4bba-9ea1-9bb628fa7256' },
                  { title: 'Sierra Nevada Forests' },
                  { regionId: '366' },
                  {
                    dek:
                      'This ecoregion lies between the California Central Valley Grasslands ecoregion to the west, which is enveloped by the California Interior Chaparral and Woodlands ecoregion, and the Great Basin Shrub Steppe ecoregion to the east.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/83e499e9-a960-4857-9d32-cdd8b54a1e9f/366 Sierra Nevada forests - pila488.jpg',
                      _id: '83e499e9-a960-4857-9d32-cdd8b54a1e9f'
                    }
                  }
                ],
                stats: [
                  { number: '22,944', item: 'Total Land Area (1000 ha)' },
                  { number: '6', item: 'Number of Ecoregions' },
                  { number: '33%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'Cascades Mountain Forests & Valleys (NA16)',
                children: [],
                _id: '0d101cf8-0f6e-46d1-ad48-18865baf2355',
                value: 1000,
                parentId: '36f54067-20f4-4c6f-842f-597a468fa5a0',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/06ca9cfb-0dbb-4cd1-ad2a-cf3502f363aa/354-Mt_Jefferson forest after burn-CC-David Van Horn-2007_resized.jpg',
                    _id: '06ca9cfb-0dbb-4cd1-ad2a-cf3502f363aa'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7c518eb0-d501-479f-ae3e-96bfc56f519a/358 North Cascades conifer forests - NPS.jpg',
                    _id: '7c518eb0-d501-479f-ae3e-96bfc56f519a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d2fdfd83-848d-40a4-aac3-b62e23df863e/403-Willamette_River_at_Molalla_CC- MO Stevens-2007.jpg',
                    _id: 'd2fdfd83-848d-40a4-aac3-b62e23df863e'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/79b0d674-f06f-498e-9f64-e31ba36442b2/Bioregion%20map-NA16.jpg',
                content:
                  '<p>The Cascades bioregion, located in the Pacific Coast subrealm of Northern America, is defined by the dense forests of the Cascades Range, stretching from northern California to the Canadian border. This bioregion also incorporates the grasslands at the foot of the Cascades Range in western Oregon. It contains four distinct ecoregions \u2013 North Cascades Conifer Forests (358), Central-Southern Cascades Forests (352), Eastern Cascades Forests (354), Willamette Valley Oak Savanna (403) \u2013 and includes the Columbia Gorge and many lakes dotted throughout the region. The land area of this bioregion is approximately 16 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/79b0d674-f06f-498e-9f64-e31ba36442b2/Bioregion%20map-NA16.jpg"/><figcaption><span class="caption"><p>The Cascades Mountain Forests &amp; Valleys bioregion is part of the North Pacific Coast subrealm and is made up of four ecoregions: (1) Willamette Valley Oak Savanna (2) Central-Southern Cascades Forests (3) Eastern Cascades Forests (4) North Cascades Conifer Forests.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Cascades Mountain Forests &amp; Valleys ecoregions below.</p>',
                ecoregions: [
                  { _id: 'a25c81e0-37b7-4ab9-88dd-8a259bf2eb7c' },
                  { title: 'North Cascades Conifer Forests' },
                  { regionId: '358' },
                  {
                    dek:
                      'This ecoregion encompasses the northern section of the Cascades Mountains in Washington and adjacent British Columbia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7c518eb0-d501-479f-ae3e-96bfc56f519a/358 North Cascades conifer forests - NPS.jpg',
                      _id: '7c518eb0-d501-479f-ae3e-96bfc56f519a'
                    }
                  },
                  { _id: 'd2ddb0df-3d61-4562-8b8e-b0e517f4aba2' },
                  { title: 'Eastern Cascades Forests' },
                  { regionId: '354' },
                  { dek: 'This ecoregion spans the eastern slope of the Cascades Mountains.' },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cf30a4d3-cd1b-41e2-b36b-7b35ae96cd64/354 Eastern Cascades Forests - Reed Noss_resized.jpg',
                      _id: 'cf30a4d3-cd1b-41e2-b36b-7b35ae96cd64'
                    }
                  },
                  { _id: 'ed8de8e5-c2a1-4a67-aece-f9f969df8bd1' },
                  { title: 'Central-Southern Cascades Forests' },
                  { regionId: '352' },
                  {
                    dek:
                      'This ecoregion stretches from the northern edge of the Sierra Nevada Range in California, just south of Mt. Lassen, northward through western Oregon to north of Mt. Rainier in Washington. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/968db501-a6d1-432a-b976-889ab700fc11/352 Central-Southern Cascades Forests - Skeeze.jpg',
                      _id: '968db501-a6d1-432a-b976-889ab700fc11'
                    }
                  },
                  { _id: '334f0977-5027-4d26-9fd4-48243cee89c0' },
                  { title: 'Willamette Valley Oak Savanna' },
                  { regionId: '403' },
                  {
                    dek:
                      'This ecoregion occupies the Willamette River Valley of northwest Oregon, between the Cascade Mountains and the Oregon Coast Range.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f952a737-3c0e-4ab6-ac57-ff9e096b8f16/403-Willamette_Valley_fog-CC-2010.JPG',
                      _id: 'f952a737-3c0e-4ab6-ac57-ff9e096b8f16'
                    }
                  }
                ],
                stats: [
                  { number: '16,228', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '47%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'Pacific Northwest Coastal Forests (NA15)',
                children: [],
                _id: 'e218ab55-a4a1-485e-a21d-60249280323e',
                value: 1000,
                parentId: '36f54067-20f4-4c6f-842f-597a468fa5a0',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6f5f8d6f-e123-4f1e-b36e-c9f6d6cbd1ca/351-Cedar_Creek_Abbey_Island_Ruby_Beach-Washington-CC-2013.jpg',
                    _id: '6f5f8d6f-e123-4f1e-b36e-c9f6d6cbd1ca'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/595ff6eb-fce1-4384-bbb5-b7b09c49c725/351-Mosses Hoh RainForest-Washington-CC_Walter Siegmund-2005.jpg',
                    _id: '595ff6eb-fce1-4384-bbb5-b7b09c49c725'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e584b5c0-7596-4bd5-88e7-d6afae7d8741/351 Central Pacific Northwest coastal forests - Rhett Butler.jpg',
                    _id: 'e584b5c0-7596-4bd5-88e7-d6afae7d8741'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/80afa96f-9602-41b1-bff1-b77c3cdf04ab/Bioregion%20map-NA15.jpg',
                content:
                  '<p>The Pacific Northwest, located in the Northern America (Nearctic) realm, is an expansive coastal bioregion that stretches from the Santa Cruz Mountains in California, crossing over the San Francisco Peninsula, to Graham Island in British Columbia. The bioregion is famous for its old growth redwood forests and includes six ecoregions \u2013 British Columbia Coastal Conifer Forests (349), Central Pacific Northwest Coastal Forests (351), Klamath-Siskiyou Forests (357), Northern California Coastal Forests (359), Puget Lowland Forests (364), Haida Gwaii Conifer Forests (365) \u2013 and adjacent marine areas. The total land area of this bioregion is approximately 30 million hectares.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/80afa96f-9602-41b1-bff1-b77c3cdf04ab/Bioregion%20map-NA15.jpg"/><figcaption><span class="caption"><p>The Pacific Northwest Coastal Forests bioregion is part of the North Pacific Coast subrealm and is made up of six ecoregions: (1) Queen Charlotte Islands Conifer Forests (2) British Columbia Coastal Conifer Forests (3) Central Pacific Northwest Coastal Forests (4) Puget Lowland Forests (5) Klamath-Siskiyou Forests (6) Northern California Coastal Forests.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Pacific Northwest Coastal Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '1afa1aee-c125-43a6-b393-bd8497798128' },
                  { title: 'Northern California Coastal Forests' },
                  { regionId: '359' },
                  {
                    dek:
                      'This ecoregion is often called the Redwood Region because it encompasses most of the range of one of the truly spectacular forests on Earth\u2014the coast redwood forest. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/18706eed-9da9-4d68-a0a1-d7702424f023/359 Northern California coastal forests - D Olson.jpg',
                      _id: '18706eed-9da9-4d68-a0a1-d7702424f023'
                    }
                  },
                  { _id: 'e4bf5a1c-a3be-4314-ad10-8b2347764039' },
                  { title: 'Klamath-Siskiyou Forests' },
                  { regionId: '357' },
                  {
                    dek:
                      'This ecoregion is the most biologically important temperate forest ecoregion in all of western North America, in terms of concentrations of endemic species and ancient lineages.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9f79eacc-b07d-41ec-9cc9-c9a212317860/357 Klamath-Siskiyou forests - D Olson_resized.jpg',
                      _id: '9f79eacc-b07d-41ec-9cc9-c9a212317860'
                    }
                  },
                  { _id: '86ccf8b3-3e36-469c-9dc5-44845b923e54' },
                  { title: 'Haida Gwaii Conifer Forests' },
                  { regionId: '365' },
                  {
                    dek:
                      'This ecoregion encompasses all 150 islands and the many islets in this archipelago. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/542d0db7-c946-40c6-89c6-156b4e9cc0fe/365 Queen Charlotte Islands conifer forests - Sam Beebe.jpg',
                      _id: '542d0db7-c946-40c6-89c6-156b4e9cc0fe'
                    }
                  },
                  { _id: 'b293154a-0a77-4d1a-8eeb-4775da26f24b' },
                  { title: 'Puget Lowland Forests' },
                  { regionId: '364' },
                  {
                    dek:
                      'This ecoregion is centered on a north-south depression, the Puget Trough, between the Cascade Range and the Olympic Peninsula in Washington, including Seattle.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ef020b07-939f-4828-a11e-f88eb3615c0f/364 Puget lowland forests - netadssell.jpg',
                      _id: 'ef020b07-939f-4828-a11e-f88eb3615c0f'
                    }
                  },
                  { _id: 'e787d767-9f53-4fa8-9909-dd587824d07b' },
                  { title: 'Central Pacific Northwest Coastal Forests' },
                  { regionId: '351' },
                  {
                    dek:
                      'This ecoregion is a thin but long ecoregion extending from the southern Oregon coast in the south, northward through coastal Washington and British Columbia to the border with Alaska.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e584b5c0-7596-4bd5-88e7-d6afae7d8741/351 Central Pacific Northwest coastal forests - Rhett Butler.jpg',
                      _id: 'e584b5c0-7596-4bd5-88e7-d6afae7d8741'
                    }
                  },
                  { _id: '62977000-88d0-4828-9cc0-f953785476f2' },
                  { title: 'British Columbia Coastal Conifer Forests' },
                  { regionId: '349' },
                  {
                    dek:
                      'This ecoregion lies between the Pacific Coastal Mountain Icefields and Tundra ecoregion to the west and the Central British Columbia Mountain Forests ecoregion to the east.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8cbfb119-1596-4ff2-ba3c-d212197ce80e/349 British Columbia coastal conifer forests - Sam Beebe.jpg',
                      _id: '8cbfb119-1596-4ff2-ba3c-d212197ce80e'
                    }
                  }
                ],
                stats: [
                  { number: '29,657', item: 'Total Land Area (1000 ha)' },
                  { number: '6', item: 'Number of Ecoregions' },
                  { number: '55%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Northern America',
            value: 600
          },
          {
            _id: 'a040acbe-f2b0-4243-bbc8-97004415cf7d',
            name: 'Northeast American Forests',
            children: [
              {
                name: 'Interior Plateau & Southern Great Lakes Forests (NA23)',
                children: [],
                _id: 'c1fe24d8-7c6b-49ae-91b5-50c304b5f3d5',
                value: 1000,
                parentId: 'a040acbe-f2b0-4243-bbc8-97004415cf7d',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1cda266e-bb3f-4705-8367-a61c4010d977/336 Interior Plateau US Hardwood Forests - Reed Noss_resized.jpg',
                    _id: '1cda266e-bb3f-4705-8367-a61c4010d977'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/74b2ff33-8400-40e8-be4c-ed17c765ae6d/342-South_Chagrin-Reservation-CC-Yu-Hong Yen-.jpg',
                    _id: '74b2ff33-8400-40e8-be4c-ed17c765ae6d'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fdd38b15-ec34-4491-ae6c-22935e288dc7/Bioregion%20map-NA23.jpg',
                content:
                  '<p>The Interior Plateau bioregion, located in the Northeast American Forests subrealm of Northern America, sits between the Appalachian Mountains to the east and the central grassland-forest transition to the west, extending northward to include the eastern half of Lake Michigan and the entirety of Lake Erie. It contains two ecoregions \u2013 Interior Plateau US Hardwood Forests (336), Southern Great Lakes Forests (342) \u2013 and is dominated by broadleaf forest. The total area of this bioregion is approximately 35 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fdd38b15-ec34-4491-ae6c-22935e288dc7/Bioregion%20map-NA23.jpg"/><figcaption><span class="caption"><p>The Interior Plateau &amp; Southern Great Lakes Forests bioregion is part of the Northeast American Forests subrealm and is made up of two ecoregions: (1) Southern Great Lakes Forests (2) Interior Plateau US Hardwood Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Interior Plateau &amp; Southern Great Lakes Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'ed12d3cc-4d7e-4359-b5f5-81ce811abca3' },
                  { title: 'Southern Great Lakes Forests' },
                  { regionId: '342' },
                  {
                    dek:
                      'This ecoregion occupies much of the industrial heartland of North America and is also highly agricultural.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/74b2ff33-8400-40e8-be4c-ed17c765ae6d/342-South_Chagrin-Reservation-CC-Yu-Hong Yen-.jpg',
                      _id: '74b2ff33-8400-40e8-be4c-ed17c765ae6d'
                    }
                  },
                  { _id: '7e3a6598-b84d-49e6-86e7-70b460d91122' },
                  { title: 'Interior Plateau US Hardwood Forests' },
                  { regionId: '336' },
                  {
                    dek:
                      'This ecoregion lies to the west of the Cumberland Plateau and includes a small part of northern Alabama, most of central Tennessee, central and western Kentucky, and the southernmost portions of Illinois, Indiana, and southwestern Ohio.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1cda266e-bb3f-4705-8367-a61c4010d977/336 Interior Plateau US Hardwood Forests - Reed Noss_resized.jpg',
                      _id: '1cda266e-bb3f-4705-8367-a61c4010d977'
                    }
                  }
                ],
                stats: [
                  { number: '35,190', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '25%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Appalachia & Allegheny Interior Forests (NA24)',
                children: [],
                _id: '36220a47-3de3-422b-ac84-67d1ec80bbce',
                value: 1000,
                parentId: 'a040acbe-f2b0-4243-bbc8-97004415cf7d',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/74ca34a9-3871-46a5-aa41-28261bcfe155/328 Allegheny Highlands forests - Nicholas A Tonelli CC.jpg',
                    _id: '74ca34a9-3871-46a5-aa41-28261bcfe155'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f4f1dd52-84c8-46d8-980e-63d3dbf9ead8/331 Appalachian-Blue Ridge forests - D Olson.jpg',
                    _id: 'f4f1dd52-84c8-46d8-980e-63d3dbf9ead8'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/826f0222-b5b0-4cf1-ba53-a041223c3bdf/330 Appalachian Piedmont Forests - Reed Noss_resized.jpg',
                    _id: '826f0222-b5b0-4cf1-ba53-a041223c3bdf'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d2342b0a-b7d6-467b-adbc-efddbdf0717c/Bioregion%20map-NA24.jpg',
                content:
                  '<p>The Appalachia &amp; Allegheny bioregion, located in the Northeast American Forests subrealm of Northern America, extends from central Alabama all the way up to the highlands of central New York, following the line of the Blue Ridge Mountains. It is dominated by broadleaf forests but contains four unique ecoregions \u2013 Allegheny Highlands Forests (328), Appalachian Mixed Mesophytic Forests (329), Appalachian Piedmont Forests (330), Appalachian-Blue Ridge Forests (331) \u2013 including numerous rivers and small lakes. The total area of this bioregion is approximately 58.5 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d2342b0a-b7d6-467b-adbc-efddbdf0717c/Bioregion%20map-NA24.jpg"/><figcaption><span class="caption"><p>The Appalachia &amp; Allegheny Interior Forests bioregion is part of the Northeast American Forests subrealm and is made up of four ecoregions: (1) Allegheny Highlands Forests (2) Appalachian Mixed Mesophytic Forests (3) Appalachian-Blue Ridge Forests (4) Appalachian Piedmont Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/stories/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Appalachia &amp; Allegheny Interior Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '660d3c3d-87b3-4beb-adf5-08503050ce3d' },
                  { title: 'Appalachian-Blue Ridge forests' },
                  { regionId: '331' },
                  {
                    dek:
                      'This ecoregion includes the Blue Ridge and Valley and Ridge physiographic provinces, a long region stretching from central Alabama northeastward to New York state and including portions of 10 states.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f4f1dd52-84c8-46d8-980e-63d3dbf9ead8/331 Appalachian-Blue Ridge forests - D Olson.jpg',
                      _id: 'f4f1dd52-84c8-46d8-980e-63d3dbf9ead8'
                    }
                  },
                  { _id: '51c439d7-6fdb-4e93-9c09-56a9e96cfca1' },
                  { title: 'Appalachian Piedmont Forests' },
                  { regionId: '330' },
                  {
                    dek:
                      'This ecoregion lies between the Coastal Plain and the Appalachian Mountains.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/826f0222-b5b0-4cf1-ba53-a041223c3bdf/330 Appalachian Piedmont Forests - Reed Noss_resized.jpg',
                      _id: '826f0222-b5b0-4cf1-ba53-a041223c3bdf'
                    }
                  },
                  { _id: '2bc1bacb-2697-4aae-9ce3-7bb42e643572' },
                  { title: 'Appalachian Mixed Mesophytic Forests' },
                  { regionId: '329' },
                  {
                    dek:
                      'This ecoregion includes the Cumberland Plateau, Cumberland Mountains, and much of the Allegheny Plateau physiographic provinces, stretching from northern Alabama to western Pennsylvania. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a995b4e1-b0e8-4792-a5ce-d0be7583a276/329 Appalachian mixed mesophytic - Reed Noss.jpg',
                      _id: 'a995b4e1-b0e8-4792-a5ce-d0be7583a276'
                    }
                  },
                  { _id: '7ff16282-5947-457b-9baf-f694461e05a1' },
                  { title: 'Allegheny Highlands Forests' },
                  { regionId: '328' },
                  {
                    dek:
                      'This ecoregion encompasses a large part of the Allegheny Plateau physiographic province, including both unglaciated and glaciated portions, in Pennsylvania and New York.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/74ca34a9-3871-46a5-aa41-28261bcfe155/328 Allegheny Highlands forests - Nicholas A Tonelli CC.jpg',
                      _id: '74ca34a9-3871-46a5-aa41-28261bcfe155'
                    }
                  }
                ],
                stats: [
                  { number: '58,517', item: 'Total Land Area (1000 ha) ' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '56%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Northern Great Lakes Forests (NA11)',
                children: [],
                _id: '85b9ab42-5307-4bcf-81ef-dee1467c8300',
                value: 1000,
                parentId: 'a040acbe-f2b0-4243-bbc8-97004415cf7d',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0bad219f-a59d-46b9-9c12-86ae9e16c658/333-Malbaie_River_in_Hautes-Gorges-de-la-Rivi\u00e8re-Malbaie_National_Park,_Quebec,_Canada-CC-David Touzin-2006.jpg',
                    _id: '0bad219f-a59d-46b9-9c12-86ae9e16c658'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/01a09930-5c24-4b63-81e8-1e0c816e2100/333-Jacques-Cartier River valley from Andante montain, Jacques-Cartier National Park, Quebec, Canada-CC-2009_resized.jpg',
                    _id: '01a09930-5c24-4b63-81e8-1e0c816e2100'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/591bb0cd-26ae-4c86-9d94-c2d3f2681625/344 Western Great Lakes Forests-Tony_webster-cc.jpg',
                    _id: '591bb0cd-26ae-4c86-9d94-c2d3f2681625'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ba7fef58-1823-4582-93a3-7272ff975f61/Bioregion%20map-NA11.jpg',
                content:
                  '<p>The Northern Great Lakes bioregion, located in the Northeast American Forests subrealm in Northern America, spans from Quebec to Minnesota just below the Canadian Shield forests. The bioregion is predominantly made up of broadleaf forests and includes four ecoregions \u2013 Western Great Lakes Forests [1], &nbsp;Upper Midwest US Forest-Savanna Transition [2], Eastern Canadian Temperate-Boreal Forest Transition [3], Eastern Great Lakes Lowland Forests [4] \u2013 encompassing most of the Great Lakes. The total land area of this bioregion is approximately 193 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ba7fef58-1823-4582-93a3-7272ff975f61/Bioregion%20map-NA11.jpg"/><figcaption><span class="caption"><p>The Northern Great Lakes Forests bioregion is part of the Northeast American Forests subrealm and is made up of four ecoregions: Western Great Lakes Forests [1], &nbsp;Upper Midwest US Forest-Savanna Transition [2], Eastern Canadian Temperate-Boreal Forest Transition [3], Eastern Great Lakes Lowland Forests [4].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Northern Great Lakes Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '5aedf6dc-3d44-4709-9fec-70ea23c96b22' },
                  { title: 'Western Great Lakes Forests' },
                  { regionId: '344' },
                  {
                    dek:
                      'This ecoregion stretches from Michigan, where it encompasses nearly half of the Lower Peninsula and all of the Upper Peninsula, through northern Wisconsin and Minnesota, southwestern Ontario, to the southeastern corner of Manitoba.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b57cc56a-8746-4d15-acd5-8c5d06090db0/344 Western Great Lakes forests - Reed Noss.jpg',
                      _id: 'b57cc56a-8746-4d15-acd5-8c5d06090db0'
                    }
                  },
                  { _id: '43ee3f56-78eb-4b3a-ad6e-2cdd302889a8' },
                  { title: 'Upper Midwest US Forest-Savanna Transition' },
                  { regionId: '343' },
                  {
                    dek:
                      'This ecoregion encompasses most of the Minneapolis-St. Paul metropolitan area and many smaller cities. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/318818b0-7b3a-43e9-85c5-98dfb74eaaf3/343 Upper Midwest forest-savanna - Reed Noss_resized.jpg',
                      _id: '318818b0-7b3a-43e9-85c5-98dfb74eaaf3'
                    }
                  },
                  { _id: '345baa96-048a-4ca9-872f-c3c4a9ad9160' },
                  { title: 'Eastern Great Lakes Lowland Forests' },
                  { regionId: '334' },
                  {
                    dek:
                      'This ecoregion covers most of the region around the eastern Great Lakes and the St. Lawrence River. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6b01c793-e704-4d10-9ff9-6e044f090a45/334 Eastern Great Lakes lowland forests - Yinan Chen.jpg',
                      _id: '6b01c793-e704-4d10-9ff9-6e044f090a45'
                    }
                  },
                  { _id: '260e175a-b177-414d-af0c-2afd62c15ff8' },
                  { title: 'Eastern Canadian Temperate-Boreal Forest Transition' },
                  { regionId: '333' },
                  {
                    dek:
                      'This ecoregion encompasses the southern portion of the Canadian (Precambrian) Shield in Ontario and Quebec, with the southern boundary of the Shield defining the southern border of this ecoregion. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5ac803c5-6f7a-45f2-8e78-300dc4ba9bee/333 Eastern Canadian Forest-Boreal transition - Denise Riches.jpg',
                      _id: '5ac803c5-6f7a-45f2-8e78-300dc4ba9bee'
                    }
                  }
                ],
                stats: [
                  { number: '87,506', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '56%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Northeastern American Mixed Forests (NA10)',
                children: [],
                _id: 'fe8a443b-785a-4c72-85a1-de7a4a218474',
                value: 1000,
                parentId: 'a040acbe-f2b0-4243-bbc8-97004415cf7d',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4c141286-4a40-4345-ae51-4cbef9f6a836/338 chensiyuan cc.jpeg',
                    _id: '4c141286-4a40-4345-ae51-4cbef9f6a836'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/defa094e-b353-43d0-92da-39a0dbb03928/338 New England-Acadian Forests-Cape_Breton_Highlands_National_Park-glangille-cc.jpg',
                    _id: 'defa094e-b353-43d0-92da-39a0dbb03928'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5196d99b-3c00-410d-b78a-af40dce46908/338 New England-Acadian Forests Kejimkujik National Park Davis Bennett cc.jpg',
                    _id: '5196d99b-3c00-410d-b78a-af40dce46908'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/92d216a9-d30a-4b6e-a98d-895822ef3f2f/335 Gulf of St. Lawrence lowland forests - Graham Hobster.jpg',
                    _id: '92d216a9-d30a-4b6e-a98d-895822ef3f2f'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6dfdb714-ff9d-40cb-8bc8-89614dc292d8/Bioregion%20map-NA10.jpg',
                content:
                  '<p>The Northeastern American bioregion, located in the Northern America (Nearctic) realm, extends from the top of New Brunswick, Canada to the Blue Ridge mountains in the mid-Atlantic region of the US. The bioregion is predominantly made up of broadleaf forests and includes three ecoregions \u2013 Northeast US Coastal Forests [1], New England-Acadian Forests [2], Gulf of St. Lawrence Lowland Forests [3] \u2013 covering most of the Northeastern Seaboard. The total land area of this bioregion is approximately 44 million hectares.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6dfdb714-ff9d-40cb-8bc8-89614dc292d8/Bioregion%20map-NA10.jpg"/><figcaption><span class="caption"><p>The Northeastern American Mixed Forests bioregion is part of the Northeast American Forests subrealm and is made up of three ecoregions: Northeast US Coastal Forests [1], New England-Acadian Forests [2], Gulf of St. Lawrence Lowland Forests [3].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Northeastern American Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '398d79bc-9771-4ec5-b00b-85e39eecd981' },
                  { title: 'Northeast US Coastal Forests' },
                  { regionId: '339' },
                  {
                    dek:
                      'This ecoregion stretches across a long strip of latitude and includes parts of 11 states, from Virginia to southern Maine.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bd5eb3c4-0562-4416-97ed-3fa327eaa906/339 Northeast US Coastal forests - David Mark.jpg',
                      _id: 'bd5eb3c4-0562-4416-97ed-3fa327eaa906'
                    }
                  },
                  { _id: 'ce26b697-8499-4684-94aa-6d8dd89a9a8d' },
                  { title: 'New England-Acadian Forests' },
                  { regionId: '338' },
                  {
                    dek:
                      'This vast ecoregion has a humid cold temperate to boreal climate. The entire region, including most of the coastal zone, is hilly to mountainous, with the highest elevations in the White Mountains of New Hampshire. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bbe0d6bd-a2e0-441c-9a2b-5088ce0f4a40/338 New England-Acadian forests - quiquefepe.jpg',
                      _id: 'bbe0d6bd-a2e0-441c-9a2b-5088ce0f4a40'
                    }
                  },
                  { _id: 'efc8d895-1bcf-49dd-a61d-a353fd0173a7' },
                  { title: 'Gulf of St. Lawrence Lowland Forests' },
                  { regionId: '335' },
                  {
                    dek:
                      'This ecoregion is surrounded by the New England-Acadian Forests ecoregion and the Atlantic Ocean\u2019s Gulf of St. Lawrence.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/92d216a9-d30a-4b6e-a98d-895822ef3f2f/335 Gulf of St. Lawrence lowland forests - Graham Hobster.jpg',
                      _id: '92d216a9-d30a-4b6e-a98d-895822ef3f2f'
                    }
                  }
                ],
                stats: [
                  { number: '44,409', item: 'Total Land Area (1000 ha) ' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '61%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Northern America',
            value: 800
          },
          {
            _id: 'e3691cbf-37e5-4fae-89d4-1a9c894b04b4',
            name: 'Southeast US Savannas & Forests',
            children: [
              {
                name: 'Southern Mixed Forests & Blackland Prairies (NA28)',
                children: [],
                _id: 'ce6a2e78-8753-41f0-9bc5-6c32f5184c2a',
                value: 1000,
                parentId: 'e3691cbf-37e5-4fae-89d4-1a9c894b04b4',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/640bcf2a-8286-46e4-b6a2-907c5880843d/363 Piney Woods Forests William L. Farr cc.jpg',
                    _id: '640bcf2a-8286-46e4-b6a2-907c5880843d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2d5fdf69-c4ff-4099-94cb-12e3edbe9c82/363 Piney Woods Forests William L. Farr cc4.jpg',
                    _id: '2d5fdf69-c4ff-4099-94cb-12e3edbe9c82'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c4487674-81bf-4e7c-9915-103705e1f75c/363 Piney Woods Forests William L. Farr cc2.jpg',
                    _id: 'c4487674-81bf-4e7c-9915-103705e1f75c'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/32341de8-c78c-461a-b628-e8f8204ae3db/Bioregion%20map-NA28.jpg',
                content:
                  '<p>The Southern Mixed Forests bioregion, located in the Southeast U.S. Savannas &amp; Forests subrealm of Northern America, consists of a swathe of forests through eastern Texas surrounded on two sides by Blackland prairie, with a large area of pines to the north. The bioregion consists of three ecoregions \u2013 East Central Texas Savanna-Woodland (332), Piney Woods Forests (363), Texas Blackland Prairies (401) \u2013 and includes the Sabine River. The total area of this bioregion is approximately 25 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/32341de8-c78c-461a-b628-e8f8204ae3db/Bioregion%20map-NA28.jpg"/><figcaption><span class="caption"><p>The Southern Mixed Forests &amp; Blackland Prairies bioregion is part of the Southeast U.S. Savannas &amp; Forests subrealm and is made up of three ecoregions: (1) Texas Blackland Prairies (2) East Central Texas Savanna-Woodland (3) Piney Woods Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Southern Mixed Forests &amp; Blackland Prairies ecoregions below.</p>',
                ecoregions: [
                  { _id: '59780b8c-caee-4944-807f-4dfb4a5d4e31' },
                  { title: 'Texas Blackland Prairies' },
                  { regionId: '401' },
                  {
                    dek:
                      ' The northern portion encompasses the city of Dallas, whereas the narrow southern portion encompasses most of Austin and San Antonio. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ce8be044-cc03-4a71-a5d2-33d91c747633/401 Texas blackland prairies - USFWS.JPG',
                      _id: 'ce8be044-cc03-4a71-a5d2-33d91c747633'
                    }
                  },
                  { _id: '0144701c-6afd-4ac4-ace2-408bcaa7dd4e' },
                  { title: 'Piney Woods Forests' },
                  { regionId: '363' },
                  {
                    dek:
                      'This ecoregion occupies the West Gulf Coastal Plain and encompasses eastern Texas (including the \u201cBig Thicket\u201d) as well as western Louisiana, southwestern Arkansas, and a small portion of southeastern Oklahoma.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6ac7401f-4eb5-4a00-90ee-de7fc2ef7462/363 Piney Woods Forests - Reed Noss_resized.jpg',
                      _id: '6ac7401f-4eb5-4a00-90ee-de7fc2ef7462'
                    }
                  },
                  { _id: 'da9b36d1-a746-466d-87e9-df07fa7897be' },
                  { title: 'East Central Texas Savanna-Woodland' },
                  { regionId: '332' },
                  {
                    dek:
                      'This ecoregion is a relatively long (in latitude) but narrow ecoregion almost entirely confined to Texas, plus a small part of southeastern Oklahoma north of the Red River.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3f84a4dc-bc8b-4b28-901a-fe2dab0e4371/332 East Central Texas forests - Travis Witt.JPG',
                      _id: '3f84a4dc-bc8b-4b28-901a-fe2dab0e4371'
                    }
                  }
                ],
                stats: [
                  { number: '34,313 ', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '28%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Western Gulf Coastal Grasslands (NA27)',
                children: [],
                _id: '0b77640c-3dfc-485e-b256-822877e900e4',
                value: 1000,
                parentId: 'e3691cbf-37e5-4fae-89d4-1a9c894b04b4',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/12357f02-e5fc-4603-91ca-b5402bbd43d9/384 Western Gulf Coastal Grasslands William L. Farr cc.jpg',
                    _id: '12357f02-e5fc-4603-91ca-b5402bbd43d9'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a3b23aac-746a-4169-9bb2-8e77392ec765/384 Western Gulf Coastal Grasslands Katy Prairie Conservancy cc.jpeg',
                    _id: 'a3b23aac-746a-4169-9bb2-8e77392ec765'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/791e11d8-e593-4b89-9c70-2e4dd8b419f0/384 Western Gulf Coastal Grasslands William L Farr cc copy.jpg',
                    _id: '791e11d8-e593-4b89-9c70-2e4dd8b419f0'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f31fd03a-4614-4ae9-b9a2-913c6f2fc235/Bioregion%20map-NA27.jpg',
                content:
                  '<p>The Western Gulf bioregion is unique in the Northern America (Nearctic) realm as the only example of a subtropical grasslands biome. Situated within the Southeast U.S. Savannas &amp; Forests subrealm it runs along the coast of Texas and consists of one single ecoregion \u2013 Western Gulf Coastal Grasslands (384) \u2013 and includes the adjacent marine area in the Gulf of Mexico. Its land area is approximately 9 million hectares.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f31fd03a-4614-4ae9-b9a2-913c6f2fc235/Bioregion%20map-NA27.jpg"/><figcaption><span class="caption"><p>The Western Gulf Coastal Grasslands bioregion is part of the Southeast U.S. Savannas &amp; Forests subrealm and is made up of one ecoregion: (1) Western Gulf Coastal Grasslands.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Western Gulf Coastal Grasslands ecoregion below.</p>',
                ecoregions: [
                  { _id: 'b8553183-d3cc-4db0-85d8-ac872a611738' },
                  { title: 'Western Gulf Coastal Grasslands' },
                  { regionId: '384' },
                  {
                    dek:
                      'This ecoregion is part of the North American Coastal Plain, which in 2016 was formally recognized by the Critical Ecosystem Partnership Fund as the 36th global biodiversity hotspot.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/12357f02-e5fc-4603-91ca-b5402bbd43d9/384 Western Gulf Coastal Grasslands William L. Farr cc.jpg',
                      _id: '12357f02-e5fc-4603-91ca-b5402bbd43d9'
                    }
                  }
                ],
                stats: [
                  { number: '9,107', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '29%', item: 'Protection Target' },
                  { number: '6', item: 'Protection Level' }
                ]
              },
              {
                name: 'Bermuda (NA26) ',
                children: [],
                _id: '9c0c927e-c08a-4f09-8f75-01efe564ff7a',
                value: 1000,
                parentId: 'e3691cbf-37e5-4fae-89d4-1a9c894b04b4',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ce48be5e-77d7-4f10-9e71-4ba30f62087b/325 Bermuda subtropical conifer forests - Aodhdubh.jpg',
                    _id: 'ce48be5e-77d7-4f10-9e71-4ba30f62087b'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/22a39606-472c-447e-8d58-8e5493272a09/Bioregion%20map-NA26.jpg',
                content:
                  '<p>Bermuda is an island over 1000 km from the Atlantic seaboard, and as an outlying island covered with subtropical conifer forests, it is unique in the Northern America (Nearctic) realm. It consists of one single ecoregion \u2013 Bermuda Subtropical Conifer Forests (325) \u2013 and the marine areas surrounding the island. Its land area is approximately 4000 hectares.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/22a39606-472c-447e-8d58-8e5493272a09/Bioregion%20map-NA26.jpg"/><figcaption><span class="caption"><p>The Bermuda bioregion is part of the Southeast U.S. Savannas &amp; Forests subrealm and is made up of one ecoregion: (1) Bermuda Subtropical Conifer Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about &nbsp;the Bermuda ecoregion below.</p>',
                ecoregions: [
                  { _id: '51fc000d-9d42-418a-95e1-1687293bf0d0' },
                  { title: 'Bermuda Subtropical Conifer Forests' },
                  { regionId: '325' },
                  {
                    dek:
                      'The Bermuda Islands are an isolated, crescent-shaped chain of more than 150 limestone islands distinguished by the northernmost mangrove swamps and tropical coral reefs in the Atlantic Ocean.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ce48be5e-77d7-4f10-9e71-4ba30f62087b/325 Bermuda subtropical conifer forests - Aodhdubh.jpg',
                      _id: 'ce48be5e-77d7-4f10-9e71-4ba30f62087b'
                    }
                  }
                ],
                stats: [
                  { number: '4', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '1%', item: 'Protection Target' },
                  { number: 'N/A', item: 'Protection Level' }
                ]
              },
              {
                name: 'Southeast Savannas & Riparian Forests (NA25)',
                children: [],
                _id: '80fad2aa-0644-4403-83fe-4a1e7e345734',
                value: 1000,
                parentId: 'e3691cbf-37e5-4fae-89d4-1a9c894b04b4',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d590708a-b173-471a-aa41-23af200b403b/399_Longleaf Pine_2_Wikimedia Commons.jpg',
                    _id: 'd590708a-b173-471a-aa41-23af200b403b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a01a6405-1ea5-4b0b-b92d-7895f0345312/347-Pine Barrens-NJ-CC-2009.jpg',
                    _id: 'a01a6405-1ea5-4b0b-b92d-7895f0345312'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6d6e99bb-1d78-4164-9e04-01b15ce4ab40/393_Atlantic White Cedar _3_Wikimedia Commons_resized.jpg',
                    _id: '6d6e99bb-1d78-4164-9e04-01b15ce4ab40'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b8e1cad8-996c-43f7-bdae-a9a4879b3a84/Bioregion%20map-NA25.jpg',
                content:
                  '<p>The Southeast Savannas bioregion, located in the Northern America (Nearctic) realm, covers much of the Atlantic seaboard and the Southeast U.S. Savannas &amp; Forests subrealm. It consists predominantly of coastal and conifer savannas but includes the Atlantic coastal pine barrens in the north and the Mississippi lowland forests to the west. The bioregion contains four ecoregions \u2013 Mississippi Lowland Forests (337), Atlantic Coastal Pine Barrens (347), Mid-Atlantic US Coastal Savannas (393), Southeast US Conifer Savannas (399) \u2013 and includes adjacent marine areas in the Atlantic Ocean and the Gulf of Mexico, as well as the lower section of the Mississippi River. The total land area of this bioregion is approximately 73 million hectares.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b8e1cad8-996c-43f7-bdae-a9a4879b3a84/Bioregion%20map-NA25.jpg"/><figcaption><span class="caption"><p>The Southeast Savannas &amp; Riparian Forests bioregion is part of the Southeast U.S. Savannas &amp; Forests subrealm and is made up of four ecoregions: (1) Mississippi Lowland Forests (2) Southeast US Conifer Savannas (3) Mid-Atlantic US Coastal Savannas (4) Atlantic Coastal Pine Barrens.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Southeast Savannas &amp; Riparian Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'b1b36b37-396a-4754-8949-5f12de06891e' },
                  { title: 'Southeast US Conifer Savannas' },
                  { regionId: '399' },
                  {
                    dek:
                      'This ecoregion is the biologically richest portion of the North American Coastal Plain.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a8444185-fac7-4f61-b441-18024498ee0c/399 Southeast US conifer savannas - Reed Noss.jpg',
                      _id: 'a8444185-fac7-4f61-b441-18024498ee0c'
                    }
                  },
                  { _id: '48e56a3d-6c68-4c96-9375-36c23f0e1a9b' },
                  { title: 'Mid-Atlantic US Coastal Savannas' },
                  { regionId: '393' },
                  {
                    dek:
                      'This ecoregion is a northern extension of the vast Southeast US Conifer Savannas ecoregion. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a211d6a1-5cb7-4e26-b728-c75f276ba354/393 Mid-Atlantic US coastal savannas - Reed Noss_resized.jpg',
                      _id: 'a211d6a1-5cb7-4e26-b728-c75f276ba354'
                    }
                  },
                  { _id: '27da6f57-11e4-4660-99fe-2aab66fc8e25' },
                  { title: 'Atlantic Coastal Pine Barrens' },
                  { regionId: '347' },
                  {
                    dek:
                      'This ecoregion represents the northern end of the North American Coastal Plain geological region.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2fd971ef-a32f-4b9b-a6a6-fd40e7fe5f5f/347 Atlantic coastal pine barrens - David Mark.jpg',
                      _id: '2fd971ef-a32f-4b9b-a6a6-fd40e7fe5f5f'
                    }
                  },
                  { _id: 'b0782ef8-c63b-4602-8c5e-fec61fe6d819' },
                  { title: 'Mississippi Lowland Forests' },
                  { regionId: '337' },
                  {
                    dek:
                      'This ecoregion occupies the lower portion of this watershed, along the Mississippi River and its tributaries from the river mouth in Louisiana to the southern tip of Illinois. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4d50abdc-4cb9-478d-9646-6481e1b83c6f/337 Mississippi lowland forests - JamesDeMers.jpg',
                      _id: '4d50abdc-4cb9-478d-9646-6481e1b83c6f'
                    }
                  }
                ],
                stats: [
                  { number: '73,226', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '15%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'Ozarks Mixed Forests (NA22)',
                children: [],
                _id: '1759ae5a-7245-47df-be51-62d224faa4fa',
                value: 1000,
                parentId: 'e3691cbf-37e5-4fae-89d4-1a9c894b04b4',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6c07fa19-ce92-4c24-81bc-ae39df0e6b1f/341 Alberta-British Columbia Foothills Forests As2020sa cc.jpg',
                    _id: '6c07fa19-ce92-4c24-81bc-ae39df0e6b1f'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/46327f04-15f8-44cd-9cde-979ba6b26ebd/340 Ozark Highlands mixed forests - David Mark.jpg',
                    _id: '46327f04-15f8-44cd-9cde-979ba6b26ebd'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ac0ded7c-5e08-4c12-b0a8-db13fe69c609/Bioregion%20map-NA22.jpg',
                content:
                  '<p>The bioregion spanning the forests of the Ozark mountains and highlands, located in the Southeast U.S. Savannas &amp; Forests subrealm of Northern America, sits between the pine woods to the south and the central grassland-forest transition to the north, bordered to the east by the lower Mississippi valley. It contains two ecoregions \u2013 Ozark Highlands Mixed Forests (340), Ozark Mountain Forests (341) \u2013 and includes most of the Arkansas River. The total area of this bioregion is nearly 18 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ac0ded7c-5e08-4c12-b0a8-db13fe69c609/Bioregion%20map-NA22.jpg"/><figcaption><span class="caption"><p>The Ozarks Mixed Forests bioregion is part of the Southeast U.S. Savannas &amp; Forests subrealm and is made up of two ecoregions: (1) Ozark Mountain Forests (2) Ozark Highlands Mixed Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Ozarks Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '39773bf1-fdf0-460d-aa48-dffc92695491' },
                  { title: 'Ozark Mountain Forests ' },
                  { regionId: '341' },
                  {
                    dek:
                      'This ecoregion comprises the Boston Mountains (a deeply dissected plateau that forms the southwestern and highest portion of the Ozark Plateau), the Arkansas (River) Valley, and the Ouachita Mountains.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/15780af1-f3ce-41a7-96e0-d634a6140128/341 Ozark Mountain Forests - Reed Noss1_resized.jpg',
                      _id: '15780af1-f3ce-41a7-96e0-d634a6140128'
                    }
                  },
                  { _id: '8de4dc86-082b-4d15-8593-bf35e8e90c04' },
                  { title: 'Ozark Highlands Mixed Forests' },
                  { regionId: '340' },
                  {
                    dek:
                      'This ecoregion constitutes the western portion of the central hardwoods forest region of the United States, but as a transitional region between forest and prairie it also contains many types of grassland.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/46327f04-15f8-44cd-9cde-979ba6b26ebd/340 Ozark Highlands mixed forests - David Mark.jpg',
                      _id: '46327f04-15f8-44cd-9cde-979ba6b26ebd'
                    }
                  }
                ],
                stats: [
                  { number: '17,624', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '48%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Northern America',
            value: 1000
          },
          {
            _id: '1ea91d75-66a5-49c6-a58a-ff6f7ef0d65e',
            name: 'Mexican Drylands',
            children: [
              {
                name: 'Baja California & Southern Deserts (NA30)',
                children: [],
                _id: '3faa44c0-a74b-4718-bb4c-f88518822ba5',
                value: 1000,
                parentId: '1ea91d75-66a5-49c6-a58a-ff6f7ef0d65e',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8ba5cdaa-8fff-4bcf-9aa5-d4d138a1f310/435-Sonoran_Desert_-CC-2007.JPG',
                    _id: '8ba5cdaa-8fff-4bcf-9aa5-d4d138a1f310'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/371c363d-940b-47b8-b48c-983017261d99/435-Sonora desert-Eco435-CC-2006.JPG',
                    _id: '371c363d-940b-47b8-b48c-983017261d99'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f3219098-a072-4b2d-9a1a-65612009f88f/435-El Pinacate y Gran Desierto de Altar Biosphere Reserve, NW M\u00e9xico.-CC-2010.jpg',
                    _id: 'f3219098-a072-4b2d-9a1a-65612009f88f'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e72ca939-b9cf-401c-9bad-9fa92443108e/Bioregion%20map-NA30.jpg',
                content:
                  '<p>The Baja California bioregion, located within the larger Mexican Drylands subrealm of Northern America, includes most of the Baja Peninsula and the scorching deserts of southern California. The bioregion contains four ecoregions \u2013 Baja California Desert (426), Gulf of California Xeric Scrub (431), Mojave Desert (433), Sonoran Desert (435) \u2013 and adjacent marine areas in the Gulf of California and the Pacific Ocean. The total land area of this bioregion is approximately 45 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e72ca939-b9cf-401c-9bad-9fa92443108e/Bioregion%20map-NA30.jpg"/><figcaption><span class="caption"><p>The Baja California &amp; Southern Deserts bioregion is part of the Mexican Drylands subrealm and is made up of four ecoregions: (1) Mojave Desert (2) Sonoran Desert (3) Baja California Desert (4) Gulf of California Xeric Scrub.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Baja California &amp; Southern Deserts ecoregions below.</p>',
                ecoregions: [
                  { _id: '4ec2dcc4-3b44-4187-8a53-ec273643aa85' },
                  { title: 'Sonoran Desert' },
                  { regionId: '435' },
                  {
                    dek:
                      ' In addition to portions of Arizona and Sonora, the Sonoran Desert occupies southeastern California (south of the Mojave Desert) and northeastern Baja California. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/591e7163-a2ea-4db4-8279-716f39f54728/435-Saguaro_National_Park_-Eco435-CC-_Joe Parks-2012.jpg',
                      _id: '591e7163-a2ea-4db4-8279-716f39f54728'
                    }
                  },
                  { _id: 'd764095b-e6df-4314-b389-5eb6b0a1f3ea' },
                  { title: 'Mojave Desert' },
                  { regionId: '433' },
                  {
                    dek:
                      'This ecoregion covers southern Nevada and portions of western Arizona and southeastern California.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1bd59b49-2e5a-48c7-abb5-1f11e47a6e25/433_Joshua Tree_2.jpg',
                      _id: '1bd59b49-2e5a-48c7-abb5-1f11e47a6e25'
                    }
                  },
                  { _id: '4b9ac0b3-2489-4462-bb96-6a13bdc4d639' },
                  { title: 'Gulf of California Xeric Scrub' },
                  { regionId: '431' },
                  {
                    dek:
                      'This ecoregion stretches along the eastern coast of the Baja Peninsula, bordering the Gulf of California from Bufeo in the north to La Paz in the south.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e7db277a-4654-44a2-84a1-fd5c11ee24c9/431 Gulf of California xeric scrub - Eduardo Chavez.jpg',
                      _id: 'e7db277a-4654-44a2-84a1-fd5c11ee24c9'
                    }
                  },
                  { _id: '89a6569c-4b6f-4b7a-8d4f-7ae41f88f6c6' },
                  { title: 'Baja California Desert ' },
                  { regionId: '426' },
                  {
                    dek:
                      'This ecoregion is one of the wildest and most intact ecoregions in Mexico, occupying most of the Baja California Peninsula and almost all of its western portion in both the states of Baja California Norte and Baja California Sur. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cb044f6e-3572-4872-b1b6-f23f3d51cc0b/426 Baja California desert - Tomas Castelazo.jpg',
                      _id: 'cb044f6e-3572-4872-b1b6-f23f3d51cc0b'
                    }
                  }
                ],
                stats: [
                  { number: '45,428', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '56%', item: 'Protection Target' },
                  { number: '6', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Sierra Madre Forests & Mexican Drylands (NA29)',
                children: [],
                _id: '29d658ac-aa33-4944-8363-7f88be8bf3aa',
                value: 1000,
                parentId: '1ea91d75-66a5-49c6-a58a-ff6f7ef0d65e',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/01eeaf5c-40f8-42ee-9ced-c9b53bc48fcd/324-Jumping cholla-Found in eco324-Dave Pape-2007.jpg',
                    _id: '01eeaf5c-40f8-42ee-9ced-c9b53bc48fcd'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/070c1a68-eac8-439a-9cec-e9805b368410/326 Sierra Madre Occidental pine-oak forests - Rael.jpg',
                    _id: '070c1a68-eac8-439a-9cec-e9805b368410'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e3556df7-1527-4a30-afbe-7e7b35bbeb96/327-Mountains Pahuatlan-Eco327-CC-Alejandro Linares Garcia-2012.JPG',
                    _id: 'e3556df7-1527-4a30-afbe-7e7b35bbeb96'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/882eaca6-46a8-4d40-b9e8-2b9c0208ba78/428-Yucca, creosote, and mesquite typify the plants in the Chihuahuan Desert-VanHorn-TX-Eco 428-CC-2008.jpg',
                    _id: '882eaca6-46a8-4d40-b9e8-2b9c0208ba78'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1868c802-4ec6-4299-aa78-126af1db9bcf/437-Ciudad_Victoria,_TamaulipasEco437-CC-Amante Darmanin-2011_resized.jpg',
                    _id: '1868c802-4ec6-4299-aa78-126af1db9bcf'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/98e479d9-b597-4d07-94f7-b0c9a409bed4/Bioregion%20map-NA29.jpg',
                content:
                  '<p>The Sierra Madre bioregion, located in the Northern America (Nearctic) realm, covers the upper half of Mexico and consists of an array of different ecoregions that are tightly interconnected. The bioregion is dominated by desert and dry shrublands, but the eastern and western ranges of the Sierra Madres are covered with subtropical pine and oak forests. It contains eight ecoregions \u2013 Sonoran-Sinaloan Subtropical Dry Forest (324), Sierra Madre Occidental Pine-Oak Forests (326), Sierra Madre Oriental Pine-Oak Forests (327), Central Mexican Matorral (427), Chihuahuan Desert (428), Meseta Central Matorral (432), Tamaulipan Matorral (436), Tamaulipan Mezquital (437). The total land area of this bioregion is approximately 116 million hectares.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/98e479d9-b597-4d07-94f7-b0c9a409bed4/Bioregion%20map-NA29.jpg"/><figcaption><span class="caption"><p>The Sierra Madre Forests &amp; Mexican Drylands bioregion is part of the Mexican Drylands subrealm and is made up of eight ecoregions: (1) Sonoran-Sinaloan Subtropical Dry Forest (2) Sierra Madre Occidental Pine-Oak Forests (3) Chihuahuan Desert (4) Tamaulipan Mezquital (5) Sierra Madre Oriental Pine-Oak Forests (6) Tamaulipan Matorral (7) Meseta Central Matorral (8) Central Mexican Matorral.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Northern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Sierra Madre Forests &amp; Mexican Drylands ecoregions below.</p>',
                ecoregions: [
                  { _id: '2180e2e9-1842-49c3-b11c-08f8526244bd' },
                  { title: 'Tamaulipan Mezquital' },
                  { regionId: '437' },
                  {
                    dek:
                      'This ecoregion occupies the southwestern portion of the Gulf Coastal Plain in southern Texas and northeastern Mexico.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b18ba3ab-315f-41ee-8036-2fa98a2ed24b/437 Tamaulipan mezquital - Texas Parks _ Wildlife Department.jpg',
                      _id: 'b18ba3ab-315f-41ee-8036-2fa98a2ed24b'
                    }
                  },
                  { _id: 'ccc09dd7-0d77-41e7-bf9e-8fd665a65407' },
                  { title: 'Tamaulipan Matorral' },
                  { regionId: '436' },
                  {
                    dek:
                      'The Tamaulipan Matorral is a small ecoregion located in a transitional area between the Nearctic and Neotropic realms'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/90e23e68-15ab-4063-95bd-80a24d5fe26e/436 Tamaulipan matorral - XHUANX.jpg',
                      _id: '90e23e68-15ab-4063-95bd-80a24d5fe26e'
                    }
                  },
                  { _id: 'd24fa957-89c0-45e3-94b2-d1a6634795d9' },
                  { title: 'Meseta Central Matorral' },
                  { regionId: '432' },
                  {
                    dek:
                      'This ecoregion is an arid lowland plain separating the massive mountain ranges of the Sierra Madre.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6b3f502a-5e22-4af4-ac88-503c1a649b3a/432 Meseta Central matorral -No\u00e9 Gonz\u00e1lez-Gallegos.JPG',
                      _id: '6b3f502a-5e22-4af4-ac88-503c1a649b3a'
                    }
                  },
                  { _id: 'cf441a89-474d-4b10-a96f-072bb19e7600' },
                  { title: 'Chihuahuan Desert' },
                  { regionId: '428' },
                  {
                    dek:
                      'The Chihuahuan Desert, the largest and most biologically diverse North American desert, sprawls across southeastern Arizona, southern New Mexico, much of western Texas, and north-central Mexico. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/00bf5ddd-c5ee-4ac0-91c5-25c3270f64de/428-Chihuahuan_Desert_from_South_Rim_BIBE-CC-Davey Nin-2012.jpg',
                      _id: '00bf5ddd-c5ee-4ac0-91c5-25c3270f64de'
                    }
                  },
                  { _id: 'f83fd839-ec07-44f0-bc70-8a236916654f' },
                  { title: 'Central Mexican Matorral' },
                  { regionId: '427' },
                  {
                    dek:
                      'This ecoregion is a relatively flat desert, with elevations up to 2,000 m, surrounded by mountains and with mountain ranges embedded within it.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ae96ad07-2b9e-4312-bbdd-65e837a365b6/427 Central Mexican matorral - Comisi\u00f3n Mexicana de Filmaciones.jpg',
                      _id: 'ae96ad07-2b9e-4312-bbdd-65e837a365b6'
                    }
                  },
                  { _id: 'be3efee6-ccc6-4efd-b22f-f11492bbd552' },
                  { title: 'Sierra Madre Oriental Pine-Oak Forests' },
                  { regionId: '327' },
                  {
                    dek:
                      'This ecoregion extends from several isolated mountain ranges in the southwestern U.S., including the Davis and Chisos Mountains in the Big Bend area of Texas and the San Andres and Organ Mountains of southern New Mexico, south through several Mexican states to just northeast of Mexico City.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6d574e12-f191-45bc-8a80-06ab15bbf128/327 Sierra Madre Oriental pine-oak forests - cortesab.jpg',
                      _id: '6d574e12-f191-45bc-8a80-06ab15bbf128'
                    }
                  },
                  { _id: 'd3944ed9-88e2-42dc-ac84-a7e40cd650f9' },
                  { title: 'Sierra Madre Occidental Pine-Oak Forests' },
                  { regionId: '326' },
                  {
                    dek:
                      'Stretching from southeastern Arizona\u2019s \u201csky islands\u201d to just north of Guadalajara in Jalisco, this extensive ecoregion is one of the most species-rich in North America'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/70b50ba0-2dde-464a-966c-66316e449bd5/326-Sierra_Madre_Occidental-Eco 326-CC-Christian Frausto Bernal-2006.jpg',
                      _id: '70b50ba0-2dde-464a-966c-66316e449bd5'
                    }
                  },
                  { _id: 'af45f0d2-fc5a-4e48-9b4a-819e4400a7dc' },
                  { title: 'Sonoran-Sinaloan Subtropical Dry Forest ' },
                  { regionId: '324' },
                  {
                    dek:
                      'This ecoregion is transitional between the Nearctic Sonoran Desert to the north and west and the Neotropic Sinaloan Dry Forests to the south and east. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/156ed228-255a-4abe-a857-764f8e257b7a/324 Sonoran-Sinaloan subtropical dry forest - Tomas Castelazo.jpg',
                      _id: '156ed228-255a-4abe-a857-764f8e257b7a'
                    }
                  }
                ],
                stats: [
                  { number: '116,853', item: 'Total Land Area (1000 ha)' },
                  { number: '8', item: 'Number of Ecoregions' },
                  { number: '43%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level ' }
                ]
              }
            ],
            parentId: 'Northern America',
            value: 400
          }
        ],
        parentId: 'top',
        _id: 'Northern America',
        value: 1000
      },
      {
        name: 'Oceania',
        children: [
          {
            _id: '75edb79d-4c4e-49ed-97c3-8d6e5e25d818',
            name: 'Oceanic Islands',
            children: [
              {
                name: 'Hawai\u2019i Tropical Islands (OC11)',
                children: [],
                _id: '6f232572-96e7-4fa0-83cb-9eed4fe81b40',
                value: 1000,
                parentId: '75edb79d-4c4e-49ed-97c3-8d6e5e25d818',
                images: [
                  {
                    path:
                      "86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cdfc0339-92b9-4534-ac24-c7942de688b9/639 Hawai'i tropical high shrublands - Amelia Leubscher.jpg",
                    _id: 'cdfc0339-92b9-4534-ac24-c7942de688b9'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f6059746-bf82-4ba7-826d-ce86cee83ce0/641 Northwest Hawai_i scrub - Cindy Rehkemper USDI.jpg',
                    _id: 'f6059746-bf82-4ba7-826d-ce86cee83ce0'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7d7d6dc9-9fbc-451e-912e-7a0d8e175ab6/623-Waialeale-CC-2018_resized.jpg',
                    _id: '7d7d6dc9-9fbc-451e-912e-7a0d8e175ab6'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1e766852-ea09-43e2-8d10-20da70c14ebe/OC11-1200.png',
                content:
                  "<p>The Hawai\u2019i Tropical Islands bioregion is located in the Oceania realm and contains five ecoregions \u2013 Hawai'i Tropical Moist Forests [1], Hawai'i Tropical Dry Forests [2], Hawai'i Tropical High Shrublands [3], Hawai'i Tropical Low Shrublands [4], Northwest Hawai'i Scrub [5] \u2013 totaling over 1.5 million hectares of land area.</p>\n<figure><img src=\"https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1e766852-ea09-43e2-8d10-20da70c14ebe/OC11-1200.png\"/><figcaption><span class=\"caption\"><p>The Hawai\u2019i Tropical Islands bioregion is located in the Oceania realm and contains five ecoregions: Hawai'i Tropical Moist Forests [1], Hawai'i Tropical Dry Forests [2], Hawai'i Tropical High Shrublands [3], Hawai'i Tropical Low Shrublands [4], and Northwest Hawai'i Scrub [5].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Oceania. Visit the <a href=\"https://www.oneearth.org/projects/\" target=\"_blank\"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Hawai\u2019i Tropical Islands ecoregions below.</p>",
                ecoregions: [
                  { _id: 'c57dc251-063f-418d-b70a-ff7ef1e4e4fb' },
                  { title: "Northwest Hawai'I Scrub" },
                  { regionId: '641' },
                  {
                    dek:
                      'The far-flung chain of nine major islands extends approximately 1,600 km from rocky Nihoa in the southeast to low Kure Atoll. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f6059746-bf82-4ba7-826d-ce86cee83ce0/641 Northwest Hawai_i scrub - Cindy Rehkemper USDI.jpg',
                      _id: 'f6059746-bf82-4ba7-826d-ce86cee83ce0'
                    }
                  },
                  { _id: 'daa3d4fe-ddbe-48f5-8d29-5f9ea79239d9' },
                  { title: "Hawai'I Tropical Low Shrublands" },
                  { regionId: '640 ' },
                  {
                    dek:
                      'This ecoregion contains the driest of all lowland habitats in the archipelago. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eb1502ad-55b1-42b9-b962-9422a114c1c1/640 Hawai_i tropical low shrublands - Forest _ Kim Starr.jpg',
                      _id: 'eb1502ad-55b1-42b9-b962-9422a114c1c1'
                    }
                  },
                  { _id: '6c3a858d-d53f-44dd-8e6e-90bb295d1203' },
                  { title: "Hawai'i Tropical High Shrublands" },
                  { regionId: '639' },
                  {
                    dek:
                      'This ecoregion\u2019s alpine deserts, alpine grasslands, and sparse shrublands occur above 3,000 m up to 4,207 m and only support a few hardy drought- and cold-adapted species.'
                  },
                  {
                    image: {
                      path:
                        "86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cdfc0339-92b9-4534-ac24-c7942de688b9/639 Hawai'i tropical high shrublands - Amelia Leubscher.jpg",
                      _id: 'cdfc0339-92b9-4534-ac24-c7942de688b9'
                    }
                  },
                  { _id: 'be0fc8c2-81f7-4a8f-9457-5acc61ea96ea' },
                  { title: "Hawai'I Tropical Dry Forests" },
                  { regionId: '636' },
                  {
                    dek:
                      'The leeward side of the main islands of Hawai\u2019i are drier as the central ranges and large volcanoes capture much of the rain brought by the trade winds.'
                  },
                  {
                    image: {
                      path:
                        "86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6cd6f09a-52cb-4ad5-a50e-70b5d8846e38/636 Hawai'i tropical dry forests - Arthur Madeiros.JPG",
                      _id: '6cd6f09a-52cb-4ad5-a50e-70b5d8846e38'
                    }
                  },
                  { _id: '0d3a0295-33d1-46b0-abc0-aad6bfeeb6ba' },
                  { title: "Hawai'I Tropical Moist Forests" },
                  { regionId: '623' },
                  {
                    dek:
                      "Tropical moist forests of Hawai'i occur as mixed mesic forests, rain forests, wet shrublands, and bogs in swampy areas."
                  },
                  {
                    image: {
                      path:
                        "86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/114e05f6-84ee-4266-85a0-6e35c8f79fd6/623 Hawai'i tropical moist forests - D Olson_resized.jpg",
                      _id: '114e05f6-84ee-4266-85a0-6e35c8f79fd6'
                    }
                  }
                ],
                stats: [
                  { number: '1,680', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '60', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Guam & Marianas Dry Tropical Islands (OC9)',
                children: [],
                _id: '969c55e9-329a-45b7-a322-8ebd27becf5d',
                value: 1000,
                parentId: '75edb79d-4c4e-49ed-97c3-8d6e5e25d818',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3507b493-7937-4bcb-9e52-c01cd2743978/Guam & Marianas Dry Tropical Islands.jpeg',
                    _id: '3507b493-7937-4bcb-9e52-c01cd2743978'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/48775ff6-204d-4286-b7d7-e36cd64ffb2d/OC9-1200.png',
                content:
                  '<p>The Guam &amp; Marianas Dry Tropical Islands bioregion is located in the Oceania realm and contains one ecoregion \u2013 Marianas Tropical Dry Forests [1] \u2013 totaling approximately 104 thousand hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/48775ff6-204d-4286-b7d7-e36cd64ffb2d/OC9-1200.png"/><figcaption><span class="caption"><p>The Guam &amp; Marianas Dry Tropical Islands bioregion is located in the Oceania realm and contains one ecoregion: Marianas Tropical Dry Forests [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Oceania. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Guam &amp; Marianas Dry Tropical Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: '1ac0f38b-eb63-4623-83f7-83c7ac698fce' },
                  { title: 'Marianas Tropical Dry Forests' },
                  { regionId: '637' },
                  { dek: 'The Mariana Islands cover a 900 km arc in the western Pacific Ocean. ' },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f645e0be-0448-4416-a8c2-e2c322ac2523/637 Marianas Tropical Dry Forests cc.jpeg',
                      _id: 'f645e0be-0448-4416-a8c2-e2c322ac2523'
                    }
                  }
                ],
                stats: [
                  { number: '104', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '90%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Palau & Caroline Tropical Islands (OC8)',
                children: [],
                _id: '61008762-3189-4bc3-aa82-0ac236ff243b',
                value: 1000,
                parentId: '75edb79d-4c4e-49ed-97c3-8d6e5e25d818',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ffa4ca98-c887-4e2d-b87f-28b488eea1e1/618-Strawn_Island_at_Palmyra_Atoll-CC-USFWS-2010.jpg',
                    _id: 'ffa4ca98-c887-4e2d-b87f-28b488eea1e1'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/90127115-fb7e-4753-943d-75389d44fddf/627 Palau tropical moist forests - Jay Park.jpg',
                    _id: '90127115-fb7e-4753-943d-75389d44fddf'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/49d9be6f-4a04-4f26-9ec6-7026d04f5084/638 Yap tropical dry forests - Pacific Worlds Yap-Ulithi.jpg',
                    _id: '49d9be6f-4a04-4f26-9ec6-7026d04f5084'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a89abbb8-a49d-4af2-b017-f6ee987bca2f/OC8-1200.png',
                content:
                  '<p>The Palau &amp; Caroline Tropical Islands bioregion is located in the Oceania realm and contains three ecoregions \u2013 Carolines Tropical Moist Forests [1], Palau Tropical Moist Forests [2], Yap Tropical Dry Forests [3] \u2013 totaling approximately 114 thousand hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a89abbb8-a49d-4af2-b017-f6ee987bca2f/OC8-1200.png"/><figcaption><span class="caption"><p>The Palau &amp; Caroline Tropical Islands bioregion is located in the Oceania realm and contains three ecoregions: Carolines Tropical Moist Forests [1], Palau Tropical Moist Forests[2], and Yap Tropical Dry Forests [3].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Oceania. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Palau &amp; Caroline Tropical Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: '7f0e227f-2aeb-4e02-8fb0-ebd80530b86b' },
                  { title: 'Yap Tropical Dry Forests' },
                  { regionId: '638' },
                  { dek: 'The Yap Islands group is located about 450 km northeast of Palau.' },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/49d9be6f-4a04-4f26-9ec6-7026d04f5084/638 Yap tropical dry forests - Pacific Worlds Yap-Ulithi.jpg',
                      _id: '49d9be6f-4a04-4f26-9ec6-7026d04f5084'
                    }
                  },
                  { _id: '54ad1790-cefc-4147-ab15-1e7fd5bcbebf' },
                  { title: 'Palau Tropical Moist Forests' },
                  { regionId: '627' },
                  {
                    dek:
                      'An incredible 586 islands make up the archipelago of Palau in western Micronesia. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/90127115-fb7e-4753-943d-75389d44fddf/627 Palau tropical moist forests - Jay Park.jpg',
                      _id: '90127115-fb7e-4753-943d-75389d44fddf'
                    }
                  },
                  { _id: '695ad14d-f74c-432c-a530-64e7ee666b15' },
                  { title: 'Carolines Tropical Moist Forests' },
                  { regionId: '618' },
                  {
                    dek:
                      'The Caroline Islands includes the Remetau Group, Chuuk, Pohnpei, and Kosrae.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c92e4801-d190-4b96-8255-5535df57f27e/618 Carolines tropical moist forests - Maloff1.jpg',
                      _id: 'c92e4801-d190-4b96-8255-5535df57f27e'
                    }
                  }
                ],
                stats: [
                  { number: '114', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '88%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              },
              {
                name: 'Fiji & Tongan Tropical Islands (OC6)',
                children: [],
                _id: 'c7a65d33-2546-46b1-b02a-4d23ebaf7e12',
                value: 1000,
                parentId: '75edb79d-4c4e-49ed-97c3-8d6e5e25d818',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a12e75e2-f531-403c-b6af-0dfce87f2020/Fiji_tropical_dry_forests_Rickard T\u00f6rnblad_cc.jpg',
                    _id: 'a12e75e2-f531-403c-b6af-0dfce87f2020'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/98f161bf-5814-4b43-87f2-ec2d225c06b5/Fiji_tropical_moist_forests_Jaejay77_cc.jpg',
                    _id: '98f161bf-5814-4b43-87f2-ec2d225c06b5'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b10c29af-9b7b-448e-bd63-40a169c6469a/OC6-1200.png',
                content:
                  '<p>The Fiji &amp; Tongan Tropical Islands bioregion is located in the Oceania realm and contains three ecoregions \u2013 Fiji Tropical Moist Forests [1], Tongan Tropical Moist Forests [2], Fiji Tropical Dry Forests [3] \u2013 totaling approximately 2 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b10c29af-9b7b-448e-bd63-40a169c6469a/OC6-1200.png"/><figcaption><span class="caption"><p>The Fiji &amp; Tongan Tropical Islands bioregion is located in the Oceania realm and contains three ecoregions: Fiji Tropical Moist Forests [1], Tongan Tropical Moist Forests [2], and Fiji Tropical Dry Forests [3].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Oceania. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Fiji &amp; Tongan Tropical Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: '0e8026d5-f30b-49ce-915e-f193c072ff83' },
                  { title: 'Fiji Tropical Dry Forests' },
                  { regionId: '635' },
                  {
                    dek:
                      'Viti Levu and Vanua Levu, the two biggest islands in Fiji, has about a third of their land area covered in dry forest along each of their northwest lowlands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ccfe9d7d-08a8-4cde-8696-b1f85f234997/fiji-tropical-dry-forests-Di Mark Heard-cc.jpg',
                      _id: 'ccfe9d7d-08a8-4cde-8696-b1f85f234997'
                    }
                  },
                  { _id: '083973dc-f798-446e-a70a-f0f2cc2dc635' },
                  { title: 'Tongan Tropical Moist Forests' },
                  { regionId: '631' },
                  {
                    dek:
                      "Tongan islands are volcanic, though the southern island of 'Eua is believed to be a fragment of the ancient Gondwanaland supercontinent and may harbor some ancient invertebrates and plants."
                  },
                  {
                    image: {
                      path:
                        "86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1a32b4ea-c961-4ee6-8942-580d05433a13/631 Tongan tropical moist forests - Tau'olungu 1.jpg",
                      _id: '1a32b4ea-c961-4ee6-8942-580d05433a13'
                    }
                  },
                  { _id: '86bfa4bc-8874-4414-a28c-8798fe7b821e' },
                  { title: 'Fiji Tropical Moist Forests' },
                  { regionId: '622' },
                  {
                    dek:
                      'Out of over 300 islands, the islands of Viti Levu and Vanua Levu occupy 78% of the ecoregion\u2019s land area and support the tallest mountain at 1,323 m. '
                  },
                  {
                    image: {
                      path:
                        "86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/caa21140-e9de-408d-8593-dd5f990c28c7/622 Fiji tropical moist forests - M Tokatoa'a.jpg",
                      _id: 'caa21140-e9de-408d-8593-dd5f990c28c7'
                    }
                  }
                ],
                stats: [
                  { number: '1,951', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '67%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              },
              {
                name: 'Samoa & West Polynesian Tropical Islands (OC5)',
                children: [],
                _id: '14278f32-15db-41ae-aaf0-0adbfb5885ad',
                value: 1000,
                parentId: '75edb79d-4c4e-49ed-97c3-8d6e5e25d818',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2318e84c-4516-4802-b9f6-8f1bef5f06c5/Samoan_tropical_moist_forests_Teinesavaii_cc.jpeg',
                    _id: '2318e84c-4516-4802-b9f6-8f1bef5f06c5'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/234e1cc0-1ee5-4ff4-9976-d421b96703aa/OC5-1200.png',
                content:
                  '<p>The Samoa &amp; West Polynesian Tropical Islands bioregion is located in the Oceania realm and contains two ecoregions \u2013 Samoan Tropical Moist Forests [1], &nbsp;Western Polynesian Tropical Moist Forests [2] &nbsp;\u2013 totaling approximately 319 thousand hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/234e1cc0-1ee5-4ff4-9976-d421b96703aa/OC5-1200.png"/><figcaption><span class="caption"><p>The Samoa &amp; West Polynesian Tropical Islands bioregion is located in the Oceania realm and contains two ecoregions: Samoan Tropical Moist Forests [1] and Western Polynesian Tropical Moist Forests [2].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Oceania. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Samoa &amp; West Polynesian Tropical Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'f3ea73a9-624e-4b89-a1db-b8a337fcee77' },
                  { title: 'Western Polynesian Tropical Moist Forests' },
                  { regionId: '634' },
                  {
                    dek:
                      'The ecoregion has three clusters of atolls and makatea islands (uplifted reefs): 8 atolls in the Phoenix Islands; 4 in Tokelau; and 9 in Tuvalu. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/956d0ec7-d546-4fa2-b1bc-5aed6046068b/634 Western Polynesian tropical moist forests - Angela K Kepler.jpg',
                      _id: '956d0ec7-d546-4fa2-b1bc-5aed6046068b'
                    }
                  },
                  { _id: '847233b7-cee9-489f-8fa9-7c4456da6f94' },
                  { title: 'Samoan Tropical Moist Forests' },
                  { regionId: '629' },
                  {
                    dek:
                      'Samoa consists of a chain of 14 volcanic islands located 600 km east of Fiji. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/69db3208-d43a-4d2b-9675-a4bd0dd89138/629 Samoan tropical moist forests - James Atherton.jpg',
                      _id: '69db3208-d43a-4d2b-9675-a4bd0dd89138'
                    }
                  }
                ],
                stats: [
                  { number: '319', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '53%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Central Polynesian Islands (OC4)',
                children: [],
                _id: 'f46c3dd3-21e5-4e25-b251-150631305ddb',
                value: 1000,
                parentId: '75edb79d-4c4e-49ed-97c3-8d6e5e25d818',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f0d3e980-609c-4d1c-80bb-f5c25e4da1d1/CentralPolynesian TropicalMoistF.jpg',
                    _id: 'f0d3e980-609c-4d1c-80bb-f5c25e4da1d1'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a03043da-1ede-4473-b26a-8504b11b411d/OC4-1200.png',
                content:
                  '<p>The Central Polynesian Islands bioregion is located in the Oceania realm and contains one ecoregion \u2013 Central Polynesian Tropical Moist Forests [1] \u2013 totaling approximately 62 thousand hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a03043da-1ede-4473-b26a-8504b11b411d/OC4-1200.png"/><figcaption><span class="caption"><p>TheCentral Polynesian Islands bioregion is part of the Oceania subrealm and is made up of one ecoregion: Central Polynesian Tropical Moist Forests [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Oceania. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Central Polynesian Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: '56224e76-c788-4b7e-b0f0-28e9cba52cda' },
                  { title: 'Central Polynesian Tropical Moist Forests' },
                  { regionId: '619' },
                  {
                    dek:
                      'This ecoregion encompasses the Northern Line Islands, Southern Line Islands, and Northern Cook Islands. Isolated Johnston is also included in this ecoregion. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e120e1b8-1784-408a-8046-00933d13059e/619-CentralPolynesianTropicalMoistForests-WikiCommons2.jpg',
                      _id: 'e120e1b8-1784-408a-8046-00933d13059e'
                    }
                  }
                ],
                stats: [
                  { number: '62', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '15%', item: 'Protection Target' },
                  { number: '10', item: 'Protection Level' }
                ]
              },
              {
                name: 'Southeast Polynesian Islands (OC3)',
                children: [],
                _id: 'cb0861df-b51a-4c3d-97f5-8fc1fc8845a8',
                value: 1000,
                parentId: '75edb79d-4c4e-49ed-97c3-8d6e5e25d818',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d16abfb7-275f-43ec-82f9-12151d2c983a/620 Cook Islands tropical moist forests - Robert Issell.jpg',
                    _id: 'd16abfb7-275f-43ec-82f9-12151d2c983a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7c106a81-cc5d-4541-8703-a9d8ba9c0ae9/620-Aitutaki-Motu_Tapuaetai-CC-2002.jpg',
                    _id: '7c106a81-cc5d-4541-8703-a9d8ba9c0ae9'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/432b5b3d-08a5-4a57-9603-74ad74feef34/630-Bora-Bora_-CC-Remi Jouan-2009.JPG',
                    _id: '432b5b3d-08a5-4a57-9603-74ad74feef34'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5c185fe2-ef94-4efb-a57f-5b5dc4bdadf2/630-Moorea_-CC-Remi Jouan-2009.JPG',
                    _id: '5c185fe2-ef94-4efb-a57f-5b5dc4bdadf2'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b24ecaa6-20f7-4c51-9589-e4c107106883/OC3-1200.png',
                content:
                  '<p>The Southeast Polynesian Islands bioregion is located in the Oceania realm and contains four ecoregions \u2013 Cook Islands Tropical Moist Forests [1], Society Islands Tropical Moist Forests [2], Tuamotu Tropical Moist Forests [3], Tubuai Tropical Moist Forests [4] &nbsp;\u2013 totaling approximately 293 thousand hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b24ecaa6-20f7-4c51-9589-e4c107106883/OC3-1200.png"/><figcaption><span class="caption"><p>The Southeast Polynesian Islands bioregion is part of the Oceania subrealm and is made up of four ecoregions: Cook Islands Tropical Moist Forests [1], Society Islands Tropical Moist Forests [2], Tuamotu Tropical Moist Forests [3], Tubuai Tropical Moist Forests [4].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Oceania. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Southeast Polynesian Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: '526fdfcf-2dcd-43f7-b4a7-fdfcaea3e932' },
                  { title: 'Tubuai Tropical Moist Forests' },
                  { regionId: '633' },
                  {
                    dek:
                      'Like the Society Islands to the north, the Tubuai Islands are eroded volcanic peaks that are surrounded by uplifted limestone reef.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/10334c3e-e2eb-486d-b52f-6c6133e61e12/633-Tubuai_depuis_le_motu_Mitiha-CC-Jeremie Silvestro-2015.jpg',
                      _id: '10334c3e-e2eb-486d-b52f-6c6133e61e12'
                    }
                  },
                  { _id: 'd49a1235-f458-4f87-b22f-fe01281bb476' },
                  { title: 'Tuamotu Tropical Moist Forests' },
                  { regionId: '632' },
                  {
                    dek:
                      'This vast ecoregion encompasses the 76 atolls and islands of Tuamotu, and stretches 1,800 km to the Gambier Islands and the Pitcairn Islands 1,000 km to the east.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c353516b-3146-49ac-b515-6136dd9f854b/632 Tuamotu tropical moist forests - Mark Van Beirs Birdquest.jpg',
                      _id: 'c353516b-3146-49ac-b515-6136dd9f854b'
                    }
                  },
                  { _id: 'bc53279f-f8b1-46cc-83d5-002712a3450e' },
                  { title: 'Society Islands Tropical Moist Forests' },
                  { regionId: '630 ' },
                  {
                    dek:
                      'These verdant islands are covered in lowland rain forest, montane rain forest, and, at the highest points, cloud forest.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/50041550-1c5d-4528-9a0e-67322f1f39e9/630 Society Islands tropical moist forests - Yanik1214.jpg',
                      _id: '50041550-1c5d-4528-9a0e-67322f1f39e9'
                    }
                  },
                  { _id: 'ba1aaba8-d8c7-4992-a6ac-abf261d72b3e' },
                  { title: 'Cook Islands Tropical Moist Forests' },
                  { regionId: '620' },
                  {
                    dek:
                      'The Cook Islands, one of the most remote archipelagos in the world, are home to some of the planet\u2019s most dazzling birds.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/623007bd-6205-4419-938c-964d046319c5/601 Gal\u00e1pagos Islands xeric scrub - peterstuartmill.jpg',
                      _id: '623007bd-6205-4419-938c-964d046319c5'
                    }
                  }
                ],
                stats: [
                  { number: '293', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '62%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              },
              {
                name: 'Marquesas Tropical Islands (OC2)',
                children: [],
                _id: '258dc6fa-ad9a-4b7d-abff-ea283b99249b',
                value: 1000,
                parentId: '75edb79d-4c4e-49ed-97c3-8d6e5e25d818',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/419e1ce5-98ba-495c-8b21-c2a4ef8743f3/625-Hatiheu_Bay,_Nuku_Hiva_(French_Polynesia)-CC-Steve Berardi-2009_resized.jpg',
                    _id: '419e1ce5-98ba-495c-8b21-c2a4ef8743f3'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fa22ff8d-0ab9-44dd-9253-d8b6a12702f4/625-Vegetation at Hiva Oa-CC-2006_resized.jpg',
                    _id: 'fa22ff8d-0ab9-44dd-9253-d8b6a12702f4'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d23dd596-e420-46c9-85e2-66cbab1d1ec8/OC2-1200.png',
                content:
                  '<p>The Marquesas Tropical Islands bioregion is located in the Oceania realm and contains one ecoregion \u2013 Marquesas Tropical Moist Forests [1] &nbsp;\u2013 totaling approximately 108 thousand hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d23dd596-e420-46c9-85e2-66cbab1d1ec8/OC2-1200.png"/><figcaption><span class="caption"><p>The Marquesas Tropical Islands bioregion is part of the Oceania subrealm and is made up of one ecoregion: Marquesas Tropical Moist Forests [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Oceania. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Marquesas Tropical Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: '9eb22675-1bb4-4e58-bb5e-a20b922f97e0' },
                  { title: 'Marquesas Tropical Moist Forests' },
                  { regionId: '625' },
                  {
                    dek:
                      'The 12 Marquesas Islands are volcanic high islands with very rugged topography, knife-edged ridges, deeply dissected gorges, and cliffs plunging from mountaintops steeply to sea level. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9246d4c5-96aa-42be-b037-6d3b56e0127b/625 Marquesas tropical moist forests - Jack Grove.jpg',
                      _id: '9246d4c5-96aa-42be-b037-6d3b56e0127b'
                    }
                  }
                ],
                stats: [
                  { number: '108', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '83%', item: 'Protection Target' },
                  { number: '0', item: 'Protection Level' }
                ]
              },
              {
                name: 'Salas y G\u00f3mez & Easter Islands (OC1)',
                children: [],
                _id: 'fb479e61-a12e-467a-8a5e-b68abd7b1996',
                value: 1000,
                parentId: '75edb79d-4c4e-49ed-97c3-8d6e5e25d818',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/16866395-b364-4eab-bce3-a83e1beb5644/628 Rapa Nui and Sala y G\u00f3mez subtropical forests - kai2015.jpg',
                    _id: '16866395-b364-4eab-bce3-a83e1beb5644'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2620f329-cc05-4284-9f4e-9fb2ddc42e7d/OC1-1200.png',
                content:
                  '<p>The Salas y G\u00f3mez &amp; Easter Islands bioregion is located in the Oceania realm and contains one ecoregion \u2013 Rapa Nui and Sala y G\u00f3mez Subtropical Broadleaf Forests [1] \u2013 totaling approximately 18 thousand hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2620f329-cc05-4284-9f4e-9fb2ddc42e7d/OC1-1200.png"/><figcaption><span class="caption"><p>The Salas y G\u00f3mez &amp; Easter Islands bioregion is located in the Oceania realm and contains one ecoregion: Rapa Nui and Sala y G\u00f3mez Subtropical Broadleaf Forests [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Oceania. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Salas y G\u00f3mez &amp; Easter Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: 'a13759f6-8081-46bb-bce9-9baa95f61fda' },
                  { title: 'Rapa Nui and Sala Y G\u00f3mez Subtropical Broadleaf Forests' },
                  { regionId: '628' },
                  {
                    dek:
                      'This isolated volcanic island in the eastern Pacific supported a simple and  unique ecosystem until Polynesians arrived thousands of years ago and transformed it to grass savannas.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/530971ba-fb19-43a1-8dca-921dbdebbcc3/628-Rapa-Nui-Landscape-CC-Bj\u00f8rn Christian T\u00f8rrissen-2013_resized.jpg',
                      _id: '530971ba-fb19-43a1-8dca-921dbdebbcc3'
                    }
                  }
                ],
                stats: [
                  { number: '18', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '100%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Ogasawara Subtropical Islands (OC10)',
                children: [],
                _id: 'daf51578-544f-44bc-b71b-a8f157d23e3e',
                value: 1000,
                parentId: '75edb79d-4c4e-49ed-97c3-8d6e5e25d818',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7b30957d-e1dc-4aeb-8e07-b3e51311079d/Ogasawara Subtropical Moist Forests Anagounagi, Creative Commons.jpg',
                    _id: '7b30957d-e1dc-4aeb-8e07-b3e51311079d'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f8408ddc-933b-4f30-949e-52ef28914a49/OC10-1200.png',
                content:
                  '<p>The Ogasawara Subtropical Islands bioregion is located in the Oceania realm and contains a single ecoregion \u2013 Ogasawara Subtropical Moist Forests [1] \u2013 totaling approximately 10 thousand hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f8408ddc-933b-4f30-949e-52ef28914a49/OC10-1200.png"/><figcaption><span class="caption"><p>The Ogasawara Subtropical Islands bioregion is located in the Oceania realm and contains a single ecoregion: Ogasawara Subtropical Moist Forests [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Oceania. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong> </a>to explore projects in this realm that need your support. Learn more about the Ogasawara Subtropical Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: 'beccd078-19b1-40b6-a23d-d79bbcced590' },
                  { title: 'Ogasawara Subtropical Moist Forests' },
                  { regionId: '626' },
                  {
                    dek:
                      'The Ogawasara (or Bonin) and Iwo (or Volcano) Islands are a widely scattered archipelago of 20 major volcanic islands once covered in subtropical moist and dry forests. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0cd039ec-339b-4f29-bb68-1a3dd28346f7/626 Ogasawara subtropical moist forests - Kzaral.jpg',
                      _id: '0cd039ec-339b-4f29-bb68-1a3dd28346f7'
                    }
                  }
                ],
                stats: [
                  { number: '10', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '80%', item: 'Protection Target' },
                  { number: '10', item: 'Protection Level' }
                ]
              },
              {
                name: 'East Micronesian Islands (OC7)',
                children: [],
                _id: 'ae1b0121-75a1-4f01-a0af-34e32d7a90b7',
                value: 1000,
                parentId: '75edb79d-4c4e-49ed-97c3-8d6e5e25d818',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5b25ad15-06ad-4c6c-b4e0-83c6fd4273ac/1440px-Onotoa.png',
                    _id: '5b25ad15-06ad-4c6c-b4e0-83c6fd4273ac'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/98f65bd3-0784-406c-ac45-437db28a400e/OC7-1200.png',
                content:
                  '<p>The East Micronesian Islands bioregion is located in the Oceania realm and contains one ecoregion \u2013 Eastern Micronesia Tropical Moist Forests [1] \u2013 totaling approximately 53 thousand hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/98f65bd3-0784-406c-ac45-437db28a400e/OC7-1200.png"/><figcaption><span class="caption"><p>The East Micronesian Islands bioregion is located in the Oceania realm and contains one ecoregion: Eastern Micronesia Tropical Moist Forests [1].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Oceania. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the East Micronesian Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: '17762dd3-9e63-4a8a-abf6-49ca26d8224e' },
                  { title: 'Eastern Micronesia Tropical Moist Forests' },
                  { regionId: '621' },
                  {
                    dek:
                      'Low atolls scattered across the central Pacific comprise this ecoregion, with Wake Island and Nauru as single-island outliers, and the Marshall Islands and Kiribati archipelagos of many islands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8158e809-29ef-4289-8478-02f0da14c9fd/621 Eastern Micronesia tropical moist forests - Peter Mellow.jpg',
                      _id: '8158e809-29ef-4289-8478-02f0da14c9fd'
                    }
                  }
                ],
                stats: [
                  { number: '53', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '9%', item: 'Protection Target' },
                  { number: '9', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Oceania',
            value: 1000
          }
        ],
        parentId: 'top',
        _id: 'Oceania',
        value: 166
      },
      {
        name: 'Southern America',
        children: [
          {
            _id: '1a6917fe-fd56-44f1-aaa6-68ac58d7650f',
            name: 'Andes & Pacific Coast',
            children: [
              {
                name: 'Andean Mountain Forests & Valleys (NT11)',
                children: [],
                _id: 'b4458504-35cd-4a0b-88fa-9d534c0ff7db',
                value: 1000,
                parentId: '1a6917fe-fd56-44f1-aaa6-68ac58d7650f',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4a017d35-695d-441c-bf6a-a1cf31ca6435/486-Laguna_de_Cuicocha-Eco486-CC-Bernard Gagnon-2014_resized.jpg',
                    _id: '4a017d35-695d-441c-bf6a-a1cf31ca6435'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0016fd04-11a1-4ae9-90c3-90faa2031982/504-Tafi del Valle-Southern Andean Yungas-Argentina-Eco-504-3-CC-Miguel Vieira-2011_resized.jpg',
                    _id: '0016fd04-11a1-4ae9-90c3-90faa2031982'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c01225b9-fbfd-466a-9b08-14d394fac64f/504-Tafi del Valle-Southern Andean Yungas-Argentina-Eco-504-CC-Miguel Vieira-2011.jpg',
                    _id: 'c01225b9-fbfd-466a-9b08-14d394fac64f'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cdfeb42e-b1e1-4717-8d28-2291dccff697/513-Sierra_de_la_Culata in Eco513-CC-2011_resized.jpg',
                    _id: 'cdfeb42e-b1e1-4717-8d28-2291dccff697'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5fc0ad29-89f4-4b33-93a5-6610d01e9a5e/538-The_Tatacoa_Desert_Eco538-CC-Jorge Lascar-2010_resized.jpg',
                    _id: '5fc0ad29-89f4-4b33-93a5-6610d01e9a5e'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/720b6d9b-6cc5-4901-b93f-a1d27919cfc2/590-Cordillera of Cajamarca-Eco590-CC-Patricio Mena Vasconez-2004.JPG',
                    _id: '720b6d9b-6cc5-4901-b93f-a1d27919cfc2'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/56930e08-c067-4fc8-8103-aa5759461104/593-Crested Roses (Espeletia) in the P\u00e1ramo de Guerrero of Colombia-Eco 593-CC-Friedrich Kircher-2008.JPG',
                    _id: '56930e08-c067-4fc8-8103-aa5759461104'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/510361a2-dad1-4f71-8810-a73df3d152fb/Bioregion%20map-NT11-rev.jpg',
                content:
                  '<p>The Andean Mountain bioregion, located in the Southern America (Neotropical) realm, is the upper half of the Andes mountain range, stretching from the very top of the continent to northern Argentina. The bioregion is defined by tropical and subtropical broadleaf forests with 17 unique ecoregions \u2013 Bolivian Yungas (444), Cauca Valley Montane Forests (448), Cordillera Oriental Montane Forests (457), Eastern Cordillera Real Montane Forests (460), Magdalena Valley Montane Forests (477), Mara\u00f1\u00f3n Dry Forests (479), Northwest Andean Montane Forests (486), Peruvian Yungas (493), Southern Andean Yungas (504), Venezuelan Andes Montane Forests (513), Bolivian Montane Dry Forests (523), Cauca Valley Dry Forests (526), Magdalena Valley Dry Forests (538), Patia Valley Dry Forests (542), Cordillera Central P\u00e1ramo (590), Cordillera De Merida P\u00e1ramo (591), Northern Andean P\u00e1ramo (593) \u2013 which run along the more humid eastern side of the Andes. This bioregion contains the three sacred headwaters of the Amazon River. Its land area is approximately 93 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/510361a2-dad1-4f71-8810-a73df3d152fb/Bioregion%20map-NT11-rev.jpg"/><figcaption><span class="caption"><p>The Andean Mountain Forests &amp; Valleys bioregion is part of the Andes &amp; Pacific Coast subrealm and is made up of 17 ecoregions: (1) Southern Andean Yungas (2) Bolivian Montane Dry Forests (3) Bolivian Yungas (4) Peruvian Yungas (5) Cordillera Central P\u00e1ramo (6) Mara\u00f1\u00f3n Dry Forests (7) Eastern Cordillera Real Montane Forests (8) Northern Andean P\u00e1ramo (9) Patia Valley Dry Forests (10) Northwest Andean Montane Forests (11) Magdalena Valley Montane Forests (12) Magdalena Valley Dry Forests (13) Cauca Valley Dry Forests (14) Cauca Valley Montane Forests (15) Cordillera Oriental Montane Forests (16) Cordillera De Merida P\u00e1ramo (17) Venezuelan Andes Montane Forests.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Andean Mountain Forests &amp; Valleys ecoregions below.</p>',
                ecoregions: [
                  { _id: '1c0fe0f4-367b-4b56-bb56-073107c09b6e' },
                  { title: 'Northern Andean P\u00e1ramo' },
                  { regionId: '593' },
                  {
                    dek:
                      'This ecoregion includes the high altitude wet grasslands that are above the tree line and below the snow line within the equatorial Andes.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a3f51cae-330c-422a-b8de-eacba289f247/593 Northern Andean p\u00e1ramo - Federico Meija.jpg',
                      _id: 'a3f51cae-330c-422a-b8de-eacba289f247'
                    }
                  },
                  { _id: '67da60f4-894f-47d2-b0cc-2cb3c60d5347' },
                  { title: 'Cordillera De Merida P\u00e1ramo' },
                  { regionId: '591' },
                  {
                    dek:
                      'This ecoregion consists of specialized high elevation grassland communities which occur in three distinct oblong patches.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/30bff2db-bc1f-4efb-97af-6c20066f5b25/591 Cordillera de Merida p\u00e1ramo - Cristo Adolfo.jpg',
                      _id: '30bff2db-bc1f-4efb-97af-6c20066f5b25'
                    }
                  },
                  { _id: '74bbd5f0-0581-49a0-b50f-78a0405430d5' },
                  { title: 'Cordillera Central P\u00e1ramo' },
                  { regionId: '590' },
                  {
                    dek:
                      'Essential for the regional water cycle, this ecoregion is the origin of many streams running down the Pacific and Atlantic slopes. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ae390634-f48c-46d4-98fa-982e6be8a15d/590 Cordillera Central p\u00e1ramo - Bernd Rakell.jpg',
                      _id: 'ae390634-f48c-46d4-98fa-982e6be8a15d'
                    }
                  },
                  { _id: '6e1703bb-a85e-49db-ba26-d05285d881d2' },
                  { title: 'Pat\u00eda valley dry forests' },
                  { regionId: '542' },
                  {
                    dek:
                      'The Pat\u00eda Valley is a dry pocket \u201cvalley\u201d surrounded by the cloud forests of the Central and Western cordilleras of Colombia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aba163cb-f1cb-43f5-888e-5d96cdd6714c/542 Pat\u00eda valley dry forests - OPD.jpg',
                      _id: 'aba163cb-f1cb-43f5-888e-5d96cdd6714c'
                    }
                  },
                  { _id: '45b4d228-a283-4982-8fc7-c893038c0220' },
                  { title: 'Magdalena Valley Dry Forests' },
                  { regionId: '538' },
                  {
                    dek:
                      'This ecoregion, located within the Northern Andes, occurs along the dry inter-Andean valley formed by the largest river in Colombia, the Magdalena.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b359078e-41fc-4de1-8207-d0169e8965a3/538 Magdalena Valley dry forest - Javier Lopez.jpg',
                      _id: 'b359078e-41fc-4de1-8207-d0169e8965a3'
                    }
                  },
                  { _id: '0b4f0ca0-ac7d-47c4-b800-16a3d75fd3ed' },
                  { title: 'Cauca Valley Dry Forests' },
                  { regionId: '526' },
                  {
                    dek:
                      'The dry inter-Andean valley is located between the west and central Andes in Colombia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/07bc8db8-61fc-4049-9fe1-0973aab7cce6/526 Cauca Valley dry forests - Ariel Jiminez Gil.jpg',
                      _id: '07bc8db8-61fc-4049-9fe1-0973aab7cce6'
                    }
                  },
                  { _id: '3930c093-86ef-4ff3-9e0b-8b057d1571f9' },
                  { title: 'Bolivian Montane Dry Forests' },
                  { regionId: '523' },
                  {
                    dek:
                      'This ecoregion is restricted to south-central Bolivia, flanking the eastern Andes, and barely reaching northwest Argentina.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b5889643-66e1-4781-972e-3328928edfae/523 Bolivian montane dry forests - Gaumut.jpg',
                      _id: 'b5889643-66e1-4781-972e-3328928edfae'
                    }
                  },
                  { _id: '5ceb13ef-2b83-4da1-a8e0-ce71e1621e43' },
                  { title: 'Venezuelan Andes Montane Forests' },
                  { regionId: '513' },
                  {
                    dek:
                      'This ecoregion occupies montane forests at middle elevations of the Venezuelan Andes, a northeastern branch of the Andes mountain range.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3ebd96d8-f94c-4527-a972-53c3331deee9/513 Venezuelan Andes montains.jpg',
                      _id: '3ebd96d8-f94c-4527-a972-53c3331deee9'
                    }
                  },
                  { _id: 'b5032d15-9146-43fe-83fd-03395eae2514' },
                  { title: 'Southern Andean Yungas' },
                  { regionId: '504' },
                  {
                    dek:
                      'This ecoregion, spanning across southwestern Bolivia and northwestern Argentina, is loosely bordered on the east by dry lowland vegetation of the Chaco and tightly on the west by the Bolivian Montane dry forests.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fc7b7bb4-2ac7-47f7-b4db-2aa50bb4c39d/504 Southern Andean Yungas - Gonza Martinez27.jpg',
                      _id: 'fc7b7bb4-2ac7-47f7-b4db-2aa50bb4c39d'
                    }
                  },
                  { _id: '6c5f75c9-11ba-4008-adda-82771eaa71bb' },
                  { title: 'Peruvian Yungas' },
                  { regionId: '493' },
                  {
                    dek:
                      'This ecoregion flanks the eastern slopes of the Andes, roughly from the Mara\u00f1on Valley depression northern Peru to near the Rio Huari Huari (Cordillera Carabaya) near the Bolivian border. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/43aded15-0695-44e1-a942-ae91cfac0264/493 Peruvian Yungas - Rhett Butler.jpg',
                      _id: '43aded15-0695-44e1-a942-ae91cfac0264'
                    }
                  },
                  { _id: '8cf02854-609a-4cea-a16c-7ab20c2856c2' },
                  { title: 'Northwest Andean Montane Forests' },
                  { regionId: '486' },
                  {
                    dek:
                      'This ecoregion is found in northwest South America in the center of Colombia and Ecuador within a 150 km wide chain of the Andes Mountains.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ace629a5-ddf4-4002-bba2-d3decfa49eb1/486 Northwest Andean Montane Forests - R Noss.jpg',
                      _id: 'ace629a5-ddf4-4002-bba2-d3decfa49eb1'
                    }
                  },
                  { _id: '2c80ef0f-7231-441e-9f2d-6ac8ff8b87de' },
                  { title: 'Mara\u00f1on Dry Forests' },
                  { regionId: '479' },
                  {
                    dek:
                      'This ecoregion extends along the upper Mara\u00f1on River valley and its tributaries in northwestern Peru.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cb730928-c6bc-4f10-9b0d-4d329c39ee49/479 Mara\u00f1\u00f3n dry forests - Lalitoaries.JPG',
                      _id: 'cb730928-c6bc-4f10-9b0d-4d329c39ee49'
                    }
                  },
                  { _id: 'd633ec5c-5856-4f49-a60f-dc80c5c5754e' },
                  { title: 'Magdalena Valley Montane Forests' },
                  { regionId: '477' },
                  {
                    dek:
                      'Magdalena Valley Forests grow on the inner slopes of the Eastern and Central cordilleras in the Northern Andes of Colombia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/39be8eaf-4684-44c9-96fc-dfaee2b06d4b/477 Magdalena Valley montane forests - papblotzin.jpg',
                      _id: '39be8eaf-4684-44c9-96fc-dfaee2b06d4b'
                    }
                  },
                  { _id: '593720a5-1b9b-4500-9c67-3d3f204dc3af' },
                  { title: 'Eastern Cordillera Real Montane Forests' },
                  { regionId: '460' },
                  {
                    dek:
                      'The Eastern Cordillera Real Montane Forests ecoregion is located on the eastern slopes of the middle Andes, extending north-south from southern Colombia, through Ecuador, and into northern Peru.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/336c1f02-1a28-4346-a2f5-8531b42c0885/460 Eastern Cordillera Real montane forests - Alejandro Miranda.jpg',
                      _id: '336c1f02-1a28-4346-a2f5-8531b42c0885'
                    }
                  },
                  { _id: '72cba1c3-176f-4bcc-98b7-68fab471343c' },
                  { title: 'Cordillera Oriental Montane Forests' },
                  { regionId: '457' },
                  {
                    dek:
                      'These forests span the eastern slopes of the Andean Cordillera Oriental from their northernmost point southwards through most of Colombia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8131146b-6deb-43d8-851f-97440601deac/457 Cordillera Oriental montane forests - Lucia Mafilito.jpg',
                      _id: '8131146b-6deb-43d8-851f-97440601deac'
                    }
                  },
                  { _id: '513118c5-90b4-4e29-95c6-2eb3ffa60d8c' },
                  { title: 'Cauca Valley Montane Forests' },
                  { regionId: '448' },
                  {
                    dek:
                      'Located at the northwestern end of the Andes Mountain Range in southwestern Colombia, the Cauca Valley is nestled between the western and central ranges of the Andes and stretches for 600 km in a south-north direction.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f842e095-8282-4db4-83a0-4002d17ca92c/448 Cauca Valley montane forests - jdpperez.jpg',
                      _id: 'f842e095-8282-4db4-83a0-4002d17ca92c'
                    }
                  },
                  { _id: '98af8e8a-7465-4834-b65b-8b2bb6341d0d' },
                  { title: 'Bolivian Yungas' },
                  { regionId: '444' },
                  {
                    dek:
                      'This ecoregion in Bolivia and parts of Peru forms a transition along the Andean slope between Amazonian and highland Puna habitats, which contributes to the high levels of biodiversity and endemism characterizing this unique ecoregion.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b2c1b9e6-ba46-48bf-a070-87468fc87b3d/444 Bolivian Yungas - Elias Bizannes.jpg',
                      _id: 'b2c1b9e6-ba46-48bf-a070-87468fc87b3d'
                    }
                  }
                ],
                stats: [
                  { number: '93,130', item: 'Total Land Area (1000 ha)' },
                  { number: '17', item: 'Number of Ecoregions' },
                  { number: '64%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Ecuadorean Dry Coastal Forests & Flooded Grasslands (NT10)',
                children: [],
                _id: '5aaf42c9-0600-421e-9448-8f8f47eb6d30',
                value: 1000,
                parentId: '1a6917fe-fd56-44f1-aaa6-68ac58d7650f',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e5bdcd81-b409-49bd-aa1d-83cddd9606f5/516 Western Ecuador moist forests - Albert Dezetter.jpg',
                    _id: 'e5bdcd81-b409-49bd-aa1d-83cddd9606f5'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0be134ef-2dd0-4f05-b068-bf39aa8d4df5/549 Tumbes-Piura dry forests - Harrison Zender.jpg',
                    _id: '0be134ef-2dd0-4f05-b068-bf39aa8d4df5'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ff627b28-8a69-49fb-b017-2d7de58f6200/531 Ecuadorian dry forests - kulfman.JPG',
                    _id: 'ff627b28-8a69-49fb-b017-2d7de58f6200'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/09883994-cdf0-401f-80bf-deb1a47a8224/582 Guayaquil Flooded Grasslands cc.jpg',
                    _id: '09883994-cdf0-401f-80bf-deb1a47a8224'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a06c6d06-5084-4ffa-a4a6-2a248b0a89cc/615 South American Pacific mangroves - Rhett Butler.jpg',
                    _id: 'a06c6d06-5084-4ffa-a4a6-2a248b0a89cc'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d475cf78-1fac-4409-a6e2-2c7adbb0b616/Bioregion%20map-NT10.jpg',
                content:
                  '<p>The Ecuadorian Dry Coastal bioregion, located in the Southern America (Neotropical) realm, is centered on the Gulf of Guayaquil, the mouth of the Guayas River. The bioregion is dominated by dry forests, but it includes coastal moist forests to the north and flooded grasslands in its center with four terrestrial ecoregions -- Western Ecuador Moist Forests (516), Tumbes-Piura Dry Forests (549), Ecuadorian Dry Forests (531), Guayaquil Flooded Grasslands (582) \u2013 and adjacent marine areas, which include the South American Pacific Mangroves (615). The land area of this bioregion is approximately 10 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d475cf78-1fac-4409-a6e2-2c7adbb0b616/Bioregion%20map-NT10.jpg"/><figcaption><span class="caption"><p>The Ecuadorean Dry Coastal Forests &amp; Flooded Grasslands bioregion is part of the Andes &amp; Pacific Coast subrealm and is made up of five ecoregions: (1) Western Ecuador Moist Forests (2) Ecuadorian Dry Forests (3) Guayaquil Flooded Grasslands (4) Tumbes-Piura Dry Forests (5) South American Pacific Mangroves.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Ecuadorean Dry Coastal Forests &amp; Flooded Grasslands ecoregions below.</p>',
                ecoregions: [
                  { _id: '43d5e898-d23d-49de-89ae-8f5619cc2ea0' },
                  { title: 'South American Pacific Mangroves' },
                  { regionId: '615' },
                  {
                    dek:
                      'The South American Pacific Mangrove ecoregion is comprised of five subecoregions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/07325c0f-cc89-409d-afdf-e84163dcfc97/615-Ensenada_de_Utri\u0301a_-_Mangroven-Eco615-CC-Philipp Weigell.jpg',
                      _id: '07325c0f-cc89-409d-afdf-e84163dcfc97'
                    }
                  },
                  { _id: '17e3bfec-5908-4000-95fc-ce105528be4e' },
                  { title: 'Guayaquil Flooded Grasslands' },
                  { regionId: '582' },
                  {
                    dek:
                      'This ecoregion is in the provinces of El Guayas, Los R\u00edos, and El Oro in Ecuador.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/09883994-cdf0-401f-80bf-deb1a47a8224/582 Guayaquil Flooded Grasslands cc.jpg',
                      _id: '09883994-cdf0-401f-80bf-deb1a47a8224'
                    }
                  },
                  { _id: 'a39509b1-76e9-4565-bb70-c096151a1a0d' },
                  { title: 'Tumbes-Piura Dry Forests' },
                  { regionId: '549' },
                  {
                    dek:
                      'This Tumbes-Piura Dry Forest ecoregion is located in the equatorial region of South American between the Pacific Ocean and the western slope of the Andes Mountains.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0be134ef-2dd0-4f05-b068-bf39aa8d4df5/549 Tumbes-Piura dry forests - Harrison Zender.jpg',
                      _id: '0be134ef-2dd0-4f05-b068-bf39aa8d4df5'
                    }
                  },
                  { _id: '21a0073a-76ea-4be7-899e-0d244d667851' },
                  { title: 'Ecuadorian Dry Forests' },
                  { regionId: '531' },
                  {
                    dek:
                      'This ecoregion extends along the Pacific Coast southward from southern Esmeraldas province in northern Ecuador into the Guayas province, ending at the Golfo de Guayaquil. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ff627b28-8a69-49fb-b017-2d7de58f6200/531 Ecuadorian dry forests - kulfman.JPG',
                      _id: 'ff627b28-8a69-49fb-b017-2d7de58f6200'
                    }
                  },
                  { _id: '07eb21ac-6e50-4d74-879c-f82a7c6448df' },
                  { title: 'Western Ecuador Moist Forests' },
                  { regionId: '516' },
                  {
                    dek:
                      'Located in southwestern Colombia and western Ecuador, the ecoregion boundaries extend from the Patia River in the north and ending at the foothills of the Andes Mountains in the east.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e5bdcd81-b409-49bd-aa1d-83cddd9606f5/516 Western Ecuador moist forests - Albert Dezetter.jpg',
                      _id: 'e5bdcd81-b409-49bd-aa1d-83cddd9606f5'
                    }
                  }
                ],
                stats: [
                  { number: '10,660', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '32%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'South American Coastal Deserts (NT8)',
                children: [],
                _id: 'aeee2e19-890c-401f-94fe-da9c3c201d45',
                value: 1000,
                parentId: '1a6917fe-fd56-44f1-aaa6-68ac58d7650f',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/57fd05ac-86a8-42ee-a142-97e9fe121861/608 Sechura desert - edo janssen.jpg',
                    _id: '57fd05ac-86a8-42ee-a142-97e9fe121861'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/344caeda-686b-4e9e-a9df-109f6c7c5788/598 Atacama desert - Javier Rubilar.jpg',
                    _id: '344caeda-686b-4e9e-a9df-109f6c7c5788'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7c5d4881-5825-4ab5-90ef-8990e8df1d01/Bioregion%20map-NT8.jpg',
                content:
                  '<p>The South American Coastal Deserts bioregion, located in the Southern America (Neotropical) realm, occupies a narrow band west of the Andes Mountains, running along the Peruvian and northern Chilean coast. It contains two arid ecoregions \u2013 Atacama Desert (598), Sechura Desert (608) \u2013 and adjacent marine areas in the Pacific Ocean. The land area of this bioregion is approximately 29 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7c5d4881-5825-4ab5-90ef-8990e8df1d01/Bioregion%20map-NT8.jpg"/><figcaption><span class="caption"><p>The South American Coastal Deserts bioregion is part of the Andes &amp; Pacific Coast subrealm and is made up of two ecoregions: (1) Sechura Desert (2) Atacama Desert.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the South American Coastal Deserts ecoregions below.</p>',
                ecoregions: [
                  { _id: '399f1c76-765a-4eb7-b2b8-742301520b14' },
                  { title: 'Sechura Desert' },
                  { regionId: '608' },
                  {
                    dek:
                      'This ecoregion occupies the western subtropical portion of South America. It borders the Pacific Ocean on the west and extends between 20\u2013100 km inland on the east until reaching the Andean secondary ridges.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/57fd05ac-86a8-42ee-a142-97e9fe121861/608 Sechura desert - edo janssen.jpg',
                      _id: '57fd05ac-86a8-42ee-a142-97e9fe121861'
                    }
                  },
                  { _id: 'b70a3167-4ada-4201-b7c4-e3ac55649645' },
                  { title: 'Atacama Desert' },
                  { regionId: '598' },
                  {
                    dek:
                      'The Atacama Desert is considered one of the driest coastal deserts in the world. It forms a continuous strip for nearly 1,000 km along the narrow coast of the northern third of Chile. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/344caeda-686b-4e9e-a9df-109f6c7c5788/598 Atacama desert - Javier Rubilar.jpg',
                      _id: '344caeda-686b-4e9e-a9df-109f6c7c5788'
                    }
                  }
                ],
                stats: [
                  { number: '29,072', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '20%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Juan Fern\u00e1ndez & Desventuradas Islands (NT7)',
                children: [],
                _id: '79add296-0e16-4da5-98be-db8172b4d0c6',
                value: 1000,
                parentId: '1a6917fe-fd56-44f1-aaa6-68ac58d7650f',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0e83dc6a-e89f-49cd-b5e1-5c77a5891a45/560 Juan Fern\u00e1ndez Islands temperate forests - Serpentus.jpg',
                    _id: '0e83dc6a-e89f-49cd-b5e1-5c77a5891a45'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8b1bd1a7-b7f6-4efc-89d2-4b6da2d79e8c/562 San F\u00e9lix-San Ambrosio Islands temperate forests - Smithsonian Institution.jpg',
                    _id: '8b1bd1a7-b7f6-4efc-89d2-4b6da2d79e8c'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c7d341e4-6b1e-4afa-9e1c-d92a018f71a8/Bioregion%20map-NT7.jpg',
                content:
                  '<p>This small group of islands off the coast of Chile, located in the Southern America (Neotropical) realm, make up a unique bioregion, consisting of temperate broadleaf forests and grasslands containing many endemic plant species. It also includes the rocky Desventuradas Islands, two ecoregions in total \u2013 Juan Fern\u00e1ndez Islands Temperate Forests (560), San F\u00e9lix-San Ambrosio Islands Temperate Forests (562) \u2013 and the surrounding marine areas, which contain a unique mix of tropical, subtropical, and temperate marine species and were recently designated as one of the largest marine parks in the Americas. The land area of this bioregion is nearly 16,000 hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c7d341e4-6b1e-4afa-9e1c-d92a018f71a8/Bioregion%20map-NT7.jpg"/><figcaption><span class="caption"><p>The Juan Fern\u00e1ndez &amp; Desventuradas Islands bioregion is part of the Andes &amp; Pacific Coast subrealm and is made up of two ecoregions: (1) Juan Fern\u00e1ndez Islands Temperate Forests (2) San F\u00e9lix-San Ambrosio Islands Temperate Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Juan Fern\u00e1ndez &amp; Desventuradas Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'fa89789e-c6af-4439-bf77-9fdf68338ff6' },
                  { title: 'San F\u00e9lix-San Ambrosio Islands Temperate Forests' },
                  { regionId: '562' },
                  {
                    dek:
                      'The Desventuradas archipelago, or \u201cUnfortunate Islands\u201d, are formed by four Pacific islands, including San F\u00e9lix and San Ambrosio.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8b1bd1a7-b7f6-4efc-89d2-4b6da2d79e8c/562 San F\u00e9lix-San Ambrosio Islands temperate forests - Smithsonian Institution.jpg',
                      _id: '8b1bd1a7-b7f6-4efc-89d2-4b6da2d79e8c'
                    }
                  },
                  { _id: 'a606e27e-baf7-48ff-af70-5da36932a626' },
                  { title: 'Juan Fern\u00e1ndez Islands Temperate Forests' },
                  { regionId: '560' },
                  {
                    dek:
                      'The Juan Fern\u00e1ndez archipelago, also known as the Robinson Crusoe Islands, is located off the coast of Chile in the southeastern part of the Pacific Ocean.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0e83dc6a-e89f-49cd-b5e1-5c77a5891a45/560 Juan Fern\u00e1ndez Islands temperate forests - Serpentus.jpg',
                      _id: '0e83dc6a-e89f-49cd-b5e1-5c77a5891a45'
                    }
                  }
                ],
                stats: [
                  { number: '16', item: 'Total Land Area (1000 ha) ' },
                  { number: '2', item: 'Number of Ecoregions ' },
                  { number: '94%', item: 'Protection Target' },
                  { number: '9', item: 'Protection Level' }
                ]
              },
              {
                name: 'Chilean Matorral Shrublands & Savanna (NT6)',
                children: [],
                _id: '0649be0d-8781-4068-9629-a096d349bc1d',
                value: 1000,
                parentId: '1a6917fe-fd56-44f1-aaa6-68ac58d7650f',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6e8cd3c7-d474-4a14-bcfc-ad617961ad2c/596-Parque Nacional La Campana, Chili-2-Eco 596-CC-Jorge leon Cabello-2003_resized.jpg',
                    _id: '6e8cd3c7-d474-4a14-bcfc-ad617961ad2c'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fb67fcb1-ba5e-4cc4-9b05-15c25f0bb139/Bioregion%20map-NT6.jpg',
                content:
                  '<p>The Chilean Matorral, located in the Southern America (Neotropical) realm, is South America\u2019s only Mediterranean biome, a mix of hardwoods, shrubs, cacti, and grassland. It occupies a narrow band along the central coast of Chile and is made up of one single ecoregion \u2013 Chilean Matorral (596) \u2013 and includes many alpine lakes and adjacent marine areas in the Pacific Ocean. The land area of this bioregion is nearly 15 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fb67fcb1-ba5e-4cc4-9b05-15c25f0bb139/Bioregion%20map-NT6.jpg"/><figcaption><span class="caption"><p>The Chilean Matorral Shrublands &amp; Savanna bioregion is part of the Andes &amp; Pacific Coast subrealm and is made up of one ecoregion: (1) Chilean Matorral.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Chilean Matorral Shrublands &amp; Savanna ecoregion below.</p>',
                ecoregions: [
                  { _id: '30cda09e-7795-419a-97db-60fd6f13ef5c' },
                  { title: 'Chilean Matorral' },
                  { regionId: '596' },
                  {
                    dek:
                      'This ecoregion constitutes a 100 km-wide strip extending along the central part of the Chilean coast between the Pacific Ocean to the west and the Andes Mountains to the east.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0a3c26a1-e28a-4ddf-87fd-13cb1829098f/596 Chilean matorral - D Olson.jpg',
                      _id: '0a3c26a1-e28a-4ddf-87fd-13cb1829098f'
                    }
                  }
                ],
                stats: [
                  { number: '14,884', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '28%', item: 'Protection Target' },
                  { number: '0', item: 'Protection Level' }
                ]
              },
              {
                name: 'Andean Mountain Grasslands (NT5)',
                children: [],
                _id: 'd9b836b5-87bf-49fe-bffe-2827953c581d',
                value: 1000,
                parentId: '1a6917fe-fd56-44f1-aaa6-68ac58d7650f',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c960b12c-9157-4c4a-b06d-4473c156748d/587-Laguna_Verde_en_Bolivia-Eco-587-CC-Ville Miettinen-2007.jpg',
                    _id: 'c960b12c-9157-4c4a-b06d-4473c156748d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3a7f17c4-616c-49a7-9fd2-b617585685ad/588-CentralAndeanPuna-WikiCommons3.jpg',
                    _id: '3a7f17c4-616c-49a7-9fd2-b617585685ad'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/449290a5-5cff-4257-8d21-1bb355d7ac5f/589 Central Andean wet puna - onapujadas.jpg',
                    _id: '449290a5-5cff-4257-8d21-1bb355d7ac5f'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f8615b06-0e27-4395-8458-1c96255d4431/592 High Monte - chispita.jpg',
                    _id: 'f8615b06-0e27-4395-8458-1c96255d4431'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b9dd769f-546f-45a8-9382-c5892823f6d1/595 Southern Andean steppe - Mathias Muller.jpg',
                    _id: 'b9dd769f-546f-45a8-9382-c5892823f6d1'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/91f1d8a5-a41f-451d-9ce6-971e52ba5380/Bioregion%20map-NT5.jpg',
                content:
                  '<p>The Andean Mountain Grasslands bioregion, located in the Southern America (Neotropical) realm, is centered on the Altiplano, the world\u2019s second highest plateau. It stretches from central Argentina to central Peru and is composed entirely of high-altitude grasslands. The bioregion contains five ecoregions \u2013 Central Andean Dry Puna (587), Central Andean Puna (588), Central Andean Wet Puna (589), High Monte (592), Southern Andean Steppe (595) \u2013 and incorporates Lake Titicaca, the largest lake in South America and one of the world\u2019s highest bodies of water. The area of this bioregion is nearly 83 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/91f1d8a5-a41f-451d-9ce6-971e52ba5380/Bioregion%20map-NT5.jpg"/><figcaption><span class="caption"><p>The Andean Mountain Grasslands bioregion is part of the Andes &amp; Pacific Coast subrealm and is made up of five ecoregions: (1) Southern Andean Steppe (2) High Monte (3) Central Andean Puna (4) Central Andean Dry Puna (5) Central Andean Wet Puna.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Andean Mountain Grasslands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'a7a4c63d-4d97-4139-b0df-0aec4b3ca710' },
                  { title: 'High Monte' },
                  { regionId: '592' },
                  {
                    dek:
                      'The High Monte ecoregion, also called the High Monte desert locally, is bounded in the west in the rain shadow of the Andes, in the north by the high arid Puna, in the east by the arid\u2013semiarid woodlands of the Chaco and Espinal.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f8615b06-0e27-4395-8458-1c96255d4431/592 High Monte - chispita.jpg',
                      _id: 'f8615b06-0e27-4395-8458-1c96255d4431'
                    }
                  },
                  { _id: 'f1118dd4-9b42-4680-8996-2a421ce2f33d' },
                  { title: 'Southern Andean Steppe' },
                  { regionId: '595' },
                  {
                    dek:
                      'A relatively untouched piece of nature, the Southren Andean Steppe ecoregion extends along the high elevations of the Andes of central Argentina and in part of Chile at altitudes between 1,800 and 5,000 m.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/68ecee58-4fcc-4236-96d8-c0bba98b2634/595-Antuco_Volcano-Eco 595-CC-2006.jpg',
                      _id: '68ecee58-4fcc-4236-96d8-c0bba98b2634'
                    }
                  },
                  { _id: '1266fb3d-edee-419d-af6f-ea5200ace73d' },
                  { title: 'Central Andean Wet Puna' },
                  { regionId: '589' },
                  {
                    dek:
                      'This ecoregion is located in the Andean Mountains of Peru and eastern Bolivia, with landscapes filled with snow-capped peaks, mountain grasslands, high lakes, plateaus, and valleys.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/449290a5-5cff-4257-8d21-1bb355d7ac5f/589 Central Andean wet puna - onapujadas.jpg',
                      _id: '449290a5-5cff-4257-8d21-1bb355d7ac5f'
                    }
                  },
                  { _id: '1941e733-75fe-4c27-9282-56613795dcab' },
                  { title: 'Central Andean Puna' },
                  { regionId: '588' },
                  {
                    dek:
                      'This ecoregion is a high elevation montane grassland in the southern high Andes, extending from southern Peru, though Bolivia, into northern Argentina.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f228819a-b043-4dc8-8368-fcad42af984e/588-Salinas_and_Aguada_Blanca_Misti_guanacos-Eco 588-Max Berger-2016.jpg',
                      _id: 'f228819a-b043-4dc8-8368-fcad42af984e'
                    }
                  },
                  { _id: '7e4a504e-6ec5-466b-804e-c666eff05313' },
                  { title: 'Central Andean Dry Puna' },
                  { regionId: '587' },
                  {
                    dek:
                      'This ecoregion is nestled between the tree-line and the permanent snow-line in a very dry region of this mountain range.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e7307dd7-0804-4e2f-806c-408394395b68/587 Central Andean Dry Puna - Cristian Ordenez.jpg',
                      _id: 'e7307dd7-0804-4e2f-806c-408394395b68'
                    }
                  }
                ],
                stats: [
                  { number: '82,848', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '45%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'Gal\u00e1pagos Islands (NT9)',
                children: [],
                _id: '5ffb4e48-057c-48aa-8ed2-5177c015ba49',
                value: 1000,
                parentId: '1a6917fe-fd56-44f1-aaa6-68ac58d7650f',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/623007bd-6205-4419-938c-964d046319c5/601 Gal\u00e1pagos Islands xeric scrub - peterstuartmill.jpg',
                    _id: '623007bd-6205-4419-938c-964d046319c5'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/90ba32d8-11d1-47ed-92bc-ee0ca65b2180/Bioregion%20map-NT9.jpg',
                content:
                  '<p>The Galapagos bioregion, located in the Southern America (Neotropical) realm, contains an archipelago of 61 volcanic islands and islands 520 nautical miles off the coast of Ecuador. With its array of plant, animal and marine species, the Galapagos have been listed as a UNESCO heritage site and was the inspiration for Darwin\u2019s theory of evolution. The islands are home to 20 endemic reptiles and the famous Giant Tortoise. The marine biodiversity is equally rich with 20% of species endemic to the region. The bioregion is dominated by one ecoregion \u2013 Gal\u00e1pagos Islands Xeric Scrub (601) \u2013 but this belies the diversity of plant life present here, with over 500 native plant species, 180 of which are endemic. The land area of this bioregion is approximately 800,000 hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/90ba32d8-11d1-47ed-92bc-ee0ca65b2180/Bioregion%20map-NT9.jpg"/><figcaption><span class="caption"><p>The Gal\u00e1pagos Islands bioregion is part of the Andes &amp; Pacific Coast subrealm and is made up of one ecoregion: (1) Gal\u00e1pagos Islands Xeric Scrub.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Gal\u00e1pagos Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: '01822738-f2c3-4b66-afd0-87424f06b87f' },
                  { title: 'Gal\u00e1pagos Islands Xeric Scrub' },
                  { regionId: '601' },
                  {
                    dek:
                      'The Gal\u00e1pagos Islands Xeric Scrub ecoregion encompasses the entire Gal\u00e1pagos archipelago, including about 128 named islands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/623007bd-6205-4419-938c-964d046319c5/601 Gal\u00e1pagos Islands xeric scrub - peterstuartmill.jpg',
                      _id: '623007bd-6205-4419-938c-964d046319c5'
                    }
                  }
                ],
                stats: [
                  { number: '803', item: 'Total Land Area (1000 ha) ' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '100%', item: 'Protection Target' },
                  { number: '10', item: 'Protection Level' }
                ]
              },
              {
                name: 'Chilean Mixed Forests (NT1)',
                children: [],
                _id: '578ed31c-1c3c-40e3-b1f1-b0211ea9e2dd',
                value: 1000,
                parentId: '1a6917fe-fd56-44f1-aaa6-68ac58d7650f',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/046103f1-e51b-428e-a8c3-071f6d15f322/561-Parque Nacional Torres del Paine-5-Eco 561-Chile-CC-Harvey Barrison-2017_resized.jpg',
                    _id: '046103f1-e51b-428e-a8c3-071f6d15f322'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cee5b52f-0bc0-4ef1-809e-6a7f2fa764a9/561-Parque Nacional Torres del Paine-2-Eco 561-Chile-CC-Harvey Barrison-2017_resized.jpg',
                    _id: 'cee5b52f-0bc0-4ef1-809e-6a7f2fa764a9'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/99e06827-c33f-4c83-9ee5-c337a1213c51/563-Forest-Parque Nacional Lanin Cerro Colorado-3-Eco 563-CC-Miguel Vieira-2011.jpg',
                    _id: '99e06827-c33f-4c83-9ee5-c337a1213c51'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c422efd8-af33-4a30-bf80-6002cacc4e1d/563 Valdivian temperate forests - Patricio Hurtado.jpg',
                    _id: 'c422efd8-af33-4a30-bf80-6002cacc4e1d'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/150f0fd1-cdbd-424a-ba76-4e4431973cac/Bioregion%20map-NT1.jpg',
                content:
                  '<p>Comprising the western half of Patagonia at the bottom of South America and located in the Southern America (Neotropical) realm, the Chilean bioregion is defined by a myriad of waterways intertwined with coastal rainforests and includes Chile\u2019s Lake District and several large glaciers at the southernmost extent of the Andes Mountains. The bioregion contains two ecoregions \u2013 Magellanic Subpolar Forests (561), Valdivian Temperate Forests (563) \u2013 and includes Tierra del Fuego and adjacent marine areas in both the southern Pacific and Atlantic oceans. The total land area of this bioregion is more than 41 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/150f0fd1-cdbd-424a-ba76-4e4431973cac/Bioregion%20map-NT1.jpg"/><figcaption><span class="caption"><p>The Chilean Mixed Forests bioregion is part of the Andes &amp; Pacific Coast subrealm and is made up of two ecoregions: (1) Magellanic Subpolar Forests (2) Valdivian Temperate Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Chilean Mixed Forest ecoregions below.</p>',
                ecoregions: [
                  { _id: 'e7f82fc3-bdac-4333-a09f-42c8a4ce7b04' },
                  { title: 'Valdivian Temperate Forests' },
                  { regionId: '563' },
                  {
                    dek:
                      'The Valdivian Temperate Forests ecoregion is in the southern cone of South America.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c422efd8-af33-4a30-bf80-6002cacc4e1d/563 Valdivian temperate forests - Patricio Hurtado.jpg',
                      _id: 'c422efd8-af33-4a30-bf80-6002cacc4e1d'
                    }
                  },
                  { _id: '5f2df912-c6e9-4073-9306-1e91fff4a082' },
                  { title: 'Magellanic Subpolar Forests' },
                  { regionId: '561' },
                  {
                    dek:
                      'The Magellanic Subpolar Forests cover the flanks of the southern Andes and adjacent lowlands of South America.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/af100262-6b3b-45c0-9e00-ce59c3633970/561 Magellanic subpolar forests - Gregoire Dubois.jpg',
                      _id: 'af100262-6b3b-45c0-9e00-ce59c3633970'
                    }
                  }
                ],
                stats: [
                  { number: '41,305', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '45%', item: 'Protection Target' },
                  { number: '7', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Southern America',
            value: 1000
          },
          {
            _id: '645211fe-cce5-417f-8871-a9f4f2a114b3',
            name: 'South American Grasslands',
            children: [
              {
                name: 'Chaco Grasslands (NT4)',
                children: [],
                _id: 'af46ec10-5c4e-4474-be0f-695385095bb1',
                value: 1000,
                parentId: '645211fe-cce5-417f-8871-a9f4f2a114b3',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b91faac4-7b5f-4944-b634-ef7adb860762/571-Esteros del Iber\u00e1 Laguna Iber\u00e1-Eco571-Argentina-CC-Miguel Vieira-2011.jpg',
                    _id: 'b91faac4-7b5f-4944-b634-ef7adb860762'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/52bd207a-461e-4263-a347-05b735bf4fd8/569-Chaco_Boreal_Paraguay-Eco 569-CC-2004.jpg',
                    _id: '52bd207a-461e-4263-a347-05b735bf4fd8'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bcca2a25-c051-4c61-b2b9-14509fa991ab/Bioregion%20map-NT4.jpg',
                content:
                  '<p>The Chaco bioregion, located in the Southern America (Neotropical) realm, covers much of Paraguay and northern Argentina. The name of this region is derived from the indigenous Quechua word <em>chaqu</em> which means \u201chunting land,\u201d due to the rich variety of wildlife that was once abundant in these subtropical grasslands and shrublands. The bioregion contains two ecoregions \u2013 Dry Chaco (569), Humid Chaco (571) \u2013 incorporating several large salt flats in the south. The land area of this bioregion is more than 108 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bcca2a25-c051-4c61-b2b9-14509fa991ab/Bioregion%20map-NT4.jpg"/><figcaption><span class="caption"><p>The Chaco Grasslands bioregion is part of the South American Grasslands subrealm and is made up of two ecoregions: (1) Dry Chaco (2) Humid Chaco.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Chaco Grasslands ecoregions below.</p>',
                ecoregions: [
                  { _id: '4766971c-aafa-4cdf-adc9-b797ce2fb14e' },
                  { title: 'Dry Chaco' },
                  { regionId: '569' },
                  {
                    dek:
                      'This ecoregion is generally restricted to the northwestern two-thirds of western Paraguay, and east of the Andes in southeastern Bolivia and northwestern Argentina'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/541be76f-4c70-46f8-9bdf-94d39d55cc48/569 Dry Chaco - P Veer.JPG',
                      _id: '541be76f-4c70-46f8-9bdf-94d39d55cc48'
                    }
                  },
                  { _id: '62238aea-faf4-4e69-9e3c-993d3820f88b' },
                  { title: 'Humid Chaco' },
                  { regionId: '571' },
                  {
                    dek:
                      'The Humid Chaco ecoregion is located in northeastern Argentina, the center of Paraguay, and small areas in southwestern Brazil. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fdf9142f-61de-4ea5-aaf3-7cfcd62cb32e/571 Humid Chaco - Ilosuna.jpg',
                      _id: 'fdf9142f-61de-4ea5-aaf3-7cfcd62cb32e'
                    }
                  }
                ],
                stats: [
                  { number: '108,294', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '48%', item: 'Protection Target ' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Rio de la Plata Grasslands (NT3)',
                children: [],
                _id: '30cfdd41-3640-46b4-9e8c-c332bab3b561',
                value: 1000,
                parentId: '645211fe-cce5-417f-8871-a9f4f2a114b3',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/775d4fe1-8ac9-46b4-881b-daf96dc351ca/574 Uruguayan Savanna - Sheridon.jpg',
                    _id: '775d4fe1-8ac9-46b4-881b-daf96dc351ca'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8e72a485-acf0-4a69-91d8-26950f8b750d/575-Argentine Espinal-Eco 575- CC-2015_resized.jpg',
                    _id: '8e72a485-acf0-4a69-91d8-26950f8b750d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b316548e-f47d-4004-887d-fd1d6ca62a6e/576-Humid Pampas-Los Toldos-Argentina-Eco 576-CC-2006.jpg',
                    _id: 'b316548e-f47d-4004-887d-fd1d6ca62a6e'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b4b38b0c-0b2b-4638-9627-308d467987a1/585 Paran\u00e1 flooded savanna - Wikiwand.jpg',
                    _id: 'b4b38b0c-0b2b-4638-9627-308d467987a1'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1b9f8d97-f223-402a-9a8d-1f1662371e9f/586 Southern Cone Mesopotamian savanna - Suomi 1973.jpg',
                    _id: '1b9f8d97-f223-402a-9a8d-1f1662371e9f'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/18e554e0-5d76-4462-a657-d118783ca15f/Bioregion%20map-NT3.jpg',
                content:
                  '<p>The Rio de la Plata bioregion, located in the Southern America (Neotropical) realm, extends from the Espinal drylands east of the Andes Mountains to the Atlantic Ocean, encompassing Argentina\u2019s humid pampas grasses and the flooded savannas formed by the Paran\u00e1 River and its tributaries. This bioregion also includes Uruguay\u2019s subtropical savanna, which forms the Northern border of the R\u00edo de la Plata estuary, containing five ecoregions in total \u2013 Uruguayan Savanna (574), Espinal (575), Humid Pampas (576), Paran\u00e1 Flooded Savanna (585), Southern Cone Mesopotamian Savanna (586) \u2013 as well as adjacent marine areas in the Atlantic Ocean. The total land area of this bioregion is more than 111 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/18e554e0-5d76-4462-a657-d118783ca15f/Bioregion%20map-NT3.jpg"/><figcaption><span class="caption"><p>The Rio de la Plata Grasslands bioregion is part of the South American Grasslands subrealm and is made up of five ecoregions: (1) Espinal (2) Humid Pampas (3) Paran\u00e1 Flooded Savanna (4) Southern Cone Mesopotamian Savanna (5) Uruguayan Savanna.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Rio de la Plata Grasslands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'd5951a74-66a6-4efb-9ba0-1176bf1df942' },
                  { title: 'Southern Cone Mesopotamian Savanna' },
                  { regionId: '586' },
                  {
                    dek:
                      'The Southern Cone Mesopotamian savanna ecoregion is grassland-wetland mosaic covering the region of Argentine \u201cMesopotamia."'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1b9f8d97-f223-402a-9a8d-1f1662371e9f/586 Southern Cone Mesopotamian savanna - Suomi 1973.jpg',
                      _id: '1b9f8d97-f223-402a-9a8d-1f1662371e9f'
                    }
                  },
                  { _id: '16956612-6e44-4d23-bd50-f464b93dd546' },
                  { title: 'Paran\u00e1 Flooded Savanna' },
                  { regionId: '585' },
                  {
                    dek:
                      'This ecoregion includes the floodplains of the middle and lower Paran\u00e1 River and its tributary, the Paraguay River.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b4b38b0c-0b2b-4638-9627-308d467987a1/585 Paran\u00e1 flooded savanna - Wikiwand.jpg',
                      _id: 'b4b38b0c-0b2b-4638-9627-308d467987a1'
                    }
                  },
                  { _id: '683c4492-d5a0-4c97-9ea8-4fb27a4f01a8' },
                  { title: 'Humid Pampas' },
                  { regionId: '576' },
                  {
                    dek:
                      'The Humid Pampas occupy the plains in the east of Argentina, taking up most of the province of Buenos Aires.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b316548e-f47d-4004-887d-fd1d6ca62a6e/576-Humid Pampas-Los Toldos-Argentina-Eco 576-CC-2006.jpg',
                      _id: 'b316548e-f47d-4004-887d-fd1d6ca62a6e'
                    }
                  },
                  { _id: '05f3c465-592c-4fc9-9313-20aa281dd057' },
                  { title: 'Espinal' },
                  { regionId: '575' },
                  {
                    dek:
                      'The Espinal ecoregion is in central Argentina extending from central Santa Fe through the province of C\u00f3rdoba to the north of San Luis.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e272bd38-32e8-4f0b-be32-c4e88886b23b/575-Argentine Espinal- Eco 575-CC-Claudio Elias-2008.JPG',
                      _id: 'e272bd38-32e8-4f0b-be32-c4e88886b23b'
                    }
                  },
                  { _id: '00ceff10-b940-4ba5-b23c-085f29eb7dd6' },
                  { title: 'Uruguayan Savanna' },
                  { regionId: '574' },
                  {
                    dek:
                      'This ecoregion extends from the extreme southern part of the Rio Grande do Sul, a Brazilian state, to include the entire country of Uruguay, and a small section of the Argentinean province of Entre R\u00edos.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/775d4fe1-8ac9-46b4-881b-daf96dc351ca/574 Uruguayan Savanna - Sheridon.jpg',
                      _id: '775d4fe1-8ac9-46b4-881b-daf96dc351ca'
                    }
                  }
                ],
                stats: [
                  { number: '111,665', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '24%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Patagonia Steppe & Low Mountains (NT2)',
                children: [],
                _id: 'c06a1e89-d20d-42fb-a695-5b7f29b0f5b4',
                value: 1000,
                parentId: '645211fe-cce5-417f-8871-a9f4f2a114b3',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e5bb7c8f-df9c-4d25-bae3-7ec90ebf2182/577- Talampaya National Park-Eco 577-CC-2006.jpg',
                    _id: 'e5bb7c8f-df9c-4d25-bae3-7ec90ebf2182'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/94bb8156-a853-4dce-b609-321d5e1661f6/578- Calafate-Argentina-Eco 578-CC-David Bartholow.jpg',
                    _id: '94bb8156-a853-4dce-b609-321d5e1661f6'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ce9c7958-39c8-4d86-9d64-8015b46f6c35/Bioregion%20map-NT2.jpg',
                content:
                  '<p>The Patagonia Steppe bioregion, located in the Southern America (Neotropical) realm, incorporates most of the temperate grassland biome of South America, between the Andes Mountains to the west and the Espinal drylands to the east. The bioregion contains two ecoregions \u2013 Low Monte (577), Patagonian Steppe (578) \u2013 and includes the Islas Malvinas (Falkland Islands) and adjacent marine areas in the southern Atlantic Ocean. The total land area of this bioregion is approximately 93 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ce9c7958-39c8-4d86-9d64-8015b46f6c35/Bioregion%20map-NT2.jpg"/><figcaption><span class="caption"><p>The Patagonia Steppe &amp; Low Mountains bioregion is part of the South American Grasslands subrealm and is made up of two ecoregions: (1) Patagonian Steppe (2) Low Monte.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Patagonia Steppe &amp; Low Mountains ecoregions below.&nbsp;</p>',
                ecoregions: [
                  { _id: '91866f85-94cf-42a4-a3b2-12d5e98d921c' },
                  { title: 'Patagonian Steppe' },
                  { regionId: '578' },
                  {
                    dek:
                      'This ecoregion mainly covers the Patagonia region of Argentina from the Atlantic Ocean shore and extends into southwestern Chile.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/96333c4a-8d5a-4cbf-8900-42a4ac7d762e/578- Patagonian steppe-Eco 578-Chile-CC-Jason Hollinger-2009.jpg',
                      _id: '96333c4a-8d5a-4cbf-8900-42a4ac7d762e'
                    }
                  },
                  { _id: '0ad807b9-a9e3-49d1-9031-6d21db562e58' },
                  { title: 'Low Monte' },
                  { regionId: '577' },
                  {
                    dek:
                      'The Low Monte is in north-central Argentina, extending along the eastern foothills of the Andes until reaching the Patagonian steppe, then extends eastwards to the Pacific Ocean.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1cf0665a-35ba-4c32-a17d-a070dcdbb2a0/577- Monte y de las Sierras-Argentina-Eco 577-CC-Christian Ostrosky-2009.jpg',
                      _id: '1cf0665a-35ba-4c32-a17d-a070dcdbb2a0'
                    }
                  }
                ],
                stats: [
                  { number: '93,076', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '54%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level ' }
                ]
              }
            ],
            parentId: 'Southern America',
            value: 375
          },
          {
            _id: 'b62b22ba-8e7d-4aee-a2fc-f3b43f519900',
            name: 'Brazil Cerrado & Atlantic Coast',
            children: [
              {
                name: 'Brazilian Atlantic Dry Forests (NT15)',
                children: [],
                _id: '83d3e7b5-17f4-42f0-827f-2519550dfa82',
                value: 1000,
                parentId: 'b62b22ba-8e7d-4aee-a2fc-f3b43f519900',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1a80cd15-7cb6-4a3b-9aaf-41926b349e0e/525 Caatinga - Ot\u00e1vio Nogueira.jpg',
                    _id: '1a80cd15-7cb6-4a3b-9aaf-41926b349e0e'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a2e4f861-d421-48a2-b8ef-f4434b815568/445 Caatinga Enclaves moist forests - Rapper Ouri\u00e7o.jpg',
                    _id: 'a2e4f861-d421-48a2-b8ef-f4434b815568'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2cb4cb6d-acd2-4d32-ba0a-ce1d1f4d31a9/540 Maranh\u00e3o Baba\u00e7u forests -Nando cunha.jpg',
                    _id: '2cb4cb6d-acd2-4d32-ba0a-ce1d1f4d31a9'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/690242a8-2f43-49a8-a75d-5d7ec2812ac8/Bioregion%20map-NT15.jpg',
                content:
                  '<p>The Brazilian Atlantic Dry Forests bioregion, located in the Southern America (Neotropical) realm, incorporates Brazil\u2019s southeastern cape and adjacent marine areas. With it\u2019s hot and dry climate, it is defined by a mosaic of shrublands, cacti, and thorny woodlands containing four distinct ecoregions \u2013 Caatinga Enclaves Moist Forests (445), Brazilian Atlantic Dry Forests (524), Caatinga (525), Maranh\u00e3o Baba\u00e7u Forests (540). The marine biodiversity of the bioregion is rich, with 57% of the fish species endemic to the area. The total land area of this bioregion is 100 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/690242a8-2f43-49a8-a75d-5d7ec2812ac8/Bioregion%20map-NT15.jpg"/><figcaption><span class="caption"><p>The Brazilian Atlantic Dry Forests bioregion is part of the Brazil Cerrado &amp; Atlantic Coast subrealm and is made up of four ecoregions: (1) Brazilian Atlantic Dry Forests (2) Caatinga (3) Caatinga Enclaves Moist Forests (4) Maranh\u00e3o Baba\u00e7u Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Brazilian Atlantic Dry Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'c5a6d23f-2f78-4d0f-9a3b-491d1f3ff0e5' },
                  { title: 'Maranh\u00e3o Baba\u00e7u Forests' },
                  { regionId: '540' },
                  {
                    dek:
                      'This ecoregion is located in eastern Brazil at the very eastern and southern flank of the Amazon Basin.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2cb4cb6d-acd2-4d32-ba0a-ce1d1f4d31a9/540 Maranh\u00e3o Baba\u00e7u forests -Nando cunha.jpg',
                      _id: '2cb4cb6d-acd2-4d32-ba0a-ce1d1f4d31a9'
                    }
                  },
                  { _id: 'd8bf5b0c-50e6-49ac-b3f0-b13337a1c65f' },
                  { title: 'Caatinga' },
                  { regionId: '525' },
                  {
                    dek:
                      'This ecoregion is the largest dry forest region in South America and one of the richest dry forests in the world.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bb509649-8657-479b-80bc-3bf0e10d2939/525-Caatinga-CC-Allan Patrick-2004.jpg',
                      _id: 'bb509649-8657-479b-80bc-3bf0e10d2939'
                    }
                  },
                  { _id: 'cb4e4334-d118-4126-aa4a-1becadfa777e' },
                  { title: 'Brazilian Atlantic Dry Forests' },
                  { regionId: '524' },
                  {
                    dek:
                      'This forest-dominated ecoregion is surrounded by open vegetation of Caatinga in the north and east and Cerrado in the west and south.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/628bc617-95ca-4035-ac23-bcce4231c7b9/524 Brazilian Atlantic dry forests - Diego Rego Monteiro.JPG',
                      _id: '628bc617-95ca-4035-ac23-bcce4231c7b9'
                    }
                  },
                  { _id: '7c14e4bc-64c0-422f-bda9-317f5080c5be' },
                  { title: 'Caatinga Enclaves Moist Forests' },
                  { regionId: '445' },
                  {
                    dek:
                      'This ecoregion consists of five established patches of Atlantic forest that are surrounded by a variety of dry Caatinga vegetation in northeast Brazil.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a2e4f861-d421-48a2-b8ef-f4434b815568/445 Caatinga Enclaves moist forests - Rapper Ouri\u00e7o.jpg',
                      _id: 'a2e4f861-d421-48a2-b8ef-f4434b815568'
                    }
                  }
                ],
                stats: [
                  { number: '99,875', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '14%', item: 'Protection Target' },
                  { number: '5', item: 'Protection Level' }
                ]
              },
              {
                name: 'Cerrado Savannas (NT13)',
                children: [],
                _id: '66514f7b-97de-4f98-a8f1-f01bbce83b9e',
                value: 1000,
                parentId: 'b62b22ba-8e7d-4aee-a2fc-f3b43f519900',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/421153e1-3baa-46e1-8290-3cc66d0a4a8b/567 Cerrado - Edmilson sanches.JPG',
                    _id: '421153e1-3baa-46e1-8290-3cc66d0a4a8b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/506da251-f109-4ef7-b83f-ded59ff88230/566 Campos Rupestres montane savanna - marciamaro.jpg',
                    _id: '506da251-f109-4ef7-b83f-ded59ff88230'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f1e7e061-3096-4a5e-9a6d-0cc0e97b3498/Bioregion%20map-NT13.jpg',
                content:
                  '<p>The Cerrado bioregion, located in the Southern America (Neotropical) realm, covers more than one-fifth of Brazil\u2019s total land area and consists of two ecoregions \u2013 &nbsp;Campos Rupestres Montane Savanna (566) Cerrado (567) \u2013 with gallery forests running along the streams and rivers. The bioregion is considered to be one of the richest tropical savannas in the world, containing 10,000 plant species, 200 mammal species, and 10 endemic bird species. The total area of this bioregion is 194 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f1e7e061-3096-4a5e-9a6d-0cc0e97b3498/Bioregion%20map-NT13.jpg"/><figcaption><span class="caption"><p>The Cerrado Savannas bioregion is part of the Brazil Cerrado &amp; Atlantic Coast subrealm and is made up of two ecoregions: (1) Cerrado (2) Campos Rupestres Montane Savanna</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Cerrado Savannas ecoregion below.</p>',
                ecoregions: [
                  { _id: 'cf7d5bac-d439-4e74-97b1-2db7d8b99d4b' },
                  { title: 'Cerrado' },
                  { regionId: '567' },
                  {
                    dek:
                      'Cerrado is the largest savanna region in South America and biologically the richest savanna in all the world.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/421153e1-3baa-46e1-8290-3cc66d0a4a8b/567 Cerrado - Edmilson sanches.JPG',
                      _id: '421153e1-3baa-46e1-8290-3cc66d0a4a8b'
                    }
                  },
                  { _id: '07034549-13ba-446b-932c-6a61336218d0' },
                  { title: 'Campos Rupestres Montane Savanna' },
                  { regionId: '566' },
                  {
                    dek:
                      'This ecoregion is part of the Espinha\u00e7o Mountain Range in Brazil, an ancient plateau formed by pre-Cambrian crystalline rocks that extend from the North Bahia southward to Serra do Ouro Branco.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/506da251-f109-4ef7-b83f-ded59ff88230/566 Campos Rupestres montane savanna - marciamaro.jpg',
                      _id: '506da251-f109-4ef7-b83f-ded59ff88230'
                    }
                  }
                ],
                stats: [
                  { number: '194,751', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '13%', item: 'Protection Target' },
                  { number: '9', item: 'Protection Level' }
                ]
              },
              {
                name: 'Pantanal Flooded Grasslands & Dry Forests (NT12)',
                children: [],
                _id: '280901a4-d287-4e2a-ac31-6ccad1c54b04',
                value: 1000,
                parentId: 'b62b22ba-8e7d-4aee-a2fc-f3b43f519900',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/be018752-f8b0-48f1-911e-057fa6e9f0d9/584-Pantanal,_Mato_Grosso,_Brasil-Eco 584-CC-2015_resized.jpg',
                    _id: 'be018752-f8b0-48f1-911e-057fa6e9f0d9'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/527ab175-b616-4769-b2bb-86c7a5432378/529 Chiquitano Dry Forest - Sam Beebe.jpg',
                    _id: '527ab175-b616-4769-b2bb-86c7a5432378'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cbb57403-9ab1-484a-b95f-146fddc77b09/Bioregion%20map-NT12.jpg',
                content:
                  '<p>The Pantanal bioregion, located in the Southern America (Neotropical) realm, lies just below the Amazon Basin straddling the border between Brazil and Bolivia. It consists of two intertwined ecoregions \u2013 Chiquitano Dry Forests (529), Pantanal (584) \u2013 fed by the Paraguay River and hundreds of small lakes. It contains both the world\u2019s largest tropical wetland and largest flooded grasslands, as well as fry tropical forests. A UNESCO heritage site, this bioregion has the highest concentration of bird, fish and vertebrate wildlife on the continent and is home to the world\u2019s largest jaguars. Its land area is approximately 40 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cbb57403-9ab1-484a-b95f-146fddc77b09/Bioregion%20map-NT12.jpg"/><figcaption><span class="caption"><p>The Pantanal Flooded Grasslands &amp; Dry Forests bioregion is part of the Brazil Cerrado &amp; Atlantic Coast subrealm and is made up of two ecoregions: (1) Chiquitano Dry Forests (2) Pantanal.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Pantanal Flooded Grasslands &amp; Dry Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'fdc36966-46d2-48f4-bf1d-54e072cd9efb' },
                  { title: 'Pantanal' },
                  { regionId: '584' },
                  {
                    dek:
                      'This ecoregion is located roughly in the center of South America, near the borders of Brazil, Bolivia, and Paraguay.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/146b19af-876b-4318-8168-18ab5d69f4a7/584 Pantanal - Alicia Yo.jpg',
                      _id: '146b19af-876b-4318-8168-18ab5d69f4a7'
                    }
                  },
                  { _id: '625c3ae9-3558-4b7f-805a-eaf77547d8fb' },
                  { title: 'Chiquitano Dry Forests' },
                  { regionId: '529' },
                  {
                    dek:
                      'Most of the Chiquitano forest lies within the eastern lowlands of Santa Cruz, Bolivia, with smaller patches extending into western Mato Grosso, Brazil.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/527ab175-b616-4769-b2bb-86c7a5432378/529 Chiquitano Dry Forest - Sam Beebe.jpg',
                      _id: '527ab175-b616-4769-b2bb-86c7a5432378'
                    }
                  }
                ],
                stats: [
                  { number: '40,250', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '69%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Brazilian Atlantic Moist Forests (NT14)',
                children: [],
                _id: 'ad0c1fd3-5173-4918-9640-1ccf04cf7a53',
                value: 1000,
                parentId: 'b62b22ba-8e7d-4aee-a2fc-f3b43f519900',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/506da251-f109-4ef7-b83f-ded59ff88230/566 Campos Rupestres montane savanna - marciamaro.jpg',
                    _id: '506da251-f109-4ef7-b83f-ded59ff88230'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eaa3edee-2ab9-47c8-9d3a-fff5580c2d52/439-Igazu Falls-Cataratas-Eco 439-CC-Enaldo Valadares-2013.jpg',
                    _id: 'eaa3edee-2ab9-47c8-9d3a-fff5580c2d52'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/356e3cba-4d26-4263-8e5f-20b2b616b96d/441 Atlantic Coast restingas - reginafaig.jpg',
                    _id: '356e3cba-4d26-4263-8e5f-20b2b616b96d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/61171014-0469-4352-89fa-bf0fa98893ea/442 Bahia Coastal Forests Daniele Longui Creative Commons.jpg',
                    _id: '61171014-0469-4352-89fa-bf0fa98893ea'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2f51a86c-862b-4443-9226-0e71cb857d98/491-Atlantic_forest-Eco 491-CC-Leonardo Brito-2008.JPG',
                    _id: '2f51a86c-862b-4443-9226-0e71cb857d98'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/59404dcb-1fde-4f71-b858-c5930d3be688/492-Rebio_serra_talhada-Eco492-CC-Jorge Delamare-2008.jpg',
                    _id: '59404dcb-1fde-4f71-b858-c5930d3be688'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e2e2b7a9-42d9-4ccd-acc5-93e053051a99/500-Jungle in Paran\u00e1, Brazil.-Eco500-CC-Nivaldo Arruda-2010.jpg',
                    _id: 'e2e2b7a9-42d9-4ccd-acc5-93e053051a99'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/05466bbc-05bd-4ef4-a302-91907517a1e4/Bioregion%20map-NT14rev.jpg',
                content:
                  '<p>The Brazilian Atlantic Moist Forests (Mata Atl\u00e2ntica) bioregion, located in the Southern America (Neotropical) realm, spans nearly the entire length of Brazil\u2019s eastern coast and consists almost entirely of tropical broadleaf forests, which extend into the heart of the Cerrado. The bioregion includes 12 ecoregions \u2013 Alto Paran\u00e1 Atlantic Forests (439), Araucaria Moist Forests (440), Atlantic Coast Restingas (441), Bahia Coastal Forests (442), Bahia Interior Forests (443), Fernando De Noronha-Atol Das Rocas Moist Forests (462), Pernambuco Coastal Forests (491), Pernambuco Interior Forests (492), Serra Do Mar Coastal Forests (500), Trindade-Martin Vaz Islands Tropical Forests (509), St. Peter and St. Paul Rocks (609), Southern Atlantic Brazilian Mangroves (616). The bioregion is home to hundreds of rare and endemic species of plants and animals, and one study found that the remaining forest harbors 20,000 species of plants, with almost 450 tree species found in a single hectare. Its total land area is approximately 123 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/05466bbc-05bd-4ef4-a302-91907517a1e4/Bioregion%20map-NT14rev.jpg"/><figcaption><span class="caption"><p>The Brazilian Atlantic Moist Forests bioregion is part of the Brazil Cerrado &amp; Atlantic Coast subrealm and is made up of 12 ecoregions: (1) Alto Paran\u00e1 Atlantic Forests (2) Araucaria Moist Forests (3) Atlantic Coast Restingas (4) Serra Do Mar Coastal Forests (5) Bahia Interior Forests (6) Bahia Coastal Forests (7) Trindade-Martin Vaz Islands Tropical Forests (8) Pernambuco Interior Forests (9) Pernambuco Coastal Forests (10) Southern Atlantic Brazilian Mangroves (11) Fernando De Noronha-Atol Das Rocas Moist Forests &nbsp;(12) St. Peter and St. Paul Rocks.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Brazilian Atlantic Moist Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '916a4593-0d35-468a-b3f2-fc6e06a27877' },
                  { title: 'Southern Atlantic Brazilian Mangroves' },
                  { regionId: '616' },
                  {
                    dek:
                      'The Southern Atlantic Brazilian Mangroves ecoregion comprises four subecoregions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0f5d95c6-209e-4b26-a8da-f4eb7ef170ab/616 Southern Atlantic Brazilian mangroves - Brigitte Werner.jpg',
                      _id: '0f5d95c6-209e-4b26-a8da-f4eb7ef170ab'
                    }
                  },
                  { _id: 'e0491dcf-79d2-4bd8-a7c6-63ab675f4f2d' },
                  { title: 'St. Peter and St. Paul Rocks' },
                  { regionId: '609' },
                  {
                    dek:
                      'More than 800 km from South America, St. Peter and St. Paul\u2019s Rocks are a small group of islands in the equatorial Atlantic Ocean. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4080c7e7-43ba-4260-bd8d-e03cac346ba9/609 St. Peter and St. Paul Rocks - John Vergari.jpg',
                      _id: '4080c7e7-43ba-4260-bd8d-e03cac346ba9'
                    }
                  },
                  { _id: '29bbdb00-aad9-4976-9f2d-39bd70b673d6' },
                  { title: 'Trindade-Martin Vaz Islands Tropical Forests' },
                  { regionId: '509' },
                  {
                    dek:
                      'The Trindade and Martin Vaz Archipelago is the most eastward point of Brazilian territory and is a result of volcanic activity deep below the Atlantic Ocean.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/64b36e8e-f597-492a-a0a0-278e4ebe20fa/509 Trindade-Martin Vaz Islands tropical forests - Simone Marinho.jpg',
                      _id: '64b36e8e-f597-492a-a0a0-278e4ebe20fa'
                    }
                  },
                  { _id: 'f9f2bc50-2a07-4ca7-b68c-a88f84cd0330' },
                  { title: 'Serra Do Mar Coastal Forests' },
                  { regionId: '500' },
                  {
                    dek:
                      'The Serra do Mar coastal forests cover a 100-km wide strip along the Atlantic Coast of Southern Brazil. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5bc774bf-b00f-4dc1-8834-0fac103daac6/500 Serra do Mar coastal forests - Bruno Urso.jpg',
                      _id: '5bc774bf-b00f-4dc1-8834-0fac103daac6'
                    }
                  },
                  { _id: '2df46576-834b-4c33-98ef-dbf53fd2e8ea' },
                  { title: 'Pernambuco Interior Forests' },
                  { regionId: '492' },
                  {
                    dek:
                      'Pernambuco Interior Forest is located in a narrow strip, approximately 50 km wide, between the ecoregions of Pernambuco Coastal Forests and Caatinga, in northeastern Brazil.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e4e73f00-d3c4-4611-ba09-b8d33e2ab07f/492 Pernambuco interior forests - lucianaclmv.jpg',
                      _id: 'e4e73f00-d3c4-4611-ba09-b8d33e2ab07f'
                    }
                  },
                  { _id: 'bb441f23-eedb-45ea-adad-27c9ea46d006' },
                  { title: 'Pernambuco Coastal Forests' },
                  { regionId: '491' },
                  {
                    dek:
                      'The Pernambuco Coastal Forests ecoregion is one of the most unique habitats in the Atlantic coast region of Brazil.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3f5a62bd-0d8a-40e6-abd2-518ace75bf08/491 Pernambuco coastal forests - IBAMA.jpg',
                      _id: '3f5a62bd-0d8a-40e6-abd2-518ace75bf08'
                    }
                  },
                  { _id: '051850fe-23e9-4696-8a74-2af596d9594b' },
                  { title: 'Fernando De Noronha-Atol Das Rocas Moist Forests' },
                  { regionId: '462' },
                  {
                    dek:
                      'The archipelago of Fernando de Noronha and its neighbor Atol das Rocas belong to the Fernando de Noronha Chain of submerged east-west volcanic mountains.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4ca28bfe-14f0-4fc6-8205-1f0a34d14eac/462 Fernando de Noronha-Atol das Rocas moist forests - Tadeu Pereira.jpg',
                      _id: '4ca28bfe-14f0-4fc6-8205-1f0a34d14eac'
                    }
                  },
                  { _id: '3565fb39-5504-4e50-9fcc-7bf37d26650e' },
                  { title: 'Bah\u00eda Interior Forests' },
                  { regionId: '443' },
                  {
                    dek:
                      'This ecoregion covers a large area, including the Brazilian states of Sergipe, Bah\u00eda, Minas Gerais, Esp\u00edrito Santo, and Rio de Janeiro. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/be005002-1803-42da-b411-2fdb190c9a87/443 Bahia interior forests Fernando Marino cc.jpg',
                      _id: 'be005002-1803-42da-b411-2fdb190c9a87'
                    }
                  },
                  { _id: '002f070b-98ce-4398-90bc-abd561ea0341' },
                  { title: 'Bahia Coastal Forests' },
                  { regionId: '442' },
                  {
                    dek:
                      'Bah\u00eda Coastal Forests have been given highest priority for biodiversity conservation by local governments because they harbor an extraordinary number of endemic species of vascular plants, birds, primates, and butterflies.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/61171014-0469-4352-89fa-bf0fa98893ea/442 Bahia Coastal Forests Daniele Longui Creative Commons.jpg',
                      _id: '61171014-0469-4352-89fa-bf0fa98893ea'
                    }
                  },
                  { _id: '5c9a1ef7-d66a-4fb9-bed8-b80fc18b170e' },
                  { title: 'Atlantic Coast Restingas' },
                  { regionId: '441' },
                  {
                    dek:
                      'Atlantic Coast Restingas consist of three well-defined areas of restinga forests distributed from northeastern to southeastern Brazil. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d8b768c2-55d0-4eb5-80d0-39dcb6eba37f/441 Parque_Nacional_da_Restinga_de_Jurubatiba_CC-Halley Pacheco de Oliveira.-2014jpg_resized.jpg',
                      _id: 'd8b768c2-55d0-4eb5-80d0-39dcb6eba37f'
                    }
                  },
                  { _id: '50b023ac-240d-4b9f-8f16-4885faa8b06c' },
                  { title: 'Araucaria Moist Forests' },
                  { regionId: '440' },
                  {
                    dek:
                      'This ecoregion is bordered on the north and west by the Alta Paran\u00e1 Atlantic Forests, on the south by the pampas grasslands, and on the east by Serra do Mar Coastal Moist Forests.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/df3ac226-ecb7-4cc4-aebf-1be2e6d095bf/440- Araucaria forest in Aparados da Serra National Park-Eco440-CC-Valerio Pillar-2005.jpg',
                      _id: 'df3ac226-ecb7-4cc4-aebf-1be2e6d095bf'
                    }
                  },
                  { _id: 'cda570b6-64e9-4e9c-b5bd-15064bc6ff43' },
                  { title: 'Alto Paran\u00e1 Atlantic Forests' },
                  { regionId: '439' },
                  {
                    dek:
                      'The Alto Paran\u00e1 Atlantic Forests represent a large block of Atlantic semi-deciduous forest spread from Southeast Brazil and Paraguay to northern Argentina.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eece9405-11ce-49c1-be58-9994a02c021d/439 Alto Paran\u00e1 Atlantic forests - miguelrangeljr.jpg',
                      _id: 'eece9405-11ce-49c1-be58-9994a02c021d'
                    }
                  },
                  { _id: '07034549-13ba-446b-932c-6a61336218d0' },
                  { title: 'Campos Rupestres Montane Savanna' },
                  { regionId: '566' },
                  {
                    dek:
                      'This ecoregion is part of the Espinha\u00e7o Mountain Range in Brazil, an ancient plateau formed by pre-Cambrian crystalline rocks that extend from the North Bahia southward to Serra do Ouro Branco.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/506da251-f109-4ef7-b83f-ded59ff88230/566 Campos Rupestres montane savanna - marciamaro.jpg',
                      _id: '506da251-f109-4ef7-b83f-ded59ff88230'
                    }
                  }
                ],
                stats: [
                  { number: '120,547', item: 'Total Land Area (1000 ha)' },
                  { number: '12', item: 'Number of Ecoregions' },
                  { number: '29%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Southern America',
            value: 500
          },
          {
            _id: 'aba37914-a595-42a3-8486-91d6890b5526',
            name: 'Amazonia',
            children: [
              {
                name: 'Northern Amazonian Forests (NT20)',
                children: [],
                _id: 'a4a890b5-d832-4b4a-8e69-b12038f6ec03',
                value: 1000,
                parentId: 'aba37914-a595-42a3-8486-91d6890b5526',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eaa28231-f568-4dc1-a645-3054ebbc8477/473 Japur\u00e1-Solim\u00f5es-Negro moist forests - Tom Karlo.jpg',
                    _id: 'eaa28231-f568-4dc1-a645-3054ebbc8477'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9a734e4f-bd62-48f9-9625-7051b5da2dce/511 Uatum\u00e3-Trombetas moist forests - Brigitte Werner.jpg',
                    _id: '9a734e4f-bd62-48f9-9625-7051b5da2dce'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ff67c306-bc49-4677-a0f3-630ea785fd6c/484 Negro-Branco moist forests - Fredrich Kircher.JPG',
                    _id: 'ff67c306-bc49-4677-a0f3-630ea785fd6c'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/faf65780-0830-4877-bb3f-6f1523bf915e/Bioregion%20map-NT20.jpg',
                content:
                  '<p>The Northern Amazonian bioregion, located in the Southern America (Neotropical) realm, lies between the Amazon River and the Guiana Shield and includes the Rio Negro, the principle northern tributary of the Amazon. The bioregion consists entirely of moist tropical forests, containing five ecoregions \u2013 Gurupa V\u00e1rzea (467), Japur\u00e1-Solim\u00f5es-Negro Moist Forests (473), Negro-Branco Moist Forests (484), Rio Negro Campinarana (498), Uatum\u00e3-Trombetas Moist Forests (511) \u2014 as well as the largest biological reserve in Brazil. The total area of this bioregion is approximately 105 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/faf65780-0830-4877-bb3f-6f1523bf915e/Bioregion%20map-NT20.jpg"/><figcaption><span class="caption"><p>The Northern Amazonian Forests bioregion is part of the Amazonia subrealm and is made up of five ecoregions: (1) Negro-Branco Moist Forests (2) Japur\u00e1-Solim\u00f5es-Negro Moist Forests (3) Rio Negro Campinarana (4) Uatum\u00e3-Trombetas Moist Forests (5) Gurupa V\u00e1rzea.</p></span> </figcaption></figure>\n<p>Learn more about each of the Northern Amazonian Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '8be014fc-0598-4f1a-be83-1cae4a6a55ee' },
                  { title: 'Uatum\u00e3-Trombetas Moist Forests' },
                  { regionId: '511' },
                  {
                    dek:
                      'Uatum\u00e3-Trombetas moist forests comprise the vast region north of the Amazon River in the eastern portion of Brazil, extending almost to the Atlantic coast and upwards to Guyana and Suriname. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9a734e4f-bd62-48f9-9625-7051b5da2dce/511 Uatum\u00e3-Trombetas moist forests - Brigitte Werner.jpg',
                      _id: '9a734e4f-bd62-48f9-9625-7051b5da2dce'
                    }
                  },
                  { _id: 'e74317c7-12d0-4a61-b95c-7b29d738a6df' },
                  { title: 'Rio Negro Campinarana' },
                  { regionId: '498' },
                  {
                    dek:
                      'This ecoregion occur as isolated patches \u201csand forest\u201d along the Rio Negro and Rio Branco basins in Venezuela and northern Brazil. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/31f5f398-380d-4f3b-b9e3-39bde4a73ac6/498 Rio Negro campinarana - IBGE.jpg',
                      _id: '31f5f398-380d-4f3b-b9e3-39bde4a73ac6'
                    }
                  },
                  { _id: '833f0ad9-b82c-4800-b0a6-b6262010e4f4' },
                  { title: 'Negro-Branco Moist Forests' },
                  { regionId: '484' },
                  {
                    dek:
                      'Rivers in the countries of Colombia, Venezuela, and Brazil bind the Negro-Blanco Moist Forests ecoregion. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ff67c306-bc49-4677-a0f3-630ea785fd6c/484 Negro-Branco moist forests - Fredrich Kircher.JPG',
                      _id: 'ff67c306-bc49-4677-a0f3-630ea785fd6c'
                    }
                  },
                  { _id: 'ff2171b6-3ba9-42cc-906f-e3cff938c8b8' },
                  { title: 'Japur\u00e1-Solim\u00f5es-Negro Moist Forests' },
                  { regionId: '473' },
                  {
                    dek:
                      'This ecoregion is situated on the lowland plateau in the central northern portion of the Amazon Basin in Brazil with tiny sections touching Colombia and Venezuela.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eaa28231-f568-4dc1-a645-3054ebbc8477/473 Japur\u00e1-Solim\u00f5es-Negro moist forests - Tom Karlo.jpg',
                      _id: 'eaa28231-f568-4dc1-a645-3054ebbc8477'
                    }
                  },
                  { _id: 'd165d1b9-547d-48ad-ad73-c38f7a9ded86' },
                  { title: 'Gurupa V\u00e1rzea' },
                  { regionId: '467' },
                  {
                    dek:
                      'The Gurupa v\u00e1rzea ecoregion is named for the large alluvial island, Ilha Grande de Gurup\u00e1, occurring in the mouth of the Amazon River. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/304d6fa4-f9dc-4ef7-8de4-ff7385ae9f55/467 Gurupa v\u00e1rzea - NASA.png',
                      _id: '304d6fa4-f9dc-4ef7-8de4-ff7385ae9f55'
                    }
                  }
                ],
                stats: [
                  { number: '105,232', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '93%', item: 'Protection Target' },
                  { number: '6', item: 'Protection Level' }
                ]
              },
              {
                name: 'Western Amazonian Forests & Plains (NT18)',
                children: [],
                _id: '6e241669-cf4c-46bc-bd37-c1e365aa22c4',
                value: 1000,
                parentId: 'aba37914-a595-42a3-8486-91d6890b5526',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/142b1fd4-5f9e-4f37-b885-6580cad051e7/469 Iquitos V\u00e1rzea EdwinJs cc.jpg',
                    _id: '142b1fd4-5f9e-4f37-b885-6580cad051e7'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/94236014-350c-4c72-be3b-2fe79cc76b3a/505-The riverbank of Man\u00fa National Park-Eco 505-CC-2007.jpg',
                    _id: '94236014-350c-4c72-be3b-2fe79cc76b3a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/032625ba-f428-4372-8d07-08f69bc3d961/512-Cordillera_Azul_National_Park_-_ZooKeys-Eco512-CC-Venegas P, Torres-Carvajal O, Duran V, Queiroz K-2013.jpg',
                    _id: '032625ba-f428-4372-8d07-08f69bc3d961'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c1783dab-8f80-41e1-8b2e-3e1a3ff7e8f5/Bioregion%20map-NT18.jpg',
                content:
                  '<p>The Western Amazonian bioregion, located in the Southern America (Neotropical) realm, stretches north from Bolivia to the Amazon river in Peru, contained by the Andes Mountains to the west. It consists mostly of moist and seasonally flooded tropical forests, but also incorporates savanna to the south that is encircled by forest. The bioregion contains four ecoregions \u2013 Iquitos V\u00e1rzea (469), Southwest Amazon Moist Forests (505), Ucayali Moist Forests (512), Beni Savanna (565) \u2013 and includes the western mainstem of the Amazon River, the Ucayali River, and several lakes in the South. The total area of this bioregion is approximately 111 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c1783dab-8f80-41e1-8b2e-3e1a3ff7e8f5/Bioregion%20map-NT18.jpg"/><figcaption><span class="caption"><p>The Western Amazonian Forests &amp; Plains bioregion is part of the Amazonia subrealm and is made up of four ecoregions: (1) Ucayali Moist Forests (2) Iquitos V\u00e1rzea (3) Southwest Amazon Moist Forests (4) Beni Savanna.&nbsp;</p></span> </figcaption></figure>\n<p>Explore the Western Amazonian Forests &amp; Plains ecoregions below.&nbsp;</p>',
                ecoregions: [
                  { _id: '1b711758-27a7-456e-bbf5-63e79cbba1c3' },
                  { title: 'Beni Savanna' },
                  { regionId: '565' },
                  {
                    dek:
                      'The Beni Savannas are the 3rd largest complex of savannas in South America.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bffea5aa-60b2-4540-b5a3-fac0a85e7661/565 Beni Savanna - Sam Beebe.jpg',
                      _id: 'bffea5aa-60b2-4540-b5a3-fac0a85e7661'
                    }
                  },
                  { _id: '5bd4c403-2142-4478-8ba3-db55f2d625dc' },
                  { title: 'Ucayali Moist Forests' },
                  { regionId: '512' },
                  {
                    dek:
                      'This ecoregion is located entirely within Peru at the foot of the Andes mountains and includes the basin west of the Ucayali river, a major branch of the Amazon river.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3b51f4b3-74e0-4922-9bd7-65ca4057fe47/512 Ucayali moist forests - Tadd _ Debbie Ottman.jpg',
                      _id: '3b51f4b3-74e0-4922-9bd7-65ca4057fe47'
                    }
                  },
                  { _id: '9b8e2caa-4f6e-4de1-b8dd-6ffd87801cf4' },
                  { title: 'Southwest Amazon Moist Forests' },
                  { regionId: '505' },
                  {
                    dek:
                      'The Southwest Amazon moist forest region covers an extensive area of the Upper Amazon Basin comprising four sub-basins.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/01d26ffd-e97e-4c16-aaed-6d2ecca9c6d6/505 Southwest Amazon moist forests - Gleilson Miranda _ State of Acre.jpg',
                      _id: '01d26ffd-e97e-4c16-aaed-6d2ecca9c6d6'
                    }
                  },
                  { _id: 'f8e97acb-1fac-4db1-b534-22988d76afe8' },
                  { title: 'Iquitos V\u00e1rzea' },
                  { regionId: '469' },
                  {
                    dek:
                      'This ecoregion  comprises the low and upper Amazon, Ucayali, Mara\u00f1on, Madre de Dios in Peru and Bolivia, and several smaller tributaries to the Amazon in Peru, and the upper Juru\u00e1 and Purus Rivers in Brazil.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/378352c9-a913-4acf-b7e7-ee9117975199/469 Iquitos v\u00e1rzea - Shao.JPG',
                      _id: '378352c9-a913-4acf-b7e7-ee9117975199'
                    }
                  }
                ],
                stats: [
                  { number: '110,816', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '90%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'Southern Amazonian Forests (NT17)',
                children: [],
                _id: '940d0d19-17a1-4a1d-8844-ec098d953cea',
                value: 1000,
                parentId: 'aba37914-a595-42a3-8486-91d6890b5526',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1b72df9a-1a26-4941-b9f1-53ea6c8c9465/507-Forest-Floresta Nacional do Jamanxim-Brazil-2-Eco 507-CC-Vinicius Mendonca-2014.jpg',
                    _id: '1b72df9a-1a26-4941-b9f1-53ea6c8c9465'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7559973e-a579-4aa4-a8de-806e0d8bad76/507-Forest-Floresta Nacional do Jamanxim-Brazil-Eco 507-CC-Vinicius Mendonca-2014.jpg',
                    _id: '7559973e-a579-4aa4-a8de-806e0d8bad76'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4f05e68e-ec43-4c8c-9ea6-2b750ea612e4/518-Carajas Mine-Eco 518-CC-2016.jpg',
                    _id: '4f05e68e-ec43-4c8c-9ea6-2b750ea612e4'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/37400027-637d-40f9-8b4a-9013dbbe27f7/Bioregion%20map-NT17.jpg',
                content:
                  '<p>The Southern Amazonian bioregion, located in the Southern America (Neotropical) realm, stretches from the Maraj\u00f3 Archipelago to Bolivia, south of the Amazon river. It consists almost entirely of highly diverse, tropical moist forest and incorporates the drier forests bordering the Cerrado. The bioregion contains four ecoregions \u2013 Madeira-Tapaj\u00f3s Moist Forests (476), Mato Grosso Tropical Dry Forests (481), Tapaj\u00f3s-Xingu Moist Forests (507), Xingu-Tocantins-Araguaia Moist Forests (518) \u2013 and includes many major and minor tributaries of the Amazon River. The total land area of this bioregion is approximately 174 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/37400027-637d-40f9-8b4a-9013dbbe27f7/Bioregion%20map-NT17.jpg"/><figcaption><span class="caption"><p>The Southern Amazonian Forests bioregion is part of the Amazonia subrealm and is made up of four ecoregions: (1) Madeira-Tapaj\u00f3s Moist Forests (2) Mato Grosso Tropical Dry Forests (3) Tapaj\u00f3s-Xingu Moist Forests (4) Xingu-Tocantins-Araguaia Moist Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Southern Amazonian Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'de92bf2b-3043-4525-bcbc-d3a64a1c43e8' },
                  { title: 'Xingu-Tocantins-Araguaia Moist Forests' },
                  { regionId: '518' },
                  {
                    dek:
                      'Located primarily between the Xingu and Lower Tocantins Rivers in Brazil, this ecoregion also includes the area around the Araguaia River. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2d8d422a-6711-41b8-9f8f-6dc3c2cb6c5c/518 Xingu-Tocantins-Araguaia moist forests - Instituto Araguaia.JPG',
                      _id: '2d8d422a-6711-41b8-9f8f-6dc3c2cb6c5c'
                    }
                  },
                  { _id: '31b980b5-0d64-4d8e-873c-5838ad1de531' },
                  { title: 'Tapaj\u00f3s-Xingu Moist Forests' },
                  { regionId: '507' },
                  {
                    dek:
                      'This ecoregion lies in central-eastern Brazil south of the Amazon River, comprising the interfluvial plain between the Tapaj\u00f3s and Xingu Rivers, both major tributaries to the Amazon River.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0ba284cf-1647-4271-a2d4-4093b59ef0ea/507 Tapaj\u00f3s-Xingu moist forests - Fred Almeida2016.jpg',
                      _id: '0ba284cf-1647-4271-a2d4-4093b59ef0ea'
                    }
                  },
                  { _id: '8e2e7262-b5b9-4387-9b5f-429aa4f52219' },
                  { title: 'Mato Grosso Tropical Dry Forests' },
                  { regionId: '481' },
                  {
                    dek:
                      'The Mato Grosso Tropical Dry Forests are in the Mato Grosso and Para provinces of central Brazil. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e914ee43-7375-4f14-8971-f1c275a7d9e5/481 Mato Grosso tropical dry forests - Fotografiaampl.jpg',
                      _id: 'e914ee43-7375-4f14-8971-f1c275a7d9e5'
                    }
                  },
                  { _id: '3836899f-1326-444b-90d7-e160bff0b7c9' },
                  { title: 'Madeira-Tapaj\u00f3s Moist Forests' },
                  { regionId: '476' },
                  {
                    dek:
                      'The ecoregion lies in central Amazonia, including a considerable expanse of land area between the Madeira and Tapaj\u00f3s Rivers (both major tributaries to the Amazon). '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f3fbf641-c005-49af-af43-22729f6d4c75/476 Madeira-Tapaj\u00f3s moist forests - deltreehd.jpg',
                      _id: 'f3fbf641-c005-49af-af43-22729f6d4c75'
                    }
                  }
                ],
                stats: [
                  { number: '174,029', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '73%', item: 'Protection Target' },
                  { number: '6', item: 'Protection Level' }
                ]
              },
              {
                name: 'Amazon River Estuary (NT16)',
                children: [],
                _id: 'b7cf26a8-84fc-4177-8889-e1420052001b',
                value: 1000,
                parentId: 'aba37914-a595-42a3-8486-91d6890b5526',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ed9750e4-2e62-41f4-b4b2-4f9ff61a7144/480-Ilha_de_Maraj\u00f3-Eco 480-CC-Nao Lizuka-2009.jpg',
                    _id: 'ed9750e4-2e62-41f4-b4b2-4f9ff61a7144'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ec64c5c7-6751-4ee9-a0d4-3a6377cfec79/508-Yellow-rumped cacique Found in Eco508-CC-Josue Soares-2016.jpg',
                    _id: 'ec64c5c7-6751-4ee9-a0d4-3a6377cfec79'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bae1b463-7176-490c-9e18-0f032335a9f0/611 Amazon-Orinoco-Southern Caribbean mangroves - Jorge Moyeja.JPG',
                    _id: 'bae1b463-7176-490c-9e18-0f032335a9f0'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5c965e08-59e0-4b90-b5ba-136c8f35e841/Bioregion%20map-NT16.jpg',
                content:
                  '<p>The Amazon River Estuary Bioregion, located in the Southern America (Neotropical) realm, includes a huge river delta formed at the end of the Amazon River\u2019s 4000-mile journey to the sea in northern Brazil, where it meets up with the Tocantins River, encompassing the Maraj\u00f3 Archipelago. It is the easternmost Amazonian bioregion consisting predominantly of tropical forest surrounding the delta and incorporates a narrow band of beach forests extending to the east with four ecoregions \u2013 Maraj\u00f3 V\u00e1rzea (480), Tocantins/Pindare Moist Forests (508), Northeast Brazil Restingas (485), Amazon-Orinoco-Southern Caribbean Mangroves (611). The total area of this bioregion is more than 31 million hectares, not including adjacent marine areas.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5c965e08-59e0-4b90-b5ba-136c8f35e841/Bioregion%20map-NT16.jpg"/><figcaption><span class="caption"><p>The Amazon River Estuary Bioregion is part of the Amazonia subrealm and is made up of four ecoregions: (1) Maraj\u00f3 V\u00e1rzea (2) Tocantins/Pindare Moist Forests (3) Northeast Brazil Restingas (4) Amazon-Orinoco-Southern Caribbean Mangroves.</p></span> </figcaption></figure>\n<p>Learn more about each of the Amazon River Estuary ecoregions below.</p>',
                ecoregions: [
                  { _id: '09a1fabd-b640-4f50-868d-ea126637b5f8' },
                  { title: 'Northeast Brazil Restingas' },
                  { regionId: '485' },
                  {
                    dek:
                      'The Northeastern Brazil Restingas extend approximately 400 km along a disjunct coastal strip, through the northern portions of the Brazilian states of Maranh\u00e3o, Piau\u00ed, and Cear\u00e1.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b3a887d3-a18b-40a7-b581-14f5deebe2dc/485 Northeast Brazil restingas - Mayra Pavanello Munerato.jpg',
                      _id: 'b3a887d3-a18b-40a7-b581-14f5deebe2dc'
                    }
                  },
                  { _id: '6e6f1ed4-44f9-4a75-ad99-f308c481165f' },
                  { title: 'Amazon-Orinoco-Southern Caribbean Mangroves' },
                  { regionId: '611' },
                  {
                    dek:
                      'The Amazon-Orinoco-Southern Caribbean Mangrove ecoregion is comprised of seven subecoregions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bae1b463-7176-490c-9e18-0f032335a9f0/611 Amazon-Orinoco-Southern Caribbean mangroves - Jorge Moyeja.JPG',
                      _id: 'bae1b463-7176-490c-9e18-0f032335a9f0'
                    }
                  },
                  { _id: '61f9454e-e570-4c5f-bbdd-a9024f3053c5' },
                  { title: 'Tocantins/Pindare Moist Forests' },
                  { regionId: '508' },
                  {
                    dek:
                      'In the Brazilian State of Par\u00e1, the ecoregion extends west to the Tocantins River and south to the Mearim River in Maranh\u00e3o State.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5235a236-bb03-47d6-ba3c-520edaabb1cd/508 TocantinsPindare moist forests - Cenapa ICMBio.jpg',
                      _id: '5235a236-bb03-47d6-ba3c-520edaabb1cd'
                    }
                  },
                  { _id: 'fc192655-e00d-4c5c-824d-d6f3331ebb1e' },
                  { title: 'Maraj\u00f3 V\u00e1rzea' },
                  { regionId: '480' },
                  {
                    dek:
                      'This v\u00e1rzea ecoregion comprises the entire Maraj\u00f3 Island, many smaller channel islands, and the surrounding mainland on both the northern and southern banks of the Amazon.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8ad734eb-9039-45c2-831c-4396b4cbe47a/480 Maraj\u00f3 v\u00e1rzea - Frank Kr\u00e4mer.jpg',
                      _id: '8ad734eb-9039-45c2-831c-4396b4cbe47a'
                    }
                  }
                ],
                stats: [
                  { number: ' 31,361 ', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '63%', item: 'Protection Target' },
                  { number: '5', item: 'Protection Level' }
                ]
              },
              {
                name: 'Central Amazonian Forests (NT19)',
                children: [],
                _id: '9f0bf0b0-cfcd-4527-ab4d-bf9c2768e346',
                value: 1000,
                parentId: 'aba37914-a595-42a3-8486-91d6890b5526',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/44ff9de7-f49f-4651-a25f-f2a6c4c3621c/482-Solim\u00f5es at Careiro da V\u00e1rzea-Eco 482-Brazil-CC-2014.JPG',
                    _id: '44ff9de7-f49f-4651-a25f-f2a6c4c3621c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5013eeab-0eeb-476e-8045-774fa1925362/483-Landscape with brown woolly monkey-eco483-Geoff Gallice-2010_resized.jpg',
                    _id: '5013eeab-0eeb-476e-8045-774fa1925362'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6c6b2ff5-8a1c-4683-a6b8-216b592d4b25/483- Cuyabeno Wildlife Reserve-Eco483-CC-2006.jpg',
                    _id: '6c6b2ff5-8a1c-4683-a6b8-216b592d4b25'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3056c331-a514-45dc-b2a8-2f98485a2007/Bioregion%20map-NT19.jpg',
                content:
                  '<p>The Central Amazonian forests bioregion, located in the Southern America (Neotropical) realm, contains the central mainstem of the Amazon River and includes three major tributaries\u2014the Japur\u00e1 in the north and the Madeira and Purus in the south\u2014forming what some call the \u201cheart\u201d of the Amazon. This bioregion is divided into eastern and western halves with seven ecoregions\u2014Caqueta Moist Forests (446), Juru\u00e1-Purus Moist Forests (474), Monte Alegre V\u00e1rzea (482), Napo Moist Forests (483), Purus Varzea (496), Purus-Madeira Moist Forests (497), Solim\u00f5es-Japur\u00e1 Moist Forests (503)\u2014unified by the seasonally flooded forests that line its rivers and streams, extending to the foot of the Andes Mountains in the north. It also includes many lakes formed at the junction of the Amazon River and its major tributaries. The total area of this bioregion is nearly 127 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3056c331-a514-45dc-b2a8-2f98485a2007/Bioregion%20map-NT19.jpg"/><figcaption><span class="caption"><p>The Central Amazonian Forests bioregion is part of the Amazonia subrealm and is made up of seven ecoregions: (1) Napo Moist Forests (2) Caqueta Moist Forests (3) Solim\u00f5es-Japur\u00e1 Moist Forests (4) Purus Varzea (5) Juru\u00e1-Purus Moist Forests (6) Monte Alegre V\u00e1rzea (7) Purus-Madeira Moist Forests.</p></span> </figcaption></figure>\n<p>Learn more about each of the Central Amazonian Forests ecoregions below. &nbsp;</p>',
                ecoregions: [
                  { _id: '70bcf6d1-412e-44a3-97f1-041e5050a413' },
                  { title: 'Solim\u00f5es-Japur\u00e1 Moist Forests' },
                  { regionId: '503' },
                  {
                    dek:
                      'This ecoregion lies on well-drained upland tertiary alluvial plains in western Amazonia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e0c2c2af-e465-4c27-9825-e8b33d9ecdcd/503 Solim\u00f5es-Japur\u00e1 moist forests - Rhett Butler.jpg',
                      _id: 'e0c2c2af-e465-4c27-9825-e8b33d9ecdcd'
                    }
                  },
                  { _id: '80459c1d-d0a8-4477-9658-6189e78dfc23' },
                  { title: 'Purus-Madeira Moist Forests' },
                  { regionId: '497' },
                  {
                    dek:
                      'The Purus-Madeira Moist Forest ecoregion lies in the center of the Brazilian Amazon, between the Purus and Madeira Rivers.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/11b35285-a633-4fec-b509-8d8c21c46c27/497 Purus-Madeira moist forests - Wikiwand.JPG',
                      _id: '11b35285-a633-4fec-b509-8d8c21c46c27'
                    }
                  },
                  { _id: 'ff7cbfd4-ca22-4cde-8ee0-a66e25cad734' },
                  { title: 'Purus V\u00e1rzea' },
                  { regionId: '496' },
                  {
                    dek:
                      'This ecoregion in Brazil comprises portions of the low, seasonally flooded river basins of the central Amazon.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/30e4f6a9-1345-415d-8d43-4cc870c1af30/496 Purus varzea - Rhett Butler.jpg',
                      _id: '30e4f6a9-1345-415d-8d43-4cc870c1af30'
                    }
                  },
                  { _id: 'd097fd5a-4d45-4941-aba1-1b811464d68a' },
                  { title: 'Napo Moist Forests' },
                  { regionId: '483' },
                  {
                    dek:
                      'The Rio Napo ecoregion covers the north-western portion of Peru, the Amazon region of Ecuador, and the southwestern corner of Colombia\u2019s Amazon.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0ee3feed-dba0-4054-8fc7-c531671a199c/483 Napo moist forests - Helena Cuerva.jpg',
                      _id: '0ee3feed-dba0-4054-8fc7-c531671a199c'
                    }
                  },
                  { _id: 'fa9ed5ec-f9c4-4556-9779-12efee1c7dd7' },
                  { title: 'Monte Alegre V\u00e1rzea' },
                  { regionId: '482' },
                  {
                    dek:
                      'This ecoregion in Brazil comprises portions of the low, seasonally flooded river basins of the central and lower Amazon.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/65e1bc0c-45a6-4247-99c3-332c61ffdfd6/482 Monte Alegre v\u00e1rzea - Neil Palmer CIAT.jpg',
                      _id: '65e1bc0c-45a6-4247-99c3-332c61ffdfd6'
                    }
                  },
                  { _id: 'cf4bb4af-6e1e-4f80-a27e-17423884f68a' },
                  { title: 'Juru\u00e1-Purus Moist Forests' },
                  { regionId: '474' },
                  {
                    dek:
                      'The Juru\u00e1-Purus Moist Forests ecoregion covers the valleys between the westernmost Amazon River to the Purus River. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a1039651-0be2-42b3-9894-51ce147cc87c/474 Juru\u00e1-Purus moist forests - Wilson Dias Agencia Brasil.jpg',
                      _id: 'a1039651-0be2-42b3-9894-51ce147cc87c'
                    }
                  },
                  { _id: 'e228f65f-1922-4b68-a12e-ad1eeedc455d' },
                  { title: 'Caqueta Moist Forests' },
                  { regionId: '446' },
                  {
                    dek:
                      'The Caquet\u00e1 Moist Forest occurs in the Colombian Amazon. It is bound on the northeast by the Guain\u00eda, Guaviare, and Guayabero Rivers and on the western extreme by the small Rio Losada, south of the Serran\u00eda de la Macarena.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f21b59de-93fb-471f-8769-56830b46b107/446 Caqueta moist forests - Carlos Casta\u00f1o Uribe.jpg',
                      _id: 'f21b59de-93fb-471f-8769-56830b46b107'
                    }
                  }
                ],
                stats: [
                  { number: '126,728', item: 'Total Land Area (1000 ha) ' },
                  { number: '7', item: 'Number of Ecoregions' },
                  { number: '94%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Southern America',
            value: 625
          },
          {
            _id: 'b3d26a87-a2d7-4299-9c35-f0c22c71fcb2',
            name: 'Upper South America',
            children: [
              {
                name: 'Venezuelan Coast (NT23)',
                children: [],
                _id: '3e7768ec-5522-48a0-8fe7-3904838fda64',
                value: 1000,
                parentId: 'b3d26a87-a2d7-4299-9c35-f0c22c71fcb2',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c9cccb8f-0e6c-4a81-bab7-8f214b0ff914/447-Parque Nacional Ci\u00e9nagas del Catatumbo-Eco 447-Juan Pablo Bottaro-2014.jpg',
                    _id: 'c9cccb8f-0e6c-4a81-bab7-8f214b0ff914'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1634fc05-7b76-45ee-803e-522cd2610320/456-Wikipedia_Cordillera_de_la_Costa-Eco 456-CC-Radoslaw Labno-2008.JPG',
                    _id: '1634fc05-7b76-45ee-803e-522cd2610320'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f99507e7-880c-456e-9b71-92dd44b8d613/536 Lara-Falc\u00f3n Dry Forests Juan Carlo Castillo Ortega.jpeg',
                    _id: 'f99507e7-880c-456e-9b71-92dd44b8d613'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8b22cde9-96ba-444f-ab56-c0b0b09623c4/597-Stenocereus_heptagonus_from_Macanao_Peninsula-Eco 597-CC-2013.jpg',
                    _id: '8b22cde9-96ba-444f-ab56-c0b0b09623c4'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/23a42283-0d87-4813-9772-2f56d886123f/602-Cabo de la Vela-Colombia-eco 602-CC-2008_resized.jpg',
                    _id: '23a42283-0d87-4813-9772-2f56d886123f'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/73180357-7a67-400b-b441-cf8fbb34fb1c/602 Guajira-Barranquilla xeric scrub - Adam Timpf.JPG',
                    _id: '73180357-7a67-400b-b441-cf8fbb34fb1c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/312a322c-37f0-41be-b113-36bce5c5235a/603-Parque Nacional Avila-Eco 603-CC-Katherine Gomez-2013.jpg',
                    _id: '312a322c-37f0-41be-b113-36bce5c5235a'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e2b28236-4597-4f0d-a641-32aa5cacfa24/Bioregion%20map-NT23.jpg',
                content:
                  '<p>The Venezuelan Coast bioregion, located in the Southern America (Neotropical) realm, runs the length of South America\u2019s Caribbean coastline. It is largely dominated by dry coastal scrublands interspersed with pockets of moist tropical forest, as well as dry tropical forest and the ice-capped Sierra Nevada de Santa Marta plateau, which many indigenous tribes believe to be the \u201cbeating heart\u201d of the continent. The bioregion contains 11 terrestrial ecoregions \u2013 Catatumbo Moist Forests (447), Cordillera de la Costa Montane Forests (456), Santa Marta Montane Forests (499), Lara-Falc\u00f3n Dry Forests (536), Maracaibo Dry Forests (539), Sin\u00fa Valley Dry Forests (546), Santa Marta P\u00e1ramo (594), Araya and Paria Xeric Scrub (597), Guajira-Barranquilla Xeric Scrub (602), La Costa Xeric Shrublands (603), Paraguana Xeric Scrub (606) \u2013 as well as Amazon-Orinoco-Southern Caribbean Mangroves (611). The total area of this bioregion is nearly 24 million hectares, not including adjacent marine areas.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e2b28236-4597-4f0d-a641-32aa5cacfa24/Bioregion%20map-NT23.jpg"/><figcaption><span class="caption"><p>The Venezuelan Coast bioregion is part of the Upper South America subrealm and is made up of 12 ecoregions: (1) Guajira-Barranquilla Xeric Scrub (2) Araya and Paria Xeric Scrub (3) Sin\u00fa Valley Dry Forests (4) Santa Marta Montane Forests (5) Santa Marta P\u00e1ramo (6) Maracaibo Dry Forests (7) Catatumbo Moist Forests (8) Paraguana Xeric Scrub (9) Lara-Falc\u00f3n Dry Forests (10) Cordillera de la Costa Montane Forests (11) La Costa Xeric Shrublands (12) Amazon-Orinoco-Southern Caribbean Mangroves.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Venezuelan Coast ecoregions below.</p>',
                ecoregions: [
                  { _id: '51e4c5f3-073a-4539-a7e1-73c54430a32c' },
                  { title: 'Paraguana Xeric Scrub' },
                  { regionId: '606' },
                  {
                    dek:
                      'This ecoregion lies within two of the four existing physiographic provinces, which are characterized by distinct geography and landscape features, in the northwest region of Venezuela.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/55bb6cff-4b04-46ca-89da-0895314d1914/606 Paraguan\u00e1 xeric scrub - Jujovar2010.jpg',
                      _id: '55bb6cff-4b04-46ca-89da-0895314d1914'
                    }
                  },
                  { _id: 'c2cc59a7-b393-40b6-8fba-d23ac0cee18e' },
                  { title: 'La Costa Xeric Shrublands' },
                  { regionId: '603' },
                  {
                    dek:
                      'The La Costa Xeric Shrublands are part of the Coastal Cordillera geographical region in northern Venezuela.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b38765f0-c378-4ca2-bc19-3ba8a36f3273/603 La Costa xeric shrublands - Kate Stevenson and Daniel Poulter_resized.jpg',
                      _id: 'b38765f0-c378-4ca2-bc19-3ba8a36f3273'
                    }
                  },
                  { _id: '9e9b5d92-0c6f-4a93-9613-71167b76564e' },
                  { title: 'Guajira-Barranquilla Xeric Scrub' },
                  { regionId: '602' },
                  {
                    dek:
                      'The Guajira-Barranquilla Xeric Scrub is found within three enclaves in parts of Venezuela and Colombia along the Caribbean Sea.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/da457b3d-2b0a-4671-92f3-6aaee94a02cd/602-Dividivi_on_aruba- Found in eco 602-CC.jpg',
                      _id: 'da457b3d-2b0a-4671-92f3-6aaee94a02cd'
                    }
                  },
                  { _id: '1e08e423-503c-44d8-ac00-d943848b0798' },
                  { title: 'Araya and Paria Xeric Scrub' },
                  { regionId: '597' },
                  {
                    dek:
                      'The ecoregion extends through portions of Margarita Island, the Araya-Paria peninsula, and onto the mainland of Cuman\u00e1 in Venezuela.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dc761dc3-bbb8-4153-bbf8-356d6a314b32/597 Araya and Paria xeric scrub - JP Ferrer Paris.jpg',
                      _id: 'dc761dc3-bbb8-4153-bbf8-356d6a314b32'
                    }
                  },
                  { _id: '9a624473-6528-4de8-a622-f1ed98bfb69f' },
                  { title: 'Santa Marta P\u00e1ramo' },
                  { regionId: '594' },
                  {
                    dek:
                      'The Santa Marta p\u00e1ramos are the northernmost occurrence of this habitat type in South America. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/86a8858f-5a88-4e05-9bca-7f3578d3ec9d/594-Pico_Cristobal_Colon in Eco594-CC-Sylvain Perret-2008.jpg',
                      _id: '86a8858f-5a88-4e05-9bca-7f3578d3ec9d'
                    }
                  },
                  { _id: '16bb8de4-24a0-4e5c-84bd-a8306ce20c7b' },
                  { title: 'Sin\u00fa Valley Dry Forests' },
                  { regionId: '546' },
                  {
                    dek:
                      'This ecoregion is situated at the northwestern extreme of the Andes, near the Darien-Panama bridge and between two major ecoregions\u2014Choc\u00f3 Wet Forests and Magdalena Medio Rain Forests.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/57bbb5d5-63e8-42d4-b120-edff2fb49ccd/Sinu\u0301 Valley Dry Forests. Courtesy of David Tryse 3.jpg',
                      _id: '57bbb5d5-63e8-42d4-b120-edff2fb49ccd'
                    }
                  },
                  { _id: '7a33ad25-6e45-428d-ac04-3e0c1a2a3f98' },
                  { title: 'Maracaibo Dry Forests' },
                  { regionId: '539' },
                  {
                    dek:
                      'The Maracaibo Dry Forests are located in the northwestern coastal area of Venezuela. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/447c2375-7a30-4105-be64-924d44f45ba9/539 Maracaibo dry forests - Lucia Mafilito.jpg',
                      _id: '447c2375-7a30-4105-be64-924d44f45ba9'
                    }
                  },
                  { _id: 'f61bd41f-e8a3-4ae2-b62f-75885b2338b4' },
                  { title: 'Lara-Falc\u00f3n Dry Forests' },
                  { regionId: '536' },
                  {
                    dek:
                      'The Lara-Falc\u00f3n Dry Forests lie in northern Venezuela, south of the Paraguana Peninsula, east of the Gulf of Maracaibo, and north of the Andes. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5560d266-70f5-4ca5-ab41-632d67f2ca3d/536 Lara-Falc\u00f3n dry forests - Luisovalles.jpg',
                      _id: '5560d266-70f5-4ca5-ab41-632d67f2ca3d'
                    }
                  },
                  { _id: 'fd1ea605-8b28-4e1b-9733-bd04e883e452' },
                  { title: 'Santa Marta Montane Forests' },
                  { regionId: '499' },
                  {
                    dek:
                      'The Santa Marta Montane Forest ecoregion lies in northern Colombia in the extreme northwest of South America.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a982438b-e18a-430c-b6f4-5026ed9eebba/499-Primary forest in Sierra Nevada da Santa Marta-Eco499-CC-Daisy Tarrier-2011.JPG',
                      _id: 'a982438b-e18a-430c-b6f4-5026ed9eebba'
                    }
                  },
                  { _id: 'fe61a4d2-d6f5-4b5a-bdbb-b970c8128929' },
                  { title: 'Cordillera de la Costa Montane Forests' },
                  { regionId: '456' },
                  {
                    dek:
                      'The Cordillera de la Costa Montane Forests ecoregion extends 720 km from east to west along the northern coast of Venezuela.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b626e201-da76-4e61-ada3-f367fbeda83f/456 Cordillera La Costa montane forests - Cristobal Alvarado Minic.jpg',
                      _id: 'b626e201-da76-4e61-ada3-f367fbeda83f'
                    }
                  },
                  { _id: 'f62d2ece-fde9-4f37-9385-c459b56d1cf5' },
                  { title: 'Catatumbo Moist Forests' },
                  { regionId: '447' },
                  {
                    dek:
                      'These Forests exist as four distinct regions within the Catatumbo Valley, and are comprised of isolated mountain, lowlands, Andean foothills, and valleys.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fcae3668-acc4-4aeb-98d5-dbb359738516/447 Catatumbo moist forests - Parque Nacional Natural Catatumbo Bar\u00ed.jpg',
                      _id: 'fcae3668-acc4-4aeb-98d5-dbb359738516'
                    }
                  },
                  { _id: '6e6f1ed4-44f9-4a75-ad99-f308c481165f' },
                  { title: 'Amazon-Orinoco-Southern Caribbean Mangroves' },
                  { regionId: '611' },
                  {
                    dek:
                      'The Amazon-Orinoco-Southern Caribbean Mangrove ecoregion is comprised of seven subecoregions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bae1b463-7176-490c-9e18-0f032335a9f0/611 Amazon-Orinoco-Southern Caribbean mangroves - Jorge Moyeja.JPG',
                      _id: 'bae1b463-7176-490c-9e18-0f032335a9f0'
                    }
                  }
                ],
                stats: [
                  { number: '23,719 ', item: 'Total Land Area (1000 ha)' },
                  { number: '12', item: 'Number of Ecoregions' },
                  { number: '48%', item: 'Protection Target' },
                  { number: '8', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Llanos & Dry Forests (NT22)',
                children: [],
                _id: '00946f20-cbca-48c1-ad34-bba50e09ddca',
                value: 1000,
                parentId: 'b3d26a87-a2d7-4299-9c35-f0c22c71fcb2',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5a9ac24c-e238-43fc-aa78-8b1a14057ed6/520-Villavicencio,_Meta,_Colombia_-_panoramio in Eco 520-CC-2011.jpg',
                    _id: '5a9ac24c-e238-43fc-aa78-8b1a14057ed6'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/84bc98bd-6126-486e-a347-e245c8857783/572-Llanos-Columbia-Eco 572-CC-Neil Palmer(CIAT)-2011.jpg',
                    _id: '84bc98bd-6126-486e-a347-e245c8857783'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/747eb265-c58d-40ec-a216-154a913673f9/572-Llanos-Eco572-CC-Laura De Oliveira-2012.JPG',
                    _id: '747eb265-c58d-40ec-a216-154a913673f9'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/13dc4cc1-15d6-4a85-8ec0-9f617b2bc80f/Bioregion%20map-NT22.jpg',
                content:
                  '<p>The Llanos bioregion, located in the Southern America (Neotropical) realm, extends from the northern Andes above the Guiana Shield. It consists almost entirely of open, grassy plains called (llanos) with dry tropical forests at the foothills of the Andes. It has two ecoregions \u2013 Apure-Villavicencio Dry Forests (520), Llanos (572) \u2013 and includes much of the Orinoco and Apure rivers. The total area of this bioregion is nearly 45 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/13dc4cc1-15d6-4a85-8ec0-9f617b2bc80f/Bioregion%20map-NT22.jpg"/><figcaption><span class="caption"><p>The Llanos &amp; Dry Forests bioregion is part of the Upper South America subrealm and is made up of two ecoregions: (1) Apure-Villavicencio Dry Forests (2) Llanos.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Llanos &amp; Dry Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '20ce7734-80c9-4b07-9315-c95344762e43' },
                  { title: 'Llanos' },
                  { regionId: '572' },
                  {
                    dek:
                      'The Llanos ecoregion is an area of extensive plains, covered mainly by savanna vegetation, and of great economic importance for Venezuela and Colombia. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aa9fc326-cb2c-403c-8fda-f030e7062112/572-La_Gran_Sabana-Eco572-CC-2008.jpg',
                      _id: 'aa9fc326-cb2c-403c-8fda-f030e7062112'
                    }
                  },
                  { _id: '1ec46ff7-a055-470e-aca3-9e198c9d7893' },
                  { title: 'Apure-Villavicencio Dry Forests' },
                  { regionId: '520' },
                  {
                    dek:
                      'The Apure-Villavicencio Dry Forests border the eastern Cordillera de M\u00e9rida from Venezuela to the Serran\u00eda de Macarena in Colombia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/68c2e750-3e99-4524-8e22-fd2965708962/520 Apure-Villavicencio dry forests - Jerzy Andrzej Kucia.jpg',
                      _id: '68c2e750-3e99-4524-8e22-fd2965708962'
                    }
                  }
                ],
                stats: [
                  { number: '44,694', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '40%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'Guianan Forests & Savanna (NT21)',
                children: [],
                _id: '3dba05d3-6673-4102-b6e9-6895415c10cc',
                value: 1000,
                parentId: 'b3d26a87-a2d7-4299-9c35-f0c22c71fcb2',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c8ef9973-48ce-4979-9df1-20e96cedf458/463-Manglares_-_Parque_Nacional_Morrocoy-Eco 463-CC-Jorge Moyeja-2011.JPG',
                    _id: 'c8ef9973-48ce-4979-9df1-20e96cedf458'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9d401fb1-9d7b-4f5c-8210-3cb01d5e608c/465 Guianan lowland moist forests - Rhett Butler.jpg',
                    _id: '9d401fb1-9d7b-4f5c-8210-3cb01d5e608c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7d8d9baf-6dd6-42e3-a6a1-e01f7fa7860b/570-Yurani river-Eco 570-CC-Daniel Mendez-2014_resized.jpg',
                    _id: '7d8d9baf-6dd6-42e3-a6a1-e01f7fa7860b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/64d5ccb5-95e0-4265-8d9d-bbe38b223057/570-Yuruani_tepuy_y_rio-Gran Sabana-Eco 507-CC-Paolo Costa Baldi-2011.jpg',
                    _id: '64d5ccb5-95e0-4265-8d9d-bbe38b223057'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/73e36c74-b2ce-407b-a506-9c7860c54eb2/570- Kukenan and Roraima tepuis-Gran Sabana-Venezuela-Eco 570-CC-Paolo Cosat Baldi-2010.JPG',
                    _id: '73e36c74-b2ce-407b-a506-9c7860c54eb2'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9e866155-a492-4b97-8199-01cd925df018/Bioregion%20map-NT21.jpg',
                content:
                  '<p>The Guianan bioregion, located in the Southern America (Neotropical) realm, extends from the eastern edge of the Guiana shield, at the border of Venezuela and Colombia, to the Atlantic coast. It contains the Guiana Highlands with its rocky plateaus that are the source for many waterfalls including the world\u2019s highest, Angel Falls. The bioregion is covered in dense tropical forest and also includes the Guinan savannas, with nine terrestrial ecoregions \u2013 Guianan Freshwater Swamp Forests (463), Guianan Highlands Moist Forests (464), Guianan Lowland Moist Forests (465), Guianan Piedmont Moist Forests (466), Orinoco Delta Swamp Forests (488), Pantepui Forests and Shrublands (490), Trinidad and Tobago Moist Forest (510), Trinidad and Tobago Dry Forests (548), Guianan Savanna (570) \u2013 as well as significant stands of Amazon-Orinoco-Southern Caribbean Mangroves (611) and Orinoco Wetlands (583). This bioregion is considered one of the most biodiverse in the world with 3000 vertebrate species and over 13,000 plant species, two-fifths of which are endemic. The total area of this bioregion is approximately 106 million hectares, not including adjacent marine areas.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9e866155-a492-4b97-8199-01cd925df018/Bioregion%20map-NT21.jpg"/><figcaption><span class="caption"><p>The Guianan Forests &amp; Savanna bioregion bioregion is part of the Upper South America subrealm and is made up of 11 ecoregions: (1) Guianan Savanna (2) Pantepui Forests and Shrublands (3) Guianan Highlands Moist Forests (4) Guianan Piedmont Moist Forests (5) Orinoco Delta Swamp Forests (6) Orinoco Wetlands (7) Trinidad and Tobago Dry Forests (8) Trinidad and Tobago Moist Forest (9) Guianan Lowland Moist Forests (10) Guianan Freshwater Swamp Forests (11) Amazon-Orinoco-Southern Caribbean Mangroves.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Guianan Forests &amp; Savanna ecoregions below.</p>',
                ecoregions: [
                  { _id: '8bf96a67-0406-4d52-a6bf-d4deacdbb008' },
                  { title: 'Guianan Piedmont Moist Forests' },
                  { regionId: '466' },
                  {
                    dek:
                      'A transitional ecoregion between the mountainous Pantepui forests and shrublands and Guianan highland moist forest and surrounding dry forests (Llanos) to the north and rain forests (Amazon Basin) to the south.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/17a15f15-128d-42bf-8ad2-629942ed3cf9/466 Guianan piedmont moist forests - D Olson_resized.jpg',
                      _id: '17a15f15-128d-42bf-8ad2-629942ed3cf9'
                    }
                  },
                  { _id: '3992b5ed-9a76-441f-9259-cf1d3c610b13' },
                  { title: 'Orinoco Wetlands' },
                  { regionId: '583' },
                  {
                    dek:
                      'The ecoregion is located to the north of the Orinoco River Delta, the second largest river in the Neotropics, in eastern Venezuela.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/df81d396-fe02-415a-ba9e-5b5edcccfcd5/583 Orinoco wetlands - Erik Cleves Kristensen.jpg',
                      _id: 'df81d396-fe02-415a-ba9e-5b5edcccfcd5'
                    }
                  },
                  { _id: '2afbf9c0-d7d8-4e54-af8b-a8d9ea2b414b' },
                  { title: 'Guianan Savanna' },
                  { regionId: '570' },
                  {
                    dek:
                      'The Gran Sabana patch is recognized as an important plant refuge and dispersal center, with several reported endemic species.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a35517f7-97fe-4dcc-94a2-fb6494591dbf/570 Guianan savannas - Fev.jpg',
                      _id: 'a35517f7-97fe-4dcc-94a2-fb6494591dbf'
                    }
                  },
                  { _id: 'cda05b40-3ba9-412b-a9a0-12bed0bc84d9' },
                  { title: 'Trinidad and Tobago Dry Forests' },
                  { regionId: '548' },
                  {
                    dek:
                      'This ecoregion covers a small portion of land in the northwest of Trinidad and the very northern end of Tobago.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3ffb309a-8143-419b-9fae-bb151c7edbcd/548 Trinidad and Tobago dry forest - FB Lucas.JPG',
                      _id: '3ffb309a-8143-419b-9fae-bb151c7edbcd'
                    }
                  },
                  { _id: 'b821d05f-badb-4615-b209-65d16288e1b8' },
                  { title: 'Trinidad and Tobago Moist Forest' },
                  { regionId: '510' },
                  {
                    dek:
                      'This moist forest ecoregion comprises approximately 90% of the land area of the archipelagic state of Trinidad and Tobago.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/33e3eca3-3045-4588-92e0-a15fc51b95e9/510 Trinidad and Tobago moist forest - mconnors_resized.jpg',
                      _id: '33e3eca3-3045-4588-92e0-a15fc51b95e9'
                    }
                  },
                  { _id: '88fa5fc3-cc2f-47d7-8cd3-27baf2a2dae3' },
                  { title: 'Pantepui Forests and Shrublands' },
                  { regionId: '490' },
                  {
                    dek:
                      'The landscape of Pantepui Forests & Shrublands ecoregion perforate an extensive matrix of highland savannas and rain forests across southern Venezuela, Guayana, Suriname, and Brazil. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/52348f13-9182-4c5e-8980-a904c38df448/490 Pantepui forests _ shrublands - Misstetei.JPG',
                      _id: '52348f13-9182-4c5e-8980-a904c38df448'
                    }
                  },
                  { _id: '037dbaad-ddb9-4eb1-85ce-b83808bdc63b' },
                  { title: 'Orinoco Delta Swamp Forests' },
                  { regionId: '488' },
                  {
                    dek:
                      'This ecoregion occurs in a continuous expanse of flooded forests and wetlands, occurring from the southern reaches of the Paria Peninsula in northern Venezuela.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7352222e-e292-4cb5-85fa-5d8027d7579a/488 Orinoco Delta swamp forests - milito.jpg',
                      _id: '7352222e-e292-4cb5-85fa-5d8027d7579a'
                    }
                  },
                  { _id: '833aa69f-f126-40e0-9785-25700a0b0f2a' },
                  { title: 'Guianan Lowland Moist Forests' },
                  { regionId: '465' },
                  {
                    dek:
                      'This region is located on the northeastern coast of South America. The Amazon basin lies to the south and the Orinoco borders on the west. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5e74404d-ffe8-4698-9bc7-dfd295d4c48a/465-Waterfall_near_Paramakatoi-Eco 465-CC-Kevin Gabbert-2008.jpg',
                      _id: '5e74404d-ffe8-4698-9bc7-dfd295d4c48a'
                    }
                  },
                  { _id: '73c67a77-2c97-4200-8f4f-7fc505d91ecb' },
                  { title: 'Guianan Highlands Moist Forests' },
                  { regionId: '464' },
                  {
                    dek:
                      'Situated in southeastern Venezuela in northern South America, the Guayanan Highlands Most Forests ecoregion is an elevational "island" surrounded by llanos and lowland forest. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/653cfd91-38d3-4e15-9fec-4a9d3174d4ef/464 Guianan Highlands moist forests - Paolo Costa Baldi.jpg',
                      _id: '653cfd91-38d3-4e15-9fec-4a9d3174d4ef'
                    }
                  },
                  { _id: 'a4b3cb9f-ea62-441a-aea3-be003fb9583f' },
                  { title: 'Guianan Freshwater Swamp Forests' },
                  { regionId: '463' },
                  {
                    dek:
                      'This Swamp Forests ecoregion extends as a narrow, near-coastal strip across all of northern Suriname, from the Courantyne River along the Guyanan border to the Maroni River along the French Guianan border.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fac61dcc-a082-4439-b5b0-b9c701d67571/463 Guianan freshwater swamp forests - Forrestjunky.jpg',
                      _id: 'fac61dcc-a082-4439-b5b0-b9c701d67571'
                    }
                  },
                  { _id: '6e6f1ed4-44f9-4a75-ad99-f308c481165f' },
                  { title: 'Amazon-Orinoco-Southern Caribbean Mangroves' },
                  { regionId: '611' },
                  {
                    dek:
                      'The Amazon-Orinoco-Southern Caribbean Mangrove ecoregion is comprised of seven subecoregions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bae1b463-7176-490c-9e18-0f032335a9f0/611 Amazon-Orinoco-Southern Caribbean mangroves - Jorge Moyeja.JPG',
                      _id: 'bae1b463-7176-490c-9e18-0f032335a9f0'
                    }
                  }
                ],
                stats: [
                  { number: ' 106,384 ', item: 'Total Land Area (1000 ha)' },
                  { number: '11', item: 'Number of Ecoregions' },
                  { number: '94%', item: 'Protection Target' },
                  { number: '6', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Southern America',
            value: 375
          }
        ],
        parentId: 'top',
        _id: 'Southern America',
        value: 833
      },
      {
        name: 'Southern Eurasia',
        children: [
          {
            _id: '5028be0f-990d-4ce0-b812-92c496e98917',
            name: 'North Africa',
            children: [
              {
                name: 'Northern Sahara Deserts, Savannas & Marshes (PA24)',
                children: [],
                _id: 'cb7a108f-f2c2-4fe8-b2b4-5c93b6e94b9f',
                value: 1000,
                parentId: '5028be0f-990d-4ce0-b812-92c496e98917',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f527ed94-78ce-43a5-9749-75364e2e8f9c/833-Oued_massa, Morocco-CC-Jum Bleak-2008.JPG',
                    _id: 'f527ed94-78ce-43a5-9749-75364e2e8f9c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e8086f0a-203f-464c-a1d2-f416123b1423/744 Nile Delta-CC-2007.jpg',
                    _id: 'e8086f0a-203f-464c-a1d2-f416123b1423'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d600d176-7180-40be-99ca-2aaee867b9ad/787- forests to the top of the Caldera de Taburiente-CC-Tony Hisgett-2011_resized.jpg',
                    _id: 'd600d176-7180-40be-99ca-2aaee867b9ad'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2d3a2279-3310-43ff-a923-c7d3f9b3804f/Bioregion%20map-PA24.jpg',
                content:
                  '<p>The Northern Sahara Deserts, Savannas &amp; Marshes bioregion is located in the Southern Eurasia realm (southern Palearctic) and contains six terrestrial ecoregions \u2013 Nile Delta Flooded Savanna (744), Canary Islands Dry Woodlands and Forests (787), East Sahara Desert (822), North Saharan Xeric Steppe and Woodland (833), Saharan Atlantic Coastal Desert (839), West Sahara Desert (845) \u2013 along with the Saharan Halophytics (745) totaling over 404 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2d3a2279-3310-43ff-a923-c7d3f9b3804f/Bioregion%20map-PA24.jpg"/><figcaption><span class="caption"><p>The Northern Sahara Deserts, Savannas &amp; Marshes bioregion is part of the Sub-Saharan Africa subrealm and is made up of seven ecoregions: (1) Canary Islands Dry Woodlands and Forests (2) Saharan Atlantic Coastal Desert (3) North Saharan Xeric Steppe and Woodland (4) West Sahara Desert (5) East Sahara Desert (6) Saharan Halophytics (7) Nile Delta Flooded Savanna.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Northern Sahara Deserts, Savannas &amp; Marshes ecoregions below.</p>',
                ecoregions: [
                  { _id: '78081454-f3ac-41f7-a5f6-e65dd7170904' },
                  { title: 'West Sahara Desert' },
                  { regionId: '845' },
                  {
                    dek:
                      'This ecoregion is a largely barren landscape, speckled sparingly with oases and transient green spaces which only appear after rare rainfall. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1b64ea32-7e18-41ca-a4d2-68af09498cf3/845 West Sahara desert - JC Brito.jpg',
                      _id: '1b64ea32-7e18-41ca-a4d2-68af09498cf3'
                    }
                  },
                  { _id: '17a5e48c-79f6-4365-838f-f907fa8535e1' },
                  { title: 'Saharan Atlantic Coastal Desert' },
                  { regionId: '839' },
                  {
                    dek:
                      'A vibrant marine ecosystem is juxtaposed with arid desert plateaus in this spectacular stretch of coastline between Western Sahara and Mauritania that forms this ecoregion.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5034a658-ef19-4acd-912f-183d98aac855/839 Saharan Atlantic coastal desert - JC Brito.jpg',
                      _id: '5034a658-ef19-4acd-912f-183d98aac855'
                    }
                  },
                  { _id: 'e8df330c-469e-4ca7-8439-503d81b796d2' },
                  { title: 'North Saharan Xeric Steppe and Woodlands' },
                  { regionId: '833' },
                  {
                    dek:
                      'This ecoregion extends right across North Africa, including parts of Western Sahara, Morocco, the northern edge of Mauritania, Algeria, Tunisia, Libya, and Egypt. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/edbfa3c6-de62-466a-ac5f-1a33c2cae47a/833 North Saharan Xeric Steppe and Woodland - JC Brito_resized.jpg',
                      _id: 'edbfa3c6-de62-466a-ac5f-1a33c2cae47a'
                    }
                  },
                  { _id: '9f1496f2-5726-42e7-8986-9d767111cf64' },
                  { title: 'East Sahara Desert' },
                  { regionId: '822' },
                  { dek: 'This ecoregion covers the central Sahara Desert.' },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/219beb82-9591-49bb-a8b9-525e1c728f3c/822 East Sahara Desert - Loretta Rossiter.jpg',
                      _id: '219beb82-9591-49bb-a8b9-525e1c728f3c'
                    }
                  },
                  { _id: '675d50c1-0a10-47ba-a185-a866e0065fd5' },
                  { title: 'Canary Islands Dry Woodlands and Forests' },
                  { regionId: '787' },
                  {
                    dek:
                      'The Canary Archipelago is a group of volcanic islands and rock islets located in the Atlantic Ocean, 115 km from the northwest coast of Africa.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0481dda9-76e3-493a-8731-14b541c95129/787 Canary Islands dry woodlands and forests - nike159.jpg',
                      _id: '0481dda9-76e3-493a-8731-14b541c95129'
                    }
                  },
                  { _id: '64560a75-f53d-4635-97d4-96236d9e1e9f' },
                  { title: 'Saharan Halophytic' },
                  { regionId: '745' },
                  {
                    dek:
                      'This ecoregion cover a number of saline depressions scattered across northern Africa.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a61f301c-d885-4d5b-89f7-1b61fbe9a9a4/745 Saharan halophytics - JC Brito.jpg',
                      _id: 'a61f301c-d885-4d5b-89f7-1b61fbe9a9a4'
                    }
                  },
                  { _id: '31068f52-1abc-449f-b39b-cbd04433ce28' },
                  { title: 'Nile Delta Flooded Savanna' },
                  { regionId: '744' },
                  {
                    dek:
                      'This ecoregion extends along the Nile River from the Aswan High Dam 1,100 km downstream to the mouth of the Nile, and includes the delta in the North, which is about 175 km long and 260 km wide, opening to the Mediterranean sea. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/63ad79a2-2e62-4b57-a139-7ed9e6d4fbfa/744 Banana plantation on the Nile Delta-CC-2014_resized.jpg',
                      _id: '63ad79a2-2e62-4b57-a139-7ed9e6d4fbfa'
                    }
                  }
                ],
                stats: [
                  { number: '404,488', item: 'Total Land Area (1000 ha)' },
                  { number: '7', item: 'Number of Ecoregions' },
                  { number: '41%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              },
              {
                name: 'Southern Sahara Deserts & Mountain Woodlands (PA25)',
                children: [],
                _id: '1f9107eb-5d02-40be-808d-29f70d663dcd',
                value: 1000,
                parentId: '5028be0f-990d-4ce0-b812-92c496e98917',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b815d7b7-9537-45ed-9fe1-0c0f863ed1a0/842 South Sahara Desert Luca Galuzzi cc.jpg',
                    _id: 'b815d7b7-9537-45ed-9fe1-0c0f863ed1a0'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/173c56f7-f274-40fb-a4d2-ffd465b34aa3/823 East Saharan montane xeric woodlands - Desertman.jpg',
                    _id: '173c56f7-f274-40fb-a4d2-ffd465b34aa3'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fea140d9-eab6-48c0-aebe-6e733b7bb4ff/842 South Sahara Desert Fiontain  cc.jpg',
                    _id: 'fea140d9-eab6-48c0-aebe-6e733b7bb4ff'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ff70bc1f-3b0f-49eb-a039-c521cab4e228/Bioregion%20map-PA25.jpg',
                content:
                  '<p>The Southern Sahara Deserts &amp; Mountain Woodlands bioregion is located in the Southern Eurasia realm (southern Palearctic) and contains four ecoregions \u2013 &nbsp;East Saharan Montane Xeric Woodlands (823), South Sahara Desert (842), Tibesti-Jebel Uweinat Montane Xeric Woodlands (844), West Saharan Montane Xeric Woodlands (846) \u2013 totaling approximately 329 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ff70bc1f-3b0f-49eb-a039-c521cab4e228/Bioregion%20map-PA25.jpg"/><figcaption><span class="caption"><p>The Southern Sahara Deserts &amp; Mountain Woodlands bioregion is part of the North Africa subrealm and is made up of four ecoregions: (1) South Sahara Desert (2) West Saharan Montane Xeric Woodlands (3) Tibesti-Jebel Uweinat Montane Xeric Woodlands (4) East Saharan Montane Xeric Woodlands.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Southern Sahara Deserts &amp; Mountain Woodlands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'f5bf4e29-ee89-4d2a-8520-dffc8ab2eb75' },
                  { title: 'West Saharan Montane Xeric Woodlands' },
                  { regionId: '846' },
                  {
                    dek:
                      'Mountain ranges such as Ahaggar, Tibesti, and A\u00efr rise up around the West Sahara Desert, notably in the south.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3a58f4f3-8f49-4efd-8ed8-f2b09cffb74a/846 West Saharan montane xeric woodlands - Jacqueline Macou.jpg',
                      _id: '3a58f4f3-8f49-4efd-8ed8-f2b09cffb74a'
                    }
                  },
                  { _id: 'f14dea00-6b33-4a1f-b820-9e8a7a5f1113' },
                  { title: 'Tibesti-Jebel Uweinat Montane Xeric Woodlands' },
                  { regionId: '844' },
                  {
                    dek:
                      'This ecoregion encompasses two mountainous areas rising from the central Sahara Desert: Tibesti and the smaller Jebel Uweinat region.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d5defaa1-2140-4927-b5b6-65d76674c8a1/844 Tibesti-Jebel Uweinat montane xeric woodlands - Michael Kerling.jpg',
                      _id: 'd5defaa1-2140-4927-b5b6-65d76674c8a1'
                    }
                  },
                  { _id: 'e1ea7519-f43b-4f7e-99c1-0fe2acdf5fc8' },
                  { title: 'South Sahara Desert' },
                  { regionId: '842' },
                  {
                    dek:
                      'The South Sahara Desert ecoregion crosses the African continent from the southern corner of Western Sahara and the northern half of Mauritania, to the northern part of Mali, southern Algeria, northern Niger, Chad, Sudan, and southeastern Egypt.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b815d7b7-9537-45ed-9fe1-0c0f863ed1a0/842 South Sahara Desert Luca Galuzzi cc.jpg',
                      _id: 'b815d7b7-9537-45ed-9fe1-0c0f863ed1a0'
                    }
                  },
                  { _id: '80b77fa2-867f-45b1-b4a0-140273c4f7d9' },
                  { title: 'East Saharan Montane Xeric Woodlands' },
                  { regionId: '823' },
                  {
                    dek:
                      'This ecoregion is restricted to three specific locations: the Massif de l\u2019Ennedi and Massif du Kapka in northeastern Chad and the nearby Jebel Marra in western Sudan'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/173c56f7-f274-40fb-a4d2-ffd465b34aa3/823 East Saharan montane xeric woodlands - Desertman.jpg',
                      _id: '173c56f7-f274-40fb-a4d2-ffd465b34aa3'
                    }
                  }
                ],
                stats: [
                  { number: '329,860 ', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '37%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'South Mediterranean Mixed Woodlands & Forests (PA23)',
                children: [],
                _id: '2762c964-78ec-4e99-b0df-93c9ad4e3362',
                value: 1000,
                parentId: '5028be0f-990d-4ce0-b812-92c496e98917',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/317ab8e4-f7f4-4bf0-9348-f1f87ed4f06a/758 Nouari0 cc.jpg',
                    _id: '317ab8e4-f7f4-4bf0-9348-f1f87ed4f06a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4390a9f3-8f72-4b51-8825-f3a53d65fc2c/798-Al_Marj_escarpment-CC-Maher A. A. Abdussalam-2010.JPG',
                    _id: '4390a9f3-8f72-4b51-8825-f3a53d65fc2c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2f751cef-b434-4457-af46-3050f584526a/701 Mediterranean conifer and mixed forests - JC Brito.jpg',
                    _id: '2f751cef-b434-4457-af46-3050f584526a'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/50a89967-c8a0-42ca-980a-39d09de73516/Bioregion%20map-PA23.jpg',
                content:
                  '<p>The South Mediterranean Mixed Woodlands &amp; Forests bioregion is located in the Southern Eurasia realm (southern Palearctic) and contains five ecoregions \u2013 Mediterranean Conifer and Mixed Forests (701), Mediterranean High Atlas Juniper Steppe (758), Mediterranean Acacia-Argania Dry Woodlands and Succulent Thickets (796), Mediterranean Dry Woodlands and Steppe (797), Mediterranean Woodlands and Forests (798) \u2013 totaling approximately 78 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/50a89967-c8a0-42ca-980a-39d09de73516/Bioregion%20map-PA23.jpg"/><figcaption><span class="caption"><p>The South Mediterranean Mixed Woodlands &amp; Forests bioregion is part of the North Africa subrealm and is made up of five ecoregions: (1) Mediterranean Acacia-Argania Dry Woodlands and Succulent Thickets (2) Mediterranean High Atlas Juniper Steppe (3) Mediterranean Woodlands and Forests (4) Mediterranean Dry Woodlands and Steppe (5) Mediterranean Conifer and Mixed Forests.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the South Mediterranean Mixed Woodlands &amp; Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '471a973f-02b8-48ef-a9c8-71e11646f3ef' },
                  { title: 'Mediterranean Woodlands and Forests' },
                  { regionId: '798' },
                  {
                    dek:
                      'This ecoregion covers the coastal plains, lowlands, and mid-elevations of northern Morocco, Algeria and Tunisia plus an isolated portion on the Cyrenaic Peninsular of Libya (Jabel al Akdar).'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/79fa05d8-6d02-4ac4-84b3-e6e214c5370c/798 Mediterranean woodlands and forests - JC Brito.jpg',
                      _id: '79fa05d8-6d02-4ac4-84b3-e6e214c5370c'
                    }
                  },
                  { _id: 'a34a4a7e-3138-482a-8e55-0a0c7dc94259' },
                  { title: 'Mediterranean Dry Woodlands and Steppe' },
                  { regionId: '797' },
                  {
                    dek:
                      'This ecoregion stretches from eastern Morocco, across northern Algeria to the Mediterranean coast of Tunisia. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/860580a0-752e-464f-afd1-b6dddbdb73f5/797 Mediterranean dry woodlands and steppe - El Golli Mohamed.jpg',
                      _id: '860580a0-752e-464f-afd1-b6dddbdb73f5'
                    }
                  },
                  { _id: '45b9777f-3c00-42a8-90db-4e89f5a60a83' },
                  { title: 'Mediterranean Acacia-Argania Dry Woodlands and Succulent Thickets' },
                  { regionId: '796' },
                  {
                    dek:
                      'This ecoregion mainly sits within Morocco and the two easternmost Canary Islands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5301b205-ab0d-4435-9106-0d62faa6f964/796 Mediterranean Acacia-Argania dry woodlands and succulent thickets - JC Brito_resized.jpg',
                      _id: '5301b205-ab0d-4435-9106-0d62faa6f964'
                    }
                  },
                  { _id: 'c4e052bd-811f-4522-963c-89fd0451cc41' },
                  { title: 'Mediterranean High Atlas Juniper Steppe' },
                  { regionId: '758' },
                  {
                    dek:
                      'This ecoregion is limited to areas of the High Atlas Mountains in Morocco above an altitude of 1,628 m.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/72d4a0a6-fa89-4a26-b2a9-5584e04d1959/758 Mediterranean High Atlas juniper steppe - Wilfried Santer.jpg',
                      _id: '72d4a0a6-fa89-4a26-b2a9-5584e04d1959'
                    }
                  },
                  { _id: '7c170961-ffb6-4079-addc-ff958992266f' },
                  { title: 'Mediterranean Conifer and Mixed Forests' },
                  { regionId: '701' },
                  {
                    dek:
                      'This ecoregion comprises relict stands of fir and pine forest in the humid, medium to high elevations of major mountain massifs in North Africa, and in the southernmost mountains of C\u00e1diz and M\u00e1laga in Spain.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2f751cef-b434-4457-af46-3050f584526a/701 Mediterranean conifer and mixed forests - JC Brito.jpg',
                      _id: '2f751cef-b434-4457-af46-3050f584526a'
                    }
                  }
                ],
                stats: [
                  { number: '78,175', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '24%', item: 'Protection Target' },
                  { number: '6', item: 'Protection Level' }
                ]
              },
              {
                name: 'Madeira Evergreen Island (PA22)',
                children: [],
                _id: '02d66ae2-5341-4226-b717-f46515a45624',
                value: 1000,
                parentId: '5028be0f-990d-4ce0-b812-92c496e98917',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/31e2ea62-9390-4930-877b-d657acc7bd58/668-Laurissilva_da_Madeira_-CC-Senza Senso-2011.jpg',
                    _id: '31e2ea62-9390-4930-877b-d657acc7bd58'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/072127b7-4512-42aa-8d7b-29d30fac9b58/Bioregion%20map-PA22.jpg',
                content:
                  '<p>The Madeira Evergreen Island bioregion is located in the Southern Eurasia realm (southern Palearctic) and contains one single ecoregion \u2013 Madeira Evergreen Forests (668) \u2013 totaling approximately 82 thousand hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/072127b7-4512-42aa-8d7b-29d30fac9b58/Bioregion%20map-PA22.jpg"/><figcaption><span class="caption"><p>The Madeira Evergreen Island bioregion is part of the North Africa subrealm and is made up of one ecoregion: (1) Madeira Evergreen Forests.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Southern Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Madeira Evergreen Island ecoregion below.</p>',
                ecoregions: [
                  { _id: 'f4c6dc08-a964-4443-bc9f-e57e755dc0c4' },
                  { title: 'Madeira Evergreen Forests' },
                  { regionId: '668' },
                  {
                    dek:
                      'Madeira is an archipelago of four islands in the Atlantic Ocean, about 560 km west of Morocco and 978 km southwest of Lisbon. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/137ae1f4-0514-4a79-ac12-8aa8a6bc0a93/668 Madeira evergreen forests - Hannes Grobe.jpg',
                      _id: '137ae1f4-0514-4a79-ac12-8aa8a6bc0a93'
                    }
                  }
                ],
                stats: [
                  { number: '82', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '63%', item: 'Protection Target' },
                  { number: '9', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Southern Eurasia',
            value: 1000
          },
          {
            _id: '1ca3fd38-5c7c-47fe-ac9f-26987f28b113',
            name: 'Greater Arabian Peninsula',
            children: [
              {
                name: 'Red Sea, Arabian Deserts & Salt Marshes (PA26)',
                children: [],
                _id: 'abb11dae-fe7d-4dae-9a53-164573da9a27',
                value: 1000,
                parentId: '1ca3fd38-5c7c-47fe-ac9f-26987f28b113',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/32b01d76-229c-4c8b-b107-c7392e42004a/Sandstone plateau, Hisma Desert \u2013 NEOM, Saudi Arabia | The NEOM Nature Reserve region neom-Iogsh4Cbdjs-unsplash.jpg',
                    _id: '32b01d76-229c-4c8b-b107-c7392e42004a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fe3bab11-d9c9-4f9c-b0d0-a9650269cec1/840 South Arabian plains and plateau desert - Eckhard Pecher.jpg',
                    _id: 'fe3bab11-d9c9-4f9c-b0d0-a9650269cec1'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5913bcc4-de53-4861-9525-5fc1fd8d45ff/821 East Arabian fog shrublands and sand desert - Andries Oudshoorn.jpg',
                    _id: '5913bcc4-de53-4861-9525-5fc1fd8d45ff'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/02f91aa7-f467-4f02-bf61-139904a3fb13/Bioregion%20map-PA26.jpg',
                content:
                  '<p>The Red Sea, Arabian Deserts &amp; Salt Marshes bioregion is located in the Southern Eurasia realm (southern Palearctic) and contains 14 ecoregions\u2014Al-Hajar Foothill Xeric Woodlands and Shrublands (722), Al-Hajar Montane Woodlands and Shrublands (723), Syrian Xeric Grasslands and Shrublands (739), Tigris-Euphrates Alluvial Salt Marsh (747), Arabian Desert (809), Arabian Sand Desert (810), Arabian-Persian Gulf Coastal Plain Desert (811), East Arabian Fog Shrublands and Sand Desert (821), Mesopotamian Shrub Desert (830), North Arabian Desert (831), North Arabian Highland Shrublands (832), Red Sea Coastal Desert (836), Red Sea-Arabian Desert Shrublands (837) South Arabian Plains and Plateau Desert (840)\u2014totaling approximately 333 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/02f91aa7-f467-4f02-bf61-139904a3fb13/Bioregion%20map-PA26.jpg"/><figcaption><span class="caption"><p>The Red Sea, Arabian Deserts &amp; Salt Marshes bioregion is part of the Greater Arabian Peninsula subrealm and is made up of 14 ecoregions: (1) South Arabian Plains and Plateau Desert (2) East Arabian Fog Shrublands and Sand Desert (3) Arabian-Persian Gulf Coastal Plain Desert (4) Al-Hajar Foothill Xeric Woodlands and Shrublands (5) Al-Hajar Montane Woodlands and Shrublands (6) Arabian Sand Desert (7) Arabian Desert (8) Red Sea-Arabian Desert Shrublands (9) North Arabian Highland Shrublands (10) North Arabian Desert (11) Tigris-Euphrates Alluvial Salt Marsh (12) Mesopotamian Shrub Desert (13) Syrian Xeric Grasslands and Shrublands (14) Red Sea Coastal Desert.</p></span> </figcaption></figure>\n<p>Learn more about each of the Red Sea, Arabian Deserts &amp; Salt Marshes ecoregions below.</p>',
                ecoregions: [
                  { _id: '88b493bf-92f4-419b-9c24-5ec0d619ddbf' },
                  { title: 'South Arabian Plains and Plateau Desert' },
                  { regionId: '840' },
                  {
                    dek:
                      'This ecoregion largely lies within Oman and Yemen, although it includes a small section in the United Arab Emirates in the East.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fe3bab11-d9c9-4f9c-b0d0-a9650269cec1/840 South Arabian plains and plateau desert - Eckhard Pecher.jpg',
                      _id: 'fe3bab11-d9c9-4f9c-b0d0-a9650269cec1'
                    }
                  },
                  { _id: '131f62e6-4010-42b3-820a-e4a391c6672c' },
                  { title: 'Red Sea-Arabian Desert Shrublands' },
                  { regionId: '837' },
                  {
                    dek:
                      'This ecoregion encompasses a great diversity of habitats, stretching from southwest Yemen to just north of the Dead Sea in Jordan with sections of Saudi Arabia, Israel, Palestine, and Egypt.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/84b9c2f7-fe24-4299-a5f6-c088680d386a/837 Red Sea-Arabian Desert shrublands - ZSL KKWRC.jpg',
                      _id: '84b9c2f7-fe24-4299-a5f6-c088680d386a'
                    }
                  },
                  { _id: 'bf6883dc-ce1c-4c7b-b003-cbd0c80db990' },
                  { title: 'Red Sea Coastal Desert' },
                  { regionId: '836' },
                  {
                    dek:
                      'This ecoregion extends south from the Gulf of Suez, encompassing most of Egypt\u2019s Red Sea coast and approximately half of Sudan\u2019s coastline. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1d17391a-12ec-4656-a66e-c4c9071f2457/836 Red Sea coastal desert - artwell.jpg',
                      _id: '1d17391a-12ec-4656-a66e-c4c9071f2457'
                    }
                  },
                  { _id: '749f8a78-44b2-4f6e-916c-46af19623ba6' },
                  { title: 'North Arabian Highland Shrublands' },
                  { regionId: '832' },
                  {
                    dek:
                      'This discontinuous ecoregion is situated in Saudi Arabia\u2019s western Ha\u2019il region. It encompasses the Shammar mountain range and surrounding patches of lowland gravel desert.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3bda287f-45eb-406d-816f-8def9267120f/832 Mesopotamian shrub desert - Bertramz.jpg',
                      _id: '3bda287f-45eb-406d-816f-8def9267120f'
                    }
                  },
                  { _id: '6da56a64-1d84-475c-94b4-878f22bbd15b' },
                  { title: 'North Arabian Desert' },
                  { regionId: '831' },
                  {
                    dek:
                      'This ecoregion stretches across much of Jordan, northern Saudi Arabia and into Iraq\u2019s western desert.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e2e2b459-b704-4328-8285-9b3e05136f4f/831 North Arabian desert - ZSL KKWRC.jpg',
                      _id: 'e2e2b459-b704-4328-8285-9b3e05136f4f'
                    }
                  },
                  { _id: 'fecd284c-b15d-477b-a3b7-75e8f20faeb1' },
                  { title: 'Mesopotamian Shrub Desert' },
                  { regionId: '830' },
                  {
                    dek:
                      'This ecoregion encompasses most of the Syrian Desert, also known as Badiyat ash Sham, stretching across East Jordan, southern Syria and western Iraq towards the foothills of the Zagros Mountains. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b347e150-456a-4da7-aeab-39babf87a479/830 Mesopotamian shrub desert - Anas Qtiesh.jpg',
                      _id: 'b347e150-456a-4da7-aeab-39babf87a479'
                    }
                  },
                  { _id: '35b9de82-2a39-4264-9380-b92089803479' },
                  { title: 'East Arabian Fog Shrublands and Sand Desert' },
                  { regionId: '821' },
                  {
                    dek:
                      'This ecoregion has a highly varied landscape, with two disjunct sections: the Wahiba Sands sand-sea in the North and the fossil-rich Huqf area in the South.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5913bcc4-de53-4861-9525-5fc1fd8d45ff/821 East Arabian fog shrublands and sand desert - Andries Oudshoorn.jpg',
                      _id: '5913bcc4-de53-4861-9525-5fc1fd8d45ff'
                    }
                  },
                  { _id: 'ade11300-1c5a-4062-b0a8-0943f0707ddc' },
                  { title: 'Arabian-Persian Gulf Coastal Plain Desert' },
                  { regionId: '811' },
                  {
                    dek:
                      'This disjointed ecoregion encompasses much of the Arabian Peninsula\u2019s eastern coast, along the Arabian-Persian Gulf and Gulf of Oman, with a section in the Arabian Sea.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/77b02580-3f8a-4847-b57f-311fff9291a5/811 Arabian-Persian Gulf coastal plain desert - hotshoel.jpg',
                      _id: '77b02580-3f8a-4847-b57f-311fff9291a5'
                    }
                  },
                  { _id: '24e99597-8fc0-47d6-af0c-0697ffd50740' },
                  { title: 'Arabian Sand Desert' },
                  { regionId: '810' },
                  {
                    dek:
                      'This ecoregion encompasses both the major sand deserts\u2014Ad-Dahna, An-Nafud, Al-Jafurah, Rub\u2019 al-Khali\u2014and sand deserts in Saudi Arabia, characterized by high linear and crescent dunes interspersed with gravel and gypsum plains.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/66409e77-e7a5-4579-b3a5-870b969f966d/810 Arabian Sand Desert - D Olson.jpg',
                      _id: '66409e77-e7a5-4579-b3a5-870b969f966d'
                    }
                  },
                  { _id: '81428e4e-adcd-4257-ab2f-fbc872e05e0f' },
                  { title: 'Arabian Desert' },
                  { regionId: '809' },
                  {
                    dek:
                      'This disjointed ecoregion encompasses large swathes of Egypt\u2019s Sinai Desert, Israel\u2019s Negev Desert, and other areas in Saudi Arabia, Yemen, Kuwait, Iraq, and Iran. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/edbabbc5-b342-4169-a0e7-ca56b6675590/Sandstone plateau, Hisma Desert \u2013 NEOM, Saudi Arabia | The NEOM Nature Reserve region 2 neom-39n8YVSn0d4-unsplash.jpg',
                      _id: 'edbabbc5-b342-4169-a0e7-ca56b6675590'
                    }
                  },
                  { _id: '8cf145d9-f5df-45c3-af76-a1a0e1993939' },
                  { title: 'Tigris-Euphrates Alluvial Salt Marsh' },
                  { regionId: '747' },
                  {
                    dek:
                      'Located at the northern end of the Persian Gulf, these wetlands are formed in the deltaic plain of the Euphrates, Tigris, and Karun rivers, which drain Turkey, Syria, Iraq, and the western Zagros mountains of Iran.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/100b836e-2776-4b3a-95fb-912ffdd36781/747 Tigris-Euphrates alluvial salt marsh - Hassan Janali.jpg',
                      _id: '100b836e-2776-4b3a-95fb-912ffdd36781'
                    }
                  },
                  { _id: 'd7304b09-ac1c-4597-bbe2-b43fa6778c99' },
                  { title: 'Syrian Xeric Grasslands and Shrublands' },
                  { regionId: '739' },
                  {
                    dek:
                      'This ecoregion arcs across West Jordan, much of central Syrian Arab Republic, Northern Iraq, and a small area of Southwest Turkey.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b38929b7-21f7-4a39-84ad-6144e561705c/739 Syrian xeric grasslands and shrublands - thorgenmaehler.jpg',
                      _id: 'b38929b7-21f7-4a39-84ad-6144e561705c'
                    }
                  },
                  { _id: 'b6e3ea80-d39f-4651-98d3-71ec28d0999b' },
                  { title: 'Al-Hajar Montane Woodlands and Shrublands' },
                  { regionId: '723' },
                  {
                    dek:
                      'Running parallel to Oman\u2019s Batinah coast, the limestone and dark opholite rocks of the Al-Hajar mountains form the largest mountain range in eastern Arabia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/52d6ba96-9d32-4810-aefd-949812ad7e2c/723 Al-Hajar montane woodlands and shrublands - Glyn Barrett.jpg',
                      _id: '52d6ba96-9d32-4810-aefd-949812ad7e2c'
                    }
                  },
                  { _id: 'd433eb7d-e9b6-4e3a-ab78-0713eaccc132' },
                  { title: 'Al-Hajar Foothill Xeric Woodlands and Shrublands' },
                  { regionId: '722' },
                  {
                    dek:
                      'This ecoregion surrounds the Al-Hajar Montane Woodlands and Shrublands ecoregion, encompassing the Al-Hajar foothills and lands lying below 1,200 m. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/43a211f9-60e6-4de3-8baf-2552ab8af33f/722 Al-Hajar foothill xeric woodlands and shrublands - Glyn Barrett.jpg',
                      _id: '43a211f9-60e6-4de3-8baf-2552ab8af33f'
                    }
                  }
                ],
                stats: [
                  { number: '332,859', item: 'Total Land Area (1000 ha)' },
                  { number: '14', item: 'Number of Ecoregions' },
                  { number: '45%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Southern Eurasia',
            value: 250
          }
        ],
        parentId: 'top',
        _id: 'Southern Eurasia',
        value: 333
      },
      {
        name: 'Subarctic America',
        children: [
          {
            _id: 'b9101d1a-cb90-4006-bb13-9dc78a7f0437',
            name: 'Alaska',
            children: [
              {
                name: 'Far Northern Pacific Coast (NA5)',
                children: [],
                _id: '7c9d0553-5261-4c98-ba80-26bb1a16ca0c',
                value: 1000,
                parentId: 'b9101d1a-cb90-4006-bb13-9dc78a7f0437',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3d266521-e063-419b-9649-9dbe05d27dad/360-Tongass_National_Forest-eco360-CC-Mark Brennan-2007.jpg',
                    _id: '3d266521-e063-419b-9649-9dbe05d27dad'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/68b9c918-3a99-4a9f-87cc-93b394ba88b8/360 Northern Pacific Alaskan Coastal Forests Diego Delso cc.jpg',
                    _id: '68b9c918-3a99-4a9f-87cc-93b394ba88b8'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/32c4d94c-51da-4db0-9f82-ab629fb7323b/360 Northern Pacific Alaskan Coastal Forests Paxson Woelber cc.jpeg',
                    _id: '32c4d94c-51da-4db0-9f82-ab629fb7323b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/31d5392a-f585-4e93-a0ed-1110e6f24353/420 Pacific Coastal Mountain Icefields and Tundra cc.jpg',
                    _id: '31d5392a-f585-4e93-a0ed-1110e6f24353'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/858d0525-d5b4-4036-912b-dc7852431b52/Bioregion%20map-NA5.jpg',
                content:
                  '<p>The Far Northern Pacific bioregion, located in the Subarctic America (Nearctic) realm, is defined by the coastal forests of the Gulf of Alaska and adjoining tundra south of the Alaska Range, all the way to the Dixon Entrance off the coast of central British Columbia. It consists of two ecoregions \u2013 Northern Pacific Alaskan Coastal Forests (360), Pacific Coastal Mountain Icefields and Tundra (420) \u2013 and adjacent marine areas. The total land area of this bioregion is approximately 17 million hectares, not including icefield areas.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/858d0525-d5b4-4036-912b-dc7852431b52/Bioregion%20map-NA5.jpg"/><figcaption><span class="caption"><p>The Far Northern Pacific Coast bioregion is part of the Alaska subrealm and is made up of two ecoregions: (1) Pacific Coastal Mountain Icefields and Tundra (2) Northern Pacific Alaskan Coastal Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Far Northern Pacific Coast ecoregions below.</p>',
                ecoregions: [
                  { _id: '129ce8fc-a475-4961-8c45-3fd93cdbcd70' },
                  { title: 'Pacific Coastal Mountain Icefields and Tundra' },
                  { regionId: '420' },
                  {
                    dek:
                      'This ecoregion parallels the Northern Pacific Alaskan Coastal Forests ecoregion, all the way from its southeastern extent in the Alaska Panhandle and adjacent British Columbia to its western terminus on the Kenai Peninsula along the Gulf of Alaska coast.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a858d648-ed33-422d-a101-732becbab7ea/Bold_Peak_Chugach_State_Park_Chugach_Mountains_Alaska_(49496086).jpeg',
                      _id: 'a858d648-ed33-422d-a101-732becbab7ea'
                    }
                  },
                  { _id: 'f5af5880-95cd-4b37-a234-eab96fa601e9' },
                  { title: 'Northern Pacific Alaskan Coastal Forests' },
                  { regionId: '360' },
                  {
                    dek:
                      'This ecoregion is one of the wildest and best-protected regions of North America outside of arctic tundra and northern taiga zones.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/405f1b08-4fe6-4cc1-85b6-817e1e7d7ec4/360-Tongass_National_Forest-2-eco360-CC-Mark Brennan-2007.jpg',
                      _id: '405f1b08-4fe6-4cc1-85b6-817e1e7d7ec4'
                    }
                  }
                ],
                stats: [
                  { number: '17,045', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '74%', item: 'Protection Target' },
                  { number: '6', item: 'Protection Level' }
                ]
              },
              {
                name: 'Greater Alaska Taiga & Tundra (NA4)',
                children: [],
                _id: '7213ad17-1fd7-4c41-a5cd-c55e43089562',
                value: 1000,
                parentId: 'b9101d1a-cb90-4006-bb13-9dc78a7f0437',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/410b06d1-234e-49bc-8586-acc04114b7bd/406-Cape_Promontory_Cape_Lutkes,_Alaska-CC-USFWS-2003.JPG',
                    _id: '410b06d1-234e-49bc-8586-acc04114b7bd'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/52564725-87d6-4aa0-8513-7cff78f11907/405-Saint_Elias_Mountains-Eco405-CC-Jack French-2006.jpg',
                    _id: '52564725-87d6-4aa0-8513-7cff78f11907'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5df2e071-ac56-405c-87d3-1cf463e627b7/410-Ahklun_and_Wood_River_Mountains-CC-William S. Harper-2004.jpg',
                    _id: '5df2e071-ac56-405c-87d3-1cf463e627b7'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/14a5ed6a-ab2b-4bd0-9f6d-f8e05125cd00/416 Interior Alaska-Yukon Alpine Tundra Beeblebrox cc.jpg',
                    _id: '14a5ed6a-ab2b-4bd0-9f6d-f8e05125cd00'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c76decbc-7edf-491d-88b4-b8bb64059eee/371-Sevenlakes-Alaska-Eco371-CC-2008.JPG',
                    _id: 'c76decbc-7edf-491d-88b4-b8bb64059eee'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/86cc8b52-10b4-4a4f-a1ad-057fb8734da2/371-Waterlillies at Kenai NWR-Alaska-eco371-CC-2011.jpg',
                    _id: '86cc8b52-10b4-4a4f-a1ad-057fb8734da2'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/afa969cc-6014-444a-8cd5-f97e4174bf6a/Bioregion%20map-NA4.jpg',
                content:
                  '<p>The Greater Alaska bioregion, located in the Subarctic America (Nearctic) realm, encompasses most of the Alaska subrealm and is divided in upper and lower halves by the Alaska Range. The upper half is dominated by lowland taiga and coastal tundra along the Bering Sea, consisting of four ecoregions \u2013 Interior Alaska-Yukon Lowland Taiga (375), Beringia Lowland Tundra (409), Beringia Upland Tundra (410) Interior Alaska-Yukon Alpine Tundra (416) \u2013 and adjacent marine areas. The lower half incorporates the alpine tundra of the Alaska Range, Cook Inlet, the Alaskan Peninsula, and the Aleutian Islands, which define the northernmost reach of the Pacific Ocean. It consists of six ecoregions \u2013 Alaska Peninsula Montane Taiga (369), Cook Inlet Taiga (371), Copper Plateau Taiga (372), Ahklun and Kilbuck Upland Tundra (404), Alaska-St. Elias Range Tundra (405), Aleutian Islands Tundra (406) \u2013 and adjacent marine areas. The total land area of this bioregion is approximately 110 million hectares, not including icefield areas.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/afa969cc-6014-444a-8cd5-f97e4174bf6a/Bioregion%20map-NA4.jpg"/><figcaption><span class="caption"><p>The Greater Alaska Taiga &amp; Tundra bioregion is part of the Alaska subrealm and is made up of ten ecoregions: (1) Aleutian Islands Tundra (2) Beringia Lowland Tundra (3) Alaska Peninsula Montane Taiga (4) Alaska-St. Elias Range Tundra (5) Cook Inlet Taiga (6) Copper Plateau Taiga (7) Interior Alaska-Yukon Alpine Tundra (8) Interior Alaska-Yukon Lowland Taiga (9) Beringia Upland Tundra (10) Ahklun and Kilbuck Upland Tundra.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Greater Alaska Taiga &amp; Tundra ecoregions below.</p>',
                ecoregions: [
                  { _id: '7568959b-0abe-45b9-a2d9-8608372c279e' },
                  { title: 'Alaska-St. Elias Range Tundra' },
                  { regionId: '405' },
                  {
                    dek:
                      'This ecoregion gets its name from the Alaska Range and the Wrangell-St. Elias Range, both of which it encompasses.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5b0177d0-a7ff-4d05-a99f-4f0651fbe57b/405 Alaska-St. Elias Range tundra - NPS Alaska.jpg',
                      _id: '5b0177d0-a7ff-4d05-a99f-4f0651fbe57b'
                    }
                  },
                  { _id: '354b7cef-edc6-4f5c-afff-85175160c8be' },
                  { title: 'Copper Plateau Taiga' },
                  { regionId: '372' },
                  {
                    dek:
                      'The Alaska-St. Elias Range Tundra ecosystem surrounds most of the Copper Plateau Taiga, except the Pacific Coastal Mountains Icefields and Tundra ecoregion forms the southern boundary of the Copper Plateau Taiga. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9c462015-93f0-4826-8290-376091b5387f/Image from iOS.jpg',
                      _id: '9c462015-93f0-4826-8290-376091b5387f'
                    }
                  },
                  { _id: '5e1a90d7-c3bc-4fda-8f3e-b8d20a39afcb' },
                  { title: 'Cook Inlet Taiga' },
                  { regionId: '371' },
                  {
                    dek:
                      'This ecoregion surrounds the upper portion of Cook Inlet and includes the city of Anchorage, with 291,538 residents (in 2018) the most populous city in Alaska.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cb282d0e-36aa-4bbd-95f0-01d2ad24e152/371 Cook Inlet taiga - LoveToTakePhotos.jpg',
                      _id: 'cb282d0e-36aa-4bbd-95f0-01d2ad24e152'
                    }
                  },
                  { _id: 'ed1400d8-62a5-4936-bc96-e2c94b7ab8e6' },
                  { title: 'Interior Alaska-Yukon Alpine Tundra' },
                  { regionId: '416' },
                  {
                    dek:
                      'This ecoregion consists of a set of disjunct higher-elevation patches of tundra and open forest in a matrix of lowland taiga (the Interior Alaska-Yukon Lowland Taiga ecoregion) across the interior of Alaska, overlapping into southwestern Yukon Territory. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/559a13fb-c09a-451c-9000-438446bb8891/416 Interior Yukon-Alaska alpine tundra - brigachtal.jpg',
                      _id: '559a13fb-c09a-451c-9000-438446bb8891'
                    }
                  },
                  { _id: '32e27acd-3ba3-44c8-8079-73491041aae4' },
                  { title: 'Beringia Upland Tundra' },
                  { regionId: '410' },
                  {
                    dek:
                      'This ecoregion occurs in two disjunct blocks: on the Seward Peninsula, where it is the dominant ecoregion, and a smaller area on the western half of St. Lawrence Island in the northern Bering Sea.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8d4753e6-e064-4063-aa31-814a870f8807/410 Beringia upland tundra - Skeeze.jpg',
                      _id: '8d4753e6-e064-4063-aa31-814a870f8807'
                    }
                  },
                  { _id: '57308c3f-bfc3-4587-aabd-e83c7f153aac' },
                  { title: 'Beringia Lowland Tundra' },
                  { regionId: '409' },
                  {
                    dek:
                      'This ecoregion consists of the southwestern Alaska mainland, separated by the higher-elevation Ahklun and Kilbuck Upland Tundra ecoregion and extending down the Alaska Peninsula to Unimak Island.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ab15397e-9e7c-48ca-a594-6e214ca5b132/409-Kuskokwim_Delta_Wetlands_-_Aerial_View-CC-USFWS.jpg',
                      _id: 'ab15397e-9e7c-48ca-a594-6e214ca5b132'
                    }
                  },
                  { _id: '8abfbce6-d883-420e-8a4c-3a705b6077c7' },
                  { title: 'Aleutian Islands Tundra' },
                  { regionId: '406' },
                  {
                    dek:
                      'This ecoregion encompasses the 1,500-km Aleutian chain, which stretches between the Alaska Peninsula and Kamchatka Peninsula in Russia, as well as the Pribilof Islands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/83d2839a-2afb-4767-ad52-2ed0753d2a91/406 Aleutian Islands tundra - skeeze.jpg',
                      _id: '83d2839a-2afb-4767-ad52-2ed0753d2a91'
                    }
                  },
                  { _id: '7f96ca26-d885-4299-84e6-596a8650d07e' },
                  { title: 'Ahklun and Kilbuck Upland Tundra' },
                  { regionId: '404' },
                  {
                    dek:
                      'This ecoregion consists primarily of the Ahklun and Kilbuck mountain ranges in southwestern Alaska and was formerly considered part of the Beringia Upland Tundra ecoregion.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9c058ed1-12b5-4a95-97e1-d764fe449993/404 Ahklun and Kilbuck upland tundra - John Morrison.jpg',
                      _id: '9c058ed1-12b5-4a95-97e1-d764fe449993'
                    }
                  },
                  { _id: '1b06be1d-0bbd-424a-b719-228bd691cd5f' },
                  { title: 'Interior Alaska-Yukon Lowland Taiga' },
                  { regionId: '375' },
                  {
                    dek:
                      'This ecoregion sprawls across a large area of southern to northern Alaska and neighboring northwestern Yukon Territory.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bb60fd7e-3447-4d17-b010-e12cfef8d1ba/375 Interior Alaska-Yukon lowland taiga - John Morrison.jpg',
                      _id: 'bb60fd7e-3447-4d17-b010-e12cfef8d1ba'
                    }
                  },
                  { _id: 'cb1b3a00-5864-44b8-a9c5-bd481f8453cc' },
                  { title: 'Alaska Peninsula Montane Taiga' },
                  { regionId: '369' },
                  {
                    dek:
                      'This ecoregion is an area of rugged and picturesque coastline extending from the MacNeil River and the mouth of Cook Inlet in the northeast, down a relatively narrow peninsular to Unimak Island in the southwest, just off the tip of the peninsula. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e65ba941-5797-420a-a5a1-fe1a668557e2/369 Alaska Peninsula montane taiga - USGS.jpg',
                      _id: 'e65ba941-5797-420a-a5a1-fe1a668557e2'
                    }
                  }
                ],
                stats: [
                  { number: '109,888', item: 'Total Land Area (1000 ha)' },
                  { number: '10', item: 'Number of Ecoregions' },
                  { number: '97%', item: 'Protection Level' },
                  { number: '4', item: 'Protection Target' }
                ]
              },
              {
                name: 'North Alaskan Tundra (NA3)',
                children: [],
                _id: '976097e4-b4b2-493e-9ef4-79d0fd2dfdf0',
                value: 1000,
                parentId: 'b9101d1a-cb90-4006-bb13-9dc78a7f0437',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/535f616f-66eb-4e56-9d92-e178f1296c25/407 Arctic coastal tundra - Bob Wick BLM.jpg',
                    _id: '535f616f-66eb-4e56-9d92-e178f1296c25'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/037a2eba-63fe-49ce-9da0-a7a3aff49336/411 Brooks-British Range tundra - NPS Alaska.jpg',
                    _id: '037a2eba-63fe-49ce-9da0-a7a3aff49336'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f680475c-1a65-482b-9fdb-0aab46be6f6c/Bioregion%20map-NA3.jpg',
                content:
                  '<p>The northern section of the Alaska subrealm, located in the Subarctic America (Nearctic) realm, is delineated by the Brooks Range. The North Alaskan Tundra bioregion is entirely made up of three tundra ecoregions\u2014Arctic Coastal Tundra (407), Arctic Foothills Tundra (408), Brooks-British Range Tundra (411)\u2014including the adjacent marine areas of the Beaufort and Chukchi seas. The total land area of this bioregion is 34 million hectares.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f680475c-1a65-482b-9fdb-0aab46be6f6c/Bioregion%20map-NA3.jpg"/><figcaption><span class="caption"><p>The North Alaskan Tundra bioregion is part of the Alaska subrealm and is made up of three ecoregions: (1) Arctic Coastal Tundra (2) Arctic Foothills Tundra (3) Brooks-British Range Tundra.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the North Alaskan Tundra ecoregions below.</p>',
                ecoregions: [
                  { _id: '272d42f7-ae00-46c9-80f6-56ad93e123c6' },
                  { title: 'Brooks-British Range tundra' },
                  { regionId: '411' },
                  {
                    dek:
                      'This ecoregion consists of the Western Brooks Range in Alaska, the lower-elevation Anaktuvuk Pass in Alaska, and the higher Eastern Brooks Range in Alaska, Yukon Territory, and a small part of extreme northwestern Northwest Territories. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/037a2eba-63fe-49ce-9da0-a7a3aff49336/411 Brooks-British Range tundra - NPS Alaska.jpg',
                      _id: '037a2eba-63fe-49ce-9da0-a7a3aff49336'
                    }
                  },
                  { _id: 'c785106c-568f-4294-b2f4-814b7427ca4f' },
                  { title: 'Arctic Foothills Tundra' },
                  { regionId: '408' },
                  {
                    dek:
                      'This ecoregion, for most of its extent, lies between the Arctic Coastal Tundra ecoregion to the north and the Brooks-British Range Tundra ecoregion to the south.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8e9fb8d3-33aa-46c7-9949-7d21ff5aa5d7/408 Arctic foothills tundra - Education Specialist.jpg',
                      _id: '8e9fb8d3-33aa-46c7-9949-7d21ff5aa5d7'
                    }
                  },
                  { _id: '7502bcbb-ff74-45d1-aca9-37af84e3dd60' },
                  { title: 'Arctic Coastal Tundra' },
                  { regionId: '407' },
                  { dek: 'This ecoregion forms most of the northern coastline of Alaska.' },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/535f616f-66eb-4e56-9d92-e178f1296c25/407 Arctic coastal tundra - Bob Wick BLM.jpg',
                      _id: '535f616f-66eb-4e56-9d92-e178f1296c25'
                    }
                  }
                ],
                stats: [
                  { number: '33,930', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '96%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Subarctic America',
            value: 750
          },
          {
            _id: 'fbf2003e-b6a6-434d-80db-896606a51f09',
            name: 'Canadian Tundra',
            children: [
              {
                name: 'Canadian Tundra (NA2)',
                children: [],
                _id: '0cd2f4a1-b327-4633-958c-1f9f5225a875',
                value: 1000,
                parentId: 'fbf2003e-b6a6-434d-80db-896606a51f09',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1e04b189-668c-47ae-b327-1142908cd32b/415 Davis Highlands Tundra Christopher ball.jpeg',
                    _id: '1e04b189-668c-47ae-b327-1142908cd32b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1467bbed-0e69-44e8-84d1-dc9d414b02ca/421- Torngat Mountain-CC-Paul Gierszweski-2008.JPG',
                    _id: '1467bbed-0e69-44e8-84d1-dc9d414b02ca'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a547055b-55cc-4d1a-8b06-f06869ba99e8/415 Davis Highlands Tundra Ansgar Walk cc2.jpg',
                    _id: 'a547055b-55cc-4d1a-8b06-f06869ba99e8'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4a6ba541-2938-4ac5-aeb5-f7a416e0321f/Bioregion%20map-NA2.jpg',
                content:
                  '<p>The Canadian Tundra bioregion, located in the Subarctic America (Nearctic) realm, encompasses the entirety of the Canadian Arctic Archipelago and the northernmost lands of the North American continent. It is entirely made up of tundra with five ecoregions\u2014Canadian High Arctic Tundra (412), Canadian Low Arctic Tundra (413), Canadian Middle Arctic Tundra (414), Davis Highlands Tundra (415), Torngat Mountain Tundra (421)\u2014including adjacent marine areas. The total land area of this bioregion is approximately 260 million hectares.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4a6ba541-2938-4ac5-aeb5-f7a416e0321f/Bioregion%20map-NA2.jpg"/><figcaption><span class="caption"><p>The Canadian Tundra bioregion is part of the Canadian Tundra subrealm and is made up of five ecoregions: Canadian Low Arctic Tundra [1], Canadian Middle Arctic Tundra [2], Canadian High Arctic Tundra [3], Davis Highlands Tundra [4], and Torngat Mountain Tundra [5].</p></span> </figcaption></figure>\n<p>Learn more about each of the Canadian Tundra ecoregions below.</p>',
                ecoregions: [
                  { _id: '1b16eb69-6724-499f-ab75-f127d76ac414' },
                  { title: 'Torngat Mountain Tundra' },
                  { regionId: '421' },
                  {
                    dek:
                      'This peninsular ecoregion lies to the north of the Eastern Canadian Shield Taiga ecoregion and projects into the sea where the Atlantic Ocean (Labrador Sea) meets the Arctic Ocean (Ungava Bay). '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/66143ef2-b6bf-445e-bf4b-3e0bc033fea6/421 Torngat Mountain tundra - Paul Gierszewski.JPG',
                      _id: '66143ef2-b6bf-445e-bf4b-3e0bc033fea6'
                    }
                  },
                  { _id: '5994e04b-68c1-4a32-b06a-7060d19739c8' },
                  { title: 'Davis Highlands Tundra' },
                  { regionId: '415' },
                  {
                    dek:
                      'This ecoregion occupies the rugged mountain chain along the eastern coast of Baffin Island, Nunavut, and the relatively narrow coastal plain adjacent to Davis Strait.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/780779a8-9e09-4f83-82c6-7137ac3d4b9d/415 Davis Highlands tundra - David Mark.jpg',
                      _id: '780779a8-9e09-4f83-82c6-7137ac3d4b9d'
                    }
                  },
                  { _id: 'd4082434-ac43-4ec2-8524-86e4b6a79916' },
                  { title: 'Canadian Middle Arctic Tundra' },
                  { regionId: '414' },
                  {
                    dek:
                      'This ecoregion lies between the Canadian High Arctic Tundra to the north and the Canadian Low Arctic Tundra to the south and is ecologically transitional between these two ecoregions.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bc00b623-ba48-4d1f-94b5-0da1b58c8139/414 Canadian Middle Arctic Tundra - Sebastian Kasten.JPG',
                      _id: 'bc00b623-ba48-4d1f-94b5-0da1b58c8139'
                    }
                  },
                  { _id: '2688729d-097f-4068-867a-29565cf900cd' },
                  { title: 'Canadian Low Arctic Tundra' },
                  { regionId: '413' },
                  {
                    dek:
                      'This ecoregion is the largest ecoregion in Northern America Realm and stretches as a continuous swath across northern Northwest Territories and Nunavut to Hudson Bay. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/47d6b9e8-4b51-4418-8e78-ce4cb5ae0e89/413 Canadian Low Arctic tundra - Lkovac.jpg',
                      _id: '47d6b9e8-4b51-4418-8e78-ce4cb5ae0e89'
                    }
                  },
                  { _id: '8d658c93-8658-44e3-891e-8cbc3a261b62' },
                  { title: 'Canadian High Arctic Tundra' },
                  { regionId: '412' },
                  {
                    dek:
                      'This ecoregion encompasses most of the northern Arctic archipelago, from much of Baffin Island, Somerset, and Prince of Wales Islands in the south, through all islands northward to the most northern island in Canada, Ellesmere Island. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b224dbed-f142-40a6-adb5-cd492af15b9b/412 Canadian High Arctic tundra - Paul Gierszewski_resized.jpg',
                      _id: 'b224dbed-f142-40a6-adb5-cd492af15b9b'
                    }
                  }
                ],
                stats: [
                  { number: '259,506', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '79%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Subarctic America',
            value: 250
          },
          {
            _id: '69fee9d5-5779-4721-a5f4-bf519378c6f4',
            name: 'Canadian Boreal Forests',
            children: [
              {
                name: 'Canadian Shield & Coastal Taiga-Forests (NA9)',
                children: [],
                _id: '9014ef51-5a10-489e-b2b1-61c2ab69246f',
                value: 1000,
                parentId: '69fee9d5-5779-4721-a5f4-bf519378c6f4',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/21a81091-9664-41f1-bccb-1444f39859bd/370 Central Canadian Shield Forests Hans-J\u00fcrgen H\u00fcbner cc.jpeg',
                    _id: '21a81091-9664-41f1-bccb-1444f39859bd'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8a788cbc-df03-4930-ab6a-601b7c96bff4/373-Paper birch-found in eco373-2009_resized.jpg',
                    _id: '8a788cbc-df03-4930-ab6a-601b7c96bff4'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a88ac2b4-12a9-4536-b640-a534bf96f9f8/382 Southern Hudson Bay Taiga Ansgar Walk CC.jpg',
                    _id: 'a88ac2b4-12a9-4536-b640-a534bf96f9f8'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cd884f6c-8f48-49a5-b34e-75d9b140bcd1/Bioregion%20map-NA9.jpg',
                content:
                  '<p>The Canadian Shield bioregion, located in the Canadian Boreal Forests subrealm in the Subarctic America (Nearctic) realm, consists of the great boreal forests spanning across North America, from the Northwest Territories to the Atlantic Ocean. It consists of six ecoregions \u2013 Central Canadian Shield Forests (370), Eastern Canadian Boreal Forests (373), Eastern Canadian Shield Taiga (374), Midwest Canadian Shield Forests (377), Northern Canadian Shield Taiga (379), Southern Hudson Bay Taiga (382) \u2013 and includes the marine areas of James Bay, Labrador Sea, and the Gulf of St. Lawrence. The total land area of this bioregion is approximately 325 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cd884f6c-8f48-49a5-b34e-75d9b140bcd1/Bioregion%20map-NA9.jpg"/><figcaption><span class="caption"><p>The Canadian Shield &amp; Coastal Taiga-Forests bioregion is part of the Canadian Boreal Forests subrealm and is made up of six ecoregions: (1) Northern Canadian Shield Taiga (2) Midwest Canadian Shield Forests (3) Southern Hudson Bay Taiga (4) Central Canadian Shield Forests (5) Eastern Canadian Shield Taiga (6) Eastern Canadian Boreal Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Canadian Shield &amp; Coastal Taiga-Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '2499faa1-c772-4a15-b5e3-9d53c241c503' },
                  { title: 'Midwest Canadian Shield Forests' },
                  { regionId: '377' },
                  {
                    dek:
                      'This ecoregion is an immense area stretching from the north shore of Lake Superior in Ontario northwestward through western Ontario and central Manitoba to the south shore of Lake Athabasca in northern Saskatchewan and Alberta.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4429fdd3-d054-4ca3-af31-b5164f76f0a5/377 Woodland_Caribou_Provincial_Park-CC-Kate Ming-Sun-2014_resized.jpg',
                      _id: '4429fdd3-d054-4ca3-af31-b5164f76f0a5'
                    }
                  },
                  { _id: '00e3f125-b8dc-4bdf-8200-ec34420c8fd6' },
                  { title: 'Eastern Canadian Boreal Forests' },
                  { regionId: '373' },
                  {
                    dek:
                      'This ecoregion includes much of eastern Quebec, the southern part of Labrador, and the entire island of Newfoundland. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1c6210a8-3a68-4987-9085-d496f1db1202/373 Eastern Canadian forests - Tango7174.jpg',
                      _id: '1c6210a8-3a68-4987-9085-d496f1db1202'
                    }
                  },
                  { _id: '3cb6fcc0-d6fe-4da0-bfe1-8052a05ccede' },
                  { title: 'Central Canadian Shield Forests' },
                  { regionId: '370' },
                  {
                    dek:
                      'This ecoregion includes much of boreal northern Quebec and Ontario, north of the temperate-boreal transition forests, south of the taiga, and west to include the northeastern shore of Lake Superior. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d73d36ec-643c-4555-940f-0a3a1c072380/370 Central Canadian Shield forests - Robert F Beltran.jpg',
                      _id: 'd73d36ec-643c-4555-940f-0a3a1c072380'
                    }
                  },
                  { _id: '745cba21-a8b1-464e-9fc4-86a4c55a113f' },
                  { title: 'Southern Hudson Bay Taiga' },
                  { regionId: '382' },
                  {
                    dek:
                      'This ecoregion encompasses the Hudson Bay Lowland(s), the most extensive wetland complex in North America and the third largest on Earth.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/70632768-afc3-489a-90e5-fd0b5d278ef5/382 Southern Hudson Bay taiga - Reed Noss.jpg',
                      _id: '70632768-afc3-489a-90e5-fd0b5d278ef5'
                    }
                  },
                  { _id: 'de86d732-53a2-48fe-8067-bfc10b5a98db' },
                  { title: 'Northern Canadian Shield Taiga ' },
                  { regionId: '379' },
                  {
                    dek:
                      'This ecoregion stretches from the eastern shore of Great Bear Lake, southeastward through the eastern half of Great Slave Lake, through the northeastern corner of Alberta, across northern Saskatchewan and the north shore of Lake Athabasca and eastward to southern Nunavut.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/59809435-5800-4a30-b42c-3dc1fe19f5ee/379 Northern Canadian Shield taiga - Paul Gierszewski.JPG',
                      _id: '59809435-5800-4a30-b42c-3dc1fe19f5ee'
                    }
                  },
                  { _id: 'd1bfa2e3-d60e-4f52-9579-9a9bd0ebdb8c' },
                  { title: 'Eastern Canadian Shield Taiga' },
                  { regionId: '374' },
                  {
                    dek:
                      'This immense ecoregion stretches from Hudson and James Bays of the Arctic Ocean east to the Labrador Sea of the Atlantic Ocean and north to the southern portion of Ungava Bay of the Arctic Ocean.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0b568a31-233e-4f23-9dd9-81ae52710024/374 Eastern Canadian Shield taiga - Paul Gierszewski.JPG',
                      _id: '0b568a31-233e-4f23-9dd9-81ae52710024'
                    }
                  }
                ],
                stats: [
                  { number: '325,135', item: 'Total Land Area (1000 ha)' },
                  { number: '6', item: 'Number of Ecoregions' },
                  { number: '97%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              },
              {
                name: 'Mid-Canada Boreal Plains & Foothill Forests (NA8)',
                children: [],
                _id: '4a9f3809-6350-4db7-a777-927277a0f8c2',
                value: 1000,
                parentId: '69fee9d5-5779-4721-a5f4-bf519378c6f4',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6c07fa19-ce92-4c24-81bc-ae39df0e6b1f/341 Alberta-British Columbia Foothills Forests As2020sa cc.jpg',
                    _id: '6c07fa19-ce92-4c24-81bc-ae39df0e6b1f'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f029c9c0-06da-40ca-8c95-f9fa39634795/376 Mid-Canada Boreal Plains Forests Image credit courtesy ofPeupleloup.jpg',
                    _id: 'f029c9c0-06da-40ca-8c95-f9fa39634795'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0f9984af-0768-4b26-87d3-bea33cedd9e7/Bioregion%20map-NA8.jpg',
                content:
                  '<p>The Mid-Canada Boreal bioregion, located in the Subarctic America (Nearctic) realm, is defined predominantly by the plains and foothill forests lying between the Northern Rockies to the west and the Canadian Shield forests to the east. It consists of two ecoregions \u2013 Alberta-British Columbia Foothills Forests (345), Mid-Canada Boreal Plains Forests (376) \u2013 and includes Lake Winnipeg with one of the largest watersheds in Canada. The total area of this bioregion is approximately 69 million hectares.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0f9984af-0768-4b26-87d3-bea33cedd9e7/Bioregion%20map-NA8.jpg"/><figcaption><span class="caption"><p>The Mid-Canada Boreal Plains &amp; Foothill Forests bioregion is part of the Canadian Boreal Forests subrealm and is made up of two ecoregions: (1) Alberta-British Columbia Foothills Forests (2) Mid-Canada Boreal Plains Forests.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Mid-Canada Boreal Plains &amp; Foothill Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '5defa646-2846-4bab-af43-97b325ca35f3' },
                  { title: 'Mid-Canada Boreal Plains Forests' },
                  { regionId: '376' },
                  {
                    dek:
                      'This ecoregion spans a large region of Canada, from just south of Wood Buffalo National Park in Alberta southeastward to just north of Winnipeg, Manitoba, encompassing Lake Winnipeg.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/daeeef37-0b86-4adf-bdad-bdb44ff7dc6d/376 Mid-Canada Boreal Plains forests - Mhalifu.JPG',
                      _id: 'daeeef37-0b86-4adf-bdad-bdb44ff7dc6d'
                    }
                  },
                  { _id: 'f9968fa5-3384-4c93-8d44-91cf6cb8baec' },
                  { title: 'Alberta-British Columbia Foothills Forests' },
                  { regionId: '345' },
                  {
                    dek:
                      'This ecoregion is an ecotone or transitional region between the Rocky Mountains to the west and the Mid-Canada Boreal Plains to the east, but also between the Boreal Forests/Taiga biome to the north and the Temperate Conifer Forests biome to the south.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c9218ba2-608b-4c4e-9295-6e5d28158931/345 Alberta-British Columbia foothills forests - Harpsz.jpg',
                      _id: 'c9218ba2-608b-4c4e-9295-6e5d28158931'
                    }
                  }
                ],
                stats: [
                  { number: '68,982', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '64%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              },
              {
                name: 'Northwest Canadian Taiga, Lakes, & Wetlands (NA7)',
                children: [],
                _id: '4e485461-d7d0-4faa-b3ae-e731afd61f5b',
                value: 1000,
                parentId: '69fee9d5-5779-4721-a5f4-bf519378c6f4',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b8974411-bec5-48c9-97a9-b76de9e1e70c/381 Northwest Territories Taiga Daniel Case cc.jpg',
                    _id: 'b8974411-bec5-48c9-97a9-b76de9e1e70c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e9cf87b4-5f5a-46e2-921d-dd875bd484fd/378 Muskwa-Slave Lake Taiga cc.jpg',
                    _id: 'e9cf87b4-5f5a-46e2-921d-dd875bd484fd'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5d8f8ee5-41a9-494f-9110-a2e624c40a0f/Bioregion%20map-NA7.jpg',
                content:
                  '<p>The Northwest Canadian Taiga bioregion, located in the west of the Canadian Boreal subrealm in the Subarctic America (Nearctic) realm, is the region lying between the Greater Yukon to the west and the Canadian Shield to the east, covering roughly half of the Northwest Territories in Canada. It consists of two large ecoregions \u2013 Muskwa-Slave Lake Taiga (378), Northwest Territories Taiga (381) \u2013 and includes Great Bear Lake, one of the largest lakes in North America, along with many wetlands.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5d8f8ee5-41a9-494f-9110-a2e624c40a0f/Bioregion%20map-NA7.jpg"/><figcaption><span class="caption"><p>The Northwest Canadian Taiga, Lakes, &amp; Wetlands bioregion is part of the Canadian Boreal subrealm and is made up of two ecoregions: (1) Northwest Territories Taiga (2) Muskwa-Slave Lake Taiga.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Northwest Canadian Taiga, Lakes, &amp; Wetlands ecoregions below.</p>',
                ecoregions: [
                  { _id: 'd8eab7e3-7fe6-4528-b877-19bb552fc343' },
                  { title: 'Northwest Territories Taiga' },
                  { regionId: '381' },
                  {
                    dek:
                      'This ecoregion is the northern extension of the generally flat Interior Plains of Canada, which include the boreal plains and prairie ecoregions to the south.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4b9d0ead-d4a7-4a3a-b3f2-2c020b2312cd/381 Northwest Territories taiga - David Adamec.jpg',
                      _id: '4b9d0ead-d4a7-4a3a-b3f2-2c020b2312cd'
                    }
                  },
                  { _id: 'd394ef5d-029e-49a9-b4fa-1d9fe499517a' },
                  { title: 'Muskwa-Slave Lake Taiga' },
                  { regionId: '378' },
                  {
                    dek:
                      'This ecoregion contains the Wood Buffalo National Park, the largest national park in Canada and the second largest national park in the world.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/41547005-3585-46a9-a8cd-d10fcbf78441/378 Muskwa-Slave Lake taiga - The Interior.JPG',
                      _id: '41547005-3585-46a9-a8cd-d10fcbf78441'
                    }
                  }
                ],
                stats: [
                  { number: '63,082', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '93%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              },
              {
                name: 'Greater Yukon (NA6)',
                children: [],
                _id: 'a28b7c1b-9f74-4aab-b310-5e10919df825',
                value: 1000,
                parentId: '69fee9d5-5779-4721-a5f4-bf519378c6f4',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/87ad718e-42f5-44fd-9812-dae6def0334e/419 Ogilvie-MacKenzie Alpine Tundra Paul Gierszewski cc.jpg',
                    _id: '87ad718e-42f5-44fd-9812-dae6def0334e'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/510d9a68-5987-4dff-8eac-23cddbba74d6/380 Northern Cordillera Forests Gharv cc.jpg',
                    _id: '510d9a68-5987-4dff-8eac-23cddbba74d6'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f4ad7b03-9764-4ae2-899a-124b80d117d8/380 Northern Cordillera Forests paul Gierszewski cc2.jpg',
                    _id: 'f4ad7b03-9764-4ae2-899a-124b80d117d8'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0983eea8-8bf9-4e87-b381-df32aa90559a/380 Northern_Cordillera_forests Adam Jones cc.jpg',
                    _id: '0983eea8-8bf9-4e87-b381-df32aa90559a'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3d12539e-3b6d-4763-abee-a0cbec497946/Bioregion%20map-NA6.jpg',
                content:
                  '<p>The Greater Yukon bioregion, located in the Subarctic America (Nearctic) realm, lies within the mountainous cordilleran region of western North American in the far west of the Canadian Boreal subrealm, defined by a large central plateau surrounded by some of the world\u2019s highest mountains. This region is the source of the Yukon River, which flows west across Alaska, and is dominated by boreal forest with tundra in the north. It includes three ecoregions \u2013 Northern Cordillera Forests (380), Watson Highlands Taiga (383), and Ogilvie-MacKenzie Alpine Tundra (419). The total area of this bioregion is approximately 71 million hectares.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3d12539e-3b6d-4763-abee-a0cbec497946/Bioregion%20map-NA6.jpg"/><figcaption><span class="caption"><p>The Greater Yukon bioregion is part of the Canadian Boreal subrealm and is made up of three ecoregions: (1) Ogilvie-MacKenzie Alpine Tundra (2) Watson Highlands Taiga (3) Northern Cordillera Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Greater Yukon ecoregions below.</p>',
                ecoregions: [
                  { _id: '92345f33-b713-4ac1-9e30-87faa6e7a78a' },
                  { title: 'Watson Highlands Taiga' },
                  { regionId: '383' },
                  {
                    dek:
                      'This ecoregion includes a large part of the Yukon Plateau and other highlands, ranging from the southwestern edge of Northwest Territories in the east, westward across northern British Columbia and a larger area of southern Yukon Territory, almost to Alaska.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3be8883d-6122-4ea6-89d5-11c1e7a15fa8/383 Watson Highlands taiga - brigachtal.jpg',
                      _id: '3be8883d-6122-4ea6-89d5-11c1e7a15fa8'
                    }
                  },
                  { _id: '3b0f9b16-87d5-4cfd-aea5-dc49837e6467' },
                  { title: 'Northern Cordillera Forests' },
                  { regionId: '380' },
                  {
                    dek:
                      'This ecoregion encompasses the northern extent of the Rocky Mountains (what Canadians call the \u201cNorthern Rockies\u201d) and the northern Coast Mountains, as well as some smaller ranges and the Stikine Plateau. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/be243172-4680-484d-8cae-2aa98a27b5d5/380 Northern Cordillera forests - brigachtal.jpg',
                      _id: 'be243172-4680-484d-8cae-2aa98a27b5d5'
                    }
                  },
                  { _id: '405fcfe3-6ebe-4d8f-8f32-5ccf7d27190a' },
                  { title: 'Ogilvie-Mackenzie Alpine Tundra ' },
                  { regionId: '419' },
                  {
                    dek:
                      'This ecoregion encompasses the Ogilvie and Wernecke Mountains in the north, the Backbone Ranges, the Canyon Ranges, the Selwyn Mountains, and the eastern and southern Mackenzie Range.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/683d3286-f1f8-4608-828c-34239adb587e/419 Ogilvie-MacKenzie alpine tundra - brigachtal.jpg',
                      _id: '683d3286-f1f8-4608-828c-34239adb587e'
                    }
                  }
                ],
                stats: [
                  { number: '70,883', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '99%', item: 'Protection Target ' },
                  { number: '1', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Subarctic America',
            value: 1000
          },
          {
            _id: 'b13dcd12-eff4-4e2b-b894-ee53adf4bb42',
            name: 'Greenland',
            children: [
              {
                name: 'Greenland (NA1)',
                children: [],
                _id: '1d017f85-6ea1-4f85-8391-2314f92051bd',
                value: 1000,
                parentId: 'b13dcd12-eff4-4e2b-b894-ee53adf4bb42',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ed9f91e3-c3d1-45f7-b131-d7a4d8959722/417 Kalaallit Nunaat Arctic steppe - Morton Kilsholm.jpg',
                    _id: 'ed9f91e3-c3d1-45f7-b131-d7a4d8959722'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/35166b7c-f7af-413e-bcdf-3ad116d13c66/418 Kalaallit Nunaat High Arctic tundra - Jerzy Strzelecki resized.jpeg',
                    _id: '35166b7c-f7af-413e-bcdf-3ad116d13c66'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fe0262d3-7eae-4cad-88f7-97d0e3ef8c05/NA01-Greenland%20(1).jpg',
                content:
                  '<p>Greenland, located in the Subarctic America (Nearctic) realm, is the world\u2019s largest island, and this bioregion consists entirely of ice-covered land, coastal tundra, and sea ice with two ecoregions \u2013 Kalaallit Nunaat Arctic Steppe [1] and Kalaallit Nunaat High Arctic Tundra [2] \u2013 including adjacent marine areas. The total land area of this bioregion is approximately 217 million hectares, about one-quarter the size of Australia. Of that, approximately 47.5 million is tundra.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fe0262d3-7eae-4cad-88f7-97d0e3ef8c05/NA01-Greenland%20(1).jpg"/><figcaption><span class="caption"><p>The Greenland bioregion is part of the Greenland subrealm and is made up of two ecoregions: Kalaallit Nunaat Arctic Steppe [1] and Kalaallit Nunaat High Arctic Tundra [2].</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic America. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Greenland ecoregions below.</p>',
                ecoregions: [
                  { _id: 'e8399c97-48ba-4e38-b0c2-7c76c52105ce' },
                  { title: 'Kalaallit Nunaat High Arctic Tundra' },
                  { regionId: '418' },
                  {
                    dek:
                      'This ecoregion is the most northern land on the planet. Only the most cold-hardy plants and animals are able to survive in this forbidding area. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bd6c3edd-7810-4705-9833-656ed3244531/418 Kalaallit Nunaat High Arctic Tundra Rita Willaert cc resized.jpeg',
                      _id: 'bd6c3edd-7810-4705-9833-656ed3244531'
                    }
                  },
                  { _id: '797ab6fb-bc51-42d8-8cb7-c5f9c702f8aa' },
                  { title: 'Kalaallit Nunaat Arctic Steppe' },
                  { regionId: '417' },
                  {
                    dek:
                      'This ecoregion occupies the southwestern coast of Greenland, across Baffin Bay from Canada\u2019s (Nunavut) Baffin Island, and the southern two-thirds of eastern Greenland, west and north of Iceland.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ed9f91e3-c3d1-45f7-b131-d7a4d8959722/417 Kalaallit Nunaat Arctic steppe - Morton Kilsholm.jpg',
                      _id: 'ed9f91e3-c3d1-45f7-b131-d7a4d8959722'
                    }
                  }
                ],
                stats: [
                  { number: '47,573', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '48%', item: 'Protection Target' },
                  { number: '10', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Subarctic America',
            value: 250
          }
        ],
        parentId: 'top',
        _id: 'Subarctic America',
        value: 666
      },
      {
        name: 'Subarctic Eurasia',
        children: [
          {
            _id: '8589131e-2c15-47cb-bfaa-cac1c7d8c03c',
            name: 'Scandinavia & West Boreal Forests',
            children: [
              {
                name: 'Ural Mountains & West Eurasian Taiga Forests (PA8)',
                children: [],
                _id: '8f3a050a-38e1-4050-8440-fa7ad1f291cb',
                value: 1000,
                parentId: '8589131e-2c15-47cb-bfaa-cac1c7d8c03c',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9839c22d-7a9c-45f2-aec0-e912f92a2147/717-RanelvaIllhoellia-Dunderlandsdalen-Norway-CC-2007.JPG',
                    _id: '9839c22d-7a9c-45f2-aec0-e912f92a2147'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/17ed160d-ef8f-4329-bc33-fb3eae169c7d/717-Forest_at_Leivonm\u00e4ki_NP-CC-2010_resized.jpg',
                    _id: '17ed160d-ef8f-4329-bc33-fb3eae169c7d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/617ff4ef-82e9-4c99-83c4-fdf8390f94ad/719-Basegi Nature Reserve in the Urals-CC-\u0420\u0430\u0441\u0442\u043e\u0440\u0433\u0443\u0435\u0432 \u041c\u0430\u043a\u0441\u0438\u043c-2011_resized.jpg',
                    _id: '617ff4ef-82e9-4c99-83c4-fdf8390f94ad'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4f374ea4-ec1a-4e60-b51e-8b1eb2295f6b/Bioregion%20map-PA8.jpg',
                content:
                  '<p>The Ural Mountains &amp; West Eurasian Taiga Forests Bioregion is located in the Subarctic Eurasia realm (northern Palearctic) and contains two ecoregions \u2013 Scandinavian and Russian Taiga (717), Urals Montane Forest and Taiga (719) \u2013 totaling more than 233 million hectares of land area.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4f374ea4-ec1a-4e60-b51e-8b1eb2295f6b/Bioregion%20map-PA8.jpg"/><figcaption><span class="caption"><p>The Ural Mountains &amp; West Eurasian Taiga Forests bioregion is part of the Scandinavia &amp; West Boreal Forests subrealm and is made up of two ecoregions: (1) Scandinavian and Russian Taiga (2) Urals Montane Forest and Taiga.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Ural Mountains &amp; West Eurasian Taiga Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '758a60d1-2e49-4100-8954-01008139d940' },
                  { title: 'Urals Montane Forest and Taiga' },
                  { regionId: '719' },
                  {
                    dek:
                      'This ecoregion is centered on the Ural Mountains, a 2,000 km range that runs north-south through the Russian Federation, from the Arctic Ocean to the Ural River.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ab75af22-8313-4853-a789-20fb2e3abf27/719 Urals montane forest and taiga - Sergeu Berezin.jpg',
                      _id: 'ab75af22-8313-4853-a789-20fb2e3abf27'
                    }
                  },
                  { _id: '801c845f-2dd4-4bb1-b3fb-8c3a5d1fd05b' },
                  { title: 'Scandinavian and Russian Taiga' },
                  { regionId: '717' },
                  {
                    dek:
                      'This is the largest ecoregion in Europe, stretching across Norway, Sweden, Finland, and into the northern part of Russia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cfba640c-92d2-428c-b93a-90a992434228/717 Scandinavian and Russian taiga - Jacqueline Macou.jpg',
                      _id: 'cfba640c-92d2-428c-b93a-90a992434228'
                    }
                  }
                ],
                stats: [
                  { number: '233,698', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '52%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Scandinavian Birch & Coastal Conifer Forests (PA3)',
                children: [],
                _id: '932ec2be-c238-4d62-ae5b-5a9a117c252a',
                value: 1000,
                parentId: '8589131e-2c15-47cb-bfaa-cac1c7d8c03c',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2d1e8304-796c-4be9-a974-53c619b39996/708 Scandinavian coastal conifer forests - ioa8340.jpg',
                    _id: '2d1e8304-796c-4be9-a974-53c619b39996'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b336b5bc-2918-45cb-a591-8212903a5b37/Bioregion%20map-PA3.jpg',
                content:
                  '<p>The Scandinavian Birch &amp; Coastal Conifer Forests bioregion is located in the Subarctic Eurasia realm (northern Palearctic) and contains two ecoregions \u2013 Scandinavian Coastal Conifer Forests (708), Scandinavian Montane Birch Forest and Grasslands (780) \u2013 totaling more than 26 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b336b5bc-2918-45cb-a591-8212903a5b37/Bioregion%20map-PA3.jpg"/><figcaption><span class="caption"><p>The Scandinavian Birch &amp; Coastal Conifer Forests bioregion is part of the Scandinavia &amp; West Boreal Forests subrealm. It is made up of two ecoregions: (1) Scandinavian Coastal Conifer Forests and (2) Scandinavian Montane Birch Forest and Grasslands.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Scandinavian Birch &amp; Coastal Conifer Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '58f941e0-b782-4d5c-ad5c-2c9af780a58f' },
                  { title: 'Scandinavian Montane Birch Forest and Grasslands' },
                  { regionId: '780' },
                  {
                    dek:
                      'The Southern part of this ecoregion is situated in Norway\u2019s central highlands and the Northern part follows the Scandinavian mountains across Norway and Sweden, and touches the northern tip of Finland. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c31f16fe-8ff7-4a65-aa9d-45b6ee6e3cdc/780 Scandinavian Montane Birch forest and grasslands - Arto Marttinen.jpg',
                      _id: 'c31f16fe-8ff7-4a65-aa9d-45b6ee6e3cdc'
                    }
                  },
                  { _id: '00c456fa-956d-4594-a6c5-184fb079d33d' },
                  { title: ' Scandinavian Coastal Conifer Forests' },
                  { regionId: '708' },
                  {
                    dek:
                      'This ecoregion follows the western Norwegian coast from Flekkefjord to Senja.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2d1e8304-796c-4be9-a974-53c619b39996/708 Scandinavian coastal conifer forests - ioa8340.jpg',
                      _id: '2d1e8304-796c-4be9-a974-53c619b39996'
                    }
                  }
                ],
                stats: [
                  { number: '26,327', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '72%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              },
              {
                name: 'Iceland (PA2)',
                children: [],
                _id: 'c576e375-de57-4c07-9eec-307b5dbea855',
                value: 1000,
                parentId: '8589131e-2c15-47cb-bfaa-cac1c7d8c03c',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/baaa8b4e-8082-4e93-838d-9f76e040cc7f/711 Neil Crawford.jpg',
                    _id: 'baaa8b4e-8082-4e93-838d-9f76e040cc7f'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2c1327ad-5385-4a98-8bac-38daf9904eb0/711 Reykholt cc.jpg',
                    _id: '2c1327ad-5385-4a98-8bac-38daf9904eb0'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c0764675-7157-40c8-a641-7e6239147b90/Bioregion%20map-PA2.jpg',
                content:
                  '<p>The Iceland bioregion is located in the Subarctic Eurasia realm (northern Palearctic) and contains one single ecoregion \u2013 Boreal Birch Forests and Alpine Tundra (711) \u2013 totaling approximately 9 million hectares of land area.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c0764675-7157-40c8-a641-7e6239147b90/Bioregion%20map-PA2.jpg"/><figcaption><span class="caption"><p>The Iceland bioregion is part of the Scandinavia &amp; West Boreal Forests subrealm and is made up of one ecoregion: (1) Boreal Birch Forests and Alpine Tundra.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the ecoregion below.</p>',
                ecoregions: [
                  { _id: 'd3a4ff49-8ff7-4572-b6bb-48c947aceda8' },
                  { title: 'Iceland Boreal Birch Forests and Alpine Tundra' },
                  { regionId: '711' },
                  {
                    dek:
                      'Iceland is the second largest island in the North Atlantic Ocean with its northern edge situated just south of the Arctic Circle. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/52a390a6-35ed-49bf-9868-cfafa13a5848/711 Iceland boreal birch forests and alpine tundra -David Mark.jpg',
                      _id: '52a390a6-35ed-49bf-9868-cfafa13a5848'
                    }
                  }
                ],
                stats: [
                  { number: '9,168', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '72%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Subarctic Eurasia',
            value: 1000
          },
          {
            _id: '370980e2-848a-4404-ac21-2bded3f0543a',
            name: 'Palearctic Tundra',
            children: [
              {
                name: 'Greater Eurasian Tundra (PA4)',
                children: [],
                _id: '8e0da6df-8bcc-4db1-88f3-1139861ee02b',
                value: 1000,
                parentId: '370980e2-848a-4404-ac21-2bded3f0543a',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0d941f47-e774-47f2-9244-87b933ad7dd0/1440px-Lovozero_Massif1.jpg',
                    _id: '0d941f47-e774-47f2-9244-87b933ad7dd0'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/80b9a0eb-a333-4126-99d6-701f2c19f153/777-Strichowa-Island-CC-Ansgar Walk-2014.jpg',
                    _id: '80b9a0eb-a333-4126-99d6-701f2c19f153'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d0e08796-97e7-4e9d-a75d-7ea82e69fb66/777-Kotelny island-CC_Ansgar Walk-2014.jpg',
                    _id: 'd0e08796-97e7-4e9d-a75d-7ea82e69fb66'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/591094af-9e2d-436d-a11c-709bdf88f80a/784-Taz_River-CC-2010.jpg',
                    _id: '591094af-9e2d-436d-a11c-709bdf88f80a'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/15704159-1131-4d80-9927-24161e81d8d4/Bioregion%20map-PA4.jpg',
                content:
                  '<p>The Greater Eurasian Tundra bioregion is located in the Subarctic Eurasia realm (northern Palearctic) and contains six ecoregions \u2013 Kola Peninsula Tundra (774), Northeast Siberian Coastal Tundra (775), Northwest Russian-Novaya Zemlya Tundra (776), Novosibirsk Islands Arctic Desert (777), Taimyr-Central Siberian Tundra (781), Yamal-Gydan Tundra (784) \u2013 totaling more than 197 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/15704159-1131-4d80-9927-24161e81d8d4/Bioregion%20map-PA4.jpg"/><figcaption><span class="caption"><p>The Greater Eurasian Tundra bioregion is part of the Palearctic Tundra subrealm and is made up of six ecoregions: (1) Kola Peninsula Tundra (2) Northwest Russian-Novaya Zemlya Tundra (3) Yamal-Gydan Tundra (4) Taimyr-Central Siberian Tundra (5) Novosibirsk Islands Arctic Desert (6) Northeast Siberian Coastal Tundra.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Greater Eurasian Tundra ecoregions below.</p>',
                ecoregions: [
                  { _id: '868e3cfc-c162-4b9b-bfec-4da9fa4f4f2b' },
                  { title: 'Yamal-Gydan Tundra' },
                  { regionId: '784' },
                  {
                    dek:
                      'This ecoregion lies in the middle of Russia\u2019s arctic coast, to the south of the Kara Sea. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/718a3ce3-2de6-4278-bc9d-7c4fffe2ed1a/784 Yamal-Gydan tundra - Andreas Hugentobler.jpg',
                      _id: '718a3ce3-2de6-4278-bc9d-7c4fffe2ed1a'
                    }
                  },
                  { _id: 'c4fee286-c3e0-4e88-9c65-d91bb5b0a830' },
                  { title: 'Taimyr-Central Siberian Tundra' },
                  { regionId: '781' },
                  {
                    dek:
                      'The northernmost continental land in the world, this ecoregion is a vast area of pristine polar desert, mountain and lowland tundra, rich wetlands and larch forests.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7bf9165b-eded-44e8-997d-a73f4883c1d7/781 Taimyr-Central Siberian tundra - \u0424\u0430\u0433\u0435 \u0410\u043b\u0435\u043a\u0441\u0435\u0439 \u041d\u0438\u043a\u043e\u043b\u0430\u0435\u0432\u0438\u0447.jpg',
                      _id: '7bf9165b-eded-44e8-997d-a73f4883c1d7'
                    }
                  },
                  { _id: 'cdb810f9-c216-444a-bc5d-8d3f37cb8d94' },
                  { title: 'Novosibirsk Islands Arctic Desert' },
                  { regionId: '777' },
                  {
                    dek:
                      'The Novosibirsk archipelago is found off the north coast of eastern Siberia, dividing the Laptev and East Siberian Seas.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2d93f88b-b138-49f3-aec2-2dee2a5cea59/777 Novosibirsk Islands Arctic desert - Ansgar Walk.jpg',
                      _id: '2d93f88b-b138-49f3-aec2-2dee2a5cea59'
                    }
                  },
                  { _id: '27d1da71-8fe2-43db-9aaa-78e8abb689ef' },
                  { title: 'Northwest Russian-Novaya Zemlya Tundra' },
                  { regionId: '776' },
                  {
                    dek:
                      'This ecoregion spans 1,000 km of the North Coast of European Russia stretching from the White Sea-bound Kanin Peninsula in the West, to the Yugorsky Peninsula in the East.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/350300a6-0251-471c-a953-e13fab22bc9e/776 Northwest Russian-Novaya Zemlya tundra - Ansgar Walk.jpg',
                      _id: '350300a6-0251-471c-a953-e13fab22bc9e'
                    }
                  },
                  { _id: '0f9d705e-37fe-4fc8-a293-02bd6d7f0513' },
                  { title: 'Northeast Siberian Coastal Tundra' },
                  { regionId: '775' },
                  {
                    dek:
                      'This ecoregion covers northeastern Sakha, from Sytygan-Tala Bay to the Kolyma river delta.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f79d39ac-9780-494c-8753-8dfb18c3fbc2/775 Northeast Siberian coastal tundra - John Lamoreux.jpg',
                      _id: 'f79d39ac-9780-494c-8753-8dfb18c3fbc2'
                    }
                  },
                  { _id: 'a34bf4b4-1ab9-4369-b1e9-b7fd5aa50180' },
                  { title: ' Kola Peninsula Tundra' },
                  { regionId: '774' },
                  {
                    dek:
                      'This tundra stretches across the Northern shore of the Russian Federation\u2019s Kola Peninsula, reaching into the northeasternmost tip of Norway.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9eb12f8c-8303-41d9-b5af-ede4e41e76cd/774 Kola Peninsula tundra - liskared.jpg',
                      _id: '9eb12f8c-8303-41d9-b5af-ede4e41e76cd'
                    }
                  }
                ],
                stats: [
                  { number: '197,393', item: 'Total Land Area (1000 ha)' },
                  { number: '6', item: 'Number of Ecoregions' },
                  { number: '89%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Russian Arctic Desert Islands (PA1)',
                children: [],
                _id: 'df4785b2-c677-48dd-941e-22a68fd363b5',
                value: 1000,
                parentId: '370980e2-848a-4404-ac21-2bded3f0543a',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/624ba04f-3d41-4cb6-bea6-4a189af78d0b/778 russian arctic desert \u041d\u0438\u043a\u043e\u043b\u0430\u0439 \u0413\u0435\u0440\u043d\u0435\u0442.jpg',
                    _id: '624ba04f-3d41-4cb6-bea6-4a189af78d0b'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/40082a7a-ae6f-4fab-ba23-6d5ba9e9f300/Bioregion%20map-PA1.jpg',
                content:
                  '<p>The Russian Arctic bioregion is located in the Subarctic Eurasia realm (northern Palearctic) and contains one single ecoregion \u2013 Russian Arctic Tundra (778) \u2013 totaling more than 16 million hectares of land area. &nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/40082a7a-ae6f-4fab-ba23-6d5ba9e9f300/Bioregion%20map-PA1.jpg"/><figcaption><span class="caption"><p>The Russian Arctic Desert Islands bioregion is part of the Palearctic Tundra subrealm and is made up of one ecoregion: (1) Russian Arctic Tundra.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Russian Arctic Desert Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: '35398fc7-24df-45dc-8564-ff493307b6b8' },
                  { title: 'Russian Arctic Desert' },
                  { regionId: '778' },
                  { dek: 'Four major archipelagos lie within this region of the High Arctic.' },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4e84b896-0e28-4db1-b730-39556c45b28b/778 Russian Arctic desert - Mince1.JPG',
                      _id: '4e84b896-0e28-4db1-b730-39556c45b28b'
                    }
                  }
                ],
                stats: [
                  { number: '16,182', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '39%', item: 'Protection Target' },
                  { number: '10', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Subarctic Eurasia',
            value: 666
          },
          {
            _id: '906a1bd5-2915-41de-aab0-147a37e6e719',
            name: 'Sea of Okhotsk & Bearing Tundra/Taiga',
            children: [
              {
                name: 'Sea of Okhotsk Coastal Taiga, Meadows & Tundra (PA6)',
                children: [],
                _id: 'df5587df-e49c-4bd1-ad69-579d43b7cfc7',
                value: 1000,
                parentId: '906a1bd5-2915-41de-aab0-147a37e6e719',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/124f0545-61c2-468e-a24d-5cc1ec786597/712 Kamchatka taiga - \u041d\u0430\u0442\u0430\u043b\u044c\u044f \u041a\u043e\u043b\u043b\u0435\u0433\u043e\u0432\u0430 1.jpg',
                    _id: '124f0545-61c2-468e-a24d-5cc1ec786597'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dd51bc93-11b2-4f44-90fb-46f81c5b49de/713-Kronotsky Nature Reserve-CC-2014.JPG',
                    _id: 'dd51bc93-11b2-4f44-90fb-46f81c5b49de'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b14e49ba-ee0d-4fcd-952b-52f87e384e60/716-Gora_Lopatina_Sakhalin-Sakhalin Island taiga-CC-2010.JPG',
                    _id: 'b14e49ba-ee0d-4fcd-952b-52f87e384e60'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d2ecbe2a-a873-4c43-a5d9-275fe9718848/Bioregion%20map-PA6.jpg',
                content:
                  '<p>The Sea of Okhotsk Coastal Taiga, Meadows &amp; Tundra bioregion is located in the Subarctic Eurasia realm (northern Palearctic) and contains five ecoregions \u2013 Kamchatka Taiga (712), Kamchatka-Kurile Meadows and Sparse Forests (713), Okhotsk-Manchurian Taiga (715), Sakhalin Island Taiga (716), Kamchatka Tundra (773) \u2013 totaling more than 75 million hectares of land area.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d2ecbe2a-a873-4c43-a5d9-275fe9718848/Bioregion%20map-PA6.jpg"/><figcaption><span class="caption"><p>The Sea of Okhotsk Coastal Taiga, Meadows &amp; Tundra bioregion is part of the Sea of Okhotsk &amp; Bearing Tundra/Taiga subrealm and is made up of five ecoregions: (1) Okhotsk-Manchurian Taiga (2) Sakhalin Island Taiga (3) Kamchatka-Kurile Meadows and Sparse Forests (4) Kamchatka Tundra (5) Kamchatka Taiga.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Sea of Okhotsk Coastal Taiga, Meadows &amp; Tundra ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: '886eaf9f-4927-4f94-8bf4-36574bbfe3fa' },
                  { title: ' Kamchatka Tundra' },
                  { regionId: '773' },
                  {
                    dek:
                      ' This ecoregion covers two mountain ranges \u2014 the Sredinny mountains running down the center of the peninsula, and the more dissected Vostochniy range on the eastern side, with over 20 active volcanoes.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c40f1177-7eab-465c-bb6e-90dbfdefe567/773 Kamchatka tundra - Natalia Kollegova.jpg',
                      _id: 'c40f1177-7eab-465c-bb6e-90dbfdefe567'
                    }
                  },
                  { _id: '0566a172-2ae6-4004-a71a-498b98e1158a' },
                  { title: 'Sakhalin Island Taiga' },
                  { regionId: '716' },
                  {
                    dek:
                      'This ecoregion covers the majority of Sakhalin, a 948 km-long island separating the Sea of Okhotsk from the Sea of Japan in the far east of Russia. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c637731a-4cc5-4295-aeba-5544ac30cf8f/716 Sakhalin Island taiga - Lupus-sapien.JPG',
                      _id: 'c637731a-4cc5-4295-aeba-5544ac30cf8f'
                    }
                  },
                  { _id: '1a293aa5-d274-4609-8570-042c40f419cb' },
                  { title: 'Okhotsk-Manchurian Taiga' },
                  { regionId: '715' },
                  {
                    dek:
                      'This ecoregion is dominated by mountains and shaped by the Amur river. Reindeer and Siberian musk deer forage on lichen found in the forests of Dahurian larch and Yeddo spruce.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2c907a0c-87bf-47c3-87f5-e1a64716073e/715 Okhotsk-Manchurian taiga - \u0421 \u0428\u0443\u0440\u0430\u043d\u043e\u0432.jpg',
                      _id: '2c907a0c-87bf-47c3-87f5-e1a64716073e'
                    }
                  },
                  { _id: '2d0e393a-0675-40c6-b83a-cb8e818da5ac' },
                  { title: 'Kamchatka-Kurile Meadows and Sparse Forests' },
                  { regionId: '713' },
                  {
                    dek:
                      'This ecoregion is generally found from sea level to 900 m or, in central Kamchatka, as a zone between 350\u2013800 m.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/66629f9f-cc81-48c0-a8da-f1cd4a89a1ef/713 Kamchatka-Kurile meadows and sparse forests - Natalia Kollegova.jpg',
                      _id: '66629f9f-cc81-48c0-a8da-f1cd4a89a1ef'
                    }
                  },
                  { _id: '2096aa38-5451-417e-80b4-0b5a9713bdbf' },
                  { title: 'Kamchatka Taiga' },
                  { regionId: '712' },
                  {
                    dek:
                      'Between the Sredinny Mountain Range and the Vostochny Ridge, lies the Central Kamchatka Depression.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/124f0545-61c2-468e-a24d-5cc1ec786597/712 Kamchatka taiga - \u041d\u0430\u0442\u0430\u043b\u044c\u044f \u041a\u043e\u043b\u043b\u0435\u0433\u043e\u0432\u0430 1.jpg',
                      _id: '124f0545-61c2-468e-a24d-5cc1ec786597'
                    }
                  }
                ],
                stats: [
                  { number: '75,336', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions ' },
                  { number: '86%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level ' }
                ]
              },
              {
                name: 'East Eurasian Coastal Tundra (PA5)',
                children: [],
                _id: 'e21a3b25-64b0-450b-8a40-b2115faf2465',
                value: 1000,
                parentId: '906a1bd5-2915-41de-aab0-147a37e6e719',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/84af86ff-b74c-4b1f-9ded-43b212a29e6e/783 Wrangel Island Arctic Desert Boris Solovyev CC4.jpg',
                    _id: '84af86ff-b74c-4b1f-9ded-43b212a29e6e'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b8c0de7d-00e4-49ec-b2f7-4fedfa2a8807/772 Chukchi Peninsula tundra - Limp182_resized.jpg',
                    _id: 'b8c0de7d-00e4-49ec-b2f7-4fedfa2a8807'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a1dcab8c-5a0e-4509-8b2d-f3dfe8471510/783 Wrangel Island Arctic Desert Boris Solovyev CC6.jpg',
                    _id: 'a1dcab8c-5a0e-4509-8b2d-f3dfe8471510'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2c4ce581-12cc-426b-b4c0-b4ca5f5e3ea7/783 Wrangel Island Arctic Desert Boris Solovyev CC1.jpg',
                    _id: '2c4ce581-12cc-426b-b4c0-b4ca5f5e3ea7'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e3c176dd-7401-443d-81ac-10366d2287a1/783 Wrangel Island Arctic Desert Boris Solovyev CC3.jpg',
                    _id: 'e3c176dd-7401-443d-81ac-10366d2287a1'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2b1e397d-b4f3-40ce-9967-4829ef5e4612/Bioregion%20map-PA5.jpg',
                content:
                  '<p>The East Eurasian Coastal Tundra bioregion is located in the Subarctic Eurasia realm (northern Palearctic) and contains three ecoregions \u2013 Chukchi Peninsula Tundra (772), Russian Bering Tundra (779), Wrangel Island Arctic Desert (783) \u2013 totaling approximately 78 million hectares of land area.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2b1e397d-b4f3-40ce-9967-4829ef5e4612/Bioregion%20map-PA5.jpg"/><figcaption><span class="caption"><p>The East Eurasian Coastal Tundra bioregion is part of the Sea of Okhotsk &amp; Bearing Tundra/Taiga subrealm and is made up of three ecoregions: (1) Russian Bering Tundra (2) Chukchi Peninsula Tundra (3) Wrangel Island Arctic Desert.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the East Eurasian Coastal Tundra ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: '2ed1395a-f377-488e-bfbf-abe77562e80e' },
                  { title: ' Wrangel Island Arctic Desert' },
                  { regionId: '783' },
                  {
                    dek:
                      'This ecoregion has unique ancient steppe and tundra vegetation, providing insight into life during Pleistocene times.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/259db024-349f-4d41-9318-972af503c3d5/783 Wrangel Island tundra - NOAA.jpg',
                      _id: '259db024-349f-4d41-9318-972af503c3d5'
                    }
                  },
                  { _id: 'a41bf539-39f1-4c46-a281-1f9ef9a125bf' },
                  { title: 'Russian Bering Tundra' },
                  { regionId: '779' },
                  {
                    dek:
                      'This ecoregion stretches between the Kolyma Mountains to the west, the Bering Sea coast to the east, and the Kamchatka peninsula to the south. The climate of the region is subarctic, influenced by the Pacific monsoon. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/15fe8ebe-ecd0-424a-abd2-d9040d9932a6/779 Russian Bering tundra - \u0418\u0433\u043e\u0440\u044c \u0428\u043f\u0438\u043b\u0435\u043d\u043e\u043a.jpg',
                      _id: '15fe8ebe-ecd0-424a-abd2-d9040d9932a6'
                    }
                  },
                  { _id: '5954a747-e8dc-4527-b0a2-91799d595889' },
                  { title: ' Chukchi Peninsula Tundra' },
                  { regionId: '772' },
                  {
                    dek:
                      'This ecoregion stretches from the Kolyma rivermouth to Cape Dezhnev, the easternmost point of mainland Asia. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b8c0de7d-00e4-49ec-b2f7-4fedfa2a8807/772 Chukchi Peninsula tundra - Limp182_resized.jpg',
                      _id: 'b8c0de7d-00e4-49ec-b2f7-4fedfa2a8807'
                    }
                  }
                ],
                stats: [
                  { number: '78,187', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '92%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Subarctic Eurasia',
            value: 666
          },
          {
            _id: '57261592-ccf8-4fde-b4ca-c8e1e79fb349',
            name: 'Siberia & East Boreal Forests',
            children: [
              {
                name: 'Siberian Boreal Forests & Mountain Tundra (PA7)',
                children: [],
                _id: '56a9b6cf-a88b-499d-bb7e-c30de6eb512c',
                value: 1000,
                parentId: '57261592-ccf8-4fde-b4ca-c8e1e79fb349',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cac96ddc-49e6-409b-8e92-54b7074d5a94/714 Northeast Siberian Taiga - Bartosh Dmytro.jpg',
                    _id: 'cac96ddc-49e6-409b-8e92-54b7074d5a94'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a7c05fc1-f0ec-4948-aa91-f0b7d364200e/710-Taiga_of_Far_East-Poliny Ospenko-CC-2006_resized.jpg',
                    _id: 'a7c05fc1-f0ec-4948-aa91-f0b7d364200e'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1eeef138-dedc-4262-8e71-76baa9973f28/771-Peak Pobeda in the Chersky Range-CC-2018.jpg',
                    _id: '1eeef138-dedc-4262-8e71-76baa9973f28'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6656c8f1-30f6-407c-bf91-6a9672ba25aa/Bioregion%20map-PA7.jpg',
                content:
                  '<p>The Siberian Boreal Forests &amp; Mountain Tundra bioregion is located in the Subarctic Eurasia realm (northern Palearctic) and contains six ecoregions \u2013 East Siberian Taiga (710), Northeast Siberian Taiga (714), Trans-Baikal Conifer Forests (718), West Siberian Taiga (720), Cherskii-Kolyma Mountain Tundra (771), Trans-Baikal Bald Mountain Tundra (782) \u2013 totaling nearly 769 million hectares of land area.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6656c8f1-30f6-407c-bf91-6a9672ba25aa/Bioregion%20map-PA7.jpg"/><figcaption><span class="caption"><p>The Siberian Boreal Forests &amp; Mountain Tundra bioregion is part of the Siberia &amp; East Boreal Forests subrealm and is made up of six ecoregions: (1) West Siberian Taiga (2) East Siberian Taiga (3) Cherskii-Kolyma Mountain Tundra (4) Trans-Baikal Bald Mountain Tundra (5) Cherskii-Kolyma Mountain Tundra (6) Northeast Siberian Taiga.&nbsp;</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Subarctic Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Siberian Boreal Forests &amp; Mountain Tundra ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: '8c6e830b-0204-49a2-bfe0-a95a1218b4ce' },
                  { title: 'Trans-Baikal Bald Mountain Tundra' },
                  { regionId: '782' },
                  {
                    dek:
                      'This ecoregion is located along a chain of mountaintops running from the northern edge of Lake Baikal to the coast of the Okhotsk Sea\u2014a series of islands amongst the East Siberian and Okhotsk-Manchurian taiga that form a trans-Siberian route for plant dispersion.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f5aa2cea-f332-4aee-addd-38cb47da20bf/782 Trans-Baikal Bald Mountain tundra - \u0418 \u041e\u043b\u044c\u0445\u043e\u0432\u0441\u043a\u0438\u0439.jpg',
                      _id: 'f5aa2cea-f332-4aee-addd-38cb47da20bf'
                    }
                  },
                  { _id: '9b3ba4d9-16f8-4e65-a96d-8f42dc8e61b7' },
                  { title: ' Cherskii-Kolyma Mountain Tundra' },
                  { regionId: '771' },
                  {
                    dek:
                      'This ecoregion consists of numerous montane areas above the tree line, including the Verkhoyansk, Cherskiy, Ulakhan-Chistay, Moma, and Kolyma mountain ranges, spread within the Northeast Siberian Taiga ecoregion. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d42e5943-513a-4c16-ad22-3b91041d3333/771 Cherskii-Kolyma mountain tundra - Alglus.jpg',
                      _id: 'd42e5943-513a-4c16-ad22-3b91041d3333'
                    }
                  },
                  { _id: 'fa881d3c-cc2e-48d4-8d72-54de2f391320' },
                  { title: 'West Siberian Taiga' },
                  { regionId: '720' },
                  {
                    dek:
                      'This ecoregion stretches from the Ural Mountains in the west to the Yenisei River in the east. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bfcabe3d-c9de-44c1-a59a-16b13cf1f2c1/720 West Siberian taiga- Tatiana Bulyonkova.jpg',
                      _id: 'bfcabe3d-c9de-44c1-a59a-16b13cf1f2c1'
                    }
                  },
                  { _id: '13707b38-6f5e-43cf-a677-5bb8109d11d3' },
                  { title: 'Trans-Baikal Conifer Forests' },
                  { regionId: '718' },
                  {
                    dek:
                      'This ecoregion is centered on the Yablonoi and Khentii Mountains, straddling the border between Russia and Mongolia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6ddb618e-17fc-40e8-9b4f-e6f22f31816e/718 Trans-Baikal conifer forests - Anderey.sledopit.jpg',
                      _id: '6ddb618e-17fc-40e8-9b4f-e6f22f31816e'
                    }
                  },
                  { _id: '8055e96f-6e17-494c-9f2c-373337f71b5f' },
                  { title: ' Northeast Siberian Taiga' },
                  { regionId: '714' },
                  {
                    dek:
                      'One of the coldest places on earth, this ecoregion has vast areas of pristine larch forest, tundra-bogs and wild coastlines, vital for a wide diversity of animals.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cac96ddc-49e6-409b-8e92-54b7074d5a94/714 Northeast Siberian Taiga - Bartosh Dmytro.jpg',
                      _id: 'cac96ddc-49e6-409b-8e92-54b7074d5a94'
                    }
                  },
                  { _id: '8e92362b-65e4-4668-afce-ed541b72b5e1' },
                  { title: ' East Siberian Taiga' },
                  { regionId: '710' },
                  {
                    dek:
                      'This truly vast area is bordered by the Yenisei River to the west and the Verkhoyansk, Kolyma and Dzhugdzhur Mountain ranges to the east.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3f298bf2-ea3c-4014-9033-2e79fa83ed81/710 East Siberian taiga - \u0418\u0433\u043e\u0440\u044c \u0428\u043f\u0438\u043b\u0435\u043d\u043e\u043a.jpg',
                      _id: '3f298bf2-ea3c-4014-9033-2e79fa83ed81'
                    }
                  }
                ],
                stats: [
                  { number: '768,848', item: 'Total Land Area (1000 ha)' },
                  { number: '6', item: 'Number of Ecoregions' },
                  { number: '88%', item: 'Protection Target' },
                  { number: '1', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Subarctic Eurasia',
            value: 333
          }
        ],
        parentId: 'top',
        _id: 'Subarctic Eurasia',
        value: 666
      },
      {
        name: 'Western Eurasia',
        children: [
          {
            _id: '49dcb5a0-f565-4f15-9c55-946ca55abf83',
            name: 'British Isles',
            children: [
              {
                name: 'Great Britain, Ireland & Faroe Islands (PA9)',
                children: [],
                _id: '241154b8-ae89-4cc6-b2bc-28634f4e294a',
                value: 1000,
                parentId: '49dcb5a0-f565-4f15-9c55-946ca55abf83',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/7acf145b-0515-4895-b906-deba323dd460/651 Celtic broadleaf forests - NPWS_resized.jpg',
                    _id: '7acf145b-0515-4895-b906-deba323dd460'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aff08de6-e6f5-4c53-9936-030cde49edcd/663-View_of_Kinver_from_Rock_Houses_England-CC_.JPG',
                    _id: 'aff08de6-e6f5-4c53-9936-030cde49edcd'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1ca1fc5b-bc86-4970-aaf5-42364f1e84e5/672 North Atlantic moist mixed forests - NPWS_resized.jpg',
                    _id: '1ca1fc5b-bc86-4970-aaf5-42364f1e84e5'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/3b541990-3de0-4eed-adbb-6e327875c258/691 near Aviemore, Scotland-CC-Mike McBey-2018_resized.jpg',
                    _id: '3b541990-3de0-4eed-adbb-6e327875c258'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8112c08d-5a0d-437a-9e44-2026b084dc5a/729 Faroe Islands Boreal Grasslands Eric Welch cc.jpg',
                    _id: '8112c08d-5a0d-437a-9e44-2026b084dc5a'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0aa52c03-8375-475e-8380-06e3bac0fc35/Bioregion-map-PA9.jpg',
                content:
                  '<p>The Great Britain, Ireland &amp; Faroe Islands bioregion is located in the Western Eurasia realm (western Palearctic) and contains five ecoregions \u2013 Celtic Broadleaf Forests (651), English Lowlands Beech Forests (663), North Atlantic Moist Mixed Forests (672), Caledon Conifer Forests (691), Faroe Islands Boreal Grasslands (729) \u2013 totaling nearly 32 million hectares of land area.&nbsp;</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/0aa52c03-8375-475e-8380-06e3bac0fc35/Bioregion-map-PA9.jpg"/><figcaption><span class="caption"><p>The Great Britain, Ireland &amp; Faroe Islands bioregion is part of the Britain subrealm and is made up of five ecoregions: (1) Faroe Islands Boreal Grasslands (2) North Atlantic Moist Mixed Forests (3) Caledon Conifer Forests (4) Celtic Broadleaf Forests (5) English Lowlands Beech Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Western Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Great Britain, Ireland &amp; Faroe Islands ecoregions below.</p>',
                ecoregions: [
                  { _id: '4651dcac-5f87-4a6a-82e0-b6e7c4200665' },
                  { title: ' Faroe Islands Boreal Grasslands' },
                  { regionId: '729' },
                  {
                    dek:
                      'The Faroe Islands are an archipelago of 18 mountainous islands, of which only one is uninhabited, located in the North Atlantic Ocean between Scotland, Norway, and Iceland.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/abdf4d1e-b517-4d43-b779-3bf5c324ab9d/729 Faroe Islands boreal grasslands - Jacqueline Macou.jpg',
                      _id: 'abdf4d1e-b517-4d43-b779-3bf5c324ab9d'
                    }
                  },
                  { _id: '4d2b427a-f55b-45c2-9be4-27f99ac5ad8a' },
                  { title: ' Caledon Conifer Forests' },
                  { regionId: '691' },
                  {
                    dek:
                      'This ecoregion covers upland Scotland, encompassing the Northwest Highlands, Grampian, and Cairngorm Mountains. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/310eabc0-9081-4d8b-b3fb-2ea582e5657a/691 Caledon Conifer Forests Erik Fitxpatrick cc.jpg',
                      _id: '310eabc0-9081-4d8b-b3fb-2ea582e5657a'
                    }
                  },
                  { _id: '16c299f0-c0ab-47d1-b5a0-02ebfd533322' },
                  { title: ' North Atlantic Moist Mixed Forests' },
                  { regionId: '672' },
                  {
                    dek:
                      'This ecoregion is restricted to areas in southwest and west Ireland, the western side of Scotland, including the Outer Hebrides, the far north of Scotland, and the Northern Isles (Orkney and Shetland). '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1ca1fc5b-bc86-4970-aaf5-42364f1e84e5/672 North Atlantic moist mixed forests - NPWS_resized.jpg',
                      _id: '1ca1fc5b-bc86-4970-aaf5-42364f1e84e5'
                    }
                  },
                  { _id: '6c209620-0f8c-4be3-9b5a-9d738a4709e5' },
                  { title: ' English Lowlands Beech Forests' },
                  { regionId: '663' },
                  {
                    dek:
                      'This ecoregion encompasses the lowlands in the southeastern part of Britain.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5ed1d213-3855-43b5-9c93-2fe293f5aec0/663 English Lowlands beech forests - Roman Grac.jpg',
                      _id: '5ed1d213-3855-43b5-9c93-2fe293f5aec0'
                    }
                  },
                  { _id: 'df3775d2-5c7b-4393-95ab-e3e9184d2df4' },
                  { title: ' Celtic Broadleaf Forests' },
                  { regionId: '651' },
                  {
                    dek:
                      'This ecoregion covers the majority of Ireland, the eastern half of Northern Ireland, the eastern edge and south of Scotland and the majority of England, excluding the English Lowlands Beech Forests in the south and east.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/574104ef-bdab-4afa-a5b1-b199241f72a6/651 Celtic broadleaf forests - NPWS_resized.jpg',
                      _id: '574104ef-bdab-4afa-a5b1-b199241f72a6'
                    }
                  }
                ],
                stats: [
                  { number: '31,741', item: 'Total Land Area (1000 ha)' },
                  { number: '5', item: 'Number of Ecoregions' },
                  { number: '29%', item: 'Protection Target' },
                  { number: '9', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Western Eurasia',
            value: 250
          },
          {
            _id: '3b9f5eb3-fbe5-45f5-bf25-4793401fe5c1',
            name: 'Greater European Forests',
            children: [
              {
                name: 'European Interior Mixed Forests (PA12)',
                children: [],
                _id: '91dafdaa-3238-4723-af0b-488a50f56146',
                value: 1000,
                parentId: '3b9f5eb3-fbe5-45f5-bf25-4793401fe5c1',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/86d28ece-9da3-4214-ab04-a6dae3c39c0c/661-Novokhopyorsk_of_Voronezh_region._Khopyorsky_State_Reserve._Khopyor_river-CC-\u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440\u043e\u0432-2011.JPG',
                    _id: '86d28ece-9da3-4214-ab04-a6dae3c39c0c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/39383599-ad81-4812-8e12-f3be9c1fe808/654-Bialowieza_National_Park-Poland-CC-Jacek Karczmarz-2010_resized.jpeg',
                    _id: '39383599-ad81-4812-8e12-f3be9c1fe808'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8862c3b8-d350-4cd2-a159-ac25873fd1e2/661-Belogorye Nature Reserve_-CC-\u0410\u0440\u0431\u0443\u0437\u043e\u0432\u0430 \u041c\u0430\u0440\u0438\u043d\u0430 \u0412\u043b\u0430\u0434\u0438\u043c\u0438\u0440\u043e\u0432\u043d\u0430-2007_resized.jpg',
                    _id: '8862c3b8-d350-4cd2-a159-ac25873fd1e2'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8d524be1-5ee2-4353-95e9-6cf98f6219bd/Bioregion%20map-PA12.jpg',
                content:
                  '<p>The European Interior Mixed Forests bioregion is located in the Western Eurasia realm (western Palearctic) and contains three ecoregions \u2013 Central European Mixed Forests (654), East European Forest Steppe (661), Western European Broadleaf Forests (686) \u2013 totaling approximately 195.5 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8d524be1-5ee2-4353-95e9-6cf98f6219bd/Bioregion%20map-PA12.jpg"/><figcaption><span class="caption"><p>The European Interior Mixed Forests bioregion is part of the Greater European Forests subrealm and is made up of three ecoregions: (1) Western European Broadleaf Forests (2) Central European Mixed Forests (3) East European Forest Steppe.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Western Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the European Interior Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '87d4ca23-f93c-4c71-8d29-01c175c8d9ef' },
                  { title: ' Western European Broadleaf Forests' },
                  { regionId: '686' },
                  {
                    dek:
                      'This ecoregion covers a large part of Western Europe, including the upland areas of massif central, central German uplands, Jura mountains, Bavarian plateau, and Bohemium massif. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/174ba189-2402-41a1-8fe0-9ae30e0bf0d5/686 Western European Broadleaf Forests SusiMarx cc.jpg',
                      _id: '174ba189-2402-41a1-8fe0-9ae30e0bf0d5'
                    }
                  },
                  { _id: 'b7637be6-d7d7-4133-a201-ecea44c4b588' },
                  { title: ' East European Forest Steppe' },
                  { regionId: '661' },
                  {
                    dek:
                      'The majority of this ecoregion lies within the Russian Federation, extending into Ukraine, Moldova, the Carpathian foothills in Romania, and finally the Northeastern corner of Bulgaria.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/84989fdd-7363-45c3-913a-3a83b7b4aef2/661 East European forest steppe - sashok1975 \u0410\u043b\u0435\u043a\u0441\u0430\u043d\u0434\u0440.jpg',
                      _id: '84989fdd-7363-45c3-913a-3a83b7b4aef2'
                    }
                  },
                  { _id: 'bc0763a0-ba59-44d6-83a7-4519501423d8' },
                  { title: ' Central European Mixed Forests' },
                  { regionId: '654' },
                  {
                    dek:
                      'Traversing the lowland plains of Northern Europe, this ecoregion spans large areas of Poland, Belarus, Lithuania, and Ukraine; small portions extend into Germany, Romania, Moldova, Austria, and the Russian Federation.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4551fe1a-88b7-4b31-a33a-21564c3b6146/654 Central European mixed forests - Robert Pastryk.jpg',
                      _id: '4551fe1a-88b7-4b31-a33a-21564c3b6146'
                    }
                  }
                ],
                stats: [
                  { number: '195,521', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '32%', item: 'Protection Target' },
                  { number: '5', item: 'Protection Level' }
                ]
              },
              {
                name: 'Baltic Sea & Sarmatic Mixed Forests (PA11)',
                children: [],
                _id: '47fa8936-600c-46bc-9f6e-c929db57e1eb',
                value: 1000,
                parentId: '3b9f5eb3-fbe5-45f5-bf25-4793401fe5c1',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/90650b30-b325-4048-839a-eb59d831512b/679 Sarmatic Mixed Forests cc.jpg',
                    _id: '90650b30-b325-4048-839a-eb59d831512b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/07c987c7-80c4-4a55-9364-cb89d52176db/679 Sarmatic Mixed Forests cc2.jpeg',
                    _id: '07c987c7-80c4-4a55-9364-cb89d52176db'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8e412f9d-ecbf-4610-8130-3e118ac8b55e/679-Central Park of Helzinki-Finland-CC-2005.jpg',
                    _id: '8e412f9d-ecbf-4610-8130-3e118ac8b55e'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aeed64fd-d267-427a-b1a7-fa9f2fed61f1/Bioregion%20map-PA11.jpg',
                content:
                  '<p>The Baltic Sea &amp; Sarmatic Mixed Forests bioregion is located in the Western Eurasia realm (western Palearctic) and contains one single ecoregion \u2013 Sarmatic Mixed Forests (679) \u2013 totaling nearly 85 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aeed64fd-d267-427a-b1a7-fa9f2fed61f1/Bioregion%20map-PA11.jpg"/><figcaption><span class="caption"><p>The Baltic Sea &amp; Sarmatic Mixed Forests bioregion is part of the Greater European Forests subrealm and is made up of one ecoregion: (1) Sarmatic Mixed Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Western Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Baltic Sea &amp; Sarmatic Mixed Forests ecoregion below.<br>\n</p>',
                ecoregions: [
                  { _id: '15e02d79-de52-4606-b6e2-b7146ecbae12' },
                  { title: ' Sarmatic Mixed Forests' },
                  { regionId: '679' },
                  {
                    dek:
                      'These mixed forests cover the entirety of Latvia and Estonia, reaching into Belarus, Lithuania, Sweden, southwesternmost Finland, southernmost Norway, and the Russian Federation.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/447c9139-ae75-4de2-bd80-f22d89313205/679 Sarmatic mixed forests - Margus Opp.jpg',
                      _id: '447c9139-ae75-4de2-bd80-f22d89313205'
                    }
                  }
                ],
                stats: [
                  { number: '84,807', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '46%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'West European Coastal Mixed Forests (PA10)',
                children: [],
                _id: 'c636d937-4b91-4d75-bc80-0e6b9320e5e9',
                value: 1000,
                parentId: '3b9f5eb3-fbe5-45f5-bf25-4793401fe5c1',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e05717c3-7307-4e43-800a-ad08c2e128aa/647 Baltic Mixed Forests Moahim cc.jpg',
                    _id: 'e05717c3-7307-4e43-800a-ad08c2e128aa'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2fcaedfa-e087-45cc-839c-447c0a91704d/647 Baltic Mixed Forests Rhinomind cc2.jpg',
                    _id: '2fcaedfa-e087-45cc-839c-447c0a91704d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/750bcaa2-e2a6-4127-83c2-393e3e5791b1/648 Cantabrian Mixed Forests Lourdes Cardenal cc.jpg',
                    _id: '750bcaa2-e2a6-4127-83c2-393e3e5791b1'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/40e71677-3e25-4ecd-9a1b-3980ecc4dc2c/Bioregion%20map-PA10.jpg',
                content:
                  '<p>The West European Coastal Mixed Forests bioregion is located in the Western Eurasia realm (western Palearctic) and contains four ecoregions \u2013 Baltic Mixed Forests (647), Cantabrian Mixed Forests (648), European Atlantic Mixed Forests (664), Pyrenees Conifer and Mixed Forests (676) \u2013 totaling more than 62 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/40e71677-3e25-4ecd-9a1b-3980ecc4dc2c/Bioregion%20map-PA10.jpg"/><figcaption><span class="caption"><p>The West European Coastal Mixed Forests bioregion is part of the Greater European Forests subrealm and is made up of four ecoregions: (1) Cantabrian Mixed Forests (2) Pyrenees Conifer and Mixed Forests (3) European Atlantic Mixed Forests (4) Baltic Mixed Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Western Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the West European Coastal Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '3c67353c-a676-4121-9db2-c9d5665ce0b2' },
                  { title: ' Pyrenees Conifer and Mixed Forests' },
                  { regionId: '676' },
                  {
                    dek:
                      'At the junction of Mediterranean and Central Europe lies a landscape sparsely covered by conifer and mixed forests, stretching up the slopes of the Pyrenees mountains.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/85c0d1d1-5af4-4543-8e1c-54dd4f62f255/676 Pyrenees conifer and mixed forests - David Mark.jpg',
                      _id: '85c0d1d1-5af4-4543-8e1c-54dd4f62f255'
                    }
                  },
                  { _id: 'f9b583d5-0c6f-43ab-86cd-b693387167a6' },
                  { title: ' European Atlantic Mixed Forests' },
                  { regionId: '664' },
                  {
                    dek:
                      'This ecoregion is located at the western coast of the Eurasian continent, extending from the south of France up to the northern most tip of Denmark.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/641a2829-fe31-481e-9261-0c0199c53746/664 European Atlantic mixed forests - David Mark.jpg',
                      _id: '641a2829-fe31-481e-9261-0c0199c53746'
                    }
                  },
                  { _id: '83c5c24c-11c4-42cb-a726-f2f4c34dc3c9' },
                  { title: ' Cantabrian Mixed Forests' },
                  { regionId: '648' },
                  {
                    dek:
                      'This ecoregion encompasses the Atlantic coast from the northern half of Portugal, across northern Spain to La Rochelle in France.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/17e19bf2-6672-4eb6-9fa1-2f11b7aa9e36/648 Cantabrian mixed forest - Ant\u00f3nio Cascalheira.jpg',
                      _id: '17e19bf2-6672-4eb6-9fa1-2f11b7aa9e36'
                    }
                  },
                  { _id: 'c538a934-2dbb-4eff-87ec-ca82aa798ef3' },
                  { title: ' Baltic Mixed Forests' },
                  { regionId: '647' },
                  {
                    dek:
                      'The Baltic Mixed Forests stretch eastwards along the Baltic coastline from Denmark to northern Germany and Poland, and include the southernmost part of Sweden.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dd2cd44b-e387-4658-86ac-a7f903f08edd/647 Baltic mixed forests - Ontheway Advice.jpg',
                      _id: 'dd2cd44b-e387-4658-86ac-a7f903f08edd'
                    }
                  }
                ],
                stats: [
                  { number: '62,272', item: 'Total Land Area (1000 ha)' },
                  { number: '4', item: 'Number of Ecoregions' },
                  { number: '35%', item: 'Protection Target' },
                  { number: '7', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Western Eurasia',
            value: 750
          },
          {
            _id: '64dd40ea-1345-4736-b727-6e9f953b9a3a',
            name: 'European Mountain Forests',
            children: [
              {
                name: 'Dinaric Mountains & Balkan Mixed Forests (PA15)',
                children: [],
                _id: '0feb05d7-b44e-4d39-9481-43c4dd9d37b0',
                value: 1000,
                parentId: '64dd40ea-1345-4736-b727-6e9f953b9a3a',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fa380716-f7b8-4c7c-be00-dd4f5cb41f81/660-Valbona Pass-Albania-CC-2006.jpg',
                    _id: 'fa380716-f7b8-4c7c-be00-dd4f5cb41f81'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/03730768-ac27-49a9-8a66-44ad4b80d6f8/678-Pirin Mountain-Bulgaria-CC-2008.jpg',
                    _id: '03730768-ac27-49a9-8a66-44ad4b80d6f8'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/792f8da3-1c0c-4e25-8b67-6cc093f8a139/678-Trevisto lake-CC-2009.jpg',
                    _id: '792f8da3-1c0c-4e25-8b67-6cc093f8a139'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2a420fb7-aa97-4219-adc1-7e17ce3b8bef/Bioregion%20map-PA15.jpg',
                content:
                  '<p>The Dinaric Mountains &amp; Balkan Mixed Forests bioregion is located in the Western Eurasia realm (western Palearctic) and contains three ecoregions \u2013 Balkan Mixed Forests (646), Dinaric Mountains Mixed Forests (660), Rodope Montane Mixed Forests (678) \u2013 totaling approximately 31.5 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2a420fb7-aa97-4219-adc1-7e17ce3b8bef/Bioregion%20map-PA15.jpg"/><figcaption><span class="caption"><p>The Dinaric Mountains &amp; Balkan Mixed Forests bioregion is part of the European Mountain Forests subrealm and is made up of three ecoregions: (1) Dinaric Mountains Mixed Forests (2) Balkan Mixed Forests (3) Rodope Montane Mixed Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Western Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Dinaric Mountains &amp; Balkan Mixed Forests ecoregions below.<br>\n</p>',
                ecoregions: [
                  { _id: '6f60d056-6457-45dd-810a-63f908a7598e' },
                  { title: ' Rodope Montane Mixed Forests' },
                  { regionId: '678' },
                  {
                    dek:
                      'The Rodope Montane Mixed Forests ecoregion encompasses the Balkan massif and Rhodope massif.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dd3526ce-de3e-4d62-aebc-69dbe3445f46/678 Rodope montane mixed forests - Mechit Musala.jpg',
                      _id: 'dd3526ce-de3e-4d62-aebc-69dbe3445f46'
                    }
                  },
                  { _id: 'fbb6ff86-47fd-4582-a9c9-281ebcf10ae4' },
                  { title: ' Dinaric Mountains Mixed Forests' },
                  { regionId: '660' },
                  {
                    dek:
                      'Spanning across the north-eastern coastline of Adriatic Sea in Eastern Europe, this ecoregion represents one of the largest and most continuous tracts of forested habitats for large carnivores in the continent.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ab84d733-20ef-4882-974a-8c8ef5a02225/660 Dinaric Mountains mixed forests - Malcolm Carlaw.jpg',
                      _id: 'ab84d733-20ef-4882-974a-8c8ef5a02225'
                    }
                  },
                  { _id: 'c39390f1-a12c-4ae5-b235-84d2d143deac' },
                  { title: ' Balkan Mixed Forests' },
                  { regionId: '646' },
                  {
                    dek:
                      'This ecoregion covers much of Bulgaria, Kosovo, North Macedonia, southern Serbia and Romania, and the northernmost parts of Greece and Turkey, stretching from the Black Sea towards the Adriatic.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/709b57e9-7158-4a8b-9f52-ff1506b37a0c/646 Balkan mixed forests - Konstantin Korlev alternative.jpg',
                      _id: '709b57e9-7158-4a8b-9f52-ff1506b37a0c'
                    }
                  }
                ],
                stats: [
                  { number: '31,489', item: 'Total Land Area (1000 ha)' },
                  { number: '3', item: 'Number of Ecoregions' },
                  { number: '41%', item: 'Protection Target' },
                  { number: '5', item: 'Protection Level' }
                ]
              },
              {
                name: 'Alps & Po Basin Mixed Forests (PA13)',
                children: [],
                _id: '196ace7f-199e-453b-b4f1-dc9d02bdd633',
                value: 1000,
                parentId: '64dd40ea-1345-4736-b727-6e9f953b9a3a',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/bfb6c31f-8b49-46dd-aa8a-a266fc1fe45d/689 Alp conifer and mixed forest - Kordula Vahle.jpg',
                    _id: 'bfb6c31f-8b49-46dd-aa8a-a266fc1fe45d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a798f217-bf57-4a07-9b80-ac78e5298007/675-Po_River at San_Benedetto_(Mantova)-CC-2009.jpg',
                    _id: 'a798f217-bf57-4a07-9b80-ac78e5298007'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6524fdd7-324b-4322-99b4-e7ba7bb4c486/689 Alps Conifer and Mixed Ju2kiwi cc.jpg',
                    _id: '6524fdd7-324b-4322-99b4-e7ba7bb4c486'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e2076faa-6e53-49ff-928b-c990158c4b2a/689 Alps Conifer and Mixed Nuno Alves cc.jpg',
                    _id: 'e2076faa-6e53-49ff-928b-c990158c4b2a'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9689cc1b-e7ac-41bb-83f7-808dbe9ca345/Bioregion%20map-PA13.jpg',
                content:
                  '<p>The Alps &amp; Po Basin Mixed Forests bioregion is located in the Western Eurasia realm (western Palearctic) and contains two ecoregions \u2013 Po Basin Mixed Forests (675), Alps Conifer and Mixed Forests (689) \u2013 totaling more than 19 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9689cc1b-e7ac-41bb-83f7-808dbe9ca345/Bioregion%20map-PA13.jpg"/><figcaption><span class="caption"><p>The Alps &amp; Po Basin Mixed Forests bioregion is part of the European Mountain Forests subrealm and is made up of two ecoregions: (1) Alps Conifer and Mixed Forests (2) Po Basin Mixed Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Western Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Alps &amp; Po Basin Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '49e58a4b-9427-49d8-86e7-7c8a5d39bf9e' },
                  { title: ' Alps Conifer and Mixed Forests' },
                  { regionId: '689' },
                  {
                    dek:
                      'Located in Central Europe, the Alps stretch across seven countries: France, Italy, Germany, Austria, Slovenia, Switzerland, and Liechtenstein. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5c3ded83-cef0-4097-8c1c-845ec29f11db/689 Alps Conifer and Mixed Forests Rainerax cc.jpg',
                      _id: '5c3ded83-cef0-4097-8c1c-845ec29f11db'
                    }
                  },
                  { _id: 'ecefffc2-cc98-4a60-994f-7206a490cf6f' },
                  { title: ' Po Basin Mixed Forests' },
                  { regionId: '675' },
                  {
                    dek:
                      'Found scattered throughout one of the most industrialized regions in Europe are the last remaining pockets of riparian woodlands and wetlands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4e5f03ea-0988-461d-8500-07c22194a153/675 Po Basin mixed forests - Enrico Castello.jpg',
                      _id: '4e5f03ea-0988-461d-8500-07c22194a153'
                    }
                  }
                ],
                stats: [
                  { number: '19,228', item: null },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '48%', item: 'Protection Target' },
                  { number: '5', item: 'Protection Level' }
                ]
              },
              {
                name: 'Carpathian Mountain & Plains Mixed Forests (PA14)',
                children: [],
                _id: '030cb112-a795-4fee-8431-5a05001597eb',
                value: 1000,
                parentId: '64dd40ea-1345-4736-b727-6e9f953b9a3a',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c226b4cb-09ce-46e7-875d-f7e88d3a7933/692-Nesamovyte_lake-Eastern Carpathians-CC_Mykola Swarnyk-2013.jpg',
                    _id: 'c226b4cb-09ce-46e7-875d-f7e88d3a7933'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f86e4df6-4886-4a63-aa7c-de22b9a85a3c/674 Pannonian Mixed Forests Tom\u00e1\u0161 Merta cc.jpg',
                    _id: 'f86e4df6-4886-4a63-aa7c-de22b9a85a3c'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/91ed1fdf-b30f-4bdd-a851-ab1432327815/692-Morskie_oko_-Western Carpathians-CC-2008.jpg',
                    _id: '91ed1fdf-b30f-4bdd-a851-ab1432327815'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/89ab6b2e-2119-416d-a777-ad07ce752830/Bioregion%20map-PA14.jpg',
                content:
                  '<p>The Carpathian Mountain &amp; Plains Mixed Forests bioregion is located in the Western Eurasia realm (western Palearctic) and contains two ecoregions \u2013 Pannonian Mixed Forests (674), Carpathian Montane Forests (692) \u2013 totaling more than 43 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/89ab6b2e-2119-416d-a777-ad07ce752830/Bioregion%20map-PA14.jpg"/><figcaption><span class="caption"><p>The Carpathian Mountain &amp; Plains Mixed Forests bioregion is part of the European Mountain Forests subrealm and is made up of two ecoregions: (1) Pannonian Mixed Forests (2) Carpathian Montane Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Western Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Carpathian Mountain &amp; Plains Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '727cc03e-9e25-44a1-b097-7d2d48d3c9e8' },
                  { title: ' Carpathian Montane Forests' },
                  { regionId: '692' },
                  {
                    dek:
                      'The Carpathian Mountain chain forms an arc across Central and Eastern Europe. 54% of the range lies within Romania, with the rest traversing the Czech Republic, Poland, Slovakia, and Ukraine.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c7790ecd-a40f-4120-9114-34cd3ada6ab4/692 Carpathian montane forests - Jacqueline Macou.jpg',
                      _id: 'c7790ecd-a40f-4120-9114-34cd3ada6ab4'
                    }
                  },
                  { _id: 'f41c7047-a53f-494a-950f-908b16c500a6' },
                  { title: 'Pannonian Mixed Forests' },
                  { regionId: '674' },
                  {
                    dek:
                      'This ecoregion covers the entirety of Hungary, and is only in part of other Central European countries.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f86e4df6-4886-4a63-aa7c-de22b9a85a3c/674 Pannonian Mixed Forests Toma\u0301s\u030c Merta cc.jpg',
                      _id: 'f86e4df6-4886-4a63-aa7c-de22b9a85a3c'
                    }
                  }
                ],
                stats: [
                  { number: '43,284', item: 'Total Land Area (1000 ha)' },
                  { number: '2', item: 'Number of Ecoregions' },
                  { number: '45%', item: 'Protection Target' },
                  { number: '6', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Western Eurasia',
            value: 750
          },
          {
            _id: '9bdcdf93-ca05-46fb-83ee-a7da09aaa900',
            name: 'Black Sea Forests & Steppe',
            children: [
              {
                name: 'Black Sea, Caucasus-Anatolian Mixed Forests & Steppe (PA17)',
                children: [],
                _id: 'fd9b52a2-40a1-4aee-bec3-9f4d79154001',
                value: 1000,
                parentId: '9bdcdf93-ca05-46fb-83ee-a7da09aaa900',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/93519e14-d636-4276-a479-66a573ad4153/652 Central Anatolian Steppe and Woodlands Semih Ekinci cc.jpg',
                    _id: '93519e14-d636-4276-a479-66a573ad4153'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/db79aaa1-b444-40a7-8772-52e06451ffb9/650-Zaqatala State Reserves-CC-Jok Erkin-2013_resized.jpg',
                    _id: 'db79aaa1-b444-40a7-8772-52e06451ffb9'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fbd3218b-992b-44a0-a739-09ad28d67822/650-Lake Baduksko-Russia-CC-Nina Zhavoronkova-2016_resized.jpg',
                    _id: 'fbd3218b-992b-44a0-a739-09ad28d67822'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/87658294-481f-4a3d-ae2a-2919a8cdd10f/Bioregion%20map-PA17.jpg',
                content:
                  '<p>The Black Sea, Caucasus-Anatolian Mixed Forests &amp; Steppe bioregion is located in the Western Eurasia realm (western Palearctic) and contains seven ecoregions \u2013 Caucasus Mixed Forests (650), Central Anatolian Steppe and Woodlands (652), Crimean Submediterranean Forest Complex (658), Eastern Anatolian Deciduous Forests (662), Euxine-Colchic Broadleaf Forests (665), Northern Anatolian Conifer and Deciduous Forests (703), Central Anatolian Steppe (725) \u2013 totaling approximately 58.5 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/87658294-481f-4a3d-ae2a-2919a8cdd10f/Bioregion%20map-PA17.jpg"/><figcaption><span class="caption"><p>The Black Sea, Caucasus-Anatolian Mixed Forests &amp; Steppe bioregion is part of the Black Sea Forests &amp; Steppe subrealm and is made up of seven ecoregions: (1) Central Anatolian Steppe (2) Central Anatolian Steppe and Woodlands (3) Northern Anatolian Conifer and Deciduous Forests (4) Euxine-Colchic Broadleaf Forests (5) Eastern Anatolian Deciduous Forests (6) Caucasus Mixed Forests (7) Crimean Submediterranean Forest Complex.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Western Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Black Sea, Caucasus-Anatolian Mixed Forests &amp; Steppe ecoregions below.</p>',
                ecoregions: [
                  { _id: '07700da1-d27a-4344-8ce3-9c25da117365' },
                  { title: ' Central Anatolian Steppe' },
                  { regionId: '725' },
                  {
                    dek:
                      'This ecoregion is comprised of five distinct areas in the Central Anatolian region of Turkey. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/cca96550-6128-446e-906f-c458d19535f8/725 Central Anatolian steppe - Zeynel Cebeci.JPG',
                      _id: 'cca96550-6128-446e-906f-c458d19535f8'
                    }
                  },
                  { _id: '8213d852-a1fa-4b56-b3db-49b6f8183867' },
                  { title: ' Northern Anatolian Conifer and Deciduous Forests' },
                  { regionId: '703' },
                  {
                    dek:
                      'These forests sprawl across the southern slopes of the Pontic Mountains, a vast range that sweeps across the Northern Anatolia region of Turkey.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/26b0a55c-fb4c-4843-b500-4f8440bc7997/703 Northern Anatolian conifer and deciduous forests - yusuf kazanc\u0131.jpg',
                      _id: '26b0a55c-fb4c-4843-b500-4f8440bc7997'
                    }
                  },
                  { _id: '24924be5-3538-4d4f-aa1f-516d05ccb085' },
                  { title: ' Euxine-Colchic Broadleaf Forests' },
                  { regionId: '665' },
                  {
                    dek:
                      'These lush forests span the southern shoreline of the Black Sea, from the Southeasternmost corner of Bulgaria, across the Northern coastline of Turkey, and into lowland Georgia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4cc8846c-e592-457d-ba82-08c338140957/665 Euxine-Colchic broadleaf forests - R\u00dc\u015eT\u00dc BOZKU\u015e.jpg',
                      _id: '4cc8846c-e592-457d-ba82-08c338140957'
                    }
                  },
                  { _id: '62c17fb3-3fa1-47b4-8bea-4a3f6641956d' },
                  { title: ' Eastern Anatolian Deciduous Forests' },
                  { regionId: '662' },
                  {
                    dek:
                      'This ecoregion lies within Turkey\u2019s Anatolian plateau, ranging over the Western part of the East Anatolian Mountains. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/999f01be-fa22-4982-91f8-7891669f0503/662 Eastern Anatolian deciduous forests - Arser.jpg',
                      _id: '999f01be-fa22-4982-91f8-7891669f0503'
                    }
                  },
                  { _id: '9dc6136e-6176-4dbe-af75-49e4e77e07fe' },
                  { title: ' Crimean Submediterranean Forest Complex' },
                  { regionId: '658' },
                  {
                    dek:
                      'This ecoregion is formed by two coastal enclaves on the Northern coast of the Black Sea. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/994cae4a-d8b6-4434-a92f-92c93b872266/658 Crimean Submediterranean forest complex - dimitriibrovko.jpg',
                      _id: '994cae4a-d8b6-4434-a92f-92c93b872266'
                    }
                  },
                  { _id: '5639d967-4a75-4873-b607-663198f6b1d1' },
                  { title: ' Central Anatolian Steppe and Woodlands' },
                  { regionId: '652' },
                  {
                    dek:
                      'This ecoregion occupies Central Turkey, bounded by the Pontic Mountains in the North and the Taurus Mountains in the South.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/813cfd28-36a8-485a-ba7f-d2134a02bab3/652 Central Anatolian steppe and woodlands - Haydar Tamer Ozturk.jpg',
                      _id: '813cfd28-36a8-485a-ba7f-d2134a02bab3'
                    }
                  },
                  { _id: 'dd0cabf5-f51e-49c0-aa47-0eee68f59512' },
                  { title: 'Caucasus Mixed Forests' },
                  { regionId: '650' },
                  {
                    dek:
                      'This ecoregion follows the Greater and Lesser Caucasus Mountain ranges, spanning five countries: Georgia, Russia, Azerbaijan, Turkey, and Armenia. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/588e4808-cea4-420e-9d50-6527acc48c53/650 Caucasus mixed forest - Elena Kaliberda.jpg',
                      _id: '588e4808-cea4-420e-9d50-6527acc48c53'
                    }
                  }
                ],
                stats: [
                  { number: '58,534', item: 'Total Land Area (1000 ha)' },
                  { number: '7', item: 'Number of Ecoregions' },
                  { number: '32%', item: 'Protection Target' },
                  { number: '2', item: 'Protection Level' }
                ]
              },
              {
                name: 'Pontic Steppe Grasslands (PA16)',
                children: [],
                _id: '60de8325-ce74-4d0b-a816-433fd4884837',
                value: 1000,
                parentId: '9bdcdf93-ca05-46fb-83ee-a7da09aaa900',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d18fb7ed-a7ca-4c77-b34d-a3e85d144282/735-Tulipa schrenkii -CC-\u0411\u0435\u0437\u0443\u0433\u043b\u043e\u0432\u0430 \u0415\u043a\u0430\u0442\u0435\u0440\u0438\u043d\u0430-2016_resized.jpg',
                    _id: 'd18fb7ed-a7ca-4c77-b34d-a3e85d144282'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/9f69a231-9737-461f-907d-ba2f8198d449/735-Azov-Syvash National Nature Park, Ukraine-CC-2014.jpg',
                    _id: '9f69a231-9737-461f-907d-ba2f8198d449'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/49fc882f-b569-46ce-8e77-bb53069cc38d/Bioregion%20map-PA16.jpg',
                content:
                  '<p>The Pontic Steppe Grasslands bioregion is located in the Western Eurasia realm (western Palearctic) and contains one single ecoregion \u2013 Pontic Steppe (735) \u2013 totaling approximately 99.5 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/49fc882f-b569-46ce-8e77-bb53069cc38d/Bioregion%20map-PA16.jpg"/><figcaption><span class="caption"><p>The Pontic Steppe Grasslands bioregion is part of the Black Sea Forests &amp; Steppe subrealm and is made up of one ecoregion: (1) Pontic Steppe.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Western Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Pontic Steppe Grasslands ecoregion below.</p>',
                ecoregions: [
                  { _id: '257b5873-dba8-40e7-a618-fe66877a30f0' },
                  { title: ' Pontic Steppe' },
                  { regionId: '735' },
                  {
                    dek:
                      'This ecoregion arises in the northeasternmost corner of Bulgaria, extending across Southeast Romania, Southeast Moldova, Southeast Ukraine, through Russia, and into Northwest Kazakhstan. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/63b4f7a7-1c09-42a3-b0e9-54049e74a3e5/735 Pontic steppe - \u0418\u0440\u0438\u043d\u0430 \u0413\u0438\u044f\u0437\u043e\u0432\u0430.jpg',
                      _id: '63b4f7a7-1c09-42a3-b0e9-54049e74a3e5'
                    }
                  }
                ],
                stats: [
                  { number: '99,629', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '11%', item: 'Protection Target' },
                  { number: '4', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Western Eurasia',
            value: 500
          },
          {
            _id: 'b09e28a3-5ff4-45b4-b056-eb50221037e9',
            name: 'Mediterranean',
            children: [
              {
                name: 'Adriatic Sea & Central Mediterranean Mixed Forests (PA19)',
                children: [],
                _id: '94f95bf6-32f0-458d-a179-385b3b677e63',
                value: 1000,
                parentId: 'b09e28a3-5ff4-45b4-b056-eb50221037e9',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aa55ea53-6c63-4ef5-a938-af2bd702315e/806 Tyrrhenian-Adriatic sclerophyllous and mixed forests - valtercirillo.jpg',
                    _id: 'aa55ea53-6c63-4ef5-a938-af2bd702315e'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/c1e1def6-fbd6-46f8-8016-930a57f0a106/644- Cimone Mountain, northern Apennine-CC-2010.jpg',
                    _id: 'c1e1def6-fbd6-46f8-8016-930a57f0a106'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2f675dba-2759-4aa5-9245-a2f02a23354b/794-Brac_beach-Murvica-Croatia-CC-2006.jpg',
                    _id: '2f675dba-2759-4aa5-9245-a2f02a23354b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/e9ebf720-5743-4223-a78a-34305b312686/802-Madonie_mountain-Sicily-CC-Martin Teetz-2004.jpg',
                    _id: 'e9ebf720-5743-4223-a78a-34305b312686'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6380b70b-c4db-4784-a134-83f3d7c47142/Bioregion-map-PA19.jpg',
                content:
                  '<p>The Adriatic Sea &amp; Central Mediterranean Mixed Forests bioregion is located in the Western Eurasia realm (western Palearctic) and contains six ecoregions \u2013 Apennine Deciduous Montane Forests (644), Corsican Montane Broadleaf and Mixed Forests (788), Illyrian Deciduous Forests (794), Italian Sclerophyllous and Semi-Deciduous Forests (795), South Apennine Mixed Montane Forests (802), Tyrrhenian-Adriatic Sclerophyllous and Mixed Forests (806) \u2013 totaling approximately 26 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/6380b70b-c4db-4784-a134-83f3d7c47142/Bioregion-map-PA19.jpg"/><figcaption><span class="caption"><p>The Adriatic Sea &amp; Central Mediterranean Mixed Forests bioregion is part of the Mediterranean subrealm and is made up of six ecoregions: (1) Corsican Montane Broadleaf and Mixed Forests (2) Tyrrhenian-Adriatic Sclerophyllous and Mixed Forests (3) Italian Sclerophyllous and Semi-Deciduous Forests (4) Apennine Deciduous Montane Forests (5) South Apennine Mixed Montane Forests (6) Illyrian Deciduous Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Western Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Adriatic Sea &amp; Central Mediterranean Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'a665293f-f01e-4aaf-849f-d03dcc2e4dd0' },
                  { title: 'Tyrrhenian-Adriatic Sclerophyllous and Mixed Forests' },
                  { regionId: '806' },
                  {
                    dek:
                      'This ecoregion extends along the coastal lowlands of the southern half of the Italian Peninsula, Sicily, and Corsica.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aa55ea53-6c63-4ef5-a938-af2bd702315e/806 Tyrrhenian-Adriatic sclerophyllous and mixed forests - valtercirillo.jpg',
                      _id: 'aa55ea53-6c63-4ef5-a938-af2bd702315e'
                    }
                  },
                  { _id: '0d24af16-35aa-4661-bf3c-6f66dfc46b52' },
                  { title: 'South Apennine Mixed Montane Forests' },
                  { regionId: '802' },
                  {
                    dek:
                      'This ecoregion is restricted to the high mountain massifs of the Italian regions of Basilicata, Calabria, and the island of Sicily.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2bb27ff2-05a9-450f-825b-dc8ea3af0b12/802 South Apennine mixed montane forests - Valter Cirillo.jpg',
                      _id: '2bb27ff2-05a9-450f-825b-dc8ea3af0b12'
                    }
                  },
                  { _id: '5cace52f-f2ea-4bb3-adb0-0da6694e0157' },
                  { title: 'Italian Sclerophyllous and Semi-Deciduous Forests' },
                  { regionId: '795' },
                  {
                    dek:
                      'The Italian Sclerophyllous and Semi-Deciduous Forests ecoregion covers the Italian peninsular from southeast France, south of the Po Plain to Basilicata in southern Italy.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/1c5bf707-4184-43b1-af1c-19775007ef13/795 Italian sclerophyllous and semi-deciduous forests - Valter Cirillo.jpg',
                      _id: '1c5bf707-4184-43b1-af1c-19775007ef13'
                    }
                  },
                  { _id: '3a2cb668-1471-475a-b879-e617f1bf27b0' },
                  { title: 'Illyrian Deciduous Forests' },
                  { regionId: '794' },
                  {
                    dek:
                      'The ecoregion extends all along the coastal ranges of the Eastern Adriatic coast, from the eastern Alps in northern Italy to the northern Ionian coast between Albania and Greece. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/eb8222ca-7da5-45f7-b5b2-8add7c9d4096/794 Illyrian deciduous forests - photoholiday.jpg',
                      _id: 'eb8222ca-7da5-45f7-b5b2-8add7c9d4096'
                    }
                  },
                  { _id: '257ba2ac-e8ea-40a4-82d0-ba1537e92267' },
                  { title: 'Corsican Montane Broadleaf and Mixed Forests' },
                  { regionId: '788' },
                  {
                    dek:
                      'This ecoregion is restricted to the high and steep mountain massifs of Corsica Island, the fourth largest island in the Mediterranean Sea. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/75b6918a-0a04-4017-b04a-3c614090c7c5/788 Corsican montane broadleaf and mixed forests - Tom Chirossel.jpg',
                      _id: '75b6918a-0a04-4017-b04a-3c614090c7c5'
                    }
                  },
                  { _id: '04e2197f-9a44-43be-a0ed-c3e1516c2a09' },
                  { title: 'Appenine Deciduous Montane Forests' },
                  { regionId: '644' },
                  {
                    dek:
                      'Tucked away among the peaks of Italy\u2019s Apennine mountains, which stretch from the Alps down to Sicily, are some of Europe\u2019s best-preserved forests and montane grasslands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/5c857378-7ce3-4ccd-a1dc-692c7d95ace1/644 Appenine deciduous montane forests - Valter Cirillo.jpg',
                      _id: '5c857378-7ce3-4ccd-a1dc-692c7d95ace1'
                    }
                  }
                ],
                stats: [
                  { number: '26,105', item: 'Total Land Area (1000 ha)' },
                  { number: '6', item: 'Number of Ecoregions' },
                  { number: '27%', item: 'Protection Target' },
                  { number: '9', item: 'Protection Level ' }
                ]
              },
              {
                name: 'Aegean Sea & East Mediterranean Mixed Forests (PA18)',
                children: [],
                _id: '868d66ac-2838-45ec-93f8-866165445ea6',
                value: 1000,
                parentId: 'b09e28a3-5ff4-45b4-b056-eb50221037e9',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/f3d96934-7bc9-44ee-84ca-a1594faba29a/789-Psiloritis-CC-Jerzy Strzelecki-2009.jpg',
                    _id: 'f3d96934-7bc9-44ee-84ca-a1594faba29a'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dd1a336d-4b21-4f92-b742-4ed12cd0724b/785-Troizen_blossom-CC-Robin Iversen Ronnlund-2011.jpg',
                    _id: 'dd1a336d-4b21-4f92-b742-4ed12cd0724b'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/d5d86dce-5c8f-4e4a-b9cb-a5f7a04879a6/789-Mount_Ida_chain_Messara_plain_from_Phaistos_Crete_Greece-CC-2005_resized.jpg',
                    _id: 'd5d86dce-5c8f-4e4a-b9cb-a5f7a04879a6'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/87b87d50-0be2-4b69-b900-de6bdda9afb3/790-Trees of Mount Olympus-CC-.JPG',
                    _id: '87b87d50-0be2-4b69-b900-de6bdda9afb3'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2917d064-ad87-44a5-92aa-c53ccbae595f/791-Turkish Pine-_Aleppo_-_Syria-CC-Taras Kalapun-2007.jpg',
                    _id: '2917d064-ad87-44a5-92aa-c53ccbae595f'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2a082ee7-51e3-4f0b-b4ff-3b27c21e05db/Bioregion-map-PA18.jpg',
                content:
                  '<p>The Aegean Sea &amp; East Mediterranean Mixed Forests bioregion is located in the Western Eurasia realm (western Palearctic) and contains seven ecoregions \u2013 Aegean and Western Turkey Sclerophyllous and Mixed Forests (785), Anatolian Conifer and Deciduous Mixed Forests (786), Crete Mediterranean Forests (789), Cyprus Mediterranean Forests (790), Eastern Mediterranean Conifer-Broadleaf Forests (791), Pindus Mountains Mixed Forests (801), Southern Anatolian Montane Conifer and Deciduous Forests (804) \u2013 totaling approximately 49.5 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/2a082ee7-51e3-4f0b-b4ff-3b27c21e05db/Bioregion-map-PA18.jpg"/><figcaption><span class="caption"><p>The Aegean Sea &amp; East Mediterranean Mixed Forests bioregion is part of the Mediterranean subrealm and is made up of seven ecoregions: (1) Pindus Mountains Mixed Forests (2) Aegean and Western Turkey Sclerophyllous and Mixed Forests (3) Crete Mediterranean Forests (4) Anatolian Conifer and Deciduous Mixed Forests (5) Southern Anatolian Montane Conifer and Deciduous Forests (6) Cyprus Mediterranean Forests (7) Eastern Mediterranean Conifer-Broadleaf Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Western Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Aegean Sea &amp; East Mediterranean Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: 'a585a414-3961-4cca-a9fe-321a4c3c71c3' },
                  { title: 'Southern Anatolian Montane Conifer and Deciduous Forests' },
                  { regionId: '804' },
                  {
                    dek:
                      'The majority of this landscape stretches across the Southern Anatolia region of Turkey, reaching into the highlands of Lebanon, Syria, and a very small area in Israel.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/fbca4b63-198f-4a8c-b783-fc20a020e933/804 Southern Anatolian Montane Conifer and Deciduous Forests.jpg',
                      _id: 'fbca4b63-198f-4a8c-b783-fc20a020e933'
                    }
                  },
                  { _id: '916c1cec-4584-4da5-a232-023c0ec52d8f' },
                  { title: 'Pindus Mountains Mixed Forests' },
                  { regionId: '801' },
                  {
                    dek:
                      'The ecoregion extends in a north-south direction from the mountain ranges of the Peloponese to the central Greek Parnasos, Smolikas, and Olympus, to northern Albania and western North Macedonia. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8aeba949-e17e-4c67-9db0-ac212af7e397/801 Pindus Mountains mixed forests - Michel Mondadori.jpg',
                      _id: '8aeba949-e17e-4c67-9db0-ac212af7e397'
                    }
                  },
                  { _id: 'b7aa595a-3775-419c-b111-73e0f2bb8712' },
                  { title: ' Eastern Mediterranean Conifer-Broadleaf Forests' },
                  { regionId: '791' },
                  {
                    dek:
                      'This ecoregion spans the Mediterranean coastline of the Middle East, running through Turkey, Lebanon, Israel, Palestine, Jordan, and the Syrian Arab Republic.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/68136802-3ae5-41cd-b03e-c9abb1691b01/791 Eastern Mediterranean conifer-broadleaf forests - Tuna Olger.jpg',
                      _id: '68136802-3ae5-41cd-b03e-c9abb1691b01'
                    }
                  },
                  { _id: '78940d0c-2477-4552-9fa3-6a334cab99de' },
                  { title: ' Cyprus Mediterranean Forests' },
                  { regionId: '790' },
                  {
                    dek:
                      'This ecoregion covers the entire area of the Republic of Cyprus, the third largest island in the Mediterranean. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/a23cca02-b6db-4392-88ae-b73b4d9af7a0/790 Cyprus Mediterranean forests - Dimitris Vetsikas.jpg',
                      _id: 'a23cca02-b6db-4392-88ae-b73b4d9af7a0'
                    }
                  },
                  { _id: 'f368a467-5013-4833-b224-a6bd77f770d8' },
                  { title: 'Crete Mediterranean Forests' },
                  { regionId: '789' },
                  {
                    dek:
                      'Crete is the fifth largest island of the Mediterranean Basin and the ecoregion which encapsulates the whole island is restricted to high mountain ranges , hills, and low plains of the island.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/4a44385c-188e-4a12-bc1e-296bdbfae0c1/789 Crete Mediterranean forests - Jimzoun Natura 2000.jpg',
                      _id: '4a44385c-188e-4a12-bc1e-296bdbfae0c1'
                    }
                  },
                  { _id: '7cb8b66c-e10f-435c-953a-183e6893dc30' },
                  { title: ' Anatolian Conifer and Deciduous Mixed Forests' },
                  { regionId: '786' },
                  {
                    dek:
                      'This transitional ecoregion lies within Western Turkey, hosting a confluence of Mediterranean, Euro-Siberian, and Irano-Turanian flora. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/68e6ba77-e52a-4e43-a2b4-7a61c9513aec/786 Anatolian conifer and deciduous mixed forests - R\u00dc\u015eT\u00dc BOZKU\u015e.jpg',
                      _id: '68e6ba77-e52a-4e43-a2b4-7a61c9513aec'
                    }
                  },
                  { _id: '351718ff-7986-4ee9-9554-fa58901fdbe4' },
                  { title: ' Aegean and Western Turkey Sclerophyllous and Mixed Forests' },
                  { regionId: '785' },
                  {
                    dek:
                      'This ecoregion stretches mostly across Greece and Western Turkey, reaching into Southeast Macedonia, and Bulgaria; it encompasses many of the Aegean and Cyclades islands. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/796c9759-af3b-43a7-94d8-da1171a6a48c/785 Aegean and Western Turkey sclerophyllous and mixed forests - Dimitris Vetsikas.jpg',
                      _id: '796c9759-af3b-43a7-94d8-da1171a6a48c'
                    }
                  }
                ],
                stats: [
                  { number: '49,688', item: 'Total Land Area (1000 ha)' },
                  { number: '7', item: 'Number of Ecoregions' },
                  { number: '30%', item: 'Protection Target' },
                  { number: '3', item: 'Protection Level' }
                ]
              },
              {
                name: 'Azores Forest Islands (PA21)',
                children: [],
                _id: 'b89144f1-fff9-47f1-a206-10f6eeed89ae',
                value: 1000,
                parentId: 'b09e28a3-5ff4-45b4-b056-eb50221037e9',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/573872f3-22db-4f26-ade9-829816d650d6/645-Azores_flores_ribeira_grande-CC-2017_resized.jpg',
                    _id: '573872f3-22db-4f26-ade9-829816d650d6'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/38829ef3-bffe-413d-9be3-10e207dc9049/Bioregion-map-PA21.jpg',
                content:
                  '<p>The Azores Forest Islands bioregion is located in the Western Eurasia realm (western Palearctic) and contains one single ecoregion \u2013 Azores Temperate Mixed Forests (645) \u2013 totaling approximately 262 thousand hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/38829ef3-bffe-413d-9be3-10e207dc9049/Bioregion-map-PA21.jpg"/><figcaption><span class="caption"><p>The Azores Forest Islands bioregion is part of the Mediterranean subrealm and is made up of one ecoregion: (1) Azores Temperate Mixed Forests.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Western Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about the Azores Forest Islands ecoregion below.</p>',
                ecoregions: [
                  { _id: '8e43c2e9-593d-49cd-a424-e1b171ac69e6' },
                  { title: 'Azores Temperate Mixed Forests' },
                  { regionId: '645' },
                  {
                    dek:
                      'Situated more than 1,350 km west of the Portuguese coast, the Azores archipelago is a collection of several small volcanic islands'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ef1f5a50-7292-45ee-a485-67d66dc6c265/645 Azores temperate mixed forests - Sandro Porto.jpg',
                      _id: 'ef1f5a50-7292-45ee-a485-67d66dc6c265'
                    }
                  }
                ],
                stats: [
                  { number: '262', item: 'Total Land Area (1000 ha)' },
                  { number: '1', item: 'Number of Ecoregions' },
                  { number: '24%', item: 'Protection Target' },
                  { number: '10', item: 'Protection Level' }
                ]
              },
              {
                name: 'Balearic Sea & West Mediterranean Mixed Forests (PA20)',
                children: [],
                _id: '8e583f57-f965-4e42-ade1-51b89cf08f22',
                value: 1000,
                parentId: 'b09e28a3-5ff4-45b4-b056-eb50221037e9',
                images: [
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/faf28758-b8d1-4e56-91af-92deb8e43291/803 Southeast Iberian shrubs and woodlands - ziegler175.jpg',
                    _id: 'faf28758-b8d1-4e56-91af-92deb8e43291'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/11c89992-57e7-414a-9775-4dff0d278c3d/805 Southwest Iberian Mediterranean Sclerophyllous and Mixed Forests Husond cc.jpg',
                    _id: '11c89992-57e7-414a-9775-4dff0d278c3d'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/b12290c4-c2ca-4cec-bc83-0446ad3d8923/792 Iberian Conifer Forests Miguel303xm  cc.jpeg',
                    _id: 'b12290c4-c2ca-4cec-bc83-0446ad3d8923'
                  },
                  {
                    path:
                      '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/dd1a336d-4b21-4f92-b742-4ed12cd0724b/785-Troizen_blossom-CC-Robin Iversen Ronnlund-2011.jpg',
                    _id: 'dd1a336d-4b21-4f92-b742-4ed12cd0724b'
                  }
                ],
                map:
                  'https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/65f165c4-a25f-4815-80b9-63ea70b3b3f2/Bioregion%20map-PA20.jpg',
                content:
                  '<p>The Balearic Sea &amp; West Mediterranean Mixed Forests bioregion is located in the Western Eurasia realm (western Palearctic) and contains six ecoregions \u2013 Iberian Conifer Forests (792), Iberian Sclerophyllous and Semi-Deciduous Forests (793), Northeastern Spain and Southern, France Mediterranean Forests (799), Northwest Iberian Montane Forests (800), Southeastern Iberian Shrubs and Woodlands (803), Southwest Iberian Mediterranean Sclerophyllous and Mixed Forests (805) \u2013 totaling approximately 55.5 million hectares of land area.</p>\n<figure><img src="https://images.takeshape.io/86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/65f165c4-a25f-4815-80b9-63ea70b3b3f2/Bioregion%20map-PA20.jpg"/><figcaption><span class="caption"><p>The Balearic Sea &amp; West Mediterranean Mixed Forests bioregion is part of the Mediterranean subrealm and is made up of six ecoregions: (1) Southwest Iberian Mediterranean Sclerophyllous and Mixed Forests (2) Northwest Iberian Montane Forests (3) Iberian Sclerophyllous and Semi-Deciduous Forest (4) Iberian Conifer Forests (5) Southeastern Iberian Shrubs and Woodlands.</p></span> </figcaption></figure>\n<p>One Earth is dedicated to mobilizing philanthropic capital to protect the ecosystems and peoples of Western Eurasia. Visit the <a href="https://www.oneearth.org/projects/" target="_blank"><strong>Project Marketplace</strong></a> to explore projects in this realm that need your support. Learn more about each of the Balearic Sea &amp; West Mediterranean Mixed Forests ecoregions below.</p>',
                ecoregions: [
                  { _id: '4d245421-9777-44f2-b8e6-53d519be9f83' },
                  { title: 'Southwest Iberian Mediterranean Sclerophyllous and Mixed Forests' },
                  { regionId: '805' },
                  {
                    dek:
                      'This ecoregion extends all along the low elevations, valleys, plains, and Atlantic coastal strip of the southwestern part of the Iberian Peninsula. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aa17b647-d9dd-464a-954b-30e80424eaf9/805 Southwest Iberian Mediterranean Sclerophyllous and Mixed Forests El Pantera cc.jpg',
                      _id: 'aa17b647-d9dd-464a-954b-30e80424eaf9'
                    }
                  },
                  { _id: '66e25125-55f8-40de-aef6-1cbafed85dfd' },
                  { title: 'Southeastern Iberian Shrubs and Woodlands' },
                  { regionId: '803' },
                  {
                    dek:
                      'This ecoregion is restricted to a narrow strip of land on the south-eastern coast of Spain from Almer\u00eda to Los Alcazares with a small addition just south of Murcia.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/ea8a1692-0e45-4f02-a4e9-2abc5e4f63b1/803 Southeastern Iberian Shrubs and Woodlands Nano Sanchez cc.jpg',
                      _id: 'ea8a1692-0e45-4f02-a4e9-2abc5e4f63b1'
                    }
                  },
                  { _id: 'e4044710-4062-46c4-8f1c-e738d49e21b9' },
                  { title: 'Northwest Iberian Montane Forests' },
                  { regionId: '800' },
                  {
                    dek:
                      'The northwestern Iberian Mountains extend from the Mediterranean southern slopes of the Cantabric Mountains to the central Iberian high mountain range. '
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/aa7d5850-90d8-44df-a40b-84fa65e6e2bb/800 Northwest Iberian montane forests - Ant\u00f3nio Cascalheira.jpg',
                      _id: 'aa7d5850-90d8-44df-a40b-84fa65e6e2bb'
                    }
                  },
                  { _id: '985358b4-4ef6-4079-bae9-0482038a5b41' },
                  { title: 'Northeastern Spain and Southern France Mediterranean Forests' },
                  { regionId: '799' },
                  {
                    dek:
                      'This ecoregion encompasses Southern France, the coastal part of Valencia and Catalonia regions in North-eastern Spain, and the Balearic Islands.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/618cf98d-bc73-4a6d-a4c1-f3badcc4906e/799 Northeastern Spain and Southern France Mediterranean Forests Joan Banjo cc.jpeg',
                      _id: '618cf98d-bc73-4a6d-a4c1-f3badcc4906e'
                    }
                  },
                  { _id: '5bcc8091-41ba-413c-9f9d-6428e241d128' },
                  { title: 'Iberian Sclerophyllous and Semi-Deciduous Forests' },
                  { regionId: '793' },
                  {
                    dek:
                      'This ecoregion covers the central plateaus, valleys, and low plains of the interior portion of the Iberian Peninsula.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/8b38b517-509b-471a-a169-fdd7c8bce44c/793 Iberian sclerophyllous and semi-deciduous forests - Ant\u00f3nio Cascalheira.jpg',
                      _id: '8b38b517-509b-471a-a169-fdd7c8bce44c'
                    }
                  },
                  { _id: 'ff6eb8bb-6234-42b7-92f2-fee0e611f123' },
                  { title: 'Iberian Conifer Forests' },
                  { regionId: '792' },
                  {
                    dek:
                      'This ecoregion spreads geographically all along the main central eastern and southeastern mountain ranges of Spain.'
                  },
                  {
                    image: {
                      path:
                        '86ce9525-f5f2-4e97-81ba-54e8ce933da7/dev/259195e2-72c4-4534-8ece-9f435bc4f054/792 Iberian conifer forests - monscanus.jpg',
                      _id: '259195e2-72c4-4534-8ece-9f435bc4f054'
                    }
                  }
                ],
                stats: [
                  { number: '55,528', item: 'Total Land Area (1000 ha)' },
                  { number: '6', item: 'Number of Ecoregions' },
                  { number: '30%', item: 'Protection Target' },
                  { number: '10', item: 'Protection Level' }
                ]
              }
            ],
            parentId: 'Western Eurasia',
            value: 1000
          }
        ],
        parentId: 'top',
        _id: 'Western Eurasia',
        value: 833
      }
    ],
    value: 1000
  }
];
export default oneearth;
